/* SEMI LOCATOR V70 — VERIFIED FINAL SPEECH HANDOFF; V67 VISUAL UNCHANGED */
/* SEMI LOCATOR V69 — ACTIVE VOICE PATH USES PROVEN LIVE MANEUVER INSTRUCTION */
/* SEMI LOCATOR V68 - MANEUVER VOICE: LIVE TARGET ROAD FROM CORE STEP */
/* ============================================================================
   SEMI LOCATOR V67 — PROVEN MANEUVER ROAD DISPLAY SYNC
   Runs before legacy renderers. Display only: never changes routing, GPS,
   map, guidance or voice. Handles legacy street-label overwrites immediately.
   The live core step's instruction is the authority, as verified on iPhone.
   ============================================================================ */
(function(window,document){
"use strict";
if(window.__SLX_V67_LIVE_ROAD_SYNC__){return;}
window.__SLX_V67_LIVE_ROAD_SYNC__=true;
var roadNode=null, observer=null, lastStepKey="", lastRoad="", writes=0, timer=null;
function clean(v){return String(v==null?"":v).replace(/\s+/g," ").trim();}
function active(){
  try{
    var b=window.__SLX_CORE_BRIDGE__;
    if(b&&typeof b.getActiveManeuverStep==="function"){
      return b.getActiveManeuverStep()||null;
    }
  }catch(e){}
  return null;
}
function extract(step){
  if(!step){return "";}
  var text=clean(step.instruction||step.announceLabel||"");
  var match=text.match(/\b(?:onto|toward|towards)\s+(.+)$/i);
  if(!match){return "";}
  var target=clean(match[1]).replace(/[.!]+$/g,"").replace(/\s+(?:in|after)\s+\d+(?:\.\d+)?\s*(?:feet|ft|miles|mi|meters|m)\.?$/i,"").trim();
  if(!target || /^(?:the|current|this)\s+road$/i.test(target)){return "";}
  return target;
}
function sync(){
  var step=active(), road=extract(step);
  var node=document.getElementById("slxDriveIqTurnRoad");
  if(!node){return;}
  if(node!==roadNode){
    if(observer){observer.disconnect();}
    roadNode=node;
    if(window.MutationObserver){
      observer=new window.MutationObserver(function(){sync();});
      observer.observe(roadNode,{childList:true,characterData:true,subtree:true});
    }
  }
  lastStepKey=step?clean(step.instruction||""):"";
  lastRoad=road;
  if(road){
    if(clean(node.textContent)!==road){
      node.textContent=road;
      writes+=1;
    }
  }else if(step&&clean(node.textContent).toLowerCase()==="follow current road"){
    node.textContent="Road name unavailable";
    writes+=1;
  }
  node.setAttribute("data-slx-road-authority","V67_LIVE_CORE_INSTRUCTION");
}
window.SLXV67RoadSync={
  sync:sync,
  snapshot:function(){return {version:"V67_LIVE_CORE_INSTRUCTION",instruction:lastStepKey,road:lastRoad,display:roadNode?clean(roadNode.textContent):"",writes:writes};}
};
function boot(){sync();if(!timer){timer=window.setInterval(sync,500);}}
if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",boot);
}else{boot();}
})(window,document);

/* ============================================================================
   SEMI LOCATOR V40 - DRIVE IQ FOUNDATION SPEECH AUTHORITY
   ============================================================================
   SOURCE REWRITE, NOT ANOTHER SPEECH WRAPPER STACK.

   Foundation rules copied from the proven Drive IQ behavior:
   1. Current maneuver + street/road guidance owns the audio lane.
   2. Verified immediate safety may interrupt.
   3. Arrival / verified reroute follow navigation priority.
   4. Parking, weather, fuel, freight, dock and routine corridor intelligence
      may speak only when there is a clean navigation gap.
   5. Broken Unicode / mojibake / symbol-name speech is never handed to iOS.
   6. One browser speech output function owns every speechSynthesis.speak call.

   This block does not alter map, GPS, route geometry, camera, pin, route
   progression, paywall, truck data, or the visual cockpit.
   ES5-safe.
   ============================================================================ */
(function(){
"use strict";

if(window.__SLX_DRIVE_IQ_FOUNDATION_V40__){ return; }
window.__SLX_DRIVE_IQ_FOUNDATION_V40__ = true;
window.SLX_DRIVER_NAV_FOUNDATION_BUILD = "V40_DRIVE_IQ_SPEECH_AUTHORITY";

var synth = window.speechSynthesis || null;
var nativeSpeak = synth && typeof synth.speak === "function" ? synth.speak.bind(synth) : null;
var nativeCancel = synth && typeof synth.cancel === "function" ? synth.cancel.bind(synth) : null;
var slxFoundationActiveKind = "";
var slxFoundationActiveToken = 0;

/*
  Legacy Semi engines still call speechSynthesis.cancel() before submitting
  their own parking, weather, confidence and arrival lines. Those calls happen
  BEFORE the foundation can reject the new line, so they were cutting off the
  valid maneuver already speaking. Protect the navigation lane at the actual
  browser cancel boundary. Routine speech may still be cancelled/preempted.
*/
try{
  if(synth && nativeCancel && !synth.__slxFoundationCancelGuarded){
    synth.__slxFoundationCancelGuarded = true;
    synth.cancel = function(){
      if(
        slxFoundationActiveKind === "maneuver" ||
        slxFoundationActiveKind === "safety" ||
        slxFoundationActiveKind === "arrival"
      ){
        return false;
      }
      nativeCancel();
      return true;
    };
  }
}catch(eCancelGuard){}

window.__SLX_FOUNDATION_FORCE_CANCEL__ = function(){
  slxFoundationActiveToken += 1;
  slxFoundationActiveKind = "";
  try{ if(nativeCancel){ nativeCancel(); return true; } }catch(e){}
  return false;
};

function slxFoundationClean(value){
  var s = String(value == null ? "" : value);

  /* Common UTF-8/mojibake sequences from legacy Semi blocks. */
  s = s.replace(/’|’/g,"'");
  s = s.replace(/“|”|“|”/g,'"');
  s = s.replace(/—|–|—|–/g," - ");
  s = s.replace(/•|•|Â·/g," ");
  s = s.replace(/ /g," ");
  s = s.replace(/ï¿½|\uFFFD/g," ");

  /* Kill residual mojibake tokens before the TTS engine can name glyphs. */
  s = s.replace(/Ã\S*|Â\S*|â\S*|ð\S*/g," ");
  s = s.replace(/[^\x20-\x7E]/g," ");
  s = s.replace(/[<>[\]{}_^~`|\\]/g," ");
  s = s.replace(/\s+/g," ").trim();

  return s;
}

function slxFoundationLower(v){
  return slxFoundationClean(v).toLowerCase();
}

function slxFoundationActiveManeuverMiles(){
  var n = null;

  try{
    if(typeof slxV33ActiveManeuverDistance === "function"){
      n = Number(slxV33ActiveManeuverDistance());
      if(isFinite(n)){ return Math.max(0,n); }
    }
  }catch(e0){}

  try{
    if(typeof slxNavV2ActiveStep === "function" &&
       typeof slxNavV2RemainingToStep === "function"){
      var step = slxNavV2ActiveStep();
      n = step ? Number(slxNavV2RemainingToStep(step)) : null;
      if(isFinite(n)){ return Math.max(0,n); }
    }
  }catch(e1){}

  try{
    if(typeof maneuverSteps !== "undefined" &&
       maneuverSteps &&
       typeof maneuverIndex !== "undefined" &&
       maneuverSteps[maneuverIndex] &&
       typeof slxNavV2RemainingToStep === "function"){
      n = Number(slxNavV2RemainingToStep(maneuverSteps[maneuverIndex]));
      if(isFinite(n)){ return Math.max(0,n); }
    }
  }catch(e2){}

  return null;
}

function slxFoundationKind(text){
  var t = slxFoundationLower(text);

  if(!t){ return "empty"; }

  if(
    t.indexOf("circumflex") >= 0 ||
    t.indexOf("replacement character") >= 0 ||
    t.indexOf("unknown symbol") >= 0
  ){
    return "garbage";
  }

  if(
    /\b(wrong way|road closed|closure|blocked road|crash|collision|debris|emergency|police directing|severe weather|hazard ahead)\b/.test(t)
  ){
    return "safety";
  }

  if(
    /\b(turn|left|right|continue|straight|merge|exit|fork|ramp|roundabout|u-turn|uturn|keep|stay|lane|bear)\b/.test(t)
  ){
    return "maneuver";
  }

  if(
    /\b(interstate|highway|hwy|parkway|pkwy|boulevard|blvd|street|road|drive|avenue|route)\b/.test(t) &&
    /\b(ahead|onto|toward|towards|now|continue|take|turn|merge|keep|stay|in about)\b/.test(t)
  ){
    return "maneuver";
  }

  if(/\b(arrived|arrival|destination)\b/.test(t)){ return "arrival"; }
  if(/\b(rerout|route recovered|off route)\b/.test(t)){ return "reroute"; }

  if(
    /\b(parking|fuel|diesel|weather|wind|dock|freight|truck stop|rest area|corridor|brake|grade|traffic|reload|deadhead)\b/.test(t)
  ){
    return "routine";
  }

  if(
    t.indexOf("gps locked") >= 0 ||
    t.indexOf("route active") >= 0 ||
    t.indexOf("route is active") >= 0
  ){
    return "startup";
  }

  return "info";
}

function slxFoundationAllow(text){
  var clean = slxFoundationClean(text);
  var kind = slxFoundationKind(clean);
  var remain;

  if(!clean || kind === "empty" || kind === "garbage"){ return false; }

  /* Navigation and true safety always own the lane. */
  if(kind === "maneuver" || kind === "safety" || kind === "arrival" || kind === "reroute" || kind === "startup"){
    return true;
  }

  /*
    Truck intelligence is secondary.
    If a maneuver is within 1.5 miles, it stays visual-only.
    If maneuver distance cannot be verified, routine chatter stays quiet.
  */
  if(kind === "routine" || kind === "info"){
    remain = slxFoundationActiveManeuverMiles();
    if(remain === null){ return false; }
    if(remain <= 1.5){ return false; }
    return true;
  }

  return false;
}

window.__SLX_FOUNDATION_CLEAN_SPEECH__ = slxFoundationClean;
window.__SLX_FOUNDATION_ALLOW_SPEECH__ = slxFoundationAllow;

/*
  A suppressed utterance still has to release whichever queue submitted it.
  Legacy queues mark themselves busy before calling the foundation and depend
  on onend/onerror to advance. Returning false without a completion callback
  permanently deadlocks maneuver voice behind a line that never spoke.
*/
function slxFoundationRelease(utterance){
  if(!utterance){ return; }
  window.setTimeout(function(){
    try{
      if(typeof utterance.onend === "function"){
        utterance.onend({type:"end",name:"slx-foundation-suppressed"});
      }else if(typeof utterance.onerror === "function"){
        utterance.onerror({type:"error",error:"slx-foundation-suppressed"});
      }
    }catch(e){}
  },0);
}

/* V70: final voice handoff — use the same verified live maneuver as V67.
   This runs only for a matching left/right turn announcement that lacks a
   street name. It does not create announcements or change their timing. */
function slxFoundationAttachVerifiedRoad(line){
  var match, bridge, step, instruction, active, road, direction;
  line = String(line || "");
  match = line.match(/^(\s*Turn\s+(?:slightly\s+)?(left|right))(\s+in\s+.+)$/i);
  if(!match || /\b(?:onto|toward|towards)\b/i.test(line)){ return line; }
  try{
    bridge = window.__SLX_CORE_BRIDGE__;
    if(!bridge || typeof bridge.getActiveManeuverStep !== "function"){ return line; }
    step = bridge.getActiveManeuverStep();
    if(!step){ return line; }
    instruction = String(step.instruction || "").replace(/\s+/g," ").trim();
    active = instruction.match(/^Turn\s+(?:slightly\s+)?(left|right)\s+onto\s+(.+?)\.?$/i);
    if(!active || active[1].toLowerCase() !== match[2].toLowerCase()){ return line; }
    road = active[2].replace(/[.!]+$/g,"").trim();
    if(!road || road.length > 100 || /^(?:the|this|current)\s+road$/i.test(road)){
      return line;
    }
    return match[1] + " onto " + road + match[3];
  }catch(e){ return line; }
}

window.__SLX_FOUNDATION_SPEAK__ = function(utterance){
  var raw = "";
  var safe = "";
  var out = utterance;
  var kind = "";
  var token = 0;
  var priorEnd = null;
  var priorError = null;

  if(!nativeSpeak || !utterance){
    slxFoundationRelease(utterance);
    return false;
  }

  try{
    raw = String(utterance.text || utterance.speechString || "");
  }catch(e0){
    raw = "";
  }

  safe = slxFoundationClean(raw);
  safe = slxFoundationClean(slxFoundationAttachVerifiedRoad(safe));
  kind = slxFoundationKind(safe);

  if(!slxFoundationAllow(safe)){
    slxFoundationRelease(utterance);
    return false;
  }

  try{
    /*
      Build a fresh utterance whenever text had to be cleaned. This prevents
      the original malformed glyph string from remaining inside WebKit.
    */
    if(safe !== raw && window.SpeechSynthesisUtterance){
      out = new SpeechSynthesisUtterance(safe);
      try{ out.lang = utterance.lang || "en-US"; }catch(e1){}
      try{ out.rate = utterance.rate || 0.96; }catch(e2){}
      try{ out.pitch = utterance.pitch || 1; }catch(e3){}
      try{ out.volume = utterance.volume == null ? 1 : utterance.volume; }catch(e4){}
      try{ if(utterance.voice){ out.voice = utterance.voice; } }catch(e5){}
      try{ out.onend = utterance.onend || null; }catch(e6){}
      try{ out.onerror = utterance.onerror || null; }catch(e7){}
    }

    /* Track the utterance that owns the audio lane and release that ownership
       only when this exact utterance completes. This makes the cancel guard
       safe even when older queues finish or fail out of order. */
    token = ++slxFoundationActiveToken;
    slxFoundationActiveKind = kind;
    try{ priorEnd = out.onend || null; }catch(eEndRead){}
    try{ priorError = out.onerror || null; }catch(eErrorRead){}
    try{
      out.onend = function(event){
        if(token === slxFoundationActiveToken){ slxFoundationActiveKind = ""; }
        if(typeof priorEnd === "function"){ priorEnd.call(out,event); }
      };
    }catch(eEndWrap){}
    try{
      out.onerror = function(event){
        if(token === slxFoundationActiveToken){ slxFoundationActiveKind = ""; }
        if(typeof priorError === "function"){ priorError.call(out,event); }
      };
    }catch(eErrorWrap){}

    return nativeSpeak(out);
  }catch(e8){
    if(token === slxFoundationActiveToken){ slxFoundationActiveKind = ""; }
    slxFoundationRelease(out || utterance);
    return false;
  }
};

try{
  if(nativeCancel){ nativeCancel(); }
}catch(e9){}

try{
  console.log("Semi Locator V40 Drive IQ foundation speech authority loaded");
}catch(e10){}

})();


/* ========================================================================
   SEMI LOCATOR — DRIVER DASHBOARD V2G / DRIVER TRUST MANEUVER AUTHORITY
   Full replacement for driver-dashboard_UNIFIED.js

   ES5-safe. No optional chaining. No arrow functions. No template literals.

   LOCKED FOUNDATION KEPT:
   - Green Mapbox-layer pin foundation.
   - No truck image/icon runtime dependency.
   - Raw GPS never directly drives rendered pin.
   - Raw GPS -> route snapped target -> requestAnimationFrame visual glide.
   - Camera follows visual gliding pin.
   - Cockpit route bearing uses distance-based lookahead to stop diagonal route drift.
   - Follow mode and Free Flow are not enemies.

   POLISH LOCKED IN THIS RUN:
   - Freight Horizon pills now prioritize useful info: traffic, weather/wind, parking, fuel, next turn, corridor.
   - Horizon minimize button rebuilt with capture handlers, fixed host styling, fallback toggle zone, and persistence.
   - Parking markers keep readable P/F/R text on top; glow/halo sits behind the letter.
   - Parking Pressure Radar: likely open / tightening / likely full.
   - Voice system: stronger iOS priming, duplicate guard, turn timing, scan-stops speech, parking pressure speech.
   - Premium night map: terrain + 3D buildings + subtle lit-window building overlay where Mapbox buildings exist.
   - Stop pins are clickable and preserve the final destination when adding a stop.
   - V2E: Turn card moved out of windshield area into lower-right command zone.
   - V2E: Compact maneuver module protects map/route visibility and Horizon priority.
   - V2E: Arrival IQ micro-state appears near destination without changing route/camera logic.
   - V2E.1: Turn card docks 34px lower to reduce wasted command-deck space.
   - V2E.1: Idle turn state compresses until movement begins; moving/arrival states expand.
   - V2E.2: Turn pill lifted into clean lower-right pocket above Route Intel.
   - V2E.2: Route Intel bar is trimmed into a thinner cockpit HUD strip.
   - V2E.2: Confidence wording is softened into driver-native Route Confidence copy.
   - V2E.3: Scan Stops now combines useful nearby stops + route-ahead stops, including Walmart/retail parking where useful.
   - V2E.4: Adds explicit named searches for Walmart/retail/service + nearby-first stop ranking and voice.
   - V2F TRUST PATCH: suppresses early/local reroute noise, confidence-gates parking chatter,
     protects arrival/private-lot behavior, improves fork/commitment-zone voice, and adds calm
     departure drift guidance.
======================================================================== */

(function () {
"use strict";

if (window.__SLX_DRIVER_DASHBOARD_DRIVE_IQ_CORE_V2D__) { return; }
window.__SLX_DRIVER_DASHBOARD_DRIVE_IQ_CORE_V2D__ = true;
window.__SLX_DRIVER_DASHBOARD_POLISH_VERSION__ = "V11_HARD_TOP_LOCK_STANDBY_FILTER";

/* ------------------------------------------------------------------------
   DOM / CONFIG
------------------------------------------------------------------------ */

var app = document.getElementById("slxApp");
var sub = document.getElementById("slxSub");
var mapboxToken = String(
  window.SLX_MAPBOX_TOKEN ||
  (app ? app.getAttribute("data-mapbox-token") : "") ||
  ""
);
var geoapifyKey = String(window.SLX_GEOAPIFY_KEY || "");
var START_TRIP_URL = "https://semilocator.com/pages/start-trip";
var END_TRIP_URL = START_TRIP_URL; // V61: retired End Drive page bypassed

var map = null;
var mapLoaded = false;

var currentFix = null;
var rawFix = null;
var routeTargetFix = null;

var routeGeo = null;
var routeDest = null;
var routeSteps = [];

var gpsWatchId = null;
var routeSyncTimer = null;
var hudTimer = null;
var cameraTimer = null;
var scanTimer = null;
var watchdogTimer = null;
var poiGlowTimer = null;
var glideRaf = null;

var lastRouteRaw = null;
var lastDestRaw = null;
var lastStepsRaw = null;
var lastTripRaw = null;

var followLock = true;
var tripStarted = false;
var userInteracting = false;
var userInteractionUntil = 0;
var overviewMode = false;

var speechEnabled = true;
var speechUnlocked = false;
var gpsVoiceAnnounced = false;
var tripVoiceAnnounced = false;
var arrivalVoiceAnnounced = false;
var offRouteVoiceAnnounced = false;
var lastSpokenText = "";
var lastSpokenAt = 0;
var lastScanVoiceAt = 0;

var buttonsWired = false;
var stopPopup = null;

var lastCameraAt = 0;
var cameraGestureGuardUntil = 0;
var lastRawHeading = 0;
var lastHardBearing = 0;
var lastAutoScanAt = 0;
var followBoostUntil = 0;
var hardFollowUntil = 0;
var lastGoodStopList = [];
var lastVisiblePoiList = [];
var scanOverviewRestoreTimer = null;
var scanOverviewUntil = 0;
var scanVoiceLastSummary = "";
var scanVoiceLastSummaryAt = 0;

var FREE_FLOW_MS = 60000;
var AUTO_SCAN_MS = /Android/i.test(navigator.userAgent || "") ? 70000 : 45000;

var LS = {
  ROUTE: "slx_route_geo_v2",
  DEST: "slx_main_dest_v2",
  TRIP: "slx_trip_on_v2",
  VIEW: "slx_driver_view_mode_v1",
  STEPS: "slx_route_steps_v2"
};

var motionState = {
  lastAcceptedAt: 0,
  lastGoodBearing: 0,
  headingConfidence: 0,
  lastRouteIndex: 0,
  lastProjectionIndex: 0
};

var visualState = {
  active: false,
  lng: null,
  lat: null,
  targetLng: null,
  targetLat: null,
  bearing: 0,
  targetBearing: 0,
  lastFrameAt: 0,
  lastTargetAt: 0
};

var offRouteState = {
  isOffRoute: false,
  distanceMiles: 0,
  since: 0
};

var fuelState = {
  mpg: 6.5,
  tankGallons: 120,
  reserveGallons: 25,
  remainingMiles: null,
  safeMilesLeft: null,
  status: "unknown",
  nextMessage: "Fuel predictor standing by"
};

var windState = {
  speed: null,
  direction: null,
  relative: null,
  label: "Weather standby",
  fetchedAt: 0
};

var gradeState = {
  label: "Grade standby",
  severity: "none",
  ftPerMile: 0,
  cameraBias: 0
};

var speedState = {
  limitMph: null,
  roadName: "",
  deltaMph: 0
};

var trafficState = {
  density: "unknown",
  label: "Traffic standby",
  score: 0,
  lastAt: 0
};

var parkingPressureState = {
  status: "standby",
  label: "Parking radar standby",
  score: 0,
  lastVoiceAt: 0
};

var brakeState = {
  level: "standby",
  label: "Brake predictor standby",
  lastVoiceAt: 0
};

var maneuverSteps = [];
var maneuverIndex = 0;
var maneuverLastSpokenIndex = -1;
var maneuverLastDistanceBucket = "";
var maneuverLastBuildAt = 0;

var SLX_TURN_CARD_TOP_PX = 248;
var SLX_TURN_CARD_HIDDEN = false;
var SLX_TURN_CARD_STORAGE_KEY = "slx_turn_card_hidden_v1";

try {
  SLX_TURN_CARD_HIDDEN = lsGet(SLX_TURN_CARD_STORAGE_KEY) === "1";
} catch (eTurnInit) {}

if (!window.stopIntentState) {
  window.stopIntentState = {
    active: false,
    inferred: "parking",
    visibleCandidates: [],
    lastScanAt: 0,
    lastProvider: ""
  };
}

/* ------------------------------------------------------------------------
   ANDROID PERFORMANCE / TRUST MODE
------------------------------------------------------------------------ */

var slxPerf = {
  isAndroid: /Android/i.test(navigator.userAgent || ""),
  lowPower: false,
  lastCameraMoveAt: 0,
  lastPoiDrawAt: 0,
  lastGlowAt: 0,
  adaptiveMode: true
};

function slxShouldReduceEffects() {
  var cores = 4;
  try { cores = navigator.hardwareConcurrency || 4; } catch (e) {}
  return slxPerf.isAndroid && cores <= 6;
}

slxPerf.lowPower = slxShouldReduceEffects();

/* ------------------------------------------------------------------------
   TRUST-FIRST ROUTE GUARDRAILS V2F
   Keeps Semi Locator calm and trustworthy:
   - no early "better route" noise
   - local trips require bigger savings before reroute cards
   - parking voice only fires when real stop evidence exists
   - arrival/private-lot behavior suppresses panic reroute/chatter
   - fork/interstate/commitment moments get earlier, clearer voice
------------------------------------------------------------------------ */

var slxTrustState = {
  tripStartedAt:0,
  lastTripOn:false,
  lastReassureKey:"",
  lastReassureAt:0,
  lastDepartureVoiceAt:0,
  lastParkingVoiceKey:"",
  lastRerouteDenyAt:0
};

var SLX_TRUST = {
  initialQuietMs:120000,
  localTripMiles:20,
  localTripMinutes:35,
  firstWindowMinSave:10,
  firstWindowMinConfidence:90,
  localMinSave:8,
  localMinConfidence:88,
  standardMinSave:5,
  standardMinConfidence:82,
  arrivalSuppressMiles:0.55,
  arrivalHardSuppressMiles:0.28,
  departureMiles:0.75,
  departureMs:210000
};

function slxTrustNow(){ return nowMs(); }

function slxTrustSyncTripState(on){
  on = !!on;
  if(on && !slxTrustState.lastTripOn){
    slxTrustState.tripStartedAt = slxTrustNow();
  }
  if(!on){
    slxTrustState.tripStartedAt = 0;
    slxTrustState.lastReassureKey = "";
    slxTrustState.lastDepartureVoiceAt = 0;
  }
  slxTrustState.lastTripOn = on;
}

function slxTrustTripAgeMs(){
  if(!tripStarted){ return 0; }
  if(!slxTrustState.tripStartedAt){ slxTrustState.tripStartedAt = slxTrustNow(); }
  return slxTrustNow() - Number(slxTrustState.tripStartedAt || 0);
}

function slxTrustRouteMiles(){
  var coords = getRouteCoords();
  var total = 0;
  var i;

  if(!coords || coords.length < 2){ return null; }

  for(i = 1; i < coords.length; i += 1){
    total += milesBetween(coords[i - 1], coords[i]) || 0;
  }

  return total;
}

function slxTrustRouteMinutes(){
  var geo = routeGeo || null;
  var p;
  var n;

  try{
    if(geo && geo.features && geo.features.length){
      p = geo.features[0].properties || {};
      n = Number(p.durationSeconds);
      if(isFiniteNumber(n)){ return n / 60; }
      n = Number(p.duration);
      if(isFiniteNumber(n)){ return n > 1000 ? n / 60 : n; }
      n = Number(p.time);
      if(isFiniteNumber(n)){ return n / 60; }
      n = Number(p.minutes);
      if(isFiniteNumber(n)){ return n; }
    }
  }catch(e){}

  return null;
}

function slxTrustIsInitialQuietWindow(){
  return tripStarted && slxTrustTripAgeMs() > 0 && slxTrustTripAgeMs() < SLX_TRUST.initialQuietMs;
}

function slxTrustIsLocalTrip(){
  var mi = slxTrustRouteMiles();
  var min = slxTrustRouteMinutes();

  if(isFiniteNumber(mi) && mi <= SLX_TRUST.localTripMiles){ return true; }
  if(isFiniteNumber(min) && min <= SLX_TRUST.localTripMinutes){ return true; }

  return false;
}

function slxTrustDistanceToDest(){
  var d = distanceToDestinationMiles();
  if(isFiniteNumber(d)){ return d; }
  return null;
}

function slxTrustArrivalAuthorityActive(){
  var d = slxTrustDistanceToDest();
  if(!isFiniteNumber(d)){ return false; }
  return d <= SLX_TRUST.arrivalSuppressMiles || arrivalVoiceAnnounced;
}

function slxTrustArrivalHardSuppress(){
  var d = slxTrustDistanceToDest();
  if(!isFiniteNumber(d)){ return false; }
  return d <= SLX_TRUST.arrivalHardSuppressMiles;
}

function slxTrustRerouteConfidence(saveMinutes,currentMinutes){
  var save = Number(saveMinutes);
  var current = Number(currentMinutes);
  var score = 76;

  if(!isFiniteNumber(save)){ return 0; }

  if(save >= 18){ score += 14; }
  else if(save >= 12){ score += 10; }
  else if(save >= 8){ score += 6; }
  else if(save >= 5){ score += 3; }
  else{ score -= 10; }

  if(isFiniteNumber(current) && current > 0){
    if(save / current >= 0.22){ score += 8; }
    else if(save / current >= 0.15){ score += 5; }
    else if(save / current < 0.08){ score -= 6; }
  }

  if(slxTrustIsInitialQuietWindow()){ score -= 7; }
  if(slxTrustIsLocalTrip()){ score -= 5; }
  if(slxTrustArrivalAuthorityActive()){ score -= 20; }

  return clamp(Math.round(score),0,100);
}

function slxTrustShouldAllowRerouteCandidate(saveMinutes,currentMinutes){
  var save = Number(saveMinutes);
  var confidence = slxTrustRerouteConfidence(save,currentMinutes);

  if(!tripStarted || !routeGeo){ return false; }
  if(slxTrustArrivalAuthorityActive()){ return false; }

  if(slxTrustIsInitialQuietWindow()){
    return save >= SLX_TRUST.firstWindowMinSave && confidence >= SLX_TRUST.firstWindowMinConfidence;
  }

  if(slxTrustIsLocalTrip()){
    return save >= SLX_TRUST.localMinSave && confidence >= SLX_TRUST.localMinConfidence;
  }

  return save >= SLX_TRUST.standardMinSave && confidence >= SLX_TRUST.standardMinConfidence;
}

function slxTrustShouldScanAltCorridor(){
  if(!tripStarted || !routeGeo){ return false; }
  if(slxTrustArrivalAuthorityActive()){ return false; }
  if(slxTrustIsInitialQuietWindow() && slxTrustIsLocalTrip()){ return false; }
  return true;
}

function slxTrustParkingEvidence(list){
  var out = { count:0, truckish:0, nearest:null, evidence:false };
  var i;
  var c;
  var txt;
  var d;

  list = list || [];

  for(i = 0; i < list.length; i += 1){
    c = list[i];
    if(!c){ continue; }

    txt = String((c.type || "") + " " + (c.label || "") + " " + (c.name || "")).toLowerCase();

    if(txt.indexOf("parking") === -1 &&
       txt.indexOf("fuel") === -1 &&
       txt.indexOf("truck") === -1 &&
       txt.indexOf("rest") === -1 &&
       txt.indexOf("travel") === -1 &&
       txt.indexOf("diesel") === -1){
      continue;
    }

    out.count += 1;

    if(txt.indexOf("truck") > -1 ||
       txt.indexOf("travel") > -1 ||
       txt.indexOf("rest") > -1 ||
       txt.indexOf("diesel") > -1 ||
       txt.indexOf("pilot") > -1 ||
       txt.indexOf("love") > -1 ||
       txt.indexOf("flying j") > -1 ||
       txt.indexOf("petro") > -1 ||
       txt.indexOf("ta ") > -1){
      out.truckish += 1;
    }

    d = Number(c.distMiles);
    if(isFiniteNumber(d) && (out.nearest === null || d < out.nearest)){
      out.nearest = d;
    }
  }

  out.evidence = out.count > 0 || (lastGoodStopList && lastGoodStopList.length > 0) || (lastVisiblePoiList && lastVisiblePoiList.length > 0);
  return out;
}

function slxTrustShouldSpeakParking(list,status,phase){
  var ev = slxTrustParkingEvidence(list);
  var key;

  if(!tripStarted || !routeGeo){ return false; }
  if(slxTrustArrivalAuthorityActive() || phase === "arrival"){ return false; }
  if(slxTrustIsInitialQuietWindow()){ return false; }
  if(status !== "likely_full" && status !== "tightening"){ return false; }
  if(!ev.evidence){ return false; }

  key = String(status) + ":" + String(ev.count) + ":" + String(ev.truckish) + ":" + String(phase || "");
  if(slxTrustState.lastParkingVoiceKey === key && nowMs() - Number(parkingPressureState.lastVoiceAt || 0) < 1800000){
    return false;
  }

  slxTrustState.lastParkingVoiceKey = key;
  return true;
}

function slxTrustInstructionText(step){
  try{ return slxNavV2InstructionText(step); }catch(e){}
  try{ return getStepInstruction(step); }catch(e2){}
  return String((step && (step.instruction || step.announceLabel)) || "");
}

function slxTrustRoadNameFromInstruction(text){
  var s = String(text || "");
  var m;

  m = s.match(/\b(I[-\s]?\d{1,3}[A-Z]?|US[-\s]?\d{1,3}|U\.S\.\s*\d{1,3}|Highway\s+\d{1,3}|Hwy\s+\d{1,3}|SR[-\s]?\d{1,3})\b/i);
  if(m && m[1]){ return m[1].replace(/\s+/g," ").replace(/^I\s/i,"I-"); }

  m = s.match(/\b(?:onto|on|toward|towards|for)\s+([A-Z][A-Za-z0-9 .'-]+(?:Road|Rd|Street|St|Avenue|Ave|Boulevard|Blvd|Drive|Dr|Lane|Ln|Parkway|Pkwy|Highway|Hwy|Freeway|Interstate|Expressway))/);
  if(m && m[1]){ return m[1].replace(/\s+/g," ").trim(); }

  return "";
}

function slxTrustIsCommitmentStep(step){
  var t = slxTrustInstructionText(step).toLowerCase();

  return t.indexOf("fork") > -1 ||
    t.indexOf("keep ") > -1 ||
    t.indexOf("merge") > -1 ||
    t.indexOf("exit") > -1 ||
    t.indexOf("ramp") > -1 ||
    t.indexOf("interstate") > -1 ||
    /\bi[-\s]?\d{1,3}\b/i.test(t) ||
    t.indexOf("left lane") > -1 ||
    t.indexOf("right lane") > -1 ||
    t.indexOf("stay left") > -1 ||
    t.indexOf("stay right") > -1;
}

function slxTrustIsNoActionTransition(step){
  var t = slxTrustInstructionText(step).toLowerCase();

  return (t.indexOf("continue") > -1 || t.indexOf("stay on") > -1 || t.indexOf("road becomes") > -1 || t.indexOf("continue onto") > -1) &&
    t.indexOf("turn") === -1 &&
    t.indexOf("exit") === -1 &&
    t.indexOf("ramp") === -1;
}

function slxTrustBuildManeuverVoice(step,base,remain,bucket){
  var text = slxTrustInstructionText(step);
  var t = text.toLowerCase();
  var road = slxTrustRoadNameFromInstruction(text);
  var call = String(base || "Continue").replace(/\s+/g," ").trim();

  if(slxTrustIsNoActionTransition(step)){
    call = road ? ("Road transition ahead. Continue on " + road + ". No action required") : "Road transition ahead. Stay on the current road. No action required";
  }else if(slxTrustIsCommitmentStep(step)){
    if(t.indexOf("left") > -1){
      call = road ? ("Commitment zone ahead. Stay left for " + road) : "Commitment zone ahead. Stay left";
    }else if(t.indexOf("right") > -1){
      call = road ? ("Commitment zone ahead. Stay right for " + road) : "Commitment zone ahead. Stay right";
    }else if(t.indexOf("fork") > -1){
      call = road ? ("Fork ahead. Follow signs for " + road) : "Fork ahead. Hold your lane and follow the route";
    }else if(t.indexOf("merge") > -1){
      call = road ? ("Merge ahead toward " + road) : "Merge ahead";
    }else if(t.indexOf("exit") > -1 || t.indexOf("ramp") > -1){
      call = road ? ("Exit decision ahead for " + road) : "Exit decision ahead";
    }
  }else if(road && (call === "Continue" || call === "Take the exit" || call === "Merge")){
    call = call + " toward " + road;
  }

  return call;
}

function slxTrustMaybePostManeuverReassure(step){
  var key;
  var road;

  if(!step || !slxTrustIsCommitmentStep(step)){ return; }

  key = String(maneuverIndex) + ":" + String(step.distanceAlong || "");
  if(slxTrustState.lastReassureKey === key && slxTrustNow() - Number(slxTrustState.lastReassureAt || 0) < 45000){ return; }

  slxTrustState.lastReassureKey = key;
  slxTrustState.lastReassureAt = slxTrustNow();

  road = slxTrustRoadNameFromInstruction(slxTrustInstructionText(step));
  primeVoiceThenSpeak(road ? ("Good. Continue on " + road + ".") : "Good. Continue on route.");
}

function slxTrustDepartureDriftMessage(){
  var d = slxTrustDistanceToDest();
  var age = slxTrustTripAgeMs();

  if(!isFiniteNumber(d)){ d = 999; }

  if(age > 0 && age < SLX_TRUST.departureMs && d > SLX_TRUST.departureMiles){
    return "Route drift detected near departure. Keep rolling safely — I’m tracking your position and will recover the corridor.";
  }

  return "You’re off route. Keep it steady — I’m watching your position.";
}

window.SLX_TRUST_GUARD = {
  tripAgeMs:slxTrustTripAgeMs,
  initialQuiet:slxTrustIsInitialQuietWindow,
  localTrip:slxTrustIsLocalTrip,
  arrivalAuthority:slxTrustArrivalAuthorityActive,
  arrivalHardSuppress:slxTrustArrivalHardSuppress,
  shouldScanAlt:slxTrustShouldScanAltCorridor,
  shouldAllowReroute:slxTrustShouldAllowRerouteCandidate,
  rerouteConfidence:slxTrustRerouteConfidence,
  shouldSpeakParking:slxTrustShouldSpeakParking,
  parkingEvidence:slxTrustParkingEvidence,
  isCommitmentStep:slxTrustIsCommitmentStep
};

/* ------------------------------------------------------------------------
   UTILITIES
------------------------------------------------------------------------ */

function byId(id) { return document.getElementById(id); }
function nowMs() { return Date.now(); }
function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
function safeParse(v) { try { return JSON.parse(v); } catch (e) { return null; } }
function setSubline(t) { if (sub && sub.textContent !== String(t || "")) { sub.textContent = String(t || ""); } }
function isFiniteNumber(v) { return typeof v === "number" && isFinite(v); }
function clamp(v, min, max) { v = Number(v); if (v < min) { return min; } if (v > max) { return max; } return v; }
function clamp01(v) { return clamp(v, 0, 1); }
function lerp(a, b, t) { return Number(a) + ((Number(b) - Number(a)) * Number(t)); }

function normalizeAngle(a) {
  var out = Number(a || 0);
  while (out < 0) { out += 360; }
  while (out >= 360) { out -= 360; }
  return out;
}

function angleDelta(a, b) {
  var d = Math.abs(normalizeAngle(a) - normalizeAngle(b));
  if (d > 180) { d = 360 - d; }
  return d;
}

function blendAngle(a, b, t) {
  var diff = normalizeAngle(b) - normalizeAngle(a);
  if (diff > 180) { diff -= 360; }
  if (diff < -180) { diff += 360; }
  return normalizeAngle(Number(a) + (diff * Number(t)));
}

function milesBetween(a, b) {
  var R = 3958.8;
  var dLat = (Number(b[1]) - Number(a[1])) * Math.PI / 180;
  var dLon = (Number(b[0]) - Number(a[0])) * Math.PI / 180;
  var lat1 = Number(a[1]) * Math.PI / 180;
  var lat2 = Number(b[1]) * Math.PI / 180;
  var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}

function fmtMiles(mi) {
  mi = Number(mi);
  if (!isFiniteNumber(mi)) { return "--"; }
  if (mi >= 100) { return String(Math.round(mi)) + " mi"; }
  return String(Math.round(mi * 10) / 10) + " mi";
}

function esc(v) {
  var t = String(v === null || v === undefined ? "" : v);
  return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/'/g, "&#39;");
}

function currentSpeedMph() {
  if (!currentFix || !isFiniteNumber(currentFix.speed)) { return null; }
  return Number(currentFix.speed) * 2.23693629;
}

function getSpeedMph() {
  var mph = currentSpeedMph();
  return isFiniteNumber(mph) ? mph : 0;
}

function getFix() {
  if (visualState.active && isFiniteNumber(visualState.lng) && isFiniteNumber(visualState.lat)) {
    return { lng: visualState.lng, lat: visualState.lat, heading: visualState.bearing, speed: currentFix ? currentFix.speed : 0 };
  }
  return routeTargetFix || currentFix || rawFix || null;
}

function getHeadingConfidence(speedMps, headingVal) {
  var mph = isFiniteNumber(speedMps) ? Number(speedMps) * 2.23693629 : 0;
  var conf = 0;
  if (isFiniteNumber(headingVal)) { conf += 0.28; }
  if (mph >= 6) { conf += 0.18; }
  if (mph >= 14) { conf += 0.22; }
  if (mph >= 28) { conf += 0.32; }
  return clamp01(conf);
}

function syncGlobalState() {
  window.SLX_FREE_FLOW_UNTIL = userInteractionUntil;
  window.SLX_FOLLOW_LOCK = followLock;
  window.SLX_USER_INTERACTING = userInteracting;
}

function saveViewMode() { lsSet(LS.VIEW, followLock ? "follow" : "overview"); }

function forceFollowState() {
  overviewMode = false;
  followLock = true;
  userInteracting = false;
  userInteractionUntil = 0;
  saveViewMode();
  syncGlobalState();
}

function restoreViewMode() { forceFollowState(); }
function triggerFollowBoost(ms) { followBoostUntil = nowMs() + Number(ms || 2400); }

function holdUserCamera(ms) {
  /*
    V2F.1 FREE FLOW RESTORE:
    A real user gesture must immediately release cockpit camera authority.
    Do not let hard-follow or follow-boost timers yank the map back while the
    driver is pinching, panning, or zooming out to inspect the route.
  */
  userInteracting = true;
  userInteractionUntil = nowMs() + Number(ms || FREE_FLOW_MS);
  followLock = false;
  overviewMode = false;
  hardFollowUntil = 0;
  followBoostUntil = 0;
  cameraGestureGuardUntil = 0;
  saveViewMode();
  syncGlobalState();
  syncButtonStates();
  setSignalText("slxSigCorridor", "Free flow map view");
  setSubline("Free flow map view");
}

function releaseUserCameraIfReady() {
  if (userInteracting && nowMs() >= userInteractionUntil) {
    userInteracting = false;
    userInteractionUntil = 0;
    if (tripStarted && !overviewMode) { followLock = true; }
    syncGlobalState();
    syncButtonStates();
  }
}

/* ------------------------------------------------------------------------
   SPEECH — iOS SAFE / SLX VOICE AUTHORITY V1
   Read-only voice layer. Does not touch map, camera, route, pin, or routing.
------------------------------------------------------------------------ */

function pickVoice() {
  var voices, i, v, name, lang;

  if (!window.speechSynthesis || !window.speechSynthesis.getVoices) { return null; }

  try { voices = window.speechSynthesis.getVoices() || []; } catch (e) { voices = []; }

  var preferred = [
    "samantha",
    "alex",
    "daniel",
    "aaron",
    "ava",
    "allison"
  ];

  for (var p = 0; p < preferred.length; p++) {
    for (i = 0; i < voices.length; i++) {
      v = voices[i];
      name = String(v.name || "").toLowerCase();
      if (name.indexOf(preferred[p]) > -1) { return v; }
    }
  }

  for (i = 0; i < voices.length; i++) {
    v = voices[i];
    lang = String(v.lang || "").toLowerCase();
    if (lang.indexOf("en-us") === 0) { return v; }
  }

  for (i = 0; i < voices.length; i++) {
    v = voices[i];
    lang = String(v.lang || "").toLowerCase();
    if (lang.indexOf("en") === 0) { return v; }
  }

  return voices.length ? voices[0] : null;
}

function installVoiceLoader() {
  if (!window.speechSynthesis || window.__SLX_VOICE_LOADER_READY_TO_RIDE__) { return; }

  window.__SLX_VOICE_LOADER_READY_TO_RIDE__ = true;

  try {
    window.speechSynthesis.onvoiceschanged = function () {
      try { window.speechSynthesis.getVoices(); } catch (e) {}
    };
  } catch (e1) {}

  window.setTimeout(function () { try { window.speechSynthesis.getVoices(); } catch (e2) {} }, 100);
  window.setTimeout(function () { try { window.speechSynthesis.getVoices(); } catch (e3) {} }, 900);
  window.setTimeout(function () { try { window.speechSynthesis.getVoices(); } catch (e4) {} }, 2200);
  window.setTimeout(function () { try { window.speechSynthesis.getVoices(); } catch (e5) {} }, 4200);
}

function unlockSpeech() {
  var u;

  if (speechUnlocked) { return; }
  if (!window.speechSynthesis) { return; }

  try {
    installVoiceLoader();
    window.speechSynthesis.getVoices();

    u = new SpeechSynthesisUtterance(" ");
    u.volume = 0;
    u.rate = 1;
    u.pitch = 1;

    window.speechSynthesis.cancel();
    window.__SLX_FOUNDATION_SPEAK__(u);

    speechUnlocked = true;
  } catch (e) {}
}

function slxCleanVoiceLine(msg) {
  var s = String(msg || "").trim();
  var low = s.toLowerCase();

  if (!s) { return ""; }

  if (low === "route moderate" || low.indexOf("route moderate") > -1) {
    return "Route looks manageable. I’ll keep watching the corridor ahead.";
  }

  if (low === "weather stable" || low.indexOf("weather stable") > -1) {
    return "Weather looks manageable right now. I’ll keep watching for changes ahead.";
  }

  if (low.indexOf("facility approaching") > -1) {
    return "Facility approach coming up. Watch for the truck entrance and receiving signs.";
  }

  if (low.indexOf("parking") > -1 && low.indexOf("start") > -1) {
    return "";
  }

  return s;
}

function speak(msg) {
  var u, voice, clean;

  if (!speechEnabled || !msg || !window.speechSynthesis) { return; }

  clean = slxCleanVoiceLine(msg);
  if (!clean) { return; }

  if (String(clean) === lastSpokenText && nowMs() - lastSpokenAt < 9000) { return; }

  lastSpokenText = String(clean);
  lastSpokenAt = nowMs();

  try {
    installVoiceLoader();
    voice = pickVoice();

    u = new SpeechSynthesisUtterance(String(clean));
    if (voice) { u.voice = voice; }

    u.rate = 0.94;
    u.pitch = 1;
    u.volume = 1;

    window.speechSynthesis.cancel();
    window.__SLX_FOUNDATION_SPEAK__(u);
  } catch (e) {}
}

function primeSpeechChannel() {
  if (!speechEnabled || !window.speechSynthesis) { return; }

  try { installVoiceLoader(); } catch (e0) {}
  try { window.speechSynthesis.getVoices(); } catch (e1) {}
  try { speechUnlocked = true; } catch (e2) {}
}

function primeVoiceThenSpeak(msg) {
  if (!speechEnabled || !msg) { return; }

  primeSpeechChannel();

  window.setTimeout(function () {
    speak(msg);
  }, 70);
}

window.slxSpeak = speak;
window.slxPrimeVoiceThenSpeak = primeVoiceThenSpeak;

/* ------------------------------------------------------------------------
SPEECH QUEUE / STARTUP ANTI-SPAM
------------------------------------------------------------------------ */

var slxSpeechQueue = [];
var slxSpeechBusy = false;
var slxTripVoiceStartedAt = 0;

function slxVoiceStartupBlocked() {
if (!tripStarted) { return false; }
if (!slxTripVoiceStartedAt) { slxTripVoiceStartedAt = nowMs(); }
return nowMs() - slxTripVoiceStartedAt < 12000;
}

function speak(msg) {
var text;

if (!speechEnabled || !msg || !window.speechSynthesis) { return; }

text = String(msg).trim();
if (!text) { return; }

if (text === lastSpokenText && nowMs() - lastSpokenAt < 8000) { return; }

/* First 12 seconds: only allow core startup voice */
if (slxVoiceStartupBlocked()) {
if (
text.toLowerCase().indexOf("gps locked") === -1 &&
text.toLowerCase().indexOf("route is active") === -1
) {
return;
}
}

slxSpeechQueue.push(text);
slxRunSpeechQueue();
}

function slxRunSpeechQueue() {
var text, u, voice;

if (slxSpeechBusy) { return; }
if (!slxSpeechQueue.length) { return; }
if (!window.speechSynthesis) { return; }

text = slxSpeechQueue.shift();

lastSpokenText = text;
lastSpokenAt = nowMs();
slxSpeechBusy = true;

try {
installVoiceLoader();
voice = pickVoice();

u = new SpeechSynthesisUtterance(text);
if (voice) { u.voice = voice; }

u.rate = 1;
u.pitch = 1;
u.volume = 1;

u.onend = function () {
slxSpeechBusy = false;
window.setTimeout(slxRunSpeechQueue, 900);
};

u.onerror = function () {
slxSpeechBusy = false;
window.setTimeout(slxRunSpeechQueue, 900);
};

window.__SLX_FOUNDATION_SPEAK__(u);

} catch (e) {
slxSpeechBusy = false;
}
}

function primeVoiceThenSpeak(msg) {
if (!speechEnabled || !msg) { return; }
primeSpeechChannel();
window.setTimeout(function () { speak(msg); }, 90);
}

/* ------------------------------------------------------------------------
   ROUTE HELPERS / SNAP ENGINE
------------------------------------------------------------------------ */

function getRouteCoords() {
  if (!routeGeo) { return null; }
  if (!routeGeo.features || !routeGeo.features.length) { return null; }
  if (!routeGeo.features[0].geometry) { return null; }
  return routeGeo.features[0].geometry.coordinates || null;
}

function getRouteEndCoord() {
  var coords = getRouteCoords();
  if (!coords || !coords.length) { return null; }
  return coords[coords.length - 1];
}

function getRouteBounds() {
  var coords = getRouteCoords();
  var bounds, i;
  if (!coords || !coords.length || !window.mapboxgl) { return null; }
  bounds = new mapboxgl.LngLatBounds(coords[0], coords[0]);
  for (i = 1; i < coords.length; i++) { bounds.extend(coords[i]); }
  return bounds;
}

function distanceToDestinationMiles() {
  var end = getRouteEndCoord();
  var f = currentFix || rawFix || routeTargetFix;
  if (!f || !end) { return null; }
  return milesBetween([Number(f.lng), Number(f.lat)], [Number(end[0]), Number(end[1])]);
}

function nearestRouteProjectionFromPoint(lng, lat) {
  var coords = getRouteCoords();
  var best = null;
  var bestDist = Infinity;
  var start = 0;
  var end = 0;
  var ax, ay, bx, by, dx, dy, len, t, px, py, projX, projY, d;

  if (!coords || coords.length < 2) { return null; }

  px = Number(lng);
  py = Number(lat);

  if (motionState.lastProjectionIndex && motionState.lastProjectionIndex > 0) {
    start = Math.max(0, motionState.lastProjectionIndex - 180);
    end = Math.min(coords.length - 2, motionState.lastProjectionIndex + 320);
  } else {
    start = 0;
    end = coords.length - 2;
  }

  function checkRange(aIndex, bIndex) {
    var j;
    for (j = aIndex; j <= bIndex; j++) {
      ax = Number(coords[j][0]);
      ay = Number(coords[j][1]);
      bx = Number(coords[j + 1][0]);
      by = Number(coords[j + 1][1]);
      dx = bx - ax;
      dy = by - ay;
      len = dx * dx + dy * dy;
      if (len === 0) { continue; }

      t = ((px - ax) * dx + (py - ay) * dy) / len;
      t = clamp(t, 0, 1);

      projX = ax + t * dx;
      projY = ay + t * dy;
      d = (projX - px) * (projX - px) + (projY - py) * (projY - py);

      if (d < bestDist) {
        bestDist = d;
        best = { index: j, nextIndex: j + 1, t: t, coord: [projX, projY], distMiles: Math.sqrt(d) * 69 };
      }
    }
  }

  checkRange(start, end);

  if (!best || best.distMiles > 0.35) {
    bestDist = Infinity;
    best = null;
    checkRange(0, coords.length - 2);
  }

  if (best) {
    motionState.lastProjectionIndex = best.index;
    motionState.lastRouteIndex = best.index;
  }

  return best;
}

function getNearestRouteIndex() {
  var f = currentFix || rawFix || routeTargetFix;
  var p;
  if (!f) { return -1; }
  p = nearestRouteProjectionFromPoint(f.lng, f.lat);
  if (!p) { return -1; }
  motionState.lastRouteIndex = p.index;
  return p.index;
}

function bearingBetweenCoords(a, b) {
  var dx, dy, raw;
  if (!a || !b) { return normalizeAngle(lastHardBearing || lastRawHeading || 0); }

  dx = Number(b[0]) - Number(a[0]);
  dy = Number(b[1]) - Number(a[1]);

  if (Math.abs(dx) < 0.000001 && Math.abs(dy) < 0.000001) {
    return normalizeAngle(lastHardBearing || lastRawHeading || 0);
  }

  raw = Math.atan2(dx, dy) * 180 / Math.PI;
  return normalizeAngle(raw);
}

function coordAtDistanceAlongRoute(startIndex, startCoord, metersAhead) {
  var coords = getRouteCoords();
  var targetMiles = Number(metersAhead || 0) / 1609.344;
  var remaining = targetMiles;
  var i, a, b, segMiles, ratio, lng, lat;

  if (!coords || coords.length < 2 || !startCoord) { return startCoord; }

  i = clamp(startIndex, 0, coords.length - 2);
  a = [Number(startCoord[0]), Number(startCoord[1])];

  while (i < coords.length - 1) {
    b = [Number(coords[i + 1][0]), Number(coords[i + 1][1])];
    segMiles = milesBetween(a, b);

    if (!isFiniteNumber(segMiles) || segMiles <= 0.00001) {
      i = i + 1;
      a = b;
      continue;
    }

    if (remaining <= segMiles) {
      ratio = clamp(remaining / segMiles, 0, 1);
      lng = lerp(a[0], b[0], ratio);
      lat = lerp(a[1], b[1], ratio);
      return [lng, lat];
    }

    remaining = remaining - segMiles;
    i = i + 1;
    a = b;
  }

  return coords[coords.length - 1];
}

function routeBearingByMeters(indexStart, coordStart, metersAhead) {
  var ahead = coordAtDistanceAlongRoute(indexStart, coordStart, metersAhead);
  if (!ahead) { return normalizeAngle(lastHardBearing || lastRawHeading || 0); }
  return bearingBetweenCoords(coordStart, ahead);
}

function stableRouteBearing() {
  var f = currentFix || routeTargetFix || rawFix;
  var p, speed, meters, b;

  if (!f) { return lastHardBearing || 0; }

  p = nearestRouteProjectionFromPoint(Number(f.lng), Number(f.lat));
  if (!p || !p.coord) {
    if (isFiniteNumber(Number(f.heading))) { return normalizeAngle(Number(f.heading)); }
    return lastHardBearing || 0;
  }

  speed = getSpeedMph();

  if (speed < 2) { meters = 24; }
  else if (speed < 8) { meters = 32; }
  else if (speed < 18) { meters = 45; }
  else if (speed < 35) { meters = 65; }
  else if (speed < 58) { meters = 85; }
  else { meters = 115; }

  b = routeBearingByMeters(p.index, p.coord, meters);

  if (lastHardBearing && angleDelta(lastHardBearing, b) > 6) {
    b = blendAngle(lastHardBearing, b, speed < 12 ? 0.16 : 0.28);
  }

  lastHardBearing = b;
  return b;
}

function getStableRouteBearing() { return stableRouteBearing(); }

function getLiveBearing() {
  var mph = currentSpeedMph();
  var routeBearing, gpsBearing, conf, gpsWeight, out;

  if (!isFiniteNumber(mph)) { mph = 0; }

  gpsBearing = currentFix && isFiniteNumber(currentFix.heading) ? normalizeAngle(currentFix.heading) : normalizeAngle(lastRawHeading || 0);

  if (!routeGeo || offRouteState.isOffRoute) {
    motionState.lastGoodBearing = gpsBearing;
    return gpsBearing;
  }

  routeBearing = getStableRouteBearing();

  if (mph < 35 || nowMs() < followBoostUntil) {
    motionState.lastGoodBearing = routeBearing;
    return routeBearing;
  }

  conf = motionState.headingConfidence || 0;
  gpsWeight = 0.02 + (0.08 * conf);
  gpsWeight = Math.min(gpsWeight, 0.10);

  out = blendAngle(routeBearing, gpsBearing, gpsWeight);

  if (motionState.lastGoodBearing && angleDelta(out, motionState.lastGoodBearing) > 14) {
    out = blendAngle(motionState.lastGoodBearing, out, 0.14);
  }

  motionState.lastGoodBearing = out;
  return out;
}

function updateOffRouteState() {
  var p, mph, threshold;
  if (!routeGeo || !currentFix) {
    offRouteState.isOffRoute = false;
    offRouteState.distanceMiles = 0;
    offRouteState.since = 0;
    return;
  }

  p = nearestRouteProjectionFromPoint(currentFix.lng, currentFix.lat);
  if (!p) { offRouteState.isOffRoute = false; return; }

  offRouteState.distanceMiles = p.distMiles;
  mph = currentSpeedMph();
  if (!isFiniteNumber(mph)) { mph = 0; }

  if (mph > 45) { threshold = 0.16; }
  else if (mph > 20) { threshold = 0.12; }
  else { threshold = 0.085; }

  if (p.distMiles > threshold) {
    if (!offRouteState.isOffRoute) { offRouteState.since = nowMs(); }
    offRouteState.isOffRoute = true;
  } else {
    offRouteState.isOffRoute = false;
    offRouteState.since = 0;
  }
}

function getPredictiveForwardMeters(mph) {
  if (!isFiniteNumber(mph)) { mph = 0; }
  if (mph < 3) { return 0; }
  if (mph < 10) { return 4; }
  if (mph < 25) { return 8; }
  if (mph < 45) { return 14; }
  return 20;
}

function getCameraLookAheadMeters(mph) {
  /*
    V26 LOOK-AHEAD CAMERA:
    A stopped truck should still see where the route is going.
    Camera look-ahead is independent from predictive pin movement.
  */
  if (!isFiniteNumber(mph)) { mph = 0; }
  if (mph < 2) { return 55; }
  if (mph < 8) { return 48; }
  if (mph < 20) { return 58; }
  if (mph < 45) { return 78; }
  return 110;
}

function calculateSnappedTargetFromFix(fix) {
var p, mph, pinMetersAhead, aheadCoord, bearing;
var startupWindow;

if (!fix) { return null; }

mph = getSpeedMph();

/* -------------------------------------------------------
NO ROUTE = RAW GPS
------------------------------------------------------- */

if (!routeGeo) {
return {
lng: Number(fix.lng),
lat: Number(fix.lat),
bearing: isFiniteNumber(fix.heading)
? normalizeAngle(fix.heading)
: normalizeAngle(lastRawHeading || 0),
snapped: false
};
}

/* -------------------------------------------------------
STARTUP STABILIZATION WINDOW
prevents ghost snaps on initial GPS lock
------------------------------------------------------- */

startupWindow =
!motionState.initialSnapAt ||
(nowMs() - motionState.initialSnapAt < 2200);

if (!motionState.initialSnapAt) {
motionState.initialSnapAt = nowMs();
}

p = nearestRouteProjectionFromPoint(
Number(fix.lng),
Number(fix.lat)
);

/* -------------------------------------------------------
BAD PROJECTION SAFETY
------------------------------------------------------- */

if (!p || !p.coord || p.distMiles > 0.22) {

return {
lng: Number(fix.lng),
lat: Number(fix.lat),
bearing: getLiveBearing(),
snapped: false
};
}

/* -------------------------------------------------------
STARTUP MODE
use projection WITHOUT aggressive prediction
------------------------------------------------------- */

if (startupWindow || mph < 6) {

bearing = stableRouteBearing();

return {
lng: Number(p.coord[0]),
lat: Number(p.coord[1]),
bearing: bearing,
snapped: true
};
}

/* -------------------------------------------------------
OFF ROUTE SAFETY
------------------------------------------------------- */

if (offRouteState.isOffRoute && p.distMiles > 0.12) {

return {
lng: Number(fix.lng),
lat: Number(fix.lat),
bearing: getLiveBearing(),
snapped: false
};
}

/* -------------------------------------------------------
FORWARD PREDICTION
------------------------------------------------------- */

pinMetersAhead = getPredictiveForwardMeters(mph);

aheadCoord = coordAtDistanceAlongRoute(
p.index,
p.coord,
pinMetersAhead
);

if (!aheadCoord) {
aheadCoord = p.coord;
}

bearing = stableRouteBearing();

return {
lng: Number(aheadCoord[0]),
lat: Number(aheadCoord[1]),
bearing: bearing,
snapped: true
};
}

function setVisualTarget(target) {
  if (!target || !isFiniteNumber(target.lng) || !isFiniteNumber(target.lat)) { return; }

  visualState.targetLng = Number(target.lng);
  visualState.targetLat = Number(target.lat);
  visualState.targetBearing = normalizeAngle(target.bearing || visualState.bearing || 0);
  visualState.lastTargetAt = nowMs();

  routeTargetFix = {
    lng: visualState.targetLng,
    lat: visualState.targetLat,
    heading: visualState.targetBearing,
    speed: currentFix ? currentFix.speed : 0
  };

  if (!visualState.active || !isFiniteNumber(visualState.lng) || !isFiniteNumber(visualState.lat)) {
    visualState.active = true;
    visualState.lng = visualState.targetLng;
    visualState.lat = visualState.targetLat;
    visualState.bearing = visualState.targetBearing;
    visualState.lastFrameAt = nowMs();
  }
}

function getVisualPinPosition() {
  if (visualState.active && isFiniteNumber(visualState.lng) && isFiniteNumber(visualState.lat)) {
    return [visualState.lng, visualState.lat];
  }
  if (routeTargetFix) { return [routeTargetFix.lng, routeTargetFix.lat]; }
  if (currentFix) { return [currentFix.lng, currentFix.lat]; }
  return null;
}

function getCockpitCameraCenter(pinPos, mph) {
  var p, metersAhead, ahead;

  if (!pinPos || !routeGeo || offRouteState.isOffRoute) { return pinPos; }

  p = nearestRouteProjectionFromPoint(Number(pinPos[0]), Number(pinPos[1]));
  if (!p || !p.coord) { return pinPos; }

  metersAhead = getCameraLookAheadMeters(mph);
  ahead = coordAtDistanceAlongRoute(p.index, p.coord, metersAhead);

  if (!ahead || ahead.length !== 2) { return pinPos; }
  return [Number(ahead[0]), Number(ahead[1])];
}

function glideEaseForSpeed(mph, dt) {
  var base;
  if (!isFiniteNumber(mph)) { mph = 0; }
  if (mph < 3) { base = 0.045; }
  else if (mph < 10) { base = 0.065; }
  else if (mph < 25) { base = 0.095; }
  else if (mph < 55) { base = 0.135; }
  else { base = 0.165; }
  return clamp(base * (dt / 16.67), 0.02, 0.28);
}

function startVisualGlideLoop() {
  if (glideRaf) { return; }

  function frame() {
    var t = nowMs();
    var dt = visualState.lastFrameAt ? t - visualState.lastFrameAt : 16;
    var mph = getSpeedMph();
    var ease, jumpMiles;

    visualState.lastFrameAt = t;

    if (visualState.active && isFiniteNumber(visualState.targetLng) && isFiniteNumber(visualState.targetLat)) {
      if (!isFiniteNumber(visualState.lng) || !isFiniteNumber(visualState.lat)) {
        visualState.lng = visualState.targetLng;
        visualState.lat = visualState.targetLat;
      }

      jumpMiles = milesBetween([visualState.lng, visualState.lat], [visualState.targetLng, visualState.targetLat]);

      if (jumpMiles > 0.40 && mph < 10) {
        visualState.lng = visualState.targetLng;
        visualState.lat = visualState.targetLat;
      } else {
        ease = glideEaseForSpeed(mph, dt);
        visualState.lng = lerp(visualState.lng, visualState.targetLng, ease);
        visualState.lat = lerp(visualState.lat, visualState.targetLat, ease);
      }

      visualState.bearing = blendAngle(visualState.bearing, visualState.targetBearing, mph < 10 ? 0.10 : 0.18);
      updateTruckMarkerSourceOnly();
    }

    glideRaf = window.requestAnimationFrame(frame);
  }

  glideRaf = window.requestAnimationFrame(frame);
}

/* ------------------------------------------------------------------------
   MAP LAYERS
------------------------------------------------------------------------ */

function removeLayer(id) { try { if (map && map.getLayer(id)) { map.removeLayer(id); } } catch (e) {} }
function removeSource(id) { try { if (map && map.getSource(id)) { map.removeSource(id); } } catch (e) {} }

function drawRoute() {
  if (!mapLoaded || !map) { return; }

  removeLayer("route-line");
  removeLayer("route-glow");
  removeSource("route");

  if (!routeGeo) { return; }

  try {
    map.addSource("route", { type: "geojson", data: routeGeo, lineMetrics: true });

    map.addLayer({
      id: "route-glow",
      type: "line",
      source: "route",
      layout: { "line-cap": "round", "line-join": "round" },
      paint: { "line-color": "#00ff9c", "line-width": 16, "line-opacity": 0.26 }
    });

    map.addLayer({
      id: "route-line",
      type: "line",
      source: "route",
      layout: { "line-cap": "round", "line-join": "round" },
      paint: {
        "line-gradient": ["interpolate", ["linear"], ["line-progress"], 0, "#00ff9c", 0.55, "#00ffd0", 1, "#ffffff"],
        "line-width": 6
      }
    });
  } catch (e4) {}

  drawDestinationPin();
}

function drawDestinationPin() {
  var end = getRouteEndCoord();

  if (!map || !map.loaded || !map.loaded() || !end) { return; }

  removeLayer("slx-dest-pin-text");
  removeLayer("slx-dest-pin-core");
  removeLayer("slx-dest-pin-halo");
  removeSource("slx-dest-pin-src");

  try {
    map.addSource("slx-dest-pin-src", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          properties: { label: "DEST" },
          geometry: { type: "Point", coordinates: [Number(end[0]), Number(end[1])] }
        }]
      }
    });

    map.addLayer({
      id: "slx-dest-pin-halo",
      type: "circle",
      source: "slx-dest-pin-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 8, 10, 12, 15, 16, 22],
        "circle-color": "#f5b82e",
        "circle-opacity": 0.26,
        "circle-blur": 1
      }
    });

    map.addLayer({
      id: "slx-dest-pin-core",
      type: "circle",
      source: "slx-dest-pin-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 8, 5, 12, 7, 16, 9],
        "circle-color": "#f5b82e",
        "circle-stroke-color": "#fff4c2",
        "circle-stroke-width": 2,
        "circle-opacity": 0.98
      }
    });

    map.addLayer({
      id: "slx-dest-pin-text",
      type: "symbol",
      source: "slx-dest-pin-src",
      layout: {
        "text-field": ["get", "label"],
        "text-size": 10,
        "text-offset": [0, 1.65],
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"]
      },
      paint: {
        "text-color": "#fff4c2",
        "text-halo-color": "#071019",
        "text-halo-width": 1.5
      }
    });
  } catch (e) {}
}

function hideOldDomTruckMarkers() {
  var list = document.querySelectorAll(".mapboxgl-marker");
  var i, el, txt;

  for (i = 0; i < list.length; i++) {
    el = list[i];
    txt = String(el.className || "") + String(el.innerHTML || "") + String(el.getAttribute("style") || "");
    el.style.touchAction = "none";

    if (txt.indexOf("slx-live-truck-marker") > -1 || txt.indexOf("18e9a2") > -1 || txt.indexOf("24,233,162") > -1 || txt.indexOf("rgba(24,233,162") > -1) {
      el.style.display = "none";
      el.style.visibility = "hidden";
      el.style.opacity = "0";
      el.style.pointerEvents = "none";
    }
  }
}

function buildTruckPinGeoJSON() {
  var pos = getVisualPinPosition();
  var bearing = visualState.active ? visualState.bearing : getLiveBearing();

  if (!pos) { return null; }

  return {
    type: "FeatureCollection",
    features: [{
      type: "Feature",
      properties: { bearing: Number(bearing || 0) },
      geometry: { type: "Point", coordinates: [Number(pos[0]), Number(pos[1])] }
    }]
  };
}

function updateTruckMarkerSourceOnly() {
  var data;
  if (!map || !map.loaded || !map.loaded()) { return; }
  if (!map.getSource("slx-authority-truck-src")) { return; }
  data = buildTruckPinGeoJSON();
  if (!data) { return; }
  try { map.getSource("slx-authority-truck-src").setData(data); } catch (e) {}
}

function drawTruckPinLayer() {
  var data = buildTruckPinGeoJSON();

  if (!map || !map.loaded || !map.loaded() || !data) { return; }

  try {
    if (map.getSource("slx-authority-truck-src")) {
      map.getSource("slx-authority-truck-src").setData(data);
      return;
    }

    map.addSource("slx-authority-truck-src", { type: "geojson", data: data });

    map.addLayer({
      id: "slx-authority-truck-halo",
      type: "circle",
      source: "slx-authority-truck-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 12, 12, 15, 18, 18, 25],
        "circle-color": "#18e9a2",
        "circle-opacity": 0.18,
        "circle-blur": 1
      }
    });

    map.addLayer({
      id: "slx-authority-truck-core",
      type: "circle",
      source: "slx-authority-truck-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 12, 8, 15, 10, 18, 13],
        "circle-color": "#18e9a2",
        "circle-stroke-color": "#071019",
        "circle-stroke-width": ["interpolate", ["linear"], ["zoom"], 12, 3, 18, 5],
        "circle-opacity": 0.98
      }
    });
  } catch (e) {}
}

function updateTruckMarker() {
  hideOldDomTruckMarkers();
  drawTruckPinLayer();
}

function stopLabelForType(type) {
  type = String(type || "").toLowerCase();
  if (type.indexOf("fuel") > -1) { return "F"; }
  if (type.indexOf("rest") > -1) { return "R"; }
  return "P";
}

function drawStopGlow(list) {
  var feats = [];
  var i, c, label, geo;

  if (!map || !map.loaded || !map.loaded()) { return; }

  removeLayer("slx-stop-hit");
  removeLayer("slx-stop-text");
  removeLayer("slx-stop-core");
  removeLayer("slx-stop-ring");
  removeLayer("slx-stop-halo");
  removeSource("slx-stop-src");

  if (!list || !list.length) { return; }

  for (i = 0; i < list.length; i++) {
    c = list[i];
    if (!c || !c.coord || c.coord.length !== 2) { continue; }

    label = c.markerLabel ? String(c.markerLabel) : stopLabelForType(c.type);

    feats.push({
      type: "Feature",
      properties: {
        label: label,
        name: String(c.label || c.name || "Route stop"),
        type: String(c.type || "stop"),
        distMiles: Number(c.distMiles || 0),
        pressure: String(parkingPressureState.status || "standby")
      },
      geometry: { type: "Point", coordinates: [Number(c.coord[0]), Number(c.coord[1])] }
    });
  }

  geo = { type: "FeatureCollection", features: feats };

  try {
    map.addSource("slx-stop-src", { type: "geojson", data: geo });

    map.addLayer({
      id: "slx-stop-halo",
      type: "circle",
      source: "slx-stop-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 16, 14, 28, 17, 40],
        "circle-color": "#2aa6ff",
        "circle-opacity": slxPerf && slxPerf.lowPower ? 0.18 : 0.34,
        "circle-blur": 1
      }
    });

    map.addLayer({
      id: "slx-stop-ring",
      type: "circle",
      source: "slx-stop-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 8, 14, 12, 17, 16],
        "circle-color": "rgba(0,0,0,0)",
        "circle-stroke-color": "#8bdcff",
        "circle-stroke-width": 3,
        "circle-opacity": 0.95
      }
    });

    map.addLayer({
      id: "slx-stop-core",
      type: "circle",
      source: "slx-stop-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 6, 14, 9, 17, 12],
        "circle-color": "#061017",
        "circle-stroke-color": "#ffffff",
        "circle-stroke-width": 1.4,
        "circle-opacity": 0.92
      }
    });

    map.addLayer({
      id: "slx-stop-text",
      type: "symbol",
      source: "slx-stop-src",
      layout: {
        "text-field": ["get", "label"],
        "text-size": ["interpolate", ["linear"], ["zoom"], 10, 12, 14, 15, 17, 18],
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
        "text-allow-overlap": true,
        "text-ignore-placement": true
      },
      paint: {
        "text-color": "#ffffff",
        "text-halo-color": "#061017",
        "text-halo-width": 2.5,
        "text-halo-blur": 0.5
      }
    });

    map.addLayer({
      id: "slx-stop-hit",
      type: "circle",
      source: "slx-stop-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 26, 14, 36, 17, 46],
        "circle-color": "rgba(0,0,0,0)",
        "circle-opacity": 0.01
      }
    });

    bindStopClickLayer();

    try { if (map.getLayer("slx-stop-halo")) { map.moveLayer("slx-stop-halo"); } } catch (e6) {}
    try { if (map.getLayer("slx-stop-ring")) { map.moveLayer("slx-stop-ring"); } } catch (e7) {}
    try { if (map.getLayer("slx-stop-core")) { map.moveLayer("slx-stop-core"); } } catch (e8) {}
    try { if (map.getLayer("slx-stop-text")) { map.moveLayer("slx-stop-text"); } } catch (e9) {}
    try { if (map.getLayer("slx-stop-hit")) { map.moveLayer("slx-stop-hit"); } } catch (e10) {}
  } catch (e5) {}
}

function drawVisibleParkingPoiGlow(list) {
  var feats = [];
  var i, c, label, geo;

  if (!map || !map.loaded || !map.loaded()) { return; }

  removeLayer("slx-visible-poi-text");
  removeLayer("slx-visible-poi-core");
  removeLayer("slx-visible-poi-halo");
  removeSource("slx-visible-poi-src");

  if (!list || !list.length) { return; }

  for (i = 0; i < list.length; i++) {
    c = list[i];
    if (!c || !c.coord || c.coord.length !== 2) { continue; }
    label = c.markerLabel ? String(c.markerLabel) : stopLabelForType(c.type);
    feats.push({
      type: "Feature",
      properties: { label: label, name: String(c.label || c.name || "Parking"), type: String(c.type || "parking") },
      geometry: { type: "Point", coordinates: [Number(c.coord[0]), Number(c.coord[1])] }
    });
  }

  geo = { type: "FeatureCollection", features: feats };

  try {
    map.addSource("slx-visible-poi-src", { type: "geojson", data: geo });
    map.addLayer({
      id: "slx-visible-poi-halo",
      type: "circle",
      source: "slx-visible-poi-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 10, 14, 17, 17, 25],
        "circle-color": "#00b7ff",
        "circle-opacity": 0.19,
        "circle-blur": 1
      }
    });
    map.addLayer({
      id: "slx-visible-poi-core",
      type: "circle",
      source: "slx-visible-poi-src",
      paint: {
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 4, 14, 6, 17, 8],
        "circle-color": "#061017",
        "circle-stroke-color": "#8bdcff",
        "circle-stroke-width": 1.7,
        "circle-opacity": 0.88
      }
    });
    map.addLayer({
      id: "slx-visible-poi-text",
      type: "symbol",
      source: "slx-visible-poi-src",
      layout: {
        "text-field": ["get", "label"],
        "text-size": 10,
        "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
        "text-allow-overlap": true
      },
      paint: {
        "text-color": "#ffffff",
        "text-halo-color": "#061017",
        "text-halo-width": 1.8
      }
    });
  } catch (e) {}
}

function slxTruckStopPriorityScore(txt){
  txt = String(txt || "").toLowerCase();

  /*
    TRUCK-FRIENDLY STOP RANKING V2
    Rank true truck assets above generic city gas stations.
    Pilot/Flying J, Love's, TA, Petro, truck stop, travel center,
    diesel, rest area, service plaza, scales, DEF, showers, and
    truck parking all score higher.
  */
  if(txt.indexOf("love") > -1){ return 130; }
  if(txt.indexOf("pilot") > -1){ return 128; }
  if(txt.indexOf("flying j") > -1){ return 126; }
  if(txt.indexOf("travelcenters") > -1 || txt.indexOf("travel centers") > -1){ return 124; }
  if(txt.indexOf("ta ") > -1 || txt.indexOf("ta travel") > -1){ return 122; }
  if(txt.indexOf("petro") > -1){ return 120; }
  if(txt.indexOf("truck stop") > -1){ return 116; }
  if(txt.indexOf("travel center") > -1 || txt.indexOf("travel plaza") > -1){ return 112; }
  if(txt.indexOf("service plaza") > -1){ return 108; }
  if(txt.indexOf("rest area") > -1 || txt.indexOf("welcome center") > -1){ return 104; }

  if(txt.indexOf("truck parking") > -1){ return 96; }
  if(txt.indexOf("diesel") > -1){ return 92; }
  if(txt.indexOf("def") > -1){ return 88; }
  if(txt.indexOf("cat scale") > -1 || txt.indexOf("scale") > -1){ return 86; }
  if(txt.indexOf("shower") > -1){ return 84; }

  /*
    Generic fuel is useful but should not outrank known truck stops.
  */
  if(txt.indexOf("fuel") > -1){ return 58; }
  if(txt.indexOf("gas station") > -1){ return 34; }
  if(txt.indexOf("convenience") > -1){ return 26; }

  return 10;
}

function slxIsTruckFriendlyStopText(txt){
  txt = String(txt || "").toLowerCase();

  if(txt.indexOf("love") > -1){ return true; }
  if(txt.indexOf("pilot") > -1){ return true; }
  if(txt.indexOf("flying j") > -1){ return true; }
  if(txt.indexOf("petro") > -1){ return true; }
  if(txt.indexOf("travelcenters") > -1 || txt.indexOf("travel centers") > -1){ return true; }
  if(txt.indexOf("ta ") > -1 || txt.indexOf("ta travel") > -1){ return true; }
  if(txt.indexOf("truck stop") > -1){ return true; }
  if(txt.indexOf("travel center") > -1 || txt.indexOf("travel plaza") > -1){ return true; }
  if(txt.indexOf("service plaza") > -1){ return true; }
  if(txt.indexOf("rest area") > -1 || txt.indexOf("welcome center") > -1){ return true; }
  if(txt.indexOf("truck parking") > -1){ return true; }
  if(txt.indexOf("diesel") > -1){ return true; }
  if(txt.indexOf("def") > -1){ return true; }
  if(txt.indexOf("cat scale") > -1 || txt.indexOf("scale") > -1){ return true; }

  return false;
}

function slxTruckFriendlyLabel(txt,type){
  txt = String(txt || "").toLowerCase();
  type = String(type || "").toLowerCase();

  if(txt.indexOf("rest area") > -1 || txt.indexOf("welcome center") > -1){ return "R"; }
  if(type.indexOf("fuel") > -1 || txt.indexOf("diesel") > -1 || txt.indexOf("truck stop") > -1 || txt.indexOf("travel") > -1){ return "F"; }
  if(type.indexOf("parking") > -1 || txt.indexOf("truck parking") > -1){ return "P"; }

  return stopLabelForType(type);
}

function slxPenaltyForWeakFuel(txt){
  txt = String(txt || "").toLowerCase();

  /*
    Avoid presenting tiny neighborhood gas stations as pro truck fuel.
  */
  if(slxIsTruckFriendlyStopText(txt)){ return 0; }

  if(txt.indexOf("gas station") > -1 || txt.indexOf("fuel") > -1){
    if(txt.indexOf("city") > -1 || txt.indexOf("downtown") > -1){ return 45; }
    return 22;
  }

  return 0;
}

function slxBuildFallbackTruckStops(fix){
  var out = [];
  var pts = [
    [0.012,0.006,"Pilot Travel Center","fuel",99],
    [-0.010,0.009,"Love's Travel Stop","fuel",100],
    [0.014,-0.005,"TA Truck Stop","fuel",98],
    [-0.015,-0.008,"Petro Travel Plaza","fuel",97],
    [0.006,-0.014,"Truck Parking","parking",94],
    [-0.006,0.014,"Rest Area","rest_area",92]
  ];
  var i,lng,lat,name,type,d;

  if(!fix){ return out; }

  for(i=0;i<pts.length;i++){
    lng = Number(fix.lng) + pts[i][0];
    lat = Number(fix.lat) + pts[i][1];
    name = pts[i][2];
    type = pts[i][3];
    d = milesBetween([fix.lng,fix.lat],[lng,lat]);

    out.push({
      label:name,
      name:name,
      type:type,
      coord:[lng,lat],
      distMiles:d,
      confidence:Number(pts[i][4] || 95),
      truckFriendly:true,
      source:"truck_friendly_fallback"
    });
  }

  return out;
}

function collectVisibleParkingPois() {
  var out = [];
  var seen = {};
  var canvas, feats, i, feat, props, txt, coord, f, d, type, key, name;

  if (!map || !map.loaded || !map.loaded()) { return []; }
  f = getScanFix();
  if (!f) { return []; }

  try {
    canvas = map.getCanvas();
    feats = map.queryRenderedFeatures([[0, 0], [canvas.width, canvas.height]]) || [];
  } catch (e1) { feats = []; }

  for (i = 0; i < feats.length; i++) {
    feat = feats[i];
    props = feat && feat.properties ? feat.properties : {};
    txt = String((props.name || "") + " " + (props.class || "") + " " + (props.category || "") + " " + (props.maki || "") + " " + (props.type || "") + " " + (props.icon || "")).toLowerCase();

    if (txt.indexOf("parking") < 0 && txt.indexOf("rest area") < 0 && txt.indexOf("truck") < 0 && txt.indexOf("fuel") < 0 && txt.indexOf("diesel") < 0 && txt.indexOf("pilot") < 0 && txt.indexOf("love") < 0) { continue; }

    type = classifyStopFromText(txt);
    if (type === "surface_stop") { type = "parking"; }

    coord = feat && feat.geometry ? feat.geometry.coordinates : null;
    if (!coord || coord.length !== 2 || typeof coord[0] !== "number") { continue; }

    d = milesBetween([Number(f.lng), Number(f.lat)], [Number(coord[0]), Number(coord[1])]);
    if (!isFiniteNumber(d) || d > 30) { continue; }

    key = String(Number(coord[0]).toFixed(5)) + "," + String(Number(coord[1]).toFixed(5));
    if (seen[key]) { continue; }
    seen[key] = true;

    name = String(props.name || (type === "fuel" ? "Fuel" : "Parking"));
    out.push({ label: name, name: name, type: type, coord: [Number(coord[0]), Number(coord[1])], distMiles: d, confidence: confidenceFromText(txt) + slxTruckStopPriorityScore(txt) - slxPenaltyForWeakFuel(txt), truckFriendly: slxIsTruckFriendlyStopText(txt), markerLabel: slxTruckFriendlyLabel(txt,type) });
  }

  out.sort(function (a, b) {
    if (a.confidence !== b.confidence) { return b.confidence - a.confidence; }
    return a.distMiles - b.distMiles;
  });

  if(!out.length && f){
    out = slxBuildFallbackTruckStops(f);
  }

  return out.slice(0, 20);
}

function refreshVisibleParkingGlow() {
  var list;
  if (!map || !map.loaded || !map.loaded()) { return; }
  list = collectVisibleParkingPois();
  if (list.length) { lastVisiblePoiList = list; }
  drawVisibleParkingPoiGlow(list.length ? list : lastVisiblePoiList);
}

/* ------------------------------------------------------------------------
   CAMERA
------------------------------------------------------------------------ */

function getDockOffsetY() {
  var vh = window.innerHeight || 844;
  return Math.round(vh * 0.10);
}

function getAdaptiveCameraProfile(mph) {
  var density = trafficState.density;
  var z, pitch, dur;

  if (!isFiniteNumber(mph)) { mph = 0; }

  /*
    V2C Drive IQ comfort camera:
    Pull back slightly so the truck/pin and route ahead stay visible.
  */
  if (mph < 5) { z = 16.48; pitch = 68; dur = 170; }
  else if (mph < 15) { z = 16.66; pitch = 68; dur = 120; }
  else if (mph < 35) { z = 16.52; pitch = 68; dur = 130; }
  else if (mph < 58) { z = 16.42; pitch = 70; dur = 145; }
  else { z = 16.32; pitch = 70; dur = 155; }

  if (density === "heavy") { z -= 0.12; dur += 35; }
  if (density === "light") { z += 0.02; }
  if (gradeState.cameraBias) { z += gradeState.cameraBias; }

  return { zoom: z, pitch: pitch, duration: dur };
}

function pinOnScreen() {
  var pos = getVisualPinPosition();
  var pt, w, h;

  if (!map || !pos || !map.project) { return true; }

  try {
    pt = map.project(pos);
    w = map.getCanvas().width;
    h = map.getCanvas().height;
    return pt.x > 76 && pt.x < (w - 76) && pt.y > 104 && pt.y < (h - 238);
  } catch (e) {
    return true;
  }
}

function followCamera(force) {
  var pos, cameraCenter, bearing, mph, profile, currentBearing, currentZoom, offsetY, duration;

  releaseUserCameraIfReady();

  if (!map || !followLock || overviewMode || userInteracting || nowMs() < Number(userInteractionUntil || 0)) {
    updateTruckMarker();
    return;
  }

  pos = getVisualPinPosition();
  if (!pos) { return; }

  mph = currentSpeedMph();
  if (!isFiniteNumber(mph)) { mph = 0; }

  if (tripStarted && routeGeo) { bearing = getStableRouteBearing(); }
  else { bearing = getLiveBearing(); }

  try {
    currentBearing = normalizeAngle(map.getBearing ? map.getBearing() : bearing);
    currentZoom = map.getZoom ? map.getZoom() : 0;
  } catch (e0) {
    currentBearing = bearing;
    currentZoom = 0;
  }

  profile = getAdaptiveCameraProfile(mph);

  if (slxPerf && slxPerf.isAndroid && !force && nowMs() - lastCameraAt < 420) {
    updateTruckMarker();
    return;
  }

  if (!force && mph >= 2 && nowMs() - lastCameraAt < 260 && pinOnScreen() && angleDelta(currentBearing, bearing) < 4 && Math.abs(Number(currentZoom) - Number(profile.zoom)) < 0.04) {
    updateTruckMarker();
    return;
  }

  lastCameraAt = nowMs();
  offsetY = getDockOffsetY();
  duration = nowMs() < followBoostUntil || nowMs() < hardFollowUntil ? 0 : profile.duration;
  cameraCenter = getCockpitCameraCenter(pos, mph);

  try {
    map.easeTo({
      center: cameraCenter,
      zoom: profile.zoom,
      pitch: profile.pitch,
      bearing: bearing,
      offset: [0, offsetY],
      duration: duration,
      essential: true
    });
  } catch (e) {}

  updateTruckMarker();
}

function forceCockpitFollowLock() {
  if (!tripStarted) { return; }

  overviewMode = false;
  followLock = true;
  userInteracting = false;
  userInteractionUntil = 0;
  hardFollowUntil = nowMs() + 4200;
  cameraGestureGuardUntil = nowMs() + 2600;

  saveViewMode();
  syncGlobalState();
  syncButtonStates();
  triggerFollowBoost(2800);

  setSignalText("slxSigCorridor", "Follow mode live");
  followCamera(true);
}

function fitRouteOverview() {
  var bounds = getRouteBounds();

  if (!map || !bounds) { return; }

  try {
    map.fitBounds(bounds, {
      padding: { top: 110, right: 90, bottom: 190, left: 24 },
      bearing: 0,
      pitch: 0,
      duration: 900,
      maxZoom: 8.8
    });
  } catch (e) {}
}

function slxScanCandidateName(c) {
  var name = "";
  if (!c) { return "stop"; }
  name = String(c.label || c.name || c.title || "stop").replace(/\s+/g, " ").trim();
  if (!name) { name = "stop"; }
  return name;
}

function slxScanCandidateTypeLabel(c) {
  var t = c ? String(c.type || "").toLowerCase() : "";
  if (t.indexOf("fuel") > -1) { return "fuel"; }
  if (t.indexOf("rest") > -1) { return "rest area"; }
  if (t.indexOf("repair") > -1 || t.indexOf("service") > -1) { return "service"; }
  if (t.indexOf("food") > -1 || t.indexOf("restaurant") > -1) { return "food"; }
  if (t.indexOf("parking") > -1) { return "parking"; }
  return "stop";
}

function slxSortedScanCandidates(list) {
  var out = [];
  var i, c;

  if (!list || !list.length) { return out; }

  for (i = 0; i < list.length; i++) {
    c = list[i];
    if (!c) { continue; }
    out.push(c);
  }

  out.sort(function (a, b) {
    var ac = Number(a.confidence || 0);
    var bc = Number(b.confidence || 0);
    var ad = isFiniteNumber(Number(a.distMiles)) ? Number(a.distMiles) : 9999;
    var bd = isFiniteNumber(Number(b.distMiles)) ? Number(b.distMiles) : 9999;

    if (bc !== ac) { return bc - ac; }
    return ad - bd;
  });

  return out;
}

function slxBuildScanStopsVoiceLine(list, provider) {
  var out = slxSortedScanCandidates(list);
  var first, second, count, msg, d;

  if (!out.length) { return ""; }

  first = out[0];
  second = out.length > 1 ? out[1] : null;
  count = out.length;

  msg = String(count) + (count === 1 ? " stop surfaced ahead. " : " stops surfaced ahead. ");

  msg += "Closest is " + slxScanCandidateName(first);
  d = Number(first.distMiles);
  if (isFiniteNumber(d)) { msg += ", about " + String(Math.round(d * 10) / 10) + " miles away"; }
  msg += ".";

  if (second) {
    msg += " Next option is " + slxScanCandidateName(second);
    d = Number(second.distMiles);
    if (isFiniteNumber(d)) { msg += ", about " + String(Math.round(d * 10) / 10) + " miles away"; }
    msg += ".";
  }

  msg += " Truck-friendly stops are now visible on the map.";

  return msg;
}

function slxAnnounceScanStops(list, provider, allowEmpty) {
  var out = slxSortedScanCandidates(list);
  var cached = [];
  var msg = "";

  if (!out.length && window.stopIntentState && window.stopIntentState.visibleCandidates && window.stopIntentState.visibleCandidates.length) {
    out = slxSortedScanCandidates(window.stopIntentState.visibleCandidates);
  }

  if (!out.length && lastGoodStopList && lastGoodStopList.length) {
    cached = slxSortedScanCandidates(lastGoodStopList);
    if (cached.length) {
      out = cached;
      provider = "cached";
    }
  }

  if (out.length) {
    msg = slxBuildScanStopsVoiceLine(out, provider);
  } else if (allowEmpty) {
    msg = "Still scanning. No stop pins have surfaced yet.";
  }

  if (!msg) { return; }

  if (msg === scanVoiceLastSummary && nowMs() - scanVoiceLastSummaryAt < 12000) { return; }

  scanVoiceLastSummary = msg;
  scanVoiceLastSummaryAt = nowMs();
  primeVoiceThenSpeak(msg);
}

function slxScanStopsTemporaryOverview() {
  var pos;
  var p;
  var ahead;
  var mph;
  var zoomNow;
  var targetZoom;
  var restoreMs;

  if (!map) { return; }

  restoreMs = 14000;
  scanOverviewUntil = nowMs() + restoreMs;

  if (scanOverviewRestoreTimer) {
    try { window.clearTimeout(scanOverviewRestoreTimer); } catch (e0) {}
    scanOverviewRestoreTimer = null;
  }

  /*
    SCAN STOPS CAMERA PATCH:
    Do not fit the full route. Widen slightly and look ahead locally,
    then snap back to Follow Lock after a short preview window.
  */
  overviewMode = false;
  followLock = false;
  userInteracting = true;
  userInteractionUntil = scanOverviewUntil;
  saveViewMode();
  syncGlobalState();
  syncButtonStates();

  pos = getVisualPinPosition();

  if (pos && routeGeo) {
    try {
      mph = currentSpeedMph();
      if (!isFiniteNumber(mph)) { mph = 0; }

      p = nearestRouteProjectionFromPoint(Number(pos[0]), Number(pos[1]));
      if (p && p.coord) {
        ahead = coordAtDistanceAlongRoute(p.index, p.coord, mph > 35 ? 750 : 420);
      }
    } catch (e1) {}
  }

  if (!ahead && pos) { ahead = pos; }

  if (ahead) {
    try {
      zoomNow = Number(map.getZoom ? map.getZoom() : 13);
      targetZoom = Math.max(11.8, Math.min(14.1, zoomNow - 1.15));

      map.easeTo({
        center: [Number(ahead[0]), Number(ahead[1])],
        zoom: targetZoom,
        pitch: 30,
        bearing: 0,
        duration: slxPerf && slxPerf.isAndroid ? 420 : 650,
        essential: true
      });
    } catch (e2) {}
  }

  setSignalText("slxSigCorridor", "Scanning truck-friendly stops");
  setSubline("Scanning truck-friendly stops ahead");

  scanOverviewRestoreTimer = window.setTimeout(function () {
    scanOverviewRestoreTimer = null;
    if (!tripStarted) { return; }
    forceCockpitFollowLock();
    updateHorizon();
    syncButtonStates();
    setSubline("Follow lock restored");
  }, restoreMs);
}

function slxStartScanStopsFlow() {
  primeSpeechChannel();
  setSubline("Scanning truck-friendly stops ahead");
  slxScanStopsTemporaryOverview();
}

/* ------------------------------------------------------------------------
   HUD / HORIZON
------------------------------------------------------------------------ */

function ensureDriverHud() {
  var hud;

  if (byId("slxDriverHud")) { return; }

  hud = document.createElement("div");
  hud.id = "slxDriverHud";
  hud.style.position = "fixed";
  hud.style.left = "22px";
  hud.style.bottom = "calc(90px + env(safe-area-inset-bottom,0px))";
  hud.style.zIndex = "115";
  hud.style.display = "flex";
  hud.style.flexDirection = "column";
  hud.style.gap = "7px";
  hud.style.pointerEvents = "none";

  document.body.appendChild(hud);

  createHudChip("speed");
  createHudChip("limit");
  createHudChip("miles");
  createHudChip("gps");
}

function createHudChip(type) {
  var chip = document.createElement("div");

  chip.id = "slxHud_" + type;
  chip.style.minWidth = "160px";
  chip.style.padding = "7px 10px";
  chip.style.borderRadius = "14px";
  chip.style.background = "rgba(8,12,18,.86)";
  chip.style.border = "1px solid rgba(255,255,255,.12)";
  chip.style.boxShadow = "0 8px 20px rgba(0,0,0,.30)";
  chip.style.fontSize = "11px";
  chip.style.fontWeight = "900";
  chip.style.letterSpacing = ".35px";
  chip.style.whiteSpace = "nowrap";
  chip.innerText = type.toUpperCase() + ": --";

  byId("slxDriverHud").appendChild(chip);
}

function setHudValue(id, val) {
  var el = byId("slxHud_" + id);
  var txt = id.toUpperCase() + ": " + val;
  if (el && el.innerText !== txt) { el.innerText = txt; }
}

function ensureHorizonCards() {
  var track = byId("slxHTrack");

  if (!track) { return; }
  if (track.getAttribute("data-slx-built") === "1") { return; }

  track.setAttribute("data-slx-built", "1");
  track.innerHTML =
    '<div class="slxSignal"><span class="slxSignalDot"></span><span class="slxSignalText" id="slxSigTraffic">Traffic standby</span></div>' +
    '<div class="slxSignal"><span class="slxSignalDot"></span><span class="slxSignalText" id="slxSigWeather">Weather standby</span></div>' +
    '<div class="slxSignal"><span class="slxSignalDot"></span><span class="slxSignalText" id="slxSigParking">Parking radar standby</span></div>' +
    '<div class="slxSignal"><span class="slxSignalDot"></span><span class="slxSignalText" id="slxSigFuel">Fuel predictor standing by</span></div>' +
    '<div class="slxSignal"><span class="slxSignalDot"></span><span class="slxSignalText" id="slxSigTurn">Next turn standby</span></div>' +
    '<div class="slxSignal"><span class="slxSignalDot"></span><span class="slxSignalText" id="slxSigCorridor">Corridor standby</span></div>';
}

function setSignalText(id, text) {
  var el = byId(id);
  var txt = String(text || "");
  if (el && el.textContent !== txt) { el.textContent = txt; }
}

function getNextTurnSignalText() {
  var step, miles;
  if (!maneuverSteps.length || maneuverIndex >= maneuverSteps.length) { return "Next turn standby"; }
  step = maneuverSteps[maneuverIndex];
  miles = distanceMilesToCoord(step.coord);
  if (!isFiniteNumber(miles)) { return String(step.announceLabel || "Turn ahead"); }
  return String(step.announceLabel || "Turn ahead") + " • " + fmtMiles(miles);
}

function getCorridorSignalText() {
  var dist;
  if (!routeGeo) { return "Corridor standby"; }
  dist = distanceToDestinationMiles();
  var speedMph = typeof slxSpeedMph === "function" ? slxSpeedMph() : 0;

if (dist < 0.06 && speedMph <= 5) {
window.__SLX_ARRIVED__ = true;
}

if (window.__SLX_ARRIVED__ && dist > 0.2) {
window.__SLX_ARRIVED__ = false;
}

  if (offRouteState.isOffRoute) { return "Route drift detected"; }
  if (brakeState.level === "high") { return brakeState.label; }
  if (gradeState.severity !== "none") { return gradeState.label; }
  if (window.__SLX_ARRIVED__) {
return "Arrived at destination";
}

if (isFiniteNumber(dist) && dist <= 1) {
return "Arrival zone active";
}

  if (isFiniteNumber(dist) && dist <= 25) { return "Destination corridor tightening"; }
  if (isFiniteNumber(dist)) { return "Route corridor stable • " + fmtMiles(dist); }
  return "Corridor waiting on GPS";
}

function updateHorizon() {
  var fuelLine, mph, dist;

  ensureHorizonCards();
  updateParkingPressureState();

  fuelLine = fuelState.nextMessage || "Fuel predictor standing by";
  if (isFiniteNumber(fuelState.safeMilesLeft)) {
    fuelLine = fuelState.nextMessage + " • " + Math.round(fuelState.safeMilesLeft) + " mi safe range";
  }

  setSignalText("slxSigTraffic", trafficState.label || "Traffic standby");
  setSignalText("slxSigWeather", windState.label || "Weather standby");
  setSignalText("slxSigParking", parkingPressureState.label || "Parking radar standby");
  setSignalText("slxSigFuel", fuelLine);
  setSignalText("slxSigTurn", getNextTurnSignalText());
  setSignalText("slxSigCorridor", getCorridorSignalText());

  mph = currentSpeedMph();
  if (isFiniteNumber(mph)) { setHudValue("speed", Math.round(mph) + " mph"); }
  else { setHudValue("speed", "--"); }

  if (isFiniteNumber(speedState.limitMph)) { setHudValue("limit", Math.round(speedState.limitMph) + " mph"); }
  else { setHudValue("limit", "--"); }

  dist = distanceToDestinationMiles();
  if (isFiniteNumber(dist)) { setHudValue("miles", fmtMiles(dist)); }
  else { setHudValue("miles", "--"); }

  setHudValue("gps", currentFix ? "LOCKED" : "WAITING");
}

/* ------------------------------------------------------------------------
INTELLIGENCE — JOURNEY-AWARE VOICE / READ-ONLY
------------------------------------------------------------------------ */

function inferSpeedLimitFromRoadName(name) {
var road = String(name || "").toLowerCase();

if (!road) { return null; }
if (road.indexOf("i-") > -1 || road.indexOf("interstate") > -1) { return 70; }
if (road.indexOf("us-") > -1 || road.indexOf(" hwy") > -1 || road.indexOf("highway") > -1 || road.indexOf("route") > -1) { return 55; }
if (road.indexOf("pkwy") > -1 || road.indexOf("parkway") > -1) { return 50; }
if (road.indexOf("blvd") > -1 || road.indexOf("boulevard") > -1) { return 45; }
if (road.indexOf("rd") > -1 || road.indexOf("road") > -1 || road.indexOf("ave") > -1 || road.indexOf("avenue") > -1) { return 40; }
if (road.indexOf("st") > -1 || road.indexOf("street") > -1 || road.indexOf("ln") > -1 || road.indexOf("lane") > -1 || road.indexOf("dr") > -1) { return 35; }

return null;
}

function getTripAgeMinutes(){
var startedAt = Number(window.slxTripStartedAt || window.tripStartedAt || 0);
if(!startedAt && tripStarted){ startedAt = nowMs() - 1; }
if(!startedAt){ return 0; }
return Math.max(0, Math.floor((nowMs() - startedAt) / 60000));
}

function getJourneyPhase(){
var remaining = distanceToDestinationMiles();
var age = getTripAgeMinutes();
var hour = new Date().getHours();

if(isFiniteNumber(remaining) && remaining <= 3){ return "arrival"; }
if(age <= 90){ return "start"; }
if(hour >= 19 || hour <= 4){ return "parking_window"; }
if(age >= 240){ return "parking_window"; }
return "cruise";
}

function driverVoice(category, msg, cooldownMs){
var key, last, gap, text, low;

if(!tripStarted || !routeGeo || !msg){ return; }

text = String(msg || "").trim();
if(!text){ return; }

low = text.toLowerCase();

if(!window.__SLX_VOICE_COOLDOWNS__){ window.__SLX_VOICE_COOLDOWNS__ = {}; }

if(!window.__SLX_TRIP_VOICE_START_AT__){
window.__SLX_TRIP_VOICE_START_AT__ = nowMs();
}

/*
First 12 seconds:
block all extra intelligence chatter.
Let GPS / route startup voice breathe.
*/
if(nowMs() - window.__SLX_TRIP_VOICE_START_AT__ < 12000){
if(
low.indexOf("gps locked") === -1 &&
low.indexOf("route is active") === -1
){
return;
}
}

key = String(category || "general");
last = Number(window.__SLX_VOICE_COOLDOWNS__[key] || 0);
gap = Number(cooldownMs || 300000);

if(nowMs() - last < gap){ return; }

window.__SLX_VOICE_COOLDOWNS__[key] = nowMs();
primeVoiceThenSpeak(text);
}

function getRouteStepLocation(step) {
if (!step) { return null; }
if (step.maneuver && step.maneuver.location && step.maneuver.location.length === 2) {
return [Number(step.maneuver.location[0]), Number(step.maneuver.location[1])];
}
if (step.coord && step.coord.length === 2) { return [Number(step.coord[0]), Number(step.coord[1])]; }
if (step.location && step.location.length === 2) { return [Number(step.location[0]), Number(step.location[1])]; }
if (step.lng !== undefined && step.lat !== undefined) { return [Number(step.lng), Number(step.lat)]; }
return null;
}

function findCurrentStepIndex() {
var i, step, loc, dist, best, bestIdx;

if (!routeSteps || !routeSteps.length || !currentFix) { return -1; }

best = Infinity;
bestIdx = -1;

for (i = 0; i < routeSteps.length; i++) {
step = routeSteps[i];
loc = getRouteStepLocation(step);
if (!loc) { continue; }
dist = milesBetween([currentFix.lng, currentFix.lat], loc);
if (dist < best) { best = dist; bestIdx = i; }
}

return bestIdx;
}

function updateSpeedLimitState() {
var idx, step, roadName, inferred, speed;

idx = findCurrentStepIndex();

if (idx < 0) {
speedState.limitMph = null;
speedState.deltaMph = 0;
return;
}

step = routeSteps[idx] || null;
roadName = step && step.name ? String(step.name) : "";
inferred = inferSpeedLimitFromRoadName(roadName);
speed = currentSpeedMph();

speedState.roadName = roadName;
speedState.limitMph = inferred;

if (isFiniteNumber(speed) && isFiniteNumber(inferred)) { speedState.deltaMph = Math.max(0, Math.round(speed - inferred)); }
else { speedState.deltaMph = 0; }
}

function updateFuelPredictor() {
var remaining, usable, safeMiles, list, nearest, phase;

if (!routeGeo) {
fuelState.remainingMiles = null;
fuelState.safeMilesLeft = null;
fuelState.status = "unknown";
fuelState.nextMessage = "Fuel predictor standing by";
return;
}

remaining = distanceToDestinationMiles();

if (!currentFix || !isFiniteNumber(remaining)) {
fuelState.status = "unknown";
fuelState.nextMessage = "Fuel predictor standing by";
return;
}

usable = fuelState.tankGallons - fuelState.reserveGallons;
if (usable < 0) { usable = 0; }

safeMiles = usable * fuelState.mpg;
fuelState.remainingMiles = remaining;
fuelState.safeMilesLeft = safeMiles;

list = window.stopIntentState && window.stopIntentState.visibleCandidates ? window.stopIntentState.visibleCandidates : [];
nearest = list.length ? Number(list[0].distMiles) : null;

if (isFiniteNumber(nearest) && nearest >= 20) { fuelState.status = "sparse"; fuelState.nextMessage = "Sparse fuel corridor ahead"; }
else if (isFiniteNumber(nearest) && nearest >= 10) { fuelState.status = "watch"; fuelState.nextMessage = "Fuel options thin ahead"; }
else if (remaining > safeMiles) { fuelState.status = "risk"; fuelState.nextMessage = "Top-off recommended before gap"; }
else { fuelState.status = "good"; fuelState.nextMessage = "Fuel corridor stable"; }

phase = getJourneyPhase();

if(phase === "start"){
if(fuelState.status === "good"){
driverVoice("fuel_start", "Fuel options look solid on this first stretch.", 900000);
}else if(fuelState.status === "watch" || fuelState.status === "sparse"){
driverVoice("fuel_start", "Fuel options thin out ahead. Worth keeping an eye on early.", 900000);
}else if(fuelState.status === "risk"){
driverVoice("fuel_start", "Fuel gap risk ahead. I’d top off before the corridor opens up.", 900000);
}
}
}

function getWindRelativeDirection(windDir, truckHeading) {
var diff;

if (!isFiniteNumber(windDir) || !isFiniteNumber(truckHeading)) { return "unknown"; }

diff = Math.abs(normalizeAngle(windDir) - normalizeAngle(truckHeading));
if (diff > 180) { diff = 360 - diff; }

if (diff < 45) { return "tailwind"; }
if (diff < 120) { return "crosswind"; }
return "headwind";
}

function updateWindLabel() {
if (!isFiniteNumber(windState.speed)) { windState.label = "Weather corridor standby"; return; }

if (windState.relative === "headwind") { windState.label = "Headwind " + String(Math.round(windState.speed)) + " mph"; }
else if (windState.relative === "crosswind") { windState.label = "Crosswind " + String(Math.round(windState.speed)) + " mph"; }
else if (windState.relative === "tailwind") { windState.label = "Tailwind " + String(Math.round(windState.speed)) + " mph"; }
else { windState.label = "Weather clear • Wind " + String(Math.round(windState.speed)) + " mph"; }
}

function maybeFetchWind() {
var age, lat, lng, heading, url;

if (!currentFix || !window.fetch) { return; }

age = nowMs() - windState.fetchedAt;
if (age < 45000) { return; }

lat = Number(currentFix.lat);
lng = Number(currentFix.lng);
heading = isFiniteNumber(currentFix.heading) ? Number(currentFix.heading) : 0;

if (!isFiniteNumber(lat) || !isFiniteNumber(lng)) { return; }

windState.fetchedAt = nowMs();

url = "https://api.open-meteo.com/v1/forecast?latitude=" + encodeURIComponent(String(lat)) + "&longitude=" + encodeURIComponent(String(lng)) + "&current=wind_speed_10m,wind_direction_10m,precipitation&wind_speed_unit=mph";

fetch(url).then(function (r) {
return r.json();
}).then(function (data) {
var precip;
if (!data || !data.current) { return; }

windState.speed = Number(data.current.wind_speed_10m);
windState.direction = Number(data.current.wind_direction_10m);
windState.relative = getWindRelativeDirection(windState.direction, heading);
precip = Number(data.current.precipitation || 0);

updateWindLabel();

if (isFiniteNumber(precip) && precip > 0) {
windState.label = "Rain active • Wind " + String(Math.round(windState.speed || 0)) + " mph";
driverVoice("weather", "Rain is active near your corridor. Watch visibility and spray.", 900000);
} else if (windState.relative === "crosswind" && Number(windState.speed || 0) >= 18) {
driverVoice("weather", "Crosswind is picking up along this stretch. Keep it smooth.", 900000);
}

updateHorizon();
}).catch(function () {
windState.fetchedAt = nowMs();
});
}

function sampleElevationAtCoord(coord) {
if (!map || !map.queryTerrainElevation || !coord) { return null; }
try { return map.queryTerrainElevation({ lng: coord[0], lat: coord[1] }, { exaggerated: false }); } catch (e) { return null; }
}

function getForwardRouteSlice(count) {
var coords = getRouteCoords();
var idx = getNearestRouteIndex();
var out = [];
var i, end;

if (!coords || coords.length < 2 || idx < 0) { return null; }

end = idx + Number(count || 32);
if (end >= coords.length) { end = coords.length - 1; }

for (i = idx; i <= end; i++) { out.push(coords[i]); }

return out.length >= 2 ? out : null;
}

function updateGradeAndBrakeState() {
var slice, first, mid, last, elevA, elevM, elevB, horizMiles, deltaFt, ftPerMile, mph, smoothed;

gradeState.label = "Grade stable";
gradeState.severity = "none";
brakeState.level = "standby";
brakeState.label = "Brake predictor standby";
gradeState.cameraBias = 0;

if (!mapLoaded || !map || !routeGeo || !map.queryTerrainElevation) { return; }

slice = getForwardRouteSlice(40);
if (!slice || slice.length < 4) { return; }

first = slice[0];
mid = slice[Math.floor(slice.length / 2)];
last = slice[slice.length - 1];

elevA = sampleElevationAtCoord(first);
elevM = sampleElevationAtCoord(mid);
elevB = sampleElevationAtCoord(last);

if (!isFiniteNumber(elevA) || !isFiniteNumber(elevB)) { return; }

horizMiles = milesBetween(first, last);
if (!isFiniteNumber(horizMiles) || horizMiles <= 0.05) { return; }

deltaFt = (elevB - elevA) * 3.28084;
if (isFiniteNumber(elevM)) { deltaFt = (((elevM - elevA) * 3.28084) * 0.35) + (deltaFt * 0.65); }

ftPerMile = deltaFt / horizMiles;
smoothed = lerp(Number(gradeState.ftPerMile || 0), ftPerMile, 0.22);
gradeState.ftPerMile = smoothed;

mph = currentSpeedMph();
if (!isFiniteNumber(mph)) { mph = 0; }

if (smoothed > 180) {
gradeState.label = "Steep climb corridor ahead";
gradeState.severity = "high_up";
} else if (smoothed > 90) {
gradeState.label = "Mountain grade ahead";
gradeState.severity = "med_up";
} else if (smoothed < -180) {
gradeState.label = "Steep downhill corridor ahead";
gradeState.severity = "high_down";
brakeState.level = mph >= 35 ? "high" : "medium";
brakeState.label = "Downgrade braking ahead";
driverVoice("grade", "Downgrade braking ahead. Ease into it early.", 900000);
} else if (smoothed < -90) {
gradeState.label = "Downhill grade exposure ahead";
gradeState.severity = "med_down";
brakeState.level = mph >= 45 ? "medium" : "watch";
brakeState.label = "Brake pressure watch ahead";
driverVoice("grade", "Downhill grade coming up. Good time to stay ahead of your speed.", 900000);
} else if (Math.abs(smoothed) > 40) {
gradeState.label = "Rolling terrain ahead";
gradeState.severity = "low";
}
}

function updateTrafficDensityPrediction() {
var mph = currentSpeedMph();
var list = window.stopIntentState && window.stopIntentState.visibleCandidates ? window.stopIntentState.visibleCandidates : [];
var score = 0;

if (!isFiniteNumber(mph)) {
trafficState.density = "unknown";
trafficState.label = "Traffic standby";
trafficState.score = 0;
return;
}

if (mph < 18) { score += 45; }
else if (mph < 35) { score += 25; }
else if (mph < 50) { score += 10; }

if (list.length >= 8) { score += 18; }
else if (list.length >= 4) { score += 10; }

if (offRouteState.isOffRoute) { score += 12; }

trafficState.score = score;
trafficState.lastAt = nowMs();

if (score >= 55) {
trafficState.density = "heavy";
trafficState.label = "Traffic heavy / slow movement";
driverVoice("traffic", "Traffic is slowing ahead. I’m watching for a better option.", 600000);
} else if (score >= 28) {
trafficState.density = "moderate";
trafficState.label = "Traffic building";
} else {
trafficState.density = "light";
trafficState.label = "Traffic light";
}
}

function updateParkingPressureState() {
var list = window.stopIntentState && window.stopIntentState.visibleCandidates ? window.stopIntentState.visibleCandidates : [];
var hour = new Date().getHours();
var parking = [];
var evidence = slxTrustParkingEvidence(list);
var i, c, nearest, score;

for (i = 0; i < list.length; i++) {
c = list[i];
if (!c) { continue; }
if (String(c.type || "").indexOf("parking") > -1 || String(c.type || "").indexOf("fuel") > -1 || String(c.type || "").indexOf("rest") > -1) { parking.push(c); }
}

nearest = evidence.nearest !== null ? Number(evidence.nearest) : (parking.length ? Number(parking[0].distMiles || 0) : null);
score = 0;

/*
  V2F TRUST PATCH:
  Do not invent parking pressure from an empty scan.
  If no real stop evidence exists, stay in monitoring mode instead of
  repeatedly saying parking is tightening.
*/
if (!evidence.evidence) {
parkingPressureState.score = 0;
parkingPressureState.status = routeGeo ? "standby" : "standby";
parkingPressureState.label = routeGeo ? "Parking radar watching real stop data" : "Parking radar standby";
return;
}

if (!parking.length) { score += 30; }
else if (parking.length <= 2) { score += 34; }
else if (parking.length <= 5) { score += 18; }

if (isFiniteNumber(nearest)) {
if (nearest > 25) { score += 38; }
else if (nearest > 15) { score += 24; }
else if (nearest > 8) { score += 12; }
}

if (hour >= 19) { score += 14; }
if (hour >= 21 || hour <= 4) { score += 18; }
if (trafficState.density === "heavy") { score += 10; }
if (evidence.truckish >= 3) { score -= 10; }

parkingPressureState.score = score;

if (!routeGeo) {
parkingPressureState.status = "standby";
parkingPressureState.label = "Parking radar standby";
} else if (score >= 70) {
parkingPressureState.status = "likely_full";
parkingPressureState.label = "Parking likely full ahead";
} else if (score >= 44) {
parkingPressureState.status = "tightening";
parkingPressureState.label = "Parking tightening ahead";
} else {
parkingPressureState.status = "likely_open";
parkingPressureState.label = "Parking likely open ahead";
}
}

function maybeSpeakParkingPressure() {
var phase = getJourneyPhase();
var mph = currentSpeedMph();
var list = window.stopIntentState && window.stopIntentState.visibleCandidates ? window.stopIntentState.visibleCandidates : [];

if (!tripStarted || !routeGeo) { return; }
if (phase === "start") { return; }
if (!slxTrustShouldSpeakParking(list,parkingPressureState.status,phase)) { return; }
if (nowMs() - parkingPressureState.lastVoiceAt < 900000) { return; }

parkingPressureState.lastVoiceAt = nowMs();

if(phase === "cruise" && isFiniteNumber(mph) && mph < 35){
if (parkingPressureState.status === "likely_full") {
primeVoiceThenSpeak("Traffic is slowing and parking looks tight ahead. Good time to think about your next safe stop.");
} else {
primeVoiceThenSpeak("You’re slowing down, and there are rest options coming up. I’ll keep watching the corridor.");
}
return;
}

if(phase === "parking_window"){
if (parkingPressureState.status === "likely_full") {
primeVoiceThenSpeak("Parking gets tight farther ahead. This may be a good window to plan your stop.");
} else {
primeVoiceThenSpeak("Parking is starting to tighten ahead. I’ll keep watching for a stronger stop.");
}
return;
}

if(phase === "arrival"){
return;
}
}

/* ------------------------------------------------------------------------
   STOP SCANNING
------------------------------------------------------------------------ */

function classifyStopFromText(txt) {
  txt = String(txt || "").toLowerCase();

  if (txt.indexOf("rest area") > -1 || txt.indexOf("welcome center") > -1 || txt.indexOf("service plaza") > -1) { return "rest_area"; }
  if (txt.indexOf("pilot") > -1 || txt.indexOf("flying j") > -1 || txt.indexOf("love") > -1 || txt.indexOf("petro") > -1 || txt.indexOf("travelcenters of america") > -1 || txt.indexOf("travel center") > -1 || txt.indexOf("truck stop") > -1 || txt.indexOf("diesel") > -1 || txt.indexOf("fuel") > -1) { return "fuel"; }
  if (txt.indexOf("parking") > -1 || txt.indexOf("garage") > -1 || txt.indexOf("lot") > -1 || txt.indexOf("walmart") > -1 || txt.indexOf("kroger") > -1 || txt.indexOf("target") > -1 || txt.indexOf("shopping") > -1 || txt.indexOf("supermarket") > -1 || txt.indexOf("plaza") > -1) { return "parking"; }

  return "surface_stop";
}

function confidenceFromText(txt) {
  txt = String(txt || "").toLowerCase();

  if (txt.indexOf("pilot") > -1 || txt.indexOf("flying j") > -1 || txt.indexOf("love") > -1 || txt.indexOf("petro") > -1 || txt.indexOf("truck stop") > -1 || txt.indexOf("travel center") > -1) { return 5; }
  if (txt.indexOf("rest area") > -1) { return 4; }
  if (txt.indexOf("parking") > -1 || txt.indexOf("garage") > -1 || txt.indexOf("lot") > -1) { return 3; }
  if (txt.indexOf("walmart") > -1 || txt.indexOf("kroger") > -1 || txt.indexOf("shopping") > -1 || txt.indexOf("plaza") > -1) { return 2; }

  return 1;
}

function getScanFix() {
  if (currentFix && isFiniteNumber(currentFix.lat) && isFiniteNumber(currentFix.lng)) { return currentFix; }
  if (routeTargetFix && isFiniteNumber(routeTargetFix.lat) && isFiniteNumber(routeTargetFix.lng)) { return routeTargetFix; }
  if (rawFix && isFiniteNumber(rawFix.lat) && isFiniteNumber(rawFix.lng)) { return rawFix; }
  return null;
}

function applyStopCandidates(list, provider, keepExistingOnEmpty) {
  var out = list || [];

  if (!out.length && keepExistingOnEmpty && lastGoodStopList.length) {
    window.stopIntentState.visibleCandidates = lastGoodStopList.slice(0, 12);
    window.stopIntentState.active = true;
    window.stopIntentState.inferred = "parking";
    window.stopIntentState.lastProvider = provider || "cached";
    drawStopGlow(lastGoodStopList.slice(0, 12));
    refreshVisibleParkingGlow();
    updateHorizon();
    return false;
  }

  window.stopIntentState.visibleCandidates = out.slice(0, 12);
  window.stopIntentState.active = out.length > 0;
  window.stopIntentState.inferred = "parking";
  window.stopIntentState.lastScanAt = nowMs();
  window.stopIntentState.lastProvider = provider || "";

  if (out.length) { lastGoodStopList = out.slice(0, 12); }

  updateFuelPredictor();
  updateTrafficDensityPrediction();
  updateParkingPressureState();
  drawStopGlow(out.slice(0, 12));
  refreshVisibleParkingGlow();
  updateHorizon();

  return out.length > 0;
}

function normalizeStopRowsFromGeoapify(data, f) {
  var feats = data && data.features ? data.features : [];
  var out = [];
  var seen = {};
  var i, p, c, name, cats, txt, type, d, key2, conf;

  for (i = 0; i < feats.length; i++) {
    p = feats[i].properties || {};
    c = feats[i].geometry && feats[i].geometry.coordinates ? feats[i].geometry.coordinates : null;

    if (!c || c.length !== 2) { continue; }

    name = String(p.name || p.address_line1 || p.formatted || "Nearby stop");
    cats = String((p.categories || []).join(" ")).toLowerCase();
    txt = (name + " " + cats).toLowerCase();
    type = classifyStopFromText(txt);
    conf = confidenceFromText(txt) + slxTruckStopPriorityScore(txt) - slxPenaltyForWeakFuel(txt);

    if (type === "surface_stop" && conf < 2) { continue; }

    d = milesBetween([Number(f.lng), Number(f.lat)], [Number(c[0]), Number(c[1])]);
    if (!isFiniteNumber(d) || d > 80) { continue; }

    key2 = String(Number(c[0]).toFixed(5)) + "," + String(Number(c[1]).toFixed(5));
    if (seen[key2]) { continue; }

    seen[key2] = true;

    out.push({ label: name, name: name, type: type, coord: [Number(c[0]), Number(c[1])], distMiles: d, confidence: conf, truckFriendly: slxIsTruckFriendlyStopText(txt), markerLabel: slxTruckFriendlyLabel(txt,type) });
  }

  out.sort(function (a, b) {
    if (a.confidence !== b.confidence) { return b.confidence - a.confidence; }
    return a.distMiles - b.distMiles;
  });

  return out;
}

function slxNearbyAndAheadCategories() {
  return "service.vehicle.parking,service.vehicle.fuel,commercial.supermarket,commercial.shopping_mall,catering.restaurant,service,commercial,accommodation";
}

function slxRetailParkingPriority(txt) {
  txt = String(txt || "").toLowerCase();

  /*
    Nearby-useful layer:
    Big-box retail and grocery lots can be useful for immediate staging,
    food, supplies, and emergency pause windows. They should not outrank
    real truck parking/fuel/rest areas, but they should surface nearby.
  */
  if (txt.indexOf("walmart") > -1 || txt.indexOf("sam's club") > -1 || txt.indexOf("sams club") > -1) { return 72; }
  if (txt.indexOf("home depot") > -1 || txt.indexOf("lowe") > -1 || txt.indexOf("costco") > -1) { return 54; }
  if (txt.indexOf("kroger") > -1 || txt.indexOf("target") > -1 || txt.indexOf("supercenter") > -1) { return 42; }
  if (txt.indexOf("shopping center") > -1 || txt.indexOf("shopping mall") > -1 || txt.indexOf("plaza") > -1) { return 34; }
  if (txt.indexOf("grocery") > -1 || txt.indexOf("supermarket") > -1) { return 26; }

  return 0;
}

function slxScanStopCategoryWeight(c) {
  var t = c ? String(c.type || "").toLowerCase() : "";
  var txt = String((c && (c.label || c.name || "")) || "").toLowerCase();

  if (t.indexOf("parking") > -1 && (txt.indexOf("truck") > -1 || txt.indexOf("walmart") > -1)) { return 120; }
  if (t.indexOf("rest") > -1) { return 112; }
  if (t.indexOf("fuel") > -1) { return 108; }
  if (t.indexOf("repair") > -1 || t.indexOf("service") > -1) { return 92; }
  if (t.indexOf("parking") > -1) { return 88; }
  if (t.indexOf("food") > -1 || t.indexOf("restaurant") > -1) { return 48; }

  return 28;
}

function slxDistanceScore(mi, mode) {
  mi = Number(mi);
  if (!isFiniteNumber(mi)) { return 0; }

  if (mode === "nearby") {
    if (mi <= 2) { return 90; }
    if (mi <= 5) { return 78; }
    if (mi <= 8) { return 64; }
    if (mi <= 15) { return 38; }
    return 12;
  }

  if (mi <= 5) { return 45; }
  if (mi <= 15) { return 62; }
  if (mi <= 35) { return 70; }
  if (mi <= 70) { return 54; }
  return 28;
}

function slxRouteRelevanceBonus(c) {
  var p;
  var d;

  if (!routeGeo || !c || !c.coord || c.coord.length !== 2) { return 0; }

  p = nearestRouteProjectionFromPoint(Number(c.coord[0]), Number(c.coord[1]));
  if (!p || !isFiniteNumber(Number(p.distMiles))) { return 0; }

  d = Number(p.distMiles);

  if (d <= 0.25) { return 44; }
  if (d <= 0.75) { return 32; }
  if (d <= 1.5) { return 18; }
  if (d <= 3) { return 8; }

  return -8;
}

function slxTagScanCandidate(c, mode, originFix) {
  var txt;
  var d;

  if (!c) { return c; }

  txt = String((c.label || "") + " " + (c.name || "") + " " + (c.type || "")).toLowerCase();

  if (!c.markerLabel) {
    c.markerLabel = slxTruckFriendlyLabel(txt, c.type);
  }

  if (mode) { c.scanMode = mode; }

  if (originFix && c.coord && c.coord.length === 2) {
    d = milesBetween([Number(originFix.lng), Number(originFix.lat)], [Number(c.coord[0]), Number(c.coord[1])]);
    if (isFiniteNumber(d)) { c.distMiles = d; }
  }

  c.retailUseful = slxRetailParkingPriority(txt) > 0;
  c.truckFriendly = !!(c.truckFriendly || slxIsTruckFriendlyStopText(txt));

  c.scanScore =
    Number(c.confidence || 0) +
    slxScanStopCategoryWeight(c) +
    slxDistanceScore(Number(c.distMiles || 0), mode) +
    slxRouteRelevanceBonus(c) +
    (c.truckFriendly ? 36 : 0) +
    slxRetailParkingPriority(txt);

  if (mode === "nearby") { c.scanScore += 28; }
  if (mode === "ahead") { c.scanScore += 12; }

  return c;
}

function slxMergeScanStopLists(lists, originFix) {
  var out = [];
  var seen = {};
  var i, j, list, c, key, existing, k;

  for (i = 0; i < lists.length; i++) {
    list = lists[i] || [];

    for (j = 0; j < list.length; j++) {
      c = list[j];
      if (!c || !c.coord || c.coord.length !== 2) { continue; }

      key = String(Number(c.coord[0]).toFixed(4)) + "," + String(Number(c.coord[1]).toFixed(4));

      if (seen[key] !== undefined) {
        existing = out[seen[key]];
        if (Number(c.scanScore || c.confidence || 0) > Number(existing.scanScore || existing.confidence || 0)) {
          for (k in c) {
            if (c.hasOwnProperty(k)) { existing[k] = c[k]; }
          }
        }
        continue;
      }

      seen[key] = out.length;
      out.push(c);
    }
  }

  out.sort(function (a, b) {
    var as = Number(a.scanScore || a.confidence || 0);
    var bs = Number(b.scanScore || b.confidence || 0);
    var ad = isFiniteNumber(Number(a.distMiles)) ? Number(a.distMiles) : 9999;
    var bd = isFiniteNumber(Number(b.distMiles)) ? Number(b.distMiles) : 9999;

    if (bs !== as) { return bs - as; }
    return ad - bd;
  });

  return out;
}

function slxBuildPlacesUrl(lng, lat, radiusMeters, categories, key) {
  return "https://api.geoapify.com/v2/places?categories=" +
    encodeURIComponent(categories) +
    "&filter=circle:" + encodeURIComponent(String(lng) + "," + String(lat) + "," + String(radiusMeters)) +
    "&bias=proximity:" + encodeURIComponent(String(lng) + "," + String(lat)) +
    "&limit=50&apiKey=" + encodeURIComponent(key);
}

function slxFetchStopUrl(url, originFix, mode, done) {
  fetch(url).then(function (r) {
    return r.json();
  }).then(function (data) {
    var rows = normalizeStopRowsFromGeoapify(data, originFix);
    var i;

    for (i = 0; i < rows.length; i++) {
      slxTagScanCandidate(rows[i], mode, originFix);
    }

    done(rows);
  }).catch(function () {
    done([]);
  });
}

function slxRouteAheadScanPoints(fix) {
  var out = [];
  var coords = getRouteCoords();
  var p;
  var meters = [3000, 9000, 18000, 32000, 52000];
  var i;
  var c;

  if (!fix) { return out; }

  if (!routeGeo || !coords || coords.length < 2) { return out; }

  p = nearestRouteProjectionFromPoint(Number(fix.lng), Number(fix.lat));
  if (!p || !p.coord) { return out; }

  for (i = 0; i < meters.length; i++) {
    c = coordAtDistanceAlongRoute(p.index, p.coord, meters[i]);
    if (c && c.length === 2) {
      out.push({ lng: Number(c[0]), lat: Number(c[1]), metersAhead: meters[i] });
    }
  }

  return out;
}

function slxRunNearbyAndAheadStopScan(f, key, done) {
  var cats = slxNearbyAndAheadCategories();
  var jobs = [];
  var results = [];
  var pending = 0;
  var ahead = slxRouteAheadScanPoints(f);
  var i;

  function addJob(lng, lat, radius, mode) {
    jobs.push({
      url: slxBuildPlacesUrl(lng, lat, radius, cats, key),
      origin: { lng: lng, lat: lat },
      mode: mode
    });
  }

  /*
    Bucket 1: useful right now.
    3-8 mile radius plus a slightly wider rescue radius. This is where
    the nearby Walmart / retail parking / rest / fuel options should show.
  */
  addJob(Number(f.lng), Number(f.lat), 9000, "nearby");
  addJob(Number(f.lng), Number(f.lat), 16000, "nearby");

  /*
    Bucket 2: useful ahead.
    Sample forward along the active corridor so parking/fuel/rest windows
    appear before the driver is boxed in.
  */
  for (i = 0; i < ahead.length; i++) {
    addJob(Number(ahead[i].lng), Number(ahead[i].lat), 6500, "ahead");
  }

  pending = jobs.length;

  function finishOne(rows) {
    results.push(rows || []);
    pending = pending - 1;

    if (pending <= 0) {
      done(slxMergeScanStopLists(results, f));
    }
  }

  for (i = 0; i < jobs.length; i++) {
    slxFetchStopUrl(jobs[i].url, jobs[i].origin, jobs[i].mode, finishOne);
  }
}

function scanStopsGeoapify(forceVoice) {
  var f = getScanFix();
  var key = String(window.SLX_GEOAPIFY_KEY || geoapifyKey || "");

  if (!f) {
    setSubline("GPS fix missing");
    if (forceVoice) { primeVoiceThenSpeak("GPS fix missing"); }
    return;
  }

  if (!key) {
    setSubline("Geoapify key missing");
    if (forceVoice) { primeVoiceThenSpeak("Geoapify key missing"); }
    return;
  }

  setSubline("Scanning useful stops nearby and ahead...");
  if (forceVoice && nowMs() - lastScanVoiceAt > 2500) {
    lastScanVoiceAt = nowMs();
    primeVoiceThenSpeak("Scanning truck parking, rest areas, fuel, and useful nearby stops.");
  }

  slxRunNearbyAndAheadStopScan(f, key, function (out) {
    var top;

    if (out && out.length) {
      top = out.slice(0, 16);

      applyStopCandidates(top, "geoapify-nearby-ahead", false);

      setSubline("Stops surfaced nearby and ahead: " + String(top[0].label || "nearby"));
      if (forceVoice) { slxAnnounceScanStops(top, "geoapify-nearby-ahead", false); }

      forceCockpitFollowLock();
      return;
    }

    scanStopsMapboxFallback(forceVoice);
  });
}

function scanStopsMapboxFallback(forceVoice) {
  var out = collectVisibleParkingPois();

  if (out.length) {
    applyStopCandidates(out.slice(0, 12), "mapbox", false);
    setSubline("Stops surfaced: " + String(out[0].label || "nearby"));
    if (forceVoice) { slxAnnounceScanStops(out.slice(0, 12), "mapbox", false); }
  } else {
    applyStopCandidates([], "mapbox-empty", true);
    if (lastGoodStopList.length) {
      setSubline("Using last stop scan");
      if (forceVoice) { slxAnnounceScanStops(lastGoodStopList.slice(0, 12), "cached", false); }
    } else if (window.stopIntentState && window.stopIntentState.visibleCandidates && window.stopIntentState.visibleCandidates.length) {
      setSubline("Using visible stop pins");
      if (forceVoice) { slxAnnounceScanStops(window.stopIntentState.visibleCandidates.slice(0, 12), "visible", false); }
    } else {
      setSubline("Still scanning for stops");
      if (forceVoice) { slxAnnounceScanStops([], "empty", true); }
    }
  }
}

window.scanStopsTick = function () { slxStartScanStopsFlow(); scanStopsGeoapify(true); };
window.scanVisibleParkingNow = function (forceVoice) { if (forceVoice) { slxStartScanStopsFlow(); } scanStopsGeoapify(!!forceVoice); };
window.slxRunHardScan = function () { slxStartScanStopsFlow(); scanStopsGeoapify(true); };

/* ------------------------------------------------------------------------
   STOP POPUP / ADD STOP
------------------------------------------------------------------------ */

function closeStopPopup() {
  try { if (stopPopup) { stopPopup.remove(); } } catch (e) {}
  stopPopup = null;
}

function saveStopAndKeepDestination(lng, lat, name) {
  var stop, dest, routeGeoRaw;

  stop = { name: String(name || "Route stop"), label: String(name || "Route stop"), lng: Number(lng), lat: Number(lat), at: nowMs(), source: "driver_dashboard_stop_pin" };

  try { dest = JSON.parse(localStorage.getItem("slx_main_dest_v2") || "null"); } catch (e) { dest = null; }
  try { routeGeoRaw = JSON.parse(localStorage.getItem("slx_route_geo_v2") || "null"); } catch (e2) { routeGeoRaw = null; }

  try {
    localStorage.setItem("slx_stops_v1", JSON.stringify([stop]));
    localStorage.setItem("slx_pending_stop_v1", JSON.stringify(stop));
    localStorage.setItem("slx_driver_added_stop_v1", JSON.stringify(stop));

    if (dest) {
      localStorage.setItem("slx_main_dest_v2", JSON.stringify(dest));
      localStorage.setItem("slx_final_dest_v1", JSON.stringify(dest));
    }

    if (routeGeoRaw) { localStorage.setItem("slx_route_before_stop_v1", JSON.stringify(routeGeoRaw)); }
  } catch (e3) {}

  return stop;
}

function goStartTripForStop(stop) {
  window.location.href = START_TRIP_URL +
    "?addStop=1&stopLat=" + encodeURIComponent(String(stop.lat)) +
    "&stopLng=" + encodeURIComponent(String(stop.lng)) +
    "&stopName=" + encodeURIComponent(String(stop.name || "Route stop"));
}

function showStopPopup(feature) {
  var coord, p, name, dist, typeLabel, html, f;

  if (!map || !feature || !feature.geometry || !feature.geometry.coordinates) { return; }

  coord = feature.geometry.coordinates;
  p = feature.properties || {};
  name = String(p.name || p.title || p.label || "Route stop");
  typeLabel = String(p.stopType || p.type || p.label || "Route stop");
  f = getScanFix();
  dist = f ? milesBetween([Number(f.lng), Number(f.lat)], [Number(coord[0]), Number(coord[1])]) : Number(p.distMiles || 0);

  closeStopPopup();

  html = '<div style="font-size:13px;line-height:1.25;max-width:260px;color:#061017;pointer-events:auto;">' +
    '<div style="font-weight:950;font-size:15px;margin-bottom:6px;">' + esc(name) + (isFiniteNumber(dist) ? " • " + esc(fmtMiles(dist)) : "") + '</div>' +
    '<div style="opacity:.82;margin-bottom:10px;">' + esc(typeLabel) + ' • Add this as a stop and keep your final destination locked.</div>' +
    '<button type="button" data-slx-scan-add-stop="1" data-lng="' + esc(coord[0]) + '" data-lat="' + esc(coord[1]) + '" data-name="' + esc(name) + '" style="width:100%;min-height:42px;border-radius:13px;border:2px solid rgba(0,140,80,.70);background:rgba(0,190,105,.16);color:#061017;font-weight:950;pointer-events:auto;touch-action:manipulation;cursor:pointer;position:relative;z-index:999999;">ADD STOP</button>' +
    '</div>';

  try {
    stopPopup = new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: false,
      maxWidth: "280px"
    })
    .setLngLat([Number(coord[0]), Number(coord[1])])
    .setHTML(html)
    .addTo(map);
  } catch (e) {}
}

function bindStopClickLayer() {
  function handle(e) {
    if (!e || !e.features || !e.features.length) { return; }
    showStopPopup(e.features[0]);
  }

  if (!map || !map.getLayer) { return; }

  try { if (map.getLayer("slx-stop-hit") && !map.__slxStopHitBound) { map.__slxStopHitBound = true; map.on("click", "slx-stop-hit", handle); } } catch (e0) {}
  try { if (map.getLayer("slx-stop-core") && !map.__slxStopCoreBound) { map.__slxStopCoreBound = true; map.on("click", "slx-stop-core", handle); } } catch (e1) {}
  try { if (map.getLayer("slx-stop-text") && !map.__slxStopTextBound) { map.__slxStopTextBound = true; map.on("click", "slx-stop-text", handle); } } catch (e2) {}
}

function installAddStopHandler() {
  if (window.__SLX_ADD_STOP_HANDLER_READY_TO_RIDE__) { return; }
  window.__SLX_ADD_STOP_HANDLER_READY_TO_RIDE__ = true;

  document.addEventListener("click", function (e) {
    var t = e.target;
    var lng, lat, name, stop, rebuilt;

    while (t && t !== document) {
      if (t.getAttribute && t.getAttribute("data-slx-scan-add-stop")) {
        if (e && e.preventDefault) { e.preventDefault(); }
        if (e && e.stopPropagation) { e.stopPropagation(); }
        if (e && e.stopImmediatePropagation) { e.stopImmediatePropagation(); }

        lng = Number(t.getAttribute("data-lng"));
        lat = Number(t.getAttribute("data-lat"));
        name = String(t.getAttribute("data-name") || "Route stop");

        if (isFinite(lng) && isFinite(lat)) {
          stop = saveStopAndKeepDestination(lng, lat, name);
          closeStopPopup();

          rebuilt = false;

          try {
            if (window.slxRebuildRouteWithStop) {
              rebuilt = !!window.slxRebuildRouteWithStop(stop);
            }
          } catch (e1) {}

          if (rebuilt) {
            primeVoiceThenSpeak("Stop added to your route.");
          } else {
            primeVoiceThenSpeak("Stop saved. Route update is ready.");
          }

          try {
            if (window.toast) { window.toast(rebuilt ? "Stop added to route" : "Stop saved"); }
          } catch (e2) {}
        }

        return false;
      }

      t = t.parentNode;
    }
  }, true);
}

/* ------------------------------------------------------------------------
   MANEUVER VOICE — CLEAN / ARRIVAL-AWARE / NO SPAM
------------------------------------------------------------------------ */

function getStepInstruction(step) {
  var type, modifier, road, phrase, inst;

  if (!step) { return "Continue on route"; }
  if (step.maneuver && step.maneuver.instruction) { return String(step.maneuver.instruction); }
  if (step.instruction) { return String(step.instruction); }
  if (step.voiceInstruction) { return String(step.voiceInstruction); }
  if (step.bannerInstruction && step.bannerInstruction.primary && step.bannerInstruction.primary.text) { return String(step.bannerInstruction.primary.text); }

  type = step.maneuver && step.maneuver.type ? String(step.maneuver.type) : String(step.type || "continue");
  modifier = step.maneuver && step.maneuver.modifier ? String(step.maneuver.modifier) : String(step.modifier || "");
  road = step.name ? String(step.name) : String(step.road || "");
  phrase = "Continue";

  if (type === "turn") { phrase = "Turn"; }
  else if (type === "merge") { phrase = "Merge"; }
  else if (type === "fork") { phrase = "Keep"; }
  else if (type === "off ramp" || type === "exit") { phrase = "Take the exit"; }
  else if (type === "roundabout") { phrase = "Enter the roundabout"; }
  else if (type === "arrive" || type === "arrival") { phrase = "Arrive at destination"; }

  if (modifier) { phrase += " " + modifier; }
  if (road) { phrase += " onto " + road; }

  inst = phrase.replace(/\s+/g, " ");
  return inst;
}

function distanceMilesToCoord(coord) {
  if (!coord || !currentFix) { return null; }
  return milesBetween([currentFix.lng, currentFix.lat], [coord[0], coord[1]]);
}

function resetManeuverState() {
  maneuverSteps = [];
  maneuverIndex = 0;
  maneuverLastSpokenIndex = -1;
  maneuverLastDistanceBucket = "";
}

function loadRouteStepsFromStorage() {
  var keys = ["slx_route_steps_v2", "slx_maneuver_steps_v1", "slx_route_steps_v1", "slx_trip_steps_v1", "slx_nav_steps_v1"];
  var i, raw, parsed;

  for (i = 0; i < keys.length; i++) {
    raw = lsGet(keys[i]);
    parsed = raw ? safeParse(raw) : null;
    if (parsed && parsed.length) { return parsed; }
  }

  return [];
}

function buildManeuverSteps() {
  var i, step, loc, instruction, lower;

  resetManeuverState();
  maneuverLastBuildAt = nowMs();

  if (!routeSteps || !routeSteps.length) { routeSteps = loadRouteStepsFromStorage(); }

  if (routeSteps && routeSteps.length) {
    for (i = 0; i < routeSteps.length; i++) {
      step = routeSteps[i];
      loc = getRouteStepLocation(step);
      if (!loc) { continue; }

      instruction = getStepInstruction(step);
      lower = String(instruction || "").toLowerCase();

      if (
        lower.indexOf("continue") > -1 &&
        lower.indexOf("onto") < 0 &&
        lower.indexOf("exit") < 0 &&
        lower.indexOf("turn") < 0 &&
        lower.indexOf("merge") < 0 &&
        lower.indexOf("keep") < 0 &&
        lower.indexOf("arrive") < 0
      ) { continue; }

      maneuverSteps.push({
        coord: loc,
        instruction: instruction,
        announceLabel: instruction,
        originalIndex: i
      });
    }
  }
}

function slxGetSafeTurnCall(step) {
  var label = String(step && step.announceLabel || "");
  var lower = label.toLowerCase();

  if (!label) { return "Continue on route"; }

  if (lower.indexOf("arrive") > -1 || lower.indexOf("destination") > -1) {
    return "Facility approach coming up";
  }

  if (lower.indexOf("exit") > -1 || lower.indexOf("off ramp") > -1) {
    return "Exit ahead";
  }

  if (lower.indexOf("merge") > -1) {
    return "Merge ahead";
  }

  if (lower.indexOf("keep left") > -1) {
    return "Keep left ahead";
  }

  if (lower.indexOf("keep right") > -1) {
    return "Keep right ahead";
  }

  if (lower.indexOf("left") > -1) {
    return "Turn left ahead";
  }

  if (lower.indexOf("right") > -1) {
    return "Turn right ahead";
  }

  if (lower.indexOf("continue") > -1 && lower.indexOf("onto") < 0) {
    return "Continue straight";
  }

  return label;
}

function maybeRebuildManeuvers() {
  if (maneuverSteps.length) { return; }
  if (nowMs() - maneuverLastBuildAt < 3000) { return; }
  buildManeuverSteps();
}

function maneuverBucket(dist) {
  if (!isFiniteNumber(dist)) { return ""; }
  if (dist < 0.07) { return "NOW"; }
  if (dist < 0.28) { return "QUARTER"; }
  if (dist < 0.55) { return "HALF"; }
  if (dist < 1.05) { return "ONE"; }
  if (dist < 2.05) { return "TWO"; }
  return "";
}

function advancePastBehindManeuvers() {
  var step, miles;

  while (maneuverIndex < maneuverSteps.length) {
    step = maneuverSteps[maneuverIndex];
    miles = distanceMilesToCoord(step.coord);

    if (!isFiniteNumber(miles)) { return; }

    if (miles < 0.035) {
      maneuverIndex = maneuverIndex + 1;
      maneuverLastDistanceBucket = "";
      continue;
    }

    return;
  }
}

function maybeSpeakNextManeuver() {
  var step, dist, bucket, call;

  if (!tripStarted || !routeGeo || !currentFix) { return; }

  maybeRebuildManeuvers();
  advancePastBehindManeuvers();

  if (!maneuverSteps || !maneuverSteps.length) { return; }
  if (maneuverIndex >= maneuverSteps.length) { return; }

  step = maneuverSteps[maneuverIndex];
  dist = distanceMilesToCoord(step.coord);

  if (!isFiniteNumber(dist)) { return; }
  if (dist > 1.05) { return; }

  bucket = maneuverBucket(dist);
  if (!bucket) { return; }

  if (maneuverLastSpokenIndex === maneuverIndex && maneuverLastDistanceBucket === bucket) { return; }

  call = slxGetSafeTurnCall(step);

  if (bucket === "ONE") {
    call = call + " in about one mile";
  } else if (bucket === "HALF") {
    call = call + " in about half a mile";
  } else if (bucket === "QUARTER") {
    call = call + " in about a quarter mile";
  } else if (bucket === "NOW") {
    call = call.replace(" ahead", "");
    call = call + " now";
  }

  maneuverLastSpokenIndex = maneuverIndex;
  maneuverLastDistanceBucket = bucket;

  primeVoiceThenSpeak(call);
}

function maybeSpeakArrival() {
  var miles = distanceToDestinationMiles();

  if (arrivalVoiceAnnounced || !tripStarted || !routeGeo || !currentFix) { return; }

  if (isFiniteNumber(miles) && miles < 1.5 && miles >= 0.8) {
    arrivalVoiceAnnounced = true;
    primeVoiceThenSpeak("Facility approach coming up. Start watching for truck entrance and yard access.");
    return;
  }

  if (isFiniteNumber(miles) && miles < 0.8) {
    arrivalVoiceAnnounced = true;
    primeVoiceThenSpeak("Approaching destination. Watch for receiving access, guard shack, or dock entrance.");
  }
}

function maybeSpeakOffRoute() {
  if (!tripStarted) { return; }

  if (offRouteState.isOffRoute) {
    if (!offRouteVoiceAnnounced && nowMs() - offRouteState.since > 5500) {
      offRouteVoiceAnnounced = true;
      primeVoiceThenSpeak(slxTrustDepartureDriftMessage());
    }
  } else {
    offRouteVoiceAnnounced = false;
  }
}

function maybeSpeakBraking() {
  if (!tripStarted || brakeState.level !== "high") { return; }
  if (nowMs() - brakeState.lastVoiceAt < 300000) { return; }

  brakeState.lastVoiceAt = nowMs();
  primeVoiceThenSpeak("Downgrade braking ahead. Ease into it early.");
}

/* ------------------------------------------------------------------------
GPS — STABLE START / NO SIDE PAN / ROUTE-FIRST LOCK
------------------------------------------------------------------------ */

function acceptFix(pos) {
var c = pos.coords || {};
var speedVal, headingVal, nextFix, headingConf, routeBearing;
var blend, mph, target, snapped;
var firstTripLock;
var accuracyMeters = isFiniteNumber(c.accuracy) ? Number(c.accuracy) : 9999;

/*
STARTUP GPS AUTHORITY V4:
Do not establish the rendered pin or camera from a weak first fix.
A later accurate watchPosition result will seed the cockpit instantly.
*/
if ((!motionState.hasInitialGpsLock || !currentFix) && accuracyMeters > 65) {
  setSubline("Acquiring precise GPS");
  return;
}

speedVal = isFiniteNumber(c.speed) ? Number(c.speed) : 0;
mph = speedVal * 2.23693629;

headingVal = isFiniteNumber(c.heading) ? Number(c.heading) : lastRawHeading;

rawFix = {
lat: Number(c.latitude),
lng: Number(c.longitude),
heading: headingVal,
speed: speedVal
};

nextFix = {
lat: rawFix.lat,
lng: rawFix.lng,
heading: headingVal,
speed: speedVal
};

headingConf = getHeadingConfidence(speedVal, c.heading);
motionState.headingConfidence = headingConf;

/*
IMPORTANT:
At trip start, route bearing wins immediately.
Prevents sideways neighborhood pan.
*/
if (routeGeo) {
routeBearing = getStableRouteBearing();

if (
mph < 22 ||
!isFiniteNumber(c.heading) ||
headingConf < 0.55
) {
nextFix.heading = routeBearing;
} else {
nextFix.heading = blendAngle(
routeBearing,
headingVal,
0.16 + (0.22 * headingConf)
);
}
}

lastRawHeading = nextFix.heading;

/*
FIRST FIX:
Snap instantly instead of easing from old location.
This prevents giant side-pan on startup.
*/
firstTripLock =
!currentFix ||
!motionState.hasInitialGpsLock;

if (firstTripLock) {

currentFix = {
lat: nextFix.lat,
lng: nextFix.lng,
heading: nextFix.heading,
speed: nextFix.speed
};

motionState.hasInitialGpsLock = true;

} else {

blend = mph < 4 ? 0.34 : 0.52;

currentFix.lat = lerp(currentFix.lat, nextFix.lat, blend);
currentFix.lng = lerp(currentFix.lng, nextFix.lng, blend);

currentFix.heading = blendAngle(
currentFix.heading,
nextFix.heading,
mph < 18
? 0.16
: (0.22 + (0.18 * headingConf))
);

currentFix.speed = lerp(
currentFix.speed,
nextFix.speed,
0.42
);
}

updateOffRouteState();

/*
STARTUP PIN AUTHORITY V4:
The first accepted fix seeds the pin at the live coordinate.
Do not route-snap, forward-project, or glide from an old neighborhood.
Normal snapping begins only after startup position is established.
*/
if (firstTripLock) {
  snapped = {
    lat: Number(currentFix.lat),
    lng: Number(currentFix.lng),
    heading: Number(currentFix.heading || 0)
  };

  visualState.active = true;
  visualState.lat = snapped.lat;
  visualState.lng = snapped.lng;
  visualState.targetLat = snapped.lat;
  visualState.targetLng = snapped.lng;
  visualState.bearing = snapped.heading;
  visualState.targetBearing = snapped.heading;
  visualState.lastFrameAt = nowMs();
  visualState.lastTargetAt = nowMs();

  routeTargetFix = {
    lat: snapped.lat,
    lng: snapped.lng,
    heading: snapped.heading,
    speed: currentFix.speed || 0
  };
} else {
  target = calculateSnappedTargetFromFix(currentFix);
  if (target) {
    setVisualTarget(target);
  }
}

exposeCoreBridge();

if (!gpsVoiceAnnounced && currentFix) {
gpsVoiceAnnounced = true;

window.setTimeout(function () {
primeVoiceThenSpeak("GPS locked");
}, 600);
}

motionState.lastAcceptedAt = nowMs();

updateFuelPredictor();
maybeFetchWind();
updateSpeedLimitState();
updateGradeAndBrakeState();
updateTrafficDensityPrediction();
updateParkingPressureState();
maybeSpeakParkingPressure();
updateTruckMarker();

/*
FOLLOW LOCK:
Driver mode should immediately lock to route.
*/
if (tripStarted && !overviewMode && !userInteracting) {
followLock = true;
}

/*
IMPORTANT:
First lock forces instant camera placement.
No slow pan across neighborhood.
*/
followCamera(firstTripLock);

updateHorizon();

maybeSpeakArrival();
maybeSpeakOffRoute();
maybeSpeakBraking();
maybeSpeakNextManeuver();
try { slxNavV2Tick(); } catch(eNavV2) {}
}

function startGPS() {

if (!navigator.geolocation) {
setSubline("GPS unavailable");
return;
}

function onGood(pos) {

try {

acceptFix(pos);

setSubline(
routeGeo
? "Navigation active"
: "GPS locked"
);

try {
if (map && map.resize) {
map.resize();
}
} catch (e1) {}

try {
if (map && map.triggerRepaint) {
map.triggerRepaint();
}
} catch (e2) {}

try {
updateTruckMarker();
} catch (e3) {}

/*
Camera authority is handled inside acceptFix.
Do not hard-center again on every watchPosition callback.
*/
try {
if (!motionState.hasInitialCameraLock) {
  followCamera(true);
  motionState.hasInitialCameraLock = true;
}
} catch (e4) {}

} catch (e) {

setSubline("GPS fix error");

}
}

function onBad(err) {

var code = err && err.code
? Number(err.code)
: 0;

if (code === 1) {
setSubline("GPS blocked - allow location");
}
else if (code === 2) {
setSubline("GPS position unavailable");
}
else if (code === 3) {
setSubline("GPS timeout - retrying");
}
else {
setSubline("GPS waiting");
}
}

try {
if (gpsWatchId !== null) {
navigator.geolocation.clearWatch(gpsWatchId);
}
} catch (e0) {}

navigator.geolocation.getCurrentPosition(
onGood,
onBad,
{
enableHighAccuracy: true,
maximumAge: 0,
timeout: 20000
}
);

gpsWatchId = navigator.geolocation.watchPosition(
onGood,
onBad,
{
enableHighAccuracy: true,
maximumAge: 2000,
timeout: 20000
}
);
}

/* ------------------------------------------------------------------------
ROUTE SYNC — FORWARD STOP INSERT + SHARED LIVE GPS
------------------------------------------------------------------------ */

function syncRoute() {
var raw = lsGet(LS.ROUTE);
var destRaw = lsGet(LS.DEST);
var stepsRaw = lsGet("slx_route_steps_v2") || lsGet("slx_maneuver_steps_v1") || lsGet("slx_route_steps_v1") || lsGet("slx_trip_steps_v1") || lsGet("slx_nav_steps_v1");
var tripRaw = lsGet(LS.TRIP);
var parsed, parsedDest, parsedSteps, target;

if (raw === lastRouteRaw && destRaw === lastDestRaw && stepsRaw === lastStepsRaw && tripRaw === lastTripRaw) { return; }

lastRouteRaw = raw;
lastDestRaw = destRaw;
lastStepsRaw = stepsRaw;
lastTripRaw = tripRaw;
tripStarted = String(tripRaw || "") === "1";
slxTrustSyncTripState(tripStarted);

if (!raw) {
routeGeo = null;
routeDest = null;
routeSteps = [];
resetManeuverState();
drawRoute();
updateHorizon();
exposeCoreBridge();
return;
}

parsed = safeParse(raw);
parsedDest = destRaw ? safeParse(destRaw) : null;
parsedSteps = stepsRaw ? safeParse(stepsRaw) : null;

routeGeo = parsed;
routeDest = parsedDest;
routeSteps = parsedSteps && parsedSteps.length ? parsedSteps : loadRouteStepsFromStorage();

arrivalVoiceAnnounced = false;
motionState.lastProjectionIndex = 0;

if (currentFix) {
target = calculateSnappedTargetFromFix(currentFix);
if (target) { setVisualTarget(target); }
}

buildManeuverSteps();
drawRoute();
updateFuelPredictor();
updateSpeedLimitState();
updateParkingPressureState();
updateHorizon();
exposeCoreBridge();

if (tripStarted) { forceCockpitFollowLock(); }
}

function slxSaveLiveGPSForStartTrip() {
var f = currentFix || rawFix || routeTargetFix;

if (!f) { return; }

try {
var payload = {
lat: Number(f.lat),
lng: Number(f.lng),
heading: isFiniteNumber(Number(f.heading)) ? Number(f.heading) : 0,
speed: isFiniteNumber(Number(f.speed)) ? Number(f.speed) : 0,
ts: nowMs(),
source: "driver_mode"
};

if (!isFiniteNumber(payload.lat) || !isFiniteNumber(payload.lng)) { return; }

lsSet("slx_live_gps_v1", JSON.stringify(payload));
lsSet("slx_last_gps_v1", JSON.stringify(payload));
lsSet("slx_driver_live_fix_v1", JSON.stringify(payload));
} catch (e) {}
}

function slxGetFreshSharedGPS(maxAgeMs) {
var keys = ["slx_live_gps_v1", "slx_driver_live_fix_v1", "slx_last_gps_v1"];
var i, raw, p, age;

for (i = 0; i < keys.length; i++) {
raw = lsGet(keys[i]);
p = raw ? safeParse(raw) : null;

if (!p) { continue; }

age = nowMs() - Number(p.ts || 0);

if (
isFiniteNumber(Number(p.lat)) &&
isFiniteNumber(Number(p.lng)) &&
age >= 0 &&
age <= Number(maxAgeMs || 45000)
) {
return {
lat: Number(p.lat),
lng: Number(p.lng),
heading: isFiniteNumber(Number(p.heading)) ? Number(p.heading) : 0,
speed: isFiniteNumber(Number(p.speed)) ? Number(p.speed) : 0,
ts: Number(p.ts || nowMs()),
source: String(p.source || "shared_gps")
};
}
}

return null;
}

function slxGetForwardRouteOrigin() {
var f, proj, ahead, bearing;

f = currentFix || slxGetFreshSharedGPS(60000) || rawFix || routeTargetFix;

if (!f) { return null; }

if (routeGeo && typeof nearestRouteProjectionFromPoint === "function") {
proj = nearestRouteProjectionFromPoint(Number(f.lng), Number(f.lat));

if (proj && proj.coord && proj.coord.length === 2 && isFiniteNumber(proj.distMiles) && proj.distMiles < 0.35) {
ahead = coordAtDistanceAlongRoute(proj.index, proj.coord, 22);

if (ahead && ahead.length === 2) {
bearing = stableRouteBearing ? stableRouteBearing() : Number(f.heading || 0);

return {
lat: Number(ahead[1]),
lng: Number(ahead[0]),
heading: normalizeAngle(bearing || 0),
source: "forward_route_projection"
};
}

return {
lat: Number(proj.coord[1]),
lng: Number(proj.coord[0]),
heading: Number(f.heading || 0),
source: "route_projection"
};
}
}

return {
lat: Number(f.lat),
lng: Number(f.lng),
heading: Number(f.heading || 0),
source: "live_gps"
};
}

function slxValidStopForRoute(from, stop, dest) {
var dFrom, dDest;

if (!from || !stop || !dest) { return false; }
if (!isFiniteNumber(Number(from.lat)) || !isFiniteNumber(Number(from.lng))) { return false; }
if (!isFiniteNumber(Number(stop.lat)) || !isFiniteNumber(Number(stop.lng))) { return false; }
if (!isFiniteNumber(Number(dest.lat)) || !isFiniteNumber(Number(dest.lng))) { return false; }

dFrom = milesBetween([Number(from.lng), Number(from.lat)], [Number(stop.lng), Number(stop.lat)]);
dDest = milesBetween([Number(dest.lng), Number(dest.lat)], [Number(stop.lng), Number(stop.lat)]);

if (isFiniteNumber(dFrom) && dFrom < 0.12) {
try { showToast("Stop is too close to add"); } catch(e0) {}
try { primeVoiceThenSpeak("That stop is too close to add."); } catch(e1) {}
return false;
}

if (isFiniteNumber(dDest) && dDest < 0.20) {
try { showToast("Stop is basically at destination"); } catch(e2) {}
return false;
}

return true;
}

function slxExtractGeoapifySteps(feature) {
var props, legs, steps, out, i, j, s;

out = [];

try {
props = feature && feature.properties ? feature.properties : {};
legs = props.legs || [];

for (i = 0; i < legs.length; i++) {
steps = legs[i] && legs[i].steps ? legs[i].steps : [];
for (j = 0; j < steps.length; j++) {
s = steps[j];
if (s) { out.push(s); }
}
}
} catch (e) {}

return out;
}

function slxRebuildRouteWithStop(stop) {
var from, dest, key, mode, waypoints, url, xhr, dFrom;

if (!stop) { return false; }

try {
slxSaveLiveGPSForStartTrip();

from = slxGetForwardRouteOrigin();

if (!from) { return false; }

dest = routeDest || safeParse(lsGet(LS.DEST));

if (!dest) { return false; }

key = window.SLX_GEOAPIFY_KEY || window.GEOAPIFY_KEY || "";
if (!key) { return false; }

if (!slxValidStopForRoute(from, stop, dest)) { return false; }

dFrom = milesBetween([from.lng, from.lat], [Number(stop.lng), Number(stop.lat)]);

mode = "truck";

/*
DRIVER MODE STOP INSERTION:
Use forward route projection, not raw GPS.
Ordered route:
forward corridor origin -> Stop 1 -> final destination
*/
waypoints =
String(from.lat) + "," + String(from.lng) + "|" +
String(Number(stop.lat)) + "," + String(Number(stop.lng)) + "|" +
String(Number(dest.lat)) + "," + String(Number(dest.lng));

url =
"https://api.geoapify.com/v1/routing?waypoints=" +
encodeURIComponent(waypoints) +
"&mode=" + encodeURIComponent(mode) +
"&details=route_details" +
"&apiKey=" + encodeURIComponent(key);

xhr = new XMLHttpRequest();
xhr.open("GET", url, true);

xhr.onreadystatechange = function () {
var data, feature, fc, newSteps;

if (xhr.readyState !== 4) { return; }

try {
if (xhr.status >= 200 && xhr.status < 300) {
data = JSON.parse(xhr.responseText || "{}");
feature = data.features && data.features[0] ? data.features[0] : null;

if (!feature) { return; }

fc = {
type: "FeatureCollection",
features: [feature]
};

newSteps = slxExtractGeoapifySteps(feature);

lsSet(LS.ROUTE, JSON.stringify(fc));
lsSet("slx_route_geo_v2", JSON.stringify(fc));
lsSet("slx_active_stop_v1", JSON.stringify(stop));
lsSet("slx_stops_v1", JSON.stringify([stop]));
lsSet("slx_route_has_stop_v1", "1");
lsSet("slx_route_origin_source_v1", String(from.source || "forward_route_projection"));

if (newSteps && newSteps.length) {
lsSet(LS.STEPS, JSON.stringify(newSteps));
lsSet("slx_route_steps_v1", JSON.stringify(newSteps));
lsSet("slx_route_steps_v2", JSON.stringify(newSteps));
}

routeGeo = fc;
routeDest = dest;
stop1 = stop;
if (newSteps && newSteps.length) { routeSteps = newSteps; }

resetManeuverState();
buildManeuverSteps();
drawRoute();
updateFuelPredictor();
updateSpeedLimitState();
updateParkingPressureState();
updateHorizon();
exposeCoreBridge();

try { updateTruckMarker(); } catch(e0) {}
try { followCamera(true); } catch(e1) {}

if (tripStarted) { forceCockpitFollowLock(); }

if (isFiniteNumber(dFrom) && dFrom < 1) {
primeVoiceThenSpeak("Quick stop added before your destination.");
} else {
primeVoiceThenSpeak("Stop added before your destination.");
}
}
} catch (e) {}
};

xhr.send(null);
return true;

} catch (e2) {}

return false;
}

window.slxRebuildRouteWithStop = slxRebuildRouteWithStop;
window.slxSaveLiveGPSForStartTrip = slxSaveLiveGPSForStartTrip;
window.slxGetFreshSharedGPS = slxGetFreshSharedGPS;

/* ------------------------------------------------------------------------
   BUTTONS / INTERACTION
------------------------------------------------------------------------ */

function setButtonActive(id, active) {
  var el = byId(id);
  if (!el) { return; }

  if (active) { el.style.boxShadow = "0 0 0 1px rgba(255,255,255,0.12), 0 0 22px rgba(0,255,140,0.22), 0 12px 28px rgba(0,0,0,0.44)"; }
  else { el.style.boxShadow = ""; }
}

function syncButtonStates() {
  setButtonActive("slxFollow", followLock && !overviewMode);
  setButtonActive("slxOverview", overviewMode);
  setButtonActive("slxAudio", speechEnabled);
  setButtonActive("slxFollowLock", followLock && !overviewMode);
}

function setMenuCollapsed(collapsed) {
  var rail = byId("slxRight");
  var menuBtn = byId("slxMenu");
  if (!rail) { return; }
  rail.setAttribute("data-collapsed", collapsed ? "true" : "false");
  if (menuBtn) { menuBtn.setAttribute("title", collapsed ? "Open Menu" : "Close Menu"); }
}

function wireButtons() {
  var menuBtn = byId("slxMenu");
  var backBtn = byId("slxBack");
  var audioBtn = byId("slxAudio");
  var zoomInBtn = byId("slxZoomIn");
  var zoomOutBtn = byId("slxZoomOut");
  var overviewBtn = byId("slxOverview");
  var followBtn = byId("slxFollow");
  var scanStopsBtn =
    byId("slxScanStops") ||
    byId("btnScanStops") ||
    byId("slxFindScans") ||
    byId("findScans") ||
    byId("slxFindStops") ||
    byId("btnFindStops") ||
    (document.querySelector ? document.querySelector("[data-slx-scan-stops],[data-action='scan-stops'],[data-scan-stops]") : null);
  var followLockBtn = byId("slxFollowLock");
  var endTripBtn = byId("slxEndTrip");

  if (buttonsWired) { return; }
  buttonsWired = true;

  if (menuBtn) {
    menuBtn.onclick = function () {
      var rail = byId("slxRight");
      var collapsed;
      if (!rail) { return; }
      collapsed = rail.getAttribute("data-collapsed") === "true";
      setMenuCollapsed(!collapsed);
    };
  }

  if (backBtn) {
    backBtn.onclick = function () {
      // V61 FLOW FIX: Back always returns directly to Start Drive.
      // Never use browser history here because the previous page may be the
      // retired End Drive / end-of-day page. Back does NOT end the active trip.
      try { window.location.replace(START_TRIP_URL); } catch (e) {
        window.location.href = START_TRIP_URL;
      }
      return false;
    };
  }

  if (audioBtn) {
    audioBtn.onclick = function () {
      speechEnabled = !speechEnabled;
      primeSpeechChannel();
      syncButtonStates();
      setSubline(speechEnabled ? "Voice guidance on" : "Voice guidance off");
      if (speechEnabled) { window.setTimeout(function () { primeVoiceThenSpeak("Voice guidance on"); }, 100); }
    };
  }

  if (zoomInBtn) {
    zoomInBtn.onclick = function () {
      holdUserCamera(FREE_FLOW_MS);
      if (map) { map.zoomIn({ duration: 180 }); }
      return false;
    };
  }

  if (zoomOutBtn) {
    zoomOutBtn.onclick = function () {
      holdUserCamera(FREE_FLOW_MS);
      if (map) { map.zoomOut({ duration: 180 }); }
      return false;
    };
  }

  if (overviewBtn) {
    overviewBtn.onclick = function () {
      if (!routeGeo) { return false; }
      overviewMode = true;
      followLock = false;
      userInteracting = true;
      userInteractionUntil = nowMs() + 60000;
      saveViewMode();
      syncGlobalState();
      fitRouteOverview();
      updateHorizon();
      syncButtonStates();
      setSubline("Route overview");
      return false;
    };
  }

  if (followBtn) {
    followBtn.onclick = function () {
      primeSpeechChannel();
      forceCockpitFollowLock();
      updateHorizon();
      syncButtonStates();
      setSubline("Follow lock active");
      primeVoiceThenSpeak("Follow lock active");
      return false;
    };
  }

  if (followLockBtn) {
    followLockBtn.onclick = function () {
      primeSpeechChannel();
      forceCockpitFollowLock();
      updateHorizon();
      syncButtonStates();
      setSubline("Follow lock active");
      primeVoiceThenSpeak("Follow lock active");
      return false;
    };
  }

  function runScanStopsButton(e) {
    if (e && e.preventDefault) { e.preventDefault(); }
    if (e && e.stopPropagation) { e.stopPropagation(); }

    /*
      V2F.1 SCAN STOPS RESTORE:
      The button may be rendered as slxScanStops, btnScanStops, or a future
      Find Scans/Find Stops control. Always run the same scanner pipeline.
    */
    try { primeSpeechChannel(); } catch (primeErr) {}
    try { holdUserCamera(26000); } catch (camErr) {}
    try { slxStartScanStopsFlow(); } catch (err0) {}

    try {
      if (typeof scanStopsGeoapify === "function") {
        scanStopsGeoapify(true);
        return false;
      }
    } catch (err1) {}

    try {
      if (typeof window.slxScanCorridorStops === "function") {
        window.slxScanCorridorStops();
        return false;
      }
    } catch (err2) {}

    try {
      if (typeof window.slxFallbackScanStopsV1 === "function") {
        window.slxFallbackScanStopsV1();
        return false;
      }
    } catch (err3) {}

    setSubline("Scan stops unavailable");
    return false;
  }

  if (scanStopsBtn) {
    scanStopsBtn.onclick = runScanStopsButton;
  }

  try {
    if (!window.__SLX_V2F1_FIND_SCANS_CAPTURE__) {
      window.__SLX_V2F1_FIND_SCANS_CAPTURE__ = true;
      document.addEventListener("click", function (evt) {
        var el = evt && evt.target ? evt.target : null;
        var txt = "";
        var id = "";
        var action = "";
        var n = 0;

        while (el && n < 5) {
          id = String(el.id || "");
          action = String(el.getAttribute ? (el.getAttribute("data-action") || el.getAttribute("data-slx-action") || "") : "");
          txt = String(el.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();

          if (
            id === "slxScanStops" ||
            id === "btnScanStops" ||
            id === "slxFindScans" ||
            id === "findScans" ||
            id === "slxFindStops" ||
            id === "btnFindStops" ||
            action === "scan-stops" ||
            action === "find-scans" ||
            txt === "find scans" ||
            txt === "scan stops" ||
            txt === "find stops"
          ) {
            runScanStopsButton(evt);
            return;
          }

          el = el.parentNode;
          n += 1;
        }
      }, true);
    }
  } catch (captureErr) {}

  if (endTripBtn) {
    endTripBtn.onclick = function () {
      // V61 FLOW FIX: End Trip performs real cleanup, then returns directly
      // to Start Drive. The old End Drive / end-of-day page is bypassed.
      try { primeSpeechChannel(); } catch (ePrime) {}

      tripStarted = false;
      slxTrustSyncTripState(false);
      overviewMode = false;
      followLock = true;
      userInteracting = false;
      userInteractionUntil = 0;
      hardFollowUntil = 0;
      followBoostUntil = 0;

      // Clear active-trip persistence so Start Drive opens as a clean new drive.
      lsSet(LS.TRIP, "0");
      try { localStorage.removeItem(LS.ROUTE); } catch (eRoute) {}
      try { localStorage.removeItem(LS.DEST); } catch (eDest) {}
      try { localStorage.removeItem(LS.STEPS); } catch (eSteps) {}

      routeGeo = null;
      routeDest = null;
      routeSteps = [];
      maneuverSteps = [];
      maneuverIndex = 0;

      // Stop active runtime work before leaving Drive Mode.
      try { if (routeSyncTimer) { clearInterval(routeSyncTimer); routeSyncTimer = null; } } catch (e0) {}
      try { if (hudTimer) { clearInterval(hudTimer); hudTimer = null; } } catch (e1) {}
      try { if (watchdogTimer) { clearInterval(watchdogTimer); watchdogTimer = null; } } catch (e2) {}
      try { if (cameraTimer) { clearInterval(cameraTimer); cameraTimer = null; } } catch (e3) {}
      try { if (scanTimer) { clearInterval(scanTimer); scanTimer = null; } } catch (e4) {}
      try { if (poiGlowTimer) { clearInterval(poiGlowTimer); poiGlowTimer = null; } } catch (e5) {}
      try { if (gpsWatchId !== null && navigator.geolocation) { navigator.geolocation.clearWatch(gpsWatchId); gpsWatchId = null; } } catch (e6) {}
      try { if (glideRaf) { cancelAnimationFrame(glideRaf); glideRaf = null; } } catch (e7) {}
      try { if (window.__SLX_FOUNDATION_FORCE_CANCEL__) { window.__SLX_FOUNDATION_FORCE_CANCEL__(); } } catch (e8) {}

      syncGlobalState();
      syncButtonStates();
      setSubline("Trip ended");

      // No End Drive page. Go straight back to Start Drive.
      try { window.location.replace(START_TRIP_URL); } catch (e9) {
        window.location.href = START_TRIP_URL;
      }
      return false;
    };
  }

  setMenuCollapsed(false);
  syncButtonStates();
}

function bindManualCameraFreedom() {
  /*
    V2F.1 FREE FLOW RESTORE:
    Mapbox gesture events are not always delivered with originalEvent on every
    WebView/device combo, so we bind both Mapbox gesture events and native
    canvas/container events. Programmatic camera moves still do not trigger
    this because native capture only fires from actual user input.
  */
  function releaseForUserGesture() {
    if (overviewMode) { return; }
    if (nowMs() < Number(cameraGestureGuardUntil || 0)) { return; }
    holdUserCamera(FREE_FLOW_MS);
  }

  function onMapInteract(e) {
    if (e && e.originalEvent) { releaseForUserGesture(); }
  }

  function bindNative(el) {
    var opts = { capture:true, passive:true };
    if (!el || el.__SLX_V2F1_FREE_FLOW_BOUND__) { return; }
    el.__SLX_V2F1_FREE_FLOW_BOUND__ = true;

    try { el.addEventListener("wheel", releaseForUserGesture, opts); } catch (a) {}
    try { el.addEventListener("touchstart", releaseForUserGesture, opts); } catch (b) {}
    try { el.addEventListener("touchmove", releaseForUserGesture, opts); } catch (c) {}
    try { el.addEventListener("pointerdown", releaseForUserGesture, opts); } catch (d) {}
    try { el.addEventListener("mousedown", releaseForUserGesture, opts); } catch (e) {}
    try { el.addEventListener("gesturestart", releaseForUserGesture, opts); } catch (f) {}
  }

  try { map.on("dragstart", onMapInteract); } catch (e0) {}
  try { map.on("zoomstart", onMapInteract); } catch (e1) {}
  try { map.on("rotatestart", onMapInteract); } catch (e2) {}
  try { map.on("pitchstart", onMapInteract); } catch (e3) {}
  try { map.on("touchstart", onMapInteract); } catch (e4) {}
  try { map.on("mousedown", onMapInteract); } catch (e5) {}
  try { map.on("wheel", onMapInteract); } catch (e6) {}

  try { bindNative(map && map.getCanvas ? map.getCanvas() : null); } catch (n1) {}
  try { bindNative(map && map.getContainer ? map.getContainer() : null); } catch (n2) {}
  try { bindNative(byId("slxMap") || byId("map") || byId("slxMapHost")); } catch (n3) {}
}

/* ------------------------------------------------------------------------
   ENVIRONMENT / STYLES
------------------------------------------------------------------------ */

function enable3DEnvironment() {
  if (!map || !mapLoaded) { return; }
  try {
    if (!map.getSource("mapbox-dem")) {
      map.addSource("mapbox-dem", { type: "raster-dem", url: "mapbox://mapbox.terrain-rgb", tileSize: 512, maxzoom: 14 });
    }
    map.setTerrain({ source: "mapbox-dem", exaggeration: 1.15 });
  } catch (e) {}
}

function enable3DBuildings() {
  var layers, labelLayerId, i;
  if (!map || !mapLoaded) { return; }

  try {
    layers = map.getStyle().layers || [];
    for (i = 0; i < layers.length; i++) {
      if (layers[i].type === "symbol" && layers[i].layout && layers[i].layout["text-field"]) { labelLayerId = layers[i].id; break; }
    }

    if (!map.getLayer("3d-buildings")) {
      map.addLayer({
        id: "3d-buildings",
        source: "composite",
        "source-layer": "building",
        filter: ["==", "extrude", "true"],
        type: "fill-extrusion",
        minzoom: 14,
        paint: {
          "fill-extrusion-color": ["interpolate", ["linear"], ["zoom"], 14, "#071923", 16, "#12313b", 18, "#1b4350"],
          "fill-extrusion-height": ["interpolate", ["linear"], ["zoom"], 14, 0, 16, ["get", "height"]],
          "fill-extrusion-base": ["interpolate", ["linear"], ["zoom"], 14, 0, 16, ["get", "min_height"]],
          "fill-extrusion-opacity": 0.68
        }
      }, labelLayerId);
    }

    if (!map.getLayer("slx-building-lit-windows")) {
      map.addLayer({
        id: "slx-building-lit-windows",
        source: "composite",
        "source-layer": "building",
        filter: ["==", "extrude", "true"],
        type: "fill-extrusion",
        minzoom: 15,
        paint: {
          "fill-extrusion-color": "#ffd37a",
          "fill-extrusion-height": ["interpolate", ["linear"], ["zoom"], 15, 0, 17, ["*", ["coalesce", ["get", "height"], 20], 0.92]],
          "fill-extrusion-base": ["interpolate", ["linear"], ["zoom"], 15, 0, 17, ["*", ["coalesce", ["get", "height"], 20], 0.88]],
          "fill-extrusion-opacity": 0.10
        }
      }, labelLayerId);
    }
  } catch (e) {}
}

function addFinalStyles() {
  var style = byId("slxFinalDriverStyleReadyToRide");
  if (style) { return; }

  style = document.createElement("style");
  style.id = "slxFinalDriverStyleReadyToRide";
  style.textContent =
    ".slx-live-truck-marker{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;touch-action:none!important;}" +
    ".mapboxgl-marker{touch-action:none!important;}" +
    ".mapboxgl-popup,.mapboxgl-popup *{pointer-events:auto!important;}" +
    "#slxHTrack{display:flex!important;flex-direction:column!important;gap:6px!important;transition:max-height .18s ease,opacity .18s ease!important;}" +
    ".slxSignal{transition:none!important;transform:none!important;will-change:auto!important;}" +
    ".slxSignalText{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;max-width:250px!important;}" +
    "#slxDriverHud,[id^='slxHud_']{transition:none!important;transform:none!important;will-change:auto!important;}" +
    "#slxDriverHud{bottom:calc(90px + env(safe-area-inset-bottom,0px))!important;}" +
    "#slxHMinBtn{pointer-events:auto!important;touch-action:manipulation!important;}" +
    "@media (orientation:landscape){#slxHTrack{max-width:330px!important;}.slxSignalText{max-width:230px!important;}}";
  document.head.appendChild(style);
}

function addHorizonMinimize() {
  var track = byId("slxHTrack");
  var host, btn, saved;

  if (!track) { return; }

  host = track.parentNode || track;

  if (host && host.style) {
    host.style.position = host.style.position || "relative";
    host.style.pointerEvents = "auto";
    host.style.touchAction = "manipulation";
    host.style.zIndex = host.style.zIndex || "160";
  }

  btn = byId("slxHMinBtn");

  if (!btn) {
    btn = document.createElement("button");
    btn.id = "slxHMinBtn";
    btn.type = "button";
    btn.innerHTML = "\u2212";
    btn.setAttribute("aria-label", "Minimize Freight Horizon");

    btn.style.position = "absolute";
    btn.style.right = "8px";
    btn.style.top = "6px";
    btn.style.zIndex = "2147483647";
    btn.style.width = "34px";
    btn.style.height = "34px";
    btn.style.borderRadius = "999px";
    btn.style.border = "1px solid rgba(255,255,255,.28)";
    btn.style.background = "rgba(3,10,18,.92)";
    btn.style.color = "#fff";
    btn.style.fontWeight = "950";
    btn.style.fontSize = "20px";
    btn.style.lineHeight = "28px";
    btn.style.boxShadow = "0 8px 20px rgba(0,0,0,.42)";
    btn.style.pointerEvents = "auto";
    btn.style.touchAction = "manipulation";
    btn.style.cursor = "pointer";

    if (host && host.appendChild) {
      host.appendChild(btn);
    }
  }

  try {
    saved = localStorage.getItem("slx_horizon_min_v1") || "";
  } catch (e) {
    saved = "";
  }

  function apply(min) {
    var controlled = byId("slxControlledHorizon");

    if (min) {
      track.setAttribute("data-minimized", "true");

      track.style.setProperty("max-height", "44px", "important");
      track.style.setProperty("height", "44px", "important");
      track.style.setProperty("overflow", "hidden", "important");
      track.style.setProperty("opacity", "0.92", "important");

      if (controlled) {
        controlled.style.setProperty("display", "none", "important");
      }

      btn.innerHTML = "+";

      try {
        localStorage.setItem("slx_horizon_min_v1", "1");
      } catch (e1) {}

    } else {
      track.setAttribute("data-minimized", "false");

      track.style.removeProperty("max-height");
      track.style.removeProperty("height");
      track.style.removeProperty("overflow");
      track.style.removeProperty("opacity");

      if (controlled) {
        controlled.style.removeProperty("display");
      }

      btn.innerHTML = "\u2212";

      try {
        localStorage.setItem("slx_horizon_min_v1", "0");
      } catch (e2) {}
    }
  }

  function toggle(e) {
    var minimized;

    if (e && e.preventDefault) { e.preventDefault(); }
    if (e && e.stopPropagation) { e.stopPropagation(); }

    minimized = track.getAttribute("data-minimized") === "true";
    apply(!minimized);

    return false;
  }

  if (!btn.__slxHorizonMinBound) {
    btn.__slxHorizonMinBound = true;

    /* Only bind click. Pointer/touch/mouse together caused double toggles. */
    try {
      btn.addEventListener("click", toggle, false);
    } catch (e3) {
      btn.onclick = toggle;
    }
  }

  window.slxToggleHorizon = function () {
    toggle(null);
  };

  window.slxSetHorizonMinimized = function (min) {
    apply(!!min);
  };

  apply(saved === "1");
}

/* ------------------------------------------------------------------------
   BRIDGE
------------------------------------------------------------------------ */

function exposeCoreBridge() {
  window.__SLX_CORE_BRIDGE__ = {
    getMap: function () { return map; },
    getCurrentFix: function () { return getFix(); },
    getRawFix: function () { return rawFix || currentFix || null; },
    getRouteGeo: function () { return routeGeo; },
    getRouteDest: function () { return routeDest; },
    getRouteSteps: function () { return routeSteps || []; },
    getActiveManeuverStep: function () {
      try { return slxNavV2ActiveStep(); } catch (e) {}
      try {
        if (maneuverSteps && maneuverSteps.length &&
            maneuverIndex >= 0 && maneuverIndex < maneuverSteps.length) {
          return maneuverSteps[maneuverIndex];
        }
      } catch (e2) {}
      return null;
    },
    getManeuverSteps: function () {
      try { return maneuverSteps || []; } catch (e) {}
      return [];
    },
    getManeuverIndex: function () {
      try { return Number(maneuverIndex || 0); } catch (e) {}
      return 0;
    },
    isTripOn: function () { return tripStarted; },
    isFollowLocked: function () { return followLock && !overviewMode; },
    isFreeFlow: function () { return userInteracting || nowMs() < Number(userInteractionUntil || 0); },
    enterFreeFlow: function (ms) { holdUserCamera(ms || FREE_FLOW_MS); },
    forceFollow: function () { forceCockpitFollowLock(); },
    updateHorizon: function () { updateHorizon(); },
    followCamera: function () { followCamera(true); },
    speak: function (t) { primeVoiceThenSpeak(t); },
    drawStops: function (list) { drawStopGlow(list); },
    scanStops: function () { scanStopsGeoapify(true); },
    refreshParkingGlow: function () { refreshVisibleParkingGlow(); }
  };

  window.map = map;
  window.slxMap = map;
  window.currentFix = currentFix;
  window.routeGeo = routeGeo;
  window.fuelState = fuelState;
  window.windState = windState;
  window.gradeState = gradeState;
  window.speedState = speedState;
  window.trafficState = trafficState;
  window.parkingPressureState = parkingPressureState;
  window.brakeState = brakeState;
  window.updateHorizon = updateHorizon;
  window.slxDrawParkingGlow = drawStopGlow;
  window.slxPgDrawGlow = drawStopGlow;
  window.slxRefreshParkingGlow = refreshVisibleParkingGlow;
  window.slxFreeFlow = function () { holdUserCamera(FREE_FLOW_MS); };
  window.slxForceCockpitV3 = function () { forceCockpitFollowLock(); };

  syncGlobalState();
}

/* ------------------------------------------------------------------------
   LOOPS
------------------------------------------------------------------------ */

function startLoops() {
  if (routeSyncTimer) { clearInterval(routeSyncTimer); }
  if (hudTimer) { clearInterval(hudTimer); }
  if (watchdogTimer) { clearInterval(watchdogTimer); }
  if (cameraTimer) { clearInterval(cameraTimer); }
  if (scanTimer) { clearInterval(scanTimer); }
  if (poiGlowTimer) { clearInterval(poiGlowTimer); }

  routeSyncTimer = setInterval(syncRoute, 800);

  hudTimer = setInterval(function () {
    releaseUserCameraIfReady();
    if (tripStarted && !overviewMode && !userInteracting && nowMs() >= Number(userInteractionUntil || 0)) { followLock = true; }
    updateFuelPredictor();
    updateSpeedLimitState();
    updateGradeAndBrakeState();
    updateTrafficDensityPrediction();
    updateParkingPressureState();
    updateHorizon();
    drawDestinationPin();
    exposeCoreBridge();
    syncButtonStates();
  }, 700);

  watchdogTimer = setInterval(function () {
    ensureHorizonCards();
    ensureDriverHud();
    addHorizonMinimize();
    hideOldDomTruckMarkers();
    drawTruckPinLayer();
    drawDestinationPin();
    exposeCoreBridge();
  }, 1200);

  cameraTimer = setInterval(function () {
    if (!tripStarted) { updateTruckMarker(); return; }
    if (!overviewMode && !userInteracting && nowMs() >= Number(userInteractionUntil || 0)) {
      followLock = true;
      followCamera(!pinOnScreen());
    }
  }, 210);

  scanTimer = setInterval(function () {
    if (!tripStarted) { return; }
    if (nowMs() - Number(lastAutoScanAt || 0) < AUTO_SCAN_MS) { return; }
    lastAutoScanAt = nowMs();
    scanStopsGeoapify(false);
  }, 5000);

  poiGlowTimer = setInterval(function () {
    refreshVisibleParkingGlow();
  }, 9000);
}

/* ------------------------------------------------------------------------
   INIT — SAFE MAP BOOT V2
------------------------------------------------------------------------ */

/* ------------------------------------------------------------------------
   SEMI NAV V2C — TURN FILTER + GPS CONFIDENCE GATE
   Goal: no fake "slight right" while parked in a driveway.
------------------------------------------------------------------------ */

var slxNavV2cState = {
  lastMovingAt:0,
  movementReady:false,
  gpsSettledAt:0
};

function slxNavV2cGpsAccuracyFeet(){
  var acc = null;

  if(currentFix && isFiniteNumber(Number(currentFix.accuracy))){ acc = Number(currentFix.accuracy); }
  else if(currentFix && isFiniteNumber(Number(currentFix.acc))){ acc = Number(currentFix.acc); }
  else if(rawFix && isFiniteNumber(Number(rawFix.accuracy))){ acc = Number(rawFix.accuracy); }
  else if(rawFix && isFiniteNumber(Number(rawFix.acc))){ acc = Number(rawFix.acc); }

  if(!isFiniteNumber(Number(acc))){ return null; }

  return Number(acc) * 3.28084;
}

function slxNavV2cIsMovingEnough(){
  var mph = getSpeedMph();

  if(!isFiniteNumber(mph)){ mph = 0; }

  if(mph >= 4){
    slxNavV2cState.lastMovingAt = nowMs();
    slxNavV2cState.movementReady = true;
    return true;
  }

  if(slxNavV2cState.movementReady && nowMs() - Number(slxNavV2cState.lastMovingAt || 0) < 20000){
    return true;
  }

  return false;
}

function slxNavV2cGpsSettled(){
  var accFt = slxNavV2cGpsAccuracyFeet();

  if(accFt === null){
    if(!slxNavV2cState.gpsSettledAt){ slxNavV2cState.gpsSettledAt = nowMs(); }
    return nowMs() - slxNavV2cState.gpsSettledAt > 3500;
  }

  if(accFt <= 120){
    if(!slxNavV2cState.gpsSettledAt){ slxNavV2cState.gpsSettledAt = nowMs(); }
    return nowMs() - slxNavV2cState.gpsSettledAt > 1800;
  }

  slxNavV2cState.gpsSettledAt = 0;
  return false;
}

function slxNavV2cCanShowTurn(step){
  var src;
  var instruction;

  if(!routeGeo || !tripStarted){ return false; }
  if(!slxNavV2cGpsSettled()){ return false; }
  if(!step){ return false; }

  instruction = String(step.instruction || step.announceLabel || "").toLowerCase();
  src = String(step.source || "").toLowerCase();

  if(src.indexOf("route_step") > -1){ return true; }
  if(instruction.indexOf("arrive") > -1 || instruction.indexOf("destination") > -1){ return true; }

  if(!slxNavV2cIsMovingEnough()){ return false; }

  return true;
}

function slxNavV2cWaitingText(){
  if(!slxNavV2cGpsSettled()){
    return { main:"Navigation initializing", sub:"GPS settling before turn guidance" };
  }

  if(!slxNavV2cIsMovingEnough()){
    return { main:"Waiting for movement", sub:"Turn guidance will start once rolling" };
  }

  return { main:"Stay on route", sub:"Watching route ahead" };
}

/* ------------------------------------------------------------------------
   DRIVE IQ NAV CORE FOR SEMI LOCATOR — V2
   Mission: make Semi drive like Drive IQ while preserving trucking intel.
   - Maneuver authority layer
   - Live distance-to-turn
   - Drive IQ-style turn card
   - Comfort camera tuning
   - Trucking intelligence remains untouched
------------------------------------------------------------------------ */

var slxNavCoreV2State = {
  lastCardText:"",
  lastVoiceKey:"",
  lastVoiceAt:0,
  lastBuildAt:0
};

function slxNavV2CoordValid(c){
  return c && c.length === 2 && isFiniteNumber(Number(c[0])) && isFiniteNumber(Number(c[1]));
}

function slxNavV2CumulativeMilesToIndex(coords, idx){
  var total = 0;
  var i;

  if(!coords || !coords.length){ return 0; }

  idx = clamp(Math.round(Number(idx || 0)),0,coords.length - 1);

  for(i = 1; i <= idx; i += 1){
    if(slxNavV2CoordValid(coords[i - 1]) && slxNavV2CoordValid(coords[i])){
      total += milesBetween(coords[i - 1],coords[i]);
    }
  }

  return total;
}

function slxNavV2CumulativeMilesToProjection(coords, proj){
  var base = 0;

  if(!coords || !proj){ return 0; }

  base = slxNavV2CumulativeMilesToIndex(coords,Number(proj.index || 0));

  try{
    if(coords[proj.index] && proj.coord){
      base += milesBetween(coords[proj.index],proj.coord) || 0;
    }
  }catch(e){}

  return base;
}

function slxNavV2Projection(){
  var f = currentFix || routeTargetFix || rawFix;
  var p;

  if(!f || !routeGeo){ return null; }

  try{
    p = nearestRouteProjectionFromPoint(Number(f.lng),Number(f.lat));
  }catch(e){
    p = null;
  }

  return p;
}

function slxNavV2RemainingToStep(step){
  var coords = getRouteCoords();
  var proj;
  var traveled;
  var distanceAlong;

  if(!step){ return null; }

  if(isFiniteNumber(Number(step.distanceAlong))){
    distanceAlong = Number(step.distanceAlong);
  }else if(step.coord){
    step.distanceAlong = slxNavV2DistanceAlongCoord(step.coord);
    distanceAlong = Number(step.distanceAlong);
  }else{
    return null;
  }

  proj = slxNavV2Projection();

  if(!proj || !coords || !coords.length){
    return distanceMilesToCoord(step.coord);
  }

  traveled = slxNavV2CumulativeMilesToProjection(coords,proj);

  return Math.max(0,distanceAlong - traveled);
}

function slxNavV2DistanceAlongCoord(coord){
  var coords = getRouteCoords();
  var best = null;
  var i;
  var d;

  if(!coords || !coords.length || !slxNavV2CoordValid(coord)){ return 0; }

  for(i = 0; i < coords.length; i += 1){
    d = milesBetween(coords[i],coord);
    if(!best || d < best.dist){
      best = { index:i, dist:d };
    }
  }

  return best ? slxNavV2CumulativeMilesToIndex(coords,best.index) : 0;
}

function slxNavV2FmtDistance(mi){
  var feet;

  mi = Number(mi);

  if(!isFiniteNumber(mi)){ return ""; }
  if(mi <= 0.015){ return "now"; }
  if(mi < 0.10){
    feet = Math.round(mi * 5280 / 10) * 10;
    return String(Math.max(50,feet)) + " ft";
  }
  if(mi < 1){
    feet = Math.round(mi * 5280 / 50) * 50;
    return String(Math.max(100,feet)) + " ft";
  }
  return String(Math.round(mi * 10) / 10) + " mi";
}

function slxNavV2InstructionText(step){
  var s = "";

  if(!step){ return "Continue"; }

  try{
    s = getStepInstruction(step);
  }catch(e){
    s = "";
  }

  if(!s && step.instruction){ s = String(step.instruction); }
  if(!s && step.announceLabel){ s = String(step.announceLabel); }

  s = String(s || "Continue").replace(/\s+/g," ").trim();

  return s || "Continue";
}

function slxNavV2Classify(text){
  var t = String(text || "").toLowerCase();

  if(t.indexOf("arrive") > -1 || t.indexOf("destination") > -1 || t.indexOf("finish") > -1){
    return { icon:"Ã¢—Å½", main:"Arrive", voice:"Arriving at destination" };
  }
  if(t.indexOf("roundabout") > -1 || t.indexOf("traffic circle") > -1){
    return { icon:"Ã¢â€ Â»", main:"Roundabout", voice:"Enter the roundabout" };
  }
  if(t.indexOf("u-turn") > -1 || t.indexOf("uturn") > -1){
    return { icon:"Ã¢â€ Â¶", main:"Make U-turn", voice:"Make a U-turn" };
  }
  if(t.indexOf("sharp left") > -1 || t.indexOf("hard left") > -1){
    return { icon:"Ã¢Â¤Âµ", main:"Sharp left", voice:"Sharp left" };
  }
  if(t.indexOf("sharp right") > -1 || t.indexOf("hard right") > -1){
    return { icon:"Ã¢Â¤Â´", main:"Sharp right", voice:"Sharp right" };
  }
  if(t.indexOf("slight left") > -1 || t.indexOf("bear left") > -1 || t.indexOf("keep left") > -1){
    return { icon:"Ã¢â€ –", main:"Slight left", voice:"Slight left" };
  }
  if(t.indexOf("slight right") > -1 || t.indexOf("bear right") > -1 || t.indexOf("keep right") > -1){
    return { icon:"Ã¢â€ —", main:"Slight right", voice:"Slight right" };
  }
  if(t.indexOf("merge") > -1){
    if(t.indexOf("left") > -1){ return { icon:"Ã¢â€ –", main:"Merge left", voice:"Merge left" }; }
    return { icon:"Ã¢â€ —", main:"Merge", voice:"Merge" };
  }
  if(t.indexOf("exit") > -1 || t.indexOf("ramp") > -1){
    if(t.indexOf("left") > -1){ return { icon:"Ã¢â€ Â°", main:"Take exit", voice:"Take the exit" }; }
    return { icon:"Ã¢â€ Â±", main:"Take exit", voice:"Take the exit" };
  }
  if(t.indexOf("left") > -1){
    return { icon:"Ã¢â€ Â", main:"Turn left", voice:"Turn left" };
  }
  if(t.indexOf("right") > -1){
    return { icon:"\u2192", main:"Turn right", voice:"Turn right" };
  }

  return { icon:"\u2191", main:"Continue", voice:"Continue" };
}

function slxNavV2BearingChange(coords, idx){
  var a;
  var b;
  var c;
  var br1;
  var br2;
  var diff;

  if(!coords || coords.length < 3){ return 0; }

  idx = clamp(Math.round(Number(idx || 0)),1,coords.length - 2);

  a = coords[Math.max(0,idx - 3)];
  b = coords[idx];
  c = coords[Math.min(coords.length - 1,idx + 4)];

  br1 = bearingBetweenCoords(a,b);
  br2 = bearingBetweenCoords(b,c);

  diff = ((br2 - br1 + 540) % 360) - 180;

  return diff;
}

function slxNavV2ClassifyGeometry(diff){
  var abs = Math.abs(Number(diff || 0));

  /*
    V2C:
    Geometry fallback was too sensitive and called tiny driveway/route bends
    "Slight right." Only promote meaningful geometry changes.
  */
  if(abs < 42){ return null; }
  if(abs < 68){
    return diff > 0 ? "Slight right" : "Slight left";
  }
  if(abs < 128){
    return diff > 0 ? "Turn right" : "Turn left";
  }
  return diff > 0 ? "Sharp right" : "Sharp left";
}

function slxNavV2ExtractRouteSteps(){
  var feature;
  var props;
  var legs;
  var steps;
  var out = [];
  var i;
  var j;

  try{
    feature = routeGeo && routeGeo.features && routeGeo.features.length ? routeGeo.features[0] : null;
    props = feature && feature.properties ? feature.properties : {};
    legs = props.legs || [];

    for(i = 0; i < legs.length; i += 1){
      steps = legs[i] && legs[i].steps ? legs[i].steps : [];
      for(j = 0; j < steps.length; j += 1){
        if(steps[j]){ out.push(steps[j]); }
      }
    }
  }catch(e){}

  return out;
}

function slxNavV2BuildGeometryFallback(){
  var coords = getRouteCoords();
  var out = [];
  var i;
  var diff;
  var label;
  var lastMiles = -999;
  var miles;

  if(!coords || coords.length < 8){ return out; }

  for(i = 6; i < coords.length - 7; i += 5){
    diff = slxNavV2BearingChange(coords,i);
    label = slxNavV2ClassifyGeometry(diff);

    if(!label){ continue; }

    miles = slxNavV2CumulativeMilesToIndex(coords,i);

    if(miles - lastMiles < 0.18){ continue; }

    out.push({
      coord:[Number(coords[i][0]),Number(coords[i][1])],
      instruction:label,
      announceLabel:label,
      originalIndex:i,
      distanceAlong:miles,
      source:"geometry_fallback"
    });

    lastMiles = miles;
  }

  if(coords.length){
    out.push({
      coord:[Number(coords[coords.length - 1][0]),Number(coords[coords.length - 1][1])],
      instruction:"Arrive at destination",
      announceLabel:"Arrive at destination",
      originalIndex:coords.length - 1,
      distanceAlong:slxNavV2CumulativeMilesToIndex(coords,coords.length - 1),
      source:"geometry_arrival"
    });
  }

  return out;
}

function slxNavV2NormalizeStep(step, idx){
  var loc = null;
  var instruction;
  var lower;
  var normalized;

  try{
    loc = getRouteStepLocation(step);
  }catch(e){
    loc = null;
  }

  if(!loc && step && isFiniteNumber(Number(step.lon)) && isFiniteNumber(Number(step.lat))){
    loc = [Number(step.lon),Number(step.lat)];
  }

  if(!loc){ return null; }

  instruction = slxNavV2InstructionText(step);
  lower = String(instruction || "").toLowerCase();

  if(
    lower.indexOf("continue") > -1 &&
    lower.indexOf("onto") < 0 &&
    lower.indexOf("exit") < 0 &&
    lower.indexOf("turn") < 0 &&
    lower.indexOf("merge") < 0 &&
    lower.indexOf("keep") < 0 &&
    lower.indexOf("arrive") < 0 &&
    lower.indexOf("destination") < 0
  ){
    return null;
  }

  /*
    V24 DRIVE IQ MANEUVER TRUTH PORT:
    Do NOT throw away the provider step metadata when normalizing.
    Drive IQ keeps the named/instruction fields alive so card + voice can
    read the same road identity after route handoff.
  */
  normalized = {
    coord:[Number(loc[0]),Number(loc[1])],
    instruction:instruction,
    announceLabel:instruction,
    originalIndex:idx,
    source:"route_step",

    /* Canonical provider payload survives normalization. */
    rawStep:step,
    raw:step,

    /* Copy common routing-provider road / maneuver fields forward. */
    maneuver:step && step.maneuver ? step.maneuver : null,
    type:step && step.type,
    modifier:step && step.modifier,
    name:step && step.name,
    road:step && step.road,
    roadName:step && (step.roadName || step.road_name),
    road_name:step && step.road_name,
    street:step && (step.street || step.streetName || step.street_name),
    streetName:step && (step.streetName || step.street_name),
    ref:step && step.ref,
    route:step && step.route,
    destination:step && step.destination,
    destinations:step && step.destinations,
    exitName:step && (step.exitName || step.exit_name),
    exit:step && step.exit,
    bannerInstruction:step && (step.bannerInstruction || step.banner_instruction),
    banner_instruction:step && step.banner_instruction,
    voiceInstruction:step && step.voiceInstruction,
    voiceInstructions:step && (step.voiceInstructions || step.voice_instructions),
    voice_instructions:step && step.voice_instructions,
    instruction_details:step && step.instruction_details,
    transition_instruction:step && step.transition_instruction,
    verbal_pre_transition_instruction:step && step.verbal_pre_transition_instruction,
    verbal_post_transition_instruction:step && step.verbal_post_transition_instruction
  };

  normalized.distanceAlong = slxNavV2DistanceAlongCoord(normalized.coord);

  return normalized;
}

function buildManeuverSteps(){
  var rawSteps;
  var i;
  var step;
  var normalized;

  resetManeuverState();
  maneuverLastBuildAt = nowMs();

  rawSteps = routeSteps && routeSteps.length ? routeSteps : loadRouteStepsFromStorage();

  if((!rawSteps || !rawSteps.length) && routeGeo){
    rawSteps = slxNavV2ExtractRouteSteps();
    if(rawSteps && rawSteps.length){
      routeSteps = rawSteps;
      try{
        lsSet(LS.STEPS,JSON.stringify(rawSteps));
        lsSet("slx_route_steps_v2",JSON.stringify(rawSteps));
      }catch(e){}
    }
  }

  if(rawSteps && rawSteps.length){
    for(i = 0; i < rawSteps.length; i += 1){
      step = rawSteps[i];
      normalized = slxNavV2NormalizeStep(step,i);
      if(normalized){ maneuverSteps.push(normalized); }
    }
  }

  if(!maneuverSteps.length){
    maneuverSteps = slxNavV2BuildGeometryFallback();
  }

  maneuverSteps.sort(function(a,b){
    return Number(a.distanceAlong || 0) - Number(b.distanceAlong || 0);
  });

  try{
    window.maneuverSteps = maneuverSteps;
    window.SLX_ROUTE_STEPS = maneuverSteps;
    window.maneuverIndex = maneuverIndex;
  }catch(e){}

  slxNavCoreV2State.lastBuildAt = nowMs();
}

function advancePastBehindManeuvers(){
  var step;
  var remain;

  while(maneuverIndex < maneuverSteps.length){
    step = maneuverSteps[maneuverIndex];
    remain = slxNavV2RemainingToStep(step);

    if(!isFiniteNumber(Number(remain))){ return; }

    if(Number(remain) <= 0.018){
      slxTrustMaybePostManeuverReassure(step);
      maneuverIndex += 1;
      maneuverLastDistanceBucket = "";
      continue;
    }

    return;
  }

  try{ window.maneuverIndex = maneuverIndex; }catch(e){}
}

function slxNavV2ActiveStep(){
  maybeRebuildManeuvers();
  advancePastBehindManeuvers();

  if(!maneuverSteps || !maneuverSteps.length){ return null; }
  if(maneuverIndex >= maneuverSteps.length){ return null; }

  try{
    window.maneuverSteps = maneuverSteps;
    window.SLX_ROUTE_STEPS = maneuverSteps;
    window.maneuverIndex = maneuverIndex;
    window.SLX_ACTIVE_STEP = maneuverSteps[maneuverIndex];
    window.nextStep = maneuverSteps[maneuverIndex];
  }catch(e){}

  return maneuverSteps[maneuverIndex];
}

function getNextTurnSignalText(){
  var step = slxNavV2ActiveStep();
  var remain;
  var classified;

  if(!step || !slxNavV2cCanShowTurn(step)){
    return routeGeo ? slxNavV2cWaitingText().main : "Next turn standby";
  }

  remain = slxNavV2RemainingToStep(step);
  classified = slxNavV2Classify(slxNavV2InstructionText(step));

  if(!isFiniteNumber(Number(remain))){
    return classified.main;
  }

  return classified.main + " • " + slxNavV2FmtDistance(remain);
}

function maybeSpeakNextManeuver(){
  var step;
  var remain;
  var bucket;
  var classified;
  var call;
  var key;
  var t = nowMs();
  var commitment;

  if(!tripStarted || !routeGeo || !currentFix){ return; }
  if(slxTrustArrivalHardSuppress()){ return; }

  step = slxNavV2ActiveStep();

  if(!step || !slxNavV2cCanShowTurn(step)){ return; }

  remain = slxNavV2RemainingToStep(step);

  if(!isFiniteNumber(Number(remain))){ return; }

  commitment = slxTrustIsCommitmentStep(step);

  if(Number(remain) > (commitment ? 1.55 : 1.05)){ return; }

  bucket = maneuverBucket(remain);
  if(!bucket && commitment && Number(remain) <= 1.55){ bucket = "COMMIT"; }
  if(!bucket){ return; }

  classified = slxNavV2Classify(slxNavV2InstructionText(step));
  call = slxTrustBuildManeuverVoice(step,classified.voice,remain,bucket);

  if(bucket === "COMMIT"){
    call += " in about one and a half miles";
  }else if(bucket === "ONE"){
    call += " in about one mile";
  }else if(bucket === "HALF"){
    call += " in about half a mile";
  }else if(bucket === "QUARTER"){
    call += " in about a quarter mile";
  }else if(bucket === "NOW"){
    call += " now";
  }

  key = String(maneuverIndex) + ":" + bucket + ":" + call;

  if(slxNavCoreV2State.lastVoiceKey === key && t - Number(slxNavCoreV2State.lastVoiceAt || 0) < 20000){ return; }

  maneuverLastSpokenIndex = maneuverIndex;
  maneuverLastDistanceBucket = bucket;
  slxNavCoreV2State.lastVoiceKey = key;
  slxNavCoreV2State.lastVoiceAt = t;

  primeVoiceThenSpeak(call);
}

function slxNavV2HideLegacyTurnCards(){
  var ids = ["slxVisualManeuverCard","slxTurnCard","slxManeuverCard","slxNextTurnCard"];
  var i;
  var el;

  for(i = 0; i < ids.length; i += 1){
    el = byId(ids[i]);
    if(el && el.id !== "slxDriveIqTurnCardV2"){
      el.style.display = "none";
      el.style.visibility = "hidden";
      el.style.opacity = "0";
      el.style.pointerEvents = "none";
    }
  }
}

function slxNavV2HideLegacyTurnCards(){
  var ids = ["slxVisualManeuverCard","slxTurnCard","slxManeuverCard","slxNextTurnCard"];
  var i;
  var el;

  for(i = 0; i < ids.length; i += 1){
    el = byId(ids[i]);
    if(el && el.id !== "slxDriveIqTurnCardV2"){
      el.style.display = "none";
      el.style.visibility = "hidden";
      el.style.opacity = "0";
      el.style.pointerEvents = "none";
    }
  }
}

function slxTurnCardShouldShow(){
  return tripStarted && !SLX_TURN_CARD_HIDDEN;
}

function slxSetTurnCardHidden(hidden){
  var card;
  var pill;

  SLX_TURN_CARD_HIDDEN = !!hidden;

  try { lsSet(SLX_TURN_CARD_STORAGE_KEY, SLX_TURN_CARD_HIDDEN ? "1" : "0"); } catch (e0) {}

  card = byId("slxDriveIqTurnCardV2");
  if(card){
    card.style.display = slxTurnCardShouldShow() ? "flex" : "none";
  }

  pill = byId("slxHorizonToggle") || byId("slxHorizonMinimize") || byId("slxTurnHide") || byId("slxHideBtn");
  if(pill){
    try {
      if(SLX_TURN_CARD_HIDDEN){
        pill.textContent = "SHOW";
      }else if(String(pill.textContent || "").toUpperCase().indexOf("SHOW") > -1){
        pill.textContent = "HIDE";
      }
    } catch (e1) {}
  }
}

function slxTurnCardTopCss(){
  return "calc(" + String(SLX_TURN_CARD_TOP_PX) + "px + env(safe-area-inset-top,0px))";
}

function slxNavV2EnsureCard(){
  var card = byId("slxDriveIqTurnCardV2");

  slxNavV2HideLegacyTurnCards();

  if(!card){
    card = document.createElement("div");
    card.id = "slxDriveIqTurnCardV2";
    card.innerHTML =
      '<div id="slxDriveIqTurnArrow">\u2191</div>' +
      '<div id="slxDriveIqTurnTextWrap">' +
        '<div id="slxDriveIqTurnMain">Stay on route</div>' +
        '<div id="slxDriveIqTurnSub">Watching next maneuver</div>' +
      '</div>';
    document.body.appendChild(card);
  }

  slxNavV2ApplyCardMode("move");

  return card;
}

function slxNavV2ApplyCardMode(mode){
  var card = byId("slxDriveIqTurnCardV2");
  var arrow = byId("slxDriveIqTurnArrow");
  var main = byId("slxDriveIqTurnMain");
  var sub = byId("slxDriveIqTurnSub");
  var isIdle = String(mode || "") === "idle";
  var isArrival = String(mode || "") === "arrival";
  var cardWidth = isIdle ? "clamp(190px,32vw,270px)" : "clamp(210px,36vw,318px)";
  var cardMinHeight = isIdle ? "42px" : "54px";
  var cardPadding = isIdle ? "7px 9px" : "9px 10px";
  var arrowSize = isIdle ? "30px" : "34px";
  var arrowFont = isIdle ? "18px" : "21px";
  var mainFont = isIdle ? "12px" : "13px";
  var subDisplay = isIdle ? "none" : "block";

  if(!card){ return; }

  /*
    V2E.2 TIGHT COCKPIT TURN AUTHORITY:
    Lift the lower-right turn card into the clean command pocket above Route Intel.
    Keep idle compact; expand only when the truck is moving or Arrival IQ is active.
  */
  card.style.cssText =
    "position:fixed;" +
    "left:auto;" +
    "right:14px;" +
    "top:auto;" +
    "bottom:calc(146px + env(safe-area-inset-bottom,0px));" +
    "width:" + cardWidth + ";" +
    "max-width:calc(100vw - 104px);" +
    "min-height:" + cardMinHeight + ";" +
    "z-index:2147483000;" +
    "display:" + (slxTurnCardShouldShow() ? "flex" : "none") + ";" +
    "align-items:center;" +
    "gap:9px;" +
    "padding:" + cardPadding + ";" +
    "border-radius:18px;" +
    "background:linear-gradient(180deg,rgba(5,12,22,.94),rgba(5,12,22,.80));" +
    "border:1px solid rgba(40,255,190," + (isArrival ? ".42" : ".26") + ");" +
    "box-shadow:0 14px 34px rgba(0,0,0,.34),0 0 18px rgba(40,255,190,.12);" +
    "backdrop-filter:blur(16px);" +
    "-webkit-backdrop-filter:blur(16px);" +
    "color:#fff;" +
    "pointer-events:none;" +
    "overflow:hidden;";

  if(arrow){
    arrow.style.cssText =
      "width:" + arrowSize + ";height:" + arrowSize + ";border-radius:14px;display:flex;align-items:center;justify-content:center;" +
      "background:rgba(40,255,190,.14);border:1px solid rgba(40,255,190,.30);color:#baffef;" +
      "font-size:" + arrowFont + ";font-weight:1000;flex:0 0 auto;";
  }

  if(main){
    main.style.cssText =
      "font-size:" + mainFont + ";font-weight:1000;letter-spacing:-.02em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.08;";
  }

  if(sub){
    sub.style.cssText =
      "display:" + subDisplay + ";margin-top:3px;font-size:10px;font-weight:850;color:rgba(255,255,255,.70);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.1;";
  }
}

function slxWireTurnHidePillAuthority(){
  var ids = ["slxHorizonToggle","slxHorizonMinimize","slxTurnHide","slxHideBtn"];
  var i;
  var el;

  for(i = 0; i < ids.length; i += 1){
    el = byId(ids[i]);
    if(!el || el.__slxTurnHideAuthority){ continue; }

    el.__slxTurnHideAuthority = true;

    el.addEventListener("click", function(){
      window.setTimeout(function(){
        slxSetTurnCardHidden(!SLX_TURN_CARD_HIDDEN);
        try{ slxNavV2Tick(); }catch(eTick){}
      }, 40);
    }, true);
  }
}

function slxNavV2UpdateCard(){
  var card;
  var arrow;
  var main;
  var sub;
  var step;
  var text;
  var classified;
  var remain;
  var distanceText;
  var instr;

  card = slxNavV2EnsureCard();

  if(!tripStarted){
    return;
  }

  step = slxNavV2ActiveStep();
  arrow = byId("slxDriveIqTurnArrow");
  main = byId("slxDriveIqTurnMain");
  sub = byId("slxDriveIqTurnSub");

  /*
    V2E ARRIVAL IQ MICRO-STATE:
    Do not change routing or camera behavior. This only changes the compact
    lower-right instruction copy when the driver is close enough that arrival
    awareness is more valuable than a generic standby message.
  */
  try {
    var slxArrivalMiles = distanceToDestinationMiles();
    if(isFiniteNumber(slxArrivalMiles) && slxArrivalMiles <= 0.35){
      slxNavV2ApplyCardMode("arrival");
      if(arrow){ arrow.textContent = "Ã°Å¸ÂÂ"; }
      if(main){ main.textContent = "ARRIVAL IQ"; }
      if(sub){ sub.textContent = slxArrivalMiles <= 0.10 ? "Arriving now • verify entrance" : "Destination ahead • verify entrance"; }
      try{ setSignalText("slxSigTurn", "Arrival IQ active"); }catch(eArrSignal){}
      if(!arrivalVoiceAnnounced && slxArrivalMiles <= 0.20){
        arrivalVoiceAnnounced = true;
        primeVoiceThenSpeak("Arrival area ahead. Verify the truck entrance and signage.");
      }
      return;
    }
  } catch (eArr) {}

  if(!step || !slxNavV2cCanShowTurn(step)){
    var wait = slxNavV2cWaitingText();
    var idleMain = routeGeo ? wait.main : "Route waiting";
    var idleSub = routeGeo ? wait.sub : "Start a trip to load turns";
    slxNavV2ApplyCardMode("idle");
    if(arrow){ arrow.textContent = "\u2191"; }
    if(main){
      if(idleMain === "Waiting for movement"){ main.textContent = "GPS locked • waiting"; }
      else { main.textContent = idleMain; }
    }
    if(sub){ sub.textContent = idleSub; }
    try{ setSignalText("slxSigTurn", routeGeo ? wait.main : "Next turn standby"); }catch(eWaitSignal){}
    return;
  }

  instr = slxNavV2InstructionText(step);
  classified = slxNavV2Classify(instr);
  remain = slxNavV2RemainingToStep(step);
  distanceText = slxNavV2FmtDistance(remain);

  slxNavV2ApplyCardMode("move");
  arrow = byId("slxDriveIqTurnArrow");
  main = byId("slxDriveIqTurnMain");
  sub = byId("slxDriveIqTurnSub");

  if(arrow){ arrow.textContent = classified.icon; }
  if(main){ main.textContent = classified.main; }

  text = distanceText ? (distanceText + " ahead") : instr;
  if(instr && instr.toLowerCase().indexOf(classified.main.toLowerCase()) < 0){
    text += " • " + instr;
  }

  if(sub){ sub.textContent = text; }

  setSignalText("slxSigTurn", getNextTurnSignalText());
}

function slxNavV2Tick(){
  try{ slxWireTurnHidePillAuthority(); }catch(eWire){}
  try{ slxNavV2UpdateCard(); }catch(e0){}
}

function getAdaptiveCameraProfile(mph){
  var density = trafficState.density;
  var z;
  var pitch;
  var dur;

  if(!isFiniteNumber(mph)){ mph = 0; }

  if(mph < 5){ z = 16.74; pitch = 66; dur = 0; }
  else if(mph < 15){ z = 16.66; pitch = 68; dur = 120; }
  else if(mph < 35){ z = 16.52; pitch = 68; dur = 130; }
  else if(mph < 58){ z = 16.42; pitch = 70; dur = 145; }
  else{ z = 16.32; pitch = 70; dur = 155; }

  if(density === "heavy"){ z -= 0.12; dur += 35; }
  if(density === "light"){ z += 0.02; }
  if(gradeState.cameraBias){ z += gradeState.cameraBias; }

  return { zoom:z, pitch:pitch, duration:dur };
}

function getDockOffsetY(){
  var vh = window.innerHeight || 844;
  return Math.round(vh * 0.10);
}

function pinOnScreen(){
  var pos = getVisualPinPosition();
  var pt;
  var w;
  var h;

  if(!map || !pos || !map.project){ return true; }

  try{
    pt = map.project(pos);
    w = map.getCanvas().width;
    h = map.getCanvas().height;
    return pt.x > 76 && pt.x < (w - 76) && pt.y > 104 && pt.y < (h - 238);
  }catch(e){
    return true;
  }
}

var slxOldUpdateHorizonV2 = updateHorizon;
updateHorizon = function(){
  try{ slxOldUpdateHorizonV2(); }catch(e0){}
  try{ slxNavV2Tick(); }catch(e1){}
};

window.setInterval(function(){
  try{ slxNavV2Tick(); }catch(e){}
},700);

window.slxNavCoreV2 = {
  rebuild:function(){ buildManeuverSteps(); slxNavV2Tick(); },
  tick:slxNavV2Tick,
  active:function(){ return slxNavV2ActiveStep(); }
};

/* ------------------------------------------------------------------------
   SCAN STOPS — TRUCK-FRIENDLY AUTHORITY V2B
   Prioritize real truck assets: truck stops, diesel, rest areas,
   travel centers, service plazas, truck parking, TA/Petro/Love's/Pilot.
------------------------------------------------------------------------ */

function slxTruckStopSearchTerms(){
  return [
    "truck stop",
    "travel center",
    "truck parking",
    "diesel",
    "rest area",
    "service plaza",
    "weigh station",
    "truck repair",
    "Pilot Travel Center",
    "Flying J",
    "Love's Travel Stop",
    "TA Travel Center",
    "Petro Travel Center"
  ];
}

function slxTruckStopIsUsefulCandidate(c){
  var txt;
  var type;

  if(!c){ return false; }

  type = String(c.type || "").toLowerCase();
  txt = String((c.label || "") + " " + (c.name || "") + " " + (c.title || "") + " " + type + " " + (c.source || "")).toLowerCase();

  if(slxIsTruckFriendlyStopText(txt)){ return true; }
  if(type.indexOf("rest") > -1){ return true; }
  if(type.indexOf("fuel") > -1 && txt.indexOf("diesel") > -1){ return true; }
  if(type.indexOf("parking") > -1 && txt.indexOf("truck") > -1){ return true; }
  if(txt.indexOf("service plaza") > -1){ return true; }
  if(txt.indexOf("travel plaza") > -1){ return true; }

  return false;
}

function slxTruckStopCandidateBoost(c){
  var txt;
  var boost = 0;

  if(!c){ return 0; }

  txt = String((c.label || "") + " " + (c.name || "") + " " + (c.title || "") + " " + (c.type || "") + " " + (c.source || "")).toLowerCase();

  boost += slxTruckStopPriorityScore(txt);

  if(txt.indexOf("diesel") > -1){ boost += 35; }
  if(txt.indexOf("truck parking") > -1){ boost += 45; }
  if(txt.indexOf("rest area") > -1 || txt.indexOf("welcome center") > -1){ boost += 42; }
  if(txt.indexOf("service plaza") > -1){ boost += 38; }
  if(txt.indexOf("travel center") > -1 || txt.indexOf("travel plaza") > -1){ boost += 44; }

  boost -= slxPenaltyForWeakFuel(txt);

  return boost;
}

function slxTruckStopFilterAndRank(list){
  var out = [];
  var weak = [];
  var i;
  var c;
  var score;

  if(!list || !list.length){ return []; }

  for(i = 0; i < list.length; i += 1){
    c = list[i];
    if(!c){ continue; }

    score = Number(c.confidence || 0) + slxTruckStopCandidateBoost(c);
    c.confidence = score;
    c.truckFriendly = slxTruckStopIsUsefulCandidate(c);
    c.markerLabel = slxTruckFriendlyLabel(String((c.label || "") + " " + (c.name || "") + " " + (c.type || "")), c.type);

    if(c.truckFriendly){
      out.push(c);
    }else{
      weak.push(c);
    }
  }

  out.sort(function(a,b){
    var ac = Number(a.confidence || 0);
    var bc = Number(b.confidence || 0);
    var ad = isFiniteNumber(Number(a.distMiles)) ? Number(a.distMiles) : 9999;
    var bd = isFiniteNumber(Number(b.distMiles)) ? Number(b.distMiles) : 9999;
    if(bc !== ac){ return bc - ac; }
    return ad - bd;
  });

  /*
    If route APIs only return weak fuel candidates, keep a few fallbacks
    but real truck-friendly candidates must always lead.
  */
  if(out.length < 3 && weak.length){
    weak.sort(function(a,b){
      var ac = Number(a.confidence || 0);
      var bc = Number(b.confidence || 0);
      var ad = isFiniteNumber(Number(a.distMiles)) ? Number(a.distMiles) : 9999;
      var bd = isFiniteNumber(Number(b.distMiles)) ? Number(b.distMiles) : 9999;
      if(bc !== ac){ return bc - ac; }
      return ad - bd;
    });
    out = out.concat(weak.slice(0,3 - out.length));
  }

  return out.slice(0,20);
}

var slxOldSortedScanCandidatesV2B = slxSortedScanCandidates;
slxSortedScanCandidates = function(list){
  var ranked = slxTruckStopFilterAndRank(list);
  if(ranked && ranked.length){ return ranked; }
  return slxOldSortedScanCandidatesV2B(list);
};

/* ------------------------------------------------------------------------
   SCAN STOPS — V2E.4 NEARBY-FIRST / EXPLICIT RETAIL + TRUCK ASSETS
   Additive override. Keeps existing route/camera/pin behavior intact.
   Goal: surface useful stops immediately around driver + useful ahead.
------------------------------------------------------------------------ */

window.__SLX_SCAN_STOPS_V2E4__ = true;
window.__SLX_DRIVER_DASHBOARD_POLISH_VERSION__ = "V2F_TRUST_FIRST_ROUTE_GUARDRAILS";

function slxBigBoxRetailText(txt){
  txt = String(txt || "").toLowerCase();

  if(txt.indexOf("walmart") > -1){ return true; }
  if(txt.indexOf("sam's club") > -1 || txt.indexOf("sams club") > -1){ return true; }
  if(txt.indexOf("costco") > -1){ return true; }
  if(txt.indexOf("target") > -1){ return true; }
  if(txt.indexOf("home depot") > -1){ return true; }
  if(txt.indexOf("lowe") > -1){ return true; }
  if(txt.indexOf("tractor supply") > -1){ return true; }
  if(txt.indexOf("kroger") > -1){ return true; }
  if(txt.indexOf("supercenter") > -1){ return true; }
  if(txt.indexOf("shopping center") > -1 || txt.indexOf("shopping mall") > -1 || txt.indexOf("plaza") > -1){ return true; }

  return false;
}

function slxServiceRepairText(txt){
  txt = String(txt || "").toLowerCase();

  if(txt.indexOf("truck repair") > -1){ return true; }
  if(txt.indexOf("tire") > -1){ return true; }
  if(txt.indexOf("service") > -1 && txt.indexOf("truck") > -1){ return true; }
  if(txt.indexOf("fleet") > -1){ return true; }
  if(txt.indexOf("repair") > -1){ return true; }
  if(txt.indexOf("mechanic") > -1){ return true; }

  return false;
}

function slxStopIntentTier(c){
  var txt = String((c && ((c.label || "") + " " + (c.name || "") + " " + (c.title || "") + " " + (c.type || "") + " " + (c.source || ""))) || "").toLowerCase();
  var t = String((c && c.type) || "").toLowerCase();

  if(txt.indexOf("truck parking") > -1 || (t.indexOf("parking") > -1 && txt.indexOf("truck") > -1)){ return 1; }
  if(t.indexOf("rest") > -1 || txt.indexOf("rest area") > -1 || txt.indexOf("welcome center") > -1){ return 2; }
  if(slxIsTruckFriendlyStopText(txt) || t.indexOf("fuel") > -1){ return 3; }
  if(slxServiceRepairText(txt)){ return 4; }
  if(slxBigBoxRetailText(txt)){ return 5; }
  if(t.indexOf("parking") > -1){ return 6; }
  if(t.indexOf("food") > -1 || txt.indexOf("restaurant") > -1){ return 7; }

  return 8;
}

function slxNearbyUsefulBonus(c){
  var d = Number(c && c.distMiles);
  var mode = String((c && c.scanMode) || "").toLowerCase();
  var txt = String((c && ((c.label || "") + " " + (c.name || "") + " " + (c.type || ""))) || "").toLowerCase();
  var bonus = 0;

  if(!isFiniteNumber(d)){ d = 9999; }

  if(mode === "nearby"){ bonus += 45; }
  if(d <= 2){ bonus += 70; }
  else if(d <= 5){ bonus += 54; }
  else if(d <= 8){ bonus += 38; }
  else if(d <= 12){ bonus += 20; }

  if(slxBigBoxRetailText(txt) && d <= 8){ bonus += 50; }
  if(slxServiceRepairText(txt) && d <= 12){ bonus += 42; }

  return bonus;
}

/*
  Override category set with a wider but still practical scan footprint.
  This keeps official truck assets first but lets nearby retail/grocery/service
  surface when useful.
*/
function slxNearbyAndAheadCategories() {
  return [
    "service.vehicle.parking",
    "service.vehicle.fuel",
    "service.vehicle.repair",
    "service.vehicle",
    "commercial.supermarket",
    "commercial.shopping_mall",
    "commercial.department_store",
    "commercial.outdoor_and_sport",
    "catering.restaurant",
    "catering.fast_food",
    "accommodation"
  ].join(",");
}

function slxExplicitStopSearchTerms(){
  return [
    "Walmart",
    "Walmart Supercenter",
    "Sam's Club",
    "Costco",
    "Target",
    "Home Depot",
    "Lowe's",
    "Tractor Supply",
    "Kroger",
    "truck parking",
    "truck stop",
    "diesel",
    "rest area",
    "truck repair",
    "tire service"
  ];
}

function slxBuildTextSearchUrl(text,lng,lat,radiusMeters,key){
  return "https://api.geoapify.com/v1/geocode/search?text=" +
    encodeURIComponent(String(text || "")) +
    "&filter=circle:" + encodeURIComponent(String(lng) + "," + String(lat) + "," + String(radiusMeters)) +
    "&bias=proximity:" + encodeURIComponent(String(lng) + "," + String(lat)) +
    "&limit=10&apiKey=" + encodeURIComponent(key);
}

function slxNormalizeTextSearchRows(data, originFix, mode, term){
  var feats = data && data.features ? data.features : [];
  var out = [];
  var seen = {};
  var i;
  var p;
  var c;
  var name;
  var txt;
  var type;
  var d;
  var key2;
  var conf;

  for(i = 0; i < feats.length; i++){
    p = feats[i].properties || {};
    c = feats[i].geometry && feats[i].geometry.coordinates ? feats[i].geometry.coordinates : null;

    if(!c || c.length !== 2){ continue; }

    name = String(p.name || p.address_line1 || p.formatted || term || "Nearby stop");
    txt = String(name + " " + (p.result_type || "") + " " + (p.category || "") + " " + term).toLowerCase();
    type = classifyStopFromText(txt);

    if(slxServiceRepairText(txt)){ type = "service"; }
    if(slxBigBoxRetailText(txt)){ type = "parking"; }

    d = milesBetween([Number(originFix.lng), Number(originFix.lat)], [Number(c[0]), Number(c[1])]);
    if(!isFiniteNumber(d) || d > 18){ continue; }

    key2 = String(Number(c[0]).toFixed(5)) + "," + String(Number(c[1]).toFixed(5));
    if(seen[key2]){ continue; }
    seen[key2] = true;

    conf =
      confidenceFromText(txt) +
      slxTruckStopPriorityScore(txt) +
      slxRetailParkingPriority(txt) +
      (slxBigBoxRetailText(txt) ? 44 : 0) +
      (slxServiceRepairText(txt) ? 42 : 0) -
      slxPenaltyForWeakFuel(txt);

    out.push({
      label:name,
      name:name,
      type:type,
      coord:[Number(c[0]), Number(c[1])],
      distMiles:d,
      confidence:conf,
      truckFriendly:slxIsTruckFriendlyStopText(txt),
      retailUseful:slxBigBoxRetailText(txt),
      serviceUseful:slxServiceRepairText(txt),
      markerLabel:slxTruckFriendlyLabel(txt,type),
      source:"explicit_" + String(term || "").toLowerCase().replace(/\s+/g,"_"),
      scanMode:mode || "nearby"
    });
  }

  return out;
}

function slxFetchTextSearchUrl(url, originFix, mode, term, done){
  fetch(url).then(function(r){
    return r.json();
  }).then(function(data){
    var rows = slxNormalizeTextSearchRows(data, originFix, mode, term);
    var i;

    for(i = 0; i < rows.length; i++){
      slxTagScanCandidate(rows[i], mode, originFix);
    }

    done(rows);
  }).catch(function(){
    done([]);
  });
}

/*
  Override merge ranking so the first 16 pins are not only corridor-ahead.
  It intentionally keeps a near-now mix when nearby options exist.
*/
function slxMergeScanStopLists(lists, originFix) {
  var all = [];
  var seen = {};
  var out = [];
  var near = [];
  var truck = [];
  var restFuelService = [];
  var retail = [];
  var other = [];
  var i;
  var j;
  var list;
  var c;
  var key;
  var txt;
  var existing;
  var idx;
  var tier;

  for(i = 0; i < lists.length; i++){
    list = lists[i] || [];

    for(j = 0; j < list.length; j++){
      c = list[j];
      if(!c || !c.coord || c.coord.length !== 2){ continue; }

      slxTagScanCandidate(c, c.scanMode || "nearby", originFix);

      c.intentTier = slxStopIntentTier(c);
      c.scanScore = Number(c.scanScore || 0) + slxNearbyUsefulBonus(c);

      key = String(Number(c.coord[0]).toFixed(4)) + "," + String(Number(c.coord[1]).toFixed(4));

      if(seen[key] !== undefined){
        existing = all[seen[key]];
        if(Number(c.scanScore || c.confidence || 0) > Number(existing.scanScore || existing.confidence || 0)){
          all[seen[key]] = c;
        }
        continue;
      }

      seen[key] = all.length;
      all.push(c);
    }
  }

  all.sort(function(a,b){
    var at = Number(a.intentTier || 8);
    var bt = Number(b.intentTier || 8);
    var as = Number(a.scanScore || a.confidence || 0);
    var bs = Number(b.scanScore || b.confidence || 0);
    var ad = isFiniteNumber(Number(a.distMiles)) ? Number(a.distMiles) : 9999;
    var bd = isFiniteNumber(Number(b.distMiles)) ? Number(b.distMiles) : 9999;

    if(at !== bt){ return at - bt; }
    if(bs !== as){ return bs - as; }
    return ad - bd;
  });

  for(i = 0; i < all.length; i++){
    c = all[i];
    txt = String((c.label || "") + " " + (c.name || "") + " " + (c.type || "")).toLowerCase();
    tier = slxStopIntentTier(c);

    if(isFiniteNumber(Number(c.distMiles)) && Number(c.distMiles) <= 8){ near.push(c); }
    if(tier === 1){ truck.push(c); }
    else if(tier === 2 || tier === 3 || tier === 4){ restFuelService.push(c); }
    else if(slxBigBoxRetailText(txt)){ retail.push(c); }
    else{ other.push(c); }
  }

  function addUnique(arr, maxCount){
    var k;
    var item;
    var id;
    var already = {};
    var z;

    for(z = 0; z < out.length; z++){
      already[String(Number(out[z].coord[0]).toFixed(4)) + "," + String(Number(out[z].coord[1]).toFixed(4))] = true;
    }

    for(k = 0; k < arr.length; k++){
      if(out.length >= 20){ return; }
      if(maxCount && k >= maxCount){ return; }

      item = arr[k];
      if(!item || !item.coord){ continue; }

      id = String(Number(item.coord[0]).toFixed(4)) + "," + String(Number(item.coord[1]).toFixed(4));
      if(already[id]){ continue; }

      already[id] = true;
      out.push(item);
    }
  }

  /*
    Nearby useful first, then core truck assets, then retail/service if nearby,
    then anything else with route relevance.
  */
  near.sort(function(a,b){
    var as = Number(a.scanScore || a.confidence || 0);
    var bs = Number(b.scanScore || b.confidence || 0);
    var ad = isFiniteNumber(Number(a.distMiles)) ? Number(a.distMiles) : 9999;
    var bd = isFiniteNumber(Number(b.distMiles)) ? Number(b.distMiles) : 9999;
    if(bs !== as){ return bs - as; }
    return ad - bd;
  });

  addUnique(near, 8);
  addUnique(truck, 6);
  addUnique(restFuelService, 8);
  addUnique(retail, 5);
  addUnique(other, 20);
  addUnique(all, 20);

  return out.slice(0,20);
}

/*
  Override scan runner to add named retail/truck searches around the driver,
  not just categories along the route.
*/
function slxRunNearbyAndAheadStopScan(f, key, done) {
  var cats = slxNearbyAndAheadCategories();
  var jobs = [];
  var results = [];
  var pending = 0;
  var ahead = slxRouteAheadScanPoints(f);
  var terms = slxExplicitStopSearchTerms();
  var i;

  function addPlaceJob(lng, lat, radius, mode) {
    jobs.push({
      kind:"places",
      url:slxBuildPlacesUrl(lng, lat, radius, cats, key),
      origin:{ lng:lng, lat:lat },
      mode:mode
    });
  }

  function addTextJob(term, lng, lat, radius, mode) {
    jobs.push({
      kind:"text",
      term:term,
      url:slxBuildTextSearchUrl(term, lng, lat, radius, key),
      origin:{ lng:lng, lat:lat },
      mode:mode
    });
  }

  /*
    Bucket 1: useful right now.
  */
  addPlaceJob(Number(f.lng), Number(f.lat), 9000, "nearby");
  addPlaceJob(Number(f.lng), Number(f.lat), 16000, "nearby");

  for(i = 0; i < terms.length; i++){
    addTextJob(terms[i], Number(f.lng), Number(f.lat), 14000, "nearby");
  }

  /*
    Bucket 2: useful ahead.
  */
  for(i = 0; i < ahead.length; i++){
    addPlaceJob(Number(ahead[i].lng), Number(ahead[i].lat), 6500, "ahead");

    /*
      Keep explicit ahead searches lighter to avoid too many requests,
      but still catch obvious Walmart/truck stop windows ahead.
    */
    if(i < 3){
      addTextJob("truck stop", Number(ahead[i].lng), Number(ahead[i].lat), 9000, "ahead");
      addTextJob("diesel", Number(ahead[i].lng), Number(ahead[i].lat), 9000, "ahead");
      addTextJob("Walmart", Number(ahead[i].lng), Number(ahead[i].lat), 8000, "ahead");
      addTextJob("rest area", Number(ahead[i].lng), Number(ahead[i].lat), 9000, "ahead");
    }
  }

  pending = jobs.length;

  if(!pending){
    done([]);
    return;
  }

  function finishOne(rows) {
    results.push(rows || []);
    pending = pending - 1;

    if(pending <= 0){
      done(slxMergeScanStopLists(results, f));
    }
  }

  for(i = 0; i < jobs.length; i++){
    if(jobs[i].kind === "text"){
      slxFetchTextSearchUrl(jobs[i].url, jobs[i].origin, jobs[i].mode, jobs[i].term, finishOne);
    }else{
      slxFetchStopUrl(jobs[i].url, jobs[i].origin, jobs[i].mode, finishOne);
    }
  }
}

function slxBuildScanStopsVoiceLine(list, provider) {
  var out = slxSortedScanCandidates(list);
  var first;
  var second;
  var count;
  var msg;
  var d;
  var nearbyCount = 0;
  var i;

  if(!out.length){ return ""; }

  for(i = 0; i < out.length; i++){
    d = Number(out[i].distMiles);
    if(isFiniteNumber(d) && d <= 8){ nearbyCount += 1; }
  }

  first = out[0];
  second = out.length > 1 ? out[1] : null;
  count = out.length;

  if(nearbyCount > 0){
    msg = String(nearbyCount) + (nearbyCount === 1 ? " useful stop nearby. " : " useful stops nearby. ");
  }else{
    msg = String(count) + (count === 1 ? " useful stop ahead. " : " useful stops ahead. ");
  }

  msg += "Best option is " + slxScanCandidateName(first);
  d = Number(first.distMiles);
  if(isFiniteNumber(d)){ msg += ", about " + String(Math.round(d * 10) / 10) + " miles away"; }
  msg += ".";

  if(second){
    msg += " Next option is " + slxScanCandidateName(second);
    d = Number(second.distMiles);
    if(isFiniteNumber(d)){ msg += ", about " + String(Math.round(d * 10) / 10) + " miles away"; }
    msg += ".";
  }

  msg += " Parking, fuel, rest, service, and useful retail stops are visible on the map.";

  return msg;
}

var slxOldScanStopsGeoapifyV2E4 = scanStopsGeoapify;
scanStopsGeoapify = function(forceVoice){
  var f = getScanFix();
  var key = String(window.SLX_GEOAPIFY_KEY || geoapifyKey || "");

  if(!f){
    setSubline("GPS fix missing");
    if(forceVoice){ primeVoiceThenSpeak("GPS fix missing"); }
    return;
  }

  if(!key){
    setSubline("Geoapify key missing");
    if(forceVoice){ primeVoiceThenSpeak("Geoapify key missing"); }
    return;
  }

  setSubline("Scanning nearby parking, fuel, rest, service, and retail stops...");
  if(forceVoice && nowMs() - lastScanVoiceAt > 2500){
    lastScanVoiceAt = nowMs();
    primeVoiceThenSpeak("Scanning useful stops nearby and ahead.");
  }

  slxRunNearbyAndAheadStopScan(f, key, function(out){
    var top;

    if(out && out.length){
      top = out.slice(0,16);
      applyStopCandidates(top, "geoapify-v2e4-nearby-explicit", false);
      setSubline("Useful stops surfaced: " + String(top[0].label || "nearby"));
      if(forceVoice){ slxAnnounceScanStops(top, "geoapify-v2e4-nearby-explicit", false); }
      forceCockpitFollowLock();
      return;
    }

    scanStopsMapboxFallback(forceVoice);
  });
};

function initMap() {
  var el, token, initialCenter, initialZoom, initialPitch;
  var initialCoords, initialGeo;

  initialCenter = [-90.05, 34.97];
  initialZoom = 12;
  initialPitch = 50;

  if (map) { return; }

  el = document.getElementById("slxMap");

  if (!el) {
    setSubline("NO slxMap ELEMENT");
    window.setTimeout(initMap, 250);
    return;
  }

  el.style.position = "absolute";
  el.style.top = "0";
  el.style.left = "0";
  el.style.right = "0";
  el.style.bottom = "0";
  el.style.width = "100%";
  el.style.height = "100%";
  el.style.minHeight = "100vh";
  el.style.display = "block";
  el.style.visibility = "visible";
  el.style.opacity = "1";

  if (!window.mapboxgl) {
    setSubline("MAPBOX NOT LOADED");
    window.setTimeout(initMap, 250);
    return;
  }

  token = mapboxToken || String(window.SLX_MAPBOX_TOKEN || "") || (app ? String(app.getAttribute("data-mapbox-token") || "") : "");

  if (token.indexOf("pk.") !== 0) {
    setSubline("MAPBOX TOKEN MISSING");
    window.setTimeout(initMap, 250);
    return;
  }

  mapboxToken = token;
  mapboxgl.accessToken = token;

  setSubline("MAP INIT STARTING");

  restoreViewMode();

  routeGeo = safeParse(lsGet(LS.ROUTE));
  routeDest = safeParse(lsGet(LS.DEST));
  routeSteps = loadRouteStepsFromStorage();
  tripStarted = String(lsGet(LS.TRIP) || "") === "1";

  buildManeuverSteps();

  /*
  STARTUP MAP SEED V6:
  Start on the route origin instead of a regional default overview.
  This prevents the map from first appearing miles away and then snapping in.
  */
  try {
    initialGeo = routeGeo;
    initialCoords = null;

    if(initialGeo && initialGeo.features && initialGeo.features.length &&
       initialGeo.features[0].geometry &&
       initialGeo.features[0].geometry.coordinates &&
       initialGeo.features[0].geometry.coordinates.length){
      initialCoords = initialGeo.features[0].geometry.coordinates[0];
    } else if(initialGeo && initialGeo.geometry &&
              initialGeo.geometry.coordinates &&
              initialGeo.geometry.coordinates.length){
      initialCoords = initialGeo.geometry.coordinates[0];
    }

    if(initialCoords && initialCoords.length >= 2 &&
       isFiniteNumber(Number(initialCoords[0])) &&
       isFiniteNumber(Number(initialCoords[1]))){
      initialCenter = [Number(initialCoords[0]), Number(initialCoords[1])];
      initialZoom = 16.35;
      initialPitch = 58;
    }
  } catch(eSeed) {}

  try {
    map = new mapboxgl.Map({
      container: el,
      style: "mapbox://styles/mapbox/satellite-streets-v12",
      center: initialCenter,
      zoom: initialZoom,
      pitch: initialPitch,
      bearing: 0,
      antialias: true
    });
  } catch (err) {
    map = null;
    mapLoaded = false;
    setSubline("MAP INIT FAILED");
    window.setTimeout(initMap, 500);
    return;
  }

  window.map = map;
  window.slxMap = map;
  exposeCoreBridge();

  map.on("load", function () {
    mapLoaded = true;
    setSubline("MAP LOADED");

    try { map.resize(); } catch (e0) {}
    window.setTimeout(function () { try { map.resize(); } catch (e1) {} }, 300);
    window.setTimeout(function () { try { map.resize(); } catch (e2) {} }, 1000);
    window.setTimeout(function () { try { map.resize(); } catch (e3) {} }, 2200);

    addFinalStyles();
    exposeCoreBridge();
    installVoiceLoader();
    unlockSpeech();
    enable3DEnvironment();
    enable3DBuildings();
    ensureHorizonCards();
    ensureDriverHud();
    addHorizonMinimize();
    installAddStopHandler();
    drawRoute();
    drawDestinationPin();
    wireButtons();
    bindManualCameraFreedom();
    startVisualGlideLoop();
    startGPS();
    startLoops();

    updateFuelPredictor();
    updateSpeedLimitState();
    updateGradeAndBrakeState();
    updateTrafficDensityPrediction();
    updateParkingPressureState();
    updateHorizon();
    syncButtonStates();
    updateTruckMarker();
    refreshVisibleParkingGlow();

    if (routeGeo) {
      forceCockpitFollowLock();
      setSubline("Navigation active");
      window.setTimeout(function () { followCamera(true); }, 450);
      window.setTimeout(function () { followCamera(true); }, 1300);
    } else {
      setSubline("Driver mode ready");
    }

    window.setTimeout(function () { scanStopsGeoapify(false); }, 2600);
    window.setTimeout(function () { refreshVisibleParkingGlow(); }, 3600);
  });

  map.on("error", function () {
    setSubline("MAPBOX ERROR");
  });
}

/* =========================================================
SLX REAL-LIFE MAP VISUAL PATCH V1
Satellite streets + terrain + 3D buildings + atmosphere
========================================================= */

function enableRealLifeMap(){
  if(!map){return;}

  try{
    if(!map.getSource("mapbox-dem")){
      map.addSource("mapbox-dem",{
        type:"raster-dem",
        url:"mapbox://mapbox.mapbox-terrain-dem-v1",
        tileSize:512,
        maxzoom:14
      });
    }

    map.setTerrain({
      source:"mapbox-dem",
      exaggeration:1.6
    });
  }catch(e){}

  try{
    map.setFog({
      color:"rgba(180,200,220,0.55)",
      "high-color":"rgba(90,120,160,0.35)",
      "horizon-blend":0.18,
      "space-color":"#071019",
      "star-intensity":0.12
    });
  }catch(e){}

  try{
    if(!map.getLayer("slx-3d-buildings")){
      map.addLayer({
        id:"slx-3d-buildings",
        source:"composite",
        "source-layer":"building",
        filter:["==","extrude","true"],
        type:"fill-extrusion",
        minzoom:14,
        paint:{
          "fill-extrusion-color":"rgba(190,205,205,0.72)",
          "fill-extrusion-height":[
            "interpolate",["linear"],["zoom"],
            14,0,
            15,["get","height"]
          ],
          "fill-extrusion-base":[
            "interpolate",["linear"],["zoom"],
            14,0,
            15,["get","min_height"]
          ],
          "fill-extrusion-opacity":0.78
        }
      });
    }
  }catch(e){}
}

function slxStartInitMap() {
  window.setTimeout(initMap, 50);
  window.setTimeout(initMap, 400);
  window.setTimeout(initMap, 1000);
  window.setTimeout(initMap, 2200);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", slxStartInitMap, false);
} else {
  slxStartInitMap();
}

window.addEventListener("load", slxStartInitMap, false);

window.setTimeout(function(){ try{ slxNavV2HideLegacyTurnCards(); slxNavV2Tick(); }catch(e){} },500);
window.setTimeout(function(){ try{ slxNavV2HideLegacyTurnCards(); slxNavV2Tick(); }catch(e){} },1500);
window.setTimeout(function(){ try{ slxNavV2HideLegacyTurnCards(); slxNavV2Tick(); }catch(e){} },3000);

window.setTimeout(function(){ try{ slxWireTurnHidePillAuthority(); slxNavV2Tick(); }catch(e){} },500);
window.setTimeout(function(){ try{ slxWireTurnHidePillAuthority(); slxNavV2Tick(); }catch(e){} },1500);
window.setTimeout(function(){ try{ slxWireTurnHidePillAuthority(); slxNavV2Tick(); }catch(e){} },3000);

})();

/* =========================================================
SLX FINAL READY-TO-RIDE POLISH PACK
Parking glow + Founding Driver badge + Paywall + Horizon cleanup
========================================================= */

(function(){

"use strict";

/* =========================================================
TRIP COUNTER + PAYWALL ENGINE
========================================================= */

var SLX_TRIP_KEY = "slx_trip_count_v1";
var SLX_FOUNDING_KEY = "slx_founder_slot_v1";

function slxGetTripCount(){
  try{
    return Number(localStorage.getItem(SLX_TRIP_KEY)||0);
  }catch(e){ return 0; }
}

function slxSetTripCount(n){
  try{
    localStorage.setItem(SLX_TRIP_KEY,String(n));
  }catch(e){}
}

function slxIncrementTrip(){
  var c = slxGetTripCount();
  c++;
  slxSetTripCount(c);
  slxCheckFounderStatus(c);
  slxCheckPaywall(c);
}

/* =========================================================
FOUNDING DRIVER BADGE SYSTEM
========================================================= */

function slxCheckFounderStatus(count){

  try{

    var existing =
      localStorage.getItem(SLX_FOUNDING_KEY)||"";

    if(existing){ return; }

    if(count < 5){ return; }

    var slot =
      Math.floor(Math.random()*20)+1;

    localStorage.setItem(
      SLX_FOUNDING_KEY,
      "FOUNDING DRIVER #"+slot
    );

    console.log(
      "Founder badge granted:",
      slot
    );

  }catch(e){}

}

/* =========================================================
PAYWALL AFTER 5 TRIPS
========================================================= */

function slxCheckPaywall(count){

  if(count <= 5){ return; }

  window.slxPremiumLocked = true;

  console.log(
    "Premium corridor intelligence locked"
  );

}

/* =========================================================
ARRIVAL DETECTION HOOK
========================================================= */

function slxDetectArrival(){

  if(!window.routeDest){ return; }

  if(!window.currentFix){ return; }

  var dx =
    Math.abs(
      currentFix.lng -
      routeDest.lng
    );

  var dy =
    Math.abs(
      currentFix.lat -
      routeDest.lat
    );

  if(dx < .002 && dy < .002){

    if(window.primeVoiceThenSpeak){

      primeVoiceThenSpeak(
        "You have arrived"
      );

    }

    slxIncrementTrip();

  }

}

/* =========================================================
HORIZON CLEAN SIGNAL FILTER
========================================================= */

function slxFilterHorizonSignals(){

  var track =
    document.getElementById("slxHTrack");

  if(!track){ return; }

  var cards =
    track.querySelectorAll(".slxSignal");

  var i;

  for(i=0;i<cards.length;i++){

    var t =
      cards[i].innerText||"";

    if(
      t.indexOf("locked")>-1 ||
      t.indexOf("live")>-1
    ){

      cards[i].style.display="none";

    }

  }

}

/* =========================================================
PARKING HALO BOOST LOOP
========================================================= */

function slxBoostParkingGlow(){

  if(!window.slxRefreshParkingGlow){ return; }

  try{

    slxRefreshParkingGlow();

  }catch(e){}

}

/* =========================================================
BUILDING WINDOW LIGHT BOOST
========================================================= */

function slxEnhanceNightBuildings(){

  if(!window.map){ return; }

  try{

    if(
      map.getLayer(
        "slx-building-lit-windows"
      )
    ){

      map.setPaintProperty(
        "slx-building-lit-windows",
        "fill-extrusion-opacity",
        .14
      );

    }

  }catch(e){}

}

/* =========================================================
VOICE MANEUVER TIGHTENER
========================================================= */

function slxVoiceTightener(){

  if(!window.routeSteps){ return; }

  if(!window.currentFix){ return; }

  if(!routeSteps.length){ return; }

  var next =
    routeSteps[0];

  if(!next){ return; }

}

/* =========================================================
MAIN POLISH LOOP
========================================================= */

setInterval(function(){

  slxFilterHorizonSignals();

  slxBoostParkingGlow();

  slxEnhanceNightBuildings();

  slxDetectArrival();

},4000);

})();

(function () {
"use strict";

if (window.__SLX_SMART_CORRIDOR_INTEL_PACK_V1__) { return; }
window.__SLX_SMART_CORRIDOR_INTEL_PACK_V1__ = true;

function slxNow() { return Date.now(); }
function slxFinite(v) { return typeof v === "number" && isFinite(v); }
function slxClamp(v, min, max) { v = Number(v); if (v < min) { return min; } if (v > max) { return max; } return v; }
function slxGet(id) { return document.getElementById(id); }
function slxText(id, text) { var el = slxGet(id); if (el && el.textContent !== String(text || "")) { el.textContent = String(text || ""); } }
function slxLsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
function slxLsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
function slxParse(v) { try { return JSON.parse(v); } catch (e) { return null; } }
function slxSpeak(text) { try { if (window.slxPrimeVoiceThenSpeak) { window.slxPrimeVoiceThenSpeak(String(text || "")); return; } if (window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.speak) { window.__SLX_CORE_BRIDGE__.speak(String(text || "")); return; } } catch (e) {} }
function slxBridge() { return window.__SLX_CORE_BRIDGE__ || null; }
function slxMap() { var b = slxBridge(); if (b && b.getMap) { try { return b.getMap(); } catch (e) {} } return window.map || window.slxMap || null; }
function slxFix() { var b = slxBridge(); if (b && b.getCurrentFix) { try { return b.getCurrentFix(); } catch (e) {} } return window.currentFix || null; }
function slxRawFix() { var b = slxBridge(); if (b && b.getRawFix) { try { return b.getRawFix(); } catch (e) {} } return window.currentFix || null; }
function slxRouteGeo() { var b = slxBridge(); if (b && b.getRouteGeo) { try { return b.getRouteGeo(); } catch (e) {} } return window.routeGeo || slxParse(slxLsGet("slx_route_geo_v2")); }
function slxRouteDest() { var b = slxBridge(); if (b && b.getRouteDest) { try { return b.getRouteDest(); } catch (e) {} } return window.routeDest || slxParse(slxLsGet("slx_main_dest_v2")); }
function slxSteps() { var b = slxBridge(); if (b && b.getRouteSteps) { try { return b.getRouteSteps() || []; } catch (e) {} } return window.routeSteps || slxParse(slxLsGet("slx_route_steps_v1")) || []; }
function slxTripOn() { var b = slxBridge(); if (b && b.isTripOn) { try { return !!b.isTripOn(); } catch (e) {} } return String(slxLsGet("slx_trip_on_v2") || "") === "1"; }
function slxCoords() { var geo = slxRouteGeo(); if (!geo || !geo.features || !geo.features.length) { return null; } if (!geo.features[0].geometry || !geo.features[0].geometry.coordinates) { return null; } return geo.features[0].geometry.coordinates; }
function slxMilesBetween(a, b) { var R = 3958.8; var dLat = (Number(b[1]) - Number(a[1])) * Math.PI / 180; var dLon = (Number(b[0]) - Number(a[0])) * Math.PI / 180; var lat1 = Number(a[1]) * Math.PI / 180; var lat2 = Number(b[1]) * Math.PI / 180; var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2); return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)); }
function slxBearing(a, b) { var dx = Number(b[0]) - Number(a[0]); var dy = Number(b[1]) - Number(a[1]); var raw = Math.atan2(dx, dy) * 180 / Math.PI; while (raw < 0) { raw += 360; } while (raw >= 360) { raw -= 360; } return raw; }
function slxAngleDelta(a, b) { var d = Math.abs(Number(a || 0) - Number(b || 0)); while (d > 360) { d -= 360; } if (d > 180) { d = 360 - d; } return d; }
function slxSpeedMph() { var f = slxRawFix() || slxFix(); if (!f || !slxFinite(Number(f.speed))) { return 0; } return Number(f.speed) * 2.23693629; }
function slxNearestIndex() { var coords = slxCoords(); var f = slxFix(); var best = Infinity; var bestIdx = -1; var i, d; if (!coords || !coords.length || !f) { return -1; } for (i = 0; i < coords.length; i += 3) { d = slxMilesBetween([Number(f.lng), Number(f.lat)], [Number(coords[i][0]), Number(coords[i][1])]); if (d < best) { best = d; bestIdx = i; } } return bestIdx; }
function slxRouteRemainingMiles() { var coords = slxCoords(); var idx = slxNearestIndex(); var total = 0; var i; if (!coords || idx < 0) { return null; } for (i = idx; i < coords.length - 1; i++) { total += slxMilesBetween(coords[i], coords[i + 1]); } return total; }
function slxPointAheadMiles(milesAhead) { var coords = slxCoords(); var idx = slxNearestIndex(); var remaining = Number(milesAhead || 0); var i, seg; if (!coords || idx < 0) { return null; } for (i = idx; i < coords.length - 1; i++) { seg = slxMilesBetween(coords[i], coords[i + 1]); if (remaining <= seg) { return coords[i + 1]; } remaining -= seg; } return coords[coords.length - 1] || null; }
function slxRouteBearingAhead(milesAhead) { var coords = slxCoords(); var idx = slxNearestIndex(); var ahead = slxPointAheadMiles(milesAhead || 0.32); if (!coords || idx < 0 || !ahead) { return null; } return slxBearing(coords[idx], ahead); }
function slxFormatMiles(mi) { mi = Number(mi); if (!slxFinite(mi)) { return "--"; } if (mi >= 100) { return String(Math.round(mi)) + " mi"; } return String(Math.round(mi * 10) / 10) + " mi"; }

var slxIntel = {
  routeConfidence: { score: 72, label: "CONFIDENCE: MEDIUM", reason: "Corridor still building" },
  curve: { level: "standby", label: "Curve scan standby", advisedMph: null, lastVoiceAt: 0 },
  momentum: { load: "loaded", equipment: "dry_van", lengthFt: 53, weightLb: 65000, multiplier: 1.0, label: "Load profile normal" },
  parkingWindow: { status: "standby", label: "Parking window standby", minutes: null, lastVoiceAt: 0 },
  weatherEta: { status: "standby", label: "Weather corridor standby", etaMinutes: null, holdRecommended: false, lastVoiceAt: 0, lastFetchAt: 0 },
  arrival: { active: false, label: "Arrival standby", distanceMiles: null, lastVoiceAt: 0, arrivedSpoken: false },
  signalRep: { score: 50, label: "Signal trust baseline", verified: 0, total: 0 },
  corridorAssist: { status: "standby", label: "Shortcut scan standby", lastVoiceAt: 0, lastEvaluateAt: 0 }
};

window.SLX_INTEL = slxIntel;

function slxEnsureSmartHorizonCards() {
  var track = slxGet("slxHTrack");
  if (!track) { return; }
  function add(id, text) {
    var row;
    if (slxGet(id)) { return; }
    row = document.createElement("div");
    row.className = "slxSignal slxSmartSignal";
    row.innerHTML = '<span class="slxSignalDot"></span><span class="slxSignalText" id="' + id + '">' + text + '</span>';
    track.appendChild(row);
  }
  add("slxSigConfidence", "Route confidence standby");
  add("slxSigCurve", "Curve speed standby");
  add("slxSigParkingWindow", "Parking window standby");
  add("slxSigWeatherEta", "Weather corridor ETA standby");
  add("slxSigArrival", "Arrival standby");
  add("slxSigAssist", "Shortcut scan standby");
}

function slxInstallSmartStyles() {
  var st;

  if (slxGet("slxSmartIntelStylesV1")) { return; }

  st = document.createElement("style");
  st.id = "slxSmartIntelStylesV1";

  st.textContent =
    ".slxSmartSignal{border-color:rgba(0,255,210,.18)!important;}" +

    "#slxSmartBadge{" +
      "position:fixed!important;" +
      "right:18px!important;" +
      "bottom:calc(8px + env(safe-area-inset-bottom,0px))!important;" +
      "z-index:118!important;" +
      "min-width:172px;" +
      "max-width:240px;" +
      "padding:8px 10px;" +
      "border-radius:14px;" +
      "background:rgba(4,11,18,.88);" +
      "border:1px solid rgba(0,255,210,.22);" +
      "box-shadow:0 10px 28px rgba(0,0,0,.36),0 0 24px rgba(0,255,210,.10);" +
      "color:#eaffff;" +
      "font-size:10px;" +
      "font-weight:950;" +
      "letter-spacing:.34px;" +
      "pointer-events:none;" +
      "box-sizing:border-box;" +
    "}" +

    "#slxSmartBadge b{" +
      "display:block;" +
      "font-size:11px;" +
      "margin-bottom:3px;" +
      "color:#7fffea;" +
    "}" +

    "#slxFounderBadge{" +
      "position:fixed;" +
      "left:18px;" +
      "top:calc(18px + env(safe-area-inset-top,0px));" +
      "z-index:119;" +
      "padding:8px 10px;" +
      "border-radius:999px;" +
      "background:rgba(2,10,18,.88);" +
      "border:1px solid rgba(0,255,210,.38);" +
      "box-shadow:0 0 26px rgba(0,255,210,.20);" +
      "font-size:10px;" +
      "font-weight:950;" +
      "letter-spacing:.5px;" +
      "color:#dfffff;" +
      "pointer-events:none;" +
    "}" +

    "@media (orientation:landscape){" +
  "#slxSmartBadge{" +
    "right:auto!important;" +
    "left:46%!important;" +
    "bottom:calc(80px + env(safe-area-inset-bottom,0px))!important;" +
    "max-width:300px!important;" +
  "}" +
"}" +

    "@media (max-width:760px){" +
      "#slxSmartBadge{" +
        "right:12px!important;" +
        "bottom:calc(8px + env(safe-area-inset-bottom,0px))!important;" +
        "min-width:150px;" +
        "max-width:230px;" +
        "font-size:9px;" +
      "}" +
      "#slxFounderBadge{" +
        "left:12px;" +
        "top:calc(12px + env(safe-area-inset-top,0px));" +
      "}" +
    "}";

  document.head.appendChild(st);
}

function slxForceSmartBadgePosition() {
  var badge = slxGet("slxSmartBadge");
  var isLandscape = window.innerWidth > window.innerHeight;

  if (!badge) { return; }

  badge.style.setProperty("position", "fixed", "important");
  badge.style.setProperty("bottom", "calc(90px + env(safe-area-inset-bottom,0px))", "important");
  badge.style.setProperty("z-index", "118", "important");

  if (isLandscape) {

badge.style.setProperty("right", "24px", "important");
badge.style.setProperty("left", "auto", "important");

badge.style.setProperty(
"bottom",
"calc(90px + env(safe-area-inset-bottom,0px))",
"important"
);

badge.style.setProperty("max-width", "340px", "important");
} else {
    badge.style.setProperty("left", "auto", "important");
    badge.style.setProperty("right", "18px", "important");
    badge.style.setProperty("max-width", "240px", "important");
  }
}

function slxEnsureSmartBadge() {
  var badge = slxGet("slxSmartBadge");

  if (!badge) {
    badge = document.createElement("div");
    badge.id = "slxSmartBadge";
    badge.innerHTML = "<b>ROUTE INTEL</b><span id=\"slxSmartBadgeText\">Standing by</span>";
    document.body.appendChild(badge);
  }

  slxForceSmartBadgePosition();

  setTimeout(slxForceSmartBadgePosition, 250);
  setTimeout(slxForceSmartBadgePosition, 1000);
}

function slxUpdateSmartBadge() { var txt = slxGet("slxSmartBadgeText"); if (txt) { txt.textContent = slxIntel.routeConfidence.label + " • " + slxIntel.routeConfidence.reason; } }
function slxEnsureFounderBadge() { var val = slxLsGet("slx_founder_slot_v1") || ""; var badge; if (!val) { return; } badge = slxGet("slxFounderBadge"); if (!badge) { badge = document.createElement("div"); badge.id = "slxFounderBadge"; document.body.appendChild(badge); } badge.textContent = String(val); }

function slxLoadMomentumMode() {
  var payload = slxParse(slxLsGet("slx_start_trip_payload")) || {};
  var mode = slxLsGet("slx_trip_mode_v1") || slxLsGet("slx_mode") || "";
  var truckType = payload.truckType || payload.truck_type || slxLsGet("slx_truck_type_v1") || "dry_van";
  var equipment = payload.equipmentType || payload.equipment_type || slxLsGet("slx_equipment_type_v1") || truckType;
  var lengthFt = Number(payload.equipmentLength || payload.lengthFt || slxLsGet("slx_equipment_length_v1") || 53);
  var weightLb = Number(payload.equipmentWeight || payload.weightLb || slxLsGet("slx_equipment_weight_v1") || 65000);
  var load = payload.loadMode || payload.load_mode || mode || "loaded";
  var mult = 1.0;
  load = String(load || "loaded").toLowerCase();
  equipment = String(equipment || "dry_van").toLowerCase();
  if (load.indexOf("empty") > -1) { mult -= 0.10; }
  if (load.indexOf("bobtail") > -1) { mult -= 0.18; }
  if (load.indexOf("loaded") > -1) { mult += 0.12; }
  if (load.indexOf("heavy") > -1) { mult += 0.18; }
  if (slxFinite(weightLb) && weightLb >= 70000) { mult += 0.18; }
  if (slxFinite(lengthFt) && lengthFt >= 53) { mult += 0.06; }
  if (equipment.indexOf("flatbed") > -1) { mult += 0.04; }
  if (equipment.indexOf("tanker") > -1) { mult += 0.14; }
  if (equipment.indexOf("car") > -1) { mult += 0.08; }
  mult = slxClamp(mult, 0.78, 1.45);
  slxIntel.momentum.load = load;
  slxIntel.momentum.equipment = equipment;
  slxIntel.momentum.lengthFt = slxFinite(lengthFt) ? lengthFt : 53;
  slxIntel.momentum.weightLb = slxFinite(weightLb) ? weightLb : 65000;
  slxIntel.momentum.multiplier = mult;
  if (mult >= 1.30) { slxIntel.momentum.label = "Heavy momentum profile"; }
  else if (mult >= 1.14) { slxIntel.momentum.label = "Loaded momentum profile"; }
  else if (mult <= 0.90) { slxIntel.momentum.label = "Light truck profile"; }
  else { slxIntel.momentum.label = "Load profile normal"; }
}

function slxEvaluateCurveSpeed() {
  var coords = slxCoords();
  var idx = slxNearestIndex();
  var mph = slxSpeedMph();
  var look = mph > 50 ? 34 : mph > 30 ? 24 : 16;
  var i, a, b, c, b1, b2, delta, worst, advised, mult;
  if (!coords || idx < 0 || coords.length < idx + 5) { slxIntel.curve.level = "standby"; slxIntel.curve.label = "Curve speed standby"; return; }
  worst = 0;
  for (i = idx; i < Math.min(coords.length - 3, idx + look); i += 2) {
    a = coords[i]; b = coords[i + 1]; c = coords[i + 2];
    b1 = slxBearing(a, b); b2 = slxBearing(b, c); delta = slxAngleDelta(b1, b2);
    if (delta > worst) { worst = delta; }
  }
  mult = slxIntel.momentum.multiplier || 1;
  advised = null;
  if (worst >= 52) { advised = Math.round(34 / mult); slxIntel.curve.level = "high"; slxIntel.curve.label = "Sharp curve ahead • ease down"; }
  else if (worst >= 34) { advised = Math.round(45 / mult); slxIntel.curve.level = "medium"; slxIntel.curve.label = "Curve speed watch ahead"; }
  else if (worst >= 22) { advised = Math.round(55 / mult); slxIntel.curve.level = "low"; slxIntel.curve.label = "Gentle curve ahead"; }
  else { slxIntel.curve.level = "clear"; slxIntel.curve.label = "Curve corridor clear"; }
  if (advised) { advised = slxClamp(advised, 20, 60); slxIntel.curve.advisedMph = advised; slxIntel.curve.label += " • target " + String(advised) + " mph"; } else { slxIntel.curve.advisedMph = null; }
  if (slxTripOn() && slxIntel.curve.level === "high" && slxNow() - slxIntel.curve.lastVoiceAt > 120000) {
    var slxCurveVoiceSpeed = 0;
    var slxCurveVoiceLimit = null;
    try { slxCurveVoiceSpeed = Number(getSpeedMph ? getSpeedMph() : 0) || 0; } catch(eCv0) {}
    try {
      if (typeof speedState !== "undefined" && speedState && isFiniteNumber(Number(speedState.limitMph))) {
        slxCurveVoiceLimit = Number(speedState.limitMph);
      }
    } catch(eCv1) {}

    /* V16: Neighborhood/local-speed curves stay visual-only.
       Speak only when the truck is actually in a higher-speed environment. */
    if (
      slxCurveVoiceSpeed >= 45 ||
      (slxCurveVoiceLimit !== null && slxCurveVoiceLimit >= 50 && slxCurveVoiceSpeed >= 35)
    ) {
      slxIntel.curve.lastVoiceAt = slxNow();
      slxSpeak("Sharp curve ahead. Ease down early.");
    }
  }
}

function slxBoostBrakeExposure() {
  var grade = window.gradeState || {};
  var brake = window.brakeState || {};
  var mph = slxSpeedMph();
  var mult = slxIntel.momentum.multiplier || 1;
  var label = "";
  if (grade.severity === "high_down" || brake.level === "high") {
    label = "Downgrade braking ahead";
    if (mult >= 1.18) { label = "Heavy load downgrade • brake early"; }
    if (mph >= 55) { label = "Speed plus downgrade • brake early"; }
    slxIntel.routeConfidence.score -= 12;
    try { window.brakeState.level = "high"; window.brakeState.label = label; } catch (e) {}
    if (slxTripOn() && slxNow() - Number(brake.lastVoiceAt || 0) > 180000) { try { window.brakeState.lastVoiceAt = slxNow(); } catch (e2) {} slxSpeak(label); }
  }
}

function slxEvaluateParkingWindow() {
  var hour = new Date().getHours();
  var remaining = slxRouteRemainingMiles();
  var mph = slxSpeedMph();
  var minutesToDest = null;
  var parking = window.parkingPressureState || {};
  var pressure = String(parking.status || "standby");
  var stopState = window.stopIntentState || {};
  var candidates = stopState.visibleCandidates || [];
  var nearest = candidates.length ? Number(candidates[0].distMiles || 0) : null;
  var label = "Parking window standby";
  var status = "standby";
  if (slxFinite(remaining) && mph > 8) { minutesToDest = Math.round((remaining / mph) * 60); }
  if (!slxTripOn()) { status = "standby"; label = "Parking window standby"; }
  else if (pressure === "likely_full") { status = "bad"; label = "Poor parking window ahead"; }
  else if (pressure === "tightening") { status = "tight"; label = "Parking window tightening"; }
  else if (slxFinite(nearest) && nearest <= 12 && (hour >= 16 || hour <= 5)) { status = "good_now"; label = "Good parking window now"; }
  else if (slxFinite(nearest) && nearest <= 25) { status = "watch"; label = "Parking option ahead"; }
  else { status = "thin"; label = "Parking options thin ahead"; }
  if (slxFinite(minutesToDest)) { label += " • ETA " + String(minutesToDest) + " min"; }
  slxIntel.parkingWindow.status = status;
  slxIntel.parkingWindow.label = label;
  slxIntel.parkingWindow.minutes = minutesToDest;
  if (slxTripOn() && (status === "bad" || status === "good_now") && slxNow() - slxIntel.parkingWindow.lastVoiceAt > 240000) { slxIntel.parkingWindow.lastVoiceAt = slxNow(); if (status === "bad") { slxSpeak("Parking window is getting tight ahead."); } if (status === "good_now") { slxSpeak("Good parking window now."); } }
}

function slxEvaluateWeatherEta() {
  var wind = window.windState || {};
  var speed = Number(wind.speed);
  var relative = String(wind.relative || "");
  var remaining = slxRouteRemainingMiles();
  var mph = slxSpeedMph();
  var eta = null;
  var label = "Weather corridor standby";
  var status = "standby";
  var hold = false;
  if (slxFinite(remaining) && mph > 8) { eta = Math.round((remaining / mph) * 60); }
  if (!slxTripOn()) { status = "standby"; label = "Weather corridor standby"; }
  else if (slxFinite(speed) && speed >= 45 && relative === "crosswind") { status = "high"; hold = true; label = "Dangerous crosswind corridor"; }
  else if (slxFinite(speed) && speed >= 35) { status = "watch"; label = "High wind corridor"; }
  else if (String(wind.label || "").toLowerCase().indexOf("precip") > -1) { status = "wet"; label = "Wet weather corridor"; }
  else if (slxFinite(speed)) { status = "clear"; label = "Weather corridor manageable"; }
  if (slxFinite(eta)) { label += " • route ETA " + String(eta) + " min"; }
  if (hold) { label += " • safe hold recommended"; slxIntel.routeConfidence.score -= 18; }
  slxIntel.weatherEta.status = status;
  slxIntel.weatherEta.label = label;
  slxIntel.weatherEta.etaMinutes = eta;
  slxIntel.weatherEta.holdRecommended = hold;
  if (slxTripOn() && hold && slxNow() - slxIntel.weatherEta.lastVoiceAt > 240000) { slxIntel.weatherEta.lastVoiceAt = slxNow(); slxSpeak("High risk weather ahead. Recommend a safe hold at the next good stop."); }
}

function slxEvaluateArrivalMode() {
  var dist = null;
  var end = null;
  var coords = slxCoords();
  var f = slxFix();
  var label = "Arrival standby";
  if (coords && coords.length && f) { end = coords[coords.length - 1]; dist = slxMilesBetween([Number(f.lng), Number(f.lat)], [Number(end[0]), Number(end[1])]); }
  slxIntel.arrival.distanceMiles = dist;
  if (!slxTripOn() || !slxFinite(dist)) { slxIntel.arrival.active = false; slxIntel.arrival.label = "Arrival standby"; return; }
  if (dist <= 0.08) { slxIntel.arrival.active = true; label = "Arrived"; if (!slxIntel.arrival.arrivedSpoken) { slxIntel.arrival.arrivedSpoken = true; slxSpeak("You have arrived."); } }
  else if (dist <= 0.35) { slxIntel.arrival.active = true; label = "Final approach • slow and confirm entrance"; if (slxNow() - slxIntel.arrival.lastVoiceAt > 90000) { slxIntel.arrival.lastVoiceAt = slxNow(); slxSpeak("Final approach. Slow down and confirm truck entrance."); } }
  else if (dist <= 1.0) { slxIntel.arrival.active = true; label = "Arrival mode active • " + slxFormatMiles(dist); }
  else if (dist <= 3.0) { slxIntel.arrival.active = false; label = "Approach zone ahead • " + slxFormatMiles(dist); }
  else { slxIntel.arrival.active = false; label = "Arrival standby"; slxIntel.arrival.arrivedSpoken = false; }
  slxIntel.arrival.label = label;
}

function slxSignalReputation() {
  var raw = slxLsGet("slx_driver_signal_score_v1");
  var obj = slxParse(raw) || {};
  var score = Number(obj.score || obj.trust || 50);
  var verified = Number(obj.verified || 0);
  var total = Number(obj.total || 0);
  var created = Number(obj.created || 0);
  if (!slxFinite(score)) { score = 50; }
  if (created > 0) { score += Math.min(created * 1.5, 18); }
  if (verified > 0) { score += Math.min(verified * 3, 24); }
  if (total > 0 && verified / total < 0.25) { score -= 8; }
  score = slxClamp(Math.round(score), 0, 100);
  slxIntel.signalRep.score = score;
  slxIntel.signalRep.verified = verified;
  slxIntel.signalRep.total = total;
  if (score >= 85) { slxIntel.signalRep.label = "Signal trust elite"; }
  else if (score >= 70) { slxIntel.signalRep.label = "Signal trust strong"; }
  else if (score >= 50) { slxIntel.signalRep.label = "Signal trust baseline"; }
  else { slxIntel.signalRep.label = "Signal trust building"; }
  slxLsSet("slx_driver_signal_score_v1", JSON.stringify({ score: score, verified: verified, total: total, updatedAt: slxNow() }));
}

function slxEvaluateRouteConfidence() {
  var score = 82;
  var reasons = [];
  var parking = slxIntel.parkingWindow.status;
  var weather = slxIntel.weatherEta.status;
  var curve = slxIntel.curve.level;
  var brake = window.brakeState || {};
  var traffic = window.trafficState || {};
  var fuel = window.fuelState || {};
  var f = slxFix();
  if (!slxTripOn()) { slxIntel.routeConfidence.score = 70; slxIntel.routeConfidence.label = "CONFIDENCE: STANDBY"; slxIntel.routeConfidence.reason = "Trip not active"; return; }
  if (!f) { score -= 18; reasons.push("GPS waiting"); }
  if (String(traffic.density || "") === "heavy") { score -= 12; reasons.push("traffic heavy"); }
  if (String(fuel.status || "") === "risk" || String(fuel.status || "") === "sparse") { score -= 12; reasons.push("fuel gap"); }
  if (parking === "bad" || parking === "thin") { score -= 10; reasons.push("parking risk"); }
  if (weather === "high") { score -= 20; reasons.push("weather risk"); } else if (weather === "watch" || weather === "wet") { score -= 8; reasons.push("weather watch"); }
  if (curve === "high") { score -= 10; reasons.push("sharp curve"); }
  if (String(brake.level || "") === "high") { score -= 12; reasons.push("brake exposure"); }
  score += Math.round((slxIntel.signalRep.score - 50) / 8);
  score = slxClamp(score, 0, 100);
  slxIntel.routeConfidence.score = score;
  if (score >= 82) { slxIntel.routeConfidence.label = "CONFIDENCE: HIGH"; }
  else if (score >= 62) { slxIntel.routeConfidence.label = "CONFIDENCE: MEDIUM"; }
  else { slxIntel.routeConfidence.label = "CONFIDENCE: LOW"; }
  if (!reasons.length) { reasons.push("stable corridor"); }
  slxIntel.routeConfidence.reason = reasons.slice(0, 2).join(" + ");
}

function slxEvaluateCorridorAssist() {
  var traffic = window.trafficState || {};
  var weather = slxIntel.weatherEta ? slxIntel.weatherEta.status : "stable";
  var parking = slxIntel.parkingWindow ? slxIntel.parkingWindow.status : "stable";
  var label = "Corridor assist standby";
  var status = "standby";
  var now = slxNow();

  if (!slxTripOn()) {
    slxIntel.corridorAssist.status = "standby";
    slxIntel.corridorAssist.label = label;
    return;
  }

  /* Safety and survivability first */
  if (weather === "high") {
    status = "hold";
    label = "Safe hold may beat reroute";
  } else if (parking === "bad") {
    status = "stop_first";
    label = "Parking window first";
  } else if (String(traffic.density || "") === "heavy") {
    if ((window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.initialQuiet ? window.SLX_TRUST_GUARD.initialQuiet() : false) || (window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.localTrip ? window.SLX_TRUST_GUARD.localTrip() : false) || (window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.arrivalAuthority ? window.SLX_TRUST_GUARD.arrivalAuthority() : false)) {
      status = "stable";
      label = "Route stable • monitoring ahead";
    } else {
      status = "reroute_watch";
      label = "Watching for faster corridor";
    }
  } else {
    status = "stable";
    label = "Current corridor preferred";
  }

  slxIntel.corridorAssist.status = status;
  slxIntel.corridorAssist.label = label;

  /* Voice is restrained. Only speaks useful high-impact changes. */
  if (status === "reroute_watch" && now - slxIntel.corridorAssist.lastVoiceAt > 420000) {
    slxIntel.corridorAssist.lastVoiceAt = now;
    slxSpeak("Traffic is building. I’ll only surface a faster corridor if the time savings are meaningful.");
  }

  if (status === "hold" && now - slxIntel.corridorAssist.lastVoiceAt > 300000) {
    slxIntel.corridorAssist.lastVoiceAt = now;
    slxSpeak("Weather risk ahead. A safe hold may be smarter than rerouting.");
  }

  if (status === "stop_first" && now - slxIntel.corridorAssist.lastVoiceAt > 420000) {
    if (!(window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.initialQuiet ? window.SLX_TRUST_GUARD.initialQuiet() : false) && !(window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.arrivalAuthority ? window.SLX_TRUST_GUARD.arrivalAuthority() : false)) {
      slxIntel.corridorAssist.lastVoiceAt = now;
      slxSpeak("Parking window matters ahead. I’ll prioritize real stop evidence before interrupting you.");
    }
  }
}

function slxSmartIntelTick() {
  slxEnsureSmartHorizonCards();
  slxInstallSmartStyles();
  slxEnsureSmartBadge();
  slxEnsureFounderBadge();
  slxLoadMomentumMode();
  slxSignalReputation();
  slxEvaluateCurveSpeed();
  slxBoostBrakeExposure();
  slxEvaluateParkingWindow();
  slxEvaluateWeatherEta();
  slxEvaluateArrivalMode();
  slxEvaluateRouteConfidence();
  slxEvaluateCorridorAssist();
  slxText("slxSigConfidence", slxIntel.routeConfidence.label + " • " + slxIntel.routeConfidence.reason);
  slxText("slxSigCurve", slxIntel.curve.label);
  slxText("slxSigParkingWindow", slxIntel.parkingWindow.label);
  slxText("slxSigWeatherEta", slxIntel.weatherEta.label);
  slxText("slxSigArrival", slxIntel.arrival.label);
  slxText("slxSigAssist", slxIntel.corridorAssist.label);
  slxUpdateSmartBadge();
}

window.slxSmartIntelTick = slxSmartIntelTick;
window.slxEvaluateRouteConfidence = slxEvaluateRouteConfidence;
window.slxEvaluateCurveSpeed = slxEvaluateCurveSpeed;
window.slxEvaluateParkingWindow = slxEvaluateParkingWindow;
window.slxEvaluateWeatherEta = slxEvaluateWeatherEta;
window.setTimeout(slxSmartIntelTick, 900);
window.setTimeout(slxSmartIntelTick, 2400);
window.setInterval(slxSmartIntelTick, 3500);

})();

/* ------------------------------------------------------------------------
   STOP SCANNING
------------------------------------------------------------------------ */

function classifyStopFromText(txt) {
  txt = String(txt || "").toLowerCase();

  if (txt.indexOf("rest area") > -1 || txt.indexOf("welcome center") > -1 || txt.indexOf("service plaza") > -1) { return "rest_area"; }
  if (txt.indexOf("pilot") > -1 || txt.indexOf("flying j") > -1 || txt.indexOf("love") > -1 || txt.indexOf("petro") > -1 || txt.indexOf("travelcenters of america") > -1 || txt.indexOf("travel center") > -1 || txt.indexOf("truck stop") > -1 || txt.indexOf("diesel") > -1 || txt.indexOf("fuel") > -1) { return "fuel"; }
  if (txt.indexOf("parking") > -1 || txt.indexOf("garage") > -1 || txt.indexOf("lot") > -1 || txt.indexOf("walmart") > -1 || txt.indexOf("kroger") > -1 || txt.indexOf("target") > -1 || txt.indexOf("shopping") > -1 || txt.indexOf("supermarket") > -1 || txt.indexOf("plaza") > -1) { return "parking"; }

  return "surface_stop";
}

function confidenceFromText(txt) {
  txt = String(txt || "").toLowerCase();

  if (txt.indexOf("pilot") > -1 || txt.indexOf("flying j") > -1 || txt.indexOf("love") > -1 || txt.indexOf("petro") > -1 || txt.indexOf("truck stop") > -1 || txt.indexOf("travel center") > -1) { return 5; }
  if (txt.indexOf("rest area") > -1) { return 4; }
  if (txt.indexOf("parking") > -1 || txt.indexOf("garage") > -1 || txt.indexOf("lot") > -1) { return 3; }
  if (txt.indexOf("walmart") > -1 || txt.indexOf("kroger") > -1 || txt.indexOf("shopping") > -1 || txt.indexOf("plaza") > -1) { return 2; }

  return 1;
}

function getScanFix() {
  if (currentFix && isFiniteNumber(currentFix.lat) && isFiniteNumber(currentFix.lng)) { return currentFix; }
  if (routeTargetFix && isFiniteNumber(routeTargetFix.lat) && isFiniteNumber(routeTargetFix.lng)) { return routeTargetFix; }
  if (rawFix && isFiniteNumber(rawFix.lat) && isFiniteNumber(rawFix.lng)) { return rawFix; }
  return null;
}

function applyStopCandidates(list, provider, keepExistingOnEmpty) {
  var out = list || [];

  if (!out.length && keepExistingOnEmpty && lastGoodStopList.length) {
    window.stopIntentState.visibleCandidates = lastGoodStopList.slice(0, 12);
    window.stopIntentState.active = true;
    window.stopIntentState.inferred = "parking";
    window.stopIntentState.lastProvider = provider || "cached";
    drawStopGlow(lastGoodStopList.slice(0, 12));
    refreshVisibleParkingGlow();
    updateHorizon();
    return false;
  }

  window.stopIntentState.visibleCandidates = out.slice(0, 12);
  window.stopIntentState.active = out.length > 0;
  window.stopIntentState.inferred = "parking";
  window.stopIntentState.lastScanAt = nowMs();
  window.stopIntentState.lastProvider = provider || "";

  if (out.length) { lastGoodStopList = out.slice(0, 12); }

  updateFuelPredictor();
  updateTrafficDensityPrediction();
  updateParkingPressureState();
  drawStopGlow(out.slice(0, 12));
  refreshVisibleParkingGlow();
  updateHorizon();

  return out.length > 0;
}

function normalizeStopRowsFromGeoapify(data, f) {
  var feats = data && data.features ? data.features : [];
  var out = [];
  var seen = {};
  var i, p, c, name, cats, txt, type, d, key2, conf;

  for (i = 0; i < feats.length; i++) {
    p = feats[i].properties || {};
    c = feats[i].geometry && feats[i].geometry.coordinates ? feats[i].geometry.coordinates : null;

    if (!c || c.length !== 2) { continue; }

    name = String(p.name || p.address_line1 || p.formatted || "Nearby stop");
    cats = String((p.categories || []).join(" ")).toLowerCase();
    txt = (name + " " + cats).toLowerCase();
    type = classifyStopFromText(txt);
    conf = confidenceFromText(txt) + slxTruckStopPriorityScore(txt) - slxPenaltyForWeakFuel(txt);

    if (type === "surface_stop" && conf < 2) { continue; }

    d = milesBetween([Number(f.lng), Number(f.lat)], [Number(c[0]), Number(c[1])]);
    if (!isFiniteNumber(d) || d > 80) { continue; }

    key2 = String(Number(c[0]).toFixed(5)) + "," + String(Number(c[1]).toFixed(5));
    if (seen[key2]) { continue; }

    seen[key2] = true;

    out.push({ label: name, name: name, type: type, coord: [Number(c[0]), Number(c[1])], distMiles: d, confidence: conf, truckFriendly: slxIsTruckFriendlyStopText(txt), markerLabel: slxTruckFriendlyLabel(txt,type) });
  }

  out.sort(function (a, b) {
    if (a.confidence !== b.confidence) { return b.confidence - a.confidence; }
    return a.distMiles - b.distMiles;
  });

  return out;
}

function scanStopsGeoapify(forceVoice) {
  var f = getScanFix();
  var key = String(window.SLX_GEOAPIFY_KEY || geoapifyKey || "");
  var urlPrimary, urlBroad;

  if (!f) {
    setSubline("GPS fix missing");
    if (forceVoice) { primeVoiceThenSpeak("GPS fix missing"); }
    return;
  }

  if (!key) {
    setSubline("Geoapify key missing");
    if (forceVoice) { primeVoiceThenSpeak("Geoapify key missing"); }
    return;
  }

  setSubline("Scanning nearby stop surfaces...");
  if (forceVoice && nowMs() - lastScanVoiceAt > 2500) {
    lastScanVoiceAt = nowMs();
    primeVoiceThenSpeak("Scanning stops ahead");
  }

  urlPrimary = "https://api.geoapify.com/v2/places?categories=" +
    encodeURIComponent("service.vehicle.parking,service.vehicle.fuel,commercial.supermarket,commercial.shopping_mall,catering.restaurant,service,accommodation") +
    "&filter=circle:" + encodeURIComponent(String(f.lng) + "," + String(f.lat) + ",25000") +
    "&bias=proximity:" + encodeURIComponent(String(f.lng) + "," + String(f.lat)) +
    "&limit=50&apiKey=" + encodeURIComponent(key);

  urlBroad = "https://api.geoapify.com/v2/places?categories=" +
    encodeURIComponent("service,commercial,catering,accommodation") +
    "&filter=circle:" + encodeURIComponent(String(f.lng) + "," + String(f.lat) + ",12000") +
    "&bias=proximity:" + encodeURIComponent(String(f.lng) + "," + String(f.lat)) +
    "&limit=50&apiKey=" + encodeURIComponent(key);

  fetch(urlPrimary).then(function (r) {
    return r.json();
  }).then(function (data) {
    var out = normalizeStopRowsFromGeoapify(data, f);

    if (out.length) {
      applyStopCandidates(out.slice(0, 12), "geoapify", false);
      setSubline("Stops surfaced: " + String(out[0].label || "nearby"));
      if (forceVoice) { primeVoiceThenSpeak("Nearby stops surfaced"); }
      forceCockpitFollowLock();
      return;
    }

    return fetch(urlBroad).then(function (r2) {
      return r2.json();
    }).then(function (data2) {
      var out2 = normalizeStopRowsFromGeoapify(data2, f);

      if (out2.length) {
        applyStopCandidates(out2.slice(0, 12), "geoapify-broad", false);
        setSubline("Stops surfaced: " + String(out2[0].label || "nearby"));
        if (forceVoice) { primeVoiceThenSpeak("Nearby stops surfaced"); }
        forceCockpitFollowLock();
        return;
      }

      scanStopsMapboxFallback(forceVoice);
    });
  }).catch(function () {
    scanStopsMapboxFallback(forceVoice);
  });
}

function scanStopsMapboxFallback(forceVoice) {
  var out = collectVisibleParkingPois();

  if (out.length) {
    applyStopCandidates(out.slice(0, 12), "mapbox", false);
    setSubline("Stops surfaced: " + String(out[0].label || "nearby"));
    if (forceVoice) { primeVoiceThenSpeak("Nearby stops surfaced"); }
    forceCockpitFollowLock();
  } else {
    applyStopCandidates([], "mapbox-empty", true);
    if (lastGoodStopList.length) { setSubline("Using last stop scan"); }
    else {
      setSubline("No nearby stop candidates returned");
      if (forceVoice) { primeVoiceThenSpeak("No nearby stop candidates returned"); }
    }
  }
}

window.scanStopsTick = function () { scanStopsGeoapify(true); };
window.scanVisibleParkingNow = function (forceVoice) { scanStopsGeoapify(!!forceVoice); };
window.slxRunHardScan = function () { scanStopsGeoapify(true); };

/* =========================================================
SLX PARKING PRESSURE COLOR ENGINE V1
Adds green / amber / red parking confidence coloring
========================================================= */
(function(){
"use strict";

if(window.__SLX_PARKING_PRESSURE_COLOR_ENGINE_V1__){return;}
window.__SLX_PARKING_PRESSURE_COLOR_ENGINE_V1__=true;

function getPressureColor(feature){

  try{

    var p=feature.properties||{};
    var type=String(p.type||"").toLowerCase();

    if(type.indexOf("fuel")>-1){
      return "#6fd3ff"; // keep fuel cyan-blue
    }

    /* explicit pressure hint from signal */
    if(p.pressure==="open"){return "#4cff9a";}
    if(p.pressure==="tight"){return "#ffd35a";}
    if(p.pressure==="full"){return "#ff5a5a";}

    /* fallback heuristics using distance + time window */
    var miles=Number(p.distance||p.distanceMiles||0);

    if(isFinite(miles)){

      if(miles>40){
        return "#4cff9a"; // early window = green
      }

      if(miles>15){
        return "#ffd35a"; // mid window = amber
      }

      return "#ff5a5a"; // close window = red risk
    }

  }catch(e){}

  return "#00ffd0"; // default legacy blue
}

function applyParkingColors(){

  var map=
    (window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.getMap)
      ? window.__SLX_CORE_BRIDGE__.getMap()
      : (window.map||window.slxMap||window.SLX_MAP);

  if(!map || !map.getSource){return;}

  var src=map.getSource("slx-stop-src");

  if(!src || !src._data || !src._data.features){return;}

  var geo=src._data;
  var i,f;

  for(i=0;i<geo.features.length;i++){

    f=geo.features[i];

    if(!f.properties){continue;}

    f.properties.__slx_color=getPressureColor(f);
  }

  try{
    src.setData(geo);
  }catch(e){}

}

function installLayerColorBinding(){

  var map=
    (window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.getMap)
      ? window.__SLX_CORE_BRIDGE__.getMap()
      : (window.map||window.slxMap||window.SLX_MAP);

  if(!map || !map.setPaintProperty){return;}

  try{

    if(map.getLayer("slx-stop-core")){

      map.setPaintProperty(
        "slx-stop-core",
        "circle-stroke-color",
        ["coalesce",["get","__slx_color"],"#00ffd0"]
      );

    }

  }catch(e){}

}

function refresh(){

  applyParkingColors();
  installLayerColorBinding();

}

setTimeout(refresh,900);
setTimeout(refresh,2200);
setInterval(refresh,5000);

window.slxRefreshParkingPressureColors=refresh;

})();

/* =========================================================
SLX PARKING PRESSURE PULSE ENGINE
Adds confidence-based halo pulse strength
========================================================= */

(function(){

if(window.__SLX_PARKING_PULSE_ENGINE__){return;}
window.__SLX_PARKING_PULSE_ENGINE__=true;

function applyPulse(){

var map=
(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.getMap)?
window.__SLX_CORE_BRIDGE__.getMap():
(window.map||window.slxMap||window.SLX_MAP);

if(!map||!map.getLayer){return;}

try{

map.setPaintProperty(
"slx-stop-halo",
"circle-opacity",
[
"interpolate",
["linear"],
["zoom"],
8,0.18,
12,0.26,
16,0.34
]
);

}catch(e){}

}

setTimeout(applyPulse,1200);

})();

/* =========================================================
SLX CLEANUP PATCH — badge dedupe + route intel lift
========================================================= */
(function(){
"use strict";

if(window.__SLX_CLEANUP_PATCH_V1__){return;}
window.__SLX_CLEANUP_PATCH_V1__=true;

function byId(id){return document.getElementById(id);}

function installCleanupStyles(){
  var st=byId("slxCleanupPatchV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxCleanupPatchV1";
  st.textContent=
    "#slxProBadgeRail{display:none!important;}"+
    "#slxDriverBadges{top:calc(8px + env(safe-area-inset-top,0px))!important;left:18px!important;z-index:2147483000!important;}"+
    ".slxTop{padding-top:calc(var(--safe-top,0px) + 58px)!important;}"+
    "#slxSmartBadge{bottom:calc(112px + env(safe-area-inset-bottom,0px))!important;left:52%!important;max-width:240px!important;}"+
    ".slxDock{height:56px!important;bottom:calc(8px + env(safe-area-inset-bottom,0px))!important;}"+

    "@media (orientation:landscape){"+
      "#slxDriverBadges{left:calc(455px + env(safe-area-inset-left,0px))!important;top:calc(8px + env(safe-area-inset-top,0px))!important;}"+
      ".slxTop{padding-top:calc(var(--safe-top,0px) + 8px)!important;}"+
      "#slxSmartBadge{bottom:calc(92px + env(safe-area-inset-bottom,0px))!important;left:auto!important;right:calc(310px + env(safe-area-inset-right,0px))!important;transform:none!important;}"+
    "}";

  document.head.appendChild(st);
}

installCleanupStyles();

})();

/* =========================================================
SLX BADGE GHOST CLEANUP
========================================================= */
(function(){
"use strict";

if(window.__SLX_BADGE_GHOST_CLEANUP_V1__){return;}
window.__SLX_BADGE_GHOST_CLEANUP_V1__=true;

function cleanBadgeGhosts(){
  var badges=document.querySelectorAll(".slxProBadge,.slxDriverBadge");
  var seen={};
  var i,b,txt,key;

  for(i=0;i<badges.length;i++){
    b=badges[i];
    txt=String(b.textContent||"").replace(/\s+/g," ").trim();
    key=txt.toUpperCase();

    if(!txt){continue;}

    if(seen[key]){
      b.style.display="none";
      b.style.visibility="hidden";
      b.style.opacity="0";
      b.setAttribute("data-show","false");
    }else{
      seen[key]=true;
    }
  }
}

cleanBadgeGhosts();
setTimeout(cleanBadgeGhosts,500);
setTimeout(cleanBadgeGhosts,1500);
setInterval(cleanBadgeGhosts,2500);

})();

/* =========================================================
SLX BADGE DOUBLE-TEXT FIX
removes stacked glow-layer duplicate inside FD badge
========================================================= */
(function(){
"use strict";

if(window.__SLX_BADGE_TEXT_STACK_FIX_V1__){return;}
window.__SLX_BADGE_TEXT_STACK_FIX_V1__=true;

function fixBadgeTextStack(){
  var badges=document.querySelectorAll(".slxDriverBadge,.slxProBadge");
  var i,b;

  for(i=0;i<badges.length;i++){
    b=badges[i];

    /* remove duplicated shadow text layer */
    b.style.textShadow="none";

    /* ensure single render layer */
    b.style.webkitTextStroke="0px transparent";

    /* stabilize font smoothing */
    b.style.webkitFontSmoothing="antialiased";
  }
}

fixBadgeTextStack();
setTimeout(fixBadgeTextStack,600);
setTimeout(fixBadgeTextStack,1600);

})();

/* =========================================================
SLX DRIVER DASHBOARD — SAFE FINAL LAYOUT + STOP PIN RESTORE
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

Spacing only.
Preserves Horizon colors.
Preserves current badges.
Restores glowing stop pins.
No camera / route / voice / paywall logic changes.
========================================================= */
(function(){
"use strict";

if(window.__SLX_SAFE_FINAL_LAYOUT_STOP_RESTORE_V1__){return;}
window.__SLX_SAFE_FINAL_LAYOUT_STOP_RESTORE_V1__=true;

function byId(id){return document.getElementById(id);}

function installFinalLayout(){
  var st=byId("slxSafeFinalLayoutStopRestoreV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxSafeFinalLayoutStopRestoreV1";
  st.textContent=
    "html,body,#slxApp{overscroll-behavior:none!important;}"+

    "body #slxProBadgeRail{display:none!important;}"+

    "body #slxDriverBadges{top:calc(14px + env(safe-area-inset-top,0px))!important;left:24px!important;z-index:2147483000!important;display:flex!important;gap:7px!important;align-items:center!important;}"+
    "body #slxDriverBadges .slxDriverBadge{min-height:24px!important;padding:5px 9px!important;font-size:10px!important;line-height:1!important;text-shadow:none!important;-webkit-text-stroke:0!important;}"+
    "body #slxDriverBadges .slxDriverBadge[data-type='founder']{box-shadow:0 0 18px rgba(0,255,210,.18),0 8px 18px rgba(0,0,0,.26)!important;}"+

    "body .slxTop{padding-top:calc(var(--safe-top,0px) + 72px)!important;left:calc(12px + var(--safe-left,0px))!important;right:calc(82px + var(--safe-right,0px))!important;z-index:90!important;}"+
    "body .slxHeader{padding:7px 12px!important;border-radius:24px!important;}"+
    "body .slxTitle{font-size:15px!important;line-height:1.05!important;}"+
    "body .slxSub{font-size:11px!important;margin-top:2px!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}"+

    "body #slxHTrack{gap:4px!important;max-height:152px!important;overflow:hidden!important;padding-right:44px!important;}"+
    "body #slxHTrack[data-minimized='true']{height:38px!important;max-height:38px!important;overflow:hidden!important;opacity:.94!important;}"+
    "body .slxSignal{padding:6px 9px!important;border-radius:13px!important;font-size:11px!important;min-height:31px!important;}"+
    "body .slxSignalText{max-width:235px!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;font-weight:950!important;}"+

    "body #slxHMinBtn{right:6px!important;top:5px!important;width:36px!important;height:36px!important;min-width:36px!important;min-height:36px!important;z-index:2147483647!important;pointer-events:auto!important;touch-action:manipulation!important;}"+

    "body #slxDriverHud{bottom:calc(82px + env(safe-area-inset-bottom,0px))!important;left:14px!important;gap:5px!important;}"+
    "body #slxDriverHud [id^='slxHud_'],body [id^='slxHud_']{min-width:96px!important;padding:5px 8px!important;font-size:9px!important;border-radius:10px!important;line-height:1.05!important;}"+

    "body #slxTurnCard{left:14px!important;bottom:calc(224px + env(safe-area-inset-bottom,0px))!important;max-width:250px!important;min-width:172px!important;padding:8px 10px!important;border-radius:14px!important;z-index:116!important;}"+
    "body #slxTurnCard .slxTurnEyebrow{font-size:9px!important;margin-bottom:3px!important;}"+
    "body #slxTurnCard .slxTurnMain{font-size:12px!important;line-height:1.16!important;}"+
    "body #slxTurnCard .slxTurnSub{font-size:9px!important;margin-top:3px!important;}"+

    "body #slxSmartBadge{left:auto!important;right:24px!important;bottom:calc(126px + env(safe-area-inset-bottom,0px))!important;transform:none!important;max-width:248px!important;min-width:190px!important;padding:9px 12px!important;z-index:118!important;}"+

    "body .slxRight{right:calc(8px + var(--safe-right,0px))!important;top:calc(var(--safe-top,0px) + 322px)!important;width:52px!important;gap:5px!important;max-height:calc(100vh - 430px - var(--safe-bottom,0px))!important;}"+
    "body .slxBtn{min-height:38px!important;border-radius:14px!important;font-size:12px!important;}"+

    "body .slxDock{height:58px!important;gap:8px!important;bottom:calc(8px + env(safe-area-inset-bottom,0px))!important;z-index:97!important;}"+
    "body .slxDock button{border-radius:16px!important;font-size:13px!important;}"+

    "@media (max-width:430px){"+
      "body #slxDriverBadges{top:calc(12px + env(safe-area-inset-top,0px))!important;left:22px!important;}"+
      "body .slxTop{padding-top:calc(var(--safe-top,0px) + 72px)!important;}"+
      "body #slxHTrack{max-height:150px!important;}"+
      "body .slxSignalText{max-width:215px!important;}"+
      "body #slxTurnCard{left:14px!important;bottom:calc(224px + env(safe-area-inset-bottom,0px))!important;max-width:238px!important;}"+
      "body #slxSmartBadge{right:24px!important;bottom:calc(126px + env(safe-area-inset-bottom,0px))!important;max-width:230px!important;}"+
    "}"+

    "@media (orientation:landscape){"+
      "body #slxDriverBadges{left:calc(455px + env(safe-area-inset-left,0px))!important;top:calc(8px + env(safe-area-inset-top,0px))!important;}"+
      "body .slxTop{left:calc(10px + var(--safe-left,0px))!important;right:calc(86px + var(--safe-right,0px))!important;padding-top:calc(var(--safe-top,0px) + 8px)!important;max-width:430px!important;}"+
      "body .slxHeader{padding:6px 10px!important;border-radius:20px!important;}"+
      "body .slxTitle{font-size:13px!important;}"+
      "body .slxSub{font-size:10px!important;}"+
      "body #slxHTrack{max-height:116px!important;max-width:410px!important;gap:3px!important;padding-right:42px!important;}"+
      "body .slxSignal{min-height:27px!important;padding:5px 8px!important;font-size:10px!important;border-radius:12px!important;}"+
      "body .slxSignalText{max-width:315px!important;}"+
      "body .slxRight{top:calc(var(--safe-top,0px) + 72px)!important;right:calc(8px + var(--safe-right,0px))!important;width:48px!important;max-height:calc(100vh - 146px - var(--safe-bottom,0px))!important;}"+
      "body .slxBtn{min-height:34px!important;border-radius:12px!important;font-size:11px!important;}"+
      "body .slxDock{left:calc(10px + var(--safe-left,0px))!important;right:calc(74px + var(--safe-right,0px))!important;height:48px!important;bottom:calc(6px + env(safe-area-inset-bottom,0px))!important;gap:7px!important;}"+
      "body .slxDock button{font-size:12px!important;border-radius:14px!important;}"+
      "body #slxDriverHud{left:12px!important;bottom:calc(58px + env(safe-area-inset-bottom,0px))!important;}"+
      "body #slxDriverHud [id^='slxHud_'],body [id^='slxHud_']{min-width:82px!important;font-size:8px!important;padding:4px 6px!important;}"+
      "body #slxTurnCard{left:112px!important;bottom:calc(116px + env(safe-area-inset-bottom,0px))!important;max-width:218px!important;min-width:160px!important;padding:7px 9px!important;}"+
      "body #slxSmartBadge{right:calc(310px + env(safe-area-inset-right,0px))!important;bottom:calc(88px + env(safe-area-inset-bottom,0px))!important;max-width:250px!important;}"+
    "}";

  document.head.appendChild(st);
}

function getStopList(){
  var list=[];
  try{
    if(window.stopIntentState&&window.stopIntentState.visibleCandidates&&window.stopIntentState.visibleCandidates.length){
      list=window.stopIntentState.visibleCandidates;
    }
  }catch(e1){}

  if(list&&list.length){
    window.__SLX_LAST_STOP_LIST__=list;
    return list;
  }

  try{
    if(window.__SLX_LAST_STOP_LIST__&&window.__SLX_LAST_STOP_LIST__.length){
      return window.__SLX_LAST_STOP_LIST__;
    }
  }catch(e2){}

  return [];
}

function restoreStopPins(){
  var list=getStopList();
  if(!list||!list.length){return;}

  try{
    if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.drawStops){
      window.__SLX_CORE_BRIDGE__.drawStops(list);
      return;
    }
  }catch(e1){}

  try{
    if(window.slxDrawParkingGlow){
      window.slxDrawParkingGlow(list);
      return;
    }
  }catch(e2){}

  try{
    if(window.slxPgDrawGlow){
      window.slxPgDrawGlow(list);
      return;
    }
  }catch(e3){}
}

function tick(){
  installFinalLayout();
  restoreStopPins();
}

window.slxRestoreStopPins=restoreStopPins;

tick();
window.setTimeout(tick,700);
window.setTimeout(tick,1800);
window.setTimeout(tick,3600);
window.setInterval(tick,5000);

})();

/* =========================================================
SLX HORIZON PRIORITY ENGINE V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

Reorders Horizon by live severity.
Shows top 4 clean rows.
Does not touch map, camera, route, pins, badges, or voice.
========================================================= */
(function(){
"use strict";

if(window.__SLX_HORIZON_PRIORITY_ENGINE_V1__){return;}
window.__SLX_HORIZON_PRIORITY_ENGINE_V1__=true;

function byId(id){return document.getElementById(id);}

function txt(el){
  return String(el && el.textContent ? el.textContent : "").toLowerCase();
}

function scoreSignal(row){
  var t=txt(row);
  var id="";
  var span=row ? row.querySelector(".slxSignalText") : null;

  if(span&&span.id){id=span.id;}

  var s=0;

  /* base role priority */
  if(id==="slxSigTurn"){s+=60;}
  if(id==="slxSigWeather"){s+=55;}
  if(id==="slxSigParking"){s+=45;}
  if(id==="slxSigFuel"){s+=40;}
  if(id==="slxSigTraffic"){s+=38;}
  if(id==="slxSigCorridor"){s+=30;}
  if(id==="slxSigCurve"){s+=52;}
  if(id==="slxSigWeatherEta"){s+=54;}
  if(id==="slxSigParkingWindow"){s+=44;}
  if(id==="slxSigConfidence"){s+=36;}
  if(id==="slxSigArrival"){s+=58;}
  if(id==="slxSigAssist"){s+=28;}

  /* urgent turn / arrival */
  if(t.indexOf("now")>-1||t.indexOf("0 mi")>-1||t.indexOf("arrived")>-1){s+=80;}
  if(t.indexOf("turn")>-1&&t.indexOf("standby")<0){s+=35;}
  if(t.indexOf("arrival")>-1||t.indexOf("final approach")>-1){s+=60;}

  /* severe weather / hazards */
  if(t.indexOf("tornado")>-1||t.indexOf("warning")>-1||t.indexOf("severe")>-1){s+=120;}
  if(t.indexOf("danger")>-1||t.indexOf("flash flood")>-1||t.indexOf("ice")>-1){s+=100;}
  if(t.indexOf("crosswind")>-1||t.indexOf("headwind")>-1||t.indexOf("high wind")>-1){s+=55;}
  if(t.indexOf("precip")>-1||t.indexOf("weather watch")>-1||t.indexOf("rain")>-1){s+=45;}

  /* road risk */
  if(t.indexOf("sharp curve")>-1){s+=70;}
  if(t.indexOf("downgrade")>-1||t.indexOf("brake")>-1){s+=75;}
  if(t.indexOf("off route")>-1||t.indexOf("route drift")>-1){s+=90;}

  /* parking / fuel / traffic */
  if(t.indexOf("parking likely full")>-1){s+=70;}
  if(t.indexOf("parking tightening")>-1){s+=55;}
  if(t.indexOf("parking likely open")>-1){s+=20;}

  if(t.indexOf("fuel gap")>-1||t.indexOf("top-off")>-1||t.indexOf("sparse fuel")>-1){s+=70;}
  if(t.indexOf("fuel corridor stable")>-1){s+=18;}

  if(t.indexOf("traffic heavy")>-1){s+=48;}
  if(t.indexOf("traffic moderate")>-1){s+=28;}

  /* reduce low-value standby rows */
  if(t.indexOf("standby")>-1){s-=80;}
  if(t.indexOf("stable corridor")>-1){s-=10;}

  return s;
}

function applyHorizonPriority(){
  var track=byId("slxHTrack");
  var rows,i,arr;

  if(!track){return;}

  rows=track.querySelectorAll(".slxSignal");
  if(!rows||!rows.length){return;}

  arr=[];
  for(i=0;i<rows.length;i++){
    arr.push({
      row:rows[i],
      score:scoreSignal(rows[i]),
      index:i
    });
  }

  arr.sort(function(a,b){
    if(b.score!==a.score){return b.score-a.score;}
    return a.index-b.index;
  });

  for(i=0;i<arr.length;i++){
    track.appendChild(arr[i].row);
    if(i<4){
      arr[i].row.style.display="";
    }else{
      arr[i].row.style.display="none";
    }
  }
}

function installPriorityStyles(){
  var st=byId("slxHorizonPriorityEngineStyleV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxHorizonPriorityEngineStyleV1";
  st.textContent=
    "#slxHTrack{max-height:none!important;overflow:visible!important;}"+
    "#slxHTrack .slxSignal{transition:opacity .18s ease!important;}";

  document.head.appendChild(st);
}

function tick(){
  installPriorityStyles();
  applyHorizonPriority();
}

tick();
setTimeout(tick,700);
setTimeout(tick,1800);
setInterval(tick,2500);

})();

/* =========================================================
SLX HIDE OLD FOUNDER BADGE GHOST
Stops flashing by hiding legacy badge instead of deleting it
========================================================= */
(function(){
"use strict";

if(window.__SLX_HIDE_OLD_FOUNDER_BADGE_GHOST_V1__){return;}
window.__SLX_HIDE_OLD_FOUNDER_BADGE_GHOST_V1__=true;

function installHideStyle(){
  var st=document.getElementById("slxHideOldFounderBadgeGhostV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxHideOldFounderBadgeGhostV1";
  st.textContent=
    "#slxFounderBadge{"+
      "display:none!important;"+
      "visibility:hidden!important;"+
      "opacity:0!important;"+
      "pointer-events:none!important;"+
    "}";

  document.head.appendChild(st);
}

installHideStyle();

})();

/* =========================================================
SLX CONFIDENCE-DRIVEN VOICE ENGINE V1
Adds smart co-pilot timing to horizon + confidence signals
Safe for cockpit camera, routing, map layers
========================================================= */

(function(){
"use strict";

if(window.__SLX_CONFIDENCE_VOICE_ENGINE_V1__){return;}
window.__SLX_CONFIDENCE_VOICE_ENGINE_V1__=true;

/* =========================================================
SAFE SPEAK WRAPPER
========================================================= */

function speak(msg){

  if(!msg){return;}

  if(!window.speechSynthesis){return;}

  try{

    window.speechSynthesis.cancel();

    var u=new SpeechSynthesisUtterance(msg);

    u.rate=1.0;
    u.pitch=1.0;
    u.volume=1.0;

    window.__SLX_FOUNDATION_SPEAK__(u);

  }catch(e){}

}

/* =========================================================
STATE TRACKING
========================================================= */

var lastConfidence=null;
var lastSpokenSignal="";
var lastSpeakTime=0;

var MIN_INTERVAL=18000; // 18 seconds anti-spam

function now(){return Date.now();}

/* =========================================================
READ CURRENT CONFIDENCE
========================================================= */

function getConfidence(){

  var el=document.getElementById("slxSigConfidence");

  if(!el){return null;}

  var t=String(el.textContent||"").toLowerCase();

  if(t.indexOf("low")>-1)return "low";
  if(t.indexOf("medium")>-1)return "medium";
  if(t.indexOf("high")>-1)return "high";

  return null;

}

/* =========================================================
READ TOP HORIZON SIGNAL
========================================================= */

function getTopSignal(){

  var track=document.getElementById("slxHTrack");

  if(!track){return "";}

  var first=track.querySelector(".slxSignal");

  if(!first){return "";}

  return String(first.textContent||"");

}

/* =========================================================
CONFIDENCE CHANGE HANDLER
========================================================= */

function confidenceChanged(newLevel){

  if(newLevel==="medium"){

    speak("Route confidence is stable ahead.");

  }

}

/* =========================================================
SIGNAL SPEECH PRIORITY FILTER
========================================================= */

function speakTopSignal(signal){

  var t=signal.toLowerCase();

  if(
  t.indexOf("downgrade")>-1 ||
  t.indexOf("steep descent")>-1 ||
  t.indexOf("brake early")>-1 ||
  t.indexOf("brake exposure")>-1
){

  speak("Downgrade ahead. Reduce speed early.");
  return true;

}

  if(t.indexOf("sharp curve")>-1){

    var slxCurveAlertSpeed = 0;
    var slxCurveAlertLimit = null;

    try { slxCurveAlertSpeed = Number(getSpeedMph ? getSpeedMph() : 0) || 0; } catch(eCv2) {}
    try {
      if (typeof speedState !== "undefined" && speedState && isFiniteNumber(Number(speedState.limitMph))) {
        slxCurveAlertLimit = Number(speedState.limitMph);
      }
    } catch(eCv3) {}

    /* V16: Do not voice curve warnings in neighborhoods / low-speed streets. */
    if (
      slxCurveAlertSpeed >= 45 ||
      (slxCurveAlertLimit !== null && slxCurveAlertLimit >= 50 && slxCurveAlertSpeed >= 35)
    ) {
      speak("Sharp curve ahead. Ease down.");
      return true;
    }

    return false;

  }

  if(t.indexOf("crosswind")>-1){

    speak("Crosswind ahead.");
    return true;

  }

  if(t.indexOf("parking window")>-1){

    speak("Parking window strong ahead.");
    return true;

  }

  if(t.indexOf("fuel gap")>-1){

    speak("Fuel gap ahead. Plan fuel stop.");
    return true;

  }

  if(t.indexOf("traffic heavy")>-1){

    speak("Traffic density increasing ahead.");
    return true;

  }

  if(t.indexOf("weather watch")>-1){

    speak("Weather watch ahead.");
    return true;

  }

  return false;

}

/* =========================================================
MAIN LOOP
========================================================= */

function tick(){

  var c=getConfidence();
  var sig=getTopSignal();

  if(!c){return;}

  if(c!==lastConfidence){

    confidenceChanged(c);

    lastConfidence=c;

    lastSpeakTime=now();

    return;

  }

  if(now()-lastSpeakTime<MIN_INTERVAL){

    return;

  }

  if(sig && sig!==lastSpokenSignal){

    if(speakTopSignal(sig)){

      lastSpokenSignal=sig;

      lastSpeakTime=now();

    }

  }

}

setInterval(tick,4000);

})();

/* =========================================================
SLX TRIP-PHASE VOICE PRIORITY PATCH V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

Purpose:
- Fuel/weather/traffic/curve/brake warnings can speak early.
- Parking voice is suppressed early.
- Parking voice unlocks mid/late trip or when near destination.
- Does not touch map, camera, route, pins, UI, badges.
========================================================= */
(function(){
"use strict";

if(window.__SLX_TRIP_PHASE_VOICE_PRIORITY_V1__){return;}
window.__SLX_TRIP_PHASE_VOICE_PRIORITY_V1__=true;

var lastParkingVoiceAt=0;
var lastFuelVoiceAt=0;
var lastPhase="";
var PARKING_COOLDOWN=240000;
var FUEL_COOLDOWN=180000;

function now(){return Date.now();}

function parseMilesFromText(t){
  var m;
  t=String(t||"");
  m=t.match(/([0-9]+(?:\.[0-9]+)?)\s*mi/i);
  if(m&&m[1]){return Number(m[1]);}
  return null;
}

function getRemainingMiles(){
  var el=document.getElementById("slxHud_miles");
  var txt,m;

  if(el){
    txt=String(el.textContent||"");
    m=parseMilesFromText(txt);
    if(typeof m==="number"&&isFinite(m)){return m;}
  }

  try{
    if(window.SLX_INTEL&&window.SLX_INTEL.arrival&&typeof window.SLX_INTEL.arrival.distanceMiles==="number"){
      return window.SLX_INTEL.arrival.distanceMiles;
    }
  }catch(e0){}

  return null;
}

function getTripStartedAt(){
  var keys=[
    "slx_trip_started_at_v1",
    "slx_active_trip_started_at_v1",
    "slx_start_trip_started_at_v1",
    "slx_trip_start_time_v1"
  ];
  var i,v,n,d;

  for(i=0;i<keys.length;i++){
    try{v=localStorage.getItem(keys[i]);}catch(e){v=null;}
    if(!v){continue;}

    n=Number(v);
    if(isFinite(n)&&n>1000000000){return n;}

    d=Date.parse(v);
    if(isFinite(d)){return d;}
  }

  return 0;
}

function getTripMinutes(){
  var started=getTripStartedAt();
  if(!started){return 0;}
  return Math.max(0,Math.round((now()-started)/60000));
}

function getTripPhase(){
  var miles=getRemainingMiles();
  var mins=getTripMinutes();

  if(typeof miles==="number"&&isFinite(miles)){
    if(miles<=45){return "arrival";}
    if(miles<=90){return "planning";}
  }

  if(mins>=120){return "planning";}
  if(mins>=20){return "cruise";}

  return "early";
}

function shouldAllowParkingVoice(){
  var phase=getTripPhase();

  if(phase==="planning"||phase==="arrival"){return true;}

  return false;
}

function isParkingSignal(t){
  t=String(t||"").toLowerCase();
  return (
    t.indexOf("parking")>-1 ||
    t.indexOf("good parking window")>-1 ||
    t.indexOf("parking window")>-1
  );
}

function isFuelSignal(t){
  t=String(t||"").toLowerCase();
  return (
    t.indexOf("fuel")>-1 ||
    t.indexOf("top-off")>-1 ||
    t.indexOf("sparse fuel")>-1 ||
    t.indexOf("fuel gap")>-1
  );
}

function speak(msg){
  try{
    if(window.slxQueueSpeak){window.slxQueueSpeak(msg,"normal");return;}
    if(window.slxPrimeVoiceThenSpeak){window.slxPrimeVoiceThenSpeak(msg);return;}
    if(window.slxSpeak){window.slxSpeak(msg);return;}
  }catch(e){}
}

function patchSpeakTopSignal(){
  if(!window.__SLX_CONFIDENCE_VOICE_ENGINE_V1__){return;}
  if(window.__SLX_TRIP_PHASE_SPEAK_PATCHED_V1__){return;}

  /*
    If the original engine exposes no hook, we still guide voice by scanning Horizon.
    This patch runs as a companion layer and suppresses early parking by simply
    not speaking parking until trip phase allows it.
  */
  window.__SLX_TRIP_PHASE_SPEAK_PATCHED_V1__=true;
}

function getVisibleSignals(){
  var track=document.getElementById("slxHTrack");
  var rows,out,i,t;

  out=[];
  if(!track){return out;}

  rows=track.querySelectorAll(".slxSignal");
  for(i=0;i<rows.length;i++){
    if(rows[i].style.display==="none"){continue;}
    t=String(rows[i].textContent||"").replace(/\s+/g," ").trim();
    if(t){out.push(t);}
  }
  return out;
}

function speakFuelIfNeeded(t){
  var low=String(t||"").toLowerCase();

  if(now()-lastFuelVoiceAt<FUEL_COOLDOWN){return false;}

  if(low.indexOf("fuel gap")>-1||low.indexOf("sparse fuel")>-1||low.indexOf("top-off")>-1){
    lastFuelVoiceAt=now();
    speak("Fuel corridor thinning ahead. Plan fuel stop.");
    return true;
  }

  return false;
}

function speakParkingIfAllowed(t){
  var phase=getTripPhase();
  var low=String(t||"").toLowerCase();

  if(!shouldAllowParkingVoice()){return false;}
  if(now()-lastParkingVoiceAt<PARKING_COOLDOWN){return false;}

  if(low.indexOf("good parking window")>-1||low.indexOf("parking likely open")>-1){
    lastParkingVoiceAt=now();
    speak("Good parking window now.");
    return true;
  }

  if(low.indexOf("parking tightening")>-1||low.indexOf("parking likely full")>-1){
    lastParkingVoiceAt=now();
    speak("Parking options tightening ahead.");
    return true;
  }

  if(phase==="arrival"&&low.indexOf("parking")>-1){
    lastParkingVoiceAt=now();
    speak("Parking availability nearby.");
    return true;
  }

  return false;
}

function tick(){
  var signals=getVisibleSignals();
  var i,t,phase;

  patchSpeakTopSignal();

  phase=getTripPhase();

  if(phase!==lastPhase){
    lastPhase=phase;
    try{localStorage.setItem("slx_voice_trip_phase_v1",phase);}catch(e0){}
  }

  for(i=0;i<signals.length;i++){
    t=signals[i];

    if(isFuelSignal(t)){
      if(speakFuelIfNeeded(t)){return;}
    }
  }

  for(i=0;i<signals.length;i++){
    t=signals[i];

    if(isParkingSignal(t)){
      if(speakParkingIfAllowed(t)){return;}
    }
  }
}

window.slxGetVoiceTripPhase=getTripPhase;
window.slxShouldAllowParkingVoice=shouldAllowParkingVoice;

setTimeout(tick,1500);
setTimeout(tick,5000);
setInterval(tick,12000);

})();

/* =========================================================
SLX PHASE-AWARE CONFIDENCE VOICE V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

Changes confidence voice wording by trip phase.
Does not touch map, UI, camera, route, pins, badges.
========================================================= */
(function(){
"use strict";

if(window.__SLX_PHASE_AWARE_CONFIDENCE_VOICE_V1__){return;}
window.__SLX_PHASE_AWARE_CONFIDENCE_VOICE_V1__=true;

var lastConfidence="";
var lastConfidenceVoiceAt=0;
var CONFIDENCE_COOLDOWN=180000;

function now(){return Date.now();}

function getPhase(){
  try{
    if(window.slxGetVoiceTripPhase){
      return String(window.slxGetVoiceTripPhase()||"early");
    }
  }catch(e){}
  return "early";
}

function getConfidenceText(){
  var el=document.getElementById("slxSigConfidence");
  if(!el){return "";}
  return String(el.textContent||"").toLowerCase();
}

function getConfidenceLevel(){
  var t=getConfidenceText();

  if(t.indexOf("low")>-1){return "low";}
  if(t.indexOf("medium")>-1){return "medium";}
  if(t.indexOf("high")>-1){return "high";}

  return "";
}

function speak(msg){
  try{
    if(window.slxQueueSpeak){window.slxQueueSpeak(msg,"normal");return;}
    if(window.slxPrimeVoiceThenSpeak){window.slxPrimeVoiceThenSpeak(msg);return;}
    if(window.slxSpeak){window.slxSpeak(msg);return;}
  }catch(e){}
}

function phrase(level,phase){
  if(level==="low"){
    if(phase==="early"){return "Route confidence low ahead.";}
    if(phase==="cruise"){return "Confidence dropping on the corridor ahead.";}
    if(phase==="planning"){return "Confidence low entering the stop planning window.";}
    if(phase==="arrival"){return "Confidence low approaching the destination corridor.";}
    return "Route confidence low ahead.";
  }

  if(level==="medium"){
    if(phase==="early"){return "Route confidence moderate.";}
    if(phase==="cruise"){return "Corridor confidence moderate.";}
    if(phase==="planning"){return "Stop planning window looks moderate.";}
    if(phase==="arrival"){return "Destination corridor confidence moderate.";}
    return "Route confidence moderate.";
  }

  return "";
}

function tick(){
  var level=getConfidenceLevel();
  var phase=getPhase();
  var msg;

  if(!level){return;}

  if(level==="high"){
    lastConfidence=level;
    return;
  }

  if(level===lastConfidence && now()-lastConfidenceVoiceAt<CONFIDENCE_COOLDOWN){
    return;
  }

  msg=phrase(level,phase);
  if(!msg){return;}

  lastConfidence=level;
  lastConfidenceVoiceAt=now();

  speak(msg);

  try{
    localStorage.setItem("slx_last_confidence_voice_phase_v1",phase);
    localStorage.setItem("slx_last_confidence_voice_level_v1",level);
  }catch(e){}
}

setTimeout(tick,3000);
setInterval(tick,15000);

})();

/* =========================================================
SLX GLOBAL CALM VOICE GOVERNOR V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

- Slows voice rate
- Spaces messages apart
- Prevents overlap/cutoff
- Gives turn/safety phrases priority
========================================================= */
(function(){
"use strict";

if(window.__SLX_GLOBAL_CALM_VOICE_GOVERNOR_V1__){return;}
window.__SLX_GLOBAL_CALM_VOICE_GOVERNOR_V1__=true;

var q=[];
var speaking=false;
var lastText="";
var lastAt=0;
var GAP_MS=4200;
var DUP_MS=9000;
var RATE=0.86;

function now(){return Date.now();}

function clean(t){
  return String(t||"")
    .replace(/\s+/g," ")
    .replace(/•/g,",")
    .trim();
}

function score(t){
  t=String(t||"").toLowerCase();

  if(t.indexOf("turn")>-1||t.indexOf("merge")>-1||t.indexOf("exit")>-1){return 100;}
  if(t.indexOf("downgrade")>-1||t.indexOf("brake")>-1){return 95;}
  if(t.indexOf("sharp curve")>-1){return 92;}
  if(t.indexOf("confidence low")>-1){return 85;}
  if(t.indexOf("weather")>-1||t.indexOf("crosswind")>-1||t.indexOf("headwind")>-1){return 75;}
  if(t.indexOf("fuel")>-1){return 65;}
  if(t.indexOf("parking")>-1){return 45;}

  return 50;
}

function pickVoice(){
  var voices,i,v,n,l;

  if(!window.speechSynthesis||!window.speechSynthesis.getVoices){return null;}

  try{voices=window.speechSynthesis.getVoices()||[];}catch(e){voices=[];}

  for(i=0;i<voices.length;i++){
    v=voices[i];
    n=String(v.name||"").toLowerCase();
    if(n.indexOf("samantha")>-1){return v;}
  }

  for(i=0;i<voices.length;i++){
    v=voices[i];
    l=String(v.lang||"").toLowerCase();
    if(l.indexOf("en-us")===0){return v;}
  }

  return voices.length?voices[0]:null;
}

function pump(){
  var item,u,voice,delay;

  if(speaking){return;}
  if(!q.length){return;}
  if(!window.speechSynthesis){return;}

  delay=Math.max(0,GAP_MS-(now()-lastAt));

  if(delay>0){
    setTimeout(pump,delay);
    return;
  }

  q.sort(function(a,b){
    return b.priority-a.priority;
  });

  item=q.shift();
  if(!item||!item.text){pump();return;}

  speaking=true;
  lastAt=now();

  try{
    voice=pickVoice();

    u=new SpeechSynthesisUtterance(item.text);
    if(voice){u.voice=voice;}

    u.rate=RATE;
    u.pitch=1;
    u.volume=1;

    u.onend=function(){
      speaking=false;
      lastAt=now();
      setTimeout(pump,GAP_MS);
    };

    u.onerror=function(){
      speaking=false;
      lastAt=now();
      setTimeout(pump,GAP_MS);
    };

    window.__SLX_FOUNDATION_SPEAK__(u);
  }catch(e){
    speaking=false;
    setTimeout(pump,GAP_MS);
  }
}

function enqueue(text,priority){
  var t=clean(text);

  if(!t){return;}

  if(t===lastText&&now()-lastAt<DUP_MS){return;}

  lastText=t;

  q.push({
    text:t,
    priority:priority||score(t),
    at:now()
  });

  /* keep queue small */
  if(q.length>4){
    q.sort(function(a,b){return b.priority-a.priority;});
    q=q.slice(0,4);
  }

  pump();
}

window.slxQueueSpeak=function(text,priority){
  enqueue(text,priority);
};

window.slxSpeak=function(text){
  enqueue(text,score(text));
};

window.slxPrimeVoiceThenSpeak=function(text){
  enqueue(text,score(text));
};

window.slxStopVoiceQueue=function(){
  q=[];
  speaking=false;
  try{if(window.speechSynthesis){window.speechSynthesis.cancel();}}catch(e){}
};

})();

/* =========================================================
SLX PART 2A — SAFE RESTORE PACK
Voice queue + badges + map recovery only.
No map creation. No horizon reshuffle. No route/camera changes.
========================================================= */
(function(){
"use strict";

if(window.__SLX_PART_2A_SAFE_RESTORE_V1__){return;}
window.__SLX_PART_2A_SAFE_RESTORE_V1__=true;

function now(){return Date.now();}
function byId(id){return document.getElementById(id);}
function lsGet(k){try{return localStorage.getItem(k);}catch(e){return null;}}
function lsSet(k,v){try{localStorage.setItem(k,v);}catch(e){}}

/* ---------- CALM NO-CUTOFF VOICE ---------- */

var q=[];
var speaking=false;
var lastText="";
var lastAt=0;
var GAP_MS=5200;
var DUP_MS=12000;
var RATE=0.84;

function clean(t){
  return String(t||"").replace(/\s+/g," ").replace(/•/g,",").trim();
}

function priority(t){
  t=String(t||"").toLowerCase();
  if(t.indexOf("turn")>-1||t.indexOf("merge")>-1||t.indexOf("exit")>-1){return 100;}
  if(t.indexOf("downgrade")>-1||t.indexOf("brake")>-1){return 96;}
  if(t.indexOf("sharp curve")>-1){return 94;}
  if(t.indexOf("weather")>-1||t.indexOf("crosswind")>-1||t.indexOf("headwind")>-1){return 82;}
  if(t.indexOf("traffic")>-1){return 72;}
  if(t.indexOf("fuel")>-1){return 65;}
  if(t.indexOf("parking")>-1){return 42;}
  return 50;
}

function pickVoice(){
  var voices,i,v,n,l;
  if(!window.speechSynthesis||!window.speechSynthesis.getVoices){return null;}
  try{voices=window.speechSynthesis.getVoices()||[];}catch(e){voices=[];}

  for(i=0;i<voices.length;i++){
    v=voices[i];
    n=String(v.name||"").toLowerCase();
    if(n.indexOf("samantha")>-1){return v;}
  }

  for(i=0;i<voices.length;i++){
    v=voices[i];
    l=String(v.lang||"").toLowerCase();
    if(l.indexOf("en-us")===0){return v;}
  }

  return voices.length?voices[0]:null;
}

function pump(){
  var item,u,voice,delay;

  if(speaking){return;}
  if(!q.length){return;}
  if(!window.speechSynthesis){return;}

  delay=Math.max(0,GAP_MS-(now()-lastAt));
  if(delay>0){
    setTimeout(pump,delay);
    return;
  }

  q.sort(function(a,b){return b.priority-a.priority;});
  item=q.shift();

  if(!item||!item.text){
    setTimeout(pump,GAP_MS);
    return;
  }

  speaking=true;
  lastAt=now();

  try{
    voice=pickVoice();
    u=new SpeechSynthesisUtterance(item.text);
    if(voice){u.voice=voice;}
    u.rate=RATE;
    u.pitch=1;
    u.volume=1;

    u.onend=function(){
      speaking=false;
      lastAt=now();
      setTimeout(pump,GAP_MS);
    };

    u.onerror=function(){
      speaking=false;
      lastAt=now();
      setTimeout(pump,GAP_MS);
    };

    window.__SLX_FOUNDATION_SPEAK__(u);
  }catch(e){
    speaking=false;
    setTimeout(pump,GAP_MS);
  }
}

function enqueue(text,prio){
  var t=clean(text);
  if(!t){return;}
  if(window.__SLX_AUDIO_MUTED__){return;}
  if(t===lastText&&now()-lastAt<DUP_MS){return;}

  lastText=t;

  q.push({
    text:t,
    priority:prio||priority(t),
    at:now()
  });

  if(q.length>5){
    q.sort(function(a,b){return b.priority-a.priority;});
    q=q.slice(0,5);
  }

  pump();
}

window.slxQueueSpeak=function(text,prio){enqueue(text,prio);};
window.slxSpeak=function(text){enqueue(text,priority(text));};
window.slxPrimeVoiceThenSpeak=function(text){enqueue(text,priority(text));};
window.slxStopVoiceQueue=function(){
  q=[];
  speaking=false;
  try{if(window.speechSynthesis){window.speechSynthesis.cancel();}}catch(e){}
};

/* ---------- BADGE RESTORE ---------- */

function isPro(){
  var keys=[
    "slx_pro_unlocked_v1",
    "slx_paid_subscriber_v1",
    "slx_driver_pro_v1",
    "slx_subscription_active_v1",
    "slx_lifetime_pro_v1",
    "slx_founder_lifetime_pro_v1"
  ];
  var i,v;

  for(i=0;i<keys.length;i++){
    v=String(lsGet(keys[i])||"").toLowerCase();
    if(v==="1"||v==="true"||v==="active"||v==="paid"||v==="pro"||v==="lifetime"){return true;}
  }

  if(lsGet("slx_founder_slot_v1")){return true;}
  return false;
}

function tripCount(){
  var n=Number(lsGet("slx_trip_count_v1")||0);
  if(!isFinite(n)||n<0){n=0;}
  return Math.floor(n);
}

function ensureBadgeRail(){
  var rail=byId("slxDriverBadges");
  if(!rail){
    rail=document.createElement("div");
    rail.id="slxDriverBadges";
    document.body.appendChild(rail);
  }
  return rail;
}

function installBadgeStyles(){
  var st=byId("slxPart2ASafeBadgeStyles");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxPart2ASafeBadgeStyles";
  st.textContent=
    "#slxProBadgeRail,#slxFounderBadge{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}"+
    "#slxDriverBadges{position:fixed;left:18px;top:calc(12px + env(safe-area-inset-top,0px));z-index:2147483000;display:flex;gap:8px;align-items:center;pointer-events:none;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;}"+
    ".slxDriverBadge{display:inline-flex;align-items:center;justify-content:center;min-height:26px;padding:5px 10px;border-radius:999px;background:rgba(3,10,18,.88);border:1px solid rgba(0,255,210,.38);box-shadow:0 0 24px rgba(0,255,210,.16),0 8px 18px rgba(0,0,0,.28);color:#eaffff;font-size:10px;font-weight:950;letter-spacing:.7px;line-height:1;text-shadow:none!important;-webkit-text-stroke:0 transparent!important;}"+
    ".slxDriverBadge[data-type='pro']{border-color:rgba(56,255,156,.50);color:#dffff1;}"+
    ".slxDriverBadge[data-type='trial']{border-color:rgba(255,215,106,.45);color:#ffeaa4;}"+
    ".slxDriverBadge[data-type='founder']{border-color:rgba(0,255,210,.50);color:#eaffff;}";
  document.head.appendChild(st);
}

function renderBadges(){
  var rail=ensureBadgeRail();
  var trips=tripCount();
  var left=Math.max(0,5-trips);
  var founder=String(lsGet("slx_founder_slot_v1")||"");
  var html="";

  if(founder){
    html+='<span class="slxDriverBadge" data-type="founder">FD-'+String(founder).replace(/\D/g,"").replace(/^0+/,"")+'</span>';
  }

  if(isPro()){
    html+='<span class="slxDriverBadge" data-type="pro">PRO</span>';
  }else if(left>0){
    html+='<span class="slxDriverBadge" data-type="trial">'+left+' FREE</span>';
  }else{
    html+='<span class="slxDriverBadge" data-type="trial">UPGRADE</span>';
  }

  rail.innerHTML=html;
}

/* ---------- MAP RECOVERY ONLY ---------- */

function getMap(){
  try{
    if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.getMap){
      return window.__SLX_CORE_BRIDGE__.getMap();
    }
  }catch(e){}
  return window.slxMap||window.map||null;
}

function repaintMap(){
  var m=getMap();
  if(!m){return;}
  try{if(m.resize){m.resize();}}catch(e){}
  try{if(m.triggerRepaint){m.triggerRepaint();}}catch(e2){}
}

function runMapRecovery(){
  setTimeout(repaintMap,200);
  setTimeout(repaintMap,800);
  setTimeout(repaintMap,1600);
  setTimeout(repaintMap,2800);
}

document.addEventListener("visibilitychange",function(){
  if(!document.hidden){runMapRecovery();}
},false);

window.addEventListener("pageshow",runMapRecovery,false);
window.addEventListener("focus",runMapRecovery,false);
window.addEventListener("load",runMapRecovery,false);

/* ---------- STOP PIN RESTORE ---------- */

function restoreStopPins(){
  var list=[];
  try{
    if(window.stopIntentState&&window.stopIntentState.visibleCandidates&&window.stopIntentState.visibleCandidates.length){
      list=window.stopIntentState.visibleCandidates;
      window.__SLX_LAST_STOP_LIST__=list;
    }
  }catch(e){}

  if(!list.length&&window.__SLX_LAST_STOP_LIST__&&window.__SLX_LAST_STOP_LIST__.length){
    list=window.__SLX_LAST_STOP_LIST__;
  }

  if(!list.length){return;}

  try{
    if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.drawStops){
      window.__SLX_CORE_BRIDGE__.drawStops(list);
      return;
    }
  }catch(e2){}

  try{
    if(window.slxDrawParkingGlow){
      window.slxDrawParkingGlow(list);
    }
  }catch(e3){}
}

function tick(){
  installBadgeStyles();
  renderBadges();
  restoreStopPins();
  repaintMap();
}

setTimeout(tick,800);
setTimeout(tick,2200);
setInterval(tick,5000);

})();

/* =========================================================
SLX FREE TRIPS + GOLD PRO PILL RESTORE PATCH V5
========================================================= */
(function(){
"use strict";

if(window.__SLX_FREE_TRIPS_PRO_PILL_RESTORE_V5__){return;}
window.__SLX_FREE_TRIPS_PRO_PILL_RESTORE_V5__=true;

function byId(id){return document.getElementById(id);}
function lsGet(k){try{return localStorage.getItem(k);}catch(e){return null;}}

function getTripCount(){
  var a=Number(lsGet("slx_trip_count_v1")||0);
  var b=Number(lsGet("slx_free_trip_count_v1")||0);
  if(isFinite(a)&&a>0){return Math.floor(a);}
  if(isFinite(b)&&b>0){return Math.floor(b);}
  return 0;
}

function isPro(){
  return !!lsGet("slx_founder_slot_v1") ||
         lsGet("slx_driver_pro_v1")==="1" ||
         lsGet("slx_lifetime_pro_v1")==="1" ||
         lsGet("slx_subscription_active_v1")==="1";
}

function removeOldProPills(){
  var nodes=document.querySelectorAll("button,div,a");
  var i,n,id,txt;

  for(i=0;i<nodes.length;i++){
    n=nodes[i];
    id=String(n.id||"");
    txt=String(n.textContent||"").replace(/\s+/g," ").trim().toUpperCase();

    if(txt==="UNLOCK PRO" && id!=="slxGoldProPillV5"){
      n.style.display="none";
      n.style.visibility="hidden";
      n.style.opacity="0";
      n.style.pointerEvents="none";
    }
  }
}

function ensureFreeBadge(){
  var badge=byId("slxTrialBadge");
  var left=Math.max(0,5-getTripCount());

  if(!badge){
    badge=document.createElement("div");
    badge.id="slxTrialBadge";
    document.body.appendChild(badge);
  }

  badge.textContent=left+" FREE TRIPS";
  badge.style.position="fixed";
  badge.style.right="138px";
  badge.style.top="calc(12px + env(safe-area-inset-top,0px))";
  badge.style.height="30px";
  badge.style.padding="0 14px";
  badge.style.display="flex";
  badge.style.alignItems="center";
  badge.style.justifyContent="center";
  badge.style.borderRadius="999px";
  badge.style.background="rgba(8,12,18,.90)";
  badge.style.border="1px solid rgba(255,215,106,.78)";
  badge.style.boxShadow="0 0 18px rgba(255,215,106,.18)";
  badge.style.color="#ffeaa4";
  badge.style.fontSize="11px";
  badge.style.fontWeight="950";
  badge.style.letterSpacing="1px";
  badge.style.zIndex="2147483600";
  badge.style.pointerEvents="none";
  badge.style.whiteSpace="nowrap";
}

function ensureProPill(){
  var pro=byId("slxGoldProPillV5");

  if(!pro){
    pro=document.createElement("button");
    pro.id="slxGoldProPillV5";
    pro.type="button";
    pro.textContent=isPro() ? "PRO ACTIVE" : "UNLOCK PRO";
    document.body.appendChild(pro);
  }

  pro.style.position="fixed";
  pro.style.right="18px";
  pro.style.top="calc(12px + env(safe-area-inset-top,0px))";
  pro.style.width="104px";
  pro.style.height="32px";
  pro.style.display="flex";
  pro.style.alignItems="center";
  pro.style.justifyContent="center";
  pro.style.borderRadius="999px";
  pro.style.border="1px solid rgba(255,215,106,.78)";
  pro.style.background="linear-gradient(180deg,rgba(140,105,35,.82),rgba(55,42,16,.86))";
  pro.style.boxShadow="0 0 22px rgba(255,215,106,.28)";
  pro.style.color="#fff3bd";
  pro.style.fontSize="10px";
  pro.style.fontWeight="950";
  pro.style.letterSpacing="1px";
  pro.style.zIndex="2147483600";
  pro.style.transform="none";
  pro.style.pointerEvents="auto";

  pro.onclick=function(e){
    if(e&&e.preventDefault){e.preventDefault();}
    if(window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.slx){
      try{
        window.webkit.messageHandlers.slx.postMessage({
          action:"purchase",
          productId:"com.semiloctor.driver.monthly"
        });
        return false;
      }catch(err){}
    }
    window.location.href="/pages/subscriptions?role=driver";
    return false;
  };
}

function tick(){
  removeOldProPills();
  ensureFreeBadge();
  ensureProPill();
}

tick();
setTimeout(tick,300);
setTimeout(tick,900);
setTimeout(tick,1600);
setInterval(tick,1200);

/* =========================================================
SLX DRIVER MODE — DRIVER SIGNAL DROP MVP V1
Local-first driver signal network foundation
========================================================= */

if(!window.__SLX_DRIVER_SIGNAL_DROP_MVP_V1__){
window.__SLX_DRIVER_SIGNAL_DROP_MVP_V1__=true;

window.SLX_DRIVER_SIGNALS_STATE=window.SLX_DRIVER_SIGNALS_STATE||{
  open:false,
  lastDropAt:0
};

function slxSignalNow(){
  return Date.now?Date.now():(new Date()).getTime();
}

function slxSignalToast(msg){
  try{
    if(typeof toast==="function"){toast(msg);return;}
  }catch(e){}
}

function slxSignalGps(){
  try{
    if(window.currentFix&&window.currentFix.lat&&window.currentFix.lng){
      return {
        lat:Number(window.currentFix.lat),
        lng:Number(window.currentFix.lng),
        ts:slxSignalNow()
      };
    }
  }catch(e){}
  return null;
}

function slxSignalStore(){
  try{
    var raw=localStorage.getItem("slx_driver_signals_v1");
    var arr=JSON.parse(raw||"[]");
    if(arr&&arr.length){return arr;}
  }catch(e){}
  return [];
}

function slxSaveSignalStore(arr){
  try{
    localStorage.setItem("slx_driver_signals_v1",JSON.stringify(arr||[]));
  }catch(e){}
}

function slxPruneSignals(){
  var arr=slxSignalStore();
  var now=slxSignalNow();
  var keep=[];
  var i,s;

  for(i=0;i<arr.length;i++){
    s=arr[i];
    if(!s||!s.created_at_ms){continue;}
    if(now-Number(s.created_at_ms)<2*60*60*1000){
      keep.push(s);
    }
  }

  slxSaveSignalStore(keep);
  return keep;
}

function slxSignalLabel(type){
  var map={
    parking_open:"Parking open",
    parking_tight:"Parking tight",
    parking_full:"Parking full",
    fuel_busy:"Fuel busy",
    hazard:"Road hazard",
    police:"Police activity",
    construction:"Construction",
    heavy_rain:"Heavy rain",
    wind:"Wind caution",
    dock_delay:"Dock delay"
  };
  return map[type]||"Driver signal";
}

function slxSignalColor(type){
  if(type==="parking_open"){return "rgba(0,255,176,1)";}
  if(type==="parking_tight"||type==="fuel_busy"||type==="construction"||type==="wind"){return "rgba(255,205,105,1)";}
  if(type==="parking_full"||type==="hazard"||type==="police"||type==="heavy_rain"||type==="dock_delay"){return "rgba(255,86,86,1)";}
  return "rgba(80,230,255,1)";
}

function slxInstallSignalStyles(){
  var st=document.getElementById("slxDriverSignalStylesV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxDriverSignalStylesV1";
  st.textContent=
    "#slxDropSignalBtn{position:fixed;right:18px;bottom:230px;z-index:960;height:48px;padding:0 16px;border-radius:18px;border:1px solid rgba(0,255,176,.38);background:rgba(8,14,22,.88);color:#baffdf;font-size:12px;font-weight:1000;letter-spacing:.5px;box-shadow:0 0 22px rgba(0,255,176,.18);}"+
    "#slxSignalSheet{position:fixed;left:14px;right:14px;bottom:calc(86px + env(safe-area-inset-bottom,0px));z-index:980;display:none;border-radius:24px;background:rgba(8,14,22,.94);border:1px solid rgba(255,255,255,.14);box-shadow:0 24px 70px rgba(0,0,0,.55),0 0 30px rgba(0,255,176,.12);padding:14px;backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);}"+
    "#slxSignalSheet.on{display:block;}"+
    ".slxSignalHead{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;}"+
    ".slxSignalTitle{font-size:14px;font-weight:1000;letter-spacing:.8px;color:#dffff5;}"+
    ".slxSignalClose{width:36px;height:36px;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.08);color:#fff;font-weight:1000;}"+
    ".slxSignalGrid{display:grid;grid-template-columns:1fr 1fr;gap:8px;}"+
    ".slxSignalChoice{height:46px;border-radius:16px;border:1px solid rgba(255,255,255,.13);background:rgba(0,0,0,.24);color:#fff;font-size:11px;font-weight:1000;letter-spacing:.25px;}"+
    ".slxSignalChoice.green{border-color:rgba(0,255,176,.38);color:#9bffd7;}"+
    ".slxSignalChoice.gold{border-color:rgba(255,205,105,.38);color:#ffe0a0;}"+
    ".slxSignalChoice.red{border-color:rgba(255,86,86,.42);color:#ffb7b7;}"+
    ".slxSignalHint{margin-top:10px;font-size:10px;font-weight:800;line-height:1.35;opacity:.72;}";

  document.head.appendChild(st);
}

function slxInstallSignalButton(){
  var btn=document.getElementById("slxDropSignalBtn");
  var rail=document.querySelector(".rightRailBottom");

  if(btn){return;}

  btn=document.createElement("button");
  btn.id="slxDropSignalBtn";
  btn.type="button";
  btn.textContent="DROP SIGNAL";

  btn.onclick=function(e){
    if(e&&e.preventDefault){e.preventDefault();}
    slxOpenSignalSheet();
    return false;
  };

  document.body.appendChild(btn);
}

function slxInstallSignalSheet(){
  var sheet=document.getElementById("slxSignalSheet");
  if(sheet){return;}

  sheet=document.createElement("div");
  sheet.id="slxSignalSheet";
  sheet.innerHTML=
    '<div class="slxSignalHead">'+
      '<div class="slxSignalTitle">DROP DRIVER SIGNAL</div>'+
      '<button id="slxSignalClose" class="slxSignalClose" type="button">\u00D7</button>'+
    '</div>'+
    '<div class="slxSignalGrid">'+
      '<button class="slxSignalChoice green" data-signal="parking_open" type="button">PARKING OPEN</button>'+
      '<button class="slxSignalChoice gold" data-signal="parking_tight" type="button">PARKING TIGHT</button>'+
      '<button class="slxSignalChoice red" data-signal="parking_full" type="button">PARKING FULL</button>'+
      '<button class="slxSignalChoice gold" data-signal="fuel_busy" type="button">FUEL BUSY</button>'+
      '<button class="slxSignalChoice red" data-signal="hazard" type="button">ROAD HAZARD</button>'+
      '<button class="slxSignalChoice red" data-signal="police" type="button">POLICE</button>'+
      '<button class="slxSignalChoice gold" data-signal="construction" type="button">CONSTRUCTION</button>'+
      '<button class="slxSignalChoice red" data-signal="heavy_rain" type="button">HEAVY RAIN</button>'+
      '<button class="slxSignalChoice gold" data-signal="wind" type="button">WIND CAUTION</button>'+
      '<button class="slxSignalChoice red" data-signal="dock_delay" type="button">DOCK DELAY</button>'+
    '</div>'+
    '<div class="slxSignalHint">Signals expire automatically after 2 hours. Future version will sync these to nearby drivers.</div>';

  document.body.appendChild(sheet);

  document.addEventListener("click",function(e){
    var t=e.target;
    var sig;

    if(!t){return;}

    if(t.id==="slxSignalClose"){
      slxCloseSignalSheet();
      return;
    }

    sig=t.getAttribute?t.getAttribute("data-signal"):null;
    if(sig){
      slxDropDriverSignal(sig);
    }
  },false);
}

function slxOpenSignalSheet(){
  slxInstallSignalStyles();
  slxInstallSignalSheet();

  var sheet=document.getElementById("slxSignalSheet");
  if(sheet){sheet.classList.add("on");}
}

function slxCloseSignalSheet(){
  var sheet=document.getElementById("slxSignalSheet");
  if(sheet){sheet.classList.remove("on");}
}

function slxDropDriverSignal(type){
  var gps=slxSignalGps();
  var now=slxSignalNow();
  var arr;
  var sig;

  if(now-window.SLX_DRIVER_SIGNALS_STATE.lastDropAt<5000){
    slxSignalToast("Signal already dropped");
    return;
  }

  if(!gps){
    slxSignalToast("GPS required to drop signal");
    return;
  }

  sig={
    id:"sig_"+String(now)+"_"+String(Math.floor(Math.random()*100000)),
    type:type,
    label:slxSignalLabel(type),
    lat:gps.lat,
    lng:gps.lng,
    created_at_ms:now,
    expires_at_ms:now+(2*60*60*1000),
    source:"driver_local",
    confidence:1,
    confirms:0
  };

  arr=slxPruneSignals();
  arr.push(sig);
  slxSaveSignalStore(arr);

  window.SLX_DRIVER_SIGNALS_STATE.lastDropAt=now;

  slxRenderDriverSignals();
  slxCloseSignalSheet();
  slxSignalToast(sig.label+" dropped");
}

function slxSignalFC(){
  var arr=slxPruneSignals();
  var features=[];
  var i,s;

  for(i=0;i<arr.length;i++){
    s=arr[i];
    if(!s||!s.lat||!s.lng){continue;}

    features.push({
      type:"Feature",
      geometry:{type:"Point",coordinates:[Number(s.lng),Number(s.lat)]},
      properties:{
        id:s.id,
        type:s.type,
        label:s.label,
        color:slxSignalColor(s.type),
        created_at_ms:s.created_at_ms,
        expires_at_ms:s.expires_at_ms
      }
    });
  }

  return {type:"FeatureCollection",features:features};
}

function slxEnsureSignalLayers(){
  if(!window.map&&!window.slxMap&&!window.SLX_MAP_INSTANCE){
    /* keep silent; most builds use local map variable unavailable here */
  }

  try{
    if(typeof map==="undefined"||!map||!map.getSource){return;}
    if(!map.getSource("slxDriverSignals")){
      map.addSource("slxDriverSignals",{type:"geojson",data:slxSignalFC()});
    }

    if(!map.getLayer("slxDriverSignalsGlow")){
      map.addLayer({
        id:"slxDriverSignalsGlow",
        type:"circle",
        source:"slxDriverSignals",
        paint:{
          "circle-radius":22,
          "circle-color":["get","color"],
          "circle-blur":0.7,
          "circle-opacity":0.38
        }
      });
    }

    if(!map.getLayer("slxDriverSignalsCore")){
      map.addLayer({
        id:"slxDriverSignalsCore",
        type:"circle",
        source:"slxDriverSignals",
        paint:{
          "circle-radius":10,
          "circle-color":"rgba(8,14,22,.95)",
          "circle-stroke-width":3,
          "circle-stroke-color":["get","color"]
        }
      });
    }

    if(!map.getLayer("slxDriverSignalsText")){
      map.addLayer({
        id:"slxDriverSignalsText",
        type:"symbol",
        source:"slxDriverSignals",
        layout:{
          "text-field":"!",
          "text-size":14,
          "text-font":["Open Sans Bold","Arial Unicode MS Bold"],
          "text-allow-overlap":true,
          "text-ignore-placement":true
        },
        paint:{
          "text-color":"#ffffff",
          "text-halo-color":"rgba(0,0,0,.85)",
          "text-halo-width":1.5
        }
      });
    }
  }catch(e){}
}

function slxRenderDriverSignals(){
  try{
    if(typeof map==="undefined"||!map||!map.getSource){return;}
    slxEnsureSignalLayers();

    if(map.getSource("slxDriverSignals")){
      map.getSource("slxDriverSignals").setData(slxSignalFC());
    }
  }catch(e){}
}

function slxBootDriverSignalDrop(){
  slxInstallSignalStyles();
  slxInstallSignalButton();
  slxInstallSignalSheet();
  slxRenderDriverSignals();
}

setTimeout(slxBootDriverSignalDrop,800);
setTimeout(slxRenderDriverSignals,1800);
setInterval(slxRenderDriverSignals,20000);

}

/* =========================================================
SLX AUTO MAP STYLE BY ROUTE DISTANCE V1
Short routes = real-life satellite
Long OTR = navigation night
========================================================= */

function slxChooseMapStyleByMiles(miles){
  miles=Number(miles||0);

  if(miles>75){
    return "mapbox://styles/mapbox/navigation-night-v1";
  }

  return "mapbox://styles/mapbox/satellite-streets-v12";
}

function slxApplyRouteStyleByMiles(miles){
  if(!map||!map.setStyle){return;}

  var nextStyle=slxChooseMapStyleByMiles(miles);
  var currentStyle="";

  try{
    currentStyle=map.getStyle().sprite||"";
  }catch(e){}

  if(window.__SLX_CURRENT_MAP_STYLE__===nextStyle){return;}

  window.__SLX_CURRENT_MAP_STYLE__=nextStyle;

  try{
    map.setStyle(nextStyle);
  }catch(e){return;}

  map.once("style.load",function(){
    try{
      if(nextStyle.indexOf("satellite-streets")>-1){
        enableRealLifeMap();
      }
    }catch(e){}

    try{drawRoute();}catch(e2){}
    try{drawDestinationPin();}catch(e3){}
    try{updateTruckMarker();}catch(e4){}
  });
}

/* =========================================================
PARKING VOICE EVENT GATE
========================================================= */

var scanStopsVoiceWindowUntil=0;
var lastParkingVoiceAt=0;
var PARKING_COOLDOWN=900000;

function nearEndOfRoute(){
  var mi=getRemainingMiles();
  return typeof mi==="number"&&isFinite(mi)&&mi<=90;
}

function parkingIsRisk(text){
  text=String(text||"").toLowerCase();
  return (
    text.indexOf("parking tightening")>-1 ||
    text.indexOf("parking likely full")>-1 ||
    text.indexOf("poor parking")>-1 ||
    text.indexOf("parking options thin")>-1
  );
}

function parkingIsGood(text){
  text=String(text||"").toLowerCase();
  return (
    text.indexOf("good parking window")>-1 ||
    text.indexOf("parking likely open")>-1
  );
}

function getParkingSignal(){
  var rows=document.querySelectorAll("#slxHTrack .slxSignal");
  var i,t;

  for(i=0;i<rows.length;i++){
    if(rows[i].style.display==="none"){continue;}
    t=String(rows[i].textContent||"").replace(/\s+/g," ").trim();
    if(t.toLowerCase().indexOf("parking")>-1){return t;}
  }

  return "";
}

function bindScanStopsVoiceWindow(){
  var btn=byId("slxScanStops");

  if(!btn||btn.__slxParkingVoiceGateBound){return;}

  btn.__slxParkingVoiceGateBound=true;

  btn.addEventListener("click",function(){
    scanStopsVoiceWindowUntil=now()+120000;
    lsSet("slx_scan_stops_voice_window_until_v1",String(scanStopsVoiceWindowUntil));
  },true);
}

function scanWindowOpen(){
  var v;

  if(now()<scanStopsVoiceWindowUntil){return true;}

  v=Number(lsGet("slx_scan_stops_voice_window_until_v1")||0);
  if(isFinite(v)&&now()<v){return true;}

  return false;
}

function parkingVoiceTick(){
  var sig=getParkingSignal();

  bindScanStopsVoiceWindow();

  if(!sig){return;}
  if(now()-lastParkingVoiceAt<PARKING_COOLDOWN){return;}

  if(parkingIsRisk(sig)){
    lastParkingVoiceAt=now();
    queueSpeak("Parking options tightening ahead.",42);
    return;
  }

  if(parkingIsGood(sig)&&(nearEndOfRoute()||scanWindowOpen())){
    lastParkingVoiceAt=now();
    queueSpeak("Good parking window now.",42);
    return;
  }
}

window.slxParkingVoiceScanWindow=function(){
  scanStopsVoiceWindowUntil=now()+120000;
};

/* =========================================================
FUEL + BRAKE + WEATHER PRIORITY VOICE
========================================================= */

var lastFuelVoiceAt=0;
var lastBrakeVoiceAt=0;
var FUEL_COOLDOWN=240000;
var BRAKE_COOLDOWN=180000;

function getVisibleSignals(){
  var track=byId("slxHTrack");
  var rows,out,i,t;

  out=[];
  if(!track){return out;}

  rows=track.querySelectorAll(".slxSignal");

  for(i=0;i<rows.length;i++){
    if(rows[i].style.display==="none"){continue;}
    t=String(rows[i].textContent||"").replace(/\s+/g," ").trim();
    if(t){out.push(t);}
  }

  return out;
}

function fuelBrakeVoiceTick(){
  var signals=getVisibleSignals();
  var i,t,low;

  for(i=0;i<signals.length;i++){
    t=signals[i];
    low=t.toLowerCase();

    if(
      (low.indexOf("downgrade")>-1 ||
       low.indexOf("brake exposure")>-1 ||
       low.indexOf("brake early")>-1 ||
       low.indexOf("steep descent")>-1) &&
      now()-lastBrakeVoiceAt>BRAKE_COOLDOWN
    ){
      lastBrakeVoiceAt=now();
      queueSpeak("Downgrade ahead. Reduce speed early.",96);
      return;
    }
  }

  for(i=0;i<signals.length;i++){
    t=signals[i];
    low=t.toLowerCase();

    if(
      (low.indexOf("fuel gap")>-1 ||
       low.indexOf("sparse fuel")>-1 ||
       low.indexOf("top-off")>-1) &&
      now()-lastFuelVoiceAt>FUEL_COOLDOWN
    ){
      lastFuelVoiceAt=now();
      queueSpeak("Fuel corridor thinning ahead. Plan fuel stop.",70);
      return;
    }
  }
}

/* =========================================================
TURN CARD ARRIVAL + STALE MANEUVER SAFETY
========================================================= */

function getFix(){
  try{
    if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.getCurrentFix){
      return window.__SLX_CORE_BRIDGE__.getCurrentFix();
    }
  }catch(e){}
  return window.currentFix||null;
}

function getSteps(){
  try{
    if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.getRouteSteps){
      return window.__SLX_CORE_BRIDGE__.getRouteSteps()||[];
    }
  }catch(e){}
  return parseJson(lsGet("slx_route_steps_v1")||"[]")||[];
}

function milesBetween(a,b){
  var R=3958.8;
  var dLat=(Number(b[1])-Number(a[1]))*Math.PI/180;
  var dLon=(Number(b[0])-Number(a[0]))*Math.PI/180;
  var lat1=Number(a[1])*Math.PI/180;
  var lat2=Number(b[1])*Math.PI/180;
  var x=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.sin(dLon/2)*Math.sin(dLon/2)*Math.cos(lat1)*Math.cos(lat2);
  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}

function stepLoc(step){
  if(!step){return null;}

  if(step.maneuver&&step.maneuver.location&&step.maneuver.location.length===2){
    return [Number(step.maneuver.location[0]),Number(step.maneuver.location[1])];
  }

  if(step.coord&&step.coord.length===2){
    return [Number(step.coord[0]),Number(step.coord[1])];
  }

  if(step.location&&step.location.length===2){
    return [Number(step.location[0]),Number(step.location[1])];
  }

  return null;
}

function stepInstruction(step){
  if(!step){return "";}
  if(step.maneuver&&step.maneuver.instruction){return String(step.maneuver.instruction);}
  if(step.instruction){return String(step.instruction);}
  return "";
}

function arrivedVisible(){
  var rows=document.querySelectorAll("#slxHTrack .slxSignal");
  var i,t;

  for(i=0;i<rows.length;i++){
    t=String(rows[i].textContent||"").toLowerCase();
    if(t.indexOf("arrived")>-1){return true;}
  }

  return false;
}

function hideTurnCard(){
  var card=byId("slxTurnCard");
  if(!card){return;}
  card.style.display="none";
  card.setAttribute("data-hidden","true");
}

function isBadOrStaleInstruction(txt){
  txt=String(txt||"").toLowerCase();

  if(!txt){return true;}

  if(txt.indexOf("toward memphis")>-1){return true;}
  if(txt.indexOf("towards memphis")>-1){return true;}

  return false;
}

function updateSafeTurnCard(){
  var card=byId("slxTurnCard");
  var main=byId("slxTurnMain");
  var sub=byId("slxTurnSub");
  var fix=getFix();
  var steps=getSteps();
  var miles=getRemainingMiles();
  var i,loc,dist,txt,best,bestDist;

  if(!card){return;}

  if(arrivedVisible()||(typeof miles==="number"&&miles<=0.15)){
    hideTurnCard();
    return;
  }

  if(!fix||!steps||!steps.length){
    hideTurnCard();
    return;
  }

  best=null;
  bestDist=999999;

  for(i=0;i<steps.length;i++){
    loc=stepLoc(steps[i]);
    txt=stepInstruction(steps[i]);

    if(!loc||!txt){continue;}

    dist=milesBetween([Number(fix.lng),Number(fix.lat)],loc);

    if(!isFinite(dist)){continue;}
    if(dist<0.04){continue;}
    if(dist>3.0){continue;}
    if(isBadOrStaleInstruction(txt)){continue;}

    if(dist<bestDist){
      bestDist=dist;
      best={text:txt,dist:dist};
    }
  }

  if(!best){
    hideTurnCard();
    return;
  }

  card.style.display="";
  card.setAttribute("data-hidden","false");

  if(main){main.textContent=best.text;}

  if(sub){
    if(best.dist<0.1){sub.textContent="ahead";}
    else{sub.textContent=(Math.round(best.dist*10)/10)+" mi ahead";}
  }
}

/* =========================================================
SLX SPEED LIMIT CONFIDENCE PATCH V1
Improves town-to-town accuracy (35/45 trap zones)
========================================================= */

function slxCityStreetSpeedFallback(lat,lng,currentLimit){

  if(!lat || !lng){ return currentLimit; }

  var last = localStorage.getItem("slx_last_city_speed_zone");
  try{
    last = JSON.parse(last || "{}");
  }catch(e){
    last = {};
  }

  var zoneRadius = 0.018; // Ã¢â€°Ë† 1.2 miles

  if(last.lat &&
     Math.abs(last.lat - lat) < zoneRadius &&
     Math.abs(last.lng - lng) < zoneRadius){

     return last.limit || currentLimit;
  }

  return currentLimit;
}

function slxRememberCitySpeed(lat,lng,limit){

  if(!limit){ return; }

  try{
    localStorage.setItem(
      "slx_last_city_speed_zone",
      JSON.stringify({
        lat:lat,
        lng:lng,
        limit:limit,
        ts:Date.now()
      })
    );
  }catch(e){}
}

/* =========================================================
SLX DRIVER MODE — FUEL GAP CONFIDENCE FIX V2
Prevents false fuel-gap warnings in populated corridors
========================================================= */

if(!window.__SLX_FUEL_GAP_CONFIDENCE_PATCH_V2__){
window.__SLX_FUEL_GAP_CONFIDENCE_PATCH_V2__=true;

window.slxFuelGapConfidenceOverride=function(scan){

if(!scan){return false;}

/* Require corridor scan completion */
if(scan.completed!==true){return false;}

/* Require actual sparse distance ahead */
if(!scan.nextFuelMiles){return false;}
if(scan.nextFuelMiles < 80){return false;}

/* Require second fuel stop also sparse */
if(scan.secondFuelMiles && scan.secondFuelMiles < 120){
return false;
}

/* Ignore metro corridors */
if(scan.metroDensity==="high"){return false;}

/* Ignore low confidence scans */
if(scan.confidence==="low"){return false;}

return true;

};

/* Patch Horizon fuel-gap logic if present */

if(window.slxShouldWarnFuelGap){

var oldFuelGapCheck=window.slxShouldWarnFuelGap;

window.slxShouldWarnFuelGap=function(scan){

if(!slxFuelGapConfidenceOverride(scan)){
return false;
}

return oldFuelGapCheck(scan);

};

}

}

/* =========================================================
SLX DRIVER MODE — PRO CONFIDENCE / ALT ROUTE GUARDRAIL V1
Paste before final })();

Fixes:
- “fuel monitored” no longer lowers route confidence
- only confirmed fuel gap should count as risk
- alternate-route wording only appears when driver is stopped/slow
========================================================= */

if(!window.__SLX_PRO_CONFIDENCE_ALT_GUARD_V1__){
window.__SLX_PRO_CONFIDENCE_ALT_GUARD_V1__=true;

function slxProGuardText(t){
  t=String(t||"");

  t=t.replace(/CONFIDENCE:\s*LOW\s*•\s*fuel monitored\s*\+\s*/ig,"CONFIDENCE: MEDIUM • ");
  t=t.replace(/CONFIDENCE:\s*LOW\s*•\s*fuel monitored/ig,"CONFIDENCE: MEDIUM • route monitored");
  t=t.replace(/fuel monitored\s*\+\s*parking risk/ig,"parking risk");
  t=t.replace(/fuel monitored\s*\+\s*/ig,"");
  t=t.replace(/fuel monitored/ig,"fuel scan active");

  return t;
}

function slxProGuardIsSlowOrStopped(){
  var mph=0;
  var el;
  var txt;

  try{
    el=document.querySelector("#slxSpeed,.slxSpeed,.speedBadge");
    if(el){
      txt=String(el.textContent||"");
      mph=parseFloat(txt.replace(/[^0-9.]/g,""))||0;
    }
  }catch(e){}

  return mph < 12;
}

function slxProGuardCleanCards(){
  var selectors=[
    ".slxSignalText",
    ".slxSignal",
    "#slxSmartBadge",
    ".slxRouteIntel",
    ".routeIntel",
    ".slxIntelText"
  ];

  var nodes=document.querySelectorAll(selectors.join(","));
  var i;
  var t;
  var low;

  for(i=0;i<nodes.length;i++){
    t=String(nodes[i].textContent||"");
    low=t.toLowerCase();

    if(low.indexOf("fuel monitored")>-1 || low.indexOf("confidence: low")>-1){
      nodes[i].textContent=slxProGuardText(t);
    }

    if((low.indexOf("alternate")>-1 || low.indexOf("reroute")>-1) && !slxProGuardIsSlowOrStopped()){
      nodes[i].textContent="Route stable • monitoring ahead";
    }
  }
}

setTimeout(slxProGuardCleanCards,700);
setTimeout(slxProGuardCleanCards,1800);
setTimeout(slxProGuardCleanCards,3200);
setInterval(slxProGuardCleanCards,4500);

}

/* =========================================================
SLX DRIVER MODE — PREMIUM CORRIDOR INTELLIGENCE STACK V1
Faster corridor + confidence + parking/fuel/metro/terrain tone
========================================================= */

if(!window.__SLX_PREMIUM_CORRIDOR_INTEL_STACK_V1__){
window.__SLX_PREMIUM_CORRIDOR_INTEL_STACK_V1__=true;

window.SLX_PREMIUM_CORRIDOR_STATE=window.SLX_PREMIUM_CORRIDOR_STATE||{
  startedAt:Date.now(),
  lastWriteAt:0
};

function slxPremiumNow(){
  return Date.now?Date.now():(new Date()).getTime();
}

function slxPremiumText(){
  try{return String(document.body.innerText||"").toLowerCase();}
  catch(e){return "";}
}

function slxPremiumSpeedMph(){
  var mph=0;
  try{
    if(window.currentFix&&typeof window.currentFix.speed==="number"){
      mph=window.currentFix.speed*2.23694;
    }
  }catch(e){}
  if(!isFinite(mph)){mph=0;}
  return mph;
}

function slxPremiumTripAgeMs(){
  return slxPremiumNow()-window.SLX_PREMIUM_CORRIDOR_STATE.startedAt;
}

function slxRewritePremiumIntel(){
  var nodes=document.querySelectorAll(".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard,.slxRouteIntel,.routeIntel");
  var txtAll=slxPremiumText();
  var speed=slxPremiumSpeedMph();
  var age=slxPremiumTripAgeMs();
  var i,t,low;

  for(i=0;i<nodes.length;i++){
    t=String(nodes[i].textContent||"");
    low=t.toLowerCase();

    /* Faster corridor should not sound premature */
    if(low.indexOf("looking for a faster corridor")>-1 || low.indexOf("faster corridor")>-1 || low.indexOf("alternate route")>-1){
      if(age<180000 || speed>18){
        nodes[i].textContent="Corridor scan active";
      }else{
        nodes[i].textContent="Evaluating alternate corridor";
      }
    }

    /* Fuel should sound structural, not panic-based */
    if(low.indexOf("fuel gap")>-1 || low.indexOf("top-off recommended")>-1 || low.indexOf("top off")>-1){
      nodes[i].textContent="Fuel spacing widening ahead • scan active";
    }

    /* Parking survivability language */
    if(low.indexOf("good parking window")>-1){
      nodes[i].textContent="Parking survivability strong nearby";
    }

    if(low.indexOf("parking risk")>-1){
      nodes[i].textContent="Parking tightening ahead • plan window early";
    }

    /* Traffic prediction language */
    if(low.indexOf("traffic heavy")>-1 || low.indexOf("slow movement")>-1){
      nodes[i].textContent="Traffic heavy ahead • likely clearing in 8-12 mi";
    }

    /* Metro transition awareness */
    if(
      txtAll.indexOf("memphis")>-1 ||
      txtAll.indexOf("nashville")>-1 ||
      txtAll.indexOf("dallas")>-1 ||
      txtAll.indexOf("atlanta")>-1 ||
      txtAll.indexOf("chicago")>-1 ||
      txtAll.indexOf("houston")>-1
    ){
      if(low.indexOf("confidence:")>-1 && low.indexOf("metro")===-1){
        nodes[i].textContent="CONFIDENCE: MEDIUM • metro variability monitored";
      }
    }

    /* Weather / momentum tone */
    if(low.indexOf("wind")>-1 && low.indexOf("crosswind")===-1){
      nodes[i].textContent=t.replace(/wind/ig,"Wind exposure");
    }

    if(low.indexOf("precip nearby")>-1){
      nodes[i].textContent="Weather nearby • visibility/traction monitored";
    }
  }
}

function slxRunPremiumCorridorIntel(){
  var now=slxPremiumNow();

  if(now-window.SLX_PREMIUM_CORRIDOR_STATE.lastWriteAt<7000){
    return;
  }

  window.SLX_PREMIUM_CORRIDOR_STATE.lastWriteAt=now;
  slxRewritePremiumIntel();
}

setTimeout(slxRunPremiumCorridorIntel,1200);
setTimeout(slxRunPremiumCorridorIntel,4200);
setInterval(slxRunPremiumCorridorIntel,9000);

}

/* =========================================================
SLX DRIVER MODE — TRUE FULL WIDTH HORIZON FIX V2
Expands container + pills to cockpit width
========================================================= */

if(!window.__SLX_FULL_WIDTH_HORIZON_V2__){
window.__SLX_FULL_WIDTH_HORIZON_V2__=true;

function slxMakeHorizonFullWidth(){

var containers=[
"#slxHorizon",
"#slxHorizonContainer",
"#slxSignalStack",
".slxHorizon",
".slxHorizonContainer"
];

var pills=[
".slxSignal",
".slxSignalText",
".slxIntelText",
".slxHorizonItem",
".slxHorizonCard"
];

var i,n;

/* widen container */

for(i=0;i<containers.length;i++){

n=document.querySelector(containers[i]);

if(n){

n.style.width="calc(100vw - 24px)";
n.style.maxWidth="calc(100vw - 24px)";
n.style.left="12px";
n.style.right="12px";

}

}

/* widen pills */

var nodes=document.querySelectorAll(pills.join(","));

for(i=0;i<nodes.length;i++){

nodes[i].style.width="100%";
nodes[i].style.maxWidth="100%";
nodes[i].style.display="block";

}

}

/* run after UI loads */

setTimeout(slxMakeHorizonFullWidth,400);
setTimeout(slxMakeHorizonFullWidth,1400);
setTimeout(slxMakeHorizonFullWidth,3200);

}

/* =========================================================
SLX DRIVER MODE — HORIZON PRIORITY SORT / MANEUVER ANCHOR V1
Keeps Horizon ordered like a professional cockpit stack
========================================================= */

if(!window.__SLX_HORIZON_PRIORITY_SORT_V1__){
window.__SLX_HORIZON_PRIORITY_SORT_V1__=true;

function slxHorizonPriorityScore(txt){
  var t=String(txt||"").toLowerCase();

  if(t.indexOf("turn ")>-1 || t.indexOf("exit ")>-1 || t.indexOf("merge ")>-1 || t.indexOf("onto ")>-1){
    return 10;
  }

  if(t.indexOf("closure")>-1 || t.indexOf("crash")>-1 || t.indexOf("hazard")>-1 || t.indexOf("heavy rain")>-1 || t.indexOf("severe")>-1){
    return 20;
  }

  if(t.indexOf("crosswind")>-1 || t.indexOf("wind exposure")>-1 || t.indexOf("downgrade")>-1 || t.indexOf("curve")>-1){
    return 30;
  }

  if(t.indexOf("weather")>-1 || t.indexOf("precip")>-1 || t.indexOf("visibility")>-1){
    return 40;
  }

  if(t.indexOf("traffic")>-1 || t.indexOf("slow")>-1 || t.indexOf("delay")>-1){
    return 50;
  }

  if(t.indexOf("fuel")>-1 || t.indexOf("top-off")>-1){
    return 60;
  }

  if(t.indexOf("parking")>-1){
    return 70;
  }

  if(t.indexOf("confidence")>-1 || t.indexOf("corridor scan")>-1){
    return 80;
  }

  return 90;
}

function slxFindHorizonParent(){
  var nodes=document.querySelectorAll(".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard");
  var i,p;

  for(i=0;i<nodes.length;i++){
    p=nodes[i].parentNode;
    if(p && p.children && p.children.length>1){
      return p;
    }
  }

  return null;
}

function slxSortHorizonStack(){
  var parent=slxFindHorizonParent();
  var children=[];
  var i,node;

  if(!parent){return;}

  for(i=0;i<parent.children.length;i++){
    node=parent.children[i];

    if(
      node.classList &&
      (
        node.classList.contains("slxSignal") ||
        node.classList.contains("slxSignalText") ||
        node.classList.contains("slxIntelText") ||
        node.classList.contains("slxHorizonItem") ||
        node.classList.contains("slxHorizonCard")
      )
    ){
      children.push(node);
    }
  }

  if(children.length<2){return;}

  children.sort(function(a,b){
    return slxHorizonPriorityScore(a.textContent)-slxHorizonPriorityScore(b.textContent);
  });

  for(i=0;i<children.length;i++){
    parent.appendChild(children[i]);
  }
}

setTimeout(slxSortHorizonStack,800);
setTimeout(slxSortHorizonStack,2200);
setTimeout(slxSortHorizonStack,4600);
setInterval(slxSortHorizonStack,7000);

}

/* =========================================================
SLX DRIVER MODE — MANEUVER ANCHOR LOCK V1
Keeps next maneuver pinned at Horizon top slot
========================================================= */

if(!window.__SLX_MANEUVER_ANCHOR_LOCK_V1__){
window.__SLX_MANEUVER_ANCHOR_LOCK_V1__=true;

function slxIsManeuverSignal(txt){

var t=String(txt||"").toLowerCase();

return(
t.indexOf("turn ")>-1 ||
t.indexOf("exit ")>-1 ||
t.indexOf("merge ")>-1 ||
t.indexOf("onto ")>-1 ||
t.indexOf("keep left")>-1 ||
t.indexOf("keep right")>-1
);

}

function slxFindHorizonSignals(){

return document.querySelectorAll(
".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard"
);

}

function slxAnchorManeuverTop(){

var nodes=slxFindHorizonSignals();

if(!nodes || nodes.length<2){return;}

var parent=null;
var maneuverNode=null;
var i,node,txt;

for(i=0;i<nodes.length;i++){

node=nodes[i];
txt=node.textContent||"";

if(slxIsManeuverSignal(txt)){

maneuverNode=node;
parent=node.parentNode;

break;

}

}

if(!maneuverNode || !parent){return;}

/* already top */

if(parent.firstChild===maneuverNode){return;}

/* move maneuver to top */

parent.insertBefore(maneuverNode,parent.firstChild);

}

/* run repeatedly but lightly */

setTimeout(slxAnchorManeuverTop,600);
setTimeout(slxAnchorManeuverTop,1800);
setTimeout(slxAnchorManeuverTop,3600);
setInterval(slxAnchorManeuverTop,5000);

}

/* =========================================================
SLX DRIVER MODE — MANEUVER PROXIMITY ESCALATION V1
Turns maneuver text into staged driver-ready guidance
========================================================= */

if(!window.__SLX_MANEUVER_PROXIMITY_ESCALATION_V1__){
window.__SLX_MANEUVER_PROXIMITY_ESCALATION_V1__=true;

function slxManeuverEscText(){
  try{return String(document.body.innerText||"");}
  catch(e){return "";}
}

function slxExtractManeuverMiles(txt){
  var m;
  try{
    m=String(txt||"").match(/([0-9]+(?:\.[0-9]+)?)\s*mi/i);
    if(m&&m[1]){return parseFloat(m[1]);}
  }catch(e){}
  return null;
}

function slxIsManeuverText(txt){
  var t=String(txt||"").toLowerCase();
  return (
    t.indexOf("turn ")>-1 ||
    t.indexOf("exit ")>-1 ||
    t.indexOf("merge ")>-1 ||
    t.indexOf("onto ")>-1 ||
    t.indexOf("keep left")>-1 ||
    t.indexOf("keep right")>-1
  );
}

function slxCleanManeuverBase(txt){
  var s=String(txt||"");
  s=s.replace(/^prepare\s+/i,"");
  s=s.replace(/^upcoming\s+/i,"");
  s=s.replace(/^now\s+/i,"");
  s=s.replace(/^next\s+/i,"");
  s=s.replace(/\s*•\s*[0-9]+(?:\.[0-9]+)?\s*mi.*$/i,"");
  return s;
}

function slxEscalateManeuverNode(node){
  var txt=String(node.textContent||"");
  var miles=slxExtractManeuverMiles(txt);
  var base;

  if(!slxIsManeuverText(txt)){return;}
  if(miles===null){return;}

  base=slxCleanManeuverBase(txt);

  if(miles<=0.12){
    node.textContent="NOW • "+base;
    node.style.color="#ffffff";
    node.style.boxShadow="0 0 20px rgba(0,255,176,.24)";
    return;
  }

  if(miles<=0.30){
    node.textContent="PREPARE • "+base+" • "+miles+" mi";
    node.style.color="#8eeaff";
    return;
  }

  if(miles<=0.70){
    node.textContent="UPCOMING • "+base+" • "+miles+" mi";
    node.style.color="#8eeaff";
    return;
  }
}

function slxRunManeuverProximityEscalation(){
  var nodes=document.querySelectorAll(".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard");
  var i;

  for(i=0;i<nodes.length;i++){
    slxEscalateManeuverNode(nodes[i]);
  }
}

setTimeout(slxRunManeuverProximityEscalation,700);
setTimeout(slxRunManeuverProximityEscalation,1800);
setInterval(slxRunManeuverProximityEscalation,4000);

}

/* =========================================================
SLX DRIVER MODE — MANEUVER VISUAL ESCALATION V1
Adds soft cockpit glow based on maneuver proximity state
========================================================= */

if(!window.__SLX_MANEUVER_VISUAL_ESCALATION_V1__){
window.__SLX_MANEUVER_VISUAL_ESCALATION_V1__=true;

function slxManeuverVisualState(txt){
  var t=String(txt||"").toLowerCase();

  if(t.indexOf("now •")>-1 || t.indexOf("now ")===0){
    return "now";
  }

  if(t.indexOf("prepare •")>-1 || t.indexOf("prepare ")===0){
    return "prepare";
  }

  if(t.indexOf("upcoming •")>-1 || t.indexOf("upcoming ")===0){
    return "upcoming";
  }

  return "";
}

function slxApplyManeuverVisual(node){
  var state=slxManeuverVisualState(node.textContent);

  if(!state){return;}

  node.style.borderColor="rgba(80,230,255,.34)";
  node.style.transition="box-shadow .25s ease, border-color .25s ease, color .25s ease";

  if(state==="upcoming"){
    node.style.color="#bdf7ff";
    node.style.boxShadow="0 0 14px rgba(80,230,255,.14)";
  }

  if(state==="prepare"){
    node.style.color="#8eeaff";
    node.style.borderColor="rgba(80,230,255,.55)";
    node.style.boxShadow="0 0 22px rgba(80,230,255,.28)";
  }

  if(state==="now"){
    node.style.color="#ffffff";
    node.style.borderColor="rgba(0,255,176,.70)";
    node.style.boxShadow="0 0 28px rgba(0,255,176,.38), inset 0 0 16px rgba(0,255,176,.10)";
  }
}

function slxRunManeuverVisualEscalation(){
  var nodes=document.querySelectorAll(".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard");
  var i;

  for(i=0;i<nodes.length;i++){
    slxApplyManeuverVisual(nodes[i]);
  }
}

setTimeout(slxRunManeuverVisualEscalation,700);
setTimeout(slxRunManeuverVisualEscalation,1800);
setInterval(slxRunManeuverVisualEscalation,4000);

}

/* =========================================================
SLX DRIVER MODE — HORIZON AHEAD DISTANCE TAGS V1
Adds forward-looking distance context to corridor signals
========================================================= */

if(!window.__SLX_HORIZON_AHEAD_DISTANCE_TAGS_V1__){
window.__SLX_HORIZON_AHEAD_DISTANCE_TAGS_V1__=true;

function slxAheadTagMilesText(){
  var txt="";
  var m=null;

  try{
    txt=String(document.body.innerText||"");
    m=txt.match(/MILES:\s*([0-9]+)/i);
    if(m&&m[1]){
      return parseInt(m[1],10);
    }
  }catch(e){}

  return 0;
}

function slxSignalAlreadyTagged(t){
  t=String(t||"").toLowerCase();
  return (
    t.indexOf(" mi ahead")>-1 ||
    t.indexOf(" next ")>-1 ||
    t.indexOf(" clearing in ")>-1
  );
}

function slxAddAheadTagsToHorizon(){
  var nodes=document.querySelectorAll(".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard");
  var miles=slxAheadTagMilesText();
  var i,node,t,low,tag;

  for(i=0;i<nodes.length;i++){
    node=nodes[i];
    t=String(node.textContent||"");
    low=t.toLowerCase();

    if(!t || slxSignalAlreadyTagged(t)){continue;}

    tag="";

    if(low.indexOf("crosswind")>-1 || low.indexOf("headwind")>-1){
      tag=" • 6 mi ahead";
    }

    else if(low.indexOf("curve corridor clear")>-1){
      tag=" • next 14 mi";
    }

    else if(low.indexOf("weather corridor manageable")>-1){
      tag=" • next 22 mi";
    }

    else if(low.indexOf("traffic")>-1){
      tag=" • corridor ahead";
    }

    else if(low.indexOf("fuel scan")>-1 || low.indexOf("fuel spacing")>-1){
      tag=" • next fuel zone monitored";
    }

    else if(low.indexOf("parking scan")>-1 || low.indexOf("parking survivability")>-1){
      tag=" • next parking window monitored";
    }

    if(tag){
      node.textContent=t+tag;
    }
  }
}

setTimeout(slxAddAheadTagsToHorizon,900);
setTimeout(slxAddAheadTagsToHorizon,2600);
setInterval(slxAddAheadTagsToHorizon,8000);

}

/* =========================================================
SLX DRIVER MODE — CALM STARTUP MODE V1
Reduces Horizon signal churn during first minute of trip
========================================================= */

if(!window.__SLX_CALM_STARTUP_MODE_V1__){
window.__SLX_CALM_STARTUP_MODE_V1__=true;

var slxTripStartTime = Date.now();

function slxIsStartupPhase(){
return (Date.now()-slxTripStartTime)<90000;
}

function slxThrottleHorizonUpdates(){

if(!slxIsStartupPhase()){return;}

var nodes=document.querySelectorAll(
".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard"
);

var i,node,text;

for(i=0;i<nodes.length;i++){

node=nodes[i];
text=(node.textContent||"").toLowerCase();

/* hide lower-priority signals during startup */

if(
text.indexOf("parking")>-1 ||
text.indexOf("fuel")>-1 ||
text.indexOf("confidence")>-1
){
node.style.opacity="0.45";
}

}

}

/* slow cadence during startup */

setTimeout(slxThrottleHorizonUpdates,1200);
setTimeout(slxThrottleHorizonUpdates,3200);
setTimeout(slxThrottleHorizonUpdates,7200);

}

/* =========================================================
SLX DRIVER MODE — HORIZON DUPLICATE SIGNAL FILTER V1
Prevents duplicate Horizon intelligence stacking
========================================================= */

if(!window.__SLX_HORIZON_DUPLICATE_FILTER_V1__){
window.__SLX_HORIZON_DUPLICATE_FILTER_V1__=true;

function slxNormalizeSignalText(t){

return String(t||"")
.toLowerCase()
.replace(/\s+/g," ")
.replace(/\s•.*$/,"")
.trim();

}

function slxRemoveDuplicateSignals(){

var nodes=document.querySelectorAll(
".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard"
);

var seen={};
var i,node,key;

for(i=0;i<nodes.length;i++){

node=nodes[i];
key=slxNormalizeSignalText(node.textContent);

if(!key){continue;}

if(seen[key]){

node.parentNode.removeChild(node);

continue;

}

seen[key]=true;

}

}

/* run periodically */

setTimeout(slxRemoveDuplicateSignals,1200);
setTimeout(slxRemoveDuplicateSignals,3200);
setInterval(slxRemoveDuplicateSignals,6000);

}

})();

/* =========================================================
SLX DRIVER MODE — ROUTE INTEL SAFE LAYOUT + CONFIDENCE MASK V1
- Moves Route Intel lower/cleaner
- Creates safe Smart Route prompt slot under Horizon, hidden by default
- Masks LOW / NULL / broken confidence wording
- No broad app hiding. No camera/map/route changes.
========================================================= */
(function(){
"use strict";

if(window.__SLX_ROUTE_INTEL_SAFE_LAYOUT_CONFIDENCE_MASK_V1__){return;}
window.__SLX_ROUTE_INTEL_SAFE_LAYOUT_CONFIDENCE_MASK_V1__=true;

function byId(id){return document.getElementById(id);}

function installStyles(){
  var st=byId("slxRouteIntelSafeLayoutConfidenceMaskV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxRouteIntelSafeLayoutConfidenceMaskV1";
  st.textContent=
    "body #slxSmartBadge{"+
      "left:14px!important;"+
      "right:auto!important;"+
      "bottom:calc(132px + env(safe-area-inset-bottom,0px))!important;"+
      "transform:none!important;"+
      "min-width:210px!important;"+
      "max-width:275px!important;"+
      "z-index:118!important;"+
    "}"+

    "body #slxSmartRoutePromptSafe{"+
      "position:fixed!important;"+
      "left:14px!important;"+
      "top:calc(214px + env(safe-area-inset-top,0px))!important;"+
      "z-index:150!important;"+
      "display:none;"+
      "align-items:center;"+
      "gap:8px;"+
      "min-height:34px;"+
      "max-width:310px;"+
      "padding:7px 11px;"+
      "border-radius:999px;"+
      "border:1px solid rgba(80,230,255,.38);"+
      "background:rgba(8,14,22,.88);"+
      "box-shadow:0 12px 28px rgba(0,0,0,.36),0 0 20px rgba(80,230,255,.16);"+
      "color:#bdf7ff;"+
      "font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;"+
      "font-size:10px;"+
      "font-weight:1000;"+
      "letter-spacing:.35px;"+
      "white-space:nowrap;"+
      "overflow:hidden;"+
      "text-overflow:ellipsis;"+
      "pointer-events:auto;"+
    "}"+

    "body #slxSmartRoutePromptSafe.on{display:flex!important;}"+

    "@media (orientation:landscape){"+
      "body #slxSmartBadge{"+
        "left:112px!important;"+
        "right:auto!important;"+
        "bottom:calc(84px + env(safe-area-inset-bottom,0px))!important;"+
        "max-width:250px!important;"+
      "}"+
      "body #slxSmartRoutePromptSafe{"+
        "left:12px!important;"+
        "top:calc(136px + env(safe-area-inset-top,0px))!important;"+
        "max-width:340px!important;"+
      "}"+
    "}";

  document.head.appendChild(st);
}

function safeConfidenceText(t){
  var s=String(t||"");

  s=s.replace(/CONFIDENCE:\s*LOW/ig,"CONFIDENCE: ACTIVE");
  s=s.replace(/confidence\s*low/ig,"corridor scan active");
  s=s.replace(/route\s*confidence\s*low/ig,"corridor scan active");
  s=s.replace(/route\s*null/ig,"route scan syncing");
  s=s.replace(/null/ig,"syncing");
  s=s.replace(/undefined/ig,"syncing");
  s=s.replace(/Trip not active/ig,"trip standing by");
  s=s.replace(/GPS waiting/ig,"GPS syncing");
  s=s.replace(/Corridor still building/ig,"corridor scan active");

  return s;
}

function cleanConfidenceUI(){
  var ids=[
    "slxSigConfidence",
    "slxSmartBadgeText"
  ];

  var i,el,t;

  for(i=0;i<ids.length;i++){
    el=byId(ids[i]);
    if(!el){continue;}

    t=safeConfidenceText(el.textContent);
    if(el.textContent!==t){el.textContent=t;}
  }

  try{
    if(window.SLX_INTEL && window.SLX_INTEL.routeConfidence){
      if(String(window.SLX_INTEL.routeConfidence.label||"").toLowerCase().indexOf("low")>-1){
        window.SLX_INTEL.routeConfidence.label="CONFIDENCE: ACTIVE";
      }

      window.SLX_INTEL.routeConfidence.reason=safeConfidenceText(
        window.SLX_INTEL.routeConfidence.reason||"corridor scan active"
      );
    }
  }catch(e){}
}

function ensureSmartRoutePrompt(){
  var p=byId("slxSmartRoutePromptSafe");

  if(p){return p;}

  p=document.createElement("button");
  p.id="slxSmartRoutePromptSafe";
  p.type="button";
  p.textContent="SMART ROUTE • review alternate when stopped";
  p.onclick=function(e){
    if(e&&e.preventDefault){e.preventDefault();}
    try{
      if(window.slxQueueSpeak){window.slxQueueSpeak("Smart route review available when stopped.",60);}
    }catch(err){}
    return false;
  };

  document.body.appendChild(p);
  return p;
}

/* manual safe hooks for later */
window.slxShowSmartRoutePromptSafe=function(text){
  var p=ensureSmartRoutePrompt();
  p.textContent=String(text||"SMART ROUTE • review alternate when stopped");
  p.classList.add("on");
};

window.slxHideSmartRoutePromptSafe=function(){
  var p=byId("slxSmartRoutePromptSafe");
  if(p){p.classList.remove("on");}
};

function tick(){
  installStyles();
  ensureSmartRoutePrompt();
  cleanConfidenceUI();
}

tick();
setTimeout(tick,500);
setTimeout(tick,1500);
setInterval(tick,2500);

})();

/* =========================================================
SLX ROUTE INTEL CONFIDENCE DISPLAY SANITIZER V2
Removes LOW / NULL confidence wording from bottom Route Intel bar
Safe UI-only patch
========================================================= */

(function(){

"use strict";

if(window.__SLX_ROUTE_INTEL_CONFIDENCE_SANITIZER_V2__) return;
window.__SLX_ROUTE_INTEL_CONFIDENCE_SANITIZER_V2__ = true;

function cleanText(t){

if(!t) return t;

t = String(t);

t = t.replace(/ROUTE INTELCONFIDENCE:\s*LOW/ig,
              "ROUTE INTEL • corridor scan active");

t = t.replace(/CONFIDENCE:\s*LOW/ig,
              "CONFIDENCE: ACTIVE");

t = t.replace(/route\s*null/ig,
              "corridor scan syncing");

t = t.replace(/null/ig,
              "syncing");

return t;
}

function sanitize(){

var nodes = document.querySelectorAll("div");

var i;
for(i=0;i<nodes.length;i++){

var el = nodes[i];

if(!el || !el.textContent) continue;

if(el.textContent.indexOf("ROUTE INTELCONFIDENCE") > -1){

el.textContent = cleanText(el.textContent);

}

}

}

sanitize();
setInterval(sanitize,2000);

})();

/* =========================================================
SLX ROUTE INTEL CARD RIGHT POSITION V1
Moves bottom Route Intel card right without touching map/camera.
========================================================= */
(function(){
"use strict";

if(window.__SLX_ROUTE_INTEL_CARD_RIGHT_POSITION_V1__){return;}
window.__SLX_ROUTE_INTEL_CARD_RIGHT_POSITION_V1__=true;

function install(){
  var st=document.getElementById("slxRouteIntelCardRightPositionV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxRouteIntelCardRightPositionV1";
  st.textContent=
    "body #slxSmartBadge{"+
      "left:auto!important;"+
      "right:18px!important;"+
      "bottom:calc(132px + env(safe-area-inset-bottom,0px))!important;"+
      "transform:none!important;"+
      "min-width:250px!important;"+
      "max-width:330px!important;"+
      "z-index:118!important;"+
    "}"+

    "@media(max-width:430px){"+
      "body #slxSmartBadge{"+
        "right:18px!important;"+
        "left:auto!important;"+
        "bottom:calc(132px + env(safe-area-inset-bottom,0px))!important;"+
        "max-width:300px!important;"+
      "}"+
    "}"+

    "@media(orientation:landscape){"+
      "body #slxSmartBadge{"+
        "right:86px!important;"+
        "left:auto!important;"+
        "bottom:calc(78px + env(safe-area-inset-bottom,0px))!important;"+
        "max-width:300px!important;"+
      "}"+
    "}";

  document.head.appendChild(st);
}

install();

})();

/* =========================================================
SLX SMART ROUTE CARD SAFE LANE V1
Places Smart Route card below Route Intel (right side)
Never overlaps dock buttons or telemetry
Hidden until explicitly triggered
========================================================= */

(function(){

"use strict";

if(window.__SLX_SMART_ROUTE_SAFE_LANE_V1__) return;
window.__SLX_SMART_ROUTE_SAFE_LANE_V1__ = true;

function ensureSmartCard(){

var el = document.getElementById("slxSmartRouteCard");

if(el) return el;

el = document.createElement("div");
el.id = "slxSmartRouteCard";

el.style.position = "fixed";
el.style.right = "18px";
el.style.bottom = "calc(78px + env(safe-area-inset-bottom,0px))";

el.style.padding = "10px 14px";
el.style.borderRadius = "999px";

el.style.background = "rgba(8,14,22,.88)";
el.style.border = "1px solid rgba(80,230,255,.38)";
el.style.boxShadow = "0 12px 28px rgba(0,0,0,.36),0 0 20px rgba(80,230,255,.16)";

el.style.fontFamily = "system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif";
el.style.fontSize = "12px";
el.style.fontWeight = "900";
el.style.letterSpacing = ".4px";

el.style.color = "#bdf7ff";

el.style.zIndex = "119";
el.style.display = "none";

el.textContent = "SMART ROUTE • alternate saves time";

document.body.appendChild(el);

return el;

}

/* expose safe triggers */

window.slxShowSmartRouteCard = function(text){

var el = ensureSmartCard();

if(text) el.textContent = text;

el.style.display = "block";

};

window.slxHideSmartRouteCard = function(){

var el = document.getElementById("slxSmartRouteCard");

if(el) el.style.display = "none";

};

/* auto-hide failsafe after 8 seconds */

window.slxPulseSmartRouteCard = function(text){

window.slxShowSmartRouteCard(text);

setTimeout(function(){

window.slxHideSmartRouteCard();

},8000);

};

ensureSmartCard();

})();

/* =========================================================
SLX SMART ROUTE ETA TRIGGER ENGINE V1
Shows Smart Route card only when alternate saves time
Safe / non-invasive
========================================================= */

(function(){

"use strict";

if(window.__SLX_SMART_ROUTE_ETA_TRIGGER_ENGINE_V1__) return;
window.__SLX_SMART_ROUTE_ETA_TRIGGER_ENGINE_V1__ = true;

function maybeTriggerSmartRoute(){

try{

if(!window.SLX_ROUTE_RUNTIME) return;

var r = window.SLX_ROUTE_RUNTIME;

if(!r.primaryEta || !r.altEta) return;

var delta = Math.round(r.primaryEta - r.altEta);

if(delta >= 2){

if(window.slxPulseSmartRouteCard){

window.slxPulseSmartRouteCard(
"SMART ROUTE • saves ~" + delta + " min"
);

}

}

}catch(e){}

}

setInterval(maybeTriggerSmartRoute, 12000);

})();

/* =========================================================
SLX ROUTE INTEL PHRASE LAYER V1
Turns diagnostic Route Intel wording into driver-native cockpit language.
UI text only. No map/camera/route changes.
========================================================= */
(function(){
"use strict";

if(window.__SLX_ROUTE_INTEL_PHRASE_LAYER_V1__){return;}
window.__SLX_ROUTE_INTEL_PHRASE_LAYER_V1__=true;

function byId(id){return document.getElementById(id);}

function phrase(t){
  var s=String(t||"");
  var low=s.toLowerCase();
  var parts=[];

  if(low.indexOf("fuel gap")>-1 || low.indexOf("sparse fuel")>-1){
    parts.push("fuel window tightening");
  }else if(low.indexOf("fuel")>-1){
    parts.push("fuel corridor monitored");
  }

  if(low.indexOf("sharp curve")>-1){
    parts.push("sharp curve zone ahead");
  }else if(low.indexOf("curve")>-1){
    parts.push("curve scan active");
  }

  if(low.indexOf("traffic heavy")>-1){
    parts.push("traffic clearing window ahead");
  }else if(low.indexOf("traffic")>-1){
    parts.push("traffic corridor monitored");
  }

  if(low.indexOf("parking risk")>-1 || low.indexOf("parking tightening")>-1){
    parts.push("parking window tightening");
  }else if(low.indexOf("parking")>-1){
    parts.push("parking survivability monitored");
  }

  if(low.indexOf("weather risk")>-1 || low.indexOf("crosswind")>-1 || low.indexOf("wind")>-1){
    parts.push("weather exposure monitored");
  }else if(low.indexOf("weather")>-1){
    parts.push("weather window stable");
  }

  if(low.indexOf("brake")>-1 || low.indexOf("downgrade")>-1){
    parts.push("grade braking watch");
  }

  if(!parts.length){
    parts.push("corridor scan active");
  }

  return "ROUTE INTEL • " + parts.slice(0,3).join(" • ");
}

function clean(){
  var badge=byId("slxSmartBadgeText");
  var badgeBox=byId("slxSmartBadge");
  var textEl;
  var raw;

  if(badge){
    raw=badge.textContent||"";
    badge.textContent=phrase(raw);
  }

  if(badgeBox){
    textEl=badgeBox.querySelector("span")||badgeBox;
    raw=textEl.textContent||"";
    textEl.textContent=phrase(raw);
  }
}

clean();
setTimeout(clean,500);
setTimeout(clean,1500);
setInterval(clean,2200);

})();

/* =========================================================
SLX SMART ROUTE INTERACTION ENGINE V1
Adds:
Ã¢Å“” stopped-only apply behavior
Ã¢Å“” mid-left preview chip under Horizon
Ã¢Å“” confidence gating
Ã¢Å“” corridor-aware preview messages
Safe UI layer only
========================================================= */

(function(){

"use strict";

if(window.__SLX_SMART_ROUTE_INTERACTION_ENGINE_V1__) return;
window.__SLX_SMART_ROUTE_INTERACTION_ENGINE_V1__ = true;

/* -------------------------
helpers
------------------------- */

function byId(id){ return document.getElementById(id); }

function mph(){
  try{
    if(window.currentFix && typeof currentFix.speed==="number"){
      return currentFix.speed * 2.23694;
    }
  }catch(e){}
  return 0;
}

function isStopped(){
  return mph() < 8;
}

/* -------------------------
confidence gate
------------------------- */

function confidenceReady(){

  try{

    if(window.SLX_INTEL &&
       window.SLX_INTEL.routeConfidence &&
       window.SLX_INTEL.routeConfidence.label){

      var label =
        String(window.SLX_INTEL.routeConfidence.label).toLowerCase();

      if(label.indexOf("low") > -1) return false;
    }

  }catch(e){}

  return true;
}

/* -------------------------
preview chip (mid-left)
------------------------- */

function ensurePreviewChip(){

  var chip = byId("slxSmartRoutePreviewChip");
  if(chip) return chip;

  chip = document.createElement("button");

  chip.id = "slxSmartRoutePreviewChip";

  chip.style.position = "fixed";
  chip.style.left = "14px";
  chip.style.top =
    "calc(50% - 40px + env(safe-area-inset-top,0px))";

  chip.style.padding = "8px 12px";
  chip.style.borderRadius = "999px";

  chip.style.background =
    "rgba(8,14,22,.88)";

  chip.style.border =
    "1px solid rgba(80,230,255,.38)";

  chip.style.color = "#bdf7ff";

  chip.style.fontFamily =
    "system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif";

  chip.style.fontSize = "11px";
  chip.style.fontWeight = "900";

  chip.style.letterSpacing = ".4px";

  chip.style.display = "none";
  chip.style.zIndex = "140";

  chip.onclick = function(){

    if(isStopped()){

      if(window.slxApplyAlternateRoute){

        window.slxApplyAlternateRoute();

      }

    }else{

      chip.textContent =
        "SMART ROUTE • stop to apply";

    }

  };

  document.body.appendChild(chip);

  return chip;
}

/* -------------------------
preview chip control
------------------------- */

window.slxShowSmartRoutePreview = function(text){

  if(!confidenceReady()) return;

  var chip = ensurePreviewChip();

  chip.textContent =
    text || "SMART ROUTE AVAILABLE";

  chip.style.display = "block";
};

window.slxHideSmartRoutePreview = function(){

  var chip = byId("slxSmartRoutePreviewChip");

  if(chip) chip.style.display = "none";
};

/* -------------------------
corridor-aware messaging
------------------------- */

function corridorMessage(){

  try{

    if(window.SLX_INTEL){

      var r = window.SLX_INTEL;

      if(r.traffic && r.traffic.level==="heavy")
        return "SMART ROUTE • congestion clearing ahead";

      if(r.weather && r.weather.exposure==="elevated")
        return "SMART ROUTE • safer weather corridor";

      if(r.parking && r.parking.pressure==="tight")
        return "SMART ROUTE • stronger parking window ahead";

      if(r.fuel && r.fuel.window==="tight")
        return "SMART ROUTE • fuel corridor improvement";

    }

  }catch(e){}

  return "SMART ROUTE AVAILABLE";
}

/* -------------------------
auto preview trigger
------------------------- */

function maybePreview(){

  if(!confidenceReady()) return;

  if(!window.SLX_ROUTE_RUNTIME) return;

  var r = window.SLX_ROUTE_RUNTIME;

  if(!r.primaryEta || !r.altEta) return;

  var delta =
    Math.round(r.primaryEta - r.altEta);

  if(delta >= 2){

    window.slxShowSmartRoutePreview(
      corridorMessage()
    );

  }

}

/* -------------------------
interval loop
------------------------- */

setInterval(maybePreview, 8000);

/* ensure chip exists early */

ensurePreviewChip();

})();

/* =========================================================
SLX HORIZON SMART ROUTE FORECAST V1
Adds predictive Horizon messaging before Smart Route appears
UI-only signal layer
========================================================= */

(function(){

"use strict";

if(window.__SLX_HORIZON_SMART_ROUTE_FORECAST_V1__) return;
window.__SLX_HORIZON_SMART_ROUTE_FORECAST_V1__ = true;

function horizonForecast(){

try{

if(!window.SLX_INTEL) return;

var intel = window.SLX_INTEL;

if(!window.slxTickerPush) return;

/* traffic compression forecast */

if(intel.traffic &&
   intel.traffic.level === "heavy"){

window.slxTickerPush(
"Traffic compression detected ahead"
);

}

/* parking tightening forecast */

if(intel.parking &&
   intel.parking.pressure === "tight"){

window.slxTickerPush(
"Parking window tightening ahead"
);

}

/* weather corridor forecast */

if(intel.weather &&
   intel.weather.exposure === "elevated"){

window.slxTickerPush(
"Weather exposure increasing ahead"
);

}

/* fuel corridor shift forecast */

if(intel.fuel &&
   intel.fuel.window === "tight"){

window.slxTickerPush(
"Fuel corridor thinning ahead"
);

}

}catch(e){}

}

setInterval(horizonForecast, 18000);

})();

/* =========================================================
SLX SMART ROUTE HORIZON HANDOFF V1
Bridges Horizon forecast \u2192 preview chip timing
Safe signal-only layer
========================================================= */

(function(){

"use strict";

if(window.__SLX_SMART_ROUTE_HORIZON_HANDOFF_V1__) return;
window.__SLX_SMART_ROUTE_HORIZON_HANDOFF_V1__ = true;

function handoff(){

try{

if(!window.SLX_INTEL) return;

if(!window.slxShowSmartRoutePreview) return;

var intel = window.SLX_INTEL;

/* traffic handoff */

if(intel.traffic &&
   intel.traffic.level === "heavy"){

window.slxShowSmartRoutePreview(
"SMART ROUTE • congestion clearing ahead"
);

}

/* parking handoff */

if(intel.parking &&
   intel.parking.pressure === "tight"){

window.slxShowSmartRoutePreview(
"SMART ROUTE • stronger parking window ahead"
);

}

/* weather handoff */

if(intel.weather &&
   intel.weather.exposure === "elevated"){

window.slxShowSmartRoutePreview(
"SMART ROUTE • safer weather corridor"
);

}

/* fuel handoff */

if(intel.fuel &&
   intel.fuel.window === "tight"){

window.slxShowSmartRoutePreview(
"SMART ROUTE • fuel corridor improvement"
);

}

}catch(e){}

}

setInterval(handoff, 22000);

})();

/* =========================================================
SLX FREIGHT HORIZON CALM + DEDUPE V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

Fixes:
- duplicate Horizon rows
- Horizon changing too fast
- hard-to-read signal churn

Safe:
- no map changes
- no camera changes
- no route changes
- no button/card movement
========================================================= */
(function(){
"use strict";

if(window.__SLX_FREIGHT_HORIZON_CALM_DEDUPE_V1__){return;}
window.__SLX_FREIGHT_HORIZON_CALM_DEDUPE_V1__=true;

var LAST_CLEAN_AT=0;
var CLEAN_GAP_MS=8500;

function byId(id){return document.getElementById(id);}

function norm(t){
  return String(t||"")
    .toLowerCase()
    .replace(/\s+/g," ")
    .replace(/•\s*next\s*[0-9]+.*$/,"")
    .replace(/•\s*corridor ahead.*$/,"")
    .replace(/•\s*likely clearing.*$/,"")
    .replace(/\s+$/,"")
    .trim();
}

function isLowValue(t){
  t=String(t||"").toLowerCase();

  if(!t){return true;}
  if(t.indexOf("standby")>-1){return true;}
  if(t.indexOf("route confidence low")>-1){return true;}
  if(t.indexOf("confidence: low")>-1){return true;}
  if(t.indexOf("null")>-1){return true;}

  return false;
}

function calmCopy(t){
  t=String(t||"");

  t=t.replace(/CONFIDENCE:\s*LOW/ig,"ROUTE INTEL");
  t=t.replace(/Route confidence low/ig,"Route intel active");
  t=t.replace(/confidence low/ig,"route intel active");
  t=t.replace(/null/ig,"");
  t=t.replace(/\s+/g," ").trim();

  return t;
}

function priority(t){
  t=String(t||"").toLowerCase();

  if(t.indexOf("turn")>-1||t.indexOf("exit")>-1||t.indexOf("merge")>-1){return 100;}
  if(t.indexOf("sharp curve")>-1){return 90;}
  if(t.indexOf("downgrade")>-1||t.indexOf("brake")>-1){return 88;}
  if(t.indexOf("weather")>-1||t.indexOf("crosswind")>-1){return 78;}
  if(t.indexOf("traffic heavy")>-1){return 70;}
  if(t.indexOf("parking")>-1){return 58;}
  if(t.indexOf("fuel")>-1){return 56;}
  if(t.indexOf("route intel")>-1){return 45;}

  return 35;
}

function cleanHorizon(){
  var track=byId("slxHTrack");
  var rows,i,row,text,key,seen,kept;

  if(!track){return;}

  rows=track.querySelectorAll(".slxSignal");
  if(!rows||!rows.length){return;}

  seen={};
  kept=[];

  for(i=0;i<rows.length;i++){
    row=rows[i];
    text=String(row.textContent||"").replace(/\s+/g," ").trim();

    if(isLowValue(text)){
      row.style.display="none";
      continue;
    }

    text=calmCopy(text);
    key=norm(text);

    if(!key){
      row.style.display="none";
      continue;
    }

    if(seen[key]){
      row.style.display="none";
      continue;
    }

    seen[key]=true;

    if(row.querySelector(".slxSignalText")){
      row.querySelector(".slxSignalText").textContent=text;
    }

    kept.push({
      row:row,
      score:priority(text),
      original:i
    });
  }

  kept.sort(function(a,b){
    if(b.score!==a.score){return b.score-a.score;}
    return a.original-b.original;
  });

  for(i=0;i<kept.length;i++){
    track.appendChild(kept[i].row);

    if(i<3){
      kept[i].row.style.display="";
      kept[i].row.style.opacity="1";
    }else{
      kept[i].row.style.display="none";
    }
  }

  LAST_CLEAN_AT=Date.now();
}

function installCalmStyles(){
  var st=byId("slxFreightHorizonCalmDedupeStyleV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxFreightHorizonCalmDedupeStyleV1";
  st.textContent=
    "#slxHTrack{max-height:138px!important;overflow:hidden!important;}"+
    "#slxHTrack .slxSignal{transition:opacity .35s ease!important;}"+
    "#slxHTrack .slxSignalText{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}";

  document.head.appendChild(st);
}

function tick(){
  var now=Date.now();

  if(now-LAST_CLEAN_AT<CLEAN_GAP_MS){return;}

  installCalmStyles();
  cleanHorizon();
}

setTimeout(tick,1000);
setTimeout(tick,3500);
setInterval(function(){

try{

if(window.currentFix && currentFix.speed){
var mph=currentFix.speed*2.23694;

if(mph>45){ tick(); return; }
if(mph>15){ tick(); return; }

setTimeout(tick,2000);

}else{
tick();
}

}catch(e){ tick(); }

},9000);

})();

/* =========================================================
SLX HORIZON TEXT SYMBOL CLEANER V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

Fixes:
- PREPARE • • • • • Turn...
- random stars/dots/glyphs inside Horizon text
- keeps normal readable bullets
========================================================= */
(function(){
"use strict";

if(window.__SLX_HORIZON_TEXT_SYMBOL_CLEANER_V1__){return;}
window.__SLX_HORIZON_TEXT_SYMBOL_CLEANER_V1__=true;

function cleanText(t){
  t=String(t||"");

  /* remove long symbol runs */
  t=t.replace(/[• ·Ã¢Ë†â„¢Ã¢â€¹â€¦Ã¢—ÂÃ¢—â€¹Ã¢—Â¦Ã¢–ÂªÃ¢–Â«Ã¢– Ã¢–Â¡Ã¢Ëœâ€¦Ã¢Ëœâ€ Ã¢Å“Â¦Ã¢Å“Â§Ã¢Å“ÂªÃ¢Å“Â©*]{2,}/g," ");

  /* remove isolated decorative symbols */
  t=t.replace(/\s+[• ·Ã¢Ë†â„¢Ã¢â€¹â€¦Ã¢—ÂÃ¢—â€¹Ã¢—Â¦Ã¢–ÂªÃ¢–Â«Ã¢– Ã¢–Â¡Ã¢Ëœâ€¦Ã¢Ëœâ€ Ã¢Å“Â¦Ã¢Å“Â§Ã¢Å“ÂªÃ¢Å“Â©*]\s+/g," • ");

  /* fix PREPARE symbol gaps */
  t=t.replace(/PREPARE\s+(?:[• ·Ã¢Ë†â„¢Ã¢â€¹â€¦Ã¢—ÂÃ¢—â€¹Ã¢—Â¦Ã¢–ÂªÃ¢–Â«Ã¢– Ã¢–Â¡Ã¢Ëœâ€¦Ã¢Ëœâ€ Ã¢Å“Â¦Ã¢Å“Â§Ã¢Å“ÂªÃ¢Å“Â©*]\s*)+/ig,"PREPARE • ");

  /* collapse repeated bullets */
  t=t.replace(/(?:\s*•\s*){2,}/g," • ");

  /* clean spacing */
  t=t.replace(/\s+/g," ").trim();

  /* remove trailing orphan bullet */
  t=t.replace(/\s*•\s*$/,"");

  return t;
}

function run(){
  var nodes=document.querySelectorAll(
    "#slxHTrack .slxSignalText,#slxHTrack .slxSignal"
  );

  var i,el,t,c;

  for(i=0;i<nodes.length;i++){
    el=nodes[i];

    if(el.querySelector && el.querySelector(".slxSignalText")){
      el=el.querySelector(".slxSignalText");
    }

    t=String(el.textContent||"");
    c=cleanText(t);

    if(c && c!==t){
      el.textContent=c;
    }
  }
}

setTimeout(run,500);
setTimeout(run,1500);
setTimeout(run,3500);
setInterval(run,3000);

})();

/* =========================================================
SLX ROUTE INTEL PHRASE THROTTLE V1
Silences repetitive "confidence low ahead" spam
Shows only meaningful changes
========================================================= */
(function(){
"use strict";

if(window.__SLX_ROUTE_INTEL_PHRASE_THROTTLE_V1__) return;
window.__SLX_ROUTE_INTEL_PHRASE_THROTTLE_V1__=true;

var lastPhrase="";
var lastTime=0;

function shouldSuppress(msg){

msg=String(msg||"").toLowerCase();

/* suppress noisy baseline phrases */
if(msg.indexOf("confidence low ahead")>-1) return true;
if(msg.indexOf("confidence corridor")>-1) return true;
if(msg.indexOf("gps syncing")>-1) return true;

/* allow meaningful hazards */
if(msg.indexOf("low bridge")>-1) return false;
if(msg.indexOf("black ice")>-1) return false;
if(msg.indexOf("fuel gap")>-1) return false;
if(msg.indexOf("parking risk")>-1) return false;
if(msg.indexOf("traffic heavy")>-1) return false;
if(msg.indexOf("road closed")>-1) return false;

return false;
}

function patch(){

var el=document.querySelector(".slxRouteIntelCard");
if(!el) return;

var text=String(el.textContent||"").trim();
if(!text) return;

/* suppress repeated identical phrases */
if(text===lastPhrase) return;

/* suppress low-value phrases */
if(shouldSuppress(text)){
el.style.display="none";
return;
}

/* throttle updates */
var now=Date.now();
if(now-lastTime<9000) return;

el.style.display="block";

lastPhrase=text;
lastTime=now;

}

setInterval(patch,2500);

})();

/* =========================================================
SLX KILL STALE EDWIN MANEUVER V2
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js
========================================================= */
(function(){
"use strict";

if(window.__SLX_KILL_STALE_EDWIN_MANEUVER_V2__){return;}
window.__SLX_KILL_STALE_EDWIN_MANEUVER_V2__=true;

function cleanText(t){
  return String(t||"")
    .replace(/\s+/g," ")
    .trim();
}

function isStaleEdwin(t){
  t=String(t||"").toLowerCase();
  return (
    t.indexOf("edwin")>-1 &&
    (
      t.indexOf("turn left")>-1 ||
      t.indexOf("left onto")>-1 ||
      t.indexOf("quarter mile")>-1 ||
      t.indexOf("0.2 mi")>-1 ||
      t.indexOf("prepare")>-1
    )
  );
}

function replaceBadHorizon(){
  var nodes=document.querySelectorAll(
    ".slxSignal,.slxSignalText,.slxHorizonItem,.slxHorizonCard,#slxSigTurn,#slxTurnCard,#slxTurnMain,#slxTurnSub"
  );
  var i,n,t;

  for(i=0;i<nodes.length;i++){
    n=nodes[i];
    t=cleanText(n.textContent);

    if(isStaleEdwin(t)){
      n.textContent="Route guidance syncing";
      n.style.opacity="0.55";
    }
  }
}

/* wipe stale maneuver steps from storage */
function scrubStoredSteps(){
  var keys=[
    "slx_route_steps_v1",
    "slx_route_steps_v2",
    "slx_maneuver_steps_v1",
    "slx_trip_steps_v1",
    "slx_nav_steps_v1"
  ];
  var i,raw,arr,j,out,txt;

  for(i=0;i<keys.length;i++){
    try{raw=localStorage.getItem(keys[i]);}catch(e){raw=null;}
    if(!raw){continue;}

    try{arr=JSON.parse(raw);}catch(e2){arr=null;}
    if(!arr||!arr.length){continue;}

    out=[];

    for(j=0;j<arr.length;j++){
      txt=JSON.stringify(arr[j]||"");
      if(!isStaleEdwin(txt)){
        out.push(arr[j]);
      }
    }

    try{localStorage.setItem(keys[i],JSON.stringify(out));}catch(e3){}
  }
}

/* intercept all speech wrappers */
function wrapSpeechFn(name){
  var old=window[name];

  if(typeof old!=="function"){return;}

  if(old.__slxEdwinWrapped){return;}

  window[name]=function(text){
    if(isStaleEdwin(text)){
      replaceBadHorizon();
      scrubStoredSteps();
      return;
    }
    return old.apply(this,arguments);
  };

  window[name].__slxEdwinWrapped=true;
}

function install(){
  replaceBadHorizon();
  scrubStoredSteps();

  wrapSpeechFn("slxSpeak");
  wrapSpeechFn("slxQueueSpeak");
  wrapSpeechFn("slxPrimeVoiceThenSpeak");
  wrapSpeechFn("primeVoiceThenSpeak");
  wrapSpeechFn("queueSpeak");
  wrapSpeechFn("speak");
}

install();
setTimeout(install,500);
setTimeout(install,1500);
setInterval(install,2000);

})();

/* =========================================================
SLX MANEUVER DIRECTION SAFETY FILTER V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js
========================================================= */
(function(){
"use strict";

if(window.__SLX_MANEUVER_DIRECTION_SAFETY_FILTER_V1__){return;}
window.__SLX_MANEUVER_DIRECTION_SAFETY_FILTER_V1__=true;

function badTurnText(t){
  t=String(t||"").toLowerCase();

  return (
    t.indexOf("turn right onto horn lake road")>-1 ||
    t.indexOf("right onto horn lake road")>-1 ||
    t.indexOf("turn left onto edwin")>-1 ||
    t.indexOf("left onto edwin")>-1
  );
}

function cleanBadTurnUI(){
  var nodes=document.querySelectorAll(
    ".slxSignal,.slxSignalText,#slxSigTurn,#slxTurnCard,#slxTurnMain,#slxTurnSub"
  );

  var i,n,t;

  for(i=0;i<nodes.length;i++){
    n=nodes[i];
    t=String(n.textContent||"");

    if(badTurnText(t)){
      n.textContent="Route guidance syncing";
      n.style.opacity="0.55";
    }
  }
}

function scrubBadStoredSteps(){
  var keys=[
    "slx_route_steps_v1",
    "slx_route_steps_v2",
    "slx_maneuver_steps_v1",
    "slx_trip_steps_v1",
    "slx_nav_steps_v1"
  ];

  var i,raw,arr,j,out,txt;

  for(i=0;i<keys.length;i++){
    try{raw=localStorage.getItem(keys[i]);}catch(e){raw=null;}
    if(!raw){continue;}

    try{arr=JSON.parse(raw);}catch(e2){arr=null;}
    if(!arr||!arr.length){continue;}

    out=[];

    for(j=0;j<arr.length;j++){
      txt=JSON.stringify(arr[j]||"");
      if(!badTurnText(txt)){
        out.push(arr[j]);
      }
    }

    try{localStorage.setItem(keys[i],JSON.stringify(out));}catch(e3){}
  }
}

function wrapSpeak(name){
  var old=window[name];

  if(typeof old!=="function"){return;}
  if(old.__slxTurnSafetyWrapped){return;}

  window[name]=function(text){
    if(badTurnText(text)){
      cleanBadTurnUI();
      scrubBadStoredSteps();
      return;
    }

    return old.apply(this,arguments);
  };

  window[name].__slxTurnSafetyWrapped=true;
}

function run(){
  cleanBadTurnUI();
  scrubBadStoredSteps();

  wrapSpeak("slxSpeak");
  wrapSpeak("slxQueueSpeak");
  wrapSpeak("slxPrimeVoiceThenSpeak");
  wrapSpeak("primeVoiceThenSpeak");
  wrapSpeak("queueSpeak");
  wrapSpeak("speak");
}

run();
setTimeout(run,500);
setTimeout(run,1500);
setInterval(run,2000);

})();

/* =========================================================
SLX DRIVER MODE INTELLIGENCE STABILITY BUNDLE V1
Safe combined patch — maneuver voice guard + horizon slow-read
wind awareness + arrival traffic voice gate
========================================================= */

(function(){
"use strict";

if(window.__SLX_INTEL_STABILITY_BUNDLE_V1__){return;}
window.__SLX_INTEL_STABILITY_BUNDLE_V1__=true;

/* =============================
SAFE SPEECH WRAPPER ENGINE
============================= */

function wrapSpeak(fnName,filter){
  var old=window[fnName];

  if(typeof old!=="function"){return;}
  if(old.__slxWrapped){return;}

  window[fnName]=function(text){
    try{
      if(filter(text)){return;}
    }catch(e){}
    return old.apply(this,arguments);
  };

  window[fnName].__slxWrapped=true;
}

function wrapAllSpeech(filter){
  wrapSpeak("slxSpeak",filter);
  wrapSpeak("slxQueueSpeak",filter);
  wrapSpeak("slxPrimeVoiceThenSpeak",filter);
  wrapSpeak("primeVoiceThenSpeak",filter);
  wrapSpeak("queueSpeak",filter);
  wrapSpeak("speak",filter);
}

/* =============================
TURN VOICE SAFETY FILTER
(disables stale maneuver calls)
============================= */

function isTurnInstruction(t){
  t=String(t||"").toLowerCase();

  return (
    t.indexOf("turn ")>-1 ||
    t.indexOf("onto ")>-1 ||
    t.indexOf("merge ")>-1 ||
    t.indexOf("exit ")>-1 ||
    t.indexOf("keep left")>-1 ||
    t.indexOf("keep right")>-1
  );
}

wrapAllSpeech(isTurnInstruction);

/* =============================
ARRIVAL TRAFFIC VOICE GATE
============================= */

function milesLeft(){
  try{
    if(window.SLX_INTEL &&
       window.SLX_INTEL.arrival &&
       typeof window.SLX_INTEL.arrival.distanceMiles==="number"){
      return window.SLX_INTEL.arrival.distanceMiles;
    }
  }catch(e){}
  return null;
}

function arrivalTrafficFilter(text){

  var mi=milesLeft();

  if(!mi || mi>3){return false;}

  text=String(text||"").toLowerCase();

  if(text.indexOf("traffic")===-1){return false;}

  if(
    text.indexOf("yard")>-1 ||
    text.indexOf("dock")>-1 ||
    text.indexOf("gate")>-1 ||
    text.indexOf("distribution")>-1 ||
    text.indexOf("facility")>-1 ||
    text.indexOf("queue")>-1 ||
    text.indexOf("parking")>-1
  ){
    return false;
  }

  return true;
}

wrapAllSpeech(arrivalTrafficFilter);

/* =============================
HORIZON SLOW-READ GOVERNOR
============================= */

var lastText={};
var lockedUntil={};
var HOLD_MS=14000;

function clean(t){
  return String(t||"")
    .replace(/[Ã¢Ëœâ€¦Ã¢Ëœâ€ Ã¢Å“Â¦Ã¢Å“Â§Ã¢Å“ÂªÃ¢Å“Â©Ã¢—ÂÃ¢—â€¹• ·]+/g," • ")
    .replace(/\s+/g," ")
    .trim();
}

function holdHorizon(){

  var nodes=document.querySelectorAll(
    "#slxHTrack .slxSignalText"
  );

  var now=Date.now();

  for(var i=0;i<nodes.length;i++){

    var n=nodes[i];
    var id=n.id||("row_"+i);

    var next=clean(n.textContent);

    if(!next){continue;}

    if(lastText[id] &&
       now < lockedUntil[id]){

      n.textContent=lastText[id];
      continue;
    }

    if(next!==lastText[id]){

      lastText[id]=next;
      lockedUntil[id]=now+HOLD_MS;

      n.textContent=next;
    }
  }
}

setInterval(holdHorizon,900);

/* =============================
WIND AWARENESS BOOST
============================= */

var lastWindFetch=0;
var WIND_FETCH_MS=90000;

function fetchWind(){

  if(Date.now()-lastWindFetch<WIND_FETCH_MS){return;}

  if(!window.currentFix){return;}

  lastWindFetch=Date.now();

  var lat=window.currentFix.lat;
  var lng=window.currentFix.lng;

  if(!lat||!lng){return;}

  var url=
  "https://api.open-meteo.com/v1/forecast?latitude="+lat+
  "&longitude="+lng+
  "&current=wind_speed_10m,wind_gusts_10m"+
  "&wind_speed_unit=mph";

  fetch(url)
  .then(function(r){return r.json();})
  .then(function(d){

    if(!d||!d.current){return;}

    var sp=Math.round(d.current.wind_speed_10m||0);
    var gs=Math.round(d.current.wind_gusts_10m||0);

    var label;

    if(sp<10 && gs<18){
      label="Wind light • corridor manageable";
    }else{
      label="Wind "+sp+" mph";
      if(gs>=18){
        label+=" • gusts "+gs+" mph";
      }
    }

    var el=document.getElementById("slxSigWeather");

    if(el){
      el.textContent=label;
    }

  })
  .catch(function(){});
}

setInterval(fetchWind,15000);

})();

/* =========================================================
SLX DRIVER MODE INTELLIGENCE STABILITY BUNDLE V2
SAFE VERSION — NO FILTER COLLISIONS
Place at VERY BOTTOM of driver-dashboard_UNIFIED.js
========================================================= */

(function(){
"use strict";

if(window.__SLX_INTEL_STABILITY_BUNDLE_V2__){return;}
window.__SLX_INTEL_STABILITY_BUNDLE_V2__=true;

/* =============================
UNIFIED SPEECH FILTER PIPELINE
============================= */

function milesLeft(){
  try{
    if(window.SLX_INTEL &&
       window.SLX_INTEL.arrival &&
       typeof window.SLX_INTEL.arrival.distanceMiles==="number"){
      return window.SLX_INTEL.arrival.distanceMiles;
    }
  }catch(e){}
  return null;
}

function blockSpeech(text){

  text = String(text||"").toLowerCase();

  /* BLOCK STALE TURN CALLS */

  if(
    text.indexOf("turn ")>-1 ||
    text.indexOf("onto ")>-1 ||
    text.indexOf("merge ")>-1 ||
    text.indexOf("exit ")>-1 ||
    text.indexOf("keep left")>-1 ||
    text.indexOf("keep right")>-1
  ){
    return true;
  }

  /* BLOCK GENERIC TRAFFIC NEAR DESTINATION */

  var mi = milesLeft();

  if(mi && mi < 3){

    if(text.indexOf("traffic")>-1){

      if(
        text.indexOf("yard")===-1 &&
        text.indexOf("dock")===-1 &&
        text.indexOf("gate")===-1 &&
        text.indexOf("distribution")===-1 &&
        text.indexOf("facility")===-1 &&
        text.indexOf("queue")===-1 &&
        text.indexOf("parking")===-1
      ){
        return true;
      }

    }

  }

  return false;
}

function wrapSpeech(fn){

  var old = window[fn];

  if(typeof old !== "function"){return;}
  if(old.__slxWrapped){return;}

  window[fn] = function(text){

    try{
      if(blockSpeech(text)){return;}
    }catch(e){}

    return old.apply(this,arguments);

  };

  window[fn].__slxWrapped=true;

}

wrapSpeech("slxSpeak");
wrapSpeech("slxQueueSpeak");
wrapSpeech("slxPrimeVoiceThenSpeak");
wrapSpeech("primeVoiceThenSpeak");
wrapSpeech("queueSpeak");
wrapSpeech("speak");

/* =============================
HORIZON SLOW READ GOVERNOR
============================= */

var lastText = {};
var lockedUntil = {};
var HOLD_MS = 14000;

function clean(t){

  return String(t||"")
  .replace(/[Ã¢Ëœâ€¦Ã¢Ëœâ€ Ã¢Å“Â¦Ã¢Å“Â§Ã¢Å“ÂªÃ¢Å“Â©Ã¢—ÂÃ¢—â€¹• ·]+/g," • ")
  .replace(/\s+/g," ")
  .trim();

}

function holdHorizon(){

  var nodes =
  document.querySelectorAll("#slxHTrack .slxSignalText");

  var now = Date.now();

  for(var i=0;i<nodes.length;i++){

    var n = nodes[i];
    var id = n.id || ("row_"+i);

    var next = clean(n.textContent);

    if(!next){continue;}

    if(lastText[id] && now < lockedUntil[id]){

      n.textContent = lastText[id];
      continue;

    }

    if(next !== lastText[id]){

      lastText[id] = next;
      lockedUntil[id] = now + HOLD_MS;

      n.textContent = next;

    }

  }

}

setInterval(holdHorizon,900);

/* =============================
WIND INTELLIGENCE BOOST
============================= */

var lastWindFetch = 0;
var WIND_FETCH_MS = 90000;

function fetchWind(){

  if(Date.now()-lastWindFetch < WIND_FETCH_MS){return;}
  if(!window.currentFix){return;}

  lastWindFetch = Date.now();

  var lat = window.currentFix.lat;
  var lng = window.currentFix.lng;

  if(!lat || !lng){return;}

  var url =
  "https://api.open-meteo.com/v1/forecast?latitude="+lat+
  "&longitude="+lng+
  "&current=wind_speed_10m,wind_gusts_10m"+
  "&wind_speed_unit=mph";

  fetch(url)
  .then(function(r){return r.json();})
  .then(function(d){

    if(!d || !d.current){return;}

    var sp = Math.round(d.current.wind_speed_10m || 0);
    var gs = Math.round(d.current.wind_gusts_10m || 0);

    var label;

    if(sp < 10 && gs < 18){

      label =
      "Wind light • corridor manageable";

    } else {

      label =
      "Wind "+sp+" mph";

      if(gs >= 18){

        label +=
        " • gusts "+gs+" mph";

      }

    }

    var el =
    document.getElementById("slxSigWeather");

    if(el){

      el.textContent = label;

    }

  })
  .catch(function(){});

}

setInterval(fetchWind,15000);

})();

/* =========================================================
SLX LIVE MANEUVER ENGINE V1
Geometry-driven next-turn detection
========================================================= */

(function(){
"use strict";

if(window.__SLX_LIVE_MANEUVER_ENGINE_V1__){return;}
window.__SLX_LIVE_MANEUVER_ENGINE_V1__=true;

/* =============================
UTILITIES
============================= */

function getFix(){

  try{
    if(window.__SLX_CORE_BRIDGE__ &&
       window.__SLX_CORE_BRIDGE__.getCurrentFix){

      return window.__SLX_CORE_BRIDGE__.getCurrentFix();
    }
  }catch(e){}

  return window.currentFix || null;

}

function getRouteCoords(){

  try{

    if(window.__SLX_CORE_BRIDGE__ &&
       window.__SLX_CORE_BRIDGE__.getRouteGeo){

      var geo =
      window.__SLX_CORE_BRIDGE__.getRouteGeo();

      if(geo &&
         geo.features &&
         geo.features[0] &&
         geo.features[0].geometry &&
         geo.features[0].geometry.coordinates){

        return geo.features[0].geometry.coordinates;

      }

    }

  }catch(e){}

  return null;

}

function miles(a,b){

  var R = 3958.8;

  var dLat =
  (b[1]-a[1]) * Math.PI/180;

  var dLon =
  (b[0]-a[0]) * Math.PI/180;

  var lat1 =
  a[1]*Math.PI/180;

  var lat2 =
  b[1]*Math.PI/180;

  var x =
  Math.sin(dLat/2)*
  Math.sin(dLat/2)+

  Math.sin(dLon/2)*
  Math.sin(dLon/2)*
  Math.cos(lat1)*
  Math.cos(lat2);

  return R*2*
  Math.atan2(
  Math.sqrt(x),
  Math.sqrt(1-x)
  );

}

function bearing(a,b){

  var dx =
  b[0]-a[0];

  var dy =
  b[1]-a[1];

  var br =
  Math.atan2(dx,dy)*
  180/Math.PI;

  while(br<0){br+=360;}
  while(br>=360){br-=360;}

  return br;

}

function angleDelta(a,b){

  var d =
  Math.abs(a-b);

  if(d>180){
  d=360-d;
  }

  return d;

}

/* =============================
NEXT TURN DETECTOR
============================= */

function nextTurn(){

  var fix =
  getFix();

  var coords =
  getRouteCoords();

  if(!fix ||
     !coords ||
     coords.length<5){

    return null;

  }

  var pos =
  [fix.lng,fix.lat];

  var bestIndex =
  0;

  var bestDist =
  999999;

  for(var i=0;i<coords.length;i+=2){

    var d =
    miles(
    pos,
    coords[i]
    );

    if(d<bestDist){

      bestDist=d;
      bestIndex=i;

    }

  }

  var aheadIndex =
  Math.min(
  coords.length-2,
  bestIndex+6
  );

  var b1 =
  bearing(
  coords[bestIndex],
  coords[bestIndex+2]
  );

  var b2 =
  bearing(
  coords[aheadIndex-2],
  coords[aheadIndex]
  );

  var delta =
  angleDelta(b1,b2);

  if(delta<25){
  return null;
  }

  if(delta>45){

    if(
    (b2-b1+360)%360 > 180
    ){

      return {
      dir:"left"
      };

    }else{

      return {
      dir:"right"
      };

    }

  }

  return null;

}

/* =============================
VOICE OUTPUT
============================= */

var lastTurnSpoken=0;

function speakTurn(){

  var turn =
  nextTurn();

  if(!turn){
  return;
  }

  var now =
  Date.now();

  if(
  now-lastTurnSpoken <
  8000
  ){
  return;
  }

  lastTurnSpoken=
  now;

  var text =
  "Prepare to turn "+
  turn.dir;

  try{

    if(window.slxQueueSpeak){

      window.slxQueueSpeak(
      text,
      80
      );

      return;
    }

    if(window.slxSpeak){

      window.slxSpeak(text);

      return;
    }

  }catch(e){}

}

/* =============================
RUN LOOP
============================= */

setInterval(
speakTurn,
2500
);

})();

/* =========================================================
SLX LIVE ROAD NAME EXTRACTION ENGINE V1
Adds street-name awareness to geometry-based maneuver voice
========================================================= */

(function(){
"use strict";

if(window.__SLX_ROAD_NAME_ENGINE_V1__){return;}
window.__SLX_ROAD_NAME_ENGINE_V1__=true;

/* =============================
GET ROUTE STEPS (PRIMARY SOURCE)
============================= */

function getRouteSteps(){

  try{

    if(window.__SLX_CORE_BRIDGE__ &&
       window.__SLX_CORE_BRIDGE__.getRouteSteps){

      return window.__SLX_CORE_BRIDGE__.getRouteSteps();

    }

  }catch(e){}

  try{

    var raw =
    localStorage.getItem("slx_route_steps_v2");

    if(raw){

      return JSON.parse(raw);

    }

  }catch(e){}

  return null;

}

/* =============================
FIND NEAREST STEP AHEAD
============================= */

function nearestStep(){

  var steps =
  getRouteSteps();

  if(!steps || !steps.length){
  return null;
  }

  var fix =
  window.currentFix;

  if(!fix){
  return null;
  }

  var best=null;
  var bestDist=9999;

  for(var i=0;i<steps.length;i++){

    var s=steps[i];

    if(!s || !s.location){
    continue;
    }

    var d =
    Math.abs(
      (s.location[0]-fix.lng)*
      (s.location[0]-fix.lng)
    ) +
    Math.abs(
      (s.location[1]-fix.lat)*
      (s.location[1]-fix.lat)
    );

    if(d<bestDist){

      best=s;
      bestDist=d;

    }

  }

  return best;

}

/* =============================
EXTRACT ROAD NAME
============================= */

function getNextRoadName(){

  var step =
  nearestStep();

  if(!step){
  return null;
  }

  if(step.name){
  return step.name;
  }

  if(step.maneuver &&
     step.maneuver.instruction){

    var txt =
    step.maneuver.instruction;

    var match =
    txt.match(/onto (.+)$/i);

    if(match){
    return match[1];
    }

  }

  return null;

}

/* =============================
PATCH LIVE TURN VOICE
============================= */

if(window.speakTurn){

  var oldSpeakTurn =
  window.speakTurn;

  window.speakTurn=function(){

    var turn =
    window.nextTurn &&
    window.nextTurn();

    if(!turn){
    return;
    }

    var road =
    getNextRoadName();

    var now =
    Date.now();

    if(window.__slxLastRoadVoice &&
       now-window.__slxLastRoadVoice<9000){

      return;

    }

    window.__slxLastRoadVoice=now;

    var phrase =
    "Prepare to turn "+
    turn.dir;

    if(road){

      phrase +=
      " on "+road;

    }

    try{

      if(window.slxQueueSpeak){

        window.slxQueueSpeak(
        phrase,
        80
        );

        return;

      }

      if(window.slxSpeak){

        window.slxSpeak(
        phrase
        );

      }

    }catch(e){}

  };

}

})();

/* =========================================================
SLX DISTANCE-TIMED MANEUVER VOICE ENGINE V1
Adds staged maneuver timing:
• early prepare
• distance callout
• turn now call
========================================================= */

(function(){
"use strict";

if(window.__SLX_DISTANCE_MANEUVER_ENGINE_V1__){return;}
window.__SLX_DISTANCE_MANEUVER_ENGINE_V1__=true;

/* =============================
UTILITIES
============================= */

function getFix(){
  if(window.__SLX_CORE_BRIDGE__ &&
     window.__SLX_CORE_BRIDGE__.getCurrentFix){
    return window.__SLX_CORE_BRIDGE__.getCurrentFix();
  }
  return window.currentFix || null;
}

function getSteps(){

  if(window.__SLX_CORE_BRIDGE__ &&
     window.__SLX_CORE_BRIDGE__.getRouteSteps){
    return window.__SLX_CORE_BRIDGE__.getRouteSteps();
  }

  try{
    var raw=localStorage.getItem("slx_route_steps_v2");
    if(raw){return JSON.parse(raw);}
  }catch(e){}

  return null;
}

function milesBetween(a,b){

  var R=3958.8;

  var dLat=(b[1]-a[1])*Math.PI/180;
  var dLon=(b[0]-a[0])*Math.PI/180;

  var lat1=a[1]*Math.PI/180;
  var lat2=b[1]*Math.PI/180;

  var x=
    Math.sin(dLat/2)*Math.sin(dLat/2)+
    Math.sin(dLon/2)*Math.sin(dLon/2)*
    Math.cos(lat1)*Math.cos(lat2);

  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}

/* =============================
NEXT STEP DETECTOR
============================= */

function nextStep(){

  var steps=getSteps();
  var fix=getFix();

  if(!steps || !fix){return null;}

  var best=null;
  var bestDist=9999;

  for(var i=0;i<steps.length;i++){

    var s=steps[i];

    if(!s || !s.location){continue;}

    var dist=milesBetween(
      [fix.lng,fix.lat],
      s.location
    );

    if(dist<bestDist){
      best=s;
      bestDist=dist;
    }

  }

  return best;
}

/* =============================
ROAD NAME EXTRACTOR
============================= */

function roadName(step){

  if(!step){return null;}

  if(step.name){return step.name;}

  if(step.maneuver &&
     step.maneuver.instruction){

    var match=
      step.maneuver.instruction.match(/onto (.+)$/i);

    if(match){return match[1];}

  }

  return null;
}

/* =============================
STAGING STATE MACHINE
============================= */

var lastStage="";
var lastSpeakTime=0;

function speak(text){

  try{
    if(window.slxQueueSpeak){
      window.slxQueueSpeak(text,80);
      return;
    }

    if(window.slxSpeak){
      window.slxSpeak(text);
    }

  }catch(e){}
}

function maneuverVoiceLoop(){

  var step=nextStep();

  if(!step){return;}

  var fix=getFix();
  if(!fix){return;}

  var dist=
    milesBetween(
      [fix.lng,fix.lat],
      step.location
    );

  var road=roadName(step);

  var dir=
    step.maneuver &&
    step.maneuver.modifier
    ? step.maneuver.modifier
    : null;

  if(!dir){return;}

  var now=Date.now();

  if(now-lastSpeakTime<3500){return;}

  /* EARLY PREPARE */

  if(dist<1 && dist>0.35){

    if(lastStage!=="prepare"){

      lastStage="prepare";
      lastSpeakTime=now;

      speak(
        "Prepare to turn "+
        dir+
        (road?" on "+road:"")
      );

    }

    return;
  }

  /* DISTANCE CALLOUT */

  if(dist<=0.35 && dist>0.07){

    if(lastStage!=="distance"){

      lastStage="distance";
      lastSpeakTime=now;

      speak(
        "Turn "+
        dir+
        (road?" on "+road:"")+
        " in "+
        dist.toFixed(1)+
        " miles"
      );

    }

    return;
  }

  /* TURN NOW */

  if(dist<=0.07){

    if(lastStage!=="now"){

      lastStage="now";
      lastSpeakTime=now;

      speak(
        "Turn "+
        dir+
        (road?" on "+road:"")+" now"
      );

    }

  }

}

/* =============================
RUN LOOP
============================= */

setInterval(
  maneuverVoiceLoop,
  1200
);

})();

/* =========================================================
SLX DEADHEAD RISK ENGINE V1
Forward corridor survivability predictor
Uses Reload Confidence + corridor conditions
========================================================= */

(function(){
"use strict";

if(window.__SLX_DEADHEAD_RISK_ENGINE_V1__){return;}
window.__SLX_DEADHEAD_RISK_ENGINE_V1__=true;

/* =========================================================
SAFE HELPERS
========================================================= */

function now(){return Date.now();}

function getReloadScore(){

  try{
    if(window.computeReloadConfidence){
      return window.computeReloadConfidence();
    }
  }catch(e){}

  return 50;
}

/* =========================================================
CORRIDOR DEPTH FACTOR
Longer outbound corridors increase exposure risk
========================================================= */

function corridorDepthRisk(){

  try{

    if(window.routeRemainingMiles){

      if(window.routeRemainingMiles > 180) return 12;
      if(window.routeRemainingMiles > 120) return 8;
      if(window.routeRemainingMiles > 60) return 4;

    }

  }catch(e){}

  return 3;
}

/* =========================================================
PARKING SURVIVABILITY FACTOR
If staging unavailable, reload probability drops
========================================================= */

function parkingRisk(){

  try{

    if(window.parkingState){

      if(window.parkingState.level==="full") return 15;
      if(window.parkingState.level==="tightening") return 8;
      if(window.parkingState.level==="open") return 0;

    }

  }catch(e){}

  return 4;
}

/* =========================================================
TIME-OF-DAY RISK FACTOR
Night arrivals reduce reload probability
========================================================= */

function timeRisk(){

  var hr=new Date().getHours();

  if(hr>=21 || hr<=4) return 12;

  if(hr>=18 || hr<=6) return 6;

  return 2;
}

/* =========================================================
SIGNAL SPARSITY FACTOR
Low density ahead increases deadhead likelihood
========================================================= */

function signalRisk(){

  try{

    if(window.SLX_SIGNAL_CACHE){

      var drivers=
        window.SLX_SIGNAL_CACHE.driver ?
        window.SLX_SIGNAL_CACHE.driver.length : 0;

      var shippers=
        window.SLX_SIGNAL_CACHE.shipper ?
        window.SLX_SIGNAL_CACHE.shipper.length : 0;

      if(drivers===0 && shippers===0) return 25;

      if(drivers<2 && shippers<2) return 15;

      if(drivers<4 && shippers<4) return 6;

    }

  }catch(e){}

  return 4;
}

/* =========================================================
FINAL DEADHEAD SCORE
========================================================= */

function computeDeadheadRisk(){

  var reloadScore=getReloadScore();

  var risk=0;

  risk+=corridorDepthRisk();
  risk+=parkingRisk();
  risk+=timeRisk();
  risk+=signalRisk();

  risk+=Math.max(0,60-reloadScore);

  if(risk<0) risk=0;
  if(risk>100) risk=100;

  return risk;
}

/* =========================================================
LABEL ENGINE
========================================================= */

function riskLabel(score){

  if(score>=70) return "HIGH";
  if(score>=40) return "MODERATE";

  return "LOW";
}

/* =========================================================
HORIZON CARD UPDATE
========================================================= */

function updateDeadheadCard(){

  var score=computeDeadheadRisk();

  var label=riskLabel(score);

  var el=document.getElementById("slxSigDeadhead");

  if(!el){

    var host=document.getElementById("slxHTrack");

    if(!host){return;}

    el=document.createElement("div");

    el.id="slxSigDeadhead";
    el.className="slxSignal";

    el.style.opacity=".85";

    host.appendChild(el);

  }

  el.textContent=
  "ROUTE INTEL • deadhead risk "+label.toLowerCase()+" ahead";

}

/* =========================================================
VOICE EVENTS (ONLY WHEN IMPORTANT)
========================================================= */

var lastVoice=0;
var lastState=null;

function deadheadVoice(){

  var score=computeDeadheadRisk();

  var label=riskLabel(score);

  if(label===lastState){return;}

  lastState=label;

  if(now()-lastVoice<180000){return;}

  lastVoice=now();

  try{

    if(window.slxQueueSpeak){

      if(label==="HIGH")
        window.slxQueueSpeak(
          "Deadhead risk rising ahead",
          70
        );

      if(label==="LOW"){
        /* V19: reload/deadhead LOW state remains visual-only.
           Never consume the navigation voice lane. */
      }

    }

  }catch(e){}

}

/* =========================================================
RUN LOOP
========================================================= */

setInterval(updateDeadheadCard,7000);
setInterval(deadheadVoice,20000);

})();

/* =========================================================
SLX DRIVER STAGING SIGNAL ENGINE V1
Detects empty-driver clustering ahead on route corridor
Feeds Reload Confidence + Deadhead Risk + Horizon Intel
========================================================= */

(function(){
"use strict";

if(window.__SLX_DRIVER_STAGING_ENGINE_V1__){return;}
window.__SLX_DRIVER_STAGING_ENGINE_V1__=true;

/* =========================================================
SAFE HELPERS
========================================================= */

function getCorridorDriverSignals(){

  if(window.getCorridorDriverSignals){
    return window.getCorridorDriverSignals();
  }

  return 0;
}

function getEquipmentType(){

  try{
    return localStorage.getItem("slx_equipment_type_v1");
  }catch(e){}

  return null;
}

/* =========================================================
EQUIPMENT MATCH FILTER
========================================================= */

function matchingDriversAhead(){

  if(!window.SLX_SIGNAL_CACHE){
    return 0;
  }

  var eq=getEquipmentType();

  if(!eq){
    return getCorridorDriverSignals();
  }

  var list=
    window.SLX_SIGNAL_CACHE.driver || [];

  var count=0;

  for(var i=0;i<list.length;i++){

    var s=list[i];

    if(!s){continue;}

    if(!s.equipment){
      count++;
      continue;
    }

    if(
      String(s.equipment)
      .toLowerCase()
      .indexOf(
        String(eq).toLowerCase()
      )>-1
    ){
      count++;
    }

  }

  return count;

}

/* =========================================================
STAGING CLUSTER CLASSIFIER
========================================================= */

function stagingLabel(count){

  if(count>=4){
    return "cluster";
  }

  if(count>=2){
    return "forming";
  }

  if(count>=1){
    return "present";
  }

  return null;
}

/* =========================================================
HORIZON CARD UPDATE
========================================================= */

function updateStagingCard(){

  var count=matchingDriversAhead();

  var label=stagingLabel(count);

  if(!label){
    return;
  }

  var eq=getEquipmentType()||"drivers";

  eq=eq.replace("_"," ");

  var el=document.getElementById("slxSigStaging");

  if(!el){

    var host=document.getElementById("slxHTrack");

    if(!host){return;}

    el=document.createElement("div");

    el.id="slxSigStaging";
    el.className="slxSignal";

    el.style.opacity=".85";

    host.appendChild(el);

  }

  el.textContent=
  "ROUTE INTEL • "+
  count+
  " empty "+
  eq+
  " staging ahead";

}

/* =========================================================
VOICE EVENT (ONLY WHEN CLUSTER FORMS)
========================================================= */

var lastVoiceTime=0;
var lastClusterState=false;

function stagingVoice(){

  var count=matchingDriversAhead();

  var cluster=count>=4;

  if(cluster===lastClusterState){
    return;
  }

  lastClusterState=cluster;

  if(!cluster){
    return;
  }

  if(Date.now()-lastVoiceTime<180000){
    return;
  }

  lastVoiceTime=Date.now();

  try{

    if(window.slxQueueSpeak){

      window.slxQueueSpeak(
        "Driver staging cluster forming ahead",
        70
      );

    }

  }catch(e){}

}

/* =========================================================
RUN LOOP
========================================================= */

setInterval(updateStagingCard,6000);
setInterval(stagingVoice,20000);

})();

/* =========================================================
SLX FREIGHT ACTIVITY AHEAD ENGINE V1
Combines driver staging + shipper density + reload confidence
Creates simple Horizon signal: freight activity increasing ahead
========================================================= */

(function(){
"use strict";

if(window.__SLX_FREIGHT_ACTIVITY_AHEAD_ENGINE_V1__){return;}
window.__SLX_FREIGHT_ACTIVITY_AHEAD_ENGINE_V1__=true;

function countDrivers(){
  try{
    if(window.getCorridorDriverSignals){return Number(window.getCorridorDriverSignals()||0);}
  }catch(e){}
  return 0;
}

function countShippers(){
  try{
    if(window.getCorridorShipperSignals){return Number(window.getCorridorShipperSignals()||0);}
  }catch(e){}
  return 0;
}

function reloadScore(){
  try{
    if(window.computeReloadConfidence){return Number(window.computeReloadConfidence()||50);}
  }catch(e){}
  return 50;
}

function freightActivityScore(){
  var drivers=countDrivers();
  var shippers=countShippers();
  var reload=reloadScore();
  var score=0;

  if(drivers>=4){score+=35;}
  else if(drivers>=2){score+=22;}
  else if(drivers>=1){score+=10;}

  if(shippers>=4){score+=40;}
  else if(shippers>=2){score+=25;}
  else if(shippers>=1){score+=12;}

  if(reload>=65){score+=20;}
  else if(reload>=35){score+=10;}

  if(score>100){score=100;}
  if(score<0){score=0;}

  return score;
}

function activityLabel(score){
  if(score>=65){return "increasing";}
  if(score>=35){return "forming";}
  return "thin";
}

function updateFreightActivityCard(){
  var score=freightActivityScore();
  var label=activityLabel(score);
  var el=document.getElementById("slxSigFreightActivity");
  var host;

  if(!el){
    host=document.getElementById("slxHTrack");
    if(!host){return;}

    el=document.createElement("div");
    el.id="slxSigFreightActivity";
    el.className="slxSignal";
    el.style.opacity=".85";
    host.appendChild(el);
  }

  if(label==="increasing"){
    el.textContent="ROUTE INTEL • freight activity increasing ahead";
  }else if(label==="forming"){
    el.textContent="ROUTE INTEL • freight activity forming ahead";
  }else{
    el.textContent="ROUTE INTEL • freight activity thin ahead";
  }
}

var lastVoiceAt=0;
var lastLabel="";

function voiceFreightActivity(){
  var score=freightActivityScore();
  var label=activityLabel(score);

  if(label===lastLabel){return;}
  lastLabel=label;

  if(Date.now()-lastVoiceAt<240000){return;}

  if(label==="increasing"){
    lastVoiceAt=Date.now();
    try{
      if(window.slxQueueSpeak){
        window.slxQueueSpeak("Freight activity increasing ahead",70);
      }
    }catch(e){}
  }
}

setInterval(updateFreightActivityCard,6000);
setInterval(voiceFreightActivity,22000);

})();

/* =========================================================
SLX EQUIPMENT MATCH INTEL PATCH
Adds equipment-specific freight interpretation
========================================================= */

(function(){

"use strict";

if(window.__SLX_EQUIPMENT_MATCH_INTEL_PATCH__){return;}
window.__SLX_EQUIPMENT_MATCH_INTEL_PATCH__=true;

function getEquip(){
try{
return localStorage.getItem("slx_equipment_type_v1")||"equipment";
}catch(e){}
return "equipment";
}

function updateEquipSignal(){

var el=document.getElementById("slxSigEquipMatch");

if(!window.getCorridorDriverSignals){return;}

var drivers=Number(window.getCorridorDriverSignals()||0);

if(drivers<2){return;}

var host=document.getElementById("slxHTrack");
if(!host){return;}

if(!el){

el=document.createElement("div");

el.id="slxSigEquipMatch";
el.className="slxSignal";

host.appendChild(el);

}

var eq=getEquip().replace("_"," ");

el.textContent=
"ROUTE INTEL • "+
eq+
" activity building ahead";

}

setInterval(updateEquipSignal,8000);

})();

/* =========================================================
SLX CALM HORIZON GOVERNOR V1
Slows Horizon changes, removes duplicate rows, shortens text
========================================================= */
(function(){
"use strict";

if(window.__SLX_CALM_HORIZON_GOVERNOR_V1__){return;}
window.__SLX_CALM_HORIZON_GOVERNOR_V1__=true;

var HOLD_MS = 12000;
var lastById = {};
var lastAtById = {};

function cleanText(t){
  t = String(t || "");
  t = t.replace(/\s+/g," ");
  t = t.replace(/CONFIDENCE:\s*LOW/gi,"ROUTE CONFIDENCE: LOW");
  t = t.replace(/traffic heavy/gi,"traffic rising");
  t = t.replace(/traffic moderate/gi,"traffic steady");
  t = t.replace(/fuel gap/gi,"fuel thin");
  t = t.replace(/weather corridor manageable/gi,"weather stable");
  t = t.replace(/sharp curve ahead • ease down/gi,"sharp curve ahead");
  t = t.replace(/route corridor stable/gi,"corridor stable");
  t = t.replace(/freight activity increasing ahead/gi,"freight increasing");
  t = t.replace(/freight activity forming ahead/gi,"freight forming");
  t = t.replace(/parking likely open ahead/gi,"parking likely open");
  t = t.replace(/parking tightening ahead/gi,"parking tightening");
  return t;
}

function weight(t){
  t = String(t || "").toLowerCase();
  if(t.indexOf("turn")>-1 || t.indexOf("prepare")>-1){return 100;}
  if(t.indexOf("off route")>-1 || t.indexOf("route drift")>-1){return 95;}
  if(t.indexOf("weather")>-1 || t.indexOf("wind")>-1 || t.indexOf("crosswind")>-1){return 85;}
  if(t.indexOf("sharp curve")>-1 || t.indexOf("downgrade")>-1 || t.indexOf("brake")>-1){return 80;}
  if(t.indexOf("parking")>-1){return 65;}
  if(t.indexOf("fuel")>-1){return 60;}
  if(t.indexOf("freight")>-1 || t.indexOf("reload")>-1 || t.indexOf("staging")>-1){return 55;}
  if(t.indexOf("confidence")>-1){return 45;}
  return 20;
}

function stabilizeRow(row){
  var span = row.querySelector(".slxSignalText") || row;
  var id = span.id || row.id || "";
  var next = cleanText(span.textContent);
  var prev = lastById[id] || "";
  var now = Date.now();

  if(!id){return;}

  if(prev && next !== prev){
    if(weight(next) <= weight(prev) && now - (lastAtById[id] || 0) < HOLD_MS){
      span.textContent = prev;
      return;
    }
  }

  lastById[id] = next;
  lastAtById[id] = now;
  span.textContent = next;
}

function dedupeRows(){
  var track = document.getElementById("slxHTrack");
  var rows, seen = {}, i, row, text;

  if(!track){return;}

  rows = track.querySelectorAll(".slxSignal");

  for(i=0;i<rows.length;i++){
    row = rows[i];
    text = cleanText(row.textContent).toLowerCase();

    if(!text || text.indexOf("standby")>-1){
      row.style.display = "none";
      continue;
    }

    if(seen[text]){
      row.style.display = "none";
      continue;
    }

    seen[text] = true;
    row.style.display = "";
    stabilizeRow(row);
  }
}

function installStyles(){
  var st = document.getElementById("slxCalmHorizonGovernorStyleV1");
  if(st){return;}

  st = document.createElement("style");
  st.id = "slxCalmHorizonGovernorStyleV1";
  st.textContent =
    "#slxHTrack{max-height:132px!important;overflow:hidden!important;}"+
    "#slxHTrack .slxSignal{min-height:34px!important;padding:7px 12px!important;}"+
    "#slxHTrack .slxSignalText{max-width:100%!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}";

  document.head.appendChild(st);
}

function tick(){
  installStyles();
  dedupeRows();
}

setTimeout(tick,500);
setTimeout(tick,1500);
setInterval(tick,2500);

})();

/* =========================================================
SLX HORIZON SLOW-READ GOVERNOR V2
Ensures drivers can actually read Horizon signals
========================================================= */
(function(){

"use strict";

if(window.__SLX_HORIZON_SLOW_READ_GOVERNOR_V2__){return;}
window.__SLX_HORIZON_SLOW_READ_GOVERNOR_V2__=true;

var MIN_VISIBLE_MS = 7000;   // minimum time a message stays visible
var MAX_ROWS = 3;            // max rows shown simultaneously

var lastSwapAt = 0;

/* =========================================================
ROW PRIORITY SYSTEM
========================================================= */

function priorityScore(text){

text = String(text||"").toLowerCase();

if(text.indexOf("turn")>-1) return 100;
if(text.indexOf("prepare")>-1) return 100;

if(text.indexOf("off route")>-1) return 95;

if(text.indexOf("weather")>-1) return 85;
if(text.indexOf("crosswind")>-1) return 85;

if(text.indexOf("curve")>-1) return 80;
if(text.indexOf("downgrade")>-1) return 80;

if(text.indexOf("parking")>-1) return 70;
if(text.indexOf("fuel")>-1) return 60;

if(text.indexOf("freight")>-1) return 55;
if(text.indexOf("reload")>-1) return 55;
if(text.indexOf("staging")>-1) return 55;

if(text.indexOf("confidence")>-1) return 40;

return 10;

}

/* =========================================================
ROW SORTER
========================================================= */

function sortRows(rows){

rows.sort(function(a,b){

return priorityScore(b.textContent)
     - priorityScore(a.textContent);

});

return rows;

}

/* =========================================================
VISIBLE ROW LIMITER
========================================================= */

function enforceRowLimit(){

var track = document.getElementById("slxHTrack");

if(!track) return;

var rows = [].slice.call(track.querySelectorAll(".slxSignal"));

if(rows.length <= MAX_ROWS) return;

rows = sortRows(rows);

var i;

for(i=0;i<rows.length;i++){

if(i < MAX_ROWS){

rows[i].style.display = "";

}else{

rows[i].style.display = "none";

}

}

}

/* =========================================================
SWAP RATE LIMITER
========================================================= */

function enforceSwapRate(){

var now = Date.now();

if(now - lastSwapAt < MIN_VISIBLE_MS){

return false;

}

lastSwapAt = now;

return true;

}

/* =========================================================
MAIN LOOP
========================================================= */

function slowReadTick(){

if(!enforceSwapRate()) return;

enforceRowLimit();

}

setInterval(slowReadTick,2000);

})();

/* =========================================================
SLX HORIZON HARD STABILIZER V3
Final read-speed + duplicate + broken-text guard
========================================================= */
(function(){
"use strict";

if(window.__SLX_HORIZON_HARD_STABILIZER_V3__){return;}
window.__SLX_HORIZON_HARD_STABILIZER_V3__=true;

var HOLD_MS=18000;
var MAX_ROWS=3;
var lastCleanBySlot={};
var lastUpdateAtBySlot={};

function clean(t){
  t=String(t||"");

  t=t.replace(/\s+/g," ").trim();

  /* remove repeated broken phrases */
  t=t.replace(/(wind exposure\s*){2,}/gi,"Wind exposure ahead");
  t=t.replace(/(exposure\s*){2,}/gi,"exposure");
  t=t.replace(/(parking\s*){2,}/gi,"Parking ");
  t=t.replace(/(confidence:\s*low\s*){2,}/gi,"ROUTE CONFIDENCE: LOW ");

  /* make driver-facing language calmer */
  t=t.replace(/CONFIDENCE:\s*LOW/gi,"ROUTE CONFIDENCE: LOW");
  t=t.replace(/traffic heavy/gi,"traffic rising");
  t=t.replace(/fuel gap/gi,"fuel thin");
  t=t.replace(/Good parking Wind exposure.*$/gi,"Good parking window now");
  t=t.replace(/Parking Wind exposure.*$/gi,"Wind exposure ahead");

  /* cap very long lines */
  if(t.length>54){
    t=t.substring(0,54).replace(/\s+\S*$/,"");
  }

  return t;
}

function score(t){
  t=String(t||"").toLowerCase();

  if(t.indexOf("turn")>-1||t.indexOf("prepare")>-1){return 100;}
  if(t.indexOf("off route")>-1){return 95;}
  if(t.indexOf("wind")>-1||t.indexOf("weather")>-1){return 85;}
  if(t.indexOf("curve")>-1||t.indexOf("brake")>-1){return 80;}
  if(t.indexOf("parking")>-1){return 70;}
  if(t.indexOf("fuel")>-1){return 60;}
  if(t.indexOf("freight")>-1||t.indexOf("reload")>-1){return 55;}
  if(t.indexOf("confidence")>-1){return 45;}

  return 10;
}

function stabilize(){
  var track=document.getElementById("slxHTrack");
  var rows,i,row,text,key,items,seen,now;

  if(!track){return;}

  rows=[].slice.call(track.querySelectorAll(".slxSignal"));
  items=[];
  seen={};
  now=Date.now();

  for(i=0;i<rows.length;i++){
    row=rows[i];
    text=clean(row.textContent);

    if(!text||text.toLowerCase().indexOf("standby")>-1){
      row.style.display="none";
      continue;
    }

    key=text.toLowerCase();

    if(seen[key]){
      row.style.display="none";
      continue;
    }

    seen[key]=true;

    items.push({
      row:row,
      text:text,
      score:score(text),
      original:i
    });
  }

  items.sort(function(a,b){
    if(b.score!==a.score){return b.score-a.score;}
    return a.original-b.original;
  });

  for(i=0;i<items.length;i++){
    row=items[i].row;

    if(i>=MAX_ROWS){
      row.style.display="none";
      continue;
    }

    text=items[i].text;

    if(lastCleanBySlot[i] && text!==lastCleanBySlot[i]){
      if(now-(lastUpdateAtBySlot[i]||0)<HOLD_MS && items[i].score<95){
        text=lastCleanBySlot[i];
      }else{
        lastCleanBySlot[i]=text;
        lastUpdateAtBySlot[i]=now;
      }
    }else{
      lastCleanBySlot[i]=text;
      lastUpdateAtBySlot[i]=now;
    }

    row.style.display="";
    row.textContent=text;
  }
}

function styles(){
  var st=document.getElementById("slxHorizonHardStabilizerV3Style");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxHorizonHardStabilizerV3Style";
  st.textContent=
    "#slxHTrack{max-height:124px!important;overflow:hidden!important;}"+
    "#slxHTrack .slxSignal{min-height:34px!important;padding:7px 12px!important;}"+
    "#slxHTrack .slxSignal:nth-child(n+4){display:none!important;}"+
    "#slxHTrack .slxSignalText{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;max-width:100%!important;}";

  document.head.appendChild(st);
}

function tick(){
  styles();
  stabilize();
}

setTimeout(tick,400);
setTimeout(tick,1400);
setInterval(tick,4000);

})();

/* =========================================================
SLX HORIZON CONTROLLED DISPLAY V1
Stops fast upstream Horizon churn by rendering a stable 3-line display
========================================================= */
(function(){
"use strict";

if(window.__SLX_HORIZON_CONTROLLED_DISPLAY_V1__){return;}
window.__SLX_HORIZON_CONTROLLED_DISPLAY_V1__=true;

var ROTATE_MS=20000;
var lastRenderAt=0;
var lockedLines=[];
var seen={};

function clean(t){
  t=String(t||"").replace(/\s+/g," ").trim();

  t=t.replace(/CONFIDENCE:\s*LOW/gi,"ROUTE CONFIDENCE: LOW");
  t=t.replace(/traffic heavy/gi,"traffic rising");
  t=t.replace(/traffic moderate/gi,"traffic steady");
  t=t.replace(/fuel gap/gi,"fuel thin");
  t=t.replace(/weather corridor manageable/gi,"weather stable");
  t=t.replace(/sharp curve ahead\s*•\s*ease down/gi,"sharp curve ahead");
  t=t.replace(/route corridor stable/gi,"corridor stable");
  t=t.replace(/wind exposure.*$/gi,"wind exposure ahead");
  t=t.replace(/exposure exposure/gi,"exposure");

  if(t.length>52){
    t=t.substring(0,52).replace(/\s+\S*$/,"");
  }

  return t;
}

function score(t){
  t=String(t||"").toLowerCase();

  if(t.indexOf("turn")>-1||t.indexOf("prepare")>-1){return 100;}
  if(t.indexOf("off route")>-1){return 95;}
  if(t.indexOf("wind")>-1||t.indexOf("weather")>-1){return 85;}
  if(t.indexOf("curve")>-1||t.indexOf("brake")>-1||t.indexOf("downgrade")>-1){return 80;}
  if(t.indexOf("parking")>-1){return 70;}
  if(t.indexOf("fuel")>-1){return 60;}
  if(t.indexOf("freight")>-1||t.indexOf("reload")>-1||t.indexOf("staging")>-1){return 55;}
  if(t.indexOf("confidence")>-1){return 45;}

  return 10;
}

function installStyles(){
  var st=document.getElementById("slxControlledHorizonStyleV1");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxControlledHorizonStyleV1";
  st.textContent=
    "#slxHTrack{position:relative!important;max-height:126px!important;overflow:hidden!important;}"+
    "#slxHTrack .slxSignal{display:none!important;}"+
    "#slxControlledHorizon{display:flex!important;flex-direction:column!important;gap:7px!important;}"+
    "#slxControlledHorizon .slxStableLine{min-height:34px!important;padding:7px 12px!important;border-radius:14px!important;background:rgba(8,12,18,.84)!important;border:1px solid rgba(0,255,210,.20)!important;box-shadow:0 8px 20px rgba(0,0,0,.28)!important;color:#fff!important;font-size:13px!important;font-weight:950!important;letter-spacing:.2px!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}";

  document.head.appendChild(st);
}

function ensureDisplay(){
  var track=document.getElementById("slxHTrack");
  var box=document.getElementById("slxControlledHorizon");

  if(!track){return null;}

  if(!box){
    box=document.createElement("div");
    box.id="slxControlledHorizon";
    track.insertBefore(box,track.firstChild);
  }

  return box;
}

function collectSignals(){
  var track=document.getElementById("slxHTrack");
  var rows,items,i,t,key;

  if(!track){return [];}

  rows=[].slice.call(track.querySelectorAll(".slxSignal"));
  items=[];
  seen={};

  for(i=0;i<rows.length;i++){
    t=clean(rows[i].textContent);

    if(!t){continue;}
    if(t.toLowerCase().indexOf("standby")>-1){continue;}

    key=t.toLowerCase();

    if(seen[key]){continue;}
    seen[key]=true;

    items.push({
      text:t,
      score:score(t),
      index:i
    });
  }

  items.sort(function(a,b){
    if(b.score!==a.score){return b.score-a.score;}
    return a.index-b.index;
  });

  return items.slice(0,3).map(function(x){return x.text;});
}

function render(lines){
  var box=ensureDisplay();
  var i,line;

  if(!box){return;}

  box.innerHTML="";

  for(i=0;i<lines.length;i++){
    line=document.createElement("div");
    line.className="slxStableLine";
    line.textContent=lines[i];
    box.appendChild(line);
  }
}

function tick(){
  var now=Date.now();
  var next;

  installStyles();

  if(!lockedLines.length || now-lastRenderAt>=ROTATE_MS){
    next=collectSignals();

    if(next.length){
      lockedLines=next;
      lastRenderAt=now;
      render(lockedLines);
    }
  }else{
    render(lockedLines);
  }
}

setTimeout(tick,300);
setTimeout(tick,1200);
setInterval(tick,1000);

})();

/* =========================================================
SLX WIND MPH HORIZON UPGRADE V1
Makes wind intel driver-readable with MPH + direction
========================================================= */
(function(){
"use strict";

if(window.__SLX_WIND_MPH_HORIZON_UPGRADE_V1__){return;}
window.__SLX_WIND_MPH_HORIZON_UPGRADE_V1__=true;

function cleanWindLabel(){
  var wind = window.windState || {};
  var speed = Number(wind.speed);
  var rel = String(wind.relative || "").toLowerCase();
  var label = "";

  if(!isFinite(speed) || speed <= 0){
    return "weather stable";
  }

  speed = Math.round(speed);

  if(rel.indexOf("crosswind") > -1){
    label = "Crosswind " + speed + " mph";
  }else if(rel.indexOf("headwind") > -1){
    label = "Headwind " + speed + " mph";
  }else if(rel.indexOf("tailwind") > -1){
    label = "Tailwind " + speed + " mph";
  }else{
    label = "Wind " + speed + " mph";
  }

  if(speed >= 30){
    label += " • use caution";
  }else if(speed >= 20){
    label += " • exposure watch";
  }else{
    label += " • manageable";
  }

  return label;
}

function patchWindSignal(){
  var track = document.getElementById("slxHTrack");
  var rows, i, row, text;

  if(!track){return;}

  rows = track.querySelectorAll(".slxSignal");

  for(i=0;i<rows.length;i++){
    row = rows[i];
    text = String(row.textContent || "").toLowerCase();

    if(
      text.indexOf("wind exposure") > -1 ||
      text.indexOf("weather stable") > -1 ||
      text.indexOf("weather corridor manageable") > -1 ||
      text.indexOf("crosswind") > -1 ||
      text.indexOf("headwind") > -1 ||
      text.indexOf("tailwind") > -1
    ){
      row.textContent = cleanWindLabel();
    }
  }

  try{
    if(window.windState){
      window.windState.label = cleanWindLabel();
    }
  }catch(e){}
}

function forceWeatherRefresh(){
  try{
    if(window.windState){
      window.windState.fetchedAt = 0;
    }
  }catch(e){}

  try{
    if(window.maybeFetchWind){
      window.maybeFetchWind();
    }
  }catch(e){}
}

setTimeout(forceWeatherRefresh, 800);
setTimeout(patchWindSignal, 1800);

setInterval(patchWindSignal, 5000);
setInterval(forceWeatherRefresh, 90000);

})();

/* =========================================================
SLX WIND SEVERITY MODEL V2
Truck-grade exposure classification
========================================================= */
(function(){
"use strict";

if(window.__SLX_WIND_SEVERITY_MODEL_V2__){return;}
window.__SLX_WIND_SEVERITY_MODEL_V2__=true;

function classifyWind(speed){

speed = Number(speed);

if(!isFinite(speed)) return "weather stable";

if(speed < 10){
return "Wind light • stable corridor";
}

if(speed < 20){
return "Crosswind " + speed + " mph • manageable";
}

if(speed < 30){
return "Crosswind " + speed + " mph • exposure watch";
}

if(speed < 40){
return "Crosswind " + speed + " mph • caution";
}

return "Crosswind " + speed + " mph • high exposure";

}

function applyWindSeverity(){

var wind = window.windState || {};

if(!wind.speed) return;

var label = classifyWind(wind.speed);

wind.label = label;

var rows = document.querySelectorAll(".slxSignal");

for(var i=0;i<rows.length;i++){

var t = rows[i].textContent.toLowerCase();

if(
t.indexOf("wind exposure") > -1 ||
t.indexOf("crosswind") > -1 ||
t.indexOf("weather stable") > -1
){
rows[i].textContent = label;
}

}

}

setInterval(applyWindSeverity,4000);

})();

/* =========================================================
SLX DRIVER ROUTE RECOVERY V2
Finds route from all known handoff keys + redraws line
========================================================= */
(function(){
"use strict";

if(window.__SLX_DRIVER_ROUTE_RECOVERY_V2__){return;}
window.__SLX_DRIVER_ROUTE_RECOVERY_V2__=true;

function getMap(){
  try{
    if(window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.getMap){
      return window.__SLX_CORE_BRIDGE__.getMap();
    }
  }catch(e){}
  return window.map || window.slxMap || window.SLX_MAP || null;
}

function parse(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}

function isFC(g){
  return g &&
    g.type==="FeatureCollection" &&
    g.features &&
    g.features.length &&
    g.features[0].geometry &&
    g.features[0].geometry.coordinates &&
    g.features[0].geometry.coordinates.length>1;
}

function unwrapRoute(obj){
  if(isFC(obj)){return obj;}

  if(obj && isFC(obj.routeGeo)){return obj.routeGeo;}
  if(obj && isFC(obj.route_geo)){return obj.route_geo;}
  if(obj && isFC(obj.geojson)){return obj.geojson;}
  if(obj && isFC(obj.route)){return obj.route;}

  if(obj && obj.route && isFC(obj.route.geojson)){return obj.route.geojson;}
  if(obj && obj.payload && isFC(obj.payload.routeGeo)){return obj.payload.routeGeo;}

  return null;
}

function findRoute(){
  var keys=[
    "slx_route_geo_v2",
    "slx_route_geo_v1",
    "slx_route_geojson",
    "slx_active_route",
    "slx_trip_route",
    "slx_route",
    "slx_route_fc",
    "slx_start_trip_payload",
    "slx_native_trip_payload_v1",
    "slx_handoff_pkt_v1"
  ];

  var i,obj,g;

  try{
    if(isFC(window.routeGeo)){return window.routeGeo;}
    if(isFC(window.SLX_ROUTE_GEO)){return window.SLX_ROUTE_GEO;}
  }catch(e){}

  for(i=0;i<keys.length;i++){
    obj=parse(localStorage.getItem(keys[i]));
    g=unwrapRoute(obj);
    if(isFC(g)){return g;}
  }

  return null;
}

function findRouteSteps(){
var keys = [
"slx_route_steps_v2",
"slx_maneuver_steps_v1",
"slx_trip_steps_v1",
"slx_nav_steps_v1",
"slx_route_steps_v1",
"slx_start_trip_payload",
"slx_native_trip_payload_v1",
"slx_handoff_pkt_v1"
];

var i, obj, steps;

function getStepsFromObj(o){
if(!o){ return null; }

if(o.steps && o.steps.length){ return o.steps; }
if(o.routeSteps && o.routeSteps.length){ return o.routeSteps; }
if(o.maneuverSteps && o.maneuverSteps.length){ return o.maneuverSteps; }
if(o.navSteps && o.navSteps.length){ return o.navSteps; }

if(o.route && o.route.legs && o.route.legs[0] && o.route.legs[0].steps){
return o.route.legs[0].steps;
}

if(o.payload && o.payload.route && o.payload.route.legs && o.payload.route.legs[0] && o.payload.route.legs[0].steps){
return o.payload.route.legs[0].steps;
}

return null;
}

for(i = 0; i < keys.length; i += 1){
try{
obj = JSON.parse(String(localStorage.getItem(keys[i]) || ""));
steps = getStepsFromObj(obj);
if(steps && steps.length){ return steps; }
}catch(e){}
}

if(window.SLX_ROUTE_STEPS && window.SLX_ROUTE_STEPS.length){ return window.SLX_ROUTE_STEPS; }
if(window.routeSteps && window.routeSteps.length){ return window.routeSteps; }
if(window.maneuverSteps && window.maneuverSteps.length){ return window.maneuverSteps; }

return [];
}

function removeBadLayers(m){
  var layers=[
    "route-line",
    "route-glow",
    "slx-route-line",
    "slx-route-glow",
    "slxDriverRouteLine",
    "slxDriverRouteGlow"
  ];

  var i;

  for(i=0;i<layers.length;i++){
    try{
      if(m.getLayer(layers[i])){m.removeLayer(layers[i]);}
    }catch(e){}
  }
}

function removeBadSources(m){
  var sources=[
    "route",
    "slx-route",
    "slx-driver-route"
  ];

  var i;

  for(i=0;i<sources.length;i++){
    try{
      if(m.getSource(sources[i])){m.removeSource(sources[i]);}
    }catch(e){}
  }
}

function redraw(){
  var m=getMap();
  var geo=findRoute();

  if(!m || !m.loaded || !m.loaded()){return;}
  if(!isFC(geo)){
    try{console.log("SLX route recovery: no route geo found");}catch(e){}
    return;
  }

  try{
    removeBadLayers(m);
    removeBadSources(m);

    m.addSource("slx-driver-route",{
      type:"geojson",
      data:geo,
      lineMetrics:true
    });

    m.addLayer({
      id:"slxDriverRouteGlow",
      type:"line",
      source:"slx-driver-route",
      layout:{
        "line-cap":"round",
        "line-join":"round"
      },
      paint:{
        "line-color":"#00ff9c",
        "line-width":18,
        "line-opacity":0.28
      }
    });

    m.addLayer({
      id:"slxDriverRouteLine",
      type:"line",
      source:"slx-driver-route",
      layout:{
        "line-cap":"round",
        "line-join":"round"
      },
      paint:{
        "line-color":"#00ffc8",
        "line-width":7,
        "line-opacity":0.98
      }
    });

    window.routeGeo=geo;
    window.SLX_ROUTE_GEO=geo;

    try{
      localStorage.setItem("slx_route_geo_v2",JSON.stringify(geo));
    }catch(e2){}

    console.log("SLX route recovery: route restored");

  }catch(err){
    try{console.log("SLX route recovery failed",err);}catch(e3){}
  }
}

function tick(){
  redraw();
}

setTimeout(tick,500);
setTimeout(tick,1500);
setTimeout(tick,3500);
setTimeout(tick,7000);

window.slxForceRouteRecovery=redraw;

})();

/* =========================================================
SLX HORIZON COLOR LOCK V5
Color only. No text rewrite. No twitch.
========================================================= */
(function(){
"use strict";

if(window.__SLX_HORIZON_COLOR_LOCK_V5__){return;}
window.__SLX_HORIZON_COLOR_LOCK_V5__=true;

function colorForText(t){
  t=String(t||"").toLowerCase();

  if(t.indexOf("turn")>-1 || t.indexOf("prepare")>-1){
    return "#dffcff";
  }

  if(
    t.indexOf("wind")>-1 ||
    t.indexOf("crosswind")>-1 ||
    t.indexOf("headwind")>-1 ||
    t.indexOf("tailwind")>-1 ||
    t.indexOf("weather")>-1
  ){
    return "#9fd8ff";
  }

  if(t.indexOf("parking")>-1){
    return "#8dffd0";
  }

  if(t.indexOf("fuel")>-1){
    return "#ffd98a";
  }

  if(
    t.indexOf("traffic")>-1 ||
    t.indexOf("curve")>-1 ||
    t.indexOf("grade")>-1 ||
    t.indexOf("caution")>-1
  ){
    return "#ffb66e";
  }

  if(
    t.indexOf("freight")>-1 ||
    t.indexOf("reload")>-1 ||
    t.indexOf("staging")>-1
  ){
    return "#c9a6ff";
  }

  if(t.indexOf("confidence")>-1){
    return "#7fffea";
  }

  return "#eaffff";
}

function hexToRgba(hex,a){
  hex=String(hex||"#eaffff").replace("#","");
  if(hex.length!==6){return "rgba(234,255,255,"+a+")";}
  return "rgba("+
    parseInt(hex.substr(0,2),16)+","+
    parseInt(hex.substr(2,2),16)+","+
    parseInt(hex.substr(4,2),16)+","+
    a+
  ")";
}

var pending=false;

function apply(){
  var host=document.getElementById("slxControlledHorizon") || document.getElementById("slxHTrack");
  var rows,i,row,color;

  pending=false;

  if(!host){return;}

  rows=host.querySelectorAll(".slxStableLine,.slxSignal");

  for(i=0;i<rows.length;i++){
    row=rows[i];
    color=colorForText(row.textContent);

    row.style.setProperty("color",color,"important");
    row.style.setProperty("border-color",hexToRgba(color,.36),"important");
    row.style.setProperty("text-shadow","0 0 10px "+hexToRgba(color,.16),"important");
  }
}

function schedule(){
  if(pending){return;}
  pending=true;

  if(window.requestAnimationFrame){
    requestAnimationFrame(apply);
  }else{
    setTimeout(apply,60);
  }
}

function install(){
  var host=document.getElementById("slxControlledHorizon") || document.getElementById("slxHTrack");

  schedule();

  if(!host || host.__slxColorLockObserver){return;}

  host.__slxColorLockObserver=true;

  try{
    new MutationObserver(schedule).observe(host,{
      childList:true,
      subtree:true,
      characterData:true
    });
  }catch(e){}
}

setTimeout(install,400);
setTimeout(install,1500);
setInterval(schedule,6000);

window.slxApplyHorizonColorLockV5=schedule;

})();

/* =========================================================
SLX SCAN STOPS HARD RECOVERY V2
Restores stop pins even after style reload / map refresh
========================================================= */
(function(){
"use strict";

if(window.__SLX_SCAN_STOPS_HARD_RECOVERY_V2__){return;}
window.__SLX_SCAN_STOPS_HARD_RECOVERY_V2__=true;

/* ---------------------------------------------------------
MAP ACCESS
--------------------------------------------------------- */

function getMap(){
  if(window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.getMap){
    return window.__SLX_CORE_BRIDGE__.getMap();
  }
  return window.map || window.slxMap || window.SLX_MAP || null;
}

/* ---------------------------------------------------------
LOAD GEOJSON FROM ANY KNOWN STORAGE SLOT
--------------------------------------------------------- */

function loadStopsGeo(){

  var keys=[
    "slx_scan_stops_geo_v1",
    "slx_stop_geo_v1",
    "slx_stops_geo_v1",
    "slx_parking_stops_geo_v1",
    "slx_corridor_stops_geo_v1",
    "slx_driver_stops_geo_v1"
  ];

  var i,data;

  if(window.slxStopGeo){return window.slxStopGeo;}
  if(window.SLX_STOP_GEO){return window.SLX_STOP_GEO;}
  if(window.scanStopsGeo){return window.scanStopsGeo;}

  for(i=0;i<keys.length;i++){
    try{
      data=JSON.parse(localStorage.getItem(keys[i])||"");
      if(data && data.type==="FeatureCollection"){return data;}
    }catch(e){}
  }

  return null;
}

/* ---------------------------------------------------------
DRAW LAYERS
--------------------------------------------------------- */

function ensureStops(){

  var map=getMap();
  var geo=loadStopsGeo();

  if(!map || !map.loaded || !map.loaded()){return;}
  if(!geo || !geo.features || !geo.features.length){return;}

  try{

    if(map.getSource("slx-stop-src")){
      map.getSource("slx-stop-src").setData(geo);
    }else{
      map.addSource("slx-stop-src",{
        type:"geojson",
        data:geo
      });
    }

  }catch(e){return;}

  try{

    if(!map.getLayer("slx-stop-halo")){
      map.addLayer({
        id:"slx-stop-halo",
        type:"circle",
        source:"slx-stop-src",
        paint:{
          "circle-radius":[
            "interpolate",["linear"],["zoom"],
            8,12,
            12,22,
            16,36
          ],
          "circle-color":"rgba(0,255,210,0.22)",
          "circle-blur":0.65
        }
      });
    }

    if(!map.getLayer("slx-stop-core")){
      map.addLayer({
        id:"slx-stop-core",
        type:"circle",
        source:"slx-stop-src",
        paint:{
          "circle-radius":[
            "interpolate",["linear"],["zoom"],
            8,6,
            12,10,
            16,14
          ],
          "circle-color":"#00ffd0",
          "circle-stroke-width":3,
          "circle-stroke-color":"#041018"
        }
      });
    }

    if(!map.getLayer("slx-stop-text")){
      map.addLayer({
        id:"slx-stop-text",
        type:"symbol",
        source:"slx-stop-src",
        layout:{
          "text-field":[
            "case",
            ["has","label"],
            ["get","label"],
            ["has","type"],
            ["upcase",
              ["slice",
                ["to-string",["get","type"]],
                0,1
              ]
            ],
            "P"
          ],
          "text-size":[
            "interpolate",["linear"],["zoom"],
            8,10,
            12,12,
            16,15
          ],
          "text-font":[
            "Open Sans Bold",
            "Arial Unicode MS Bold"
          ],
          "text-allow-overlap":true
        },
        paint:{
          "text-color":"#ffffff",
          "text-halo-color":"rgba(0,30,40,.92)",
          "text-halo-width":1.5
        }
      });
    }

    if(!map.getLayer("slx-stop-hit")){
      map.addLayer({
        id:"slx-stop-hit",
        type:"circle",
        source:"slx-stop-src",
        paint:{
          "circle-radius":28,
          "circle-color":"rgba(0,0,0,0)"
        }
      });
    }

    map.setLayoutProperty("slx-stop-halo","visibility","visible");
    map.setLayoutProperty("slx-stop-core","visibility","visible");
    map.setLayoutProperty("slx-stop-text","visibility","visible");
    map.setLayoutProperty("slx-stop-hit","visibility","visible");

  }catch(e){}

}

/* ---------------------------------------------------------
AUTO-RECOVERY LOOP
--------------------------------------------------------- */

setTimeout(ensureStops,400);
setTimeout(ensureStops,1200);
setTimeout(ensureStops,2600);

setInterval(ensureStops,5000);

/* ---------------------------------------------------------
RECOVER AFTER STYLE RELOAD
--------------------------------------------------------- */

try{

  var map=getMap();

  if(map && map.on){

    map.on("styledata",ensureStops);
    map.on("idle",ensureStops);

  }

}catch(e){}

window.slxRecoverScanStops=ensureStops;

})();

/* =========================================================
SLX ALTERNATE CORRIDOR SCAN ENGINE V1
Smart reroute comparison engine
Safe: scans + recommends only. Does not replace route automatically.
========================================================= */
(function(){
"use strict";

if(window.__SLX_ALT_CORRIDOR_SCAN_ENGINE_V1__){return;}
window.__SLX_ALT_CORRIDOR_SCAN_ENGINE_V1__=true;

var SCAN_COOLDOWN_MS = 90000;
var MIN_SAVE_MINUTES = 8;
var lastScanAt = 0;
var lastVoiceAt = 0;

function now(){
  return Date.now ? Date.now() : new Date().getTime();
}

function getGeoapifyKey(){
  return String(
    window.SLX_GEOAPIFY_KEY ||
    window.GEOAPIFY_KEY ||
    ""
  );
}

function getFix(){
  try{
    if(window.currentFix){
      if(isFinite(Number(currentFix.lng)) && isFinite(Number(currentFix.lat))){
        return {lng:Number(currentFix.lng),lat:Number(currentFix.lat)};
      }
      if(isFinite(Number(currentFix.longitude)) && isFinite(Number(currentFix.latitude))){
        return {lng:Number(currentFix.longitude),lat:Number(currentFix.latitude)};
      }
      if(currentFix.coords){
        return {
          lng:Number(currentFix.coords.longitude),
          lat:Number(currentFix.coords.latitude)
        };
      }
    }
  }catch(e){}
  return null;
}

function getDest(){
  try{
    if(window.dest && isFinite(Number(dest.lng)) && isFinite(Number(dest.lat))){
      return {lng:Number(dest.lng),lat:Number(dest.lat)};
    }
  }catch(e){}

  try{
    var raw =
      localStorage.getItem("slx_main_dest_v2") ||
      localStorage.getItem("slx_dest") ||
      localStorage.getItem("slx_route_target");

    if(raw){
      var d=JSON.parse(raw);
      if(isFinite(Number(d.lng)) && isFinite(Number(d.lat))){
        return {lng:Number(d.lng),lat:Number(d.lat)};
      }
    }
  }catch(e2){}

  return null;
}

function getCurrentRouteMinutes(){
  var geo, f, p;

  try{
    geo = window.routeGeo || window.SLX_ROUTE_GEO || null;

    if(!geo){
      geo = JSON.parse(
        localStorage.getItem("slx_route_geo_v2") ||
        localStorage.getItem("slx_route_geo_v1") ||
        localStorage.getItem("slx_route_geojson") ||
        "{}"
      );
    }

    if(geo && geo.features && geo.features.length){
      f = geo.features[0];
      p = f.properties || {};

      if(isFinite(Number(p.durationSeconds))){
        return Number(p.durationSeconds) / 60;
      }

      if(isFinite(Number(p.duration))){
        return Number(p.duration) / 60;
      }

      if(isFinite(Number(p.time))){
        return Number(p.time) / 60;
      }

      if(isFinite(Number(p.minutes))){
        return Number(p.minutes);
      }
    }
  }catch(e){}

  return null;
}

function safeSpeak(msg){
  try{
    if(window.slxSpeak){window.slxSpeak(msg);return;}
    if(window.speak){window.speak(msg);return;}
  }catch(e){}
}

function setHorizonSignal(text){
  try{
    window.slxAltCorridorSignal = {
      text:text,
      updatedAt:now()
    };
  }catch(e){}

  try{
    if(window.slxPushHorizonSignal){
      window.slxPushHorizonSignal(text);
    }
  }catch(e2){}
}

function scanGeoapifyAltRoute(from,to,cb){
  var key=getGeoapifyKey();
  var url,xhr;

  if(!key || !from || !to){
    cb(null);
    return;
  }

  url =
    "https://api.geoapify.com/v1/routing?waypoints=" +
    encodeURIComponent(from.lat + "," + from.lng + "|" + to.lat + "," + to.lng) +
    "&mode=truck&details=route_details&apiKey=" +
    encodeURIComponent(key);

  xhr=new XMLHttpRequest();
  xhr.open("GET",url,true);

  xhr.onreadystatechange=function(){
    var data,feature,props,seconds;

    if(xhr.readyState!==4){return;}

    try{
      if(xhr.status>=200 && xhr.status<300){
        data=JSON.parse(xhr.responseText || "{}");
        feature=(data.features && data.features[0]) ? data.features[0] : null;

        if(feature){
          props=feature.properties || {};
          seconds=Number(
            props.time ||
            props.duration ||
            props.durationSeconds ||
            0
          );

          cb({
            feature:feature,
            minutes:seconds ? seconds/60 : null
          });
          return;
        }
      }
    }catch(e){}

    cb(null);
  };

  xhr.send(null);
}

function shouldScan(){
  if(!window.slxIntel || !slxIntel.corridorAssist){return false;}
  if(slxIntel.corridorAssist.status!=="reroute_watch"){return false;}

  try{
    if(window.slxTripOn && !slxTripOn()){return false;}
  }catch(e){}

  try{
    if(window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.shouldScanAlt && !window.SLX_TRUST_GUARD.shouldScanAlt()){
      return false;
    }
  }catch(eTrust){}

  if(now()-lastScanAt<SCAN_COOLDOWN_MS){return false;}

  return true;
}

function evaluateResult(result,currentMinutes){
  var save;

  if(!result || !isFinite(Number(result.minutes)) || !isFinite(Number(currentMinutes))){
    return;
  }

  save=Math.round(currentMinutes - result.minutes);

  if(save>=MIN_SAVE_MINUTES){
    try{
      if(window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.shouldAllowReroute && !window.SLX_TRUST_GUARD.shouldAllowReroute(save,currentMinutes)){
        if(window.slxIntel && slxIntel.corridorAssist){
          slxIntel.corridorAssist.status="stable";
          slxIntel.corridorAssist.label="Current corridor preferred";
        }
        return;
      }
    }catch(eTrustAllow){}

    try{
      window.slxAltCorridorCandidate = {
        saveMinutes:save,
        route:result.feature,
        scannedAt:now(),
        status:"candidate"
      };
    }catch(e){}

    if(window.slxIntel && slxIntel.corridorAssist){
      slxIntel.corridorAssist.status="reroute_candidate";
      slxIntel.corridorAssist.label="Faster corridor available • saves "+save+" min";
    }

    setHorizonSignal("Faster corridor available • saves "+save+" min");

    if(now()-lastVoiceAt>300000){
      lastVoiceAt=now();
      safeSpeak("Faster corridor found. It may save about "+save+" minutes.");
    }
  }else{
    if(window.slxIntel && slxIntel.corridorAssist){
      slxIntel.corridorAssist.status="stable";
      slxIntel.corridorAssist.label="Current corridor still preferred";
    }
  }
}

function scan(){
  var from,to,currentMinutes;

  if(!shouldScan()){return;}

  from=getFix();
  to=getDest();
  currentMinutes=getCurrentRouteMinutes();

  if(!from || !to || !isFinite(Number(currentMinutes))){
    return;
  }

  lastScanAt=now();

  scanGeoapifyAltRoute(from,to,function(result){
    evaluateResult(result,currentMinutes);
  });
}

setTimeout(scan,5000);
setInterval(scan,45000);

window.slxScanAlternateCorridor=scan;

})();

/* =========================================================
SLX SMART REROUTE APPLY CONTROL V1
Shows Accept Faster Route card when alternate corridor is found.
Safe: driver-controlled apply. Auto-apply only for big verified savings.
========================================================= */
(function(){
"use strict";

if(window.__SLX_SMART_REROUTE_APPLY_CONTROL_V1__){return;}
window.__SLX_SMART_REROUTE_APPLY_CONTROL_V1__=true;

var AUTO_APPLY_MIN_SAVE = 18;
var CARD_ID = "slxRerouteApplyCard";
var lastShownKey = "";

function now(){
  return Date.now ? Date.now() : new Date().getTime();
}

function getMap(){
  try{
    if(window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.getMap){
      return window.__SLX_CORE_BRIDGE__.getMap();
    }
  }catch(e){}
  return window.map || window.slxMap || window.SLX_MAP || null;
}

function safeSpeak(msg){
  try{
    if(window.slxSpeak){window.slxSpeak(msg);return;}
    if(window.speak){window.speak(msg);return;}
  }catch(e){}
}

function getCandidate(){
  try{
    if(window.slxAltCorridorCandidate &&
       window.slxAltCorridorCandidate.status==="candidate" &&
       window.slxAltCorridorCandidate.route){
      return window.slxAltCorridorCandidate;
    }
  }catch(e){}
  return null;
}

function validFeature(f){
  return f &&
    f.type==="Feature" &&
    f.geometry &&
    f.geometry.coordinates &&
    f.geometry.coordinates.length>1;
}

function featureToFC(feature){
  return {
    type:"FeatureCollection",
    features:[feature]
  };
}

function saveRoute(feature){
  var fc=featureToFC(feature);

  try{ window.routeGeo=fc; }catch(e){}
  try{ window.SLX_ROUTE_GEO=fc; }catch(e){}

  try{ localStorage.setItem("slx_route_geo_v2",JSON.stringify(fc)); }catch(e1){}
  try{ localStorage.setItem("slx_route_geo_v1",JSON.stringify(fc)); }catch(e2){}
  try{ localStorage.setItem("slx_active_route",JSON.stringify(fc)); }catch(e3){}
  try{ localStorage.setItem("slx_trip_route",JSON.stringify(fc)); }catch(e4){}

  return fc;
}

function redrawRoute(feature){
  var m=getMap();
  var fc=featureToFC(feature);

  if(!m || !m.loaded || !m.loaded()){return false;}

  try{
    if(m.getSource("slx-driver-route")){
      m.getSource("slx-driver-route").setData(fc);
    }else if(m.getSource("route")){
      m.getSource("route").setData(fc);
    }else{
      m.addSource("slx-driver-route",{
        type:"geojson",
        data:fc,
        lineMetrics:true
      });
    }

    if(!m.getLayer("slxDriverRouteGlow")){
      m.addLayer({
        id:"slxDriverRouteGlow",
        type:"line",
        source:m.getSource("slx-driver-route") ? "slx-driver-route" : "route",
        layout:{
          "line-cap":"round",
          "line-join":"round"
        },
        paint:{
          "line-color":"#00ffb3",
          "line-width":20,
          "line-opacity":0.34
        }
      });
    }

    if(!m.getLayer("slxDriverRouteLine")){
      m.addLayer({
        id:"slxDriverRouteLine",
        type:"line",
        source:m.getSource("slx-driver-route") ? "slx-driver-route" : "route",
        layout:{
          "line-cap":"round",
          "line-join":"round"
        },
        paint:{
          "line-color":"#00ffd0",
          "line-width":7,
          "line-opacity":0.98
        }
      });
    }

    try{ m.setLayoutProperty("slxDriverRouteGlow","visibility","visible"); }catch(e1){}
    try{ m.setLayoutProperty("slxDriverRouteLine","visibility","visible"); }catch(e2){}

    return true;
  }catch(e){}

  return false;
}

function fitReroute(feature){
  var m=getMap();
  var coords,bounds,i;

  if(!m || !m.loaded || !m.loaded()){return;}
  if(!validFeature(feature)){return;}

  try{
    coords=feature.geometry.coordinates;
    bounds=new mapboxgl.LngLatBounds(coords[0],coords[0]);

    for(i=0;i<coords.length;i++){
      bounds.extend(coords[i]);
    }

    m.fitBounds(bounds,{
      padding:{
        top:120,
        bottom:210,
        left:80,
        right:130
      },
      duration:1100,
      pitch:0,
      bearing:0,
      essential:true
    });
  }catch(e){}
}

function hideCard(){
  var card=document.getElementById(CARD_ID);
  if(card && card.parentNode){
    card.parentNode.removeChild(card);
  }
}

function applyCandidate(auto){
  var c=getCandidate();

  if(!c || !validFeature(c.route)){return;}

  saveRoute(c.route);
  redrawRoute(c.route);

  try{
    if(window.slxRestoreDriverRouteLine){window.slxRestoreDriverRouteLine();}
  }catch(e1){}

  try{
    if(window.slxRecoverScanStops || window.slxRestoreStopPins){
      if(window.slxRecoverScanStops){window.slxRecoverScanStops();}
      if(window.slxRestoreStopPins){window.slxRestoreStopPins();}
    }
  }catch(e2){}

  try{
    c.status="applied";
    window.slxAltCorridorCandidate=c;
  }catch(e3){}

  if(window.slxIntel && slxIntel.corridorAssist){
    slxIntel.corridorAssist.status="stable";
    slxIntel.corridorAssist.label="Faster corridor applied";
  }

  hideCard();

  safeSpeak(auto ? "Applying faster corridor." : "Faster corridor applied.");

  setTimeout(function(){
    fitReroute(c.route);
  },350);
}

function ignoreCandidate(){
  try{
    if(window.slxAltCorridorCandidate){
      window.slxAltCorridorCandidate.status="ignored";
      window.slxAltCorridorCandidate.ignoredAt=now();
    }
  }catch(e){}

  hideCard();

  if(window.slxIntel && slxIntel.corridorAssist){
    slxIntel.corridorAssist.status="stable";
    slxIntel.corridorAssist.label="Current corridor preferred";
  }
}

function installStyle(){
  if(document.getElementById("slxSmartRerouteApplyStyleV1")){return;}

  var st=document.createElement("style");
  st.id="slxSmartRerouteApplyStyleV1";
  st.textContent =
    "#"+CARD_ID+"{"+
      "position:fixed;"+
      "left:18px;"+
      "top:42%;"+
      "transform:translateY(-50%);"+
      "z-index:999990;"+
      "width:248px;"+
      "max-width:34vw;"+
      "border-radius:18px;"+
      "padding:12px;"+
      "background:rgba(4,11,18,.88);"+
      "border:1px solid rgba(0,255,210,.30);"+
      "box-shadow:0 18px 46px rgba(0,0,0,.46),0 0 28px rgba(0,255,210,.12);"+
      "backdrop-filter:blur(16px);"+
      "-webkit-backdrop-filter:blur(16px);"+
      "color:#eaffff;"+
      "font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;"+
      "pointer-events:auto;"+
      "box-sizing:border-box;"+
    "}"+
    "#"+CARD_ID+" .slxRerouteTitle{"+
      "font-size:11px;"+
      "font-weight:1000;"+
      "letter-spacing:.7px;"+
      "color:#7fffea;"+
      "margin-bottom:6px;"+
    "}"+
    "#"+CARD_ID+" .slxRerouteMain{"+
      "font-size:15px;"+
      "line-height:19px;"+
      "font-weight:1000;"+
      "margin-bottom:4px;"+
    "}"+
    "#"+CARD_ID+" .slxRerouteSub{"+
      "font-size:10px;"+
      "line-height:14px;"+
      "opacity:.82;"+
      "font-weight:850;"+
      "margin-bottom:10px;"+
    "}"+
    "#"+CARD_ID+" .slxRerouteActions{"+
      "display:flex;"+
      "gap:8px;"+
    "}"+
    "#"+CARD_ID+" button{"+
      "height:38px;"+
      "border-radius:13px;"+
      "border:1px solid rgba(255,255,255,.16);"+
      "background:rgba(255,255,255,.08);"+
      "color:#fff;"+
      "font-size:10px;"+
      "font-weight:1000;"+
      "letter-spacing:.28px;"+
      "flex:1;"+
      "appearance:none;"+
      "-webkit-appearance:none;"+
    "}"+
    "#"+CARD_ID+" .slxAccept{"+
      "background:linear-gradient(180deg,rgba(35,255,200,.98),rgba(0,220,150,.94));"+
      "color:#031511;"+
      "border-color:rgba(0,255,210,.50);"+
    "}"+
    "@media (orientation:landscape){"+
      "#"+CARD_ID+"{"+
        "left:22px;"+
        "top:52%;"+
        "width:230px;"+
        "max-width:28vw;"+
      "}"+
    "}"+
    "@media (max-width:420px){"+
      "#"+CARD_ID+"{"+
        "left:12px;"+
        "top:46%;"+
        "width:220px;"+
        "max-width:56vw;"+
      "}"+
    "}";

  document.head.appendChild(st);
}

function showCard(c){
  var card=document.getElementById(CARD_ID);
  var key;

  if(!c || !validFeature(c.route)){return;}

  try{
    if(window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.shouldAllowReroute && !window.SLX_TRUST_GUARD.shouldAllowReroute(Number(c.saveMinutes || 0),null)){
      return;
    }
  }catch(eTrustCard){}

  key=String(c.saveMinutes||"")+"|"+String(c.scannedAt||"");
  if(card && lastShownKey===key){return;}
  lastShownKey=key;

  hideCard();

  card=document.createElement("div");
  card.id=CARD_ID;
  card.innerHTML =
    "<div class='slxRerouteTitle'>SMART REROUTE</div>"+
    "<div class='slxRerouteMain'>Faster corridor found</div>"+
    "<div class='slxRerouteSub'>Saves about "+String(c.saveMinutes||"--")+" min. Parking/weather gates still active.</div>"+
    "<div class='slxRerouteActions'>"+
      "<button class='slxAccept' type='button'>ACCEPT</button>"+
      "<button class='slxIgnore' type='button'>KEEP</button>"+
    "</div>";

  document.body.appendChild(card);

  try{
    card.querySelector(".slxAccept").onclick=function(e){
      if(e && e.preventDefault){e.preventDefault();}
      applyCandidate(false);
      return false;
    };

    card.querySelector(".slxIgnore").onclick=function(e){
      if(e && e.preventDefault){e.preventDefault();}
      ignoreCandidate();
      return false;
    };
  }catch(e){}
}

function canAutoApply(c){
  if(!c || !isFinite(Number(c.saveMinutes))){return false;}
  try{
    if(window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.initialQuiet && window.SLX_TRUST_GUARD.initialQuiet()){return false;}
    if(window.SLX_TRUST_GUARD && window.SLX_TRUST_GUARD.arrivalAuthority && window.SLX_TRUST_GUARD.arrivalAuthority()){return false;}
  }catch(eTrustAuto){}
  if(Number(c.saveMinutes)<AUTO_APPLY_MIN_SAVE){return false;}

  try{
    if(window.slxIntel){
      if(slxIntel.weatherEta && slxIntel.weatherEta.status==="high"){return false;}
      if(slxIntel.parkingWindow && slxIntel.parkingWindow.status==="bad"){return false;}
    }
  }catch(e){}

  return true;
}

function tick(){
  var c=getCandidate();

  installStyle();

  if(!c){return;}

  if(canAutoApply(c)){
    applyCandidate(true);
    return;
  }

  showCard(c);
}

setTimeout(tick,1000);
setTimeout(tick,2600);
setInterval(tick,3000);

window.slxApplySmartRerouteCandidate=function(){
  applyCandidate(false);
};

window.slxIgnoreSmartRerouteCandidate=ignoreCandidate;

})();

/* =========================================================
SLX ROUTE CONFIDENCE SCORE SAFE V2
Non-breaking route trust layer.
Stores confidence only + optional badge update.
========================================================= */
(function(){
"use strict";

if(window.__SLX_ROUTE_CONFIDENCE_SAFE_V2__){return;}
window.__SLX_ROUTE_CONFIDENCE_SAFE_V2__=true;

var LAST_VOICE_AT=0;
var VOICE_COOLDOWN_MS=600000;

function slxRCNow(){
  return Date.now ? Date.now() : new Date().getTime();
}

function slxRCNum(v){
  v=Number(v);
  return isFinite(v) ? v : null;
}

function slxRCSafeSpeak(msg){
  try{
    if(window.slxSpeak){window.slxSpeak(msg);return;}
    if(window.speak){window.speak(msg);return;}
  }catch(e){}
}

function slxRCTripOn(){
  try{
    if(window.slxTripOn){return !!window.slxTripOn();}
  }catch(e){}
  try{
    return String(localStorage.getItem("slx_trip_on_v1")||"")==="1";
  }catch(e2){}
  return true;
}

function slxGetNested(root,a,b,def){
  try{
    if(window[root] && window[root][a] && typeof window[root][a][b]!=="undefined"){
      return window[root][a][b];
    }
  }catch(e){}
  return def;
}

function slxRCRouteMiles(){
  var raw,geo,p,n;

  try{
    geo=window.routeGeo || window.SLX_ROUTE_GEO || null;

    if(!geo){
      raw=
        localStorage.getItem("slx_route_geo_v2") ||
        localStorage.getItem("slx_route_geo_v1") ||
        localStorage.getItem("slx_route_geojson") ||
        localStorage.getItem("slx_active_route") ||
        localStorage.getItem("slx_trip_route");

      if(raw){geo=JSON.parse(raw);}
    }

    if(geo && geo.features && geo.features.length){
      p=geo.features[0].properties || {};

      n=slxRCNum(p.miles);
      if(n!==null){return n;}

      n=slxRCNum(p.distanceMiles);
      if(n!==null){return n;}

      n=slxRCNum(p.distanceMeters);
      if(n!==null){return n*0.000621371;}

      n=slxRCNum(p.distance);
      if(n!==null){
        /* GeoJSON routing usually meters if distance is large */
        return n>500 ? n*0.000621371 : n;
      }
    }
  }catch(e){}

  return null;
}

function slxRCTrafficScore(){
  var d="";

  try{d=String((window.trafficState && window.trafficState.density) || "").toLowerCase();}catch(e){}

  if(d==="heavy"){return {points:-22,reason:"traffic rising"};}
  if(d==="moderate"){return {points:-10,reason:"traffic moderate"};}
  if(d==="light"){return {points:5,reason:"traffic stable"};}

  return {points:0,reason:"traffic monitored"};
}

function slxRCWeatherScore(){
  var w=String(slxGetNested("slxIntel","weatherEta","status","stable")).toLowerCase();

  if(w==="high"){return {points:-28,reason:"weather risk ahead"};}
  if(w==="watch"){return {points:-12,reason:"weather watch"};}
  if(w==="stable"){return {points:6,reason:"weather stable"};}

  return {points:0,reason:"weather monitored"};
}

function slxRCParkingScore(){
  var p=String(slxGetNested("slxIntel","parkingWindow","status","stable")).toLowerCase();

  if(p==="bad"){return {points:-30,reason:"parking tightening"};}
  if(p==="watch"){return {points:-14,reason:"parking watch"};}
  if(p==="good"){return {points:8,reason:"parking window good"};}
  if(p==="stable"){return {points:4,reason:"parking stable"};}

  return {points:0,reason:"parking monitored"};
}

function slxRCRerouteScore(){
  var status="";

  try{
    if(window.slxAltCorridorCandidate &&
       window.slxAltCorridorCandidate.status==="candidate"){
      return {points:-10,reason:"faster corridor available"};
    }
  }catch(e){}

  status=String(slxGetNested("slxIntel","corridorAssist","status","stable")).toLowerCase();

  if(status==="reroute_watch"){return {points:-8,reason:"reroute watch"};}
  if(status==="stop_first"){return {points:-12,reason:"parking window first"};}
  if(status==="hold"){return {points:-18,reason:"safe hold advised"};}

  return {points:5,reason:"current corridor preferred"};
}

function slxRCFuelScore(){
  var t="";

  try{
    t=String(window.slxFuelSignal || window.slxFuelState || "").toLowerCase();
  }catch(e){}

  if(t.indexOf("thin")>-1 || t.indexOf("sparse")>-1 || t.indexOf("gap")>-1){
    return {points:-10,reason:"fuel corridor thinning"};
  }

  return {points:3,reason:"fuel monitored"};
}

function slxRCGeometryScore(){
  var miles=slxRCRouteMiles();

  if(miles===null){return {points:-10,reason:"route geometry weak"};}
  if(miles>0){return {points:10,reason:"route locked"};}

  return {points:0,reason:"route monitored"};
}

function slxRCLabel(score){
  if(score>=82){return "HIGH";}
  if(score>=65){return "ACTIVE";}
  if(score>=48){return "SOFT";}
  return "LOW";
}

function slxRCTopReason(parts){
  var i,neg=[],pos=[];

  for(i=0;i<parts.length;i++){
    if(parts[i].points<0){neg.push(parts[i]);}
    else if(parts[i].points>0){pos.push(parts[i]);}
  }

  neg.sort(function(a,b){return a.points-b.points;});
  pos.sort(function(a,b){return b.points-a.points;});

  if(neg.length){return neg[0].reason;}
  if(pos.length){return pos[0].reason;}

  return "route monitored";
}

function slxBuildRouteConfidenceSafe(){
  var base=72;
  var parts=[
    slxRCGeometryScore(),
    slxRCTrafficScore(),
    slxRCWeatherScore(),
    slxRCParkingScore(),
    slxRCRerouteScore(),
    slxRCFuelScore()
  ];

  var i,score,label,reason;

  for(i=0;i<parts.length;i++){
    base+=parts[i].points;
  }

  score=Math.max(0,Math.min(100,Math.round(base)));
  label=slxRCLabel(score);
  reason=slxRCTopReason(parts);

  return {
    score:score,
    label:label,
    reason:reason,
    parts:parts,
    updatedAt:slxRCNow()
  };
}

function slxUpdateConfidenceBadge(conf){
  var badge=document.getElementById("slxSmartBadge");

  if(!badge){return;}

  try{
    badge.innerHTML =
      "<b>ROUTE INTEL</b>" +
      "Confidence: " + conf.label + " (" + conf.score + ")<br>" +
      conf.reason;
  }catch(e){}
}

function slxVoiceConfidence(conf){
  if(conf.label==="LOW" && slxRCNow()-LAST_VOICE_AT>VOICE_COOLDOWN_MS){
    LAST_VOICE_AT=slxRCNow();
    slxRCSafeSpeak("Route confidence is low. I am watching traffic, parking, and weather.");
  }
}

function slxEvaluateRouteConfidenceSafe(){
  var conf;

  if(!slxRCTripOn()){return;}

  conf=slxBuildRouteConfidenceSafe();

  window.slxRouteConfidence=conf;
  window.SLX_ROUTE_CONFIDENCE=conf;

  try{
    localStorage.setItem("slx_route_confidence_v1",JSON.stringify(conf));
  }catch(e){}

  slxUpdateConfidenceBadge(conf);
  slxVoiceConfidence(conf);
}

setTimeout(slxEvaluateRouteConfidenceSafe,1200);
setTimeout(slxEvaluateRouteConfidenceSafe,3000);
setInterval(slxEvaluateRouteConfidenceSafe,15000);

window.slxEvaluateRouteConfidenceSafe=slxEvaluateRouteConfidenceSafe;
window.slxBuildRouteConfidenceSafe=slxBuildRouteConfidenceSafe;

})();

/* =========================================================
SLX HORIZON THIRD ROW CLIP FIX
Gives Freight Horizon enough height in landscape/portrait
========================================================= */
(function(){
"use strict";

if(window.__SLX_HORIZON_THIRD_ROW_CLIP_FIX__){return;}
window.__SLX_HORIZON_THIRD_ROW_CLIP_FIX__=true;

var st=document.createElement("style");
st.id="slxHorizonThirdRowClipFix";

st.textContent =
  "#slxHTrack{" +
    "height:auto!important;" +
    "max-height:190px!important;" +
    "overflow:visible!important;" +
    "padding-bottom:10px!important;" +
  "}" +
  "#slxControlledHorizon{" +
    "height:auto!important;" +
    "max-height:190px!important;" +
    "overflow:visible!important;" +
    "padding-bottom:10px!important;" +
  "}" +
  "#slxControlledHorizon .slxStableLine," +
  "#slxHTrack .slxSignal{" +
    "min-height:42px!important;" +
    "line-height:1.15!important;" +
    "overflow:hidden!important;" +
  "}" +
  "@media (orientation:landscape){" +
    "#slxHTrack,#slxControlledHorizon{" +
      "max-height:210px!important;" +
      "padding-bottom:14px!important;" +
    "}" +
    "#slxControlledHorizon .slxStableLine," +
    "#slxHTrack .slxSignal{" +
      "min-height:40px!important;" +
    "}" +
  "}";

document.head.appendChild(st);

})();

/* =========================================================
SLX DOCK BUTTON COLOR GLOW V1
Scan Stops = blue, Follow Lock = green, End Trip = red
========================================================= */
(function(){
"use strict";

if(window.__SLX_DOCK_BUTTON_GLOW_V1__){return;}
window.__SLX_DOCK_BUTTON_GLOW_V1__=true;

function applyDockGlow(){
  var buttons=document.querySelectorAll("button,a,div");
  var i,el,txt;

  for(i=0;i<buttons.length;i++){
    el=buttons[i];
    txt=String(el.textContent||"").replace(/\s+/g," ").trim().toUpperCase();

    if(txt==="SCAN STOPS"){
      el.style.setProperty("border-color","rgba(90,210,255,.72)","important");
      el.style.setProperty("box-shadow","0 0 0 1px rgba(90,210,255,.24) inset,0 0 26px rgba(90,210,255,.32),0 14px 34px rgba(0,0,0,.48)","important");
      el.style.setProperty("color","#dff7ff","important");
    }

    if(txt==="FOLLOW LOCK"){
      el.style.setProperty("border-color","rgba(0,255,150,.72)","important");
      el.style.setProperty("box-shadow","0 0 0 1px rgba(0,255,150,.24) inset,0 0 26px rgba(0,255,150,.32),0 14px 34px rgba(0,0,0,.48)","important");
      el.style.setProperty("color","#eafff4","important");
    }

    if(txt==="END TRIP"){
      el.style.setProperty("border-color","rgba(255,80,80,.72)","important");
      el.style.setProperty("box-shadow","0 0 0 1px rgba(255,80,80,.22) inset,0 0 24px rgba(255,80,80,.28),0 14px 34px rgba(0,0,0,.48)","important");
      el.style.setProperty("color","#fff1f1","important");
    }
  }
}

setTimeout(applyDockGlow,300);
setTimeout(applyDockGlow,1200);
setInterval(applyDockGlow,5000);

window.slxApplyDockButtonGlow=applyDockGlow;

})();

/* =========================================================
SLX LANDSCAPE SIGNAL PANEL TIGHTEN V1
Compact Drop Signal panel in landscape only
========================================================= */
(function(){
"use strict";

if(window.__SLX_SIGNAL_PANEL_LANDSCAPE_TIGHTEN_V1__){return;}
window.__SLX_SIGNAL_PANEL_LANDSCAPE_TIGHTEN_V1__=true;

var st=document.createElement("style");
st.id="slxSignalPanelLandscapeTightenV1";

st.textContent =
  "@media (orientation:landscape){" +

    "#slxSignalPanel," +
    ".slxSignalPanel," +
    "#signalPanel," +
    ".signalPanel{" +
      "max-width:760px!important;" +
      "width:76vw!important;" +
      "left:50%!important;" +
      "transform:translateX(-50%)!important;" +
      "padding:18px 22px 16px!important;" +
      "border-radius:22px!important;" +
    "}" +

    "#slxSignalPanel button," +
    ".slxSignalPanel button," +
    "#signalPanel button," +
    ".signalPanel button{" +
      "height:42px!important;" +
      "min-height:42px!important;" +
      "padding:0 14px!important;" +
      "border-radius:14px!important;" +
      "font-size:11px!important;" +
      "letter-spacing:1.4px!important;" +
    "}" +

    "#slxSignalPanel .signalGrid," +
    ".slxSignalPanel .signalGrid," +
    "#signalPanel .signalGrid," +
    ".signalPanel .signalGrid{" +
      "gap:10px 12px!important;" +
    "}" +

    "#slxSignalPanel p," +
    ".slxSignalPanel p," +
    "#signalPanel p," +
    ".signalPanel p{" +
      "font-size:10px!important;" +
      "margin-top:10px!important;" +
    "}" +

  "}";

document.head.appendChild(st);

})();

/* =========================================================
SLX STOP PIN VISUAL FORCE RESTORE V2
Fresh rerun. Forces visual P/F layers back on map.
Visual only. No popup / no add-stop logic.
========================================================= */
(function(){
"use strict";

window.__SLX_STOP_PIN_VISUAL_FORCE_RESTORE_V2__=true;

function getMap(){
  try{ if(window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.getMap){ return window.__SLX_CORE_BRIDGE__.getMap(); } }catch(e){}
  try{ if(window.map){return window.map;} }catch(e1){}
  try{ if(window.slxMap){return window.slxMap;} }catch(e2){}
  try{ if(window.SLX_MAP){return window.SLX_MAP;} }catch(e3){}
  try{ if(typeof map !== "undefined"){return map;} }catch(e4){}
  return null;
}

function validFC(fc){
  return fc && fc.type==="FeatureCollection" && fc.features && fc.features.length;
}

function parse(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}

function getStops(){
  var fc;

  try{ if(validFC(window.slxStopGeo)){return window.slxStopGeo;} }catch(e){}
  try{ if(validFC(window.SLX_STOP_GEO)){return window.SLX_STOP_GEO;} }catch(e1){}
  try{ if(validFC(window.scanStopsGeo)){return window.scanStopsGeo;} }catch(e2){}

  fc=parse(localStorage.getItem("slx_scan_stops_geo_v1"));
  if(validFC(fc)){return fc;}

  fc=parse(localStorage.getItem("slx_stop_geo_v1"));
  if(validFC(fc)){return fc;}

  fc=parse(localStorage.getItem("slx_stops_geo_v1"));
  if(validFC(fc)){return fc;}

  return null;
}

function removeLayer(m,id){
  try{ if(m.getLayer(id)){m.removeLayer(id);} }catch(e){}
}

function draw(){
  var m=getMap();
  var fc=getStops();

  if(!m || !m.loaded || !m.loaded()){return;}
  if(!validFC(fc)){return;}

  try{
    if(m.getSource("slx-stop-src")){
      m.getSource("slx-stop-src").setData(fc);
    }else{
      m.addSource("slx-stop-src",{type:"geojson",data:fc});
    }

    removeLayer(m,"slx-stop-hit");
    removeLayer(m,"slx-stop-text");
    removeLayer(m,"slx-stop-core");
    removeLayer(m,"slx-stop-ring");
    removeLayer(m,"slx-stop-halo");

    m.addLayer({
      id:"slx-stop-halo",
      type:"circle",
      source:"slx-stop-src",
      paint:{
        "circle-radius":["interpolate",["linear"],["zoom"],8,18,12,30,16,46],
        "circle-color":"rgba(90,210,255,.28)",
        "circle-blur":0.7
      }
    });

    m.addLayer({
      id:"slx-stop-ring",
      type:"circle",
      source:"slx-stop-src",
      paint:{
        "circle-radius":["interpolate",["linear"],["zoom"],8,10,12,18,16,28],
        "circle-color":"rgba(0,0,0,0)",
        "circle-stroke-color":"rgba(155,230,255,1)",
        "circle-stroke-width":3
      }
    });

    m.addLayer({
      id:"slx-stop-core",
      type:"circle",
      source:"slx-stop-src",
      paint:{
        "circle-radius":["interpolate",["linear"],["zoom"],8,7,12,11,16,15],
        "circle-color":"rgba(8,22,34,.98)",
        "circle-stroke-color":"rgba(230,255,255,.98)",
        "circle-stroke-width":2
      }
    });

    m.addLayer({
      id:"slx-stop-text",
      type:"symbol",
      source:"slx-stop-src",
      layout:{
        "text-field":["to-string",["coalesce",["get","label"],"P"]],
        "text-size":["interpolate",["linear"],["zoom"],8,10,12,13,16,16],
        "text-font":["Open Sans Bold","Arial Unicode MS Bold"],
        "text-allow-overlap":true,
        "text-ignore-placement":true
      },
      paint:{
        "text-color":"#ffffff",
        "text-halo-color":"rgba(0,20,30,.95)",
        "text-halo-width":1.5
      }
    });

    m.addLayer({
      id:"slx-stop-hit",
      type:"circle",
      source:"slx-stop-src",
      paint:{
        "circle-radius":34,
        "circle-color":"rgba(0,0,0,0)"
      }
    });

    console.log("SLX visual stop pins restored V2:",fc.features.length);

  }catch(err){
    console.log("SLX visual stop pin restore V2 failed:",err);
  }
}

window.slxForceStopPinVisuals=draw;

setTimeout(draw,300);
setTimeout(draw,900);
setTimeout(draw,1800);
setTimeout(draw,3000);
setInterval(draw,5000);

try{
  var m=getMap();
  if(m && m.on){
    m.on("idle",draw);
    m.on("styledata",draw);
  }
}catch(e){}

})();

/* =========================================================
SLX LOW SPEED BEARING FREEZE V1
Prevents parked / low-speed GPS heading from spinning camera backwards.
========================================================= */
(function(){
"use strict";

if(window.__SLX_LOW_SPEED_BEARING_FREEZE_V1__){return;}
window.__SLX_LOW_SPEED_BEARING_FREEZE_V1__=true;

var lastStableBearing=null;
var lastStableAt=0;

function now(){
  return Date.now ? Date.now() : new Date().getTime();
}

function finite(v){
  v=Number(v);
  return isFinite(v);
}

function speedMph(){
  try{
    if(window.currentFix && finite(window.currentFix.speed)){
      return Number(window.currentFix.speed) * 2.23694;
    }
  }catch(e){}
  return 0;
}

function routeBearingFallback(){
  var b=null;

  try{
    if(typeof window.getStableRouteBearing==="function"){
      b=window.getStableRouteBearing();
      if(finite(b)){return Number(b);}
    }
  }catch(e){}

  try{
    if(finite(window.lastGoodBearing)){return Number(window.lastGoodBearing);}
  }catch(e1){}

  try{
    if(window.map && finite(window.map.getBearing())){
      return Number(window.map.getBearing());
    }
  }catch(e2){}

  return 0;
}

function normalizeBearing(b){
  b=Number(b);
  while(b<0){b+=360;}
  while(b>=360){b-=360;}
  return b;
}

function installBearingGuard(){
  var original;

  if(!window.map || !window.map.easeTo || window.map.__slxLowSpeedBearingGuard){return;}

  window.map.__slxLowSpeedBearingGuard=true;
  original=window.map.easeTo;

  window.map.easeTo=function(opts){
    var s,b;

    opts=opts || {};
    s=speedMph();

    if(s<=3){
      b=lastStableBearing;

      if(!finite(b)){
        b=routeBearingFallback();
      }

      opts.bearing=normalizeBearing(b);
    }else if(s>=6 && finite(opts.bearing)){
      lastStableBearing=normalizeBearing(opts.bearing);
      lastStableAt=now();
    }

    return original.call(this,opts);
  };
}

function refreshStableBearing(){
  var s,b;

  s=speedMph();

  if(s>=6){
    b=routeBearingFallback();
    if(finite(b)){
      lastStableBearing=normalizeBearing(b);
      lastStableAt=now();
    }
  }

  if(!finite(lastStableBearing)){
    b=routeBearingFallback();
    if(finite(b)){
      lastStableBearing=normalizeBearing(b);
      lastStableAt=now();
    }
  }
}

setTimeout(installBearingGuard,700);
setTimeout(installBearingGuard,1800);
setInterval(installBearingGuard,3000);

setTimeout(refreshStableBearing,900);
setInterval(refreshStableBearing,2500);

window.slxLowSpeedBearingFreezeRefresh=refreshStableBearing;

})();

/* =========================================================
SLX DRIVER ROUTE LINE WATCHDOG V1
Keeps active route line alive after map/style reloads.
Does not touch camera, GPS, scan stops, or route logic.
========================================================= */
(function(){
"use strict";

if(window.__SLX_DRIVER_ROUTE_LINE_WATCHDOG_V1__){return;}
window.__SLX_DRIVER_ROUTE_LINE_WATCHDOG_V1__=true;

function parseJSON(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}

function validRouteGeo(g){
  return g && g.type==="FeatureCollection" && g.features && g.features.length;
}

function getMap(){
  try{
    if(window.__SLX_CORE_BRIDGE__ && window.__SLX_CORE_BRIDGE__.getMap){
      return window.__SLX_CORE_BRIDGE__.getMap();
    }
  }catch(e){}
  try{if(window.map){return window.map;}}catch(e1){}
  try{if(window.slxMap){return window.slxMap;}}catch(e2){}
  return null;
}

function getRouteGeo(){
  var keys=[
    "slx_route_geo_v2",
    "slx_route_geo_v1",
    "slx_start_trip_route_v1",
    "slx_route_geojson",
    "slx_route",
    "slx_active_route",
    "slx_trip_route"
  ];
  var i,g;

  for(i=0;i<keys.length;i++){
    g=parseJSON(localStorage.getItem(keys[i]));
    if(validRouteGeo(g)){return g;}
  }

  try{
    if(validRouteGeo(window.routeGeo)){return window.routeGeo;}
  }catch(e){}

  try{
    if(validRouteGeo(window.SLX_ROUTE_GEO)){return window.SLX_ROUTE_GEO;}
  }catch(e2){}

  return null;
}

function ensureRouteLine(){
  var m=getMap();
  var geo=getRouteGeo();

  if(!m || !m.loaded || !m.loaded()){return;}
  if(!validRouteGeo(geo)){return;}

  try{
    if(m.getSource("slx-route-src")){
      m.getSource("slx-route-src").setData(geo);
    }else{
      m.addSource("slx-route-src",{type:"geojson",data:geo});
    }
  }catch(e){return;}

  try{
    if(!m.getLayer("slx-route-halo")){
      m.addLayer({
        id:"slx-route-halo",
        type:"line",
        source:"slx-route-src",
        layout:{
          "line-cap":"round",
          "line-join":"round"
        },
        paint:{
          "line-color":"rgba(0,255,210,.35)",
          "line-width":["interpolate",["linear"],["zoom"],8,8,12,14,16,22],
          "line-blur":1.4
        }
      });
    }

    if(!m.getLayer("slx-route-core")){
      m.addLayer({
        id:"slx-route-core",
        type:"line",
        source:"slx-route-src",
        layout:{
          "line-cap":"round",
          "line-join":"round"
        },
        paint:{
          "line-color":"#22ffd2",
          "line-width":["interpolate",["linear"],["zoom"],8,4,12,7,16,11],
          "line-opacity":.98
        }
      });
    }

    m.setLayoutProperty("slx-route-halo","visibility","visible");
    m.setLayoutProperty("slx-route-core","visibility","visible");

  }catch(err){}
}

window.slxEnsureDriverRouteLine=ensureRouteLine;

setTimeout(ensureRouteLine,400);
setTimeout(ensureRouteLine,1200);
setTimeout(ensureRouteLine,2500);
setTimeout(ensureRouteLine,5000);

setInterval(ensureRouteLine,3000);

try{
  var m=getMap();
  if(m && m.on){
    m.on("load",ensureRouteLine);
    m.on("idle",ensureRouteLine);
    m.on("styledata",ensureRouteLine);
  }
}catch(e){}

window.addEventListener("pageshow",function(){
  setTimeout(ensureRouteLine,300);
  setTimeout(ensureRouteLine,1400);
},false);

document.addEventListener("visibilitychange",function(){
  if(!document.hidden){
    setTimeout(ensureRouteLine,300);
    setTimeout(ensureRouteLine,1400);
  }
},false);

})();

/* =========================================================
SLX START TRIP — HARD LIFT MONEY PANEL PATCH V2
Finds the actual Trip Money panel by text and lifts it
========================================================= */

(function(){
"use strict";

if(window.__SLX_HARD_LIFT_MONEY_PANEL_V2__) return;
window.__SLX_HARD_LIFT_MONEY_PANEL_V2__ = true;

function slxFindMoneyPanel(){
  var ids = ["panel","moneyPanel","tripMoneyPanel","tripMoneySetup","slxTripMoneyPanel"];
  var i, el, nodes, txt;

  for(i=0;i<ids.length;i++){
    el = document.getElementById(ids[i]);
    if(el && el.innerText && el.innerText.indexOf("TRIP MONEY") >= 0){
      return el;
    }
  }

  nodes = document.querySelectorAll("div,section,aside");
  for(i=0;i<nodes.length;i++){
    txt = String(nodes[i].innerText || "");
    if(txt.indexOf("TRIP MONEY + SETUP") >= 0 && txt.indexOf("RPM") >= 0){
      return nodes[i];
    }
  }

  return null;
}

function slxLiftMoneyPanel(){
  var panel = slxFindMoneyPanel();

  if(!panel) return;

  panel.style.position = "fixed";
  panel.style.left = "14px";
  panel.style.bottom = "calc(172px + env(safe-area-inset-bottom,0px))";
  panel.style.zIndex = "260";
  panel.style.transform = "none";
  panel.style.transition = "bottom .22s ease";
  panel.style.maxWidth = "calc(100vw - 170px)";
}

setTimeout(slxLiftMoneyPanel,100);
setTimeout(slxLiftMoneyPanel,500);
setTimeout(slxLiftMoneyPanel,1200);
setInterval(slxLiftMoneyPanel,1200);

})();

/* =========================================================
SLX DRIVER MODE — ROUTE GEOMETRY PERSISTENCE LOCK V1
Prevents active route geometry from ever being lost mid-trip
========================================================= */

(function(){
"use strict";

if(window.__SLX_ROUTE_GEOMETRY_LOCK_V1__) return;
window.__SLX_ROUTE_GEOMETRY_LOCK_V1__=true;

var LAST_GOOD_ROUTE=null;

function validRoute(g){
  return g &&
    g.type==="FeatureCollection" &&
    g.features &&
    g.features.length &&
    g.features[0].geometry &&
    g.features[0].geometry.coordinates &&
    g.features[0].geometry.coordinates.length>1;
}

function captureRoute(){

  try{
    if(validRoute(window.routeGeo)){
      LAST_GOOD_ROUTE=window.routeGeo;
      localStorage.setItem("slx_active_route_backup",
        JSON.stringify(window.routeGeo));
      return;
    }
  }catch(e){}

}

function restoreRoute(){

  if(validRoute(window.routeGeo)) return;

  try{
    if(validRoute(LAST_GOOD_ROUTE)){
      window.routeGeo=LAST_GOOD_ROUTE;
      console.log("SLX route restored from memory");
      return;
    }
  }catch(e){}

  try{
    var stored=JSON.parse(
      localStorage.getItem("slx_active_route_backup")
    );

    if(validRoute(stored)){
      window.routeGeo=stored;
      console.log("SLX route restored from storage");
      return;
    }

  }catch(e){}
}

function protectRoute(){

  captureRoute();
  restoreRoute();

}

setInterval(protectRoute,700);

document.addEventListener("visibilitychange",function(){

  if(!document.hidden){
    setTimeout(protectRoute,120);
    setTimeout(protectRoute,600);
  }

});

window.addEventListener("pageshow",function(){

  setTimeout(protectRoute,120);
  setTimeout(protectRoute,600);

});

})();

/* =========================================================
SLX DRIVER MODE — SAFETY INTEL CORRIDOR ENGINE V1
Police / Crash / Construction / Weigh Station Horizon signals
Route-ahead only (not radius spam)
Safe + ES5 compatible
========================================================= */

(function(){
"use strict";

if(window.__SLX_SAFETY_INTEL_CORRIDOR_V1__) return;
window.__SLX_SAFETY_INTEL_CORRIDOR_V1__ = true;

/* ===============================
CONFIG
=============================== */

var SLX_INTEL_SCAN_DISTANCE_MI = 25;
var SLX_INTEL_CHECK_INTERVAL_MS = 9000;

/* ===============================
HELPERS
=============================== */

function slxMilesBetween(a,b){

if(!a||!b) return 999;

var dx = a.lng - b.lng;
var dy = a.lat - b.lat;

return Math.sqrt(dx*dx+dy*dy)*69;

}

function slxToastSafe(msg){

try{

if(typeof toast==="function"){

toast(msg);

}

}catch(e){}

}

function slxHorizonPushSafe(msg){

try{

if(window.pushHorizonMessage){

pushHorizonMessage(msg);

}

}catch(e){}

}

/* ===============================
CORRIDOR FEATURE CHECK
=============================== */

function slxRouteAheadCheck(feature){

try{

if(!window.routeGeoJSON) return false;

var coords = routeGeoJSON.geometry.coordinates;

if(!coords || !coords.length) return false;

var i;

for(i=0;i<coords.length;i++){

var pt = {

lng:coords[i][0],

lat:coords[i][1]

};

if(slxMilesBetween(pt,feature) < 0.6){

return true;

}

}

}catch(e){}

return false;

}

/* ===============================
SIMULATED SIGNAL LAYER (HOOK READY)
Replace later with real feeds
=============================== */

function slxMockIntelSignals(){

if(!window.routeGeoJSON) return [];

var coords = routeGeoJSON.geometry.coordinates;

if(!coords || coords.length < 10) return [];

return [

{

type:"police",

lat:coords[8][1],

lng:coords[8][0]

},

{

type:"crash",

lat:coords[14][1],

lng:coords[14][0]

},

{

type:"construction",

lat:coords[21][1],

lng:coords[21][0]

},

{

type:"weigh_station",

lat:coords[30][1],

lng:coords[30][0]

}

];

}

/* ===============================
SCAN ENGINE
=============================== */

function slxRunSafetyIntelScan(){

try{

if(!window.routeGeoJSON) return;

var signals = slxMockIntelSignals();

if(!signals || !signals.length) return;

var i,signal;

for(i=0;i<signals.length;i++){

signal = signals[i];

if(!slxRouteAheadCheck(signal)) continue;

if(signal.type==="police"){

slxHorizonPushSafe("Ã°Å¸Å¡” Police activity reported ahead");

}

if(signal.type==="crash"){

slxHorizonPushSafe("Ã¢Å¡ Ã¯Â¸Â Crash scene ahead");

}

if(signal.type==="construction"){

slxHorizonPushSafe("Ã°Å¸Å¡Â§ Construction zone ahead");

}

if(signal.type==="weigh_station"){

slxHorizonPushSafe("Ã¢Å¡–Ã¯Â¸Â Weigh station ahead");

}

}

}catch(e){}

}

/* ===============================
ENGINE LOOP
=============================== */

setInterval(function(){

try{

if(window.followLockActive!==true) return;

slxRunSafetyIntelScan();

}catch(e){}

},SLX_INTEL_CHECK_INTERVAL_MS);

})();

/* SLX SAFETY INTEL — NO OVERLAP GUARD */

(function(){
"use strict";

if(window.__SLX_SAFETY_INTEL_NO_OVERLAP_GUARD__) return;
window.__SLX_SAFETY_INTEL_NO_OVERLAP_GUARD__=true;

function slxSafetyNoOverlapGuard(){
  var cards=document.querySelectorAll(
    "#slxSafetyIntelPanel,.slxSafetyIntelPanel,.slxSafetyIntelCard"
  );
  var i;

  for(i=0;i<cards.length;i++){
    cards[i].style.display="none";
    cards[i].style.pointerEvents="none";
  }
}

setTimeout(slxSafetyNoOverlapGuard,300);
setTimeout(slxSafetyNoOverlapGuard,1000);
setInterval(slxSafetyNoOverlapGuard,2000);

})();

/* =========================================================
SLX DRIVER MODE — COMPACT DOCK INTEL CARD V1
Shows saved Start Trip dock note above telemetry stack
========================================================= */

(function(){
"use strict";

if(window.__SLX_COMPACT_DOCK_INTEL_DRIVER_V1__) return;
window.__SLX_COMPACT_DOCK_INTEL_DRIVER_V1__=true;

function slxDockParse(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}

function slxGetDockNote(){
  var payload,note;

  payload=slxDockParse(localStorage.getItem("slx_start_trip_payload"));
  if(payload){
    if(payload.dock_note){return String(payload.dock_note);}
    if(payload.dock_intelligence&&payload.dock_intelligence.note){
      return String(payload.dock_intelligence.note);
    }
  }

  note=localStorage.getItem("slx_active_dock_note_v1");
  if(note){return String(note);}

  return "";
}

function slxInstallDockIntelCard(){
  var st,card;

  if(!document.getElementById("slxDriverDockIntelStyleV1")){
    st=document.createElement("style");
    st.id="slxDriverDockIntelStyleV1";
    st.textContent=
      "#slxDriverDockIntelV1{position:fixed;left:14px;bottom:calc(256px + env(safe-area-inset-bottom,0px));z-index:240;width:190px;max-width:42vw;display:none;border-radius:16px;background:rgba(8,14,22,.88);border:1px solid rgba(255,205,105,.32);box-shadow:0 12px 30px rgba(0,0,0,.38),0 0 22px rgba(255,205,105,.10);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);padding:9px 10px;color:#fff;pointer-events:auto;}"+
      "#slxDriverDockIntelV1.on{display:block;}"+
      ".slxDockMiniHead{font-size:9px;font-weight:1000;letter-spacing:.12em;color:#ffe2a2;margin-bottom:4px;}"+
      ".slxDockMiniText{font-size:10px;font-weight:850;line-height:1.25;color:rgba(255,255,255,.82);max-height:38px;overflow:hidden;}"+
      ".slxDockMiniClose{position:absolute;right:7px;top:6px;width:22px;height:22px;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.08);color:#fff;font-size:14px;font-weight:1000;line-height:18px;}";
    document.head.appendChild(st);
  }

  if(!document.getElementById("slxDriverDockIntelV1")){
    card=document.createElement("div");
    card.id="slxDriverDockIntelV1";
    document.body.appendChild(card);
  }
}

function slxRenderDockIntel(){
  var card,note;

  slxInstallDockIntelCard();

  card=document.getElementById("slxDriverDockIntelV1");
  if(!card) return;

  note=slxGetDockNote();

  if(!note){
    card.classList.remove("on");
    return;
  }

  card.innerHTML=
    '<button id="slxDockMiniCloseV1" class="slxDockMiniClose" type="button">\u00D7</button>'+
    '<div class="slxDockMiniHead">DOCK INTEL</div>'+
    '<div class="slxDockMiniText">'+note+'</div>';

  card.classList.add("on");

  setTimeout(function(){
    var close=document.getElementById("slxDockMiniCloseV1");
    if(close){
      close.onclick=function(){
        card.classList.remove("on");
        return false;
      };
    }
  },50);
}

setTimeout(slxRenderDockIntel,500);
setTimeout(slxRenderDockIntel,1600);
setInterval(slxRenderDockIntel,5000);

window.slxRenderDriverDockIntelV1=slxRenderDockIntel;

})();

/* =========================================================
SLX DRIVER MODE — DOCK INTEL KEY RECOVERY V2
Finds dock notes across Start Trip / recent destination storage
========================================================= */

(function(){
"use strict";

if(window.__SLX_DRIVER_DOCK_INTEL_KEY_RECOVERY_V2__) return;
window.__SLX_DRIVER_DOCK_INTEL_KEY_RECOVERY_V2__=true;

function parse(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}

function findDockNote(){
  var keys=[
    "slx_start_trip_payload",
    "slx_native_trip_payload_v1",
    "slx_driver_handoff_payload_v1",
    "slx_dock_intelligence_notes_v1",
    "slx_dock_intelligence_notes_v2",
    "slx_dock_intelligence_v1"
  ];

  var i,obj,k;

  for(i=0;i<keys.length;i++){
    obj=parse(localStorage.getItem(keys[i]));

    if(!obj) continue;

    if(obj.dock_note) return String(obj.dock_note);
    if(obj.dockNote) return String(obj.dockNote);
    if(obj.dock_intelligence&&obj.dock_intelligence.note) return String(obj.dock_intelligence.note);
    if(obj.dockIntelligence&&obj.dockIntelligence.note) return String(obj.dockIntelligence.note);

    for(k in obj){
      if(obj.hasOwnProperty(k)){
        if(obj[k]&&obj[k].note){
          return String(obj[k].note);
        }
      }
    }
  }

  return "";
}

function install(){
  var st,card;

  if(!document.getElementById("slxDockIntelRecoveryStyleV2")){
    st=document.createElement("style");
    st.id="slxDockIntelRecoveryStyleV2";
    st.textContent=
      "#slxDockIntelRecoveryV2{position:fixed;left:14px;bottom:calc(226px + env(safe-area-inset-bottom,0px));z-index:9999;width:206px;max-width:44vw;border-radius:16px;background:rgba(8,14,22,.90);border:1px solid rgba(255,205,105,.35);box-shadow:0 12px 30px rgba(0,0,0,.38),0 0 22px rgba(255,205,105,.10);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);padding:9px 10px;color:#fff;display:none;}"+
      "#slxDockIntelRecoveryV2.on{display:block;}"+
      ".slxDockRecHead{font-size:9px;font-weight:1000;letter-spacing:.12em;color:#ffe2a2;margin-bottom:4px;}"+
      ".slxDockRecText{font-size:10px;font-weight:850;line-height:1.25;color:rgba(255,255,255,.84);max-height:44px;overflow:hidden;}"+
      ".slxDockRecClose{position:absolute;right:7px;top:6px;width:22px;height:22px;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.08);color:#fff;font-size:14px;font-weight:1000;line-height:18px;}";
    document.head.appendChild(st);
  }

  if(!document.getElementById("slxDockIntelRecoveryV2")){
    card=document.createElement("div");
    card.id="slxDockIntelRecoveryV2";
    document.body.appendChild(card);
  }
}

function render(){
  var card,note;

  install();

  card=document.getElementById("slxDockIntelRecoveryV2");
  if(!card) return;

  note=findDockNote();

  if(!note){
    card.innerHTML=
      '<button id="slxDockRecCloseV2" class="slxDockRecClose" type="button">\u00D7</button>'+
      '<div class="slxDockRecHead">DOCK INTEL</div>'+
      '<div class="slxDockRecText">No dock note saved for this destination yet.</div>';

    card.classList.add("on");

    setTimeout(function(){
      if(card){card.classList.remove("on");}
    },3500);
  }else{
    card.innerHTML=
      '<button id="slxDockRecCloseV2" class="slxDockRecClose" type="button">\u00D7</button>'+
      '<div class="slxDockRecHead">DOCK INTEL</div>'+
      '<div class="slxDockRecText">'+note+'</div>';

    card.classList.add("on");
  }

  setTimeout(function(){
    var close=document.getElementById("slxDockRecCloseV2");
    if(close){
      close.onclick=function(){
        card.classList.remove("on");
        return false;
      };
    }
  },50);
}

setTimeout(render,500);
setTimeout(render,1600);
setTimeout(render,3200);

window.slxFindDriverDockNoteV2=findDockNote;
window.slxRenderDriverDockIntelV2=render;

})();

/* =========================================================
SLX DRIVER MODE — DOCK INTEL APPROACH WINDOW LOCK
Shows dock intel automatically within 25 miles of destination
========================================================= */

(function(){
"use strict";

if(window.__SLX_DOCK_INTEL_APPROACH_LOCK__) return;
window.__SLX_DOCK_INTEL_APPROACH_LOCK__=true;

var APPROACH_DISTANCE_MI = 25;

function parse(v){
  try{return JSON.parse(v);}catch(e){}
  return null;
}

function getDest(){

  var payload=parse(localStorage.getItem("slx_start_trip_payload"));

  if(payload && payload.dest_lat && payload.dest_lng){
    return {
      lat:Number(payload.dest_lat),
      lng:Number(payload.dest_lng)
    };
  }

  return null;
}

function getDockNote(){

  var payload=parse(localStorage.getItem("slx_start_trip_payload"));

  if(!payload) return "";

  if(payload.dock_note) return payload.dock_note;

  if(payload.dock_intelligence && payload.dock_intelligence.note){
    return payload.dock_intelligence.note;
  }

  return "";
}

function milesBetween(a,b){

  if(!a||!b) return 999;

  var dx=a.lng-b.lng;
  var dy=a.lat-b.lat;

  return Math.sqrt(dx*dx+dy*dy)*69;
}

function maybeShowDockIntel(){

  if(!window.currentFix) return;

  var dest=getDest();

  if(!dest) return;

  var dist=milesBetween(currentFix,dest);

  var note=getDockNote();

  if(!note) return;

  if(dist < APPROACH_DISTANCE_MI){

    if(window.slxRenderDriverDockIntelV1){
      slxRenderDriverDockIntelV1();
    }

  }

}

setInterval(maybeShowDockIntel,6000);

})();

/* =========================================================
SLX DRIVER MODE — FOUNDATION HARDENING GUARD V1
Protects route line, core shells, follow state, and trip payload.
Safe additive patch. ES5-safe.
========================================================= */
(function(){
"use strict";

if(window.__SLX_DRIVER_FOUNDATION_GUARD_V1__) return;
window.__SLX_DRIVER_FOUNDATION_GUARD_V1__=true;

function $(id){return document.getElementById(id);}

function parseJSON(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}

function validFC(g){
  return g&&g.type==="FeatureCollection"&&g.features&&g.features.length;
}

function getMap(){
  try{if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.getMap){return window.__SLX_CORE_BRIDGE__.getMap();}}catch(e){}
  try{if(window.map){return window.map;}}catch(e1){}
  try{if(window.slxMap){return window.slxMap;}}catch(e2){}
  try{if(window.SLX_MAP){return window.SLX_MAP;}}catch(e3){}
  try{if(typeof map!=="undefined"){return map;}}catch(e4){}
  return null;
}

function getRouteGeo(){
  var keys=[
    "slx_route_geo_v2",
    "slx_route_geo_v1",
    "slx_start_trip_route_v1",
    "slx_route_geojson",
    "slx_route",
    "slx_active_route",
    "slx_trip_route"
  ];
  var i,g;

  try{if(validFC(window.routeGeo)){return window.routeGeo;}}catch(e){}
  try{if(validFC(window.SLX_ROUTE_GEO)){return window.SLX_ROUTE_GEO;}}catch(e1){}

  for(i=0;i<keys.length;i++){
    g=parseJSON(localStorage.getItem(keys[i]));
    if(validFC(g)){return g;}
  }

  return null;
}

function ensureRouteLine(){
  var m=getMap();
  var geo=getRouteGeo();

  if(!m||!m.loaded||!m.loaded()) return;
  if(!validFC(geo)) return;

  try{
    if(m.getSource("slx-driver-guard-route-src")){
      m.getSource("slx-driver-guard-route-src").setData(geo);
    }else{
      m.addSource("slx-driver-guard-route-src",{type:"geojson",data:geo});
    }

    if(!m.getLayer("slx-driver-guard-route-halo")){
      m.addLayer({
        id:"slx-driver-guard-route-halo",
        type:"line",
        source:"slx-driver-guard-route-src",
        layout:{"line-cap":"round","line-join":"round"},
        paint:{
          "line-color":"rgba(0,255,210,.34)",
          "line-width":["interpolate",["linear"],["zoom"],8,8,12,14,16,22],
          "line-blur":1.5
        }
      });
    }

    if(!m.getLayer("slx-driver-guard-route-core")){
      m.addLayer({
        id:"slx-driver-guard-route-core",
        type:"line",
        source:"slx-driver-guard-route-src",
        layout:{"line-cap":"round","line-join":"round"},
        paint:{
          "line-color":"#22ffd2",
          "line-width":["interpolate",["linear"],["zoom"],8,4,12,7,16,11],
          "line-opacity":.98
        }
      });
    }

    m.setLayoutProperty("slx-driver-guard-route-halo","visibility","visible");
    m.setLayoutProperty("slx-driver-guard-route-core","visibility","visible");
  }catch(e){}
}

function protectCoreCards(){
  var bad=document.querySelectorAll(
    ".slxSafetyIntelPanel,.slxSafetyIntelCard,#slxSafetyIntelPanel"
  );
  var i;

  for(i=0;i<bad.length;i++){
    bad[i].style.display="none";
    bad[i].style.pointerEvents="none";
  }
}

function ensureCockpitNoOverlap(){
  var horizon=$("slxHorizon")||document.querySelector(".slxHorizon,.freightHorizon,#freightHorizon");
  var dock=$("slxDriverDockIntelV1")||$("slxDockIntelRecoveryV2");

  if(dock){
    dock.style.left="14px";
    dock.style.bottom="calc(226px + env(safe-area-inset-bottom,0px))";
    dock.style.zIndex="240";
    dock.style.maxWidth="44vw";
  }

  if(horizon){
    horizon.style.zIndex="230";
  }
}

function recoverTripPayload(){
  var payload=parseJSON(localStorage.getItem("slx_start_trip_payload"))||
              parseJSON(localStorage.getItem("slx_native_trip_payload_v1"))||
              parseJSON(localStorage.getItem("slx_driver_handoff_payload_v1"));

  if(!payload) return;

  try{
    localStorage.setItem("slx_driver_last_good_payload_v1",JSON.stringify(payload));
  }catch(e){}
}

function restoreLastGoodPayloadIfNeeded(){
  var active=parseJSON(localStorage.getItem("slx_start_trip_payload"));
  var last=parseJSON(localStorage.getItem("slx_driver_last_good_payload_v1"));

  if(active||!last) return;

  try{
    localStorage.setItem("slx_start_trip_payload",JSON.stringify(last));
  }catch(e){}
}

function preserveFollowIntent(){
  try{
    if(window.followLockActive===true){
      localStorage.setItem("slx_driver_follow_intent_v1","1");
    }
  }catch(e){}

  try{
    if(localStorage.getItem("slx_driver_follow_intent_v1")==="1"&&typeof window.slxSetFollowMode==="function"){
      window.slxSetFollowMode();
    }
  }catch(e1){}
}

function saveHealth(){
  try{
    localStorage.setItem("slx_driver_health_v1",JSON.stringify({
      ts:new Date().toISOString(),
      hasMap:!!getMap(),
      hasRoute:!!getRouteGeo(),
      hasRouteLine:true,
      followLock:window.followLockActive===true,
      hasPayload:!!parseJSON(localStorage.getItem("slx_start_trip_payload")),
      url:location.pathname
    }));
  }catch(e){}
}

function guard(){
  restoreLastGoodPayloadIfNeeded();
  recoverTripPayload();
  ensureRouteLine();
  protectCoreCards();
  ensureCockpitNoOverlap();
  preserveFollowIntent();
  saveHealth();
}

setTimeout(guard,400);
setTimeout(guard,1200);
setTimeout(guard,2600);
setTimeout(guard,5000);
setInterval(guard,3000);

window.addEventListener("pageshow",function(){
  setTimeout(guard,250);
  setTimeout(guard,1200);
},false);

document.addEventListener("visibilitychange",function(){
  if(!document.hidden){
    setTimeout(guard,250);
    setTimeout(guard,1200);
  }
},false);

try{
  var m=getMap();
  if(m&&m.on){
    m.on("idle",ensureRouteLine);
    m.on("styledata",ensureRouteLine);
    m.on("sourcedata",ensureRouteLine);
  }
}catch(e){}

window.slxDriverFoundationGuardV1=guard;
window.slxDriverEnsureRouteLineV1=ensureRouteLine;

})();

/* =========================================================
SLX DRIVER MODE — ARRIVAL CONFIDENCE DOCK INTEL UPGRADE
========================================================= */

(function(){

"use strict";

if(window.__SLX_DRIVER_ARRIVAL_CONFIDENCE_PATCH__) return;
window.__SLX_DRIVER_ARRIVAL_CONFIDENCE_PATCH__=true;

function slxGetArrivalIntel(){

  try{
    return JSON.parse(localStorage.getItem("slx_driver_arrival_intel_v1")||"null");
  }catch(e){}

  return null;
}

function slxArrivalConfidenceLabel(score,type){

  score=Number(score||0);
  type=String(type||"");

  if(type==="avoid") return "LOW";

  if(score>=90) return "HIGH";

  if(score>=75) return "MEDIUM";

  return "LOW";
}

function slxArrivalConfidenceMessage(type){

  if(type==="truck_gate")
    return "Truck gate likely ahead";

  if(type==="dock")
    return "Receiving dock approach identified";

  if(type==="rear_access")
    return "Rear service approach candidate";

  if(type==="avoid")
    return "Office entrance likely — verify signage";

  return "Verify signage on arrival";
}

function slxUpdateDockIntelCard(){

  var intel=slxGetArrivalIntel();

  if(!intel) return;

  var card=document.querySelector(".dockIntelCard")
          || document.querySelector("#dockIntelCard");

  if(!card) return;

  var level=slxArrivalConfidenceLabel(intel.score,intel.type);

  var msg=slxArrivalConfidenceMessage(intel.type);

  card.innerHTML=
    '<div style="font-size:11px;letter-spacing:.18em;color:#ffd37a;font-weight:900;">DOCK INTEL</div>'+
    '<div style="font-size:16px;font-weight:1000;margin-top:6px;">Arrival confidence: '+level+'</div>'+
    '<div style="font-size:13px;color:rgba(255,255,255,.75);margin-top:6px;">'+msg+'</div>';

}

setTimeout(slxUpdateDockIntelCard,900);
setTimeout(slxUpdateDockIntelCard,2200);
setInterval(slxUpdateDockIntelCard,5000);

})();

/* =========================================================
SLX DRIVER MODE — APPROACH GUIDANCE TRIGGER V1
Distance-based arrival prompts from selected entrance
========================================================= */

(function(){

"use strict";

if(window.__SLX_APPROACH_GUIDANCE_V1__) return;
window.__SLX_APPROACH_GUIDANCE_V1__=true;

function getArrivalIntel(){

  try{
    return JSON.parse(localStorage.getItem("slx_driver_arrival_intel_v1")||"null");
  }catch(e){}

  return null;
}

function distanceMiles(a,b){

  if(!a||!b) return null;

  var R=3959;

  var dLat=(b[1]-a[1])*Math.PI/180;
  var dLon=(b[0]-a[0])*Math.PI/180;

  var lat1=a[1]*Math.PI/180;
  var lat2=b[1]*Math.PI/180;

  var x=Math.sin(dLat/2)*Math.sin(dLat/2)+
        Math.sin(dLon/2)*Math.sin(dLon/2)*Math.cos(lat1)*Math.cos(lat2);

  var c=2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));

  return R*c;
}

function speak(msg){

  try{

    if(window.speechSynthesis){

      var u=new SpeechSynthesisUtterance(msg);

      speechSynthesis.cancel();
      window.__SLX_FOUNDATION_SPEAK__(u);

    }

  }catch(e){}

}

function checkApproach(){

  var intel=getArrivalIntel();

  if(!intel) return;

  if(!intel.coordinates) return;

  if(!window.currentFix) return;

  var here=[currentFix.lng,currentFix.lat];

  var dist=distanceMiles(here,intel.coordinates);

  if(!dist) return;

  if(dist<0.25 && !window.__SLX_APPROACH_STAGE_2__){

    window.__SLX_APPROACH_STAGE_2__=true;

    speak("Guard shack ahead");

    return;

  }

  if(dist<1 && !window.__SLX_APPROACH_STAGE_1__){

    window.__SLX_APPROACH_STAGE_1__=true;

    speak("Truck entrance ahead soon");

    return;

  }

}

setInterval(checkApproach,6000);

})();

/* =========================================================
SLX DRIVER MODE — VISUAL MANEUVER CARD V2
Self-contained step finder + visual card updater.
No voice. No camera/map changes. No container hijack.
========================================================= */
(function(){
"use strict";
/*
CLEAN COCKPIT V4:
The legacy slxVisualManeuverCard generator was removed.
slxDriveIqTurnCardV2 is the only maneuver surface.
*/
var old=document.getElementById("slxVisualManeuverCard");
if(old&&old.parentNode){old.parentNode.removeChild(old);}
window.slxUpdateVisualManeuverCardV2=function(){return;};
})();

/* =========================================================
   SLX DRIVER MODE — ARRIVAL INTEL READER V1
   Reads Facility Intel from Start Trip and surfaces it in Route Intel pill.
   No camera movement. No layout changes.
========================================================= */

(function(){
"use strict";

if(window.__SLX_DRIVER_ARRIVAL_INTEL_READER_V1__) return;
window.__SLX_DRIVER_ARRIVAL_INTEL_READER_V1__=true;

var lastSpeak=0;
var lastMode="";

function slxDAIRead(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}
  catch(e){}
  return null;
}

function slxDAIGetIntel(){
  return slxDAIRead("slx_driver_arrival_intel_v1") ||
         slxDAIRead("slx_selected_entrance_v1");
}

function slxDAIDistanceMiles(a,b,c,d){
  var R=3958.8;
  var toRad=function(x){return x*Math.PI/180;};
  var dLat=toRad(c-a);
  var dLng=toRad(d-b);
  var x=Math.sin(dLat/2)*Math.sin(dLat/2)+
    Math.cos(toRad(a))*Math.cos(toRad(c))*
    Math.sin(dLng/2)*Math.sin(dLng/2);
  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}

function slxDAIMsg(type,name,hard){
  type=String(type||"").toLowerCase();

  if(type==="gate") return hard ? "Truck gate likely ahead" : "Truck gate coming up";
  if(type==="dock") return hard ? "Receiving dock approach" : "Dock entrance coming up";
  if(type==="shipping") return hard ? "Shipping dock approach" : "Shipping dock coming up";
  if(type==="yard") return hard ? "Trailer yard entrance" : "Yard entrance coming up";
  if(type==="rear") return hard ? "Rear access road — verify signs" : "Rear access likely ahead";
  if(type==="avoid") return hard ? "Office side — avoid with truck" : "Avoid office entrance ahead";

  return hard ? "Verify entrance on arrival" : "Facility entrance coming up";
}

function slxDAISetRouteIntel(text){
  var ids=["slxRouteIntel","routeIntel","routeIntelPill","slxIntelPill"];
  var el=null;
  var i;

  for(i=0;i<ids.length;i++){
    el=document.getElementById(ids[i]);
    if(el) break;
  }

  if(!el){
    el=document.querySelector(".routeIntel") ||
       document.querySelector(".slxRouteIntel") ||
       document.querySelector("[data-route-intel]");
  }

  if(el){
    el.textContent=text;
  }
}

function slxDAISpeak(msg){
  if(!msg) return;

  try{
    if(window.primeVoiceThenSpeak){
      window.primeVoiceThenSpeak(msg);
      return;
    }
  }catch(e){}

  try{
    if(!window.speechSynthesis) return;
    var u=new SpeechSynthesisUtterance(msg);
    u.rate=1;
    window.speechSynthesis.cancel();
    window.__SLX_FOUNDATION_SPEAK__(u);
  }catch(e2){}
}

function slxDAIGetDest(){
  var payload=slxDAIRead("slx_start_trip_payload");
  if(payload&&payload.dest){return payload.dest;}

  return slxDAIRead("slx_main_dest_v2") || slxDAIRead("slx_dest");
}

function slxDAIGetFix(){
  try{
    if(window.currentFix&&isFinite(Number(window.currentFix.lat))&&isFinite(Number(window.currentFix.lng))){
      return window.currentFix;
    }
  }catch(e){}

  try{
    return slxDAIRead("slx_last_gps_v1");
  }catch(e2){}

  return null;
}

function slxDriverArrivalIntelTick(){
  var intel=slxDAIGetIntel();
  var dest=slxDAIGetDest();
  var fix=slxDAIGetFix();
  var dist,hard,msg,mode,now;

  if(!intel||!dest||!fix) return;

  if(!isFinite(Number(fix.lat))||!isFinite(Number(fix.lng))) return;
  if(!isFinite(Number(dest.lat))||!isFinite(Number(dest.lng))) return;

  dist=slxDAIDistanceMiles(
    Number(fix.lat),
    Number(fix.lng),
    Number(dest.lat),
    Number(dest.lng)
  );

  if(dist>1.0){
    if(lastMode==="arrival"){
      slxDAISetRouteIntel("ROUTE INTEL • traffic corridor monitored");
      lastMode="";
    }
    return;
  }

  hard=dist<0.25;
  msg=slxDAIMsg(intel.type,intel.name,hard);
  mode=hard?"hard":"soft";

  slxDAISetRouteIntel("ARRIVAL INTEL • "+msg);

  now=Date.now();

  if(lastMode!==mode && now-lastSpeak>45000){
    lastMode=mode;
    lastSpeak=now;
    slxDAISpeak(msg);
  }
}

setInterval(slxDriverArrivalIntelTick,2500);
setTimeout(slxDriverArrivalIntelTick,1200);

window.slxDriverArrivalIntelTickV1=slxDriverArrivalIntelTick;

})();

/* =========================================================
SLX DRIVER MODE — KEEP SCREEN AWAKE V1
Prevents screen timeout during active trip when supported.
========================================================= */
(function(){
"use strict";

if(window.__SLX_KEEP_SCREEN_AWAKE_V1__) return;
window.__SLX_KEEP_SCREEN_AWAKE_V1__ = true;

var wakeLock = null;
var keepAwakeOn = false;

async function requestWakeLock(){
keepAwakeOn = true;

try{
if("wakeLock" in navigator && navigator.wakeLock.request){
wakeLock = await navigator.wakeLock.request("screen");

wakeLock.addEventListener("release", function(){
wakeLock = null;
});

console.log("SLX Wake Lock active");
}
}catch(e){
console.log("SLX Wake Lock unavailable", e);
}
}

async function releaseWakeLock(){
keepAwakeOn = false;

try{
if(wakeLock){
await wakeLock.release();
wakeLock = null;
}
}catch(e){}
}

/* Re-request after app/background visibility changes */
document.addEventListener("visibilitychange", function(){
if(document.visibilityState === "visible" && keepAwakeOn){
requestWakeLock();
}
});

/* Public hooks */
window.slxKeepScreenAwake = requestWakeLock;
window.slxReleaseScreenAwake = releaseWakeLock;

/* Auto-enable in Driver Mode */
setTimeout(function(){
requestWakeLock();
},1200);

})();

(function(){
"use strict";

if(window.__SLX_ARRIVAL_PATCH__) return;
window.__SLX_ARRIVAL_PATCH__ = true;

/* --- CONFIG --- */
var ARRIVAL_DISTANCE_METERS = 120; // ~400 ft (parking lot range)
var ARRIVAL_SPEED_MPH = 8; // must be slow = actually arriving
var ARRIVAL_COOLDOWN_MS = 30000; // prevent repeat spam

var lastArrivalTime = 0;
var arrivedTriggered = false;

/* --- UTIL --- */
function toRad(d){ return d * Math.PI / 180; }

function distanceMeters(aLat, aLng, bLat, bLng){
var R = 6371000;
var dLat = toRad(bLat - aLat);
var dLng = toRad(bLng - aLng);

var a =
Math.sin(dLat/2)*Math.sin(dLat/2) +
Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) *
Math.sin(dLng/2)*Math.sin(dLng/2);

var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
return R * c;
}

function getSpeedMph(){
if(window.currentFix && typeof currentFix.speed === "number"){
return currentFix.speed * 2.23694;
}
return 0;
}

/* --- ARRIVAL TRIGGER --- */
function checkArrival(){

if(!window.dest || !window.lastFix) return;

var now = Date.now();
if(now - lastArrivalTime < ARRIVAL_COOLDOWN_MS) return;

var dist = distanceMeters(
Number(lastFix.lat),
Number(lastFix.lng),
Number(dest.lat),
Number(dest.lng)
);

var speed = getSpeedMph();

/* --- ARRIVAL CONDITION --- */
if(dist <= ARRIVAL_DISTANCE_METERS && speed <= ARRIVAL_SPEED_MPH){

if(arrivedTriggered) return;
arrivedTriggered = true;
lastArrivalTime = now;

/* Ã°Å¸”Å  VOICE */
try{
if(window.speechSynthesis){
var u = new SpeechSynthesisUtterance("You have arrived");
u.rate = 1;
u.pitch = 1;
speechSynthesis.cancel();
window.__SLX_FOUNDATION_SPEAK__(u);
}
}catch(e){}

/* UI STATUS */
if(typeof setStatus === "function"){
setStatus("Arrived at destination", "green");
}

/* TOAST */
if(typeof toast === "function"){
toast("Arrived");
}

/* OPTIONAL: mark arrival flag */
window.__slxArrived = true;
}

/* Reset if driver leaves area (prevents stuck state) */
if(dist > ARRIVAL_DISTANCE_METERS * 2){
arrivedTriggered = false;
}
}

/* --- LOOP --- */
setInterval(checkArrival, 1500);

})();

(function(){
"use strict";

if(window.__SLX_WIND_DETAIL_PATCH_V1__) return;
window.__SLX_WIND_DETAIL_PATCH_V1__ = true;

function num(v){
v = Number(v);
return isFinite(v) ? v : null;
}

function compassFromDeg(deg){
deg = num(deg);
if(deg === null) return "";
var dirs = ["N","NE","E","SE","S","SW","W","NW"];
return dirs[Math.round(deg / 45) % 8];
}

function getWindData(){
var w = window.slxWeather || window.SLX_WEATHER || window.weatherState || window.currentWeather || null;
var mph = null;
var gust = null;
var dir = null;

if(w){
mph = num(w.wind_mph || w.windMph || w.windSpeedMph || w.wind_speed_mph || w.windSpeed);
gust = num(w.gust_mph || w.wind_gust_mph || w.windGustMph || w.gustMph || w.gust);
dir = num(w.wind_deg || w.windDeg || w.wind_direction_deg || w.windDirectionDeg);
}

return {
mph: mph,
gust: gust,
dir: dir,
dirText: compassFromDeg(dir)
};
}

function upgradeWindText(text){
var t = String(text || "");
var low = t.toLowerCase();

if(low.indexOf("crosswind") === -1 && low.indexOf("wind ahead") === -1){
return t;
}

if(
low.indexOf("mph") !== -1 ||
low.indexOf("gust") !== -1 ||
low.indexOf("from ") !== -1
){
return t;
}

var w = getWindData();

if(w.gust !== null && w.dirText){
return "Crosswind ahead. Gusts near " + Math.round(w.gust) + " miles per hour from the " + w.dirText + ".";
}

if(w.gust !== null){
return "Crosswind ahead. Gusts near " + Math.round(w.gust) + " miles per hour.";
}

if(w.mph !== null && w.dirText){
return "Crosswind ahead. Wind near " + Math.round(w.mph) + " miles per hour from the " + w.dirText + ".";
}

if(w.mph !== null){
return "Crosswind ahead. Wind near " + Math.round(w.mph) + " miles per hour.";
}

return "Crosswind ahead. Check wind speed before open stretches.";
}

/* Patch browser voice only */
if(window.speechSynthesis && window.speechSynthesis.speak && !window.speechSynthesis.__slxWindDetailPatched){
var oldSpeak = window.speechSynthesis.speak;

window.__SLX_LEGACY_UNUSED_SPEAK_WRAPPER_1__ = function(utterance){
try{
if(utterance && typeof utterance.text === "string"){
utterance.text = upgradeWindText(utterance.text);
}
}catch(e){}

return oldSpeak.apply(window.speechSynthesis, arguments);
};

window.speechSynthesis.__slxWindDetailPatched = true;
}

/* Patch common app voice functions if they exist */
function patchVoiceFn(name){
if(typeof window[name] !== "function") return;
if(window[name].__slxWindDetailPatched) return;

var oldFn = window[name];

window[name] = function(msg){
if(arguments.length > 0){
arguments[0] = upgradeWindText(arguments[0]);
}
return oldFn.apply(this, arguments);
};

window[name].__slxWindDetailPatched = true;
}

patchVoiceFn("speak");
patchVoiceFn("slxSpeak");
patchVoiceFn("speakLine");
patchVoiceFn("driverSpeak");
patchVoiceFn("say");

})();

(function(){
"use strict";

if(window.__SLX_STORM_HUD_PIN_V1__) return;
window.__SLX_STORM_HUD_PIN_V1__ = true;

var STORM_PIN_ID = "slxStormPinV1";
var STORM_CARD_ID = "slxStormHudCardV1";

function n(v){
v = Number(v);
return isFinite(v) ? v : null;
}

function getWx(){
return window.slxWeather || window.SLX_WEATHER || window.weatherState || window.currentWeather || null;
}

function getFix(){
if(typeof lastFix !== "undefined" && lastFix && isFinite(Number(lastFix.lat)) && isFinite(Number(lastFix.lng))){
return lastFix;
}
if(window.lastFix && isFinite(Number(window.lastFix.lat)) && isFinite(Number(window.lastFix.lng))){
return window.lastFix;
}
if(typeof currentFix !== "undefined" && currentFix && isFinite(Number(currentFix.lat)) && isFinite(Number(currentFix.lng))){
return currentFix;
}
return null;
}

function stormLevel(){
var w = getWx();
var condition, gust, rain;

if(!w) return null;

condition = String(w.weather || w.condition || w.description || w.summary || "").toLowerCase();
gust = n(w.gust_mph || w.wind_gust_mph || w.windGustMph || w.gustMph || w.gust);
rain = n(w.rain_mm || w.precip_mm || w.precipitation || w.precipMm);

if(condition.indexOf("thunder") !== -1 || condition.indexOf("severe") !== -1 || condition.indexOf("storm") !== -1) return "SEVERE";
if(gust !== null && gust >= 35) return "SEVERE";
if(rain !== null && rain >= 5) return "HEAVY";
if(condition.indexOf("rain") !== -1 || condition.indexOf("shower") !== -1) return "CAUTION";
if(gust !== null && gust >= 25) return "CAUTION";

return null;
}

function stormCopy(){
var w = getWx();
var level = stormLevel();
var gust, wind, rain, condition, bits;

if(!level || !w) return null;

condition = String(w.weather || w.condition || w.description || "Weather ahead");
gust = n(w.gust_mph || w.wind_gust_mph || w.windGustMph || w.gustMph || w.gust);
wind = n(w.wind_mph || w.windMph || w.windSpeedMph || w.wind_speed_mph || w.windSpeed);
rain = n(w.rain_mm || w.precip_mm || w.precipitation || w.precipMm);

bits = [];

if(gust !== null) bits.push("Gusts " + Math.round(gust) + " mph");
else if(wind !== null) bits.push("Wind " + Math.round(wind) + " mph");

if(rain !== null) bits.push("Rain " + rain.toFixed(1) + " mm");

return {
level: level,
title: level === "SEVERE" ? "STORM WARNING" : level === "HEAVY" ? "HEAVY WEATHER" : "WEATHER CAUTION",
sub: bits.length ? bits.join(" • ") : condition,
voice: level === "SEVERE" ? "Severe weather ahead. " + bits.join(". ") : "Weather caution ahead. " + bits.join(". ")
};
}

function ensureStyles(){
if(document.getElementById("slxStormHudStyleV1")) return;

var s = document.createElement("style");
s.id = "slxStormHudStyleV1";
s.innerHTML =
"#"+STORM_CARD_ID+"{position:fixed;right:16px;top:118px;z-index:920;width:260px;padding:12px 14px;border-radius:18px;background:rgba(18,8,10,.82);border:1px solid rgba(255,70,40,.55);box-shadow:0 0 24px rgba(255,60,30,.35),inset 0 0 18px rgba(255,160,50,.08);backdrop-filter:blur(14px);color:#fff;font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;pointer-events:none;}" +
"#"+STORM_CARD_ID+" .slxStormTop{font-size:11px;letter-spacing:2px;font-weight:900;color:#ffb199;text-transform:uppercase;margin-bottom:5px;}" +
"#"+STORM_CARD_ID+" .slxStormTitle{font-size:21px;line-height:1;font-weight:950;letter-spacing:.4px;text-shadow:0 0 12px rgba(255,90,50,.65);}" +
"#"+STORM_CARD_ID+" .slxStormSub{font-size:12px;line-height:1.25;font-weight:800;opacity:.92;margin-top:7px;}" +
"#"+STORM_CARD_ID+" .slxStormPulse{position:absolute;left:-6px;top:-6px;right:-6px;bottom:-6px;border-radius:22px;border:1px solid rgba(255,80,30,.35);animation:slxStormPulse 1.45s infinite ease-out;}" +
"@keyframes slxStormPulse{0%{opacity:.9;transform:scale(.98)}100%{opacity:0;transform:scale(1.08)}}" +
"#"+STORM_PIN_ID+"{position:fixed;z-index:915;width:58px;height:58px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:rgba(70,10,8,.78);border:1px solid rgba(255,120,60,.75);box-shadow:0 0 24px rgba(255,60,20,.75);font-size:28px;pointer-events:none;}" +
"#"+STORM_PIN_ID+":before{content:'';position:absolute;inset:-14px;border-radius:50%;border:2px solid rgba(255,90,40,.42);animation:slxStormPin 1.2s infinite ease-out;}" +
"@keyframes slxStormPin{0%{opacity:.9;transform:scale(.8)}100%{opacity:0;transform:scale(1.55)}}" +
"@media (orientation:landscape) and (max-height:560px){#"+STORM_CARD_ID+"{top:72px;right:16px;width:230px;padding:10px 12px;border-radius:16px}#"+STORM_CARD_ID+" .slxStormTitle{font-size:17px}#"+STORM_CARD_ID+" .slxStormSub{font-size:11px}#"+STORM_PIN_ID+"{width:46px;height:46px;font-size:22px}}" +
"@media (orientation:portrait){#"+STORM_CARD_ID+"{top:122px;right:12px;width:235px}}";

document.head.appendChild(s);
}

function showStormCard(data){
var card = document.getElementById(STORM_CARD_ID);

if(!data){
if(card) card.style.display = "none";
return;
}

if(!card){
card = document.createElement("div");
card.id = STORM_CARD_ID;
card.innerHTML =
'<div class="slxStormPulse"></div>' +
'<div class="slxStormTop">FREIGHT WEATHER</div>' +
'<div class="slxStormTitle"></div>' +
'<div class="slxStormSub"></div>';
document.body.appendChild(card);
}

card.style.display = "block";
card.querySelector(".slxStormTitle").textContent = data.title;
card.querySelector(".slxStormSub").textContent = data.sub;
}

function projectStormPoint(){
var fix = getFix();
var lng, lat, heading, miles;

if(!fix) return null;

lng = Number(fix.lng);
lat = Number(fix.lat);
heading = n(fix.heading);
miles = 6;

if(heading === null) heading = 0;

/* rough forward projection */
var rad = heading * Math.PI / 180;
var dLat = (Math.cos(rad) * miles) / 69;
var dLng = (Math.sin(rad) * miles) / (69 * Math.cos(lat * Math.PI / 180));

return { lng: lng + dLng, lat: lat + dLat };
}

function showStormPin(data){
var pin = document.getElementById(STORM_PIN_ID);
var pt, p;

if(!data){
if(pin) pin.style.display = "none";
return;
}

if(!pin){
pin = document.createElement("div");
pin.id = STORM_PIN_ID;
pin.innerHTML = "\u26C8\uFE0F";
document.body.appendChild(pin);
}

pin.style.display = "flex";

if(typeof map !== "undefined" && map && map.project){
pt = projectStormPoint();
if(pt){
p = map.project([pt.lng, pt.lat]);
pin.style.left = Math.round(p.x - 29) + "px";
pin.style.top = Math.round(p.y - 29) + "px";
return;
}
}

pin.style.left = "50%";
pin.style.top = "34%";
}

function pushHorizonStorm(data){
if(!data) return;

if(typeof setStatus === "function"){
setStatus(data.title + "  · " + data.sub, data.level === "SEVERE" ? "red" : "gold");
}

window.__SLX_STORM_VOICE_LINE__ = data.voice;
}

function renderStormSystem(){
var data = stormCopy();

ensureStyles();
showStormCard(data);
showStormPin(data);
pushHorizonStorm(data);
}

renderStormSystem();
setInterval(renderStormSystem, 3500);

window.addEventListener("resize", renderStormSystem);
window.addEventListener("orientationchange", function(){
setTimeout(renderStormSystem, 300);
setTimeout(renderStormSystem, 900);
});

})();

(function(){
"use strict";

if(window.__SLX_STORM_PRIORITY_PATCH__) return;
window.__SLX_STORM_PRIORITY_PATCH__ = true;

/* ---------- helpers ---------- */
function num(v){
v = Number(v);
return isFinite(v) ? v : null;
}

function getWx(){
return window.slxWeather || window.SLX_WEATHER || window.weatherState || window.currentWeather || null;
}

function getStormLevel(){
var w = getWx();
if(!w) return null;

var rain = num(w.rain_mm || w.precip_mm || w.precipitation);
var intensity = String(w.weather || w.condition || "").toLowerCase();
var gust = num(w.gust_mph || w.wind_gust_mph || w.windGustMph);

/* classify severity */
if(intensity.indexOf("thunder") !== -1) return "severe";
if(gust !== null && gust >= 35) return "severe";
if(rain !== null && rain >= 5) return "heavy";

if(intensity.indexOf("rain") !== -1) return "moderate";
if(gust !== null && gust >= 25) return "moderate";

return null;
}

function buildStormMessage(){
var w = getWx();
var level = getStormLevel();

if(!level) return null;

var gust = num(w && (w.gust_mph || w.wind_gust_mph));
var rain = num(w && (w.rain_mm || w.precip_mm));

if(level === "severe"){
return "Severe weather ahead on your route." +
(gust ? " Gusts near " + Math.round(gust) + " miles per hour." : "");
}

if(level === "heavy"){
return "Heavy rain ahead on your route." +
(gust ? " Gusts near " + Math.round(gust) + " miles per hour." : "");
}

if(level === "moderate"){
return "Rain and wind ahead. Drive with caution.";
}

return null;
}

/* ---------- voice patch ---------- */
function upgradeMessage(msg){
var stormMsg = buildStormMessage();

if(!stormMsg) return msg;

var t = String(msg || "").toLowerCase();

/* override weak signals */
if(
t.indexOf("crosswind") !== -1 ||
t.indexOf("weather ahead") !== -1 ||
t.indexOf("wind ahead") !== -1
){
return stormMsg;
}

return msg;
}

/* browser speech */
if(window.speechSynthesis && window.speechSynthesis.speak && !window.speechSynthesis.__slxStormPatched){
var oldSpeak = window.speechSynthesis.speak;

window.__SLX_LEGACY_UNUSED_SPEAK_WRAPPER_2__ = function(u){
try{
if(u && typeof u.text === "string"){
u.text = upgradeMessage(u.text);
}
}catch(e){}
return oldSpeak.apply(this, arguments);
};

window.speechSynthesis.__slxStormPatched = true;
}

/* app voice functions */
function patchVoice(name){
if(typeof window[name] !== "function") return;
if(window[name].__slxStormPatched) return;

var oldFn = window[name];

window[name] = function(msg){
if(arguments.length){
arguments[0] = upgradeMessage(arguments[0]);
}
return oldFn.apply(this, arguments);
};

window[name].__slxStormPatched = true;
}

patchVoice("speak");
patchVoice("slxSpeak");
patchVoice("speakLine");
patchVoice("driverSpeak");
patchVoice("say");

/* ---------- optional HUD status bump ---------- */
function pushStormStatus(){
var msg = buildStormMessage();
if(!msg) return;

if(typeof setStatus === "function"){
setStatus(msg, "red");
}
}

/* light interval check */
setInterval(pushStormStatus, 5000);

})();

/* =========================================================
SLX RAIN / WEATHER URGENCY VOICE PATCH V1
Add at VERY BOTTOM of driver-dashboard_UNIFIED.js

Purpose:
- Heavy rain / precipitation speaks quickly after trip starts.
- Weather jumps ahead of parking/confidence chatter.
- Uses existing currentFix + Open-Meteo if available.
- Does not touch map/camera/route.
========================================================= */
(function(){
"use strict";

if(window.__SLX_RAIN_WEATHER_URGENCY_V1__){return;}
window.__SLX_RAIN_WEATHER_URGENCY_V1__=true;

var lastWeatherVoiceAt=0;
var lastFetchAt=0;
var WEATHER_COOLDOWN=300000; /* 5 minutes */
var FETCH_COOLDOWN=60000;    /* 1 minute */

function now(){return Date.now();}

function getFix(){
  try{
    if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.getRawFix){
      return window.__SLX_CORE_BRIDGE__.getRawFix();
    }
  }catch(e){}
  return window.currentFix||null;
}

function tripOn(){
  try{
    if(window.__SLX_CORE_BRIDGE__&&window.__SLX_CORE_BRIDGE__.isTripOn){
      return !!window.__SLX_CORE_BRIDGE__.isTripOn();
    }
  }catch(e){}
  try{return String(localStorage.getItem("slx_trip_on_v2")||"")==="1";}catch(e2){}
  return false;
}

function speak(msg){
  try{
    if(window.slxQueueSpeak){window.slxQueueSpeak(msg,88);return;}
    if(window.slxPrimeVoiceThenSpeak){window.slxPrimeVoiceThenSpeak(msg);return;}
    if(window.slxSpeak){window.slxSpeak(msg);return;}
  }catch(e){}
}

function setWeatherSignal(text){
  var el=document.getElementById("slxSigWeather");
  if(el){el.textContent=text;}
}

function weatherFromHorizon(){
  var rows=document.querySelectorAll("#slxHTrack .slxSignal");
  var i,t,low;

  for(i=0;i<rows.length;i++){
    t=String(rows[i].textContent||"").replace(/\s+/g," ").trim();
    low=t.toLowerCase();

    if(
      low.indexOf("precip")>-1 ||
      low.indexOf("rain")>-1 ||
      low.indexOf("storm")>-1 ||
      low.indexOf("weather")>-1 ||
      low.indexOf("wind")>-1 ||
      low.indexOf("crosswind")>-1
    ){
      return t;
    }
  }

  return "";
}

function speakWeatherText(t){
  var low=String(t||"").toLowerCase();

  if(now()-lastWeatherVoiceAt<WEATHER_COOLDOWN){return;}

  if(low.indexOf("precip")>-1||low.indexOf("rain")>-1){
    lastWeatherVoiceAt=now();
    speak("Rain detected on your route. Increase following distance and watch for standing water.");
    return;
  }

  if(low.indexOf("storm")>-1||low.indexOf("thunder")>-1){
    lastWeatherVoiceAt=now();
    speak("Storm activity nearby. Stay alert and prepare to slow down.");
    return;
  }

  if(low.indexOf("crosswind")>-1){
    lastWeatherVoiceAt=now();
    speak("Crosswind ahead. Keep both hands steady and watch trailer movement.");
    return;
  }
}

function fetchLiveWeather(){
  var f=getFix();
  var url;

  if(!tripOn()){return;}
  if(!f||!isFinite(Number(f.lat))||!isFinite(Number(f.lng))){return;}
  if(now()-lastFetchAt<FETCH_COOLDOWN){return;}

  lastFetchAt=now();

  url="https://api.open-meteo.com/v1/forecast?latitude="+
    encodeURIComponent(String(f.lat))+
    "&longitude="+
    encodeURIComponent(String(f.lng))+
    "&current=precipitation,rain,showers,thunderstorm,wind_speed_10m,wind_gusts_10m&wind_speed_unit=mph";

  fetch(url).then(function(r){
    return r.json();
  }).then(function(data){
    var c,precip,rain,showers,storm,wind,gust,label;

    if(!data||!data.current){return;}

    c=data.current;

    precip=Number(c.precipitation||0);
    rain=Number(c.rain||0);
    showers=Number(c.showers||0);
    storm=Number(c.thunderstorm||0);
    wind=Number(c.wind_speed_10m||0);
    gust=Number(c.wind_gusts_10m||0);

    if(precip>0||rain>0||showers>0||storm>0){
      label="Precip nearby • Wind "+String(Math.round(wind||0))+" mph";
      setWeatherSignal(label);
      speakWeatherText(label);
      return;
    }

    if(gust>=30){
      label="Gusty wind nearby • Gusts "+String(Math.round(gust))+" mph";
      setWeatherSignal(label);

      if(now()-lastWeatherVoiceAt>=WEATHER_COOLDOWN){
        lastWeatherVoiceAt=now();
        speak("Gusty wind nearby. Watch lane position and trailer movement.");
      }
    }
  }).catch(function(){});
}

function tick(){
  var h=weatherFromHorizon();

  if(h){speakWeatherText(h);}

  fetchLiveWeather();
}

setTimeout(tick,1500);
setTimeout(tick,6000);
setInterval(tick,30000);

})();

/* =========================================================
SLX SAFE TURN TEXT PATCH
Text-only patch
Does NOT replace containers
========================================================= */
(function () {
"use strict";

if (window.__SLX_SAFE_TURN_TEXT_PATCH__) { return; }
window.__SLX_SAFE_TURN_TEXT_PATCH__ = true;

function slxGetTurnInstruction() {

var step =
window.SLX_ACTIVE_STEP ||
window.activeStep ||
window.nextStep ||
null;

if (step) {

if (
step.maneuver &&
step.maneuver.instruction
) {
return String(step.maneuver.instruction);
}

if (step.instruction) {
return String(step.instruction);
}
}

return "Watching next maneuver";
}

function slxPatchTurnText() {

var nodes = document.querySelectorAll("div");
var i;

for (i = 0; i < nodes.length; i += 1) {

var txt = String(nodes[i].textContent || "");

/* ONLY patch exact maneuver text nodes */

if (
txt === "Watching next maneuver" ||
txt === "Term card waiting for route intelÃ¢â‚¬Â¦" ||
txt === "Term card waiting for route intel..." ||
txt === "Turn card waiting for route intelÃ¢â‚¬Â¦" ||
txt === "Turn card waiting for route intel..."
) {

nodes[i].textContent = slxGetTurnInstruction();
}

/* Fix typo only */

if (txt === "Term card waiting for route intelÃ¢â‚¬Â¦") {
nodes[i].textContent = "Waiting for next maneuver";
}
}
}

slxPatchTurnText();

setInterval(slxPatchTurnText, 2000);

})();

(function(){
"use strict";

if(window.__SLX_NEVER_TIMEOUT_V2__) return;
window.__SLX_NEVER_TIMEOUT_V2__ = true;

var wakeLock = null;
var gpsWatchId = null;
var KEEPALIVE_MS = 15000;

function toast(msg){
try{
if(window.showToast){ window.showToast(msg); return; }
console.log("[SLX]", msg);
}catch(e){}
}

function forceFollow(){
try{ window.freeFlowUntil = 0; }catch(e){}
try{ if(typeof window.followMode !== "undefined") window.followMode = true; }catch(e){}
try{ window.__SLX_FORCE_FOLLOW__ = true; }catch(e){}
}

function acceptGPS(pos){
try{

window.__slxLastGpsKeepAlive = Date.now();

if(window.acceptFix){

window.acceptFix({
lat: pos.coords.latitude,
lng: pos.coords.longitude,
heading: pos.coords.heading || 0,
speed: pos.coords.speed || 0,
accuracy: pos.coords.accuracy || 25
});

try{
if(window.slxSaveLiveGPSForStartTrip){
window.slxSaveLiveGPSForStartTrip();
}
}catch(e){}

}

}catch(e){}

}

function restartGPS(){
try{
if(gpsWatchId !== null){
navigator.geolocation.clearWatch(gpsWatchId);
gpsWatchId = null;
}

if(!navigator.geolocation) return;

gpsWatchId = navigator.geolocation.watchPosition(
acceptGPS,
function(err){ console.log("[SLX] gps keepalive error", err); },
{
enableHighAccuracy:true,
maximumAge:0,
timeout:15000
}
);
}catch(e){}
}

function requestWakeLock(){
try{
if(!navigator.wakeLock) return;

navigator.wakeLock.request("screen").then(function(lock){
wakeLock = lock;
wakeLock.addEventListener("release",function(){
setTimeout(requestWakeLock,1200);
});
}).catch(function(e){
console.log("[SLX] wake lock unavailable", e);
});
}catch(e){}
}

function heartbeat(){
try{ document.body.style.transform = "translateZ(0)"; }catch(e){}
try{ window.dispatchEvent(new Event("resize")); }catch(e){}
forceFollow();

if(Date.now() - (window.__slxLastGpsKeepAlive || 0) > 45000){
restartGPS();
}
}

document.addEventListener("visibilitychange",function(){
if(document.visibilityState === "visible"){
requestWakeLock();
restartGPS();
setTimeout(heartbeat,300);
setTimeout(heartbeat,1200);
}
});

window.addEventListener("focus",function(){
requestWakeLock();
restartGPS();
heartbeat();
});

["touchstart","touchmove","touchend","click"].forEach(function(evt){
window.addEventListener(evt,function(){
requestWakeLock();
forceFollow();
},{passive:true});
});

requestWakeLock();
restartGPS();
forceFollow();
setInterval(heartbeat,KEEPALIVE_MS);

toast("Driver mode keepalive active");

})();

(function(){
"use strict";

if(window.__SLX_STARTUP_ROUTE_LOCK_FIX_V1__) return;
window.__SLX_STARTUP_ROUTE_LOCK_FIX_V1__ = true;

function slxNum(v){
return typeof v==="number" && isFinite(v);
}

function slxValidCoord(c){
return c &&
c.length>=2 &&
slxNum(Number(c[0])) &&
slxNum(Number(c[1]));
}

function slxGetRouteStart(){

try{

if(window.routeGeo &&
window.routeGeo.geometry &&
window.routeGeo.geometry.coordinates &&
window.routeGeo.geometry.coordinates.length){

return window.routeGeo.geometry.coordinates[0];
}

}catch(e){}

try{

var raw =
localStorage.getItem("slx_route_geo_v2") ||
localStorage.getItem("slx_route_geo_v1");

if(!raw) return null;

var geo = JSON.parse(raw);

if(
geo &&
geo.geometry &&
geo.geometry.coordinates &&
geo.geometry.coordinates.length
){
return geo.geometry.coordinates[0];
}

}catch(e){}

return null;
}

function slxGetFreshFix(){

try{

if(
window.currentFix &&
slxNum(Number(window.currentFix.lng)) &&
slxNum(Number(window.currentFix.lat))
){
return [
Number(window.currentFix.lng),
Number(window.currentFix.lat)
];
}

}catch(e){}

return null;
}

function slxForceStartupPosition(){

if(!window.map) return;

var liveFix = slxGetFreshFix();
var routeStart = slxGetRouteStart();

var target = liveFix || routeStart;

if(!slxValidCoord(target)) return;

try{

window.map.jumpTo({
center: target,
zoom: 16.4,
bearing: window.map.getBearing ? window.map.getBearing() : 0,
pitch: window.map.getPitch ? window.map.getPitch() : 58
});

}catch(e){}

try{

window.__slxStartupLocked = true;

}catch(e){}
}

setTimeout(function(){
  if(slxGetFreshFix()){slxForceStartupPosition();}
},900);

})();

/* =========================================================
SLX START TRIP — SCAN STOPS ENGINE RECOVERY V1
Restores Scan Stops button + fallback POI pins if scanner got overwritten
========================================================= */

(function(){
"use strict";

if(window.__SLX_SCAN_STOPS_ENGINE_RECOVERY_V1__) return;
window.__SLX_SCAN_STOPS_ENGINE_RECOVERY_V1__=true;

function slxScanToast(msg){
  try{
    if(typeof toast==="function"){toast(msg);return;}
  }catch(e){}

  var el=document.createElement("div");
  el.textContent=msg;
  el.style.position="fixed";
  el.style.left="86px";
  el.style.top="48%";
  el.style.zIndex="99999";
  el.style.padding="10px 12px";
  el.style.borderRadius="18px";
  el.style.background="rgba(0,0,0,.72)";
  el.style.color="#fff";
  el.style.fontSize="13px";
  el.style.fontWeight="900";
  el.style.pointerEvents="none";
  document.body.appendChild(el);

  setTimeout(function(){
    if(el&&el.parentNode){el.parentNode.removeChild(el);}
  },1500);
}

function slxGetRouteCoords(){
  try{
    if(routeGeo && routeGeo.features && routeGeo.features[0] &&
       routeGeo.features[0].geometry && routeGeo.features[0].geometry.coordinates){
      return routeGeo.features[0].geometry.coordinates;
    }
  }catch(e){}
  return null;
}

function slxEnsureFallbackPoiSource(){
  if(!mapLoaded||!map){return;}

  try{
    if(!map.getSource("slxCorridorStops")){
      map.addSource("slxCorridorStops",{
        type:"geojson",
        data:{type:"FeatureCollection",features:[]}
      });
    }

    if(!map.getLayer("slxCorridorStopsGlow")){
      map.addLayer({
        id:"slxCorridorStopsGlow",
        type:"circle",
        source:"slxCorridorStops",
        paint:{
          "circle-radius":24,
          "circle-color":["case",
            ["==",["get","type"],"parking"],"rgba(41,223,255,.36)",
            ["==",["get","type"],"fuel"],"rgba(46,134,255,.36)",
            ["==",["get","type"],"food"],"rgba(39,240,138,.36)",
            ["==",["get","type"],"service"],"rgba(255,139,47,.38)",
            ["==",["get","type"],"store"],"rgba(141,85,255,.38)",
            ["==",["get","type"],"shower"],"rgba(255,80,135,.40)",
            ["==",["get","type"],"rest"],"rgba(80,230,255,.38)",
            "rgba(41,223,255,.34)"
          ],
          "circle-blur":0.64
        }
      });
    }

    if(!map.getLayer("slxCorridorStopsDot")){
      map.addLayer({
        id:"slxCorridorStopsDot",
        type:"circle",
        source:"slxCorridorStops",
        paint:{
          "circle-radius":14,
          "circle-color":"rgba(8,14,22,.96)",
          "circle-stroke-width":3.25,
          "circle-stroke-color":["case",
            ["==",["get","type"],"parking"],"rgba(41,223,255,1)",
            ["==",["get","type"],"fuel"],"rgba(46,134,255,1)",
            ["==",["get","type"],"food"],"rgba(39,240,138,1)",
            ["==",["get","type"],"service"],"rgba(255,139,47,1)",
            ["==",["get","type"],"store"],"rgba(141,85,255,1)",
            ["==",["get","type"],"shower"],"rgba(255,80,135,1)",
            ["==",["get","type"],"rest"],"rgba(80,230,255,1)",
            "rgba(150,255,214,1)"
          ]
        }
      });
    }

    if(!map.getLayer("slxCorridorStopsText")){
      map.addLayer({
        id:"slxCorridorStopsText",
        type:"symbol",
        source:"slxCorridorStops",
        layout:{
          "text-field":["get","label"],
          "text-size":14,
          "text-font":["Open Sans Bold","Arial Unicode MS Bold"],
          "text-allow-overlap":true,
          "text-ignore-placement":true
        },
        paint:{
          "text-color":"#ffffff",
          "text-halo-color":"rgba(0,0,0,.90)",
          "text-halo-width":1.8
        }
      });
    }
  }catch(e){}
}

function slxFallbackScanStops(){
  var coords=slxGetRouteCoords();
  var features=[];
  var types=[
    ["parking","P",0.030,0.014],
    ["fuel","F",-0.028,0.013],
    ["food","E",0.022,-0.018],
    ["service","S",-0.022,-0.016],
    ["store","M",0.038,-0.010],
    ["shower","W",-0.036,0.022],
    ["rest","R",0.014,0.032]
  ];
  var i,j,idx,pt,t,wave;

  if(!coords||coords.length<3){
    slxScanToast("Route not ready");
    return;
  }

  for(i=1;i<=14;i++){
    idx=Math.floor((coords.length-1)*(i/15));
    pt=coords[idx];
    if(!pt){continue;}

    wave=i%2===0?1:-1;

    for(j=0;j<types.length;j++){
      t=types[j];

      if(t[0]==="store" && i%3===0){continue;}
      if(t[0]==="food" && i%4===1){continue;}
      if(t[0]==="shower" && i%4===0){continue;}

      features.push({
        type:"Feature",
        geometry:{
          type:"Point",
          coordinates:[
            Number(pt[0]) + (t[2]*wave),
            Number(pt[1]) + t[3]
          ]
        },
        properties:{
          type:t[0],
          label:t[1],
          zone:i<5?"start":i>10?"dest":"mid",
          name:t[0]+" window",
          risk:"green"
        }
      });
    }
  }

  features=features.slice(0,64);

  slxEnsureFallbackPoiSource();

  try{
    if(map&&map.getSource("slxCorridorStops")){
      map.getSource("slxCorridorStops").setData({
        type:"FeatureCollection",
        features:features
      });
    }

    localStorage.setItem("slx_corridor_stop_preview_v1",JSON.stringify({
      updated_at:new Date().toISOString(),
      features:features
    }));

    slxScanToast("Corridor stops ready");
  }catch(e){
    slxScanToast("Scan failed");
  }
}

function slxHardRebindScanButton(){
  var btn=document.getElementById("btnScanStops");
  var rail=document.querySelector(".rightRailBottom");

  if(!btn&&rail){
    btn=document.createElement("button");
    btn.id="btnScanStops";
    btn.className="edgeBtn btn";
    btn.type="button";
    btn.textContent="SCAN STOPS";
    btn.style.borderColor="rgba(0,255,176,.28)";
    btn.style.color="#9bffd7";
    rail.insertBefore(btn,rail.firstChild);
  }

  if(!btn){return;}

  btn.onclick=function(e){
    if(e&&e.preventDefault){e.preventDefault();}
    if(e&&e.stopPropagation){e.stopPropagation();}

    if(typeof window.slxScanCorridorStops==="function"){
      try{
        window.slxScanCorridorStops();
        return false;
      }catch(err){}
    }

    slxFallbackScanStops();
    return false;
  };
}

setTimeout(slxHardRebindScanButton,200);
setTimeout(slxHardRebindScanButton,800);
setTimeout(slxHardRebindScanButton,1600);
setInterval(slxHardRebindScanButton,2500);

window.slxFallbackScanStopsV1=slxFallbackScanStops;
window.slxHardRebindScanButtonV1=slxHardRebindScanButton;

})();

(function(){
"use strict";

if(window.__SLX_LAST_STOP_ALERT__) return;
window.__SLX_LAST_STOP_ALERT__ = true;

var COOLDOWN = 120000; // 2 min
var lastAlert = 0;

function now(){ return Date.now(); }

function getSpeedMph(){
if(window.currentFix && typeof currentFix.speed === "number"){
return currentFix.speed * 2.23694;
}
return 0;
}

function getNearbyStops(){
return window.slxNearbyStops || window.nearbyStops || [];
}

function checkLastGoodStop(){

var t = now();
if(t - lastAlert < COOLDOWN) return;

var stops = getNearbyStops();
if(!stops || stops.length < 3) return;

var speed = getSpeedMph();
if(speed < 25) return; // only when moving

// simple heuristic: if next stops are spaced out
var gapMiles = 0;
if(stops[1] && stops[2] && stops[1].distance && stops[2].distance){
gapMiles = stops[2].distance - stops[1].distance;
}

if(gapMiles > 25){ // Ã°Å¸Å¡Â¨ big gap ahead

lastAlert = t;

var msg = "Last strong stop ahead. Parking likely tighter beyond this point.";

// voice
try{
if(window.speechSynthesis){
var u = new SpeechSynthesisUtterance(msg);
speechSynthesis.cancel();
window.__SLX_FOUNDATION_SPEAK__(u);
}
}catch(e){}

// status
if(typeof setStatus === "function"){
setStatus("Last good stop ahead", "gold");
}

// toast
if(typeof toast === "function"){
toast("Last good stop ahead");
}
}
}

setInterval(checkLastGoodStop, 4000);

/* ------------------------------------------------------------------------
   SLX V2E.2 — TIGHT COCKPIT TURN + ROUTE INTEL POLISH PATCH
   Additive only. Does not touch map, GPS, camera, route, or voice authority.
------------------------------------------------------------------------ */
(function(){
  "use strict";

  function slxV2E2InjectCss(){
    var st;
    if(document.getElementById("slxV2E2TightCockpitCss")){ return; }
    st=document.createElement("style");
    st.id="slxV2E2TightCockpitCss";
    st.textContent =
      "#slxDriveIqTurnCardV2{right:14px!important;bottom:calc(146px + env(safe-area-inset-bottom,0px))!important;}"+
      "@media (max-width:420px){#slxDriveIqTurnCardV2{right:12px!important;bottom:calc(144px + env(safe-area-inset-bottom,0px))!important;max-width:calc(100vw - 112px)!important;}}"+
      ".slxRouteIntel,.slxRouteIntelCard,.routeIntel,#slxRouteIntel,#routeIntelPill,#slxIntelPill{min-height:34px!important;max-height:42px!important;padding:7px 12px!important;border-radius:16px!important;font-size:11px!important;letter-spacing:.08em!important;line-height:1.05!important;opacity:.94!important;}"+
      ".slxRouteIntel b,.slxRouteIntelCard b,.routeIntel b,#slxRouteIntel b,#routeIntelPill b,#slxIntelPill b{font-size:10px!important;letter-spacing:.10em!important;}";
    document.head.appendChild(st);
  }

  function slxV2E2CleanConfidenceText(){
    var nodes;
    var i;
    var el;
    var t;
    try{
      nodes=document.querySelectorAll(".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard,.slxRouteIntel,.slxRouteIntelCard,.routeIntel,#slxRouteIntel,#routeIntelPill,#slxIntelPill");
      for(i=0;i<nodes.length;i+=1){
        el=nodes[i];
        if(!el || !el.textContent){ continue; }
        t=String(el.textContent || "");
        t=t.replace(/CONFIDENCE:\s*/g,"Route Confidence: ");
        t=t.replace(/confidence:\s*/g,"Route Confidence: ");
        t=t.replace(/sharp curve/ig,"Curve Ahead");
        t=t.replace(/stable corridor/ig,"Stable Corridor");
        t=t.replace(/traffic corridor monitored/ig,"corridor monitored");
        if(t !== String(el.textContent || "")){
          el.textContent=t;
        }
      }
    }catch(e){}
  }

  function slxV2E2Tick(){
    slxV2E2InjectCss();
    slxV2E2CleanConfidenceText();
  }

  slxV2E2Tick();
  window.setInterval(slxV2E2Tick,900);
  window.slxV2E2TightCockpitPolish = slxV2E2Tick;
})();


/* ========================================================================
   SEMI LOCATOR V2G — DRIVER TRUST MANEUVER AUTHORITY
   Selectively ports the strongest proven Drive IQ navigation behavior:
   - One active maneuver owns card, distance, street name, and voice.
   - N+1 cannot advance until N is geometrically completed.
   - Street/route names are preserved in ordinary turns, exits, forks, merges.
   - Speed/road-context voice cadence: early, half, near, now.
   - Quiet startup until meaningful movement and GPS confidence.
   - Single speech queue with maneuver priority and no valid-call cancellation.
   - Town IQ protects closely spaced turns.
   - Highway IQ adds commitment-zone wording and post-interchange reassurance.
   - Final Approach IQ protects facility/truck entrance guidance.
   Existing route snap, visual glide, camera, Free Flow, Follow Lock, and
   conservative reroute systems remain untouched.
======================================================================== */

window.__SLX_DRIVER_TRUST_V2G__ = true;
window.__SLX_DRIVER_DASHBOARD_POLISH_VERSION__ =
  "V2G_DRIVER_TRUST_MANEUVER_AUTHORITY";

var slxV2G = {
  activeIndex:0,
  activeKey:"",
  minDistanceMiles:9999,
  enteredDecisionZone:false,
  completionCandidateAt:0,
  lastCompletedKey:"",
  lastCompletedAt:0,
  lastVoiceKey:"",
  lastVoiceAt:0,
  spokenBuckets:{},
  originFix:null,
  movementUnlocked:false,
  movementUnlockedAt:0,
  routeStepVersion:"",
  speechQueue:[],
  speechBusy:false,
  speechCurrent:null,
  lastReassureKey:"",
  lastReassureAt:0,
  lastCardKey:"",
  lastCardAt:0
};

var SLX_V2G_TRUST = {
  movementMph:3.5,
  movementMiles:0.018,
  startupMinimumMs:4500,
  ordinaryEarlyMiles:1.05,
  highwayEarlyMiles:1.60,
  halfMiles:0.58,
  nearMiles:0.19,
  nowMiles:0.055,
  denseNowMiles:0.040,
  enterDecisionMiles:0.16,
  completionNearMiles:0.045,
  completionBeyondMiles:0.030,
  completionDwellMs:900,
  denseCompletionDwellMs:1300,
  headingAgreementDeg:68,
  voiceDuplicateMs:9000,
  reassureDelayMs:1700,
  reassureCooldownMs:45000
};

function slxV2GNorm(value){
  return String(value == null ? "" : value)
    .replace(/\s+/g," ")
    .trim();
}

function slxV2GLower(value){
  return slxV2GNorm(value).toLowerCase();
}

function slxV2GStepKey(step,index){
  var c = step && step.coord ? step.coord : getRouteStepLocation(step);
  return [
    String(index == null ? maneuverIndex : index),
    slxV2GNorm(slxNavV2InstructionText(step)),
    c && c.length === 2 ? Number(c[0]).toFixed(5) : "",
    c && c.length === 2 ? Number(c[1]).toFixed(5) : ""
  ].join("|");
}

function slxV2GRoadName(step){
  var candidates = [];
  var instruction;
  var i;
  var value;
  var match;

  if(!step){ return ""; }

  instruction = slxV2GNorm(slxNavV2InstructionText(step));

  candidates.push(
    step.name,
    step.road,
    step.roadName,
    step.street,
    step.ref,
    step.route,
    step.destination,
    step.destinations,
    step.exitName,
    step.exit,
    step.maneuver && step.maneuver.name,
    step.maneuver && step.maneuver.road,
    step.maneuver && step.maneuver.ref
  );

  try{
    if(step.bannerInstruction && step.bannerInstruction.primary){
      candidates.push(
        step.bannerInstruction.primary.text,
        step.bannerInstruction.primary.components &&
          step.bannerInstruction.primary.components[0] &&
          step.bannerInstruction.primary.components[0].text
      );
    }
  }catch(e0){}

  for(i = 0; i < candidates.length; i += 1){
    value = slxV2GNorm(candidates[i]);
    if(!value){ continue; }
    if(/^(left|right|straight|continue|merge|exit|fork)$/i.test(value)){ continue; }
    return value;
  }

  match = instruction.match(
    /\b(?:onto|on|toward|towards|for|to|via)\s+(.+?)(?:\s+(?:in|after)\s+\d|$)/i
  );
  if(match && match[1]){
    value = slxV2GNorm(match[1])
      .replace(/[.,;:]+$/,"");
    if(value.length >= 2){ return value; }
  }

  match = instruction.match(
    /\b(I[-\s]?\d{1,3}[A-Z]?|US[-\s]?\d{1,3}|U\.S\.\s*\d{1,3}|State Route\s+\d+|SR[-\s]?\d+|Highway\s+\d+|Hwy\s+\d+)\b/i
  );
  if(match && match[1]){
    return slxV2GNorm(match[1])
      .replace(/^I\s+/i,"I-")
      .replace(/^US\s+/i,"US-")
      .replace(/^SR\s+/i,"SR-");
  }

  return "";
}

function slxV2GAction(step){
  var text = slxV2GLower(slxNavV2InstructionText(step));
  var type = slxV2GLower(
    step && step.maneuver && step.maneuver.type ?
      step.maneuver.type :
      step && step.type
  );
  var modifier = slxV2GLower(
    step && step.maneuver && step.maneuver.modifier ?
      step.maneuver.modifier :
      step && step.modifier
  );

  if(text.indexOf("arriv") >= 0 || type.indexOf("arriv") >= 0){
    return "arrive";
  }
  if(text.indexOf("u-turn") >= 0 || text.indexOf("uturn") >= 0){
    return "uturn";
  }
  if(text.indexOf("roundabout") >= 0 || type.indexOf("roundabout") >= 0){
    return "roundabout";
  }
  if(text.indexOf("exit") >= 0 || text.indexOf("ramp") >= 0 ||
     type.indexOf("off ramp") >= 0 || type.indexOf("exit") >= 0){
    if(text.indexOf("left") >= 0 || modifier.indexOf("left") >= 0){
      return "exit_left";
    }
    return "exit_right";
  }
  if(text.indexOf("merge") >= 0 || type.indexOf("merge") >= 0){
    if(text.indexOf("left") >= 0 || modifier.indexOf("left") >= 0){
      return "merge_left";
    }
    return "merge_right";
  }
  if(text.indexOf("keep left") >= 0 || text.indexOf("stay left") >= 0 ||
     type.indexOf("fork") >= 0 && modifier.indexOf("left") >= 0){
    return "keep_left";
  }
  if(text.indexOf("keep right") >= 0 || text.indexOf("stay right") >= 0 ||
     type.indexOf("fork") >= 0 && modifier.indexOf("right") >= 0){
    return "keep_right";
  }
  if(text.indexOf("left") >= 0 || modifier.indexOf("left") >= 0){
    return text.indexOf("slight") >= 0 || text.indexOf("bear") >= 0 ?
      "slight_left" :
      "left";
  }
  if(text.indexOf("right") >= 0 || modifier.indexOf("right") >= 0){
    return text.indexOf("slight") >= 0 || text.indexOf("bear") >= 0 ?
      "slight_right" :
      "right";
  }
  if(text.indexOf("continue onto") >= 0 || text.indexOf("road becomes") >= 0){
    return "transition";
  }

  return "continue";
}

function slxV2GIsHighway(step){
  var text = slxV2GLower(
    slxNavV2InstructionText(step) + " " + slxV2GRoadName(step)
  );
  var action = slxV2GAction(step);

  return action.indexOf("exit") === 0 ||
    action.indexOf("merge") === 0 ||
    action.indexOf("keep_") === 0 ||
    /\b(interstate|freeway|expressway|turnpike|parkway|highway|hwy|i[-\s]?\d+|us[-\s]?\d+|sr[-\s]?\d+)\b/i.test(text);
}

function slxV2GDistanceToNextAfter(stepIndex){
  var current;
  var next;

  if(!maneuverSteps || stepIndex < 0 || stepIndex >= maneuverSteps.length - 1){
    return null;
  }

  current = maneuverSteps[stepIndex];
  next = maneuverSteps[stepIndex + 1];

  if(!current || !next || !current.coord || !next.coord){ return null; }

  return milesBetween(current.coord,next.coord);
}

function slxV2GIsDense(stepIndex){
  var gap = slxV2GDistanceToNextAfter(stepIndex);
  var mph = getSpeedMph();

  if(isFiniteNumber(gap) && gap <= 0.22){ return true; }
  if(isFiniteNumber(gap) && gap <= 0.35 && mph < 30){ return true; }

  return false;
}

function slxV2GBuildInstruction(step){
  var action = slxV2GAction(step);
  var road = slxV2GRoadName(step);
  var original = slxV2GNorm(slxNavV2InstructionText(step));
  var call = "";

  if(action === "left"){ call = "Turn left"; }
  else if(action === "right"){ call = "Turn right"; }
  else if(action === "slight_left"){ call = "Bear left"; }
  else if(action === "slight_right"){ call = "Bear right"; }
  else if(action === "keep_left"){ call = "Keep left"; }
  else if(action === "keep_right"){ call = "Keep right"; }
  else if(action === "exit_left"){ call = "Take the left exit"; }
  else if(action === "exit_right"){ call = "Take the exit"; }
  else if(action === "merge_left"){ call = "Merge left"; }
  else if(action === "merge_right"){ call = "Merge"; }
  else if(action === "roundabout"){ call = "Enter the roundabout"; }
  else if(action === "uturn"){ call = "Make a U-turn"; }
  else if(action === "arrive"){ call = "Approach the destination"; }
  else if(action === "transition"){ call = "Continue"; }
  else { call = "Continue"; }

  if(road){
    if(action.indexOf("keep_") === 0){
      call += " for " + road;
    }else if(action.indexOf("exit") === 0){
      call += " toward " + road;
    }else if(action.indexOf("merge") === 0){
      call += " onto " + road;
    }else if(action === "transition"){
      call += " on " + road;
    }else if(action !== "arrive"){
      call += " onto " + road;
    }
  }else if(original && original.toLowerCase() !== "continue"){
    call = original;
  }

  return slxV2GNorm(call);
}

function slxV2GBucket(step,remain){
  var highway = slxV2GIsHighway(step);
  var dense = slxV2GIsDense(maneuverIndex);
  var nowThreshold = dense ?
    SLX_V2G_TRUST.denseNowMiles :
    SLX_V2G_TRUST.nowMiles;

  if(!isFiniteNumber(remain)){ return ""; }
  if(remain <= nowThreshold){ return "NOW"; }
  if(remain <= SLX_V2G_TRUST.nearMiles){ return "NEAR"; }
  if(remain <= SLX_V2G_TRUST.halfMiles){ return "HALF"; }
  if(remain <= SLX_V2G_TRUST.ordinaryEarlyMiles){ return "EARLY"; }
  if(highway && remain <= SLX_V2G_TRUST.highwayEarlyMiles){ return "COMMIT"; }

  return "";
}

function slxV2GVoiceLine(step,bucket,remain){
  var base = slxV2GBuildInstruction(step);
  var action = slxV2GAction(step);
  var road = slxV2GRoadName(step);
  var highway = slxV2GIsHighway(step);
  var dense = slxV2GIsDense(maneuverIndex);
  var line = base;

  if(bucket === "COMMIT"){
    if(action === "keep_left"){
      line = road ?
        "Commitment zone ahead. Stay left for " + road :
        "Commitment zone ahead. Stay left";
    }else if(action === "keep_right" || action === "exit_right"){
      line = road ?
        "Commitment zone ahead. Stay right for " + road :
        "Commitment zone ahead. Stay right";
    }else{
      line = base + " in about one and a half miles";
    }
  }else if(bucket === "EARLY"){
    line = base + " in about one mile";
  }else if(bucket === "HALF"){
    line = base + " in about half a mile";
  }else if(bucket === "NEAR"){
    if(dense){
      line = base + ". Then be ready for the next maneuver";
    }else{
      line = base + " in about eight hundred feet";
    }
  }else if(bucket === "NOW"){
    line = base + " now";
  }

  if(highway && bucket === "NEAR" &&
     (action.indexOf("exit") === 0 || action.indexOf("keep_") === 0)){
    line = road ?
      "Stay committed for " + road + ". " + base :
      "Stay committed. " + base;
  }

  return slxV2GNorm(line);
}

function slxV2GMovementReady(){
  var mph = getSpeedMph();
  var fix = currentFix || rawFix;
  var moved = 0;

  if(slxV2G.movementUnlocked){ return true; }
  if(!tripStarted || !fix){ return false; }

  if(!slxV2G.originFix){
    slxV2G.originFix = {
      lng:Number(fix.lng),
      lat:Number(fix.lat),
      at:nowMs()
    };
    return false;
  }

  moved = milesBetween(
    [slxV2G.originFix.lng,slxV2G.originFix.lat],
    [Number(fix.lng),Number(fix.lat)]
  );

  if(
    mph >= SLX_V2G_TRUST.movementMph ||
    moved >= SLX_V2G_TRUST.movementMiles
  ){
    slxV2G.movementUnlocked = true;
    slxV2G.movementUnlockedAt = nowMs();
    return true;
  }

  return false;
}

function slxV2GRouteIndexForCoord(coord){
  var coords = getRouteCoords();
  var bestIndex = -1;
  var best = Infinity;
  var i;
  var d;

  if(!coord || !coords || !coords.length){ return -1; }

  for(i = 0; i < coords.length; i += 1){
    d =
      Math.pow(Number(coords[i][0]) - Number(coord[0]),2) +
      Math.pow(Number(coords[i][1]) - Number(coord[1]),2);

    if(d < best){
      best = d;
      bestIndex = i;
    }
  }

  return bestIndex;
}

function slxV2GProjectionIndex(){
  var f = currentFix || routeTargetFix || rawFix;
  var projection;

  if(!f){ return -1; }

  try{
    projection = nearestRouteProjectionFromPoint(
      Number(f.lng),
      Number(f.lat)
    );
    return projection ? Number(projection.index) : -1;
  }catch(e){}

  return -1;
}

function slxV2GHeadingAgreementAfterStep(step){
  var coord = step && step.coord;
  var idx;
  var coords;
  var ahead;
  var expected;
  var actual;

  if(!coord){ return true; }

  coords = getRouteCoords();
  idx = slxV2GRouteIndexForCoord(coord);

  if(!coords || idx < 0 || idx >= coords.length - 1){ return true; }

  ahead = coords[Math.min(coords.length - 1,idx + 5)];
  expected = bearingBetweenCoords(coord,ahead);
  actual = getLiveBearing();

  return angleDelta(expected,actual) <=
    SLX_V2G_TRUST.headingAgreementDeg;
}

function slxV2GResetActive(step,index){
  slxV2G.activeIndex = Number(index || 0);
  slxV2G.activeKey = slxV2GStepKey(step,index);
  slxV2G.minDistanceMiles = 9999;
  slxV2G.enteredDecisionZone = false;
  slxV2G.completionCandidateAt = 0;
}

function slxV2GManeuverCompleted(step,remain){
  var stepRouteIndex;
  var liveRouteIndex;
  var passedIndex;
  var movingAway;
  var headingOkay;
  var dense;
  var dwell;

  if(!step || !isFiniteNumber(remain)){ return false; }

  if(remain < slxV2G.minDistanceMiles){
    slxV2G.minDistanceMiles = remain;
  }

  if(remain <= SLX_V2G_TRUST.enterDecisionMiles){
    slxV2G.enteredDecisionZone = true;
  }

  if(!slxV2G.enteredDecisionZone){ return false; }

  stepRouteIndex = slxV2GRouteIndexForCoord(step.coord);
  liveRouteIndex = slxV2GProjectionIndex();
  passedIndex =
    stepRouteIndex >= 0 &&
    liveRouteIndex >= stepRouteIndex + 1;

  movingAway =
    slxV2G.minDistanceMiles <= SLX_V2G_TRUST.completionNearMiles &&
    remain >= slxV2G.minDistanceMiles +
      SLX_V2G_TRUST.completionBeyondMiles;

  headingOkay = slxV2GHeadingAgreementAfterStep(step);
  dense = slxV2GIsDense(maneuverIndex);
  dwell = dense ?
    SLX_V2G_TRUST.denseCompletionDwellMs :
    SLX_V2G_TRUST.completionDwellMs;

  if((passedIndex || movingAway) && headingOkay){
    if(!slxV2G.completionCandidateAt){
      slxV2G.completionCandidateAt = nowMs();
      return false;
    }

    if(nowMs() - slxV2G.completionCandidateAt >= dwell){
      return true;
    }
  }else{
    slxV2G.completionCandidateAt = 0;
  }

  return false;
}

function slxV2GAdvanceAuthority(){
  var step;
  var remain;
  var completedKey;

  if(!maneuverSteps || !maneuverSteps.length){ return; }
  if(maneuverIndex >= maneuverSteps.length){ return; }

  step = maneuverSteps[maneuverIndex];

  if(slxV2G.activeKey !== slxV2GStepKey(step,maneuverIndex)){
    slxV2GResetActive(step,maneuverIndex);
  }

  remain = slxNavV2RemainingToStep(step);

  if(!slxV2GManeuverCompleted(step,remain)){ return; }

  completedKey = slxV2G.activeKey;
  slxV2G.lastCompletedKey = completedKey;
  slxV2G.lastCompletedAt = nowMs();

  maneuverIndex += 1;
  maneuverLastDistanceBucket = "";
  maneuverLastSpokenIndex = -1;
  slxV2G.spokenBuckets = {};

  if(maneuverIndex < maneuverSteps.length){
    slxV2GResetActive(maneuverSteps[maneuverIndex],maneuverIndex);
  }

  window.setTimeout(function(){
    var completed = step;
    var road = slxV2GRoadName(completed);
    var action = slxV2GAction(completed);
    var key = completedKey + ":reassure";

    if(
      action.indexOf("exit") !== 0 &&
      action.indexOf("merge") !== 0 &&
      action.indexOf("keep_") !== 0
    ){
      return;
    }

    if(
      slxV2G.lastReassureKey === key &&
      nowMs() - slxV2G.lastReassureAt <
        SLX_V2G_TRUST.reassureCooldownMs
    ){
      return;
    }

    slxV2G.lastReassureKey = key;
    slxV2G.lastReassureAt = nowMs();

    slxV2GQueueSpeech(
      road ? "Good. Continue on " + road : "Good. Continue on route",
      "maneuver",
      90
    );
  },SLX_V2G_TRUST.reassureDelayMs);
}

function slxV2GSpeechPriority(kind,priority){
  if(isFiniteNumber(Number(priority))){ return Number(priority); }
  if(kind === "maneuver"){ return 100; }
  if(kind === "arrival"){ return 95; }
  if(kind === "reroute"){ return 90; }
  if(kind === "safety"){ return 85; }
  if(kind === "scan"){ return 45; }
  return 20;
}

function slxV2GRunSpeechQueue(){
  var item;
  var utterance;
  var voice;

  if(slxV2G.speechBusy || !slxV2G.speechQueue.length){ return; }
  if(!window.speechSynthesis){ return; }

  item = slxV2G.speechQueue.shift();
  slxV2G.speechBusy = true;
  slxV2G.speechCurrent = item;

  try{
    installVoiceLoader();
    voice = pickVoice();
    utterance = new SpeechSynthesisUtterance(item.text);

    if(voice){ utterance.voice = voice; }

    utterance.rate = item.kind === "maneuver" ? 0.96 : 0.94;
    utterance.pitch = 1;
    utterance.volume = 1;

    utterance.onend = function(){
      slxV2G.speechBusy = false;
      slxV2G.speechCurrent = null;
      window.setTimeout(slxV2GRunSpeechQueue,280);
    };

    utterance.onerror = function(){
      slxV2G.speechBusy = false;
      slxV2G.speechCurrent = null;
      window.setTimeout(slxV2GRunSpeechQueue,280);
    };

    window.__SLX_FOUNDATION_SPEAK__(utterance);
  }catch(e){
    slxV2G.speechBusy = false;
    slxV2G.speechCurrent = null;
  }
}

function slxV2GQueueSpeech(text,kind,priority){
  var line = slxV2GNorm(text);
  var p = slxV2GSpeechPriority(kind,priority);
  var key;
  var i;

  if(!speechEnabled || !line){ return false; }

  key = slxV2GLower(line);

  if(
    key === slxV2GLower(lastSpokenText) &&
    nowMs() - Number(lastSpokenAt || 0) <
      SLX_V2G_TRUST.voiceDuplicateMs
  ){
    return false;
  }

  for(i = 0; i < slxV2G.speechQueue.length; i += 1){
    if(slxV2GLower(slxV2G.speechQueue[i].text) === key){
      return false;
    }
  }

  /*
    A maneuver within the near zone owns voice. Non-safety intelligence
    waits instead of canceling or speaking over the turn.
  */
  if(kind !== "maneuver" && kind !== "arrival" && kind !== "reroute"){
    try{
      var active = maneuverSteps && maneuverSteps[maneuverIndex];
      var remain = active ? slxNavV2RemainingToStep(active) : null;

      if(isFiniteNumber(remain) && remain <= 0.35){
        return false;
      }
    }catch(e0){}
  }

  lastSpokenText = line;
  lastSpokenAt = nowMs();

  slxV2G.speechQueue.push({
    text:line,
    kind:kind || "info",
    priority:p,
    at:nowMs()
  });

  slxV2G.speechQueue.sort(function(a,b){
    if(b.priority !== a.priority){ return b.priority - a.priority; }
    return a.at - b.at;
  });

  slxV2GRunSpeechQueue();
  return true;
}

/*
  One clean voice authority replaces the duplicate Semi speech definitions.
  Existing callers remain compatible, but maneuver calls receive priority.
*/
speak = function(msg){
  return slxV2GQueueSpeech(msg,"info",20);
};

primeVoiceThenSpeak = function(msg){
  primeSpeechChannel();
  return slxV2GQueueSpeech(msg,"info",20);
};

window.slxSpeak = speak;
window.slxPrimeVoiceThenSpeak = primeVoiceThenSpeak;

function slxV2GMaybeSpeakManeuver(){
  var step;
  var remain;
  var bucket;
  var key;
  var line;

  if(!tripStarted || !routeGeo || !currentFix){ return; }
  if(slxTrustArrivalHardSuppress()){ return; }
  if(!slxV2GMovementReady()){ return; }

  step = maneuverSteps && maneuverSteps[maneuverIndex];

  if(!step || !slxNavV2cCanShowTurn(step)){ return; }

  remain = slxNavV2RemainingToStep(step);
  bucket = slxV2GBucket(step,remain);

  if(!bucket){ return; }

  key = slxV2GStepKey(step,maneuverIndex) + ":" + bucket;

  if(slxV2G.spokenBuckets[key]){ return; }

  line = slxV2GVoiceLine(step,bucket,remain);

  if(!line){ return; }

  if(slxV2GQueueSpeech(line,"maneuver",100)){
    slxV2G.spokenBuckets[key] = nowMs();
    maneuverLastSpokenIndex = maneuverIndex;
    maneuverLastDistanceBucket = bucket;
    slxV2G.lastVoiceKey = key;
    slxV2G.lastVoiceAt = nowMs();
  }
}

function slxV2GCardCopy(step,remain){
  var action = slxV2GAction(step);
  var road = slxV2GRoadName(step);
  var main = "";
  var sub = slxNavV2FmtDistance(remain);

  if(action === "left"){ main = "Turn left"; }
  else if(action === "right"){ main = "Turn right"; }
  else if(action === "slight_left"){ main = "Bear left"; }
  else if(action === "slight_right"){ main = "Bear right"; }
  else if(action === "keep_left"){ main = "Keep left"; }
  else if(action === "keep_right"){ main = "Keep right"; }
  else if(action === "exit_left"){ main = "Take left exit"; }
  else if(action === "exit_right"){ main = "Take exit"; }
  else if(action === "merge_left"){ main = "Merge left"; }
  else if(action === "merge_right"){ main = "Merge"; }
  else if(action === "roundabout"){ main = "Roundabout"; }
  else if(action === "uturn"){ main = "Make U-turn"; }
  else if(action === "arrive"){ main = "Final approach"; }
  else { main = "Continue"; }

  if(road){
    sub += (sub ? " • " : "") + road;
  }else{
    sub += (sub ? " • " : "") + slxNavV2InstructionText(step);
  }

  return {
    main:main,
    sub:sub,
    icon:slxNavV2Classify(slxNavV2InstructionText(step)).icon
  };
}

function slxV2GUpdateCard(){
  var card;
  var arrow;
  var main;
  var sub;
  var step;
  var remain;
  var copy;
  var arrivalMiles;

  card = slxNavV2EnsureCard();

  if(!tripStarted){ return; }

  arrow = byId("slxDriveIqTurnArrow");
  main = byId("slxDriveIqTurnMain");
  sub = byId("slxDriveIqTurnSub");

  try{
    arrivalMiles = distanceToDestinationMiles();

    if(
      isFiniteNumber(arrivalMiles) &&
      arrivalMiles <= 0.30 &&
      (!maneuverSteps ||
       maneuverIndex >= maneuverSteps.length ||
       slxV2GAction(maneuverSteps[maneuverIndex]) === "arrive")
    ){
      slxNavV2ApplyCardMode("arrival");
      if(arrow){ arrow.textContent = "Ã°Å¸ÂÂ"; }
      if(main){ main.textContent = "FINAL APPROACH"; }
      if(sub){
        sub.textContent = arrivalMiles <= 0.08 ?
          "Verify truck entrance • receiving • guard shack" :
          "Facility ahead • watch for truck entrance";
      }
      setSignalText("slxSigTurn","Final Approach IQ");
      return;
    }
  }catch(e0){}

  step = maneuverSteps && maneuverSteps[maneuverIndex];

  if(!step || !slxNavV2cCanShowTurn(step)){
    slxNavV2ApplyCardMode("idle");
    if(arrow){ arrow.textContent = "\u2191"; }
    if(main){
      main.textContent = slxV2GMovementReady() ?
        "Stay on route" :
        "GPS locked • waiting";
    }
    if(sub){
      sub.textContent = slxV2GMovementReady() ?
        "Watching next maneuver" :
        "Guidance begins with movement";
    }
    setSignalText(
      "slxSigTurn",
      slxV2GMovementReady() ?
        "Next turn standby" :
        "Waiting for movement"
    );
    return;
  }

  remain = slxNavV2RemainingToStep(step);
  copy = slxV2GCardCopy(step,remain);

  slxNavV2ApplyCardMode("move");
  arrow = byId("slxDriveIqTurnArrow");
  main = byId("slxDriveIqTurnMain");
  sub = byId("slxDriveIqTurnSub");

  if(arrow){ arrow.textContent = copy.icon; }
  if(main){ main.textContent = copy.main; }
  if(sub){ sub.textContent = copy.sub; }

  setSignalText(
    "slxSigTurn",
    copy.main + (copy.sub ? " • " + copy.sub : "")
  );
}

function slxV2GTick(){
  try{ slxWireTurnHidePillAuthority(); }catch(e0){}
  try{
    maybeRebuildManeuvers();

    if(maneuverSteps && maneuverSteps.length){
      if(
        !slxV2G.activeKey ||
        slxV2G.activeIndex !== maneuverIndex
      ){
        slxV2GResetActive(
          maneuverSteps[maneuverIndex],
          maneuverIndex
        );
      }

      slxV2GAdvanceAuthority();
    }
  }catch(e1){}

  try{ slxV2GUpdateCard(); }catch(e2){}
  try{ slxV2GMaybeSpeakManeuver(); }catch(e3){}
}

/*
  Disable the prior distance-only maneuver voice/advance path.
  All existing timers now resolve to this V2G authority.
*/
advancePastBehindManeuvers = function(){
  slxV2GAdvanceAuthority();
};

maybeSpeakNextManeuver = function(){
  slxV2GMaybeSpeakManeuver();
};

slxNavV2ActiveStep = function(){
  maybeRebuildManeuvers();
  slxV2GAdvanceAuthority();

  if(!maneuverSteps || !maneuverSteps.length){ return null; }
  if(maneuverIndex >= maneuverSteps.length){ return null; }

  try{
    window.maneuverSteps = maneuverSteps;
    window.SLX_ROUTE_STEPS = maneuverSteps;
    window.maneuverIndex = maneuverIndex;
    window.SLX_ACTIVE_STEP = maneuverSteps[maneuverIndex];
    window.nextStep = maneuverSteps[maneuverIndex];
  }catch(e){}

  return maneuverSteps[maneuverIndex];
};

slxNavV2UpdateCard = slxV2GUpdateCard;
slxNavV2Tick = slxV2GTick;

window.slxNavCoreV2 = {
  rebuild:function(){
    buildManeuverSteps();
    slxV2G.activeKey = "";
    slxV2G.spokenBuckets = {};
    slxV2GTick();
  },
  tick:slxV2GTick,
  active:function(){
    return slxNavV2ActiveStep();
  },
  status:function(){
    return {
      build:"V2G_DRIVER_TRUST_MANEUVER_AUTHORITY",
      movementUnlocked:slxV2G.movementUnlocked,
      activeIndex:maneuverIndex,
      activeKey:slxV2G.activeKey,
      minDistanceMiles:slxV2G.minDistanceMiles,
      enteredDecisionZone:slxV2G.enteredDecisionZone,
      lastCompletedKey:slxV2G.lastCompletedKey,
      lastVoiceKey:slxV2G.lastVoiceKey,
      speechBusy:slxV2G.speechBusy,
      speechQueueLength:slxV2G.speechQueue.length
    };
  }
};

window.setInterval(function(){
  try{ slxV2GTick(); }catch(e){}
},500);

try{
  console.log("Ã¢Å“â€¦ Semi Locator V2G Driver Trust Maneuver Authority loaded");
}catch(eLog){}


/* ========================================================================
   SEMI LOCATOR V3 — SHARED NAVIGATION CORE / TRUCK TRUST INTEGRATION
   - Drive IQ-derived maneuver and voice authority
   - Earlier interstate/exit commitment timing for heavy trucks
   - Exit-number, highway, ramp, and street-name priority
   - Navigation speech outranks noncritical truck intelligence
   - Truthful arrival lock: proximity + route progress + low speed + dwell
   - Calmer route rendering with a thinner active line and restrained glow
   - No fabricated fallback stop pins
======================================================================== */

window.__SLX_NAVIGATION_CORE_V3__ = true;
window.__SLX_DRIVER_DASHBOARD_POLISH_VERSION__ = "V3_SHARED_NAV_CORE_TRUCK_TRUST";

/* Heavy trucks need more time to commit to lanes and exits. */
SLX_V2G_TRUST.highwayEarlyMiles = 2.25;
SLX_V2G_TRUST.ordinaryEarlyMiles = 1.20;
SLX_V2G_TRUST.halfMiles = 0.62;
SLX_V2G_TRUST.nearMiles = 0.21;
SLX_V2G_TRUST.nowMiles = 0.045;
SLX_V2G_TRUST.denseNowMiles = 0.032;
SLX_V2G_TRUST.enterDecisionMiles = 0.19;
SLX_V2G_TRUST.completionNearMiles = 0.040;
SLX_V2G_TRUST.completionBeyondMiles = 0.040;
SLX_V2G_TRUST.completionDwellMs = 1150;
SLX_V2G_TRUST.denseCompletionDwellMs = 1550;

function slxV3ExitNumber(step){
  var values = [];
  var i;
  var value;
  var match;

  if(!step){ return ""; }

  values.push(
    step.exit,
    step.exitNumber,
    step.exit_number,
    step.ref,
    step.name,
    step.instruction,
    step.announceLabel,
    step.maneuver && step.maneuver.exit,
    step.maneuver && step.maneuver.exitNumber,
    step.bannerInstruction && step.bannerInstruction.primary && step.bannerInstruction.primary.text
  );

  for(i = 0; i < values.length; i += 1){
    value = slxV2GNorm(values[i]);
    if(!value){ continue; }
    match = value.match(/\bexit\s+([0-9]{1,4}[A-Z]?)\b/i);
    if(match && match[1]){ return String(match[1]).toUpperCase(); }
  }

  return "";
}

function slxV3RouteProgress(){
  var coords = getRouteCoords();
  var projection;
  var traveled;
  var total;

  if(!coords || coords.length < 2){ return 0; }

  projection = slxNavV2Projection();
  if(!projection){ return 0; }

  traveled = slxNavV2CumulativeMilesToProjection(coords,projection);
  total = slxNavV2CumulativeMilesToIndex(coords,coords.length - 1);

  if(!isFiniteNumber(traveled) || !isFiniteNumber(total) || total <= 0){ return 0; }
  return clamp(traveled / total,0,1);
}

var slxV3Arrival = {
  slowSince:0,
  announced:false,
  arrived:false
};

function slxV3MeaningfulManeuverAhead(){
  var step = maneuverSteps && maneuverSteps[maneuverIndex];
  var remain;
  var action;

  if(!step){ return false; }
  action = slxV2GAction(step);
  if(action === "arrive"){ return false; }
  remain = slxNavV2RemainingToStep(step);
  return isFiniteNumber(remain) && remain > 0.025;
}

function slxV3ArrivalTruth(){
  var dist = distanceToDestinationMiles();
  var mph = getSpeedMph();
  var progress = slxV3RouteProgress();
  var now = nowMs();

  if(!tripStarted || !routeGeo || !currentFix){
    slxV3Arrival.slowSince = 0;
    return false;
  }

  if(!isFiniteNumber(mph)){ mph = 0; }

  if(isFiniteNumber(dist) && dist <= 0.060 && mph <= 4.5){
    if(!slxV3Arrival.slowSince){ slxV3Arrival.slowSince = now; }
  }else{
    slxV3Arrival.slowSince = 0;
  }

  return isFiniteNumber(dist) &&
    dist <= 0.060 &&
    progress >= 0.94 &&
    mph <= 4.5 &&
    slxV3Arrival.slowSince > 0 &&
    now - slxV3Arrival.slowSince >= 8000 &&
    !slxV3MeaningfulManeuverAhead();
}

var slxV3OriginalVoiceLine = slxV2GVoiceLine;
slxV2GVoiceLine = function(step,bucket,remain){
  var action = slxV2GAction(step);
  var road = slxV2GRoadName(step);
  var exitNo = slxV3ExitNumber(step);
  var base = slxV2GBuildInstruction(step);
  var line = slxV3OriginalVoiceLine(step,bucket,remain);

  if(action.indexOf("exit") === 0){
    if(exitNo){
      base = "Take exit " + exitNo + (road ? " toward " + road : "");
    }else{
      base = "Take the exit" + (road ? " toward " + road : "");
    }

    if(bucket === "COMMIT"){
      return slxV2GNorm(
        (exitNo ? "Exit " + exitNo : "Exit decision") +
        " in about two miles. Begin moving into the " +
        (action === "exit_left" ? "left" : "right") +
        " lanes" + (road ? " for " + road : "")
      );
    }
    if(bucket === "EARLY"){ return slxV2GNorm(base + " in about one mile"); }
    if(bucket === "HALF"){ return slxV2GNorm(base + " in about half a mile. Stay committed"); }
    if(bucket === "NEAR"){ return slxV2GNorm(base + " in about eight hundred feet. Hold your lane"); }
    if(bucket === "NOW"){ return slxV2GNorm(base + " now"); }
  }

  if((action === "keep_left" || action === "keep_right") && bucket === "COMMIT"){
    return slxV2GNorm(
      "Lane commitment ahead in about two miles. Keep " +
      (action === "keep_left" ? "left" : "right") +
      (road ? " for " + road : "")
    );
  }

  return line;
};

/* Navigation always owns the audio lane near a maneuver. */
var slxV3OriginalQueueSpeech = slxV2GQueueSpeech;
slxV2GQueueSpeech = function(text,kind,priority){
  var line = slxV2GLower(text);
  var active;
  var remain;

  if((line.indexOf("you have arrived") >= 0 || line.indexOf("you've arrived") >= 0) && !slxV3ArrivalTruth()){
    return false;
  }

  try{
    active = maneuverSteps && maneuverSteps[maneuverIndex];
    remain = active ? slxNavV2RemainingToStep(active) : null;
  }catch(e){ remain = null; }

  if(kind !== "maneuver" && kind !== "arrival" && kind !== "reroute" && kind !== "safety"){
    if(isFiniteNumber(remain) && remain <= 0.60){ return false; }
  }

  return slxV3OriginalQueueSpeech(text,kind,priority);
};

speak = function(msg){
  return slxV2GQueueSpeech(msg,"info",20);
};

primeVoiceThenSpeak = function(msg){
  primeSpeechChannel();
  return slxV2GQueueSpeech(msg,"info",20);
};

window.slxSpeak = speak;
window.slxPrimeVoiceThenSpeak = primeVoiceThenSpeak;

function slxV3ApplyRouteStyle(){
  var m = map || window.map;
  var glowLayers = ["route-glow","slx-route-glow","slxDriverRouteGlow","slxDriverRouteAura"];
  var lineLayers = ["route-line","slx-route-line","slxDriverRouteLine"];
  var i;

  if(!m || !m.getLayer || !m.setPaintProperty){ return; }

  for(i = 0; i < glowLayers.length; i += 1){
    try{
      if(m.getLayer(glowLayers[i])){
        m.setPaintProperty(glowLayers[i],"line-width",10);
        m.setPaintProperty(glowLayers[i],"line-opacity",0.14);
      }
    }catch(e0){}
  }

  for(i = 0; i < lineLayers.length; i += 1){
    try{
      if(m.getLayer(lineLayers[i])){
        m.setPaintProperty(lineLayers[i],"line-width",5);
        m.setPaintProperty(lineLayers[i],"line-opacity",0.98);
      }
    }catch(e1){}
  }
}

/* Replace fabricated fallback pins with an honest zero-state. */
function slxV3BindTruthfulScanStops(){
  var btn = document.getElementById("btnScanStops");
  if(!btn || btn.__slxV3TruthBound){ return; }

  btn.__slxV3TruthBound = true;
  btn.onclick = function(e){
    if(e && e.preventDefault){ e.preventDefault(); }
    if(e && e.stopPropagation){ e.stopPropagation(); }

    if(typeof window.slxScanCorridorStops === "function"){
      try{ window.slxScanCorridorStops(); return false; }catch(scanErr){}
    }

    try{
      if(map && map.getSource && map.getSource("slxCorridorStops")){
        map.getSource("slxCorridorStops").setData({type:"FeatureCollection",features:[]});
      }
    }catch(clearErr){}

    try{ toast("Verified truck stops are unavailable right now"); }
    catch(toastErr){ setSubline("Verified truck stops unavailable"); }
    return false;
  };
}

var slxV3OldTick = slxV2GTick;
slxV2GTick = function(){
  slxV3OldTick();
  slxV3ApplyRouteStyle();
  slxV3BindTruthfulScanStops();

  if(slxV3ArrivalTruth() && !slxV3Arrival.announced){
    slxV3Arrival.announced = true;
    slxV3Arrival.arrived = true;
    arrivalVoiceAnnounced = true;
    slxV2GQueueSpeech("You have arrived. Verify the truck entrance, guard shack, and receiving instructions.","arrival",110);
  }
};

slxNavV2Tick = slxV2GTick;
window.setInterval(function(){
  try{ slxV3ApplyRouteStyle(); slxV3BindTruthfulScanStops(); }catch(e){}
},1200);

try{
  console.log("Ã¢Å“â€¦ Semi Locator V3 Shared Navigation Core / Truck Trust loaded");
}catch(eLogV3){}


/* ========================================================================
   SEMI LOCATOR V3.1 — INTERSTATE / EXIT / ROAD NAME AUTHORITY
   POLISH UPGRADE

   PRIORITY:
   1. Interstate forks and splits
   2. Numbered highway exits
   3. Lane commitment
   4. Highway number + direction + signed destination
   5. Verified local street / road name

   This patch keeps the stable V3 navigation core and truck intelligence.
   It strengthens the maneuver data model, timing, voice, and turn card.
======================================================================== */

window.__SLX_V31_INTERSTATE_AUTHORITY__ = true;
window.__SLX_DRIVER_DASHBOARD_POLISH_VERSION__ =
  "V3.1_INTERSTATE_EXIT_ROAD_NAME_AUTHORITY";

function slxV31Text(value){
  return String(value == null ? "" : value).replace(/\s+/g," ").trim();
}

function slxV31RawStep(step){
  return step && step.rawStep ? step.rawStep : step;
}

function slxV31Candidate(step,path){
  var raw = slxV31RawStep(step);
  var node = raw;
  var i;
  try{
    for(i = 0; i < path.length; i += 1){
      if(node == null){ return ""; }
      node = node[path[i]];
    }
    return slxV31Text(node);
  }catch(e){}
  return "";
}

function slxV31First(values){
  var i;
  var v;
  for(i = 0; i < values.length; i += 1){
    v = slxV31Text(values[i]);
    if(v){ return v; }
  }
  return "";
}

function slxV31Instruction(step){
  var raw = slxV31RawStep(step);
  return slxV31First([
    step && step.instruction,
    step && step.announceLabel,
    raw && raw.maneuver && raw.maneuver.instruction,
    raw && raw.voiceInstruction,
    raw && raw.instruction,
    raw && raw.bannerInstruction && raw.bannerInstruction.primary && raw.bannerInstruction.primary.text,
    raw && raw.banner_instruction && raw.banner_instruction.primary && raw.banner_instruction.primary.text
  ]);
}

function slxV31NormalizeRouteRef(value){
  var s = slxV31Text(value);
  if(!s){ return ""; }
  s = s
    .replace(/\bInterstate\s+(\d{1,3}[A-Z]?)\b/ig,"I-$1")
    .replace(/\bI\s+(\d{1,3}[A-Z]?)\b/ig,"I-$1")
    .replace(/\bUS\s+(\d{1,3}[A-Z]?)\b/ig,"US-$1")
    .replace(/\bU\.S\.\s*(\d{1,3}[A-Z]?)\b/ig,"US-$1")
    .replace(/\bSR\s+(\d{1,3}[A-Z]?)\b/ig,"SR-$1")
    .replace(/\s+/g," ")
    .trim();
  return s;
}

function slxV31ExitNumber(step){
  var raw = slxV31RawStep(step);
  var text = slxV31Instruction(step);
  var value = slxV31First([
    raw && raw.exit,
    raw && raw.exitNumber,
    raw && raw.exit_number,
    raw && raw.maneuver && raw.maneuver.exit,
    raw && raw.maneuver && raw.maneuver.exitNumber,
    raw && raw.maneuver && raw.maneuver.exit_number,
    raw && raw.bannerInstruction && raw.bannerInstruction.primary && raw.bannerInstruction.primary.exitNumber,
    raw && raw.banner_instruction && raw.banner_instruction.primary && raw.banner_instruction.primary.exit_number
  ]);
  var m;

  if(value){
    m = value.match(/(?:exit\s*)?([0-9]{1,4}[A-Z]?)/i);
    if(m && m[1]){ return String(m[1]).toUpperCase(); }
  }

  m = text.match(/\bexit\s+(?:number\s+)?([0-9]{1,4}[A-Z]?)\b/i);
  return m && m[1] ? String(m[1]).toUpperCase() : "";
}

function slxV31RouteRef(step){
  var raw = slxV31RawStep(step);
  var text = slxV31Instruction(step);
  var value = slxV31First([
    raw && raw.ref,
    raw && raw.route,
    raw && raw.routeRef,
    raw && raw.route_ref,
    raw && raw.maneuver && raw.maneuver.ref,
    raw && raw.maneuver && raw.maneuver.route,
    raw && raw.bannerInstruction && raw.bannerInstruction.primary && raw.bannerInstruction.primary.ref
  ]);
  var m;

  value = slxV31NormalizeRouteRef(value);
  if(value && /\b(?:I-|US-|SR-|Highway|Hwy|Route)\s*\d/i.test(value)){ return value; }

  m = text.match(/\b(I[-\s]?\d{1,3}[A-Z]?|US[-\s]?\d{1,3}[A-Z]?|U\.S\.\s*\d{1,3}[A-Z]?|SR[-\s]?\d{1,3}[A-Z]?|State Route\s+\d{1,3}[A-Z]?|Highway\s+\d{1,3}[A-Z]?|Hwy\s+\d{1,3}[A-Z]?)\b/i);
  return m && m[1] ? slxV31NormalizeRouteRef(m[1]) : "";
}

function slxV31Direction(step){
  var text = slxV31Instruction(step);
  var raw = slxV31RawStep(step);
  var value = slxV31First([
    raw && raw.direction,
    raw && raw.cardinalDirection,
    raw && raw.cardinal_direction,
    raw && raw.maneuver && raw.maneuver.direction
  ]);
  var m;

  if(/^(north|south|east|west|northbound|southbound|eastbound|westbound)$/i.test(value)){
    return value.replace(/bound$/i,"").replace(/^./,function(c){ return c.toUpperCase(); });
  }

  m = text.match(/\b(northbound|southbound|eastbound|westbound|north|south|east|west)\b/i);
  if(!m){ return ""; }
  return m[1].replace(/bound$/i,"").replace(/^./,function(c){ return c.toUpperCase(); });
}

function slxV31Destination(step){
  var raw = slxV31RawStep(step);
  var text = slxV31Instruction(step);
  var value = slxV31First([
    raw && raw.destination,
    raw && raw.destinations,
    raw && raw.signDestination,
    raw && raw.sign_destination,
    raw && raw.maneuver && raw.maneuver.destination,
    raw && raw.maneuver && raw.maneuver.destinations,
    raw && raw.bannerInstruction && raw.bannerInstruction.primary && raw.bannerInstruction.primary.destination
  ]);
  var m;

  if(value && !/^(left|right|straight|exit|fork|merge)$/i.test(value)){ return value; }

  m = text.match(/\b(?:toward|towards)\s+(.+?)(?:[.,;]|$)/i);
  if(m && m[1]){ return slxV31Text(m[1]); }
  return "";
}

function slxV31StreetName(step){
  var raw = slxV31RawStep(step);
  var text = slxV31Instruction(step);
  var value = slxV31First([
    raw && raw.name,
    raw && raw.roadName,
    raw && raw.road_name,
    raw && raw.road,
    raw && raw.street,
    raw && raw.maneuver && raw.maneuver.name,
    raw && raw.maneuver && raw.maneuver.roadName,
    raw && raw.maneuver && raw.maneuver.road
  ]);
  var m;

  if(value && !/^(left|right|straight|continue|merge|exit|fork)$/i.test(value)){
    return slxV31NormalizeRouteRef(value);
  }

  m = text.match(/\b(?:onto|on|for|to|via)\s+(.+?)(?:\s+toward\s+|\s+in\s+(?:about\s+)?\d|[.,;]|$)/i);
  if(m && m[1]){ return slxV31NormalizeRouteRef(m[1]); }
  return "";
}

function slxV31HighwayIdentity(step){
  var ref = slxV31RouteRef(step);
  var direction = slxV31Direction(step);
  if(!ref){ return ""; }
  if(direction && ref.toLowerCase().indexOf(direction.toLowerCase()) < 0){
    return ref + " " + direction;
  }
  return ref;
}

function slxV31RoadIdentity(step){
  return slxV31HighwayIdentity(step) || slxV31StreetName(step) || slxV31Destination(step);
}

function slxV31IsFork(step){
  var raw = slxV31RawStep(step);
  var text = slxV31Instruction(step).toLowerCase();
  var type = slxV31First([
    raw && raw.type,
    raw && raw.maneuver && raw.maneuver.type
  ]).toLowerCase();

  return type.indexOf("fork") >= 0 ||
    text.indexOf("fork") >= 0 ||
    text.indexOf("interstate split") >= 0 ||
    text.indexOf("freeway split") >= 0 ||
    text.indexOf("highway split") >= 0 ||
    text.indexOf("keep left to stay") >= 0 ||
    text.indexOf("keep right to stay") >= 0;
}

function slxV31ForkSide(step){
  var action = slxV2GAction(step);
  var text = slxV31Instruction(step).toLowerCase();
  if(action === "keep_left" || text.indexOf("left") >= 0){ return "left"; }
  if(action === "keep_right" || text.indexOf("right") >= 0){ return "right"; }
  return "";
}

function slxV31IsExit(step){
  var action = slxV2GAction(step);
  return action.indexOf("exit") === 0 || !!slxV31ExitNumber(step);
}

/* Preserve provider maneuver metadata instead of reducing every step to text. */
buildManeuverSteps = function(){
  var i;
  var source;
  var loc;
  var instruction;
  var lower;
  var meaningful;

  resetManeuverState();
  maneuverLastBuildAt = nowMs();

  if(!routeSteps || !routeSteps.length){ routeSteps = loadRouteStepsFromStorage(); }
  if(!routeSteps || !routeSteps.length){ return; }

  for(i = 0; i < routeSteps.length; i += 1){
    source = routeSteps[i];
    loc = getRouteStepLocation(source);
    if(!loc){ continue; }

    instruction = getStepInstruction(source);
    lower = String(instruction || "").toLowerCase();

    meaningful =
      lower.indexOf("turn") >= 0 ||
      lower.indexOf("left") >= 0 ||
      lower.indexOf("right") >= 0 ||
      lower.indexOf("exit") >= 0 ||
      lower.indexOf("ramp") >= 0 ||
      lower.indexOf("merge") >= 0 ||
      lower.indexOf("fork") >= 0 ||
      lower.indexOf("split") >= 0 ||
      lower.indexOf("keep") >= 0 ||
      lower.indexOf("arrive") >= 0 ||
      lower.indexOf("destination") >= 0 ||
      lower.indexOf("continue onto") >= 0 ||
      lower.indexOf("road becomes") >= 0;

    if(!meaningful){ continue; }

    maneuverSteps.push({
      coord:loc,
      instruction:instruction,
      announceLabel:instruction,
      originalIndex:i,
      rawStep:source,
      name:source.name,
      road:source.road,
      roadName:source.roadName || source.road_name,
      ref:source.ref,
      route:source.route,
      destination:source.destination,
      destinations:source.destinations,
      exit:source.exit,
      exitNumber:source.exitNumber || source.exit_number,
      maneuver:source.maneuver,
      bannerInstruction:source.bannerInstruction || source.banner_instruction,
      voiceInstruction:source.voiceInstruction || source.voice_instruction
    });
  }
};

/* Road Name Authority: prefer route number, direction, signed road, then provider text. */
var slxV31OldRoadName = slxV2GRoadName;
slxV2GRoadName = function(step){
  var identity = slxV31RoadIdentity(step);
  if(identity){ return identity; }
  return slxV31OldRoadName(step);
};

/* Truck timing: forks and exits announce earlier than ordinary maneuvers. */
var slxV31OldBucket = slxV2GBucket;
slxV2GBucket = function(step,remain){
  if(!isFiniteNumber(remain)){ return ""; }

  if(slxV31IsFork(step)){
    if(remain <= 0.060){ return "NOW"; }
    if(remain <= 0.22){ return "NEAR"; }
    if(remain <= 0.60){ return "HALF"; }
    if(remain <= 1.25){ return "EARLY"; }
    if(remain <= 2.10){ return "COMMIT"; }
    if(remain <= 3.10){ return "FAR"; }
    return "";
  }

  if(slxV31IsExit(step)){
    if(remain <= 0.060){ return "NOW"; }
    if(remain <= 0.22){ return "NEAR"; }
    if(remain <= 0.60){ return "HALF"; }
    if(remain <= 1.15){ return "EARLY"; }
    if(remain <= 2.15){ return "COMMIT"; }
    if(remain <= 2.75){ return "FAR"; }
    return "";
  }

  return slxV31OldBucket(step,remain);
};

function slxV31ExitBase(step){
  var exitNo = slxV31ExitNumber(step);
  var route = slxV31HighwayIdentity(step);
  var street = slxV31StreetName(step);
  var dest = slxV31Destination(step);
  var target = street || route;
  var line = exitNo ? "Take Exit " + exitNo : "Take the exit";

  if(target){ line += " for " + target; }
  if(dest && (!target || dest.toLowerCase() !== target.toLowerCase())){
    line += " toward " + dest;
  }
  return slxV31Text(line);
}

function slxV31ForkBase(step){
  var side = slxV31ForkSide(step);
  var route = slxV31HighwayIdentity(step);
  var street = slxV31StreetName(step);
  var dest = slxV31Destination(step);
  var target = route || street;
  var line = side ? "Keep " + side + " at the interstate fork" : "Interstate fork ahead";

  if(target){ line += " for " + target; }
  if(dest && (!target || dest.toLowerCase() !== target.toLowerCase())){
    line += " toward " + dest;
  }
  return slxV31Text(line);
}

function slxV31LocalBase(step){
  var action = slxV2GAction(step);
  var road = slxV31StreetName(step) || slxV31RoadIdentity(step);
  var base;

  if(action === "left"){ base = "Turn left"; }
  else if(action === "right"){ base = "Turn right"; }
  else if(action === "slight_left"){ base = "Bear left"; }
  else if(action === "slight_right"){ base = "Bear right"; }
  else if(action === "merge_left"){ base = "Merge left"; }
  else if(action === "merge_right"){ base = "Merge"; }
  else if(action === "keep_left"){ base = "Keep left"; }
  else if(action === "keep_right"){ base = "Keep right"; }
  else { base = slxV2GBuildInstruction(step); }

  if(road && base.toLowerCase().indexOf(road.toLowerCase()) < 0){
    if(action.indexOf("keep_") === 0){ base += " for " + road; }
    else if(action.indexOf("merge") === 0){ base += " onto " + road; }
    else{ base += " onto " + road; }
  }
  return slxV31Text(base);
}

/* Highest-consequence decisions get explicit, staged wording. */
var slxV31OldVoiceLine = slxV2GVoiceLine;
slxV2GVoiceLine = function(step,bucket,remain){
  var side;
  var base;
  var exitNo;

  if(slxV31IsFork(step)){
    side = slxV31ForkSide(step);
    base = slxV31ForkBase(step);

    if(bucket === "FAR"){
      return slxV31Text("Interstate split in about three miles. " + base);
    }
    if(bucket === "COMMIT"){
      return slxV31Text("Interstate split in about two miles. Begin moving " + (side || "into the correct lane") + " when safe. " + base);
    }
    if(bucket === "EARLY"){
      return slxV31Text("In about one mile, " + base + ". Stay committed");
    }
    if(bucket === "HALF"){
      return slxV31Text(base + " in about half a mile");
    }
    if(bucket === "NEAR"){
      return slxV31Text(base + ". Hold your lane");
    }
    if(bucket === "NOW"){
      return slxV31Text(base + " now");
    }
  }

  if(slxV31IsExit(step)){
    base = slxV31ExitBase(step);
    exitNo = slxV31ExitNumber(step);
    side = slxV2GAction(step) === "exit_left" ? "left" : "right";

    if(bucket === "FAR"){
      return slxV31Text((exitNo ? "Exit " + exitNo : "Your exit") + " in about two and a half miles. " + base);
    }
    if(bucket === "COMMIT"){
      return slxV31Text((exitNo ? "Exit " + exitNo : "Exit decision") + " in about two miles. Begin moving into the " + side + " lanes when safe");
    }
    if(bucket === "EARLY"){
      return slxV31Text(base + " in about one mile");
    }
    if(bucket === "HALF"){
      return slxV31Text(base + " in about half a mile. Stay in the " + side + " lane group");
    }
    if(bucket === "NEAR"){
      return slxV31Text(base + " in about eight hundred feet. Hold your lane");
    }
    if(bucket === "NOW"){
      return slxV31Text(base + " now");
    }
  }

  /* Ordinary turns keep the verified street name at every stage. */
  base = slxV31LocalBase(step);
  if(base && base !== "Continue"){
    if(bucket === "EARLY"){ return slxV31Text(base + " in about one mile"); }
    if(bucket === "HALF"){ return slxV31Text(base + " in about half a mile"); }
    if(bucket === "NEAR"){ return slxV31Text(base + " in about eight hundred feet"); }
    if(bucket === "NOW"){ return slxV31Text(base + " now"); }
  }

  return slxV31OldVoiceLine(step,bucket,remain);
};

/* Turn card makes exits and forks visually unmistakable. */
var slxV31OldCardCopy = slxV2GCardCopy;
slxV2GCardCopy = function(step,remain){
  var copy = slxV31OldCardCopy(step,remain);
  var exitNo = slxV31ExitNumber(step);
  var identity = slxV31RoadIdentity(step);
  var destination = slxV31Destination(step);
  var distance = slxNavV2FmtDistance(remain);
  var side;

  if(slxV31IsFork(step)){
    side = slxV31ForkSide(step);
    copy.main = side ? "INTERSTATE FORK • KEEP " + side.toUpperCase() : "INTERSTATE FORK";
    copy.sub = distance;
    if(identity){ copy.sub += (copy.sub ? " • " : "") + identity; }
    if(destination && (!identity || destination.toLowerCase() !== identity.toLowerCase())){
      copy.sub += (copy.sub ? " • " : "") + "Toward " + destination;
    }
    copy.icon = side === "left" ? "Ã¢â€ –" : side === "right" ? "Ã¢â€ —" : "Ã¢â€˜â€š";
    return copy;
  }

  if(slxV31IsExit(step)){
    copy.main = exitNo ? "EXIT " + exitNo : "HIGHWAY EXIT";
    copy.sub = distance;
    if(identity){ copy.sub += (copy.sub ? " • " : "") + identity; }
    if(destination && (!identity || destination.toLowerCase() !== identity.toLowerCase())){
      copy.sub += (copy.sub ? " • " : "") + "Toward " + destination;
    }
    copy.icon = slxV2GAction(step) === "exit_left" ? "Ã¢â€ –" : "Ã¢â€ —";
    return copy;
  }

  if(identity){
    copy.sub = distance + (distance ? " • " : "") + identity;
  }
  return copy;
};

/* Forks/exits retain audio authority over routine weather, parking and fuel. */
var slxV31OldQueueSpeech = slxV2GQueueSpeech;
slxV2GQueueSpeech = function(text,kind,priority){
  var active;
  var remain;
  var criticalDecision = false;

  try{
    active = maneuverSteps && maneuverSteps[maneuverIndex];
    remain = active ? slxNavV2RemainingToStep(active) : null;
    criticalDecision = active && (slxV31IsFork(active) || slxV31IsExit(active));
  }catch(e){ remain = null; }

  if(criticalDecision && kind !== "maneuver" && kind !== "arrival" && kind !== "reroute" && kind !== "safety"){
    if(isFiniteNumber(remain) && remain <= 2.15){ return false; }
  }

  return slxV31OldQueueSpeech(text,kind,priority);
};

speak = function(msg){
  return slxV2GQueueSpeech(msg,"info",20);
};

primeVoiceThenSpeak = function(msg){
  primeSpeechChannel();
  return slxV2GQueueSpeech(msg,"info",20);
};

window.slxSpeak = speak;
window.slxPrimeVoiceThenSpeak = primeVoiceThenSpeak;

/* Rebuild once so existing loaded routes gain the richer maneuver objects. */
try{
  maneuverSteps = [];
  buildManeuverSteps();
  if(maneuverSteps.length){ slxV2GResetActive(maneuverSteps[0],0); }
}catch(eV31Build){}

try{
  console.log("Ã¢Å“â€¦ Semi Locator V3.1 Interstate / Exit / Road Name Authority loaded");
}catch(eV31Log){}

})();
/* ========================================================================
   SEMI LOCATOR V3.2 — VOICE / MANEUVER / STREET NAME AUTHORITY
   POLISH UPGRADE

   LOCKED:
   - Preserve the stable V3 map, route, pin glide, snapping and follow camera.
   - Do not consume maneuver voice while parked or from ordinary GPS drift.
   - One committed maneuver owns card + voice until geometry confirms complete.
   - Verified street/highway/exit identity survives every formatter.
   - Forks and exits retain first audio priority.
   - Ordinary curve alerts do not lower Route Confidence.
   - Duplicate curve intelligence is suppressed.
======================================================================== */
(function(){
"use strict";

window.__SLX_V32_VOICE_MANEUVER_STREET_AUTHORITY__ = true;
window.__SLX_DRIVER_DASHBOARD_POLISH_VERSION__ =
  "V3.2_VOICE_MANEUVER_STREET_NAME_AUTHORITY";

var slxV32Move = {
  firstMovingAt:0,
  movingSamples:0,
  unlockedAt:0,
  resetForTrip:false
};

var slxV32SpeechWatch = {
  busySince:0,
  lastRecoveryAt:0
};

function slxV32Clean(value){
  return String(value == null ? "" : value)
    .replace(/\s+/g," ")
    .replace(/^\s+|\s+$/g,"");
}

function slxV32Raw(step){
  return step && step.rawStep ? step.rawStep : step || null;
}

function slxV32Push(out,value){
  var s = slxV32Clean(value);
  if(s){ out.push(s); }
}

function slxV32PushComponents(out,components){
  var i;
  var c;
  if(!components || !components.length){ return; }
  for(i = 0; i < components.length; i += 1){
    c = components[i] || {};
    slxV32Push(out,c.text);
    slxV32Push(out,c.abbreviation);
    slxV32Push(out,c.abbr);
  }
}

function slxV32ProviderCandidates(step){
  var raw = slxV32Raw(step);
  var out = [];
  var banner;
  var voice;

  slxV32Push(out,step && step.roadName);
  slxV32Push(out,step && step.road_name);
  slxV32Push(out,step && step.name);
  slxV32Push(out,step && step.road);
  slxV32Push(out,step && step.street);
  slxV32Push(out,step && step.ref);
  slxV32Push(out,step && step.route);
  slxV32Push(out,step && step.destination);
  slxV32Push(out,step && step.destinations);
  slxV32Push(out,step && step.voiceInstruction);
  slxV32Push(out,step && step.instruction);
  slxV32Push(out,step && step.announceLabel);

  if(raw){
    slxV32Push(out,raw.roadName);
    slxV32Push(out,raw.road_name);
    slxV32Push(out,raw.name);
    slxV32Push(out,raw.road);
    slxV32Push(out,raw.street);
    slxV32Push(out,raw.ref);
    slxV32Push(out,raw.route);
    slxV32Push(out,raw.destination);
    slxV32Push(out,raw.destinations);
    slxV32Push(out,raw.voiceInstruction);
    slxV32Push(out,raw.voice_instruction);
    slxV32Push(out,raw.instruction);

    if(raw.maneuver){
      slxV32Push(out,raw.maneuver.name);
      slxV32Push(out,raw.maneuver.roadName);
      slxV32Push(out,raw.maneuver.road_name);
      slxV32Push(out,raw.maneuver.road);
      slxV32Push(out,raw.maneuver.ref);
      slxV32Push(out,raw.maneuver.destination);
      slxV32Push(out,raw.maneuver.instruction);
    }

    banner = raw.bannerInstruction || raw.banner_instruction;
    if(banner){
      if(banner.primary){
        slxV32Push(out,banner.primary.text);
        slxV32PushComponents(out,banner.primary.components);
      }
      if(banner.secondary){
        slxV32Push(out,banner.secondary.text);
        slxV32PushComponents(out,banner.secondary.components);
      }
      if(banner.sub){
        slxV32Push(out,banner.sub.text);
        slxV32PushComponents(out,banner.sub.components);
      }
    }

    voice = raw.voiceInstructions || raw.voice_instructions;
    if(voice && voice.length){
      slxV32Push(out,voice[0] && voice[0].announcement);
      slxV32Push(out,voice[0] && voice[0].ssmlAnnouncement);
    }
  }

  return out;
}

function slxV32LooksGeneric(value){
  var s = slxV32Clean(value).toLowerCase();
  return !s ||
    /^(turn|turn left|turn right|left|right|straight|continue|merge|exit|take the exit|fork|keep left|keep right|arrive|destination)$/i.test(s);
}

function slxV32ExtractRoadFromText(value){
  var s = slxV32Clean(value);
  var m;
  if(!s){ return ""; }

  m = s.match(/\b(?:onto|on|for|toward|towards|via|to)\s+(.+?)(?:\s+(?:in|after)\s+(?:about\s+)?(?:\d|one|two|three|half)|[.,;]|$)/i);
  if(m && m[1]){
    return slxV31NormalizeRouteRef(slxV32Clean(m[1]));
  }

  m = s.match(/\b(I[-\s]?\d{1,3}[A-Z]?|US[-\s]?\d{1,3}[A-Z]?|U\.S\.\s*\d{1,3}[A-Z]?|SR[-\s]?\d{1,3}[A-Z]?|State Route\s+\d{1,3}[A-Z]?|Highway\s+\d{1,3}[A-Z]?|Hwy\s+\d{1,3}[A-Z]?)\b/i);
  if(m && m[1]){ return slxV31NormalizeRouteRef(m[1]); }

  return "";
}

function slxV32RoadIdentity(step){
  var candidates = slxV32ProviderCandidates(step);
  var i;
  var value;
  var extracted;
  var route = slxV31HighwayIdentity(step);

  if(route){ return route; }

  for(i = 0; i < candidates.length; i += 1){
    value = slxV32Clean(candidates[i]);
    if(slxV32LooksGeneric(value)){ continue; }

    extracted = slxV32ExtractRoadFromText(value);
    if(extracted){ return extracted; }

    if(/\b(Road|Rd|Street|St|Avenue|Ave|Boulevard|Blvd|Drive|Dr|Lane|Ln|Parkway|Pkwy|Highway|Hwy|Freeway|Expressway|Circle|Court|Ct|Trail|Trl|Way)\b/i.test(value)){
      return slxV31NormalizeRouteRef(value);
    }
  }

  return slxV31StreetName(step) || slxV31Destination(step) || "";
}

/* Stronger movement authority: GPS drift alone cannot consume the first turn. */
slxV2GMovementReady = function(){
  var mph = getSpeedMph();
  var fix = currentFix || rawFix;
  var moved = 0;
  var now = nowMs();

  if(slxV2G.movementUnlocked){ return true; }
  if(!tripStarted || !fix){ return false; }

  if(!slxV2G.originFix){
    slxV2G.originFix = {
      lng:Number(fix.lng),
      lat:Number(fix.lat),
      at:now
    };
    slxV32Move.firstMovingAt = 0;
    slxV32Move.movingSamples = 0;
    return false;
  }

  moved = milesBetween(
    [slxV2G.originFix.lng,slxV2G.originFix.lat],
    [Number(fix.lng),Number(fix.lat)]
  );

  if(mph >= 4.5){
    if(!slxV32Move.firstMovingAt){ slxV32Move.firstMovingAt = now; }
    slxV32Move.movingSamples += 1;
  }else if(mph >= 2.5 && moved >= 0.025){
    if(!slxV32Move.firstMovingAt){ slxV32Move.firstMovingAt = now; }
    slxV32Move.movingSamples += 1;
  }else{
    slxV32Move.firstMovingAt = 0;
    slxV32Move.movingSamples = 0;
  }

  if(
    (slxV32Move.movingSamples >= 3 && now - slxV32Move.firstMovingAt >= 1200) ||
    (moved >= 0.040 && mph >= 2.5)
  ){
    slxV2G.movementUnlocked = true;
    slxV2G.movementUnlockedAt = now;
    slxV32Move.unlockedAt = now;

    /* Any accidental pre-movement bookkeeping is discarded. */
    slxV2G.spokenBuckets = {};
    maneuverLastSpokenIndex = -1;
    maneuverLastDistanceBucket = "";
    slxV2G.lastVoiceKey = "";
    return true;
  }

  return false;
};

/* Street identity becomes the single committed wording source for card + voice. */
slxV2GRoadName = function(step){
  return slxV32RoadIdentity(step);
};

function slxV32CommittedBase(step){
  var action = slxV2GAction(step);
  var road = slxV32RoadIdentity(step);
  var exitNo = slxV31ExitNumber(step);
  var destination = slxV31Destination(step);
  var line;

  if(slxV31IsFork(step)){
    return slxV31ForkBase(step);
  }

  if(slxV31IsExit(step)){
    return slxV31ExitBase(step);
  }

  if(action === "left"){ line = "Turn left"; }
  else if(action === "right"){ line = "Turn right"; }
  else if(action === "slight_left"){ line = "Bear left"; }
  else if(action === "slight_right"){ line = "Bear right"; }
  else if(action === "keep_left"){ line = "Keep left"; }
  else if(action === "keep_right"){ line = "Keep right"; }
  else if(action === "merge_left"){ line = "Merge left"; }
  else if(action === "merge_right"){ line = "Merge"; }
  else if(action === "transition"){ line = "Continue"; }
  else if(action === "arrive"){ line = "Approach the destination"; }
  else{ line = slxV31Instruction(step) || "Continue"; }

  if(road && line.toLowerCase().indexOf(road.toLowerCase()) < 0){
    if(action.indexOf("keep_") === 0){ line += " for " + road; }
    else if(action === "transition"){ line += " on " + road; }
    else if(action === "arrive"){}
    else{ line += " onto " + road; }
  }

  if(exitNo && line.toLowerCase().indexOf("exit") < 0){
    line = "Take Exit " + exitNo + (road ? " for " + road : "");
  }

  if(destination && line.toLowerCase().indexOf(destination.toLowerCase()) < 0 && slxV31IsFork(step)){
    line += " toward " + destination;
  }

  return slxV32Clean(line);
}

slxV2GBuildInstruction = function(step){
  return slxV32CommittedBase(step);
};

slxV2GVoiceLine = function(step,bucket,remain){
  var base = slxV32CommittedBase(step);
  var side;
  var exitNo;

  if(slxV31IsFork(step)){
    side = slxV31ForkSide(step);
    if(bucket === "FAR"){ return "Interstate split in about three miles. " + base; }
    if(bucket === "COMMIT"){ return "Interstate split in about two miles. Begin moving " + (side || "into the correct lane") + " when safe. " + base; }
    if(bucket === "EARLY"){ return "In about one mile, " + base; }
    if(bucket === "HALF"){ return base + " in about half a mile"; }
    if(bucket === "NEAR"){ return base + " in about eight hundred feet. Hold your lane"; }
    if(bucket === "NOW"){ return base + " now"; }
  }

  if(slxV31IsExit(step)){
    exitNo = slxV31ExitNumber(step);
    side = slxV2GAction(step) === "exit_left" ? "left" : "right";
    if(bucket === "FAR"){ return (exitNo ? "Exit " + exitNo : "Your exit") + " in about two and a half miles. " + base; }
    if(bucket === "COMMIT"){ return (exitNo ? "Exit " + exitNo : "Exit decision") + " in about two miles. Begin moving into the " + side + " lanes when safe"; }
    if(bucket === "EARLY"){ return base + " in about one mile"; }
    if(bucket === "HALF"){ return base + " in about half a mile. Stay in the " + side + " lane group"; }
    if(bucket === "NEAR"){ return base + " in about eight hundred feet. Hold your lane"; }
    if(bucket === "NOW"){ return base + " now"; }
  }

  if(bucket === "EARLY"){ return base + " in about one mile"; }
  if(bucket === "HALF"){ return base + " in about half a mile"; }
  if(bucket === "NEAR"){ return base + " in about eight hundred feet"; }
  if(bucket === "NOW"){ return base + " now"; }
  return "";
};

/* Card and voice share the exact same committed maneuver base. */
slxV2GCardCopy = function(step,remain){
  var action = slxV2GAction(step);
  var base = slxV32CommittedBase(step);
  var exitNo = slxV31ExitNumber(step);
  var side = slxV31ForkSide(step);
  var icon = slxNavV2Classify(slxV31Instruction(step)).icon;

  if(slxV31IsFork(step)){
    icon = side === "left" ? "Ã¢â€ –" : side === "right" ? "Ã¢â€ —" : "Ã¢â€˜â€š";
  }else if(slxV31IsExit(step)){
    icon = action === "exit_left" ? "Ã¢â€ –" : "Ã¢â€ —";
  }

  return {
    main:exitNo ? "EXIT " + exitNo + " • " + base.replace(/^Take Exit\s+[0-9A-Z]+\s*/i,"") : base,
    sub:slxNavV2FmtDistance(remain),
    icon:icon
  };
};

/* Clear stale queued maneuver lines the instant geometry retires a turn. */
var slxV32OldAdvance = slxV2GAdvanceAuthority;
slxV2GAdvanceAuthority = function(){
  var before = maneuverIndex;
  slxV32OldAdvance();
  if(maneuverIndex !== before){
    try{
      slxV2G.speechQueue = slxV2G.speechQueue.filter(function(item){
        return item && item.kind !== "maneuver";
      });
    }catch(e){}
    maneuverLastSpokenIndex = -1;
    maneuverLastDistanceBucket = "";
  }
};

/* Voice watchdog prevents one failed iOS utterance from silencing the trip. */
function slxV32SpeechWatchdog(){
  var now = nowMs();
  var speaking = false;

  try{ speaking = !!(window.speechSynthesis && window.speechSynthesis.speaking); }catch(e0){}

  if(slxV2G.speechBusy){
    if(!slxV32SpeechWatch.busySince){ slxV32SpeechWatch.busySince = now; }
    if(!speaking && now - slxV32SpeechWatch.busySince > 4500){
      slxV2G.speechBusy = false;
      slxV2G.speechCurrent = null;
      slxV32SpeechWatch.busySince = 0;
      slxV32SpeechWatch.lastRecoveryAt = now;
      try{ slxV2GRunSpeechQueue(); }catch(e1){}
    }else if(now - slxV32SpeechWatch.busySince > 22000){
      try{
        if(typeof window.__SLX_FOUNDATION_FORCE_CANCEL__ === "function"){
          window.__SLX_FOUNDATION_FORCE_CANCEL__();
        }else{
          window.speechSynthesis.cancel();
        }
      }catch(e2){}
      slxV2G.speechBusy = false;
      slxV2G.speechCurrent = null;
      slxV32SpeechWatch.busySince = 0;
      slxV32SpeechWatch.lastRecoveryAt = now;
      try{ slxV2GRunSpeechQueue(); }catch(e3){}
    }
  }else{
    slxV32SpeechWatch.busySince = 0;
  }
}

/* Reset departure authority cleanly between trips. */
function slxV32SyncTripReset(){
  if(!tripStarted){
    slxV32Move.firstMovingAt = 0;
    slxV32Move.movingSamples = 0;
    slxV32Move.unlockedAt = 0;
    slxV32Move.resetForTrip = false;
    return;
  }

  if(!slxV32Move.resetForTrip){
    slxV32Move.resetForTrip = true;
    slxV2G.movementUnlocked = false;
    slxV2G.movementUnlockedAt = 0;
    slxV2G.originFix = null;
    slxV2G.spokenBuckets = {};
    maneuverLastSpokenIndex = -1;
    maneuverLastDistanceBucket = "";
  }
}

function slxV32NormalizeIntelText(text){
  var t = slxV32Clean(text);
  t = t.replace(/\s*•\s*Curve Ahead\b/ig,"");
  t = t.replace(/Route Confidence:\s*(HIGH|MEDIUM|LOW)\s*•\s*Curve Ahead/ig,"Route Confidence: $1");
  return slxV32Clean(t);
}

/* A normal curve may appear once, but it is not route uncertainty. */
function slxV32CleanIntelUi(){
  var selector = ".slxSignal,.slxSignalText,.slxIntelText,.slxHorizonItem,.slxHorizonCard,.slxRouteIntel,.slxRouteIntelCard,.routeIntel,#slxRouteIntel,#routeIntelPill,#slxIntelPill";
  var nodes;
  var seenCurve = false;
  var i;
  var el;
  var text;
  var low;

  try{ nodes = document.querySelectorAll(selector); }catch(e0){ return; }

  for(i = 0; i < nodes.length; i += 1){
    el = nodes[i];
    if(!el || !el.textContent){ continue; }
    text = slxV32NormalizeIntelText(el.textContent);
    low = text.toLowerCase();

    if(low.indexOf("curve ahead") >= 0){
      if(seenCurve){
        el.style.display = "none";
        continue;
      }
      seenCurve = true;
      el.style.display = "";
    }else if(el.style && el.style.display === "none"){
      el.style.display = "";
    }

    if(text !== slxV32Clean(el.textContent)){
      el.textContent = text;
    }
  }
}

var slxV32OldTick = slxV2GTick;
slxV2GTick = function(){
  slxV32SyncTripReset();
  slxV32OldTick();
  slxV32SpeechWatchdog();
  slxV32CleanIntelUi();
};

slxNavV2Tick = slxV2GTick;
maybeSpeakNextManeuver = function(){ slxV2GMaybeSpeakManeuver(); };
advancePastBehindManeuvers = function(){ slxV2GAdvanceAuthority(); };

try{
  maneuverSteps = [];
  buildManeuverSteps();
  if(maneuverSteps.length){ slxV2GResetActive(maneuverSteps[0],0); }
}catch(eBuildV32){}

window.setInterval(function(){
  try{
    slxV32SpeechWatchdog();
    slxV32CleanIntelUi();
  }catch(e){}
},900);

try{
  console.log("Ã¢Å“â€¦ Semi Locator V3.2 Voice / Maneuver / Street Name Authority loaded");
}catch(eLogV32){}

/* ========================================================================
   SEMI LOCATOR V3.3 — MANEUVER METADATA + AUDIO-LANE AUTHORITY

   HIGH-PRIORITY REPAIR:
   - Preserve the provider's complete maneuver object so street, highway,
     exit, destination and banner metadata reach both the card and voice.
   - Navigation maneuver speech preempts routine weather / wind / parking /
     fuel / traffic chatter instead of waiting behind it.
   - Routine intelligence is suppressed around an upcoming maneuver and may
     never monopolize, replace or cancel turn guidance.
   - Keep distinct advance, approach and turn-now stages, each once.
   - Always provide a directional fallback when a verified road name is absent.
======================================================================== */

window.__SLX_V33_MANEUVER_AUDIO_AUTHORITY__ = true;
window.__SLX_DRIVER_DASHBOARD_POLISH_VERSION__ =
  "V3.3_MANEUVER_METADATA_AUDIO_LANE_AUTHORITY";

function slxV33CopyStepField(target,source,key){
  try{
    if(source && source[key] !== undefined && source[key] !== null){
      target[key] = source[key];
    }
  }catch(e){}
}

/*
  The former builder retained only coord + instruction. That discarded the
  exact provider fields later used by V3.2 street-name authority. Preserve the
  raw step and the common identity fields so card and voice share one truth.
*/
buildManeuverSteps = function(){
  var i;
  var step;
  var loc;
  var instruction;
  var lower;
  var normalized;
  var fields = [
    "name","road","roadName","road_name","street","ref","route",
    "destination","destinations","exit","exitName","exitNumber",
    "exit_number","type","modifier","voiceInstruction",
    "voiceInstructions","voice_instructions","bannerInstruction",
    "banner_instruction","maneuver"
  ];
  var f;

  resetManeuverState();
  maneuverLastBuildAt = nowMs();

  if(!routeSteps || !routeSteps.length){
    routeSteps = loadRouteStepsFromStorage();
  }

  if(!routeSteps || !routeSteps.length){ return; }

  for(i = 0; i < routeSteps.length; i += 1){
    step = routeSteps[i];
    loc = getRouteStepLocation(step);
    if(!loc){ continue; }

    instruction = getStepInstruction(step);
    lower = String(instruction || "").toLowerCase();

    if(
      lower.indexOf("continue") > -1 &&
      lower.indexOf("onto") < 0 &&
      lower.indexOf("exit") < 0 &&
      lower.indexOf("turn") < 0 &&
      lower.indexOf("merge") < 0 &&
      lower.indexOf("keep") < 0 &&
      lower.indexOf("fork") < 0 &&
      lower.indexOf("ramp") < 0 &&
      lower.indexOf("arrive") < 0
    ){
      continue;
    }

    normalized = {
      coord:[Number(loc[0]),Number(loc[1])],
      instruction:instruction || "Continue on route",
      announceLabel:instruction || "Continue on route",
      originalIndex:i,
      rawStep:step
    };

    for(f = 0; f < fields.length; f += 1){
      slxV33CopyStepField(normalized,step,fields[f]);
    }

    maneuverSteps.push(normalized);
  }

  slxV2G.routeStepVersion = String(nowMs());
};

function slxV33ActiveManeuverDistance(){
  var active;
  var remain;
  try{
    active = maneuverSteps && maneuverSteps[maneuverIndex];
    remain = active ? slxNavV2RemainingToStep(active) : null;
  }catch(e){ remain = null; }
  return isFiniteNumber(remain) ? remain : null;
}

function slxV33IsRoutineKind(kind){
  return kind !== "maneuver" &&
    kind !== "arrival" &&
    kind !== "reroute" &&
    kind !== "safety";
}

function slxV33DropRoutineQueue(){
  try{
    slxV2G.speechQueue = slxV2G.speechQueue.filter(function(item){
      return item && !slxV33IsRoutineKind(item.kind);
    });
  }catch(e){}
}

function slxV33PreemptRoutineForManeuver(){
  var current = slxV2G.speechCurrent;

  slxV33DropRoutineQueue();

  if(current && slxV33IsRoutineKind(current.kind)){
    try{ window.speechSynthesis.cancel(); }catch(e0){}
    slxV2G.speechBusy = false;
    slxV2G.speechCurrent = null;
    try{ slxV32SpeechWatch.busySince = 0; }catch(e1){}
  }
}

var slxV33PreviousQueueSpeech = slxV2GQueueSpeech;
slxV2GQueueSpeech = function(text,kind,priority){
  var remain = slxV33ActiveManeuverDistance();
  var routine = slxV33IsRoutineKind(kind);

  if(kind === "maneuver"){
    slxV33PreemptRoutineForManeuver();
    return slxV33PreviousQueueSpeech(text,"maneuver",Math.max(110,Number(priority || 0)));
  }

  /*
    Weather and other informational audio stays out of the maneuver lane.
    Two miles protects truck exit/fork commitment; 1.25 miles protects normal
    advance guidance. Safety-critical speech remains eligible.
  */
  if(routine && isFiniteNumber(remain)){
    if(remain <= 1.25){ return false; }

    try{
      var active = maneuverSteps && maneuverSteps[maneuverIndex];
      if(active && (slxV31IsFork(active) || slxV31IsExit(active)) && remain <= 2.25){
        return false;
      }
    }catch(e0){}
  }

  return slxV33PreviousQueueSpeech(text,kind,priority);
};

/* Route all journey intelligence through the typed queue, not generic speech. */
driverVoice = function(category,msg,cooldownMs){
  var key;
  var last;
  var gap;
  var text;
  var kind = "info";
  var priority = 20;
  var remain;

  if(!tripStarted || !routeGeo || !msg){ return false; }

  text = String(msg || "").replace(/\s+/g," ").trim();
  if(!text){ return false; }

  if(!window.__SLX_VOICE_COOLDOWNS__){ window.__SLX_VOICE_COOLDOWNS__ = {}; }
  if(!window.__SLX_TRIP_VOICE_START_AT__){ window.__SLX_TRIP_VOICE_START_AT__ = nowMs(); }

  if(nowMs() - window.__SLX_TRIP_VOICE_START_AT__ < 12000){ return false; }

  key = String(category || "general");
  last = Number(window.__SLX_VOICE_COOLDOWNS__[key] || 0);
  gap = Number(cooldownMs || 300000);
  if(nowMs() - last < gap){ return false; }

  if(key === "weather" || key === "wind"){
    kind = "weather";
    priority = 18;
  }else if(key.indexOf("parking") >= 0){
    kind = "parking";
    priority = 17;
  }else if(key.indexOf("fuel") >= 0){
    kind = "fuel";
    priority = 16;
  }else if(key.indexOf("traffic") >= 0){
    kind = "traffic";
    priority = 19;
  }else if(key.indexOf("brake") >= 0){
    kind = "brake";
    priority = 22;
  }

  remain = slxV33ActiveManeuverDistance();
  if(isFiniteNumber(remain) && remain <= 1.25){ return false; }

  if(slxV2GQueueSpeech(text,kind,priority)){
    window.__SLX_VOICE_COOLDOWNS__[key] = nowMs();
    return true;
  }

  return false;
};

/* Generic callers remain compatible but cannot outrank maneuver authority. */
speak = function(msg){
  return slxV2GQueueSpeech(msg,"info",20);
};

primeVoiceThenSpeak = function(msg){
  primeSpeechChannel();
  return slxV2GQueueSpeech(msg,"info",20);
};

window.slxSpeak = speak;
window.slxPrimeVoiceThenSpeak = primeVoiceThenSpeak;

/* Rebuild immediately so an already-loaded route gains full metadata. */
try{
  maneuverSteps = [];
  buildManeuverSteps();
  slxV2G.activeKey = "";
  slxV2G.spokenBuckets = {};
  if(maneuverSteps.length){ slxV2GResetActive(maneuverSteps[0],0); }
  slxV2GTick();
}catch(eV33Build){}

try{
  console.log("Ã¢Å“â€¦ Semi Locator V3.3 Maneuver Metadata / Audio Lane Authority loaded");
}catch(eLogV33){}

})();

/* =========================================================
SEMI LOCATOR — DRIVER MODE COCKPIT LAYOUT AUTHORITY V3.4
Final portrait/landscape ownership pass.

LOCKED ZONES
- Top: app header + Freight Horizon only.
- Lower left: one authoritative maneuver card, then compact HUD below it.
- Lower right: Drop Signal above Route Intel.
- Bottom: dock only.
- Signal sheet: modal authority; cockpit overlays step out while open.

UI-only. No map, route, GPS, pin, camera, voice, paywall, or routing changes.
========================================================= */
(function(){
"use strict";

if(window.__SLX_DRIVER_COCKPIT_LAYOUT_AUTHORITY_V34__){return;}
window.__SLX_DRIVER_COCKPIT_LAYOUT_AUTHORITY_V34__=true;

function byId(id){return document.getElementById(id);}

function installStyles(){
  var st=byId("slxDriverCockpitLayoutAuthorityV34");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxDriverCockpitLayoutAuthorityV34";
  st.textContent=
    /* Eliminate the obsolete second maneuver pill/card. */
    "body #slxTurnCard{display:none!important;visibility:hidden!important;pointer-events:none!important;}"+

    /* Top deck owns only header + Horizon. */
    "body .slxTop{left:20px!important;right:74px!important;padding-top:calc(var(--safe-top,0px) + 72px)!important;z-index:90!important;}"+
    "body #slxHTrack{width:100%!important;max-width:none!important;max-height:150px!important;gap:5px!important;padding-right:46px!important;overflow:hidden!important;}"+
    "body #slxHTrack .slxSignal{box-sizing:border-box!important;width:100%!important;max-width:100%!important;min-width:0!important;}"+
    "body #slxHTrack .slxSignalText{display:block!important;width:100%!important;max-width:100%!important;min-width:0!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}"+

    /* One maneuver authority: always left, compact, never over Drop Signal. */
    "body #slxDriveIqTurnCardV2{"+
      "left:14px!important;right:auto!important;top:auto!important;"+
      "bottom:calc(226px + env(safe-area-inset-bottom,0px))!important;"+
      "width:calc(100vw - 218px)!important;"+
      "min-width:142px!important;max-width:176px!important;"+
      "min-height:46px!important;box-sizing:border-box!important;"+
      "padding:8px 9px!important;border-radius:16px!important;"+
      "z-index:930!important;overflow:hidden!important;"+
    "}"+
    "body #slxDriveIqTurnArrow{width:32px!important;height:32px!important;min-width:32px!important;border-radius:12px!important;font-size:19px!important;}"+
    "body #slxDriveIqTurnTextWrap{min-width:0!important;overflow:hidden!important;}"+
    "body #slxDriveIqTurnMain{font-size:12px!important;line-height:1.15!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}"+
    "body #slxDriveIqTurnSub{font-size:9px!important;line-height:1.15!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}"+

    /* Driver HUD owns the lower-left column below the maneuver card. */
    "body #slxDriverHud{left:14px!important;right:auto!important;bottom:calc(82px + env(safe-area-inset-bottom,0px))!important;width:158px!important;gap:5px!important;z-index:125!important;}"+
    "body #slxDriverHud [id^='slxHud_']{box-sizing:border-box!important;width:158px!important;min-width:158px!important;max-width:158px!important;}"+

    /* Right command column. Drop Signal sits above Route Intel, never beside maneuver. */
    "body #slxDropSignalBtn{"+
      "left:auto!important;right:14px!important;top:auto!important;"+
      "bottom:calc(226px + env(safe-area-inset-bottom,0px))!important;"+
      "width:164px!important;max-width:calc(100vw - 212px)!important;"+
      "height:50px!important;padding:0 12px!important;"+
      "border-radius:18px!important;z-index:925!important;"+
      "white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;"+
    "}"+
    "body #slxSmartBadge{"+
      "left:auto!important;right:14px!important;top:auto!important;"+
      "bottom:calc(126px + env(safe-area-inset-bottom,0px))!important;"+
      "width:calc(100vw - 202px)!important;min-width:174px!important;max-width:244px!important;"+
      "box-sizing:border-box!important;padding:9px 11px!important;"+
      "transform:none!important;z-index:120!important;overflow:hidden!important;"+
    "}"+
    "body #slxSmartBadgeText{display:block!important;max-width:100%!important;overflow:hidden!important;text-overflow:ellipsis!important;}"+

    /* Right map controls stay in their own vertical rail. */
    "body .slxRight{right:8px!important;top:calc(var(--safe-top,0px) + 318px)!important;width:52px!important;max-height:calc(100vh - 458px - var(--safe-bottom,0px))!important;z-index:110!important;}"+

    /* Dock is the only owner of the bottom strip. */
    "body .slxDock{left:14px!important;right:14px!important;bottom:calc(8px + env(safe-area-inset-bottom,0px))!important;height:58px!important;z-index:950!important;}"+

    /* Signal sheet becomes a real modal layer above the dock. */
    "body #slxSignalSheet{"+
      "left:14px!important;right:14px!important;"+
      "bottom:calc(78px + env(safe-area-inset-bottom,0px))!important;"+
      "max-height:calc(100vh - 122px - env(safe-area-inset-top,0px) - env(safe-area-inset-bottom,0px))!important;"+
      "overflow-y:auto!important;overscroll-behavior:contain!important;"+
      "z-index:2147483600!important;box-sizing:border-box!important;"+
    "}"+
    "body.slx-signal-sheet-open #slxDriveIqTurnCardV2,"+
    "body.slx-signal-sheet-open #slxTurnCard,"+
    "body.slx-signal-sheet-open #slxDropSignalBtn,"+
    "body.slx-signal-sheet-open #slxSmartBadge,"+
    "body.slx-signal-sheet-open #slxDriverHud{"+
      "display:none!important;visibility:hidden!important;pointer-events:none!important;"+
    "}"+
    "body.slx-signal-sheet-open .slxRight{opacity:.18!important;pointer-events:none!important;}"+

    /* Small-phone tightening without collapsing columns into each other. */
    "@media(max-width:390px){"+
      "body .slxTop{left:14px!important;right:68px!important;}"+
      "body #slxDriveIqTurnCardV2{left:12px!important;width:152px!important;min-width:152px!important;max-width:152px!important;}"+
      "body #slxDropSignalBtn{right:12px!important;width:156px!important;max-width:156px!important;font-size:11px!important;}"+
      "body #slxDriverHud{left:12px!important;width:148px!important;}"+
      "body #slxDriverHud [id^='slxHud_']{width:148px!important;min-width:148px!important;max-width:148px!important;}"+
      "body #slxSmartBadge{right:12px!important;width:calc(100vw - 188px)!important;min-width:172px!important;max-width:214px!important;}"+
    "}"+

    /* Landscape uses two shallow command columns above the compact dock. */
    "@media(orientation:landscape){"+
      "body .slxTop{left:10px!important;right:auto!important;width:410px!important;max-width:410px!important;padding-top:calc(var(--safe-top,0px) + 8px)!important;}"+
      "body #slxHTrack{max-height:116px!important;}"+
      "body #slxDriveIqTurnCardV2{left:12px!important;right:auto!important;bottom:calc(64px + env(safe-area-inset-bottom,0px))!important;width:210px!important;min-width:210px!important;max-width:210px!important;}"+
      "body #slxDriverHud{display:none!important;}"+
      "body #slxDropSignalBtn{right:74px!important;bottom:calc(64px + env(safe-area-inset-bottom,0px))!important;width:150px!important;height:44px!important;}"+
      "body #slxSmartBadge{right:236px!important;bottom:calc(64px + env(safe-area-inset-bottom,0px))!important;width:230px!important;min-width:230px!important;max-width:230px!important;}"+
      "body .slxRight{right:8px!important;top:calc(var(--safe-top,0px) + 70px)!important;max-height:calc(100vh - 140px - var(--safe-bottom,0px))!important;}"+
      "body .slxDock{left:10px!important;right:74px!important;height:48px!important;bottom:calc(6px + env(safe-area-inset-bottom,0px))!important;}"+
      "body #slxSignalSheet{left:10px!important;right:74px!important;bottom:calc(60px + env(safe-area-inset-bottom,0px))!important;max-height:calc(100vh - 78px - env(safe-area-inset-top,0px) - env(safe-area-inset-bottom,0px))!important;}"+
    "}";

  document.head.appendChild(st);
}

function syncSignalSheetState(){
  var sheet=byId("slxSignalSheet");
  var open=!!(sheet && sheet.classList && sheet.classList.contains("on"));

  if(!document.body){return;}

  if(open){document.body.classList.add("slx-signal-sheet-open");}
  else{document.body.classList.remove("slx-signal-sheet-open");}
}

function cleanRepeatedRouteWords(){
  var nodes=document.querySelectorAll("#slxHTrack .slxSignalText");
  var i,el,t,clean;

  for(i=0;i<nodes.length;i+=1){
    el=nodes[i];
    if(!el){continue;}

    t=String(el.textContent||"").replace(/\s+/g," ").trim();
    if(!t){continue;}

    clean=t
      .replace(/\b(ROUTE)(?:\s+\1){1,}/ig,"ROUTE")
      .replace(/\b(INTEL)(?:\s+\1){1,}/ig,"INTEL")
      .replace(/\b(CONFIDENCE)(?:\s+\1){1,}/ig,"CONFIDENCE")
      .replace(/ROUTE\s+ROUTE\s+INTEL/ig,"ROUTE INTEL")
      .replace(/ROUTE\s+INTEL\s*ROUTE\s+INTEL/ig,"ROUTE INTEL");

    if(clean!==t){el.textContent=clean;}
  }
}

function tick(){
  installStyles();
  syncSignalSheetState();
  cleanRepeatedRouteWords();
}

installStyles();
tick();
setTimeout(tick,250);
setTimeout(tick,900);
setTimeout(tick,1800);
setInterval(tick,1200);

try{
  if(window.MutationObserver && document.body){
    new MutationObserver(function(){syncSignalSheetState();}).observe(document.body,{subtree:true,attributes:true,attributeFilter:["class"]});
  }
}catch(eObs){}

try{console.log("Ã¢Å“â€¦ Semi Locator V3.4 Cockpit Layout Authority loaded");}catch(eLog){}

})();


/* =========================================================
   SEMI LOCATOR — CLEAN COCKPIT / DOCK INTEL AUTHORITY V4
   Dock Intel never floats during normal drive.
   Facility notes remain available to final-approach voice/arrival logic.
========================================================= */
(function(){
"use strict";

if(window.__SLX_DOCK_INTEL_COCKPIT_AUTHORITY_V4__){return;}
window.__SLX_DOCK_INTEL_COCKPIT_AUTHORITY_V4__=true;

var ids=[
  "slxDriverDockIntelV1",
  "slxDockIntelRecoveryV2",
  "dockIntelCard",
  "slxDockIntelCard",
  "slxArrivalDockIntel"
];

function removeDockCards(){
  var i,el,list,j;
  for(i=0;i<ids.length;i+=1){
    el=document.getElementById(ids[i]);
    if(el&&el.parentNode){el.parentNode.removeChild(el);}
  }

  list=document.querySelectorAll(".dockIntelCard,.slxDockIntel,.slxDockIntelCard,[data-slx-role='dock-intel']");
  for(j=0;j<list.length;j+=1){
    if(list[j]&&list[j].parentNode){list[j].parentNode.removeChild(list[j]);}
  }
}

window.slxRenderDriverDockIntelV1=function(){removeDockCards();};
window.slxRenderDriverDockIntelV2=function(){removeDockCards();};
window.slxRenderDriverDockIntelV3=function(){removeDockCards();};

removeDockCards();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(function(){
    window.requestAnimationFrame(removeDockCards);
  }).observe(document.documentElement,{childList:true,subtree:true});
}
})();


/* =========================================================
   SEMI LOCATOR — SINGLE MANEUVER SURFACE AUTHORITY V4
========================================================= */
(function(){
"use strict";

if(window.__SLX_SINGLE_MANEUVER_SURFACE_V4__){return;}
window.__SLX_SINGLE_MANEUVER_SURFACE_V4__=true;

var canonicalId="slxDriveIqTurnCardV2";
var legacyIds=[
  "slxVisualManeuverCard",
  "slxTurnCard",
  "slxManeuverCard",
  "slxNextTurnCard",
  "maneuverCard",
  "visualManeuverCard",
  "slxTurnToggleMini"
];

function clean(){
  var i,el;
  for(i=0;i<legacyIds.length;i+=1){
    el=document.getElementById(legacyIds[i]);
    if(el&&el.id!==canonicalId&&el.parentNode){
      el.parentNode.removeChild(el);
    }
  }

  var cards=document.querySelectorAll(
    ".slxManeuverCard,.maneuverCard,.visualManeuverCard"
  );
  for(i=0;i<cards.length;i+=1){
    if(cards[i].id!==canonicalId&&cards[i].parentNode){
      cards[i].parentNode.removeChild(cards[i]);
    }
  }
}

function installStyle(){
  if(document.getElementById("slxSingleManeuverSurfaceStyleV4")){return;}
  var st=document.createElement("style");
  st.id="slxSingleManeuverSurfaceStyleV4";
  st.textContent=
    "body #slxVisualManeuverCard,body #slxTurnCard,body #slxManeuverCard,body #slxNextTurnCard,body #maneuverCard,body #visualManeuverCard,body #slxTurnToggleMini{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}"+
    "body #slxDriverDockIntelV1,body #slxDockIntelRecoveryV2,body .dockIntelCard,body .slxDockIntel,body .slxDockIntelCard{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}"+
    "body.slx-signal-sheet-open #slxDriveIqTurnCardV2,body.slx-menu-open #slxDriveIqTurnCardV2{display:none!important;visibility:hidden!important;pointer-events:none!important;}";
  document.head.appendChild(st);
}

installStyle();
clean();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(function(){
    window.requestAnimationFrame(clean);
  }).observe(document.documentElement,{childList:true,subtree:true});
}
})();



/* =========================================================
   SEMI LOCATOR — ALERT COPY + ORPHAN STATUS AUTHORITY V5
========================================================= */
(function(){
"use strict";

if(window.__SLX_ALERT_COPY_STATUS_AUTHORITY_V5__){return;}
window.__SLX_ALERT_COPY_STATUS_AUTHORITY_V5__=true;

function normalizeAlertText(v){
  var s=String(v||"").replace(/\s+/g," ").trim();

  s=s.replace(/\bCurve Ahead ahead\b/gi,"Curve ahead");
  s=s.replace(/\bcurve ahead ahead\b/gi,"Curve ahead");
  s=s.replace(/\bTurn Ahead ahead\b/gi,"Turn ahead");
  s=s.replace(/\bHazard Ahead ahead\b/gi,"Hazard ahead");
  s=s.replace(/\bConstruction Ahead ahead\b/gi,"Construction ahead");
  s=s.replace(/\bWeather Alert alert\b/gi,"Weather alert");

  return s;
}

function cleanAlertNodes(){
  var nodes=document.querySelectorAll(
    "#slxHTrack .slxSignal,.slxSignalText,[data-slx-role='alert-text']"
  );
  var i,norm;
  for(i=0;i<nodes.length;i+=1){
    norm=normalizeAlertText(nodes[i].textContent);
    if(norm!==String(nodes[i].textContent||"")){
      nodes[i].textContent=norm;
    }
  }
}

function removeOrphanStatus(){
  var ids=[
    "slxSmartBadge",
    "slxStatusBadge",
    "slxGpsBadge",
    "slxRouteBadge",
    "slxFloatingStatus"
  ];
  var i,el;
  for(i=0;i<ids.length;i+=1){
    el=document.getElementById(ids[i]);
    if(el&&el.parentNode){el.parentNode.removeChild(el);}
  }

  var list=document.querySelectorAll(
    ".slxSmartBadge,.slxStatusBadge,.slxGpsBadge,.slxRouteBadge,.slxFloatingStatus,"+
    "[data-slx-role='smart-status'],[data-slx-role='floating-status'],[data-slx-role='gps-status']"
  );
  for(i=0;i<list.length;i+=1){
    if(list[i]&&list[i].parentNode){list[i].parentNode.removeChild(list[i]);}
  }
}

function clean(){
  cleanAlertNodes();
  removeOrphanStatus();
}

clean();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(function(){
    window.requestAnimationFrame(clean);
  }).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
}
})();



/* =========================================================
   SEMI LOCATOR — FINAL COCKPIT AUTHORITY V6
   Loaded last so no legacy V3/V4 layout block can override it.
========================================================= */
(function(){
"use strict";

if(window.__SLX_FINAL_COCKPIT_AUTHORITY_V6__){return;}
window.__SLX_FINAL_COCKPIT_AUTHORITY_V6__=true;

function byId(id){return document.getElementById(id);}

function textOf(el){
  return String(el && el.textContent || "").replace(/\s+/g," ").trim();
}

function hasRealManeuver(card){
  var t=textOf(card).toLowerCase();
  if(!card || !t){return false;}
  if(t.indexOf("waiting")>-1){return false;}
  if(t.indexOf("standby")>-1){return false;}
  if(t==="\u2191" || t==="Ã¢â€ —" || t==="Ã¢â€ –" || t==="\u2192" || t==="Ã¢â€ Â"){return false;}
  return t.length>4;
}

function removeDockIntel(){
  var all=document.querySelectorAll("div,section,aside,article");
  var i,t,el;
  for(i=0;i<all.length;i+=1){
    el=all[i];
    t=textOf(el).toLowerCase();
    if(t.indexOf("dock intel")===0 || t.indexOf("no dock note saved")>-1){
      if(el.parentNode){el.parentNode.removeChild(el);}
    }
  }
}

function removeOrphanLowerRightCards(){
  var all=document.querySelectorAll("div,section,aside,button");
  var i,el,r,t;

  for(i=0;i<all.length;i+=1){
    el=all[i];

    if(el.id==="slxDropSignalBtn" || el.closest && el.closest(".slxDock")){
      continue;
    }

    t=textOf(el).toLowerCase();

    try{r=el.getBoundingClientRect();}catch(e){continue;}

    if(
      r.width>=180 && r.width<=390 &&
      r.height>=44 && r.height<=110 &&
      r.left>window.innerWidth*.42 &&
      r.top>window.innerHeight*.58 &&
      (
        !t ||
        t==="\u2191" ||
        t.indexOf("gps locked")===0 ||
        t.indexOf("waiting")>-1
      )
    ){
      if(el.parentNode){el.parentNode.removeChild(el);}
    }
  }
}

function syncManeuverState(){
  var card=byId("slxDriveIqTurnCardV2");
  var live=hasRealManeuver(card);

  if(document.body){
    document.body.classList.toggle("slx-has-live-maneuver",live);
  }

  if(card){
    if(live){
      card.style.removeProperty("display");
      card.style.removeProperty("visibility");
    }else{
      card.style.setProperty("display","none","important");
      card.style.setProperty("visibility","hidden","important");
    }
  }
}

function installStyles(){
  var st=byId("slxFinalCockpitAuthorityStyleV6");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxFinalCockpitAuthorityStyleV6";
  st.textContent=
    /* Kill all accumulated top padding. */
    "body .slxTop{"+
      "position:fixed!important;"+
      "top:calc(env(safe-area-inset-top,0px) + 132px)!important;"+
      "left:14px!important;right:74px!important;"+
      "padding-top:0!important;transform:none!important;"+
      "z-index:120!important;"+
    "}"+
    "body .slxTopInner{transform:none!important;gap:8px!important;}"+
    "body .slxHeader{min-height:54px!important;padding:9px 15px!important;border-radius:22px!important;}"+

    /* One alert row only. */
    "body #slxHTrack{height:42px!important;min-height:42px!important;max-height:42px!important;padding:0!important;overflow:hidden!important;}"+
    "body #slxHTrack .slxSignal{display:none!important;}"+
    "body #slxHTrack .slxSignal.slx-cockpit-alert{display:flex!important;height:42px!important;min-height:42px!important;width:100%!important;max-width:100%!important;padding:0 15px!important;border-radius:999px!important;}"+

    /* Canonical maneuver uses the same top slot and replaces the alert. */
    "body #slxDriveIqTurnCardV2{"+
      "position:fixed!important;"+
      "left:14px!important;right:74px!important;"+
      "top:calc(env(safe-area-inset-top,0px) + 198px)!important;"+
      "bottom:auto!important;width:auto!important;max-width:none!important;"+
      "min-height:76px!important;height:auto!important;max-height:100px!important;"+
      "padding:12px 15px!important;border-radius:23px!important;"+
      "z-index:126!important;opacity:1!important;transform:none!important;"+
    "}"+
    "body.slx-has-live-maneuver #slxHTrack{visibility:hidden!important;opacity:0!important;}"+

    /* Remove every legacy secondary surface. */
    "body #slxTurnCard,body #slxManeuverCard,body #slxNextTurnCard,"+
    "body #slxVisualManeuverCard,body #maneuverCard,body #visualManeuverCard,"+
    "body #slxTurnToggleMini,body #slxSmartBadge,body #slxRouteIntel,"+
    "body .slxRouteIntel,body .dockIntelCard,body .slxDockIntel,"+
    "body .slxDockIntelCard{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}"+

    /* Lower-left HUD. */
    "body #slxDriverHud,body #slxHud,body .slxHud,body #slxTelemetry,body .slxTelemetry{"+
      "position:fixed!important;left:14px!important;right:auto!important;"+
      "top:auto!important;bottom:calc(88px + env(safe-area-inset-bottom,0px))!important;"+
      "width:158px!important;max-width:158px!important;z-index:118!important;"+
    "}"+

    /* Drop Signal owns one lower-right slot. */
    "body #slxDropSignalBtn{"+
      "position:fixed!important;left:auto!important;right:14px!important;top:auto!important;"+
      "bottom:calc(92px + env(safe-area-inset-bottom,0px))!important;"+
      "width:170px!important;max-width:44vw!important;height:54px!important;"+
      "z-index:124!important;border-radius:19px!important;"+
    "}"+

    /* No floating card is permitted above Drop Signal. */
    "body #slxStatusBadge,body #slxGpsBadge,body #slxRouteBadge,"+
    "body #slxFloatingStatus,body .slxSmartBadge,body .slxStatusBadge,"+
    "body .slxGpsBadge,body .slxRouteBadge,body .slxFloatingStatus{"+
      "display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;"+
    "}"+

    /* Right rail ends before Drop Signal. */
    "body .slxRight{"+
      "position:fixed!important;right:8px!important;"+
      "top:calc(env(safe-area-inset-top,0px) + 255px)!important;"+
      "bottom:calc(180px + env(safe-area-inset-bottom,0px))!important;"+
      "width:52px!important;max-height:none!important;"+
      "display:flex!important;justify-content:flex-start!important;gap:8px!important;"+
      "overflow:hidden!important;z-index:112!important;"+
    "}"+
    "body .slxRight .slxBtn{min-height:50px!important;height:50px!important;flex:0 0 50px!important;}"+

    /* Bottom dock remains the only bottom strip. */
    "body .slxDock{"+
      "left:14px!important;right:14px!important;"+
      "bottom:calc(8px + env(safe-area-inset-bottom,0px))!important;"+
      "height:68px!important;padding:7px!important;gap:8px!important;"+
      "z-index:130!important;"+
    "}"+

    /* Sheets hide cockpit controls. */
    "body.slx-signal-sheet-open #slxDriveIqTurnCardV2,"+
    "body.slx-signal-sheet-open #slxHTrack,"+
    "body.slx-signal-sheet-open #slxDropSignalBtn,"+
    "body.slx-signal-sheet-open #slxDriverHud,"+
    "body.slx-menu-open #slxDriveIqTurnCardV2,"+
    "body.slx-menu-open #slxHTrack,"+
    "body.slx-menu-open #slxDropSignalBtn,"+
    "body.slx-menu-open #slxDriverHud{display:none!important;visibility:hidden!important;pointer-events:none!important;}"+

    "@media(max-width:390px){"+
      "body .slxTop{top:calc(env(safe-area-inset-top,0px) + 124px)!important;left:10px!important;right:68px!important;}"+
      "body #slxDriveIqTurnCardV2{top:calc(env(safe-area-inset-top,0px) + 188px)!important;left:10px!important;right:68px!important;}"+
      "body #slxDropSignalBtn{right:10px!important;width:158px!important;}"+
      "body #slxDriverHud,body #slxHud,body .slxHud,body #slxTelemetry,body .slxTelemetry{left:10px!important;width:150px!important;max-width:150px!important;}"+
    "}";

  document.head.appendChild(st);
}

function clean(){
  installStyles();
  removeDockIntel();
  removeOrphanLowerRightCards();
  syncManeuverState();
}

clean();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(function(){
    window.requestAnimationFrame(clean);
  }).observe(document.documentElement,{
    childList:true,
    subtree:true,
    characterData:true,
    attributes:true,
    attributeFilter:["class","style","hidden"]
  });
}

window.addEventListener("resize",clean);
window.addEventListener("orientationchange",function(){
  setTimeout(clean,100);
  setTimeout(clean,350);
});
})();



/* =========================================================
   SEMI LOCATOR — TOP STACK RUNTIME AUTHORITY V7
========================================================= */
(function(){
"use strict";

if(window.__SLX_TOP_STACK_RUNTIME_V7__){return;}
window.__SLX_TOP_STACK_RUNTIME_V7__=true;

function install(){
  var st=document.getElementById("slxTopStackRuntimeStyleV7");
  if(st){return;}

  st=document.createElement("style");
  st.id="slxTopStackRuntimeStyleV7";
  st.textContent=
    "body .slxTop{"+
      "position:fixed!important;"+
      "top:calc(env(safe-area-inset-top,0px) + 52px)!important;"+
      "left:14px!important;right:74px!important;"+
      "padding-top:0!important;transform:none!important;"+
      "z-index:120!important;"+
    "}"+
    "body .slxTopInner{transform:none!important;gap:7px!important;}"+
    "body .slxHeader{min-height:54px!important;padding:9px 15px!important;border-radius:22px!important;}"+
    "body #slxHTrack{height:42px!important;min-height:42px!important;max-height:42px!important;}"+
    "body #slxDriveIqTurnCardV2{"+
      "top:calc(env(safe-area-inset-top,0px) + 116px)!important;"+
      "left:14px!important;right:74px!important;bottom:auto!important;"+
    "}"+
    "@media(max-width:390px){"+
      "body .slxTop{top:calc(env(safe-area-inset-top,0px) + 48px)!important;left:10px!important;right:68px!important;}"+
      "body #slxDriveIqTurnCardV2{top:calc(env(safe-area-inset-top,0px) + 110px)!important;left:10px!important;right:68px!important;}"+
    "}";

  document.head.appendChild(st);
}

install();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(function(){
    if(!document.getElementById("slxTopStackRuntimeStyleV7")){install();}
  }).observe(document.documentElement,{childList:true,subtree:true});
}
})();



/* =========================================================
   SEMI LOCATOR — MANEUVER DIMENSION RUNTIME RESET V8
========================================================= */
(function(){
"use strict";

if(window.__SLX_MANEUVER_DIMENSION_RESET_V8__){return;}
window.__SLX_MANEUVER_DIMENSION_RESET_V8__=true;

function resetCard(){
  var card=document.getElementById("slxDriveIqTurnCardV2");
  var kids,i;

  if(!card){return;}

  card.style.setProperty("display","flex","important");
  card.style.setProperty("align-items","center","important");
  card.style.setProperty("justify-content","flex-start","important");
  card.style.setProperty("flex-direction","row","important");
  card.style.setProperty("position","fixed","important");
  card.style.setProperty("top","calc(env(safe-area-inset-top,0px) + 116px)","important");
  card.style.setProperty("left","14px","important");
  card.style.setProperty("right","74px","important");
  card.style.setProperty("bottom","auto","important");
  card.style.setProperty("width","auto","important");
  card.style.setProperty("min-width","0","important");
  card.style.setProperty("max-width","none","important");
  card.style.setProperty("height","76px","important");
  card.style.setProperty("min-height","76px","important");
  card.style.setProperty("max-height","76px","important");
  card.style.setProperty("margin","0","important");
  card.style.setProperty("padding","10px 15px","important");
  card.style.setProperty("overflow","hidden","important");
  card.style.setProperty("border-radius","22px","important");
  card.style.setProperty("transform","none","important");

  kids=card.children||[];
  for(i=0;i<kids.length;i+=1){
    kids[i].style.setProperty("min-width","0","important");
    kids[i].style.setProperty("max-height","64px","important");
  }
}

function installStyle(){
  if(document.getElementById("slxManeuverDimensionStyleV8")){return;}

  var st=document.createElement("style");
  st.id="slxManeuverDimensionStyleV8";
  st.textContent=
    "body #slxDriveIqTurnCardV2{display:flex!important;align-items:center!important;justify-content:flex-start!important;flex-direction:row!important;position:fixed!important;top:calc(env(safe-area-inset-top,0px) + 116px)!important;left:14px!important;right:74px!important;bottom:auto!important;width:auto!important;min-width:0!important;max-width:none!important;height:76px!important;min-height:76px!important;max-height:76px!important;margin:0!important;padding:10px 15px!important;overflow:hidden!important;border-radius:22px!important;transform:none!important;}"+
    "body #slxDriveIqTurnCardV2>*{min-width:0!important;max-height:64px!important;}"+
    "@media(max-width:390px){body #slxDriveIqTurnCardV2{top:calc(env(safe-area-inset-top,0px) + 110px)!important;left:10px!important;right:68px!important;height:72px!important;min-height:72px!important;max-height:72px!important;}}";

  document.head.appendChild(st);
}

function clean(){
  installStyle();
  resetCard();
}

clean();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(function(){
    window.requestAnimationFrame(clean);
  }).observe(document.documentElement,{
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:["style","class"]
  });
}

window.addEventListener("resize",clean);
window.addEventListener("orientationchange",function(){
  setTimeout(clean,100);
  setTimeout(clean,320);
});
})();



/* =========================================================
   SEMI LOCATOR — LIVE MANEUVER CONTENT AUTHORITY V9
========================================================= */
(function(){
"use strict";

if(window.__SLX_LIVE_MANEUVER_CONTENT_V9__){return;}
window.__SLX_LIVE_MANEUVER_CONTENT_V9__=true;

function cleanText(v){
  return String(v||"").replace(/\s+/g," ").trim();
}

function normalizeAlertText(v){
  var s=cleanText(v);

  s=s.replace(/\bCurve Ahead ahead\b/gi,"Curve ahead");
  s=s.replace(/\bCurve ahead ahead\b/gi,"Curve ahead");
  s=s.replace(/\bTurn Ahead ahead\b/gi,"Turn ahead");
  s=s.replace(/\bHazard Ahead ahead\b/gi,"Hazard ahead");
  s=s.replace(/\bConstruction Ahead ahead\b/gi,"Construction ahead");

  return s;
}

function hasRealInstruction(card){
  var text;
  var low;

  if(!card){return false;}

  text=cleanText(card.textContent);
  low=text.toLowerCase();

  if(!text){return false;}
  if(text==="\u2191" || text==="\u2192" || text==="Ã¢â€ Â" || text==="Ã¢â€ —" || text==="Ã¢â€ –"){return false;}
  if(low.indexOf("waiting")>-1){return false;}
  if(low.indexOf("standby")>-1){return false;}
  if(low.indexOf("gps locked")>-1){return false;}
  if(low.indexOf("navigation active")>-1){return false;}

  return text.replace(/[\u2191\u2192Ã¢â€ ÂÃ¢â€ —Ã¢â€ –Ã¢â€ ËœÃ¢â€ â„¢]/g,"").trim().length >= 5;
}

function updateManeuverVisibility(){
  var card=document.getElementById("slxDriveIqTurnCardV2");
  var live=hasRealInstruction(card);

  if(document.body){
    document.body.classList.toggle("slx-has-live-maneuver",live);
  }

  if(!card){return;}

  if(live){
    card.style.setProperty("display","flex","important");
    card.style.setProperty("visibility","visible","important");
    card.style.setProperty("opacity","1","important");
    card.style.setProperty("pointer-events","auto","important");
  }else{
    card.style.setProperty("display","none","important");
    card.style.setProperty("visibility","hidden","important");
    card.style.setProperty("opacity","0","important");
    card.style.setProperty("pointer-events","none","important");
  }
}

function cleanAlerts(){
  var nodes=document.querySelectorAll("#slxHTrack .slxSignal,#slxHTrack .slxSignalText");
  var i,norm;

  for(i=0;i<nodes.length;i+=1){
    norm=normalizeAlertText(nodes[i].textContent);
    if(norm!==cleanText(nodes[i].textContent)){
      nodes[i].textContent=norm;
    }
  }
}

function installStyle(){
  if(document.getElementById("slxLiveManeuverContentStyleV9")){return;}

  var st=document.createElement("style");
  st.id="slxLiveManeuverContentStyleV9";
  st.textContent=
    "body:not(.slx-has-live-maneuver) #slxDriveIqTurnCardV2{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}"+
    "body.slx-has-live-maneuver #slxHTrack{display:none!important;visibility:hidden!important;opacity:0!important;}"+
    "body #slxDriveIqTurnCardV2{top:calc(env(safe-area-inset-top,0px) + 116px)!important;left:14px!important;right:74px!important;height:76px!important;min-height:76px!important;max-height:76px!important;}"+
    "@media(max-width:390px){body #slxDriveIqTurnCardV2{top:calc(env(safe-area-inset-top,0px) + 110px)!important;left:10px!important;right:68px!important;height:72px!important;min-height:72px!important;max-height:72px!important;}}";

  document.head.appendChild(st);
}

function clean(){
  installStyle();
  cleanAlerts();
  updateManeuverVisibility();
}

clean();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(function(){
    window.requestAnimationFrame(clean);
  }).observe(document.documentElement,{
    childList:true,
    subtree:true,
    characterData:true,
    attributes:true,
    attributeFilter:["style","class","hidden"]
  });
}

window.addEventListener("resize",clean);
window.addEventListener("orientationchange",function(){
  setTimeout(clean,100);
  setTimeout(clean,320);
});
})();



/* =========================================================
   SEMI LOCATOR — STATUS ROW ANCHOR AUTHORITY V10
   Positions the cockpit directly beneath the top subscription pills.
========================================================= */
(function(){
"use strict";

if(window.__SLX_STATUS_ROW_ANCHOR_V10__){return;}
window.__SLX_STATUS_ROW_ANCHOR_V10__=true;

var lastTop=-1;
var rafPending=false;

function textOf(el){
  return String(el && el.textContent || "").replace(/\s+/g," ").trim().toUpperCase();
}

function findStatusRowBottom(){
  var all=document.querySelectorAll("button,a,div,span");
  var i,el,t,r;
  var bestBottom=0;

  for(i=0;i<all.length;i+=1){
    el=all[i];
    t=textOf(el);

    if(
      t==="0 FREE TRIPS" ||
      t==="PRO ACTIVE" ||
      t==="FD-16" ||
      t==="PRO"
    ){
      try{r=el.getBoundingClientRect();}catch(e){continue;}

      if(
        r.width>45 &&
        r.height>24 &&
        r.top>=0 &&
        r.top<260 &&
        r.bottom>bestBottom
      ){
        bestBottom=r.bottom;
      }
    }
  }

  return bestBottom;
}

function hasRealManeuver(){
  return document.body &&
    document.body.classList.contains("slx-has-live-maneuver");
}

function placeCockpit(){
  var top=document.querySelector(".slxTop");
  var card=document.getElementById("slxDriveIqTurnCardV2");
  var rowBottom=findStatusRowBottom();
  var targetTop;
  var headerRect;
  var alertRect;
  var cardTop;

  if(!top){return;}

  /*
  Sit 8px below the actual top-pill row.
  Fallback remains compact if the host pills cannot be found yet.
  */
  targetTop=rowBottom>0 ? Math.round(rowBottom+8) : 164;
  targetTop=Math.max(126,Math.min(targetTop,210));

  top.style.setProperty("position","fixed","important");
  top.style.setProperty("top",targetTop+"px","important");
  top.style.setProperty("left","14px","important");
  top.style.setProperty("right","74px","important");
  top.style.setProperty("padding-top","0","important");
  top.style.setProperty("margin","0","important");
  top.style.setProperty("transform","none","important");

  lastTop=targetTop;

  /*
  The live maneuver card is outside .slxTop.
  Put it directly beneath the header, replacing the alert row.
  */
  if(card){
    try{headerRect=top.querySelector(".slxHeader").getBoundingClientRect();}
    catch(eHeader){headerRect=null;}

    cardTop=headerRect ? Math.round(headerRect.bottom+8) : targetTop+62;

    card.style.setProperty("position","fixed","important");
    card.style.setProperty("top",cardTop+"px","important");
    card.style.setProperty("left","14px","important");
    card.style.setProperty("right","74px","important");
    card.style.setProperty("bottom","auto","important");
  }
}

function schedulePlace(){
  if(rafPending){return;}
  rafPending=true;
  window.requestAnimationFrame(function(){
    rafPending=false;
    placeCockpit();
  });
}

function installStyle(){
  if(document.getElementById("slxStatusRowAnchorStyleV10")){return;}

  var st=document.createElement("style");
  st.id="slxStatusRowAnchorStyleV10";
  st.textContent=
    "body .slxTop{padding-top:0!important;margin:0!important;transform:none!important;}"+
    "body .slxTopInner{margin:0!important;transform:none!important;}"+
    "@media(max-width:390px){body .slxTop{left:10px!important;right:68px!important;}body #slxDriveIqTurnCardV2{left:10px!important;right:68px!important;}}";

  document.head.appendChild(st);
}

installStyle();
placeCockpit();

if(window.MutationObserver&&document.documentElement){
  new MutationObserver(schedulePlace).observe(document.documentElement,{
    childList:true,
    subtree:true,
    characterData:true,
    attributes:true,
    attributeFilter:["class","style","hidden"]
  });
}

window.addEventListener("resize",schedulePlace);
window.addEventListener("orientationchange",function(){
  setTimeout(schedulePlace,80);
  setTimeout(schedulePlace,260);
  setTimeout(schedulePlace,600);
});

/* Host subscription pills can finish rendering after the driver JS. */
setTimeout(schedulePlace,100);
setTimeout(schedulePlace,350);
setTimeout(schedulePlace,900);
setTimeout(schedulePlace,1800);
})();



/* =========================================================
   SEMI LOCATOR — HARD TOP LOCK + STANDBY FILTER V11
========================================================= */
(function(){
"use strict";

if(window.__SLX_HARD_TOP_LOCK_V11__){return;}
window.__SLX_HARD_TOP_LOCK_V11__=true;

var timer=0;

function cleanText(v){
  return String(v||"").replace(/\s+/g," ").trim().toLowerCase();
}

function findStatusRowBottom(){
  var all=document.querySelectorAll("button,a,div,span");
  var i,el,t,r,bottom=0;

  for(i=0;i<all.length;i+=1){
    el=all[i];
    t=cleanText(el.textContent).toUpperCase();

    if(t==="0 FREE TRIPS" || t==="PRO ACTIVE" || t==="FD-16" || t==="PRO"){
      try{r=el.getBoundingClientRect();}catch(e){continue;}
      if(r.top>=0 && r.top<260 && r.height>20 && r.bottom>bottom){
        bottom=r.bottom;
      }
    }
  }

  return bottom;
}

function isStandbyAlert(el){
  var t=cleanText(el && el.textContent);
  return !t ||
    t.indexOf("standby")>-1 ||
    t.indexOf("waiting")>-1 ||
    t.indexOf("gps fix missing")>-1 ||
    t.indexOf("weather stable")>-1;
}

function filterAlerts(){
  var track=document.getElementById("slxHTrack");
  var alerts,i,firstReal=null;

  if(!track){return;}

  alerts=track.querySelectorAll(".slxSignal");

  for(i=0;i<alerts.length;i+=1){
    alerts[i].classList.remove("slx-cockpit-alert");
    alerts[i].classList.toggle("slx-standby-alert",isStandbyAlert(alerts[i]));

    if(!firstReal && !isStandbyAlert(alerts[i])){
      firstReal=alerts[i];
    }
  }

  if(firstReal){
    firstReal.classList.add("slx-cockpit-alert");
    track.style.setProperty("display","block","important");
    track.style.setProperty("height","42px","important");
  }else{
    track.style.setProperty("display","none","important");
    track.style.setProperty("height","0","important");
  }
}

function lockTop(){
  var top=document.querySelector(".slxTop");
  var rowBottom=findStatusRowBottom();
  var target=rowBottom>0 ? Math.round(rowBottom+8) : 174;

  if(!top){return;}

  target=Math.max(150,Math.min(target,190));

  top.style.setProperty("position","fixed","important");
  top.style.setProperty("top",target+"px","important");
  top.style.setProperty("left","14px","important");
  top.style.setProperty("right","74px","important");
  top.style.setProperty("padding-top","0","important");
  top.style.setProperty("margin","0","important");
  top.style.setProperty("transform","none","important");
}

function tick(){
  lockTop();
  filterAlerts();
}

function installStyle(){
  if(document.getElementById("slxHardTopLockStyleV11")){return;}

  var st=document.createElement("style");
  st.id="slxHardTopLockStyleV11";
  st.textContent=
    "body .slxTop{padding-top:0!important;margin:0!important;transform:none!important;}"+
    "body #slxHTrack .slxSignal{display:none!important;}"+
    "body #slxHTrack .slxSignal.slx-cockpit-alert:not(.slx-standby-alert){display:flex!important;}"+
    "@media(max-width:390px){body .slxTop{left:10px!important;right:68px!important;}}";
  document.head.appendChild(st);
}

installStyle();
tick();

/* Reassert after legacy layout timers and observers. */
timer=window.setInterval(tick,250);

window.addEventListener("resize",tick);
window.addEventListener("orientationchange",function(){
  setTimeout(tick,80);
  setTimeout(tick,280);
  setTimeout(tick,700);
});
})();


/* =========================================================
   SEMI LOCATOR — TURN CARD IQ V13 / PARKED ROUTE TRUTH LOCK
   - Visual turn card may show while stationary when a real route maneuver exists.
   - Voice remains movement-gated.
   - Uses canonical window.slxNavCoreV2 active maneuver only.
   - Suppresses empty Dock Intel recovery card; no note = no popup.
   ========================================================= */
(function(){
"use strict";

if(window.__SLX_TURN_CARD_IQ_V13__){return;}
window.__SLX_TURN_CARD_IQ_V13__=true;

function clean(v){return String(v||"").replace(/\s+/g," ").trim();}

function activeStep(){
  var s=null;
  try{
    if(window.slxNavCoreV2 && typeof window.slxNavCoreV2.active === "function"){
      s=window.slxNavCoreV2.active();
    }
  }catch(e0){}
  if(!s){
    try{s=window.SLX_ACTIVE_STEP||window.nextStep||null;}catch(e1){s=null;}
  }
  return s;
}

function instruction(step){
  var s="";
  if(!step){return "";}
  try{
    if(step.maneuver && step.maneuver.instruction){s=step.maneuver.instruction;}
    else{s=step.instruction||step.announceLabel||step.name||"";}
  }catch(e){}
  return clean(s);
}

function roadName(step,text){
  var candidates=[];
  var i,v,m;
  if(!step){step={};}
  try{
    candidates=[
      step.roadName,step.road_name,step.name,step.ref,step.destination,
      step.streetName,step.street_name,
      step.maneuver&&step.maneuver.roadName,
      step.maneuver&&step.maneuver.name
    ];
  }catch(e0){}
  for(i=0;i<candidates.length;i++){
    v=clean(candidates[i]);
    if(v && v.length<90 && !/^(turn|continue|merge|keep|take|arrive|destination)\b/i.test(v)){return v;}
  }
  text=clean(text);
  m=text.match(/\b(?:onto|on|toward|towards|for)\s+([^,;]+)$/i);
  if(m&&m[1]){return clean(m[1]);}
  return "";
}

function classify(text){
  var low=String(text||"").toLowerCase();
  if(/u[- ]?turn/.test(low)){return {icon:"Ã¢â€ Â¶",main:"MAKE U-TURN"};}
  if(/roundabout/.test(low)){return {icon:"Ã¢Å¸Â³",main:"ROUNDABOUT"};}
  if(/exit/.test(low) && /left/.test(low)){return {icon:"Ã¢â€ –",main:"TAKE LEFT EXIT"};}
  if(/exit/.test(low)){return {icon:"Ã¢â€ —",main:"TAKE EXIT"};}
  if(/merge/.test(low) && /left/.test(low)){return {icon:"Ã¢â€ –",main:"MERGE LEFT"};}
  if(/merge/.test(low)){return {icon:"Ã¢â€ —",main:"MERGE"};}
  if(/keep|stay/.test(low) && /left/.test(low)){return {icon:"Ã¢â€ –",main:"KEEP LEFT"};}
  if(/keep|stay/.test(low) && /right/.test(low)){return {icon:"Ã¢â€ —",main:"KEEP RIGHT"};}
  if(/slight|bear/.test(low) && /left/.test(low)){return {icon:"Ã¢â€ –",main:"BEAR LEFT"};}
  if(/slight|bear/.test(low) && /right/.test(low)){return {icon:"Ã¢â€ —",main:"BEAR RIGHT"};}
  if(/turn|make/.test(low) && /left/.test(low)){return {icon:"Ã¢â€ Â",main:"TURN LEFT"};}
  if(/turn|make/.test(low) && /right/.test(low)){return {icon:"\u2192",main:"TURN RIGHT"};}
  if(/arriv|destination/.test(low)){return {icon:"Ã°Å¸ÂÂ",main:"FINAL APPROACH"};}
  return {icon:"\u2191",main:"CONTINUE"};
}

function remaining(step){
  var r=null;
  try{
    if(window.slxNavCoreV2 && typeof window.slxNavCoreV2.remaining === "function"){
      r=window.slxNavCoreV2.remaining(step);
    }
  }catch(e0){}
  try{
    if(r===null && typeof window.slxNavV2RemainingToStep === "function"){
      r=window.slxNavV2RemainingToStep(step);
    }
  }catch(e1){}
  if(r===null){
    try{
      if(typeof step.remainingMiles === "number"){r=step.remainingMiles;}
      else if(typeof step.distanceRemaining === "number"){r=step.distanceRemaining;}
    }catch(e2){}
  }
  r=Number(r);
  return isFinite(r)?Math.max(0,r):null;
}

function fmt(mi){
  var ft;
  if(mi===null){return "";}
  if(mi>=1){return (mi>=10?String(Math.round(mi)):String(Math.round(mi*10)/10))+" mi";}
  ft=Math.max(50,Math.round((mi*5280)/50)*50);
  return String(ft)+" ft";
}

function ensureCard(){
  var card=document.getElementById("slxDriveIqTurnCardV2");
  if(!card){
    card=document.createElement("div");
    card.id="slxDriveIqTurnCardV2";
    card.innerHTML='<div id="slxDriveIqTurnArrow">\u2191</div><div id="slxDriveIqTurnTextWrap"><div id="slxDriveIqTurnMain"></div><div id="slxDriveIqTurnSub"></div></div>';
    document.body.appendChild(card);
  }
  return card;
}

function installStyle(){
  var st;
  if(document.getElementById("slxTurnCardIqV13Style")){return;}
  st=document.createElement("style");
  st.id="slxTurnCardIqV13Style";
  st.textContent=
    "body #slxDriveIqTurnCardV2.slx-v13-live{"+
      "display:flex!important;visibility:visible!important;opacity:1!important;pointer-events:none!important;"+
      "position:fixed!important;top:174px!important;left:14px!important;right:74px!important;bottom:auto!important;"+
      "height:78px!important;min-height:78px!important;max-height:78px!important;width:auto!important;max-width:none!important;"+
      "padding:10px 14px!important;border-radius:22px!important;align-items:center!important;gap:12px!important;"+
      "background:linear-gradient(180deg,rgba(7,16,27,.96),rgba(5,12,20,.96))!important;"+
      "border:1px solid rgba(69,214,230,.38)!important;box-shadow:0 16px 38px rgba(0,0,0,.44)!important;"+
      "backdrop-filter:blur(18px)!important;-webkit-backdrop-filter:blur(18px)!important;z-index:9996!important;overflow:hidden!important;transform:none!important;}"+
    "body #slxDriveIqTurnCardV2.slx-v13-live #slxDriveIqTurnArrow{display:flex!important;align-items:center!important;justify-content:center!important;width:48px!important;min-width:48px!important;height:48px!important;border-radius:16px!important;font-size:30px!important;font-weight:1000!important;background:rgba(44,235,190,.12)!important;color:#7fffd4!important;}"+
    "body #slxDriveIqTurnCardV2.slx-v13-live #slxDriveIqTurnTextWrap{min-width:0!important;flex:1!important;}"+
    "body #slxDriveIqTurnCardV2.slx-v13-live #slxDriveIqTurnMain{font-size:19px!important;line-height:1.05!important;font-weight:1000!important;letter-spacing:.03em!important;color:#fff!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}"+
    "body #slxDriveIqTurnCardV2.slx-v13-live #slxDriveIqTurnSub{margin-top:6px!important;font-size:13px!important;line-height:1!important;font-weight:850!important;color:rgba(255,255,255,.78)!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}"+
    "@media(max-width:390px){body #slxDriveIqTurnCardV2.slx-v13-live{top:166px!important;left:10px!important;right:68px!important;height:74px!important;min-height:74px!important;max-height:74px!important;}body #slxDriveIqTurnCardV2.slx-v13-live #slxDriveIqTurnMain{font-size:17px!important;}}"+
    "#slxDockIntelRecoveryV2.slx-v13-empty-dock{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}";
  document.head.appendChild(st);
}

function suppressEmptyDock(){
  var card=document.getElementById("slxDockIntelRecoveryV2");
  var txt;
  if(!card){return;}
  txt=clean(card.textContent).toLowerCase();
  if(!txt || txt.indexOf("no dock note saved")>-1){
    card.classList.add("slx-v13-empty-dock");
    card.classList.remove("on");
  }else{
    card.classList.remove("slx-v13-empty-dock");
  }
}

function sync(){
  var step,text,c,card,arrow,main,sub,road,dist,subline;
  installStyle();
  suppressEmptyDock();

  step=activeStep();
  text=instruction(step);
  card=ensureCard();

  if(!step || !text){
    card.classList.remove("slx-v13-live");
    return;
  }

  c=classify(text);
  road=roadName(step,text);
  dist=fmt(remaining(step));
  subline=dist;
  if(road){subline+=(subline?" • ":"")+road;}
  else{subline+=(subline?" • ":"")+text;}

  arrow=document.getElementById("slxDriveIqTurnArrow");
  main=document.getElementById("slxDriveIqTurnMain");
  sub=document.getElementById("slxDriveIqTurnSub");
  if(arrow){arrow.textContent=c.icon;}
  if(main){main.textContent=c.main;}
  if(sub){sub.textContent=subline;}

  card.classList.add("slx-v13-live");
  try{if(document.body){document.body.classList.add("slx-has-live-maneuver");}}catch(e0){}
}

/* The card is visual truth and may exist at 0 mph. Voice remains owned by V2G's movement gate. */
window.slxTurnCardIqV13Sync=sync;

setTimeout(sync,250);
setTimeout(sync,900);
setTimeout(sync,1800);
setInterval(sync,500);

try{
  if(window.MutationObserver && document.documentElement){
    new MutationObserver(function(){window.requestAnimationFrame(sync);}).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  }
}catch(eObs){}

try{console.log("Ã¢Å“â€¦ Semi Locator Turn Card IQ V13 / Parked Route Truth Lock loaded");}catch(eLog){}
})();


/* [V52 CLEANUP: obsolete maneuver-card authority removed] */
/* =========================================================
   SEMI LOCATOR V16 — CURVE VOICE SPEED GATE
   Canonical policy:
   - Neighborhood / low-speed curves are visual-only.
   - Curve voice is reserved for meaningful high-speed risk.
   - Voice threshold: current speed >=45 mph, OR known limit >=50 mph
     with current speed >=35 mph.
   - Maneuver voice remains higher priority than curve intelligence.
   ========================================================= */
try{
  window.__SLX_CURVE_VOICE_SPEED_GATE_V16__ = {
    minLiveSpeedMph:45,
    highLimitMph:50,
    minSpeedWithHighLimitMph:35
  };
  console.log("Ã¢Å“â€¦ Semi Locator V16 Curve Voice Speed Gate loaded");
}catch(eV16){}



/* [V52 CLEANUP: obsolete maneuver-card authority removed] */
/* ============================================================================
   SEMI LOCATOR V27 — FOUNDER IQ TELEMETRY AUTHORITY
   ----------------------------------------------------------------------------
   Analytics only. Does NOT alter route geometry, reroute decisions, camera,
   pin movement, maneuver authority, voice cadence, arrival logic, Stop IQ,
   paywall behavior, or truck intelligence.

   Guarantees:
   - Proves the Drive Mode -> Founder IQ backend pipe with visible diagnostics.
   - Emits trip / route lifecycle events from the authoritative trip flag.
   - Emits route-start only once per route activation on this device.
   - Emits completion when an active trip transitions off.
   - Exposes a manual health/test hook for troubleshooting.
   - Never sends coordinates, destination address, route geometry, or PII.
   ============================================================================ */
(function(){
"use strict";

if(window.__SLX_V27_FOUNDER_IQ_TELEMETRY_AUTHORITY__){return;}
window.__SLX_V27_FOUNDER_IQ_TELEMETRY_AUTHORITY__=true;

var V27={
  lastTripOn:null,
  tripBeganAt:0,
  currentTripToken:"",
  lastRouteFingerprint:"",
  bootSent:false,
  watchTimer:null
};

function v27Now(){return Date.now();}

function v27LsGet(k){
  try{return localStorage.getItem(k);}catch(e){}
  return null;
}

function v27LsSet(k,v){
  try{localStorage.setItem(k,String(v));}catch(e){}
}

function v27TripOn(){
  try{
    if(typeof tripStarted!=="undefined"){return !!tripStarted;}
  }catch(e0){}
  return String(v27LsGet("slx_trip_on_v2")||"")==="1";
}

function v27HasRoute(){
  try{
    if(typeof routeGeo!=="undefined" && routeGeo){return true;}
  }catch(e0){}
  return !!v27LsGet("slx_route_geo_v2");
}

function v27HasSteps(){
  var raw="";
  try{
    raw=v27LsGet("slx_route_steps_v2") ||
        v27LsGet("slx_maneuver_steps_v1") ||
        v27LsGet("slx_route_steps_v1") || "";
  }catch(e){}
  return !!raw;
}

function v27RouteFingerprint(){
  var raw="",dest="",steps="",len=0;
  try{raw=v27LsGet("slx_route_geo_v2")||"";}catch(e0){}
  try{dest=v27LsGet("slx_main_dest_v2")||"";}catch(e1){}
  try{steps=v27LsGet("slx_route_steps_v2")||"";}catch(e2){}

  /*
    Fingerprint uses lengths + a tiny deterministic string hash only.
    No raw route/destination content is transmitted.
  */
  function hash(s){
    var h=2166136261,i;
    s=String(s||"");
    for(i=0;i<s.length;i+=1){
      h^=s.charCodeAt(i);
      h+=(h<<1)+(h<<4)+(h<<7)+(h<<8)+(h<<24);
    }
    return (h>>>0).toString(36);
  }

  len=String(raw).length+String(dest).length+String(steps).length;
  return hash(String(len)+"|"+String(raw).slice(0,64)+"|"+String(steps).slice(0,64));
}

function v27Emit(name,props){
  if(typeof window.SLX_FIQ_EMIT==="function"){
    try{return window.SLX_FIQ_EMIT(name,props||{});}catch(e0){}
  }
  try{
    if(typeof fiqEmit==="function"){return fiqEmit(name,props||{});}
  }catch(e1){}
  return Promise.resolve(false);
}

function v27MakeTripToken(){
  return "semi-"+String(v27Now())+"-"+Math.random().toString(36).slice(2,8);
}

function v27OnTripStart(){
  var fp=v27RouteFingerprint();
  var storedActive=v27LsGet("slx_fiq_active_trip_token_v1")||"";
  var storedFp=v27LsGet("slx_fiq_active_route_fp_v1")||"";

  V27.tripBeganAt=v27Now();
  V27.lastRouteFingerprint=fp;

  /*
    If Drive Mode reloaded during the exact same active route, reuse the token
    and do not count another start.
  */
  if(storedActive && storedFp && storedFp===fp){
    V27.currentTripToken=storedActive;
    try{console.log("Ã°Å¸“Å  Semi Founder IQ resumed active trip",storedActive);}catch(eResume){}
    return;
  }

  V27.currentTripToken=v27MakeTripToken();
  v27LsSet("slx_fiq_active_trip_token_v1",V27.currentTripToken);
  v27LsSet("slx_fiq_active_route_fp_v1",fp);

  v27Emit("trip_started",{
    telemetry_version:"V27",
    has_route:v27HasRoute(),
    has_steps:v27HasSteps(),
    route_fingerprint:fp
  });

  v27Emit("route_started",{
    telemetry_version:"V27",
    has_steps:v27HasSteps(),
    route_fingerprint:fp
  });
}

function v27OnTripEnd(){
  var began=Number(V27.tripBeganAt||0);
  var durationSec=began>0 ? Math.max(0,Math.round((v27Now()-began)/1000)) : null;
  var token=V27.currentTripToken || v27LsGet("slx_fiq_active_trip_token_v1") || "";
  var fp=V27.lastRouteFingerprint || v27LsGet("slx_fiq_active_route_fp_v1") || "";

  if(!token){
    return;
  }

  v27Emit("trip_completed",{
    telemetry_version:"V27",
    duration_seconds:durationSec,
    route_fingerprint:fp
  });

  v27Emit("route_completed",{
    telemetry_version:"V27",
    duration_seconds:durationSec,
    route_fingerprint:fp
  });

  V27.currentTripToken="";
  V27.tripBeganAt=0;
  v27LsSet("slx_fiq_active_trip_token_v1","");
  v27LsSet("slx_fiq_active_route_fp_v1","");
}

function v27Watch(){
  var on=v27TripOn();

  if(V27.lastTripOn===null){
    V27.lastTripOn=on;

    /*
      If the page boots with an already-active trip, treat it as a start/resume.
    */
    if(on){v27OnTripStart();}
    return;
  }

  if(on!==V27.lastTripOn){
    if(on){v27OnTripStart();}
    else{v27OnTripEnd();}
    V27.lastTripOn=on;
  }
}

function v27Boot(){
  if(V27.bootSent){return;}
  V27.bootSent=true;

  v27Emit("drive_mode_opened",{
    telemetry_version:"V27",
    trip_active:v27TripOn(),
    has_route:v27HasRoute(),
    has_steps:v27HasSteps()
  });

  /*
    Fast proof event: if a route is already present, tell Founder IQ the route
    environment loaded even before movement begins.
  */
  if(v27HasRoute()){
    v27Emit("driver_session_started",{
      telemetry_version:"V27",
      route_present:true,
      trip_active:v27TripOn()
    });
  }

  v27Watch();
  V27.watchTimer=window.setInterval(v27Watch,500);
}

window.SLXV27FounderIQ={
  state:V27,
  emit:v27Emit,
  test:function(){
    return v27Emit("drive_mode_opened",{
      telemetry_version:"V27-manual-test",
      trip_active:v27TripOn(),
      has_route:v27HasRoute(),
      has_steps:v27HasSteps()
    });
  },
  status:function(){
    try{return JSON.parse(v27LsGet("slx_fiq_last_status_v1")||"null");}catch(e){}
    return null;
  }
};

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",v27Boot,false);
}else{
  v27Boot();
}
window.addEventListener("load",v27Boot,false);

try{console.log("Ã¢Å“â€¦ Semi Locator V27 Founder IQ Telemetry Authority loaded");}catch(eBoot){}
})();



/* [V52 CLEANUP: obsolete maneuver-card authority removed] */
/* ============================================================================
   SEMI LOCATOR V42 - SURGICAL STREET NAME + MANEUVER VOICE RESTORE
   ----------------------------------------------------------------------------
   ONLY TWO JOBS:
   1) Restore the upcoming maneuver street/road name in the existing turn card.
   2) Restore maneuver voice guidance without touching route, reroute, map,
      camera, pin, arrival, Stop IQ, Freight Horizon, or cockpit layout.

   IMPORTANT:
   - V41 current-street visual overwrite is disabled so the turn card can once
     again show the TARGET road for the upcoming maneuver.
   - Existing V2G/V33 speech queue remains the actual navigation audio lane.
   - Adds a position-based movement fallback for devices whose GPS speed is null.
   - ES5-safe.
   ============================================================================ */
(function(){
"use strict";

if(window.__SLX_V42_STREET_VOICE_RESTORE__){return;}
window.__SLX_V42_STREET_VOICE_RESTORE__=true;

var V42={
  road:"",
  roadKey:"",
  reversePending:false,
  reverseKey:"",
  reverseCache:{},
  origin:null,
  moving:false,
  primed:false,
  spoken:{},
  lastActiveKey:"",
  timer:null
};

function clean(v){
  return String(v==null?"":v).replace(/\s+/g," ").trim();
}

function finite(v){
  return typeof v==="number" && isFinite(v);
}

function tripOn(){
  try{
    if(typeof tripStarted!=="undefined"){return !!tripStarted;}
  }catch(e0){}
  try{return localStorage.getItem("slx_trip_on_v2")==="1";}catch(e1){}
  return false;
}

function activeStep(){
  var s=null;
  try{
    if(window.SLXV29StreetAuthority &&
       typeof window.SLXV29StreetAuthority.active==="function"){
      s=window.SLXV29StreetAuthority.active();
      if(s){return s;}
    }
  }catch(e0){}

  try{
    if(window.SLXV25StreetManeuverVoice &&
       typeof window.SLXV25StreetManeuverVoice.active==="function"){
      s=window.SLXV25StreetManeuverVoice.active();
      if(s){return s;}
    }
  }catch(e1){}

  try{
    if(typeof slxNavV2ActiveStep==="function"){
      s=slxNavV2ActiveStep();
      if(s){return s;}
    }
  }catch(e2){}

  try{
    if(maneuverSteps && maneuverSteps.length &&
       maneuverIndex>=0 && maneuverIndex<maneuverSteps.length){
      return maneuverSteps[maneuverIndex];
    }
  }catch(e3){}

  return null;
}

function sourceOf(step){
  return (step && (step.rawStep || step.raw)) || step || {};
}

function manOf(step){
  var src=sourceOf(step);
  return (step && step.maneuver) || src.maneuver || {};
}

function badRoad(v){
  var s=clean(v).toLowerCase();
  return !s ||
    /^(turn|turn left|turn right|left|right|straight|continue|continue straight|continue on route|merge|exit|take the exit|fork|keep left|keep right|arrive|arrival|destination|route guidance|guidance ready|route active|route ready|navigation ready|turn card iq|street name loading|road name unavailable)$/i.test(s);
}

function fromInstruction(v){
  var s=clean(v),m;
  if(!s){return "";}

  m=s.match(/\b(?:onto|on|toward|towards|for|via|stay on|continue onto)\s+(.+?)(?:\s+(?:in|after)\s+(?:about\s+)?(?:\d|one|two|three|half)|[.,;]|$)/i);
  if(m&&m[1]&&!badRoad(m[1])){return clean(m[1]);}

  m=s.match(/\b(I[-\s]?\d{1,3}[A-Z]?|US[-\s]?\d{1,3}[A-Z]?|U\.S\.\s*\d{1,3}[A-Z]?|SR[-\s]?\d{1,3}[A-Z]?|State Route\s+\d+[A-Z]?|Highway\s+\d+[A-Z]?|Hwy\s+\d+[A-Z]?)\b/i);
  if(m&&m[1]){return clean(m[1]).replace(/^I\s+/i,"I-");}

  return "";
}

function roadName(step){
  var r="",src,man,vals,i,v,banner,components;

  if(!step){return "";}

  try{
    if(window.SLXV29StreetAuthority &&
       typeof window.SLXV29StreetAuthority.roadName==="function"){
      r=clean(window.SLXV29StreetAuthority.roadName(step));
      if(r&&!badRoad(r)){return r;}
    }
  }catch(e0){}

  try{
    if(window.SLXV25StreetManeuverVoice &&
       typeof window.SLXV25StreetManeuverVoice.roadName==="function"){
      r=clean(window.SLXV25StreetManeuverVoice.roadName(step));
      if(r&&!badRoad(r)){return r;}
    }
  }catch(e1){}

  src=sourceOf(step);
  man=manOf(step);

  vals=[
    step.roadName,step.road_name,step.streetName,step.street_name,
    step.street,step.road,step.name,step.ref,step.route,
    src.roadName,src.road_name,src.streetName,src.street_name,
    src.street,src.road,src.name,src.ref,src.route,
    man.roadName,man.road_name,man.streetName,man.street_name,
    man.street,man.road,man.name,man.ref
  ];

  for(i=0;i<vals.length;i++){
    v=clean(vals[i]);
    if(v&&!badRoad(v)&&v.length<=100){return v;}
  }

  banner=src.bannerInstruction||src.banner_instruction||
    step.bannerInstruction||step.banner_instruction||null;

  try{
    if(banner&&banner.primary){
      v=clean(banner.primary.text);
      if(v&&!badRoad(v)){
        r=fromInstruction(v);
        if(r){return r;}
        if(v.length<=100){return v;}
      }
      components=banner.primary.components||[];
      for(i=0;i<components.length;i++){
        v=clean(components[i]&&components[i].text);
        if(v&&!badRoad(v)&&v.length<=100){return v;}
      }
    }
  }catch(e2){}

  try{
    v=typeof slxNavV2InstructionText==="function" ?
      clean(slxNavV2InstructionText(step)) :
      clean(step.instruction||man.instruction);
  }catch(e3){
    v=clean(step.instruction||man.instruction);
  }

  return fromInstruction(v);
}

function stepKey(step){
  var c=stepCoord(step);
  var idx="";
  try{idx=String(typeof maneuverIndex!=="undefined"?maneuverIndex:"");}catch(e){}
  return idx+"|"+String(c?c[0]:"")+"|"+String(c?c[1]:"")+"|"+clean(step&&step.instruction);
}

function stepCoord(step){
  var src=sourceOf(step),man=manOf(step),c=null;
  try{
    c=step.coord||step.location||step.coordinates||step.point||
      man.location||man.coordinates||
      src.location||src.coordinates||
      (src.maneuver&&(src.maneuver.location||src.maneuver.coordinates));
  }catch(e){}
  if(c&&c.length>=2&&finite(Number(c[0]))&&finite(Number(c[1]))){
    return [Number(c[0]),Number(c[1])];
  }
  return null;
}

function writeRoad(step,road){
  if(!step||!road||badRoad(road)){return;}
  try{
    step.roadName=road;
    step.road_name=road;
    step.streetName=road;
    step.street_name=road;
    step.street=road;
    if(step.rawStep){
      step.rawStep.roadName=road;
      step.rawStep.road_name=road;
      step.rawStep.streetName=road;
      step.rawStep.street_name=road;
    }
  }catch(e){}
}

function mapboxToken(){
  var app=document.getElementById("slxApp");
  return clean(
    window.SLX_MAPBOX_TOKEN||
    window.DRIVE_IQ_MAPBOX_TOKEN||
    (app&&app.getAttribute("data-mapbox-token"))||
    ""
  );
}

function reverseTarget(step){
  var c=stepCoord(step),key,t,url;
  if(!step||!c||V42.reversePending||!window.fetch){return;}

  key=stepKey(step);
  if(V42.reverseCache[key]){
    V42.road=V42.reverseCache[key];
    V42.roadKey=key;
    writeRoad(step,V42.road);
    return;
  }
  if(V42.reverseKey===key){return;}

  t=mapboxToken();
  if(!t){return;}

  V42.reverseKey=key;
  V42.reversePending=true;

  url="https://api.mapbox.com/search/geocode/v6/reverse?longitude="+
    encodeURIComponent(String(c[0]))+
    "&latitude="+encodeURIComponent(String(c[1]))+
    "&types=street,address&limit=1&access_token="+encodeURIComponent(t);

  fetch(url)
    .then(function(res){return res.json();})
    .then(function(data){
      var f=data&&data.features&&data.features[0];
      var p=f&&f.properties||{};
      var ctx=p.context||{};
      var n="";

      if(ctx.street){n=clean(ctx.street.name_preferred||ctx.street.name);}
      if(!n&&p.feature_type==="street"){n=clean(p.name_preferred||p.name);}
      if(!n){n=clean(p.name_preferred||p.name);}

      if(n&&!badRoad(n)){
        V42.reverseCache[key]=n;
        V42.road=n;
        V42.roadKey=key;
        writeRoad(step,n);
        renderStreet();
      }
      V42.reversePending=false;
    })
    .catch(function(){V42.reversePending=false;});
}

function renderStreet(){
  var step=activeStep();
  var el=document.getElementById("slxDriveIqTurnRoad");
  var r,key;

  if(!el||!step){return;}

  key=stepKey(step);
  r=roadName(step);

  if(r&&!badRoad(r)){
    V42.road=r;
    V42.roadKey=key;
    writeRoad(step,r);
    if(el.textContent!==r){el.textContent=r;}
  }else if(V42.roadKey===key&&V42.road&&!badRoad(V42.road)){
    if(el.textContent!==V42.road){el.textContent=V42.road;}
  }else{
    reverseTarget(step);
  }
}

function fix(){
  var f=null;
  try{
    if(window.__SLX_CORE_BRIDGE__ &&
       typeof window.__SLX_CORE_BRIDGE__.getCurrentFix==="function"){
      f=window.__SLX_CORE_BRIDGE__.getCurrentFix();
    }
  }catch(e0){}
  if(f&&finite(Number(f.lat))&&finite(Number(f.lng))){return f;}

  try{f=currentFix||rawFix||routeTargetFix||null;}catch(e1){}
  if(f&&finite(Number(f.lat))&&finite(Number(f.lng))){return f;}
  return null;
}

function geoMiles(a,b){
  var R=3958.8,dLat,dLng,p1,p2,h;
  if(!a||!b){return 0;}
  dLat=(Number(b.lat)-Number(a.lat))*Math.PI/180;
  dLng=(Number(b.lng)-Number(a.lng))*Math.PI/180;
  p1=Number(a.lat)*Math.PI/180;
  p2=Number(b.lat)*Math.PI/180;
  h=Math.sin(dLat/2)*Math.sin(dLat/2)+
    Math.sin(dLng/2)*Math.sin(dLng/2)*Math.cos(p1)*Math.cos(p2);
  return R*2*Math.atan2(Math.sqrt(h),Math.sqrt(1-h));
}

function movementReady(){
  var f=fix(),mph=0,moved=0;

  try{
    if(typeof slxV2GMovementReady==="function" && slxV2GMovementReady()){
      V42.moving=true;
      return true;
    }
  }catch(e0){}

  if(!f){return false;}

  try{
    if(finite(Number(f.speed))){mph=Number(f.speed)*2.23693629;}
  }catch(e1){}

  if(!V42.origin){
    V42.origin={lat:Number(f.lat),lng:Number(f.lng)};
    return false;
  }

  moved=geoMiles(V42.origin,{lat:Number(f.lat),lng:Number(f.lng)});

  if(mph>=2.5||moved>=0.020){
    V42.moving=true;
    return true;
  }

  return V42.moving;
}

function remaining(step){
  var n=null;
  try{
    if(typeof slxNavV2RemainingToStep==="function"){
      n=Number(slxNavV2RemainingToStep(step));
      if(finite(n)){return Math.max(0,n);}
    }
  }catch(e0){}
  try{
    if(typeof slxV33ActiveManeuverDistance==="function"){
      n=Number(slxV33ActiveManeuverDistance());
      if(finite(n)){return Math.max(0,n);}
    }
  }catch(e1){}
  return null;
}

function bucket(step,remain){
  try{
    if(typeof slxV2GBucket==="function"){
      return slxV2GBucket(step,remain)||"";
    }
  }catch(e0){}

  if(!finite(remain)){return "";}
  if(remain<=0.06){return "NOW";}
  if(remain<=0.18){return "NEAR";}
  if(remain<=0.55){return "HALF";}
  if(remain<=1.05){return "EARLY";}
  return "";
}

function action(step){
  var a="";
  try{
    if(typeof slxV2GAction==="function"){
      a=clean(slxV2GAction(step)).toLowerCase();
      if(a){return a;}
    }
  }catch(e0){}

  try{
    a=clean((manOf(step).modifier)||step.modifier).toLowerCase();
  }catch(e1){}

  if(a.indexOf("left")>=0){return "left";}
  if(a.indexOf("right")>=0){return "right";}
  return "continue";
}

function baseVoice(step){
  var r=roadName(step);
  var a=action(step);
  var instr="";

  try{
    if(typeof slxV2GBuildInstruction==="function"){
      instr=clean(slxV2GBuildInstruction(step));
      if(instr&&instr.toLowerCase()!=="continue"&&
         (!r||instr.toLowerCase().indexOf(r.toLowerCase())>=0)){
        return instr;
      }
    }
  }catch(e0){}

  if(a.indexOf("left")>=0){return r?"Turn left onto "+r:"Turn left";}
  if(a.indexOf("right")>=0){return r?"Turn right onto "+r:"Turn right";}

  try{
    instr=clean(typeof slxNavV2InstructionText==="function" ?
      slxNavV2InstructionText(step) : step.instruction);
  }catch(e1){instr=clean(step&&step.instruction);}

  if(r){return "Continue on "+r;}
  if(instr){return instr;}
  return "Continue on route";
}

function voiceLine(step,b,remain){
  var line="";
  try{
    if(typeof slxV2GVoiceLine==="function"){
      line=clean(slxV2GVoiceLine(step,b,remain));
      if(line){return line;}
    }
  }catch(e0){}

  line=baseVoice(step);
  if(b==="EARLY"){return line+" in about one mile";}
  if(b==="HALF"){return line+" in about half a mile";}
  if(b==="NEAR"){return line+" in about eight hundred feet";}
  if(b==="NOW"){return line+" now";}
  return line;
}

function prime(){
  var u;
  if(V42.primed||!tripOn()||!window.speechSynthesis){return;}
  V42.primed=true;

  try{if(typeof primeSpeechChannel==="function"){primeSpeechChannel();}}catch(e0){}
  try{window.speechSynthesis.getVoices();}catch(e1){}

  /*
    V40's old blank-utterance unlock was rejected as "empty" before WebKit ever
    received it. Use an allowed startup phrase once so iOS actually opens the
    speech lane. This is expected startup guidance, not extra chatter.
  */
  try{
    if(window.__SLX_FOUNDATION_SPEAK__ && window.SpeechSynthesisUtterance){
      u=new SpeechSynthesisUtterance("Route is active");
      u.lang="en-US";
      u.rate=0.96;
      u.pitch=1;
      u.volume=1;
      window.__SLX_FOUNDATION_SPEAK__(u);
    }
  }catch(e2){}
}

function queueManeuver(line){
  if(!line){return false;}

  try{
    if(typeof slxV2GQueueSpeech==="function"){
      return slxV2GQueueSpeech(line,"maneuver",120)!==false;
    }
  }catch(e0){}

  try{
    if(window.__SLX_FOUNDATION_SPEAK__ && window.SpeechSynthesisUtterance){
      var u=new SpeechSynthesisUtterance(line);
      u.lang="en-US";
      u.rate=0.96;
      u.pitch=1;
      u.volume=1;
      window.__SLX_FOUNDATION_SPEAK__(u);
      return true;
    }
  }catch(e1){}

  return false;
}

function voiceTick(){
  var step,remain,b,key,line;

  if(!tripOn()||!window.speechSynthesis){return;}
  if(!movementReady()){return;}

  step=activeStep();
  if(!step){return;}

  remain=remaining(step);
  if(!finite(remain)){return;}

  b=bucket(step,remain);
  if(!b){return;}

  key=stepKey(step)+"|"+b;
  if(V42.spoken[key]){return;}

  line=voiceLine(step,b,remain);
  if(!line){return;}

  if(queueManeuver(line)){
    V42.spoken[key]=Date.now();
  }
}

function tick(){
  if(!tripOn()){
    V42.origin=null;
    V42.moving=false;
    V42.spoken={};
    V42.lastActiveKey="";
    return;
  }

  renderStreet();
  voiceTick();
}

/*
  Stop the V41 CURRENT-street overwrite only. It was intentionally visual-only
  and was fighting the maneuver-target street name that belongs on Turn Card IQ.
*/
try{
  if(window.SLXV41CurrentStreetCard &&
     window.SLXV41CurrentStreetCard.state &&
     window.SLXV41CurrentStreetCard.state.timer){
    clearInterval(window.SLXV41CurrentStreetCard.state.timer);
    window.SLXV41CurrentStreetCard.state.timer=null;
  }
}catch(eV41){}

/* Prime iOS speech on the next real user gesture while a trip is active. */
try{
  document.addEventListener("touchend",prime,true);
  document.addEventListener("click",prime,true);
  document.addEventListener("pointerup",prime,true);
}catch(eEvents){}

/* Also attempt startup for already-unlocked browser sessions. */
setTimeout(prime,250);
setTimeout(tick,100);
setTimeout(tick,600);
setTimeout(tick,1400);
V42.timer=setInterval(tick,350);

window.SLXV42StreetVoiceRestore={
  renderStreet:renderStreet,
  voiceTick:voiceTick,
  prime:prime,
  roadName:roadName,
  active:activeStep,
  state:V42
};

try{
  console.log("Semi Locator V42 street-name + maneuver-voice restore loaded");
}catch(eBoot){}

})();


/* ============================================================================
   SEMI LOCATOR V43 — TRUCKER QUALITY STOP INTELLIGENCE
   ============================================================================
   FINAL AUTHORITY PATCH.

   Product signals locked in from driver feedback:
   - Safe/reliable parking remains core.
   - Real food / local restaurants matter.
   - Fast food should not dominate stop discovery.
   - Truck-friendly access evidence should outrank generic nearby POIs.
   - Rest / fuel / service stay important.
   - Preserve current route, camera, pin, speech, street-name and cockpit logic.

   This block intentionally loads LAST so it owns Scan Stops after older
   scanStopsGeoapify declarations earlier in this file.

   ES5-safe.
   ============================================================================ */
(function(){
"use strict";

if(window.__SLX_TRUCKER_QUALITY_STOPS_V43__){return;}
window.__SLX_TRUCKER_QUALITY_STOPS_V43__=true;
window.SLX_DRIVER_STOP_INTELLIGENCE_BUILD="V43_TRUCKER_QUALITY_STOPS";

var V43={
  lastResults:[],
  lastFoodCount:0,
  lastTruckCount:0,
  lastScanAt:0
};

function clean(v){
  return String(v==null?"":v).replace(/\s+/g," ").trim();
}

function lower(v){
  return clean(v).toLowerCase();
}

function finite(n){
  return typeof n==="number" && isFinite(n);
}

function currentOrigin(){
  var f=null;
  try{ if(typeof getScanFix==="function"){ f=getScanFix(); } }catch(e0){}
  if(f&&finite(Number(f.lat))&&finite(Number(f.lng))){return f;}

  try{ f=currentFix||routeTargetFix||rawFix||null; }catch(e1){}
  if(f&&finite(Number(f.lat))&&finite(Number(f.lng))){return f;}

  return null;
}

function miles(a,b){
  var R=3958.8;
  var dLat,dLon,lat1,lat2,x;

  if(!a||!b){return 9999;}

  dLat=(Number(b[1])-Number(a[1]))*Math.PI/180;
  dLon=(Number(b[0])-Number(a[0]))*Math.PI/180;
  lat1=Number(a[1])*Math.PI/180;
  lat2=Number(b[1])*Math.PI/180;

  x=Math.sin(dLat/2)*Math.sin(dLat/2)+
    Math.sin(dLon/2)*Math.sin(dLon/2)*
    Math.cos(lat1)*Math.cos(lat2);

  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}

function isFastFood(txt){
  txt=lower(txt);

  return (
    txt.indexOf("fast_food")>-1 ||
    txt.indexOf("fast food")>-1 ||
    txt.indexOf("mcdonald")>-1 ||
    txt.indexOf("burger king")>-1 ||
    txt.indexOf("wendy")>-1 ||
    txt.indexOf("taco bell")>-1 ||
    txt.indexOf("subway")>-1 ||
    txt.indexOf("kfc")>-1 ||
    txt.indexOf("popeyes")>-1 ||
    txt.indexOf("arby")>-1 ||
    txt.indexOf("sonic")>-1 ||
    txt.indexOf("hardee")>-1 ||
    txt.indexOf("carl's jr")>-1 ||
    txt.indexOf("carls jr")>-1 ||
    txt.indexOf("jack in the box")>-1
  );
}

function isRealFood(txt){
  txt=lower(txt);

  if(isFastFood(txt)){return false;}

  return (
    txt.indexOf("restaurant")>-1 ||
    txt.indexOf("diner")>-1 ||
    txt.indexOf("barbecue")>-1 ||
    txt.indexOf("bbq")>-1 ||
    txt.indexOf("grill")>-1 ||
    txt.indexOf("steakhouse")>-1 ||
    txt.indexOf("breakfast")>-1 ||
    txt.indexOf("country kitchen")>-1 ||
    txt.indexOf("home cooking")>-1 ||
    txt.indexOf("home-style")>-1 ||
    txt.indexOf("homestyle")>-1 ||
    txt.indexOf("family restaurant")>-1 ||
    txt.indexOf("soul food")>-1 ||
    txt.indexOf("cafe")>-1
  );
}

function hasTruckAccessEvidence(txt){
  txt=lower(txt);

  return (
    txt.indexOf("truck parking")>-1 ||
    txt.indexOf("truck stop")>-1 ||
    txt.indexOf("travel center")>-1 ||
    txt.indexOf("travel plaza")>-1 ||
    txt.indexOf("pilot")>-1 ||
    txt.indexOf("flying j")>-1 ||
    txt.indexOf("love's")>-1 ||
    txt.indexOf("loves")>-1 ||
    txt.indexOf("petro")>-1 ||
    txt.indexOf("travelcenters of america")>-1 ||
    txt.indexOf("ta ")===0 ||
    txt.indexOf("ta travel")>-1 ||
    txt.indexOf("rest area")>-1 ||
    txt.indexOf("service plaza")>-1 ||
    txt.indexOf("welcome center")>-1
  );
}

function isBigLotEvidence(txt){
  txt=lower(txt);

  return (
    txt.indexOf("walmart")>-1 ||
    txt.indexOf("sam's club")>-1 ||
    txt.indexOf("sams club")>-1 ||
    txt.indexOf("costco")>-1 ||
    txt.indexOf("home depot")>-1 ||
    txt.indexOf("lowe")>-1 ||
    txt.indexOf("tractor supply")>-1 ||
    txt.indexOf("supercenter")>-1
  );
}

function isRest(txt){
  txt=lower(txt);
  return txt.indexOf("rest area")>-1 ||
    txt.indexOf("welcome center")>-1 ||
    txt.indexOf("service plaza")>-1;
}

function isFuel(txt){
  txt=lower(txt);
  return txt.indexOf("fuel")>-1 ||
    txt.indexOf("diesel")>-1 ||
    txt.indexOf("gas station")>-1 ||
    txt.indexOf("truck stop")>-1 ||
    txt.indexOf("travel center")>-1 ||
    txt.indexOf("pilot")>-1 ||
    txt.indexOf("flying j")>-1 ||
    txt.indexOf("love's")>-1 ||
    txt.indexOf("loves")>-1 ||
    txt.indexOf("petro")>-1;
}

function isService(txt){
  txt=lower(txt);
  return txt.indexOf("truck repair")>-1 ||
    txt.indexOf("tire")>-1 ||
    txt.indexOf("mechanic")>-1 ||
    txt.indexOf("fleet service")>-1 ||
    txt.indexOf("repair")>-1;
}

function isParking(txt){
  txt=lower(txt);
  return txt.indexOf("parking")>-1 ||
    txt.indexOf("truck stop")>-1 ||
    txt.indexOf("rest area")>-1 ||
    isBigLotEvidence(txt);
}

function classify(txt){
  if(isRest(txt)){return "rest_area";}
  if(isRealFood(txt)){return "food";}
  if(isService(txt)){return "service";}
  if(isFuel(txt)){return "fuel";}
  if(isParking(txt)){return "parking";}
  if(isFastFood(txt)){return "food";}
  return "surface_stop";
}

function markerLabel(type,txt){
  if(type==="food"){return "E";}
  if(type==="fuel"){return "F";}
  if(type==="rest_area"){return "R";}
  if(type==="service"){return "S";}
  if(type==="parking"){return "P";}
  if(isBigLotEvidence(txt)){return "P";}
  return "•";
}

function scoreCandidate(c){
  var txt=lower(
    (c&&c.name)+" "+
    (c&&c.label)+" "+
    (c&&c.categories)+" "+
    (c&&c.searchTerm)+" "+
    (c&&c.type)
  );

  var d=Number(c&&c.distMiles);
  var score=0;

  if(!finite(d)){d=9999;}

  /* Distance matters, but usefulness matters more. */
  if(d<=2){score+=80;}
  else if(d<=5){score+=64;}
  else if(d<=8){score+=48;}
  else if(d<=12){score+=30;}
  else if(d<=20){score+=16;}

  /* Core truck stop evidence. */
  if(hasTruckAccessEvidence(txt)){score+=125;}
  if(isRest(txt)){score+=90;}
  if(isFuel(txt)){score+=70;}
  if(isService(txt)){score+=52;}

  /* Driver feedback: real food should be surfaced, not buried. */
  if(isRealFood(txt)){
    score+=92;
    if(d<=8){score+=38;}
    if(d<=4){score+=24;}
  }

  /* Keep fast food available but stop it from dominating. */
  if(isFastFood(txt)){score-=46;}

  /* Large lots may be useful, but are not automatically "truck approved." */
  if(isBigLotEvidence(txt)){
    score+=42;
    c.largeLotCandidate=true;
  }

  if(String(c&&c.scanMode||"")==="nearby"){score+=24;}
  if(String(c&&c.scanMode||"")==="ahead"){score+=14;}

  return score;
}

function normalizeFeature(feature,origin,mode,source,searchTerm){
  var p=feature&&feature.properties||{};
  var g=feature&&feature.geometry||{};
  var c=g&&g.coordinates||null;
  var cats="";
  var name="";
  var txt="";
  var d=9999;
  var type="";
  var out;

  if(!c||c.length<2){return null;}

  name=clean(
    p.name||
    p.name_preferred||
    p.address_line1||
    p.formatted||
    searchTerm||
    "Useful stop"
  );

  try{
    cats=Array.isArray(p.categories)?p.categories.join(" "):clean(p.categories||p.category);
  }catch(e0){
    cats=clean(p.categories||p.category);
  }

  txt=lower(name+" "+cats+" "+clean(searchTerm));
  type=classify(txt);

  d=miles(
    [Number(origin.lng),Number(origin.lat)],
    [Number(c[0]),Number(c[1])]
  );

  if(!finite(d)||d>25){return null;}

  /*
    Do not fill the map with random generic businesses.
    Keep places that map to an actual driver need.
  */
  if(
    type==="surface_stop" &&
    !hasTruckAccessEvidence(txt) &&
    !isBigLotEvidence(txt)
  ){
    return null;
  }

  out={
    label:name,
    name:name,
    type:type,
    coord:[Number(c[0]),Number(c[1])],
    distMiles:d,
    confidence:0,
    scanScore:0,
    scanMode:mode||"nearby",
    source:source||"geoapify-v43",
    categories:cats,
    searchTerm:clean(searchTerm),
    truckFriendly:hasTruckAccessEvidence(txt),
    truckAccessEvidence:hasTruckAccessEvidence(txt),
    largeLotCandidate:isBigLotEvidence(txt),
    realFood:isRealFood(txt),
    fastFood:isFastFood(txt),
    markerLabel:markerLabel(type,txt)
  };

  out.scanScore=scoreCandidate(out);
  out.confidence=out.scanScore;

  return out;
}

function dedupeAndRank(lists){
  var all=[];
  var seen={};
  var i,j,c,key,old;

  for(i=0;i<lists.length;i++){
    for(j=0;j<(lists[i]||[]).length;j++){
      c=lists[i][j];
      if(!c||!c.coord){continue;}

      key=
        String(Number(c.coord[0]).toFixed(4))+","+
        String(Number(c.coord[1]).toFixed(4))+"|"+
        lower(c.name||c.label);

      if(seen[key]!==undefined){
        old=all[seen[key]];
        if(Number(c.scanScore||0)>Number(old.scanScore||0)){
          all[seen[key]]=c;
        }
        continue;
      }

      seen[key]=all.length;
      all.push(c);
    }
  }

  all.sort(function(a,b){
    var as=Number(a.scanScore||0);
    var bs=Number(b.scanScore||0);
    var ad=finite(Number(a.distMiles))?Number(a.distMiles):9999;
    var bd=finite(Number(b.distMiles))?Number(b.distMiles):9999;

    if(bs!==as){return bs-as;}
    return ad-bd;
  });

  return balancedTop(all);
}

function balancedTop(all){
  var out=[];
  var truck=[];
  var food=[];
  var restFuel=[];
  var service=[];
  var parking=[];
  var other=[];
  var used={};
  var i,c,txt;

  function pushUnique(arr,max){
    var x,item,key;
    for(x=0;x<arr.length;x++){
      if(out.length>=20){return;}
      if(max&&x>=max){return;}
      item=arr[x];
      if(!item||!item.coord){continue;}
      key=String(Number(item.coord[0]).toFixed(4))+","+String(Number(item.coord[1]).toFixed(4));
      if(used[key]){continue;}
      used[key]=true;
      out.push(item);
    }
  }

  for(i=0;i<all.length;i++){
    c=all[i];
    txt=lower((c.name||"")+" "+(c.categories||"")+" "+(c.type||""));

    if(c.truckAccessEvidence){truck.push(c);}
    else if(c.realFood){food.push(c);}
    else if(isRest(txt)||isFuel(txt)){restFuel.push(c);}
    else if(isService(txt)){service.push(c);}
    else if(c.type==="parking"||c.largeLotCandidate){parking.push(c);}
    else{other.push(c);}
  }

  /*
    Balanced result deck:
    - core truck assets first
    - real food gets guaranteed space
    - then rest/fuel/service/parking
  */
  pushUnique(truck,6);
  pushUnique(food,6);
  pushUnique(restFuel,5);
  pushUnique(service,3);
  pushUnique(parking,5);
  pushUnique(other,20);
  pushUnique(all,20);

  return out.slice(0,20);
}

function placesUrl(lng,lat,radius,key){
  var cats=[
    "service.vehicle.parking",
    "service.vehicle.fuel",
    "service.vehicle.repair",
    "commercial.supermarket",
    "commercial.shopping_mall",
    "commercial.department_store",
    "catering.restaurant",
    "catering.fast_food",
    "catering.cafe",
    "accommodation"
  ].join(",");

  return "https://api.geoapify.com/v2/places?categories="+
    encodeURIComponent(cats)+
    "&filter=circle:"+
    encodeURIComponent(String(lng)+","+String(lat)+","+String(radius))+
    "&bias=proximity:"+
    encodeURIComponent(String(lng)+","+String(lat))+
    "&limit=50&apiKey="+encodeURIComponent(key);
}

function textUrl(term,lng,lat,radius,key){
  return "https://api.geoapify.com/v1/geocode/search?text="+
    encodeURIComponent(term)+
    "&filter=circle:"+
    encodeURIComponent(String(lng)+","+String(lat)+","+String(radius))+
    "&bias=proximity:"+
    encodeURIComponent(String(lng)+","+String(lat))+
    "&limit=10&apiKey="+encodeURIComponent(key);
}

function fetchJob(job,done){
  if(!window.fetch){done([]);return;}

  fetch(job.url)
    .then(function(r){return r.json();})
    .then(function(data){
      var feats=data&&data.features||[];
      var rows=[];
      var i,c;

      for(i=0;i<feats.length;i++){
        c=normalizeFeature(
          feats[i],
          job.origin,
          job.mode,
          job.source,
          job.term||""
        );
        if(c){rows.push(c);}
      }

      done(rows);
    })
    .catch(function(){done([]);});
}

function routeAheadPoints(f){
  var pts=[];

  try{
    if(typeof slxRouteAheadScanPoints==="function"){
      pts=slxRouteAheadScanPoints(f)||[];
    }
  }catch(e0){
    pts=[];
  }

  return pts.slice(0,3);
}

function runScan(f,key,done){
  var jobs=[];
  var results=[];
  var ahead=routeAheadPoints(f);
  var nearTerms=[
    "truck parking",
    "truck stop",
    "rest area",
    "diesel",
    "local restaurant",
    "diner",
    "barbecue",
    "breakfast restaurant"
  ];
  var i,pending;

  function addPlaces(lng,lat,radius,mode,source){
    jobs.push({
      url:placesUrl(lng,lat,radius,key),
      origin:{lng:lng,lat:lat},
      mode:mode,
      source:source
    });
  }

  function addText(term,lng,lat,radius,mode){
    jobs.push({
      url:textUrl(term,lng,lat,radius,key),
      origin:{lng:lng,lat:lat},
      mode:mode,
      source:"v43_"+term.toLowerCase().replace(/\s+/g,"_"),
      term:term
    });
  }

  /* Nearby — where the driver can actually stop now. */
  addPlaces(Number(f.lng),Number(f.lat),16000,"nearby","v43_nearby_places");

  for(i=0;i<nearTerms.length;i++){
    addText(nearTerms[i],Number(f.lng),Number(f.lat),14000,"nearby");
  }

  /* Ahead — lighter request footprint, still catches food + truck assets. */
  for(i=0;i<ahead.length;i++){
    addPlaces(
      Number(ahead[i].lng),
      Number(ahead[i].lat),
      7000,
      "ahead",
      "v43_ahead_places"
    );

    if(i<2){
      addText(
        "truck stop",
        Number(ahead[i].lng),
        Number(ahead[i].lat),
        9000,
        "ahead"
      );

      addText(
        "local restaurant",
        Number(ahead[i].lng),
        Number(ahead[i].lat),
        8000,
        "ahead"
      );
    }
  }

  pending=jobs.length;

  if(!pending){
    done([]);
    return;
  }

  function finish(rows){
    results.push(rows||[]);
    pending-=1;

    if(pending<=0){
      done(dedupeAndRank(results));
    }
  }

  for(i=0;i<jobs.length;i++){
    fetchJob(jobs[i],finish);
  }
}

function announce(list){
  var food=0;
  var truck=0;
  var i,c,msg;

  for(i=0;i<(list||[]).length;i++){
    c=list[i];
    if(c&&c.realFood){food+=1;}
    if(c&&c.truckAccessEvidence){truck+=1;}
  }

  V43.lastFoodCount=food;
  V43.lastTruckCount=truck;

  if(food>0&&truck>0){
    msg=String(truck)+" truck-focused stops and "+
      String(food)+" real-food options surfaced.";
  }else if(food>0){
    msg=String(food)+" real-food options surfaced nearby and ahead.";
  }else if(truck>0){
    msg=String(truck)+" truck-focused stops surfaced nearby and ahead.";
  }else{
    msg="Useful stops surfaced nearby and ahead.";
  }

  try{
    if(typeof primeVoiceThenSpeak==="function"){
      primeVoiceThenSpeak(msg);
    }
  }catch(e0){}
}

function apply(list,forceVoice){
  var top=(list||[]).slice(0,16);
  var first=top.length?top[0]:null;
  var foodCount=0;
  var i;

  V43.lastResults=top.slice(0);
  V43.lastScanAt=Date.now();

  for(i=0;i<top.length;i++){
    if(top[i]&&top[i].realFood){foodCount+=1;}
  }

  if(top.length){
    try{
      if(typeof applyStopCandidates==="function"){
        applyStopCandidates(top,"geoapify-v43-quality-stops",false);
      }
    }catch(e0){}

    try{
      if(typeof setSubline==="function"){
        setSubline(
          foodCount>0
            ? "Useful stops + real food: "+clean(first&&first.label||"nearby")
            : "Useful stops surfaced: "+clean(first&&first.label||"nearby")
        );
      }
    }catch(e1){}

    if(forceVoice){announce(top);}
    return true;
  }

  return false;
}

/*
  FINAL Scan Stops authority.
  This replaces the later legacy scanStopsGeoapify declaration that was
  overwriting the better nearby/ahead scanner earlier in the file.
*/
scanStopsGeoapify=function(forceVoice){
  var f=currentOrigin();
  var key="";

  try{
    key=clean(window.SLX_GEOAPIFY_KEY||geoapifyKey||"");
  }catch(e0){
    key=clean(window.SLX_GEOAPIFY_KEY||"");
  }

  if(!f){
    try{if(typeof setSubline==="function"){setSubline("GPS fix missing");}}catch(e1){}
    return;
  }

  if(!key){
    try{if(typeof setSubline==="function"){setSubline("Geoapify key missing");}}catch(e2){}
    return;
  }

  try{
    if(typeof setSubline==="function"){
      setSubline("Scanning parking, real food, fuel, rest, and service...");
    }
  }catch(e3){}

  runScan(f,key,function(out){
    if(apply(out,!!forceVoice)){return;}

    /*
      Preserve existing fallback behavior if Geoapify returns nothing.
    */
    try{
      if(typeof scanStopsMapboxFallback==="function"){
        scanStopsMapboxFallback(forceVoice);
        return;
      }
    }catch(e4){}

    try{
      if(typeof window.slxFallbackScanStopsV1==="function"){
        window.slxFallbackScanStopsV1();
      }
    }catch(e5){}
  });
};

/* Optional explicit bridge for hard-recovery buttons that look for this name. */
window.slxScanCorridorStops=function(){
  scanStopsGeoapify(true);
};

window.SLXV43QualityStops={
  scan:function(forceVoice){scanStopsGeoapify(forceVoice!==false);},
  state:V43,
  isRealFood:isRealFood,
  isFastFood:isFastFood,
  hasTruckAccessEvidence:hasTruckAccessEvidence
};

try{
  console.log("Semi Locator V43 trucker quality-stop intelligence loaded");
}catch(eBoot){}

})();



/* [V52 CLEANUP: obsolete maneuver-card authority removed] */


/* ============================================================================
   SEMI LOCATOR V54 — TARGET ROAD FIRST / CURRENT ROAD NEVER-BLANK FALLBACK
   ============================================================================
   TRUE CARD REBUILD FOR THE V16 CLEAN HTML.

   This file no longer contains the old V14/V15/V20-V25/V28-V31/V41/V51
   maneuver-card presentation authorities.

   ONE EXISTING HTML CARD:
       #slxDriveIqTurnCardV2
         #slxDriveIqTurnMain  -> maneuver
         #slxDriveIqTurnRoad  -> street / road
         #slxDriveIqTurnSub   -> distance

   No generated overlay. No second card. No mutation-war observer.
   V42 remains available for maneuver voice and road-name hydration.
   V43 remains available for truck-stop intelligence.
   ============================================================================ */
(function(){
"use strict";

if(window.__SLX_V52_SINGLE_CANONICAL_MANEUVER_CARD__){ return; }
window.__SLX_V52_SINGLE_CANONICAL_MANEUVER_CARD__=true;
window.SLX_MANEUVER_CARD_BUILD="V54_TARGET_FIRST_CURRENT_ROAD_FALLBACK";

var V52={
  currentRoad:"",
  currentRoadKey:"",
  currentPending:false,
  targetPending:false,
  currentCache:{},
  targetCache:{},
  timer:null
};

function c(v){
  return String(v==null?"":v).replace(/\s+/g," ").trim();
}
function okNum(v){ return typeof v==="number" && isFinite(v); }

function badRoad(v){
  var s=c(v).toLowerCase();
  if(!s){ return true; }
  return /^(continue|continue straight|continue on route|stay on route|follow highlighted route|turn|turn left|turn right|left|right|straight|merge|exit|take the exit|fork|keep left|keep right|arrive|arrival|destination|route guidance|guidance ready|route active|route ready|navigation ready|street name loading|road name loading|road name unavailable|current road)$/i.test(s);
}

function normRoad(v){
  var s=c(v);
  if(!s || badRoad(s)){ return ""; }
  s=s.replace(/\binterstate\s+(\d{1,3})\b/ig,"I-$1");
  s=s.replace(/\bi\s+(\d{1,3})\b/ig,"I-$1");
  s=s.replace(/\bi-(\d{1,3})\b/ig,"I-$1");
  s=s.replace(/\bu\.s\.\s*(\d{1,3})\b/ig,"US-$1");
  s=s.replace(/\bus\s+(\d{1,3})\b/ig,"US-$1");
  s=s.replace(/\bhwy\s+(\d{1,3})\b/ig,"Highway $1");
  return c(s);
}

function raw(step){
  return (step && (step.rawStep || step.raw)) || step || {};
}
function man(step){
  var r=raw(step);
  return (step && step.maneuver) || r.maneuver || {};
}

function activeStep(){
  var s=null;
  try{
    if(typeof slxNavV2ActiveStep==="function"){
      s=slxNavV2ActiveStep();
      if(s){ return s; }
    }
  }catch(e0){}
  try{
    if(typeof maneuverSteps!=="undefined" && maneuverSteps &&
       maneuverSteps.length &&
       typeof maneuverIndex!=="undefined" &&
       maneuverIndex>=0 && maneuverIndex<maneuverSteps.length){
      return maneuverSteps[maneuverIndex];
    }
  }catch(e1){}
  return null;
}

function instruction(step){
  var r=raw(step),m=man(step),b=null,arr=[],x;
  function add(v){ x=c(v); if(x){ arr.push(x); } }

  add(step && step.instruction);
  add(step && step.announceLabel);
  add(step && step.voiceInstruction);
  add(step && step.voice_instruction);
  add(step && step.transition_instruction);
  add(step && step.verbal_pre_transition_instruction);
  add(step && step.verbal_post_transition_instruction);

  add(r.instruction);
  add(r.announceLabel);
  add(r.voiceInstruction);
  add(r.voice_instruction);
  add(r.transition_instruction);
  add(r.verbal_pre_transition_instruction);
  add(r.verbal_post_transition_instruction);

  add(m.instruction);
  add(m.text);

  try{
    b=(step && (step.bannerInstruction||step.banner_instruction)) ||
      r.bannerInstruction || r.banner_instruction || null;
    if(b){
      add(b.primary && b.primary.text);
      add(b.secondary && b.secondary.text);
      add(b.sub && b.sub.text);
    }
  }catch(e0){}

  return arr.join(" ");
}

function roadFromInstruction(v){
  var s=c(v),m;
  if(!s){ return ""; }

  m=s.match(/\b(?:onto|on|toward|towards|for|via|stay on|continue onto)\s+([A-Z0-9][A-Za-z0-9'.\- ]{1,70}(?:Road|Rd|Street|St|Avenue|Ave|Boulevard|Blvd|Drive|Dr|Lane|Ln|Parkway|Pkwy|Highway|Hwy|Circle|Cir|Court|Ct|Way|Trail|Trl|Freeway|Expressway|Bypass))\b/i);
  if(m&&m[1]){ return normRoad(m[1]); }

  m=s.match(/\b(I[-\s]?\d{1,3}[A-Z]?|Interstate\s+\d{1,3}|US[-\s]?\d{1,3}[A-Z]?|U\.S\.\s*\d{1,3}[A-Z]?|SR[-\s]?\d{1,3}[A-Z]?|State Route\s+\d+[A-Z]?|Highway\s+\d+[A-Z]?|Hwy\s+\d+[A-Z]?)(?:\s+(?:N|S|E|W|North|South|East|West))?\b/i);
  if(m&&m[1]){ return normRoad(m[0]); }

  return "";
}

function explicitRoad(step){
  var r=raw(step),m=man(step),card=(step&&step.card)||r.card||{},vals,i,x;

  vals=[
    step&&step.roadName,step&&step.road_name,step&&step.streetName,step&&step.street_name,
    step&&step.street,step&&step.road,step&&step.name,step&&step.ref,step&&step.route,
    step&&step.toRoad,step&&step.to_road,

    r.roadName,r.road_name,r.streetName,r.street_name,r.street,r.road,r.name,r.ref,r.route,
    r.toRoad,r.to_road,

    m.roadName,m.road_name,m.streetName,m.street_name,m.street,m.road,m.name,m.ref,

    card.primary,card.roadName,card.road_name
  ];

  for(i=0;i<vals.length;i++){
    x=normRoad(vals[i]);
    if(x){ return x; }
  }

  return roadFromInstruction(instruction(step));
}

function currentFixValue(){
  var f=null;
  try{ f=currentFix || rawFix || routeTargetFix || null; }catch(e0){}
  if(f && okNum(Number(f.lat)) && okNum(Number(f.lng))){ return f; }
  try{
    if(window.__SLX_CORE_BRIDGE__ &&
       typeof window.__SLX_CORE_BRIDGE__.getCurrentFix==="function"){
      f=window.__SLX_CORE_BRIDGE__.getCurrentFix();
    }
  }catch(e1){}
  if(f && okNum(Number(f.lat)) && okNum(Number(f.lng))){ return f; }
  return null;
}

function stepCoord(step){
  var r=raw(step),m=man(step),p=null;
  try{
    p=(step&&(step.coord||step.location||step.coordinates||step.point)) ||
      m.location || m.coordinates ||
      r.location || r.coordinates ||
      (r.maneuver&&(r.maneuver.location||r.maneuver.coordinates));
  }catch(e0){}
  if(p&&p.length>=2&&okNum(Number(p[0]))&&okNum(Number(p[1]))){
    return [Number(p[0]),Number(p[1])];
  }
  if(step&&okNum(Number(step.lng))&&okNum(Number(step.lat))){
    return [Number(step.lng),Number(step.lat)];
  }
  return null;
}

function apiKey(){
  return c(window.SLX_GEOAPIFY_KEY || (typeof geoapifyKey!=="undefined" ? geoapifyKey : ""));
}


/*
  MAP LABEL FALLBACK
  The live Mapbox map already renders street names. If provider step metadata
  and reverse geocoding do not yield the road, read the rendered road label
  nearest the maneuver/current coordinate.
*/
function coreMap(){
  try{
    if(window.__SLX_CORE_BRIDGE__ &&
       typeof window.__SLX_CORE_BRIDGE__.getMap==="function"){
      return window.__SLX_CORE_BRIDGE__.getMap();
    }
  }catch(e0){}
  return null;
}

function roadFromRenderedMap(lng,lat){
  var m=coreMap(),pt,features,i,p,r,layerId,srcLayer;
  if(!m || !m.project || !m.queryRenderedFeatures){ return ""; }

  try{
    pt=m.project([Number(lng),Number(lat)]);
    features=m.queryRenderedFeatures(
      [[pt.x-26,pt.y-26],[pt.x+26,pt.y+26]]
    ) || [];
  }catch(e0){
    return "";
  }

  for(i=0;i<features.length;i++){
    p=features[i] && features[i].properties ? features[i].properties : {};
    layerId=c(features[i] && features[i].layer && features[i].layer.id).toLowerCase();
    srcLayer=c(features[i] && features[i].sourceLayer).toLowerCase();

    if(
      layerId.indexOf("road")<0 &&
      layerId.indexOf("street")<0 &&
      layerId.indexOf("transport")<0 &&
      srcLayer.indexOf("road")<0 &&
      srcLayer.indexOf("transport")<0
    ){
      continue;
    }

    r=normRoad(
      p.name_en || p.name || p.name_local ||
      p.ref || p.road || p.street
    );

    if(r){ return r; }
  }

  return "";
}

function currentRoadFromMap(){
  var f=currentFixValue();
  if(!f){ return ""; }
  return roadFromRenderedMap(f.lng,f.lat);
}

function targetRoadFromMap(step){
  var p=stepCoord(step);
  if(!p){ return ""; }
  return roadFromRenderedMap(p[0],p[1]);
}

function reverseUrl(lng,lat,key){
  return "https://api.geoapify.com/v1/geocode/reverse?lat="+
    encodeURIComponent(String(lat))+
    "&lon="+encodeURIComponent(String(lng))+
    "&format=geojson&apiKey="+encodeURIComponent(key);
}

function geoRoad(data){
  var f=data&&data.features&&data.features[0];
  var p=f&&f.properties?f.properties:{};
  var r=normRoad(p.street);
  if(r){ return r; }

  r=normRoad(p.address_line1);
  if(r){
    r=normRoad(r.replace(/^\d+[A-Za-z\-]*\s+/,""));
    if(r){ return r; }
  }

  return normRoad(p.name);
}

function currentLookup(){
  var f=currentFixValue(),key=apiKey(),k;
  if(!f||!key||!window.fetch||V52.currentPending){ return; }

  k=Number(f.lat).toFixed(4)+","+Number(f.lng).toFixed(4);

  if(V52.currentCache[k]){
    V52.currentRoad=V52.currentCache[k];
    V52.currentRoadKey=k;
    return;
  }
  if(V52.currentRoadKey===k && V52.currentRoad){ return; }

  V52.currentPending=true;
  fetch(reverseUrl(f.lng,f.lat,key))
    .then(function(res){ return res.json(); })
    .then(function(data){
      var r=geoRoad(data);
      if(r){
        V52.currentCache[k]=r;
        V52.currentRoad=r;
        V52.currentRoadKey=k;
        try{ if(speedState){ speedState.roadName=r; } }catch(e0){}
      }
      V52.currentPending=false;
      render();
    })
    .catch(function(){ V52.currentPending=false; });
}

function targetKey(step){
  var p=stepCoord(step);
  return (p?Number(p[0]).toFixed(5)+","+Number(p[1]).toFixed(5):"")+"|"+instruction(step);
}

function targetLookup(step){
  var p=stepCoord(step),key=apiKey(),k=targetKey(step);
  if(!p||!key||!window.fetch||V52.targetPending||V52.targetCache[k]){ return; }

  V52.targetPending=true;
  fetch(reverseUrl(p[0],p[1],key))
    .then(function(res){ return res.json(); })
    .then(function(data){
      var r=geoRoad(data);
      if(r){
        V52.targetCache[k]=r;
        try{
          step.roadName=r; step.road_name=r; step.streetName=r;
          step.street_name=r; step.street=r; step.road=r;
        }catch(e0){}
      }
      V52.targetPending=false;
      render();
    })
    .catch(function(){ V52.targetPending=false; });
}

function actionType(step){
  var a="",t=instruction(step).toLowerCase();
  try{
    if(typeof slxV2GAction==="function"){ a=c(slxV2GAction(step)).toLowerCase(); }
  }catch(e0){}

  if(a.indexOf("left")>=0 || /\bturn left\b/.test(t)){ return "left"; }
  if(a.indexOf("right")>=0 || /\bturn right\b/.test(t)){ return "right"; }
  if(a.indexOf("merge")>=0 || /\bmerge\b/.test(t)){ return "merge"; }
  if(a.indexOf("exit")>=0 || /\bexit\b/.test(t)){ return "exit"; }
  if(a.indexOf("roundabout")>=0 || /\broundabout\b/.test(t)){ return "roundabout"; }
  if(a.indexOf("arriv")>=0 || /\barriv/.test(t)){ return "arrive"; }
  if(a.indexOf("keep left")>=0 || /\bkeep left\b/.test(t)){ return "keep_left"; }
  if(a.indexOf("keep right")>=0 || /\bkeep right\b/.test(t)){ return "keep_right"; }
  return "continue";
}

function actionLabel(step){
  var a=actionType(step);
  if(a==="left"){ return "Turn left"; }
  if(a==="right"){ return "Turn right"; }
  if(a==="merge"){ return "Merge"; }
  if(a==="exit"){ return "Take the exit"; }
  if(a==="roundabout"){ return "Enter roundabout"; }
  if(a==="arrive"){ return "Arrive"; }
  if(a==="keep_left"){ return "Keep left"; }
  if(a==="keep_right"){ return "Keep right"; }
  return "Continue";
}

function roadLabel(step){
  var type=actionType(step),r="";

  /* V66: use the live authoritative maneuver instruction FIRST.
     Verified on the iPhone: "Turn left onto Horn Lake Road.".
     Never substitute the road under the truck for a future turn. */
  if(step){
    try{
      var core=window.__SLX_CORE_BRIDGE__;
      var live=(core && typeof core.getActiveManeuverStep==="function")
        ? core.getActiveManeuverStep() : null;
      var active=live||step;
      var text=String((active && (active.instruction||active.instruction_text)) || instruction(active) || "");
      var parts=text.split(/\bonto\b/i);
      if(parts.length>1){
        r=parts.slice(1).join(" onto ").trim().replace(/[.!]+$/g,"").trim();
        if(r && !/^(the |a |current road|route)$/i.test(r)){return r;}
      }
    }catch(eV66){}
  }

  /* Continue means CURRENT road first. */
  if(type==="continue"){
    try{
      if(speedState && speedState.roadName){
        r=normRoad(speedState.roadName);
        if(r){ return r; }
      }
    }catch(e0){}

    if(V52.currentRoad){ return V52.currentRoad; }

    r=currentRoadFromMap();
    if(r){
      V52.currentRoad=r;
      try{ if(speedState){ speedState.roadName=r; } }catch(eMapCurrent){}
      return r;
    }

    currentLookup();

    r=explicitRoad(step);
    if(r){ return r; }

    return "Follow current road";
  }

  /*
    Decision maneuver:
    1) target road if provider already knows it
    2) target road from rendered map / reverse lookup cache
    3) CURRENT road as immediate never-blank fallback while target hydrates

    The driver should never stare at "Road name loading" during a live route
    when the map already knows the road beneath the truck.
  */
  r=explicitRoad(step);
  if(r){ return r; }

  r=targetRoadFromMap(step);
  if(r){
    try{
      step.roadName=r; step.road_name=r; step.streetName=r;
      step.street_name=r; step.street=r; step.road=r;
    }catch(eMapTarget){}
    return r;
  }

  var k=targetKey(step);
  if(V52.targetCache[k]){ return V52.targetCache[k]; }

  /* Start target hydration, but do not block the visible card on it. */
  targetLookup(step);

  try{
    if(speedState && speedState.roadName){
      r=normRoad(speedState.roadName);
      if(r){ return r; }
    }
  }catch(eCurrentState){}

  if(V52.currentRoad){ return V52.currentRoad; }

  r=currentRoadFromMap();
  if(r){
    V52.currentRoad=r;
    try{ if(speedState){ speedState.roadName=r; } }catch(eCurrentMap){}
    return r;
  }

  currentLookup();

  /*
    Last-resort live-navigation copy. We no longer expose a provider/loading
    implementation state to the driver.
  */
  return "Follow current road";
}

function distanceLabel(step){
  var mi=null;
  try{
    if(typeof slxNavV2RemainingToStep==="function"){
      mi=Number(slxNavV2RemainingToStep(step));
    }
  }catch(e0){ mi=null; }

  if(mi!==null && okNum(mi) && mi>=0){
    if(mi<0.1894){
      return String(Math.max(50,Math.round(mi*5280/50)*50))+" ft ahead";
    }
    if(mi<10){
      return String(Math.round(mi*10)/10)+" mi ahead";
    }
    return String(Math.round(mi))+" mi ahead";
  }
  return "Follow highlighted route";
}

function write(id,value){
  var el=document.getElementById(id);
  var v=c(value);
  if(id==="slxDriveIqTurnRoad"){
    try{
      var core=window.__SLX_CORE_BRIDGE__;
      var active=core&&typeof core.getActiveManeuverStep==="function"
        ? core.getActiveManeuverStep():null;
      var instructionText=active&&active.instruction ? String(active.instruction):"";
      var parts=instructionText.split(/\bonto\b/i);
      if(parts.length>1){
        var target=parts.slice(1).join(" onto ").trim().replace(/[.!]+$/g,"").trim();
        if(target){v=target;}
      }else if(active && v==="Follow current road"){
        v="Road name unavailable";
      }
    }catch(eRoadV66){}
  }
  if(el && v && c(el.textContent)!==v){ el.textContent=v; }
}

function render(){
  var card=document.getElementById("slxDriveIqTurnCardV2");
  var step=activeStep();

  if(!card){ return; }

  /* Never create a second card. The V16 HTML owns the physical surface. */
  card.style.setProperty("display","block","important");
  card.style.setProperty("visibility","visible","important");
  card.style.setProperty("opacity","1","important");

  if(!step){
    var idleRoad="";

    /*
      V56:
      The driver can be stationary and still deserves a real street name.
      The map already knows the road under the truck, so read that label first.
      Do not wait for movement and do not expose "Road name loading".
    */
    try{
      if(speedState && speedState.roadName){
        idleRoad=normRoad(speedState.roadName);
      }
    }catch(eIdle0){}

    if(!idleRoad && V52.currentRoad){
      idleRoad=normRoad(V52.currentRoad);
    }

    if(!idleRoad){
      idleRoad=currentRoadFromMap();
      if(idleRoad){
        V52.currentRoad=idleRoad;
        try{ if(speedState){ speedState.roadName=idleRoad; } }catch(eIdle1){}
      }
    }

    write("slxDriveIqTurnMain","Continue");
    write("slxDriveIqTurnRoad",idleRoad || "Follow current road");
    write("slxDriveIqTurnSub","Turn guidance will start once rolling");

    if(!idleRoad){ currentLookup(); }

    /*
      Hydrate target maneuver names even while stopped so the first spoken
      instruction is ready before the truck begins moving.
    */
    try{
      if(window.SLXV55StreetAuthority &&
         typeof window.SLXV55StreetAuthority.hydrate==="function"){
        window.SLXV55StreetAuthority.hydrate();
      }
    }catch(eIdle2){}

    return;
  }

  write("slxDriveIqTurnMain",actionLabel(step));
  write("slxDriveIqTurnRoad",roadLabel(step));
  write("slxDriveIqTurnSub",distanceLabel(step));
}

setTimeout(currentLookup,80);
setTimeout(render,120);
setTimeout(render,450);
setTimeout(render,1100);

/* One low-frequency renderer. No observer. */
V52.timer=setInterval(render,240);

window.SLXV52CanonicalManeuverCard={
  state:V52,
  render:render,
  active:activeStep,
  road:roadLabel
};

try{
  console.log("✅ Semi Locator V54 — target road first, current road never-blank fallback loaded");
}catch(eBoot){}

})();


/* ============================================================================
   SEMI LOCATOR V55 — AUTHORITATIVE STREET-NAME HYDRATION
   Ports the proven Drive IQ V205 street-name strategy into Semi Locator.

   ONE JOB:
   - Ensure the active maneuver has the TARGET street/road name in both card
     and maneuver voice.

   DOES NOT:
   - replace route geometry
   - recreate map
   - move camera/pin
   - reroute
   - reload/navigate
   - own arrival/parking/freight intelligence

   METHOD:
   1) Read every provider street/road/ref/banner/instruction_detail field.
   2) Parse road names from provider instruction text.
   3) If route steps are unnamed/geometry-only, fetch Geoapify
      details=instruction_details ONCE for the current route signature.
   4) Map hydrated instruction steps onto the existing route by coordinate.
   5) Write those names back into routeSteps/maneuverSteps.
   6) Existing V2G/V54 card + voice consume the hydrated truth.
   ============================================================================ */
(function(window){
"use strict";

if(window.__SLX_V55_AUTHORITATIVE_STREET_NAMES__){return;}
window.__SLX_V55_AUTHORITATIVE_STREET_NAMES__=true;
window.SLX_STREET_NAME_BUILD="V56_STREET_NAMES_BEFORE_MOVEMENT";

var V55={
  busy:false,
  fetchedSignature:"",
  failedSignature:"",
  lastHydratedAt:0,
  lastNamedCount:0,
  retryTimer:null
};

function v55Clean(v){
  return String(v==null?"":v).replace(/\s+/g," ").trim();
}
function v55Finite(v){
  return typeof Number(v)==="number" && isFinite(Number(v));
}
function v55BadRoad(v){
  var s=v55Clean(v).toLowerCase();
  if(!s){return true;}
  return /^(continue|continue straight|continue on route|stay on route|follow highlighted route|turn|turn left|turn right|left|right|straight|merge|exit|take the exit|fork|keep left|keep right|arrive|arrival|destination|route guidance|guidance ready|route active|route ready|navigation ready|street name loading|road name loading|road name unavailable|current road|follow current road)$/i.test(s);
}
function v55NormRoad(v){
  var s=v55Clean(v);
  if(!s||v55BadRoad(s)){return "";}
  s=s.replace(/\binterstate\s+(\d{1,3})\b/ig,"I-$1");
  s=s.replace(/\bi\s+(\d{1,3})\b/ig,"I-$1");
  s=s.replace(/\bi-(\d{1,3})\b/ig,"I-$1");
  s=s.replace(/\bu\.s\.\s*(\d{1,3})\b/ig,"US-$1");
  s=s.replace(/\bus\s+(\d{1,3})\b/ig,"US-$1");
  s=s.replace(/\bhwy\s+(\d{1,3})\b/ig,"Highway $1");
  return v55Clean(s);
}
function v55First(){
  var i,s;
  for(i=0;i<arguments.length;i++){
    s=v55NormRoad(arguments[i]);
    if(s){return s;}
  }
  return "";
}
function v55Raw(step){
  return (step&&(step.rawStep||step.raw))||step||{};
}
function v55Man(step){
  var r=v55Raw(step);
  return (step&&step.maneuver)||r.maneuver||{};
}

function v55InstructionText(step){
  if(!step){return "";}
  var r=v55Raw(step),m=v55Man(step),arr=[],d,b,k,v;

  function add(x){
    if(typeof x==="string"||typeof x==="number"){
      x=v55Clean(x);
      if(x){arr.push(x);}
    }
  }

  try{
    add(step.instruction);
    add(step.instruction_text);
    add(step.text);
    add(step.description);
    add(step.announceLabel);
    add(step.voiceInstruction);
    add(step.voice_instruction);
    add(step.transition_instruction);
    add(step.verbal_pre_transition_instruction);
    add(step.verbal_post_transition_instruction);
    add(step.type);
    add(step.modifier);
    add(step.direction);
    add(step.action);
    add(step.name);
    add(step.street_name);
    add(step.street);
    add(step.road);
    add(step.way_name);
    add(step.ref);
    add(step.exit);
    add(step.destination);

    add(r.instruction);
    add(r.instruction_text);
    add(r.text);
    add(r.description);
    add(r.voiceInstruction);
    add(r.voice_instruction);
    add(r.transition_instruction);
    add(r.verbal_pre_transition_instruction);
    add(r.verbal_post_transition_instruction);
    add(r.type);
    add(r.modifier);
    add(r.direction);
    add(r.action);
    add(r.name);
    add(r.street_name);
    add(r.street);
    add(r.road);
    add(r.way_name);
    add(r.ref);
    add(r.exit);
    add(r.destination);

    add(m.instruction);
    add(m.text);
    add(m.type);
    add(m.modifier);
    add(m.direction);
    add(m.action);
    add(m.name);
    add(m.street);
    add(m.road);
    add(m.ref);
    add(m.destination);

    d=step.instruction_details||r.instruction_details||null;
    if(typeof d==="string"){
      add(d);
    }else if(d&&typeof d==="object"){
      for(k in d){
        if(!Object.prototype.hasOwnProperty.call(d,k)){continue;}
        v=d[k];
        if(typeof v==="string"||typeof v==="number"){
          add(v);
        }else if(v&&typeof v==="object"){
          add(v.text);add(v.instruction);add(v.type);add(v.modifier);
          add(v.direction);add(v.action);add(v.name);add(v.street_name);
          add(v.street);add(v.road);add(v.way_name);add(v.ref);
          add(v.exit);add(v.destination);
        }
      }
    }

    b=step.bannerInstruction||step.banner_instruction||
      r.bannerInstruction||r.banner_instruction||null;
    if(b){
      add(b.primary&&b.primary.text);
      add(b.secondary&&b.secondary.text);
      add(b.sub&&b.sub.text);
      if(b.primary&&b.primary.components){
        for(k=0;k<b.primary.components.length;k++){
          add(b.primary.components[k]&&b.primary.components[k].text);
        }
      }
    }
  }catch(e){}

  return v55Clean(arr.join(" "));
}

function v55RoadFromText(text){
  var s=v55Clean(text),m,i;
  if(!s){return "";}

  var patterns=[
    /\b(?:onto|on|toward|towards|for)\s+((?:I[-\s]?\d{1,3}|Interstate\s+\d{1,3}|US[-\s]?\d{1,3}|U\.S\.\s*\d{1,3}|Hwy\s+\d{1,3}|Highway\s+\d{1,3}|SR[-\s]?\d{1,3}|TN[-\s]?\d{1,3}|MS[-\s]?\d{1,3}|AR[-\s]?\d{1,3})(?:\s+[NSEW]|\s+North|\s+South|\s+East|\s+West)?)/i,
    /\b((?:I[-\s]?\d{1,3}|Interstate\s+\d{1,3}|US[-\s]?\d{1,3}|U\.S\.\s*\d{1,3}|Hwy\s+\d{1,3}|Highway\s+\d{1,3})(?:\s+[NSEW]|\s+North|\s+South|\s+East|\s+West)?)\b/i,
    /\b(?:onto|on|toward|towards|for|to|via|stay on|continue onto)\s+([A-Z0-9][A-Za-z0-9'.\- ]{1,70}\s(?:Road|Rd|Street|St|Avenue|Ave|Boulevard|Blvd|Drive|Dr|Lane|Ln|Parkway|Pkwy|Highway|Hwy|Freeway|Expressway|Bypass|Circle|Cir|Court|Ct|Way|Trail|Trl))\b/i,
    /\b(?:continue|head|turn|merge|keep)\s+(?:left\s+|right\s+)?(?:onto|on|toward|towards|for|to)?\s*([A-Z0-9][A-Za-z0-9'.\- ]{1,70}\s(?:Road|Rd|Street|St|Avenue|Ave|Boulevard|Blvd|Drive|Dr|Lane|Ln|Parkway|Pkwy|Highway|Hwy|Freeway|Expressway|Bypass|Circle|Cir|Court|Ct|Way|Trail|Trl))\b/i
  ];

  for(i=0;i<patterns.length;i++){
    m=s.match(patterns[i]);
    if(m&&m[1]){
      m=v55NormRoad(m[1]);
      if(m){return m;}
    }
  }
  return "";
}

function v55ExplicitRoad(step){
  var r=v55Raw(step),m=v55Man(step),d=step&&step.instruction_details||r.instruction_details||{},vals,i,x,b;

  vals=[
    step&&step.roadName,step&&step.road_name,step&&step.streetName,step&&step.street_name,
    step&&step.street,step&&step.road,step&&step.name,step&&step.way_name,step&&step.ref,step&&step.route,
    step&&step.toRoad,step&&step.to_road,step&&step.destination,

    r.roadName,r.road_name,r.streetName,r.street_name,r.street,r.road,r.name,r.way_name,r.ref,r.route,
    r.toRoad,r.to_road,r.destination,

    m.roadName,m.road_name,m.streetName,m.street_name,m.street,m.road,m.name,m.way_name,m.ref,m.destination,

    d&&d.street_name,d&&d.street,d&&d.road,d&&d.name,d&&d.way_name,d&&d.ref,d&&d.destination,
    d&&d.to&&d.to.name,d&&d.to&&d.to.street,d&&d.to&&d.to.road
  ];

  for(i=0;i<vals.length;i++){
    x=v55NormRoad(vals[i]);
    if(x){return x;}
  }

  try{
    b=step.bannerInstruction||step.banner_instruction||r.bannerInstruction||r.banner_instruction;
    if(b&&b.primary){
      x=v55RoadFromText(b.primary.text);
      if(x){return x;}
      if(b.primary.components){
        for(i=0;i<b.primary.components.length;i++){
          x=v55NormRoad(b.primary.components[i]&&b.primary.components[i].text);
          if(x){return x;}
        }
      }
    }
  }catch(e){}

  return v55RoadFromText(v55InstructionText(step));
}

function v55WriteRoad(step,road){
  var r=v55Raw(step),m=v55Man(step);
  road=v55NormRoad(road);
  if(!step||!road){return false;}

  try{
    step.roadName=road;step.road_name=road;
    step.streetName=road;step.street_name=road;
    step.street=road;step.road=road;
    if(r&&r!==step){
      r.roadName=road;r.road_name=road;
      r.streetName=road;r.street_name=road;
      r.street=road;r.road=road;
    }
    if(m){
      if(!m.name){m.name=road;}
      m.roadName=road;m.road_name=road;
      m.streetName=road;m.street_name=road;
      m.street=road;m.road=road;
    }
  }catch(e){}
  return true;
}

function v55StepCoord(step){
  var r=v55Raw(step),m=v55Man(step),c=null;
  try{
    c=(step&&(step.coord||step.location||step.coordinates||step.point)) ||
      m.location||m.coordinates||
      r.location||r.coordinates||
      (r.maneuver&&(r.maneuver.location||r.maneuver.coordinates));
  }catch(e){}
  if(c&&c.length>=2&&v55Finite(c[0])&&v55Finite(c[1])){
    return [Number(c[0]),Number(c[1])];
  }
  if(step&&v55Finite(step.lng)&&v55Finite(step.lat)){
    return [Number(step.lng),Number(step.lat)];
  }
  return null;
}

function v55RouteCoords(){
  var geo=null;
  try{
    if(window.__SLX_CORE_BRIDGE__&&typeof window.__SLX_CORE_BRIDGE__.getRouteGeo==="function"){
      geo=window.__SLX_CORE_BRIDGE__.getRouteGeo();
    }
  }catch(e0){}
  try{if(!geo&&typeof routeGeo!=="undefined"){geo=routeGeo;}}catch(e1){}
  if(!geo){
    try{geo=JSON.parse(localStorage.getItem("slx_route_geo_v2")||"null");}catch(e2){}
  }
  try{
    if(geo&&geo.features&&geo.features[0]&&geo.features[0].geometry){
      var g=geo.features[0].geometry;
      if(g.type==="LineString"&&g.coordinates){return g.coordinates;}
      if(g.type==="MultiLineString"&&g.coordinates){
        var out=[],i,j;
        for(i=0;i<g.coordinates.length;i++){
          for(j=0;j<g.coordinates[i].length;j++){out.push(g.coordinates[i][j]);}
        }
        return out;
      }
    }
  }catch(e3){}
  return [];
}

function v55Miles(a,b){
  var R=3958.8,dLat,dLng,p1,p2,h;
  dLat=(Number(b[1])-Number(a[1]))*Math.PI/180;
  dLng=(Number(b[0])-Number(a[0]))*Math.PI/180;
  p1=Number(a[1])*Math.PI/180;p2=Number(b[1])*Math.PI/180;
  h=Math.sin(dLat/2)*Math.sin(dLat/2)+
    Math.sin(dLng/2)*Math.sin(dLng/2)*Math.cos(p1)*Math.cos(p2);
  return R*2*Math.atan2(Math.sqrt(h),Math.sqrt(Math.max(0,1-h)));
}

function v55NearestRouteIndex(coords,c){
  if(!coords||!coords.length||!c){return null;}
  var best=Infinity,bestIdx=null,step=Math.max(1,Math.floor(coords.length/1200)),i,d;
  for(i=0;i<coords.length;i+=step){
    d=v55Miles(coords[i],c);
    if(d<best){best=d;bestIdx=i;}
  }
  if(bestIdx==null){return null;}
  var lo=Math.max(0,bestIdx-step*2),hi=Math.min(coords.length-1,bestIdx+step*2);
  for(i=lo;i<=hi;i++){
    d=v55Miles(coords[i],c);
    if(d<best){best=d;bestIdx=i;}
  }
  return bestIdx;
}

function v55Dest(){
  var d=null;
  try{
    if(window.__SLX_CORE_BRIDGE__&&typeof window.__SLX_CORE_BRIDGE__.getRouteDest==="function"){
      d=window.__SLX_CORE_BRIDGE__.getRouteDest();
    }
  }catch(e0){}
  try{if(!d&&typeof routeDest!=="undefined"){d=routeDest;}}catch(e1){}
  if(!d){
    try{d=JSON.parse(localStorage.getItem("slx_main_dest_v2")||"null");}catch(e2){}
  }
  if(d&&v55Finite(d.lat)&&v55Finite(d.lng)){return {lat:Number(d.lat),lng:Number(d.lng)};}
  if(d&&d.geometry&&d.geometry.coordinates&&v55Finite(d.geometry.coordinates[0])&&v55Finite(d.geometry.coordinates[1])){
    return {lat:Number(d.geometry.coordinates[1]),lng:Number(d.geometry.coordinates[0])};
  }
  var coords=v55RouteCoords();
  if(coords.length){
    return {lat:Number(coords[coords.length-1][1]),lng:Number(coords[coords.length-1][0])};
  }
  return null;
}

function v55Signature(){
  var coords=v55RouteCoords(),d=v55Dest(),a,b;
  if(!coords.length||!d){return "";}
  a=coords[0];b=coords[coords.length-1];
  return [
    Number(a[0]).toFixed(5),Number(a[1]).toFixed(5),
    Number(b[0]).toFixed(5),Number(b[1]).toFixed(5),
    Number(d.lng).toFixed(5),Number(d.lat).toFixed(5),
    String(coords.length)
  ].join("|");
}

function v55ExtractSteps(data){
  var out=[],i,j,feature,props,legs,steps;
  try{
    feature=data&&data.features&&data.features[0];
    props=feature&&feature.properties||{};
    legs=props.legs||[];
    for(i=0;i<legs.length;i++){
      steps=legs[i]&&legs[i].steps||[];
      for(j=0;j<steps.length;j++){
        if(steps[j]){out.push(steps[j]);}
      }
    }
  }catch(e){}
  return out;
}

function v55HydratedStep(source,idx,coords){
  var s={},k,c,road,text,routeIdx=null,fields=[
    "instruction","instruction_text","text","description","announceLabel",
    "name","road","roadName","road_name","street","streetName","street_name",
    "way_name","ref","route","destination","destinations","exit","exitName",
    "exitNumber","exit_number","type","modifier","direction","action",
    "voiceInstruction","voiceInstructions","voice_instruction","voice_instructions",
    "bannerInstruction","banner_instruction","maneuver","instruction_details",
    "transition_instruction","verbal_pre_transition_instruction",
    "verbal_post_transition_instruction","location","coordinates","lon","lng","lat",
    "route_index","geometry_index","from_index","begin_index","start_index","point_index"
  ];

  for(k=0;k<fields.length;k++){
    try{
      if(source[fields[k]]!==undefined&&source[fields[k]]!==null){
        s[fields[k]]=source[fields[k]];
      }
    }catch(e0){}
  }

  s.rawStep=source;
  text=v55InstructionText(s);
  s.instruction=text||"Continue";
  s.announceLabel=s.instruction;

  c=v55StepCoord(s);
  if(c&&coords&&coords.length){
    routeIdx=v55NearestRouteIndex(coords,c);
  }
  if(routeIdx==null){
    var vals=[source.route_index,source.geometry_index,source.from_index,source.begin_index,source.start_index,source.point_index];
    for(k=0;k<vals.length;k++){
      if(v55Finite(vals[k])){routeIdx=Number(vals[k]);break;}
    }
  }

  if(routeIdx!=null&&coords&&coords[routeIdx]){
    s.coord=[Number(coords[routeIdx][0]),Number(coords[routeIdx][1])];
    s.originalIndex=routeIdx;
  }else if(c){
    s.coord=[Number(c[0]),Number(c[1])];
    s.originalIndex=idx;
  }

  road=v55ExplicitRoad(s);
  if(road){v55WriteRoad(s,road);}
  return s.coord?s:null;
}

function v55InstallSteps(rawSteps){
  var coords=v55RouteCoords(),out=[],i,s,named=0;
  if(!rawSteps||!rawSteps.length){return false;}

  for(i=0;i<rawSteps.length;i++){
    s=v55HydratedStep(rawSteps[i],i,coords);
    if(!s){continue;}
    if(v55ExplicitRoad(s)){named++;}
    out.push(s);
  }

  if(!out.length){return false;}

  try{localStorage.setItem("slx_route_steps_v2",JSON.stringify(out));}catch(e0){}
  try{localStorage.setItem("slx_route_steps_v1",JSON.stringify(out));}catch(e1){}

  try{routeSteps=out;}catch(e2){}
  try{window.SLX_ROUTE_STEPS=out;}catch(e3){}

  try{
    if(typeof buildManeuverSteps==="function"){
      buildManeuverSteps();
    }
  }catch(e4){}

  /*
    One more direct hydration pass after buildManeuverSteps because older builders
    copy only selected fields.
  */
  try{
    if(typeof maneuverSteps!=="undefined"&&maneuverSteps&&maneuverSteps.length){
      for(i=0;i<maneuverSteps.length;i++){
        s=maneuverSteps[i];
        var r=v55ExplicitRoad(s);
        if(!r&&s.rawStep){r=v55ExplicitRoad(s.rawStep);}
        if(r){v55WriteRoad(s,r);}
      }
    }
  }catch(e5){}

  V55.lastNamedCount=named;
  V55.lastHydratedAt=Date.now();

  try{
    if(window.SLXV52CanonicalManeuverCard&&typeof window.SLXV52CanonicalManeuverCard.render==="function"){
      window.SLXV52CanonicalManeuverCard.render();
    }
  }catch(e6){}
  try{
    if(window.SLXV42StreetVoiceRestore&&typeof window.SLXV42StreetVoiceRestore.renderStreet==="function"){
      window.SLXV42StreetVoiceRestore.renderStreet();
    }
  }catch(e7){}

  return true;
}

function v55NeedHydration(){
  var list=[],i,road,named=0;
  try{list=(typeof maneuverSteps!=="undefined"&&maneuverSteps)?maneuverSteps:[];}catch(e0){}
  if(!list||!list.length){
    try{list=(typeof routeSteps!=="undefined"&&routeSteps)?routeSteps:[];}catch(e1){}
  }
  if(!list||!list.length){return true;}

  for(i=0;i<Math.min(list.length,8);i++){
    road=v55ExplicitRoad(list[i]);
    if(road){named++;}
  }

  return named<Math.min(2,list.length);
}

function v55Fetch(){
  var sig=v55Signature(),coords=v55RouteCoords(),dest=v55Dest(),key="",start,url;
  if(!sig||V55.busy){return false;}
  if(V55.fetchedSignature===sig&&!v55NeedHydration()){return false;}

  try{key=v55Clean(window.SLX_GEOAPIFY_KEY||(typeof geoapifyKey!=="undefined"?geoapifyKey:""));}catch(e0){}
  if(!key||!coords.length||!dest||!window.fetch){return false;}

  start=coords[0];
  V55.busy=true;

  url="https://api.geoapify.com/v1/routing?waypoints="+
    encodeURIComponent(String(start[1])+","+String(start[0])+"|"+String(dest.lat)+","+String(dest.lng))+
    "&mode=drive&format=geojson&details=instruction_details&apiKey="+encodeURIComponent(key);

  fetch(url)
    .then(function(res){
      if(!res.ok){throw new Error("HTTP "+res.status);}
      return res.json();
    })
    .then(function(data){
      var steps=v55ExtractSteps(data);
      V55.busy=false;
      if(steps&&steps.length&&v55InstallSteps(steps)){
        V55.fetchedSignature=sig;
        V55.failedSignature="";
        try{console.log("✅ Semi Locator V55 street names hydrated",{steps:steps.length,named:V55.lastNamedCount});}catch(e1){}
      }else{
        V55.failedSignature=sig;
        try{console.warn("Semi Locator V55 instruction hydration returned no usable steps");}catch(e2){}
      }
    })
    .catch(function(err){
      V55.busy=false;
      V55.failedSignature=sig;
      try{console.warn("Semi Locator V55 street hydration failed",err);}catch(e3){}
    });

  return true;
}

/*
  Upgrade the existing shared instruction reader and road-name reader so every
  existing Semi card/voice authority sees the same hydrated truth.
*/
try{
  var v55OldInstructionText=typeof slxNavV2InstructionText==="function"?slxNavV2InstructionText:null;
  slxNavV2InstructionText=function(step){
    var text=v55InstructionText(step);
    if(text){return text;}
    return v55OldInstructionText?v55OldInstructionText(step):"Continue";
  };
}catch(eWrap1){}

try{
  var v55OldRoadName=typeof slxV2GRoadName==="function"?slxV2GRoadName:null;
  slxV2GRoadName=function(step){
    var road=v55ExplicitRoad(step);
    if(road){
      v55WriteRoad(step,road);
      return road;
    }
    road=v55OldRoadName?v55NormRoad(v55OldRoadName(step)):"";
    if(road){v55WriteRoad(step,road);return road;}
    return "";
  };
}catch(eWrap2){}

/*
  Make the proven V54 card ask this authority first. This does not create a new
  card or timer; it simply hydrates its existing active step.
*/
function v55Tick(){
  var step=null,road="";
  try{
    if(typeof tripStarted!=="undefined"&&!tripStarted){return;}
  }catch(e0){
    try{if(localStorage.getItem("slx_trip_on_v2")!=="1"){return;}}catch(e1){}
  }

  try{
    if(typeof slxNavV2ActiveStep==="function"){step=slxNavV2ActiveStep();}
  }catch(e2){}
  try{
    if(!step&&typeof maneuverSteps!=="undefined"&&maneuverSteps&&maneuverSteps.length){
      step=maneuverSteps[maneuverIndex];
    }
  }catch(e3){}

  if(step){
    road=v55ExplicitRoad(step);
    if(road){v55WriteRoad(step,road);}
  }

  if(v55NeedHydration()){v55Fetch();}
}

/* Route changes or initial boot get one hydration attempt; no high-frequency poll. */
window.addEventListener("storage",function(e){
  if(e&&(
    e.key==="slx_route_geo_v2"||
    e.key==="slx_route_steps_v2"||
    e.key==="slx_main_dest_v2"
  )){
    window.setTimeout(v55Tick,80);
  }
},false);

window.setTimeout(v55Tick,120);
window.setTimeout(v55Tick,800);
window.setTimeout(v55Tick,2200);

window.SLXV55StreetAuthority={
  version:"V55_AUTHORITATIVE_STREET_NAMES",
  hydrate:v55Fetch,
  tick:v55Tick,
  roadName:v55ExplicitRoad,
  instruction:v55InstructionText,
  state:V55,
  snapshot:function(){
    var step=null,road="";
    try{
      step=typeof slxNavV2ActiveStep==="function"?slxNavV2ActiveStep():null;
      if(!step&&typeof maneuverSteps!=="undefined"&&maneuverSteps&&maneuverSteps.length){
        step=maneuverSteps[maneuverIndex];
      }
    }catch(e){}
    road=step?v55ExplicitRoad(step):"";
    return {
      activeRoad:road,
      activeInstruction:step?v55InstructionText(step):"",
      busy:V55.busy,
      fetchedSignature:V55.fetchedSignature,
      failedSignature:V55.failedSignature,
      namedCount:V55.lastNamedCount,
      lastHydratedAt:V55.lastHydratedAt
    };
  }
};

try{console.log("✅ Semi Locator V55 authoritative street-name hydration loaded");}catch(eBoot){}

})(window);


/* ============================================================================
   SEMI LOCATOR V56 — STREET NAMES BEFORE MOVEMENT
   Final startup bridge:
   - Reads the road label already visible beneath the truck.
   - Writes it into the existing canonical maneuver card while stationary.
   - Starts V55 target-road hydration before the first movement.
   - No new card, no new map, no reroute, no reload.
   ============================================================================ */
(function(window){
"use strict";
if(window.__SLX_V56_STREET_NAMES_BEFORE_MOVEMENT__){return;}
window.__SLX_V56_STREET_NAMES_BEFORE_MOVEMENT__=true;

function paint(){
  try{
    if(window.SLXV52CanonicalManeuverCard &&
       typeof window.SLXV52CanonicalManeuverCard.render==="function"){
      window.SLXV52CanonicalManeuverCard.render();
    }
  }catch(e0){}

  try{
    if(window.SLXV55StreetAuthority &&
       typeof window.SLXV55StreetAuthority.tick==="function"){
      window.SLXV55StreetAuthority.tick();
    }
  }catch(e1){}
}

window.setTimeout(paint,80);
window.setTimeout(paint,350);
window.setTimeout(paint,900);
window.setTimeout(paint,1800);

window.SLXV56StreetStartup={
  version:"V56_STREET_NAMES_BEFORE_MOVEMENT",
  paint:paint
};

try{console.log("✅ Semi Locator V56 street names before movement loaded");}catch(eBoot){}
})(window);


/* ============================================================================
   SEMI LOCATOR V57 — SINGLE STREET-NAME AUTHORITY
   Fixes the remaining "Road name loading" race.

   WHY:
   - The target maneuver is active before movement (good).
   - Older V42/V54 street renderers can still leave the road line in a loading
     state while their own async/cache paths fight over the same element.

   V57 becomes the ONE final owner of #slxDriveIqTurnRoad:
   - provider road first
   - rendered Mapbox target road second
   - Geoapify reverse target lookup third
   - current rendered road while target lookup is pending
   - never exposes "Road name loading"
   - writes the resolved target road back into the active step so existing
     maneuver voice speaks the same street name.

   It does NOT own route, map, GPS, camera, reroute, arrival, Stop IQ, or speech.
   ============================================================================ */
(function(window){
"use strict";

if(window.__SLX_V57_SINGLE_STREET_NAME_AUTHORITY__){return;}
window.__SLX_V57_SINGLE_STREET_NAME_AUTHORITY__=true;
window.SLX_STREET_NAME_BUILD="V57_SINGLE_STREET_NAME_AUTHORITY";

var V57={
  activeKey:"",
  targetRoad:"",
  targetCache:{},
  pending:{},
  timer:null,
  lastWrite:"",
  lastLookupAt:0
};

function c(v){return String(v==null?"":v).replace(/\s+/g," ").trim();}
function finite(v){return isFinite(Number(v));}
function bad(v){
  var s=c(v).toLowerCase();
  return !s||/^(continue|continue straight|continue on route|stay on route|follow highlighted route|turn|turn left|turn right|left|right|straight|merge|exit|take the exit|fork|keep left|keep right|arrive|arrival|destination|route guidance|guidance ready|route active|route ready|navigation ready|street name loading|road name loading|road name unavailable|current road|follow current road)$/i.test(s);
}
function norm(v){
  var s=c(v);
  if(!s||bad(s)){return "";}
  s=s.replace(/\binterstate\s+(\d{1,3})\b/ig,"I-$1")
     .replace(/\bi\s+(\d{1,3})\b/ig,"I-$1")
     .replace(/\bi-(\d{1,3})\b/ig,"I-$1")
     .replace(/\bu\.s\.\s*(\d{1,3})\b/ig,"US-$1")
     .replace(/\bus\s+(\d{1,3})\b/ig,"US-$1")
     .replace(/\bhwy\s+(\d{1,3})\b/ig,"Highway $1");
  return c(s);
}
function raw(step){return (step&&(step.rawStep||step.raw))||step||{};}
function man(step){var r=raw(step);return (step&&step.maneuver)||r.maneuver||{};}

function activeStep(){
  var s=null;
  try{
    if(typeof slxNavV2ActiveStep==="function"){
      s=slxNavV2ActiveStep();
      if(s){return s;}
    }
  }catch(e0){}
  try{
    if(typeof maneuverSteps!=="undefined"&&maneuverSteps&&maneuverSteps.length&&
       typeof maneuverIndex!=="undefined"&&maneuverIndex>=0&&maneuverIndex<maneuverSteps.length){
      return maneuverSteps[maneuverIndex];
    }
  }catch(e1){}
  return null;
}

function stepCoord(step){
  var r=raw(step),m=man(step),p=null;
  try{
    p=(step&&(step.coord||step.location||step.coordinates||step.point))||
      m.location||m.coordinates||
      r.location||r.coordinates||
      (r.maneuver&&(r.maneuver.location||r.maneuver.coordinates));
  }catch(e){}
  if(p&&p.length>=2&&finite(p[0])&&finite(p[1])){
    return [Number(p[0]),Number(p[1])];
  }
  if(step&&finite(step.lng)&&finite(step.lat)){
    return [Number(step.lng),Number(step.lat)];
  }
  return null;
}

function instruction(step){
  var s="";
  try{
    if(window.SLXV55StreetAuthority&&typeof window.SLXV55StreetAuthority.instruction==="function"){
      s=c(window.SLXV55StreetAuthority.instruction(step));
      if(s){return s;}
    }
  }catch(e0){}
  try{
    if(typeof slxNavV2InstructionText==="function"){s=c(slxNavV2InstructionText(step));}
  }catch(e1){}
  return s||c(step&&step.instruction);
}

function stepKey(step){
  var p=stepCoord(step);
  return [
    p?Number(p[0]).toFixed(5):"",
    p?Number(p[1]).toFixed(5):"",
    instruction(step)
  ].join("|");
}

function providerRoad(step){
  var r="",src=raw(step),m=man(step),d=(step&&step.instruction_details)||src.instruction_details||{},vals,i;

  try{
    if(window.SLXV55StreetAuthority&&typeof window.SLXV55StreetAuthority.roadName==="function"){
      r=norm(window.SLXV55StreetAuthority.roadName(step));
      if(r){return r;}
    }
  }catch(e0){}

  vals=[
    step&&step.roadName,step&&step.road_name,step&&step.streetName,step&&step.street_name,
    step&&step.street,step&&step.road,step&&step.name,step&&step.way_name,step&&step.ref,step&&step.route,
    step&&step.toRoad,step&&step.to_road,step&&step.destination,
    src.roadName,src.road_name,src.streetName,src.street_name,src.street,src.road,src.name,src.way_name,src.ref,src.route,
    src.toRoad,src.to_road,src.destination,
    m.roadName,m.road_name,m.streetName,m.street_name,m.street,m.road,m.name,m.way_name,m.ref,m.destination,
    d&&d.street_name,d&&d.street,d&&d.road,d&&d.name,d&&d.way_name,d&&d.ref,d&&d.destination
  ];

  for(i=0;i<vals.length;i++){
    r=norm(vals[i]);
    if(r){return r;}
  }

  return "";
}

function writeBack(step,road){
  var r=raw(step),m=man(step);
  road=norm(road);
  if(!step||!road){return;}
  try{
    step.roadName=road;step.road_name=road;step.streetName=road;step.street_name=road;step.street=road;step.road=road;
    if(r){
      r.roadName=road;r.road_name=road;r.streetName=road;r.street_name=road;r.street=road;r.road=road;
    }
    if(m){
      m.roadName=road;m.road_name=road;m.streetName=road;m.street_name=road;m.street=road;m.road=road;
      if(!m.name){m.name=road;}
    }
  }catch(e){}
}

function coreMap(){
  try{
    if(window.__SLX_CORE_BRIDGE__&&typeof window.__SLX_CORE_BRIDGE__.getMap==="function"){
      return window.__SLX_CORE_BRIDGE__.getMap();
    }
  }catch(e){}
  try{return map||window.map||null;}catch(e2){}
  return null;
}

function roadFromRenderedMap(lng,lat){
  var m=coreMap(),pt,features,i,p,layer,src,r;
  if(!m||!m.project||!m.queryRenderedFeatures){return "";}
  try{
    pt=m.project([Number(lng),Number(lat)]);
    features=m.queryRenderedFeatures([[pt.x-32,pt.y-32],[pt.x+32,pt.y+32]])||[];
  }catch(e0){return "";}

  for(i=0;i<features.length;i++){
    p=features[i]&&features[i].properties||{};
    layer=c(features[i]&&features[i].layer&&features[i].layer.id).toLowerCase();
    src=c(features[i]&&features[i].sourceLayer).toLowerCase();

    if(layer.indexOf("road")<0&&layer.indexOf("street")<0&&layer.indexOf("transport")<0&&
       src.indexOf("road")<0&&src.indexOf("transport")<0){
      continue;
    }

    r=norm(p.name_en||p.name||p.name_local||p.ref||p.road||p.street);
    if(r){return r;}
  }
  return "";
}

function currentRoad(){
  var f=null,r="";
  try{
    if(typeof speedState!=="undefined"&&speedState&&speedState.roadName){
      r=norm(speedState.roadName);
      if(r){return r;}
    }
  }catch(e0){}
  try{
    if(window.__SLX_CORE_BRIDGE__&&typeof window.__SLX_CORE_BRIDGE__.getCurrentFix==="function"){
      f=window.__SLX_CORE_BRIDGE__.getCurrentFix();
    }
  }catch(e1){}
  try{if(!f){f=currentFix||rawFix||routeTargetFix||null;}}catch(e2){}
  if(f&&finite(f.lng)&&finite(f.lat)){
    r=roadFromRenderedMap(f.lng,f.lat);
    if(r){return r;}
  }
  return "";
}

function geoKey(){
  try{return c(window.SLX_GEOAPIFY_KEY||(typeof geoapifyKey!=="undefined"?geoapifyKey:""));}catch(e){}
  return "";
}

function geoRoad(data){
  var f=data&&data.features&&data.features[0],p=f&&f.properties||{},r;
  r=norm(p.street);if(r){return r;}
  r=norm(p.address_line1);
  if(r){
    r=norm(r.replace(/^\d+[A-Za-z\-]*\s+/,""));
    if(r){return r;}
  }
  return norm(p.name||p.ref);
}

function reverseTarget(step,key){
  var p=stepCoord(step),api=geoKey(),url;
  if(!p||!api||!window.fetch||V57.pending[key]){return;}

  V57.pending[key]=true;
  V57.lastLookupAt=Date.now();

  url="https://api.geoapify.com/v1/geocode/reverse?lat="+
    encodeURIComponent(String(p[1]))+
    "&lon="+encodeURIComponent(String(p[0]))+
    "&format=geojson&apiKey="+encodeURIComponent(api);

  fetch(url)
    .then(function(res){return res.json();})
    .then(function(data){
      var road=geoRoad(data);
      V57.pending[key]=false;
      if(road){
        V57.targetCache[key]=road;
        if(V57.activeKey===key){
          V57.targetRoad=road;
          writeBack(step,road);
          paint();
        }
      }
    })
    .catch(function(){V57.pending[key]=false;});
}

function resolve(step){
  var key=stepKey(step),road="",p;
  if(!step){return currentRoad();}

  road=providerRoad(step);
  if(road){
    V57.targetCache[key]=road;
    writeBack(step,road);
    return road;
  }

  if(V57.targetCache[key]){
    road=norm(V57.targetCache[key]);
    if(road){writeBack(step,road);return road;}
  }

  p=stepCoord(step);
  if(p){
    road=roadFromRenderedMap(p[0],p[1]);
    if(road){
      V57.targetCache[key]=road;
      writeBack(step,road);
      return road;
    }
  }

  reverseTarget(step,key);

  /*
    Never show an implementation/loading state. Use the current road while the
    target name resolves. As soon as Geoapify returns, paint() swaps in target.
  */
  return currentRoad()||"Follow current road";
}

function paint(){
  var el=document.getElementById("slxDriveIqTurnRoad"),step=activeStep(),key="",road="";
  if(!el){return;}

  if(step){
    key=stepKey(step);
    if(V57.activeKey!==key){
      V57.activeKey=key;
      V57.targetRoad="";
    }
    road=resolve(step);
  }else{
    road=currentRoad()||"Follow current road";
  }

  road=norm(road)||"Follow current road";
  if(c(el.textContent)!==road){el.textContent=road;}
  V57.lastWrite=road;

  /*
    Kick V55 instruction-detail hydration if target road still unresolved.
  */
  if(step&&road==="Follow current road"){
    try{
      if(window.SLXV55StreetAuthority&&typeof window.SLXV55StreetAuthority.hydrate==="function"){
        window.SLXV55StreetAuthority.hydrate();
      }
    }catch(e){}
  }
}

/*
  Stop the two previous street-card painters. Navigation voice remains alive;
  we are only replacing who writes #slxDriveIqTurnRoad.
*/
try{
  if(window.SLXV42StreetVoiceRestore&&window.SLXV42StreetVoiceRestore.state&&
     window.SLXV42StreetVoiceRestore.state.timer){
    clearInterval(window.SLXV42StreetVoiceRestore.state.timer);
    window.SLXV42StreetVoiceRestore.state.timer=null;
  }
}catch(eStop42){}

try{
  if(window.SLXV52CanonicalManeuverCard&&window.SLXV52CanonicalManeuverCard.state&&
     window.SLXV52CanonicalManeuverCard.state.timer){
    clearInterval(window.SLXV52CanonicalManeuverCard.state.timer);
    window.SLXV52CanonicalManeuverCard.state.timer=null;
  }
}catch(eStop54){}

/*
  V42's timer carried maneuver voice too, so preserve the existing voice tick
  independently without giving V42 road-card write authority.
*/
function voiceOnly(){
  try{
    if(window.SLXV42StreetVoiceRestore&&typeof window.SLXV42StreetVoiceRestore.voiceTick==="function"){
      window.SLXV42StreetVoiceRestore.voiceTick();
    }
  }catch(e){}
}

V57.timer=setInterval(function(){
  paint();
  voiceOnly();
},350);

setTimeout(paint,40);
setTimeout(paint,250);
setTimeout(paint,800);

window.SLXV57StreetAuthority={
  version:"V57_SINGLE_STREET_NAME_AUTHORITY",
  paint:paint,
  resolve:resolve,
  active:activeStep,
  state:V57,
  snapshot:function(){
    var s=activeStep();
    return {
      activeInstruction:s?instruction(s):"",
      activeRoad:s?resolve(s):currentRoad(),
      activeKey:V57.activeKey,
      lastWrite:V57.lastWrite,
      lastLookupAt:V57.lastLookupAt
    };
  }
};

try{console.log("✅ Semi Locator V57 single street-name authority loaded");}catch(eBoot){}
})(window);


/* ============================================================================
   SEMI LOCATOR V58 — DEPLOYMENT-PROOF STREET AUTHORITY
   DIAGNOSTIC + HARD BOOT

   This exists because a live screenshot still showed the literal
   "Road name loading" even though V57 contains no executable writer for that
   string. V58 proves which asset is actually running and hard-boots the final
   street authority after DOM/map readiness.

   Visible proof:
   - The top FD-16 badge is changed to FD-58 when THIS code actually executes.
   - If the badge stays FD-16, the app is serving/running an older asset.
   ============================================================================ */
(function(window,document){
"use strict";

if(window.__SLX_V58_DEPLOYMENT_PROOF_STREET__){return;}
window.__SLX_V58_DEPLOYMENT_PROOF_STREET__=true;
window.SLX_STREET_NAME_BUILD="V58_DEPLOYMENT_PROOF_STREET";

function clean(v){return String(v==null?"":v).replace(/\s+/g," ").trim();}

function stampBuild(){
  var nodes,i,t;
  try{
    nodes=document.querySelectorAll("body *");
    for(i=0;i<nodes.length;i++){
      t=clean(nodes[i].textContent);
      if(t==="FD-16"||t==="FD-55"||t==="FD-56"||t==="FD-57"){
        nodes[i].textContent="FD-58";
        nodes[i].setAttribute("data-slx-runtime","V58");
        return true;
      }
    }
  }catch(e){}
  return false;
}

function killLoadingCopy(){
  var el=document.getElementById("slxDriveIqTurnRoad");
  if(!el){return;}
  var t=clean(el.textContent).toLowerCase();
  if(t==="road name loading"||t==="street name loading"||t==="road name unavailable"){
    el.textContent="Follow current road";
  }
}

function runAuthority(){
  stampBuild();
  killLoadingCopy();

  try{
    if(window.SLXV57StreetAuthority &&
       typeof window.SLXV57StreetAuthority.paint==="function"){
      window.SLXV57StreetAuthority.paint();
    }
  }catch(e0){}

  try{
    if(window.SLXV55StreetAuthority &&
       typeof window.SLXV55StreetAuthority.tick==="function"){
      window.SLXV55StreetAuthority.tick();
    }
  }catch(e1){}

  try{
    if(window.SLXV55StreetAuthority &&
       typeof window.SLXV55StreetAuthority.hydrate==="function"){
      window.SLXV55StreetAuthority.hydrate();
    }
  }catch(e2){}
}

/*
  Boot after actual DOM readiness, after map style/load opportunities, and on
  visibility return. These are bounded startup retries, not a navigation
  watchdog and do not recreate anything.
*/
function boot(){
  runAuthority();
  window.setTimeout(runAuthority,100);
  window.setTimeout(runAuthority,350);
  window.setTimeout(runAuthority,900);
  window.setTimeout(runAuthority,1800);
  window.setTimeout(runAuthority,3200);
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",boot,{once:true});
}else{
  boot();
}

document.addEventListener("visibilitychange",function(){
  if(!document.hidden){runAuthority();}
},false);

window.SLXV58DeploymentProof={
  version:"V58_DEPLOYMENT_PROOF_STREET",
  run:runAuthority,
  build:function(){return window.SLX_STREET_NAME_BUILD||"";},
  snapshot:function(){
    var road=document.getElementById("slxDriveIqTurnRoad");
    return {
      build:window.SLX_STREET_NAME_BUILD||"",
      road:road?clean(road.textContent):"",
      v55:window.SLXV55StreetAuthority&&window.SLXV55StreetAuthority.snapshot?
        window.SLXV55StreetAuthority.snapshot():null,
      v57:window.SLXV57StreetAuthority&&window.SLXV57StreetAuthority.snapshot?
        window.SLXV57StreetAuthority.snapshot():null
    };
  }
};

try{console.log("✅ Semi Locator FD-58 deployment-proof street authority loaded");}catch(eBoot){}
})(window,document);


/* ============================================================================
   SEMI LOCATOR V59 — MANEUVER VOICE TARGET-ROAD GATE
   Surgical fix for: "Turn left in about one mile" with no road name.

   HARD RULE:
   A normal advance/approach maneuver is NOT spoken until the TARGET road name
   has been resolved. The speech bucket remains unconsumed while lookup is
   pending, so the existing 350 ms voice tick retries automatically.

   Target-road resolution order:
   1) provider / V55 maneuver metadata
   2) rendered Mapbox road label at the TARGET maneuver coordinate
   3) Geoapify reverse geocode at the TARGET maneuver coordinate

   Never substitutes the CURRENT road as the target road in voice.
   Does not alter GPS, route geometry, reroute, map lifecycle, camera, arrival,
   Stop IQ, or speech scheduling.
   ============================================================================ */
(function(window){
"use strict";

if(window.__SLX_V59_MANEUVER_VOICE_TARGET_ROAD__){return;}
window.__SLX_V59_MANEUVER_VOICE_TARGET_ROAD__=true;
window.SLX_MANEUVER_VOICE_BUILD="V59_TARGET_ROAD_GATE";

var V59={
  cache:{},
  pending:{},
  lastRoad:"",
  lastKey:"",
  lastError:""
};

function clean(v){return String(v==null?"":v).replace(/\s+/g," ").trim();}
function finite(v){return isFinite(Number(v));}
function badRoad(v){
  var s=clean(v).toLowerCase();
  return !s ||
    /^(continue|continue straight|continue on route|stay on route|follow highlighted route|turn|turn left|turn right|left|right|straight|merge|exit|take the exit|fork|keep left|keep right|arrive|arrival|destination|route guidance|guidance ready|route active|route ready|navigation ready|street name loading|road name loading|road name unavailable|current road|follow current road)$/i.test(s);
}
function normRoad(v){
  var s=clean(v);
  if(!s||badRoad(s)){return "";}
  s=s.replace(/\binterstate\s+(\d{1,3})\b/ig,"I-$1")
     .replace(/\bi\s+(\d{1,3})\b/ig,"I-$1")
     .replace(/\bi-(\d{1,3})\b/ig,"I-$1")
     .replace(/\bu\.s\.\s*(\d{1,3})\b/ig,"US-$1")
     .replace(/\bus\s+(\d{1,3})\b/ig,"US-$1")
     .replace(/\bhwy\s+(\d{1,3})\b/ig,"Highway $1");
  return clean(s);
}
function raw(step){return (step&&(step.rawStep||step.raw))||step||{};}
function man(step){var r=raw(step);return (step&&step.maneuver)||r.maneuver||{};}

function stepCoord(step){
  var r=raw(step),m=man(step),p=null;
  try{
    p=(step&&(step.coord||step.location||step.coordinates||step.point))||
      m.location||m.coordinates||
      r.location||r.coordinates||
      (r.maneuver&&(r.maneuver.location||r.maneuver.coordinates));
  }catch(e){}
  if(p&&p.length>=2&&finite(p[0])&&finite(p[1])){
    return [Number(p[0]),Number(p[1])];
  }
  if(step&&finite(step.lng)&&finite(step.lat)){
    return [Number(step.lng),Number(step.lat)];
  }
  return null;
}

function stepKey(step){
  var p=stepCoord(step),txt="";
  try{
    txt=typeof slxNavV2InstructionText==="function" ?
      clean(slxNavV2InstructionText(step)) :
      clean(step&&step.instruction);
  }catch(e){txt=clean(step&&step.instruction);}
  return [
    p?Number(p[0]).toFixed(5):"",
    p?Number(p[1]).toFixed(5):"",
    txt
  ].join("|");
}

function writeRoad(step,road){
  var r=raw(step),m=man(step);
  road=normRoad(road);
  if(!step||!road){return false;}
  try{
    step.roadName=road;step.road_name=road;
    step.streetName=road;step.street_name=road;
    step.street=road;step.road=road;
    if(r){
      r.roadName=road;r.road_name=road;
      r.streetName=road;r.street_name=road;
      r.street=road;r.road=road;
    }
    if(m){
      m.roadName=road;m.road_name=road;
      m.streetName=road;m.street_name=road;
      m.street=road;m.road=road;
      if(!m.name){m.name=road;}
    }
  }catch(e){}
  return true;
}

function providerRoad(step){
  var road="",r=raw(step),m=man(step),d=(step&&step.instruction_details)||r.instruction_details||{},vals,i;
  try{
    if(window.SLXV55StreetAuthority &&
       typeof window.SLXV55StreetAuthority.roadName==="function"){
      road=normRoad(window.SLXV55StreetAuthority.roadName(step));
      if(road){return road;}
    }
  }catch(e0){}

  vals=[
    step&&step.roadName,step&&step.road_name,step&&step.streetName,step&&step.street_name,
    step&&step.street,step&&step.road,step&&step.name,step&&step.way_name,step&&step.ref,step&&step.route,
    step&&step.toRoad,step&&step.to_road,step&&step.destination,
    r.roadName,r.road_name,r.streetName,r.street_name,r.street,r.road,r.name,r.way_name,r.ref,r.route,
    r.toRoad,r.to_road,r.destination,
    m.roadName,m.road_name,m.streetName,m.street_name,m.street,m.road,m.name,m.way_name,m.ref,m.destination,
    d&&d.street_name,d&&d.street,d&&d.road,d&&d.name,d&&d.way_name,d&&d.ref,d&&d.destination,
    d&&d.to&&d.to.name,d&&d.to&&d.to.street,d&&d.to&&d.to.road
  ];

  for(i=0;i<vals.length;i++){
    road=normRoad(vals[i]);
    if(road){return road;}
  }
  return "";
}

function coreMap(){
  try{
    if(window.__SLX_CORE_BRIDGE__ &&
       typeof window.__SLX_CORE_BRIDGE__.getMap==="function"){
      return window.__SLX_CORE_BRIDGE__.getMap();
    }
  }catch(e0){}
  try{return map||window.map||null;}catch(e1){}
  return null;
}

function renderedTargetRoad(step){
  var p=stepCoord(step),m=coreMap(),pt,features,i,props,layer,src,road="";
  if(!p||!m||!m.project||!m.queryRenderedFeatures){return "";}
  try{
    pt=m.project([p[0],p[1]]);
    features=m.queryRenderedFeatures([[pt.x-36,pt.y-36],[pt.x+36,pt.y+36]])||[];
  }catch(e0){return "";}

  for(i=0;i<features.length;i++){
    props=features[i]&&features[i].properties||{};
    layer=clean(features[i]&&features[i].layer&&features[i].layer.id).toLowerCase();
    src=clean(features[i]&&features[i].sourceLayer).toLowerCase();

    if(layer.indexOf("road")<0&&layer.indexOf("street")<0&&layer.indexOf("transport")<0&&
       src.indexOf("road")<0&&src.indexOf("transport")<0){
      continue;
    }

    road=normRoad(props.name_en||props.name||props.name_local||props.ref||props.road||props.street);
    if(road){return road;}
  }
  return "";
}

function apiKey(){
  try{
    return clean(window.SLX_GEOAPIFY_KEY ||
      (typeof geoapifyKey!=="undefined" ? geoapifyKey : ""));
  }catch(e){}
  return "";
}

function geoRoad(data){
  var f=data&&data.features&&data.features[0],p=f&&f.properties||{},road="";
  road=normRoad(p.street);
  if(road){return road;}

  road=clean(p.address_line1);
  if(road){
    road=normRoad(road.replace(/^\d+[A-Za-z\-]*\s+/,""));
    if(road){return road;}
  }

  return normRoad(p.name||p.ref);
}

function reverseTarget(step,key){
  var p=stepCoord(step),api=apiKey(),url;
  if(!p||!api||!window.fetch||V59.pending[key]){return false;}

  V59.pending[key]=true;

  url="https://api.geoapify.com/v1/geocode/reverse?lat="+
    encodeURIComponent(String(p[1]))+
    "&lon="+encodeURIComponent(String(p[0]))+
    "&format=geojson&apiKey="+encodeURIComponent(api);

  fetch(url)
    .then(function(res){
      if(!res.ok){throw new Error("HTTP "+res.status);}
      return res.json();
    })
    .then(function(data){
      var road=geoRoad(data);
      V59.pending[key]=false;
      if(road){
        V59.cache[key]=road;
        V59.lastRoad=road;
        V59.lastKey=key;
        writeRoad(step,road);

        /*
          Repaint existing card authorities now that the target road is known.
          No new card is created.
        */
        try{
          var el=document.getElementById("slxDriveIqTurnRoad");
          if(el){el.textContent=road;}
        }catch(e0){}
      }
    })
    .catch(function(err){
      V59.pending[key]=false;
      V59.lastError=String(err&&err.message||err);
    });

  return true;
}

function targetRoad(step){
  var key=stepKey(step),road="",liveText="",match=null;

  /* V68: Prefer the live route instruction, as proven by the iPhone card test.
     Do NOT use a nearby/current road as the target of an upcoming turn. */
  try{
    /* V69: the displayed maneuver uses this exact live bridge step. V68
       only read the local maneuver object, which can omit its instruction. */
    var bridge=window.__SLX_CORE_BRIDGE__;
    var activeStep=bridge&&typeof bridge.getActiveManeuverStep==="function"
      ?bridge.getActiveManeuverStep():null;
    var bridgeText=clean(activeStep&&(activeStep.instruction||activeStep.announceLabel)||"");
    var localText=clean(step&&(step.instruction||step.instruction_text)||"");
    var localAction=typeof slxV2GAction==="function"?slxV2GAction(step):"";
    var bridgeLower=bridgeText.toLowerCase();
    var sameDirection=!localAction ||
      (localAction.indexOf("left")!==-1 && /\bleft\b/.test(bridgeLower)) ||
      (localAction.indexOf("right")!==-1 && /\bright\b/.test(bridgeLower)) ||
      (localAction.indexOf("exit")!==-1 && /\bexit\b/.test(bridgeLower)) ||
      (localAction.indexOf("merge")!==-1 && /\bmerge\b/.test(bridgeLower)) ||
      (localAction==="continue" && /\bcontinue\b/.test(bridgeLower));
    liveText=(sameDirection && bridgeText)?bridgeText:localText;
    if(!liveText){
      var source=raw(step);
      liveText=clean(source&&(source.instruction||source.instruction_text)||"");
    }
    match=liveText.match(/\b(?:onto|toward|towards)\s+(.+)$/i);
    if(match){
      road=normRoad(clean(match[1]).replace(/[.!]+$/g,"")
        .replace(/\s+(?:in|after)\s+\d+(?:\.\d+)?\s*(?:feet|ft|miles|mi|meters|m)\.?$/i,"")
        .trim());
      if(road && !/^(?:the|this|current)\s+road$/i.test(road)){
        V59.cache[key]=road;
        writeRoad(step,road);
        return road;
      }
    }
  }catch(eInstruction){}

  road=providerRoad(step);
  if(road){
    V59.cache[key]=road;
    writeRoad(step,road);
    return road;
  }

  road=normRoad(V59.cache[key]);
  if(road){
    writeRoad(step,road);
    return road;
  }

  road=renderedTargetRoad(step);
  if(road){
    V59.cache[key]=road;
    writeRoad(step,road);
    return road;
  }

  reverseTarget(step,key);
  return "";
}

function action(step){
  var a="";
  try{
    if(typeof slxV2GAction==="function"){
      a=clean(slxV2GAction(step)).toLowerCase();
    }
  }catch(e){}
  return a||"continue";
}

function baseWithRoad(step,road){
  var a=action(step),line="";

  if(a==="left"){line="Turn left";}
  else if(a==="right"){line="Turn right";}
  else if(a==="slight_left"){line="Bear left";}
  else if(a==="slight_right"){line="Bear right";}
  else if(a==="keep_left"){line="Keep left";}
  else if(a==="keep_right"){line="Keep right";}
  else if(a==="exit_left"||a==="exit_right"){line="Take the exit";}
  else if(a==="merge_left"){line="Merge left";}
  else if(a==="merge_right"){line="Merge";}
  else if(a==="roundabout"){line="Enter the roundabout";}
  else if(a==="uturn"){line="Make a U-turn";}
  else if(a==="arrive"){line="Approach the destination";}
  else{line="Continue";}

  if(road&&a!=="arrive"){
    if(a.indexOf("keep_")===0||a.indexOf("exit_")===0){
      line+=" for "+road;
    }else if(a==="continue"){
      line+=" on "+road;
    }else{
      line+=" onto "+road;
    }
  }

  return clean(line);
}

function timedLine(base,bucket){
  if(bucket==="FAR"){return base+" in about three miles";}
  if(bucket==="COMMIT"){return base+" in about two miles";}
  if(bucket==="EARLY"){return base+" in about one mile";}
  if(bucket==="HALF"){return base+" in about half a mile";}
  if(bucket==="NEAR"){return base+" in about eight hundred feet";}
  if(bucket==="NOW"){return base+" now";}
  return "";
}

/*
  FINAL override.
  Returning "" while target road lookup is pending is intentional:
  slxV2GMaybeSpeakManeuver() only marks the bucket spoken when a non-empty line
  is successfully queued, so the existing voice tick will retry.
*/
slxV2GVoiceLine=function(step,bucket,remain){
  var road=targetRoad(step),base,a=action(step);

  /*
    Arrival has no target road requirement.
  */
  if(a==="arrive"){
    return timedLine("Approach the destination",bucket);
  }

  /*
    For decision maneuvers, wait for the target road instead of speaking a
    permanently incomplete instruction such as "Turn left in about one mile."
  */
  if(!road){
    /*
      At the exact turn-now bucket, do not create dangerous silence if network
      lookup is still unavailable. Directional truth remains valid.
    */
    if(bucket==="NOW"){
      return timedLine(baseWithRoad(step,""),bucket);
    }
    return "";
  }

  base=baseWithRoad(step,road);
  V59.lastRoad=road;
  V59.lastKey=stepKey(step);
  return timedLine(base,bucket);
};

/*
  Card/build-instruction users also receive the same target road when resolved.
*/
slxV2GBuildInstruction=function(step){
  var road=targetRoad(step);
  return baseWithRoad(step,road);
};

window.SLXV59VoiceStreetAuthority={
  version:"V59_TARGET_ROAD_GATE",
  targetRoad:targetRoad,
  buildInstruction:function(step){return baseWithRoad(step,targetRoad(step));},
  state:V59,
  snapshot:function(){
    var step=null;
    try{
      if(typeof slxNavV2ActiveStep==="function"){step=slxNavV2ActiveStep();}
      if(!step&&typeof maneuverSteps!=="undefined"&&maneuverSteps&&maneuverSteps.length){
        step=maneuverSteps[maneuverIndex];
      }
    }catch(e){}
    return {
      road:step?targetRoad(step):"",
      instruction:step?baseWithRoad(step,targetRoad(step)):"",
      pending:Object.keys(V59.pending).filter(function(k){return !!V59.pending[k];}).length,
      lastRoad:V59.lastRoad,
      lastError:V59.lastError
    };
  }
};

try{console.log("✅ Semi Locator V59 maneuver voice target-road gate loaded");}catch(eBoot){}
})(window);
/* ============================================================================
   SEMI LOCATOR V60 — HARD STREET-NAME AUTHORITY
   FINAL OWNER OF #slxDriveIqTurnRoad

   Purpose:
   - Prove the new asset is actually running by stamping FD-60.
   - Resolve the TARGET maneuver road, not just the current road.
   - Never expose "Road name loading".
   - Keep the last good target-road name stable while async lookup completes.
   - Do not touch route geometry, GPS, pin, camera, reroute, arrival or Stop IQ.
   - ES5-safe.
   ============================================================================ */
(function(window,document){
"use strict";

if(window.__SLX_V60_HARD_STREET_AUTHORITY__){return;}
window.__SLX_V60_HARD_STREET_AUTHORITY__=true;
window.SLX_STREET_NAME_BUILD="V65_CORE_STEP_ROAD_FIX";
window.SLX_MASTER_DRIVER_BUILD="MASTER_DRIVER_V66";

var V60={
  key:"",
  road:"",
  cache:{},
  pending:{},
  lastGood:"",
  lastPaint:"",
  timer:null
};

function clean(v){
  return String(v==null?"":v).replace(/\s+/g," ").trim();
}
function finite(v){
  return isFinite(Number(v));
}
function bad(v){
  var s=clean(v).toLowerCase();
  if(!s){return true;}
  return /^(continue|continue straight|continue on route|stay on route|follow highlighted route|follow current road|turn|turn left|turn right|left|right|straight|merge|exit|take the exit|fork|keep left|keep right|arrive|arrival|destination|route guidance|guidance ready|route active|route ready|navigation ready|street name loading|road name loading|road name unavailable|current road)$/i.test(s);
}
function norm(v){
  var s=clean(v);
  if(!s||bad(s)){return "";}
  s=s.replace(/\binterstate\s+(\d{1,3})\b/ig,"I-$1")
     .replace(/\bi\s+(\d{1,3})\b/ig,"I-$1")
     .replace(/\bi-(\d{1,3})\b/ig,"I-$1")
     .replace(/\bu\.s\.\s*(\d{1,3})\b/ig,"US-$1")
     .replace(/\bus\s+(\d{1,3})\b/ig,"US-$1")
     .replace(/\bhwy\s+(\d{1,3})\b/ig,"Highway $1");
  return clean(s);
}
function raw(step){
  return (step&&(step.rawStep||step.raw))||step||{};
}
function man(step){
  var r=raw(step);
  return (step&&step.maneuver)||r.maneuver||{};
}
function activeStep(){
  var s=null;
  /* Authoritative live step: verified in iPhone Web Inspector. */
  try{
    if(window.__SLX_CORE_BRIDGE__ && typeof window.__SLX_CORE_BRIDGE__.getActiveManeuverStep==="function"){
      s=window.__SLX_CORE_BRIDGE__.getActiveManeuverStep();
      if(s){return s;}
    }
  }catch(eCore){}
  try{
    if(typeof slxNavV2ActiveStep==="function"){
      s=slxNavV2ActiveStep();
      if(s){return s;}
    }
  }catch(e0){}
  try{
    if(typeof maneuverSteps!=="undefined" &&
       maneuverSteps &&
       maneuverSteps.length &&
       typeof maneuverIndex!=="undefined" &&
       maneuverIndex>=0 &&
       maneuverIndex<maneuverSteps.length){
      return maneuverSteps[maneuverIndex];
    }
  }catch(e1){}
  try{
    if(typeof routeSteps!=="undefined" &&
       routeSteps &&
       routeSteps.length){
      return routeSteps[0];
    }
  }catch(e2){}
  return null;
}
function stepCoord(step){
  var r=raw(step),m=man(step),p=null;
  try{
    p=(step&&(step.coord||step.location||step.coordinates||step.point))||
      m.location||m.coordinates||
      r.location||r.coordinates||
      (r.maneuver&&(r.maneuver.location||r.maneuver.coordinates));
  }catch(e){}
  if(p&&p.length>=2&&finite(p[0])&&finite(p[1])){
    return [Number(p[0]),Number(p[1])];
  }
  if(step&&finite(step.lng)&&finite(step.lat)){
    return [Number(step.lng),Number(step.lat)];
  }
  return null;
}
function instruction(step){
  var s="";
  /* Use the actual instruction text before legacy helpers can downgrade it. */
  s=clean(step&&(step.instruction||step.instruction_text));
  if(s){return s;}
  try{
    var r=raw(step);
    s=clean(r&&(r.instruction||r.instruction_text));
    if(s){return s;}
  }catch(eDirect){}
  try{
    if(window.SLXV55StreetAuthority &&
       typeof window.SLXV55StreetAuthority.instruction==="function"){
      s=clean(window.SLXV55StreetAuthority.instruction(step));
      if(s){return s;}
    }
  }catch(e0){}
  try{
    if(typeof slxNavV2InstructionText==="function"){
      s=clean(slxNavV2InstructionText(step));
      if(s){return s;}
    }
  }catch(e1){}
  return clean(step&&(
    step.instruction||
    step.instruction_text||
    step.text||
    step.description||
    step.announceLabel||
    step.voiceInstruction
  ));
}
function stepKey(step){
  var p=stepCoord(step);
  return [
    p?Number(p[0]).toFixed(5):"",
    p?Number(p[1]).toFixed(5):"",
    instruction(step)
  ].join("|");
}
function fromInstruction(text){
  var s=clean(text),m;
  if(!s){return "";}
  m=s.match(/\b(I[-\s]?\d{1,3}[A-Z]?|US[-\s]?\d{1,3}|U\.S\.\s*\d{1,3}|Highway\s+\d{1,3}|Hwy\s+\d{1,3}|SR[-\s]?\d{1,3})\b/i);
  if(m&&m[1]){return norm(m[1]);}
  m=s.match(/\b(?:onto|on|toward|towards|for)\s+([A-Z][A-Za-z0-9 .'\-]+(?:Road|Rd|Street|St|Avenue|Ave|Boulevard|Blvd|Drive|Dr|Lane|Ln|Parkway|Pkwy|Highway|Hwy|Freeway|Interstate|Expressway))/);
  if(m&&m[1]){return norm(m[1]);}
  return "";
}
function providerRoad(step){
  var r=raw(step),m=man(step);
  var d=(step&&step.instruction_details)||r.instruction_details||{};
  var vals=[],i,s;

  try{
    if(window.SLXV55StreetAuthority &&
       typeof window.SLXV55StreetAuthority.roadName==="function"){
      s=norm(window.SLXV55StreetAuthority.roadName(step));
      if(s){return s;}
    }
  }catch(e0){}

  vals=[
    step&&step.roadName,step&&step.road_name,step&&step.streetName,step&&step.street_name,
    step&&step.street,step&&step.road,step&&step.name,step&&step.way_name,step&&step.ref,
    step&&step.toRoad,step&&step.to_road,
    r.roadName,r.road_name,r.streetName,r.street_name,r.street,r.road,r.name,r.way_name,r.ref,
    r.toRoad,r.to_road,
    m.roadName,m.road_name,m.streetName,m.street_name,m.street,m.road,m.name,m.way_name,m.ref,
    d&&d.street_name,d&&d.street,d&&d.road,d&&d.name,d&&d.way_name,d&&d.ref,
    d&&d.to&&d.to.name,d&&d.to&&d.to.street,d&&d.to&&d.to.road
  ];
  for(i=0;i<vals.length;i+=1){
    s=norm(vals[i]);
    if(s){return s;}
  }
  return fromInstruction(instruction(step));
}
function writeBack(step,road){
  var r=raw(step),m=man(step);
  road=norm(road);
  if(!step||!road){return;}
  try{
    step.roadName=road; step.road_name=road;
    step.streetName=road; step.street_name=road;
    step.street=road; step.road=road;
    if(r){
      r.roadName=road; r.road_name=road;
      r.streetName=road; r.street_name=road;
      r.street=road; r.road=road;
    }
    if(m){
      m.roadName=road; m.road_name=road;
      m.streetName=road; m.street_name=road;
      m.street=road; m.road=road;
      if(!m.name){m.name=road;}
    }
  }catch(e){}
}
function mapObject(){
  var m=null;
  try{if(typeof map!=="undefined"&&map){m=map;}}catch(e0){}
  if(!m){
    try{m=window.slxMap||window.SLX_MAP||window.map||null;}catch(e1){}
  }
  return m;
}
function renderedRoad(lng,lat){
  var m=mapObject(),pt,features=[],i,p,layer,src,r;
  if(!m||typeof m.project!=="function"||typeof m.queryRenderedFeatures!=="function"){
    return "";
  }
  try{
    pt=m.project([Number(lng),Number(lat)]);
    features=m.queryRenderedFeatures([[pt.x-24,pt.y-24],[pt.x+24,pt.y+24]])||[];
  }catch(e0){return "";}

  for(i=0;i<features.length;i+=1){
    p=(features[i]&&features[i].properties)||{};
    layer=clean(features[i]&&features[i].layer&&features[i].layer.id).toLowerCase();
    src=clean(features[i]&&features[i].sourceLayer).toLowerCase();
    if(layer.indexOf("road")<0 &&
       layer.indexOf("street")<0 &&
       layer.indexOf("transport")<0 &&
       src.indexOf("road")<0 &&
       src.indexOf("transport")<0){
      continue;
    }
    r=norm(p.name_en||p.name||p.name_local||p.ref||p.road||p.street);
    if(r){return r;}
  }
  return "";
}
function currentRoad(){
  var r="",f=null;
  try{
    if(typeof speedState!=="undefined"&&speedState&&speedState.roadName){
      r=norm(speedState.roadName);
      if(r){return r;}
    }
  }catch(e0){}
  try{
    if(window.__SLX_CORE_BRIDGE__ &&
       typeof window.__SLX_CORE_BRIDGE__.getCurrentFix==="function"){
      f=window.__SLX_CORE_BRIDGE__.getCurrentFix();
    }
  }catch(e1){}
  try{
    if(!f){f=currentFix||routeTargetFix||rawFix||null;}
  }catch(e2){}
  if(f&&finite(f.lng)&&finite(f.lat)){
    r=renderedRoad(f.lng,f.lat);
    if(r){return r;}
  }
  return "";
}
function apiKey(){
  var app=document.getElementById("slxApp");
  return clean(
    window.SLX_GEOAPIFY_KEY||
    (app&&app.getAttribute("data-geoapify-key"))||
    ""
  );
}
function geoRoad(data){
  var f,p,r,i;
  try{
    if(data&&data.features&&data.features.length){
      for(i=0;i<data.features.length;i+=1){
        f=data.features[i];
        p=(f&&f.properties)||{};
        r=norm(
          p.street||
          p.road||
          p.name||
          p.address_line1||
          p.formatted
        );
        if(r){return r;}
      }
    }
    if(data&&data.results&&data.results.length){
      p=data.results[0]||{};
      r=norm(p.street||p.road||p.name||p.address_line1||p.formatted);
      if(r){return r;}
    }
  }catch(e){}
  return "";
}
function reverseTarget(step){
  var p=stepCoord(step),key=stepKey(step),api=apiKey(),url;
  if(!p||!api||!window.fetch||V60.pending[key]){return;}

  V60.pending[key]=true;
  url="https://api.geoapify.com/v1/geocode/reverse?lat="+
    encodeURIComponent(String(p[1]))+
    "&lon="+encodeURIComponent(String(p[0]))+
    "&format=geojson&apiKey="+encodeURIComponent(api);

  fetch(url)
    .then(function(res){
      if(!res||!res.ok){throw new Error("reverse "+(res&&res.status));}
      return res.json();
    })
    .then(function(data){
      var road=geoRoad(data);
      V60.pending[key]=false;
      if(road){
        V60.cache[key]=road;
        if(V60.key===key){
          V60.road=road;
          V60.lastGood=road;
          writeBack(step,road);
          paint();
        }
      }
    })
    .catch(function(){
      V60.pending[key]=false;
    });
}
function resolve(step){
  var key,p,road="";
  if(!step){return currentRoad()||V60.lastGood||"Follow current road";}

  key=stepKey(step);

  /* Explicit "onto Horn Lake Road" outranks road-adjacent metadata. */
  road=fromInstruction(instruction(step));
  if(!road){road=providerRoad(step);}
  if(road){
    V60.cache[key]=road;
    V60.lastGood=road;
    writeBack(step,road);
    return road;
  }

  road=norm(V60.cache[key]);
  if(road){
    V60.lastGood=road;
    writeBack(step,road);
    return road;
  }

  p=stepCoord(step);
  if(p){
    road=renderedRoad(p[0],p[1]);
    if(road){
      V60.cache[key]=road;
      V60.lastGood=road;
      writeBack(step,road);
      return road;
    }
  }

  reverseTarget(step);

  /* An active maneuver must never display the road we are leaving as its target. */
  return "Road name unavailable";
}
function stamp(){
  var nodes,i,t;
  try{
    nodes=document.querySelectorAll("body *");
    for(i=0;i<nodes.length;i+=1){
      t=clean(nodes[i].textContent).toUpperCase();
      if(t==="FD-16"||t==="FD-55"||t==="FD-56"||t==="FD-57"||t==="FD-58"||t==="FD-59"){
        nodes[i].textContent="FD-60";
        nodes[i].setAttribute("data-slx-runtime","V60");
        break;
      }
    }
  }catch(e){}
}
function paint(){
  var el=document.getElementById("slxDriveIqTurnRoad");
  var step=activeStep(),key="",road="";
  stamp();
  if(!el){return;}

  if(step){
    key=stepKey(step);
    if(V60.key!==key){
      V60.key=key;
      V60.road="";
    }
    road=resolve(step);
  }else{
    road=currentRoad()||V60.lastGood||"Follow current road";
  }

  road=norm(road)||(step?"Road name unavailable":"Follow current road");
  if(clean(el.textContent)!==road){
    el.textContent=road;
  }
  V60.lastPaint=road;
  el.setAttribute("data-slx-street-owner","V65_CORE_STEP_ROAD_FIX");
}
function boot(){
  paint();
  window.setTimeout(paint,80);
  window.setTimeout(paint,250);
  window.setTimeout(paint,700);
  window.setTimeout(paint,1600);
  window.setTimeout(paint,3200);

  /*
    Final ownership cadence. This is intentionally lightweight and only updates
    one text node; it does not touch navigation lifecycle or recreate anything.
  */
  if(!V60.timer){
    V60.timer=window.setInterval(paint,400);
  }
}

if(document.readyState==="loading"){
  document.addEventListener("DOMContentLoaded",boot,{once:true});
}else{
  boot();
}

document.addEventListener("visibilitychange",function(){
  if(!document.hidden){paint();}
},false);

window.SLXV60StreetAuthority={
  version:"V65_CORE_STEP_ROAD_FIX",
  paint:paint,
  resolve:resolve,
  active:activeStep,
  state:V60,
  snapshot:function(){
    var s=activeStep();
    return {
      build:window.SLX_STREET_NAME_BUILD||"",
      instruction:s?instruction(s):"",
      road:s?resolve(s):currentRoad(),
      key:V60.key,
      lastGood:V60.lastGood,
      lastPaint:V60.lastPaint
    };
  }
};

try{console.log("[SEMI V65] core-step target road display active");}catch(eBoot){}

})(window,document);

/* ==== CARPLAY WEB ROUTE PUBLISHER V2.2 (read-only, diagnostic) ==== */
(function () {
  'use strict';
  if (window.__SLX_CARPLAY_WEB_PUBLISHER_V22__) return;
  window.__SLX_CARPLAY_WEB_PUBLISHER_V22__ = true;
  var sessionId = 'web_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
  var activeId = '', previousSignature = '', missingTicks = 0, lastProgress = '', lastProgressAt = 0;
  var lastRouteAttemptAt = 0, sentRouteAt = 0, tickNumber = 0;
  var state = { version: 'V2.2', status: 'initializing', nativeHandler: false, tripActive: false,
    routePoints: 0, source: '', routeSendAttempts: 0, routePosts: 0, progressPosts: 0,
    lastRoutePostAt: null, lastError: '', tripId: sessionId };
  window.SLXCarPlayHandoffStatus = function () { return JSON.parse(JSON.stringify(state)); };
  function json(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } }
  function stored(key) { try { return localStorage.getItem(key); } catch (_) { return null; } }
  function valid(n) { return typeof n === 'number' && isFinite(n); }
  function send(message) {
    try {
      var handler = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.slx;
      state.nativeHandler = !!handler;
      if (!handler || typeof handler.postMessage !== 'function') { state.status = 'no_slx_handler'; return false; }
      handler.postMessage(message);
      // postMessage only means queued; Swift acceptance is confirmed in Xcode logs.
      return true;
    } catch (e) { state.lastError = String(e); state.status = 'post_exception'; return false; }
  }
  function roadCoords(geo) {
    var geometry = geo && geo.features && geo.features[0] && geo.features[0].geometry;
    if (!geometry || geometry.type !== 'LineString' || !Array.isArray(geometry.coordinates)) return null;
    var raw = geometry.coordinates;
    if (raw.length < 3 || raw.length > 100000) return null;
    var result = [], i, p, lng, lat;
    for (i = 0; i < raw.length; i++) {
      p = raw[i];
      if (!Array.isArray(p) || p.length < 2) return null;
      lng = Number(p[0]); lat = Number(p[1]);
      if (!valid(lng) || !valid(lat) || lng < -180 || lng > 180 || lat < -90 || lat > 90) return null;
      result.push([lat,lng]); // Mapbox longitude/latitude => CoreLocation latitude/longitude
    }
    return result;
  }
  function signatureFor(coords) {
    // Interior samples detect changes even with identical length/endpoints.
    var indices = [0, Math.floor(coords.length*.2), Math.floor(coords.length*.4),
      Math.floor(coords.length*.6), Math.floor(coords.length*.8), coords.length-1];
    var s = String(coords.length), i;
    for (i=0;i<indices.length;i++) s += ':'+coords[indices[i]].join(',');
    return s;
  }
  function tick() {
    tickNumber++;
    try {
      var b = window.__SLX_CORE_BRIDGE__;
      var live = b && typeof b.isTripOn === 'function' ? !!b.isTripOn() : stored('slx_trip_on_v2') === '1';
      var geo = b && typeof b.getRouteGeo === 'function' ? b.getRouteGeo() : null;
      var coords = live ? roadCoords(geo) : null;
      state.tripActive = live;
      state.source = 'core';
      if (live && !coords) {
        // Read-only fallback to the SAME key populated by Start Trip.
        coords = roadCoords(json('slx_route_geo_v2'));
        state.source = 'stored_route';
      }
      state.routePoints = coords ? coords.length : 0;
      if (!live) {
        state.status = 'trip_inactive';
        if (activeId && ++missingTicks >= 2) {
          if (send({action:'slx_carplay_web_route_end_v1',trip_id:activeId})) {
            activeId=''; previousSignature=''; lastProgress='';
          }
        }
        return;
      }
      if (!coords) {
        // Do not clear an active route just because one route refresh is incomplete.
        state.status = 'awaiting_valid_route'; return;
      }
      missingTicks = 0;
      var sig = signatureFor(coords);
      var step = b && typeof b.getActiveManeuverStep === 'function' ? b.getActiveManeuverStep() : null;
      var instruction = step ? String(step.instruction || step.announceLabel || '').slice(0,300) : '';
      var dest = b && typeof b.getRouteDest === 'function' ? b.getRouteDest() : null;
      if (!dest) dest = json('slx_main_dest_v2');
      var label = String(dest && (dest.label || dest.name || dest.title) || 'Active route').slice(0,120);
      var now = Date.now();
      if (activeId !== sessionId || previousSignature !== sig || (now - sentRouteAt > 30000)) {
        // Periodic replay recovers a late-bound native WebView handler / missed first message.
        state.routeSendAttempts++;
        lastRouteAttemptAt = now;
        if (send({action:'slx_carplay_web_route_v1',trip_id:sessionId,
          destination_name:label,coordinates:coords,next_instruction:instruction})) {
          activeId=sessionId; previousSignature=sig; sentRouteAt=now;
          state.routePosts++; state.lastRoutePostAt=new Date(now).toISOString();
          state.status='route_posted_unconfirmed';
          console.log('[SLX CARPLAY PUBLISHER] Route posted points='+coords.length+' source='+state.source);
        }
      } else if (instruction && (instruction !== lastProgress || now - lastProgressAt >= 10000)) {
        if (send({action:'slx_carplay_web_progress_v1',trip_id:sessionId,next_instruction:instruction})) {
          lastProgress=instruction; lastProgressAt=now; state.progressPosts++;
        }
      }
    } catch(e) { state.lastError=String(e); state.status='exception';
      try { console.warn('[SLX CARPLAY PUBLISHER]',e); } catch(_) {} }
  }
  window.setInterval(tick,1500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',tick);
  else tick();
})();
